var __create = Object.create;
var __getProtoOf = Object.getPrototypeOf;
var __defProp = Object.defineProperty;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __toESM = (mod, isNodeMode, target) => {
  target = mod != null ? __create(__getProtoOf(mod)) : {};
  const to = isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target;
  for (let key of __getOwnPropNames(mod))
    if (!__hasOwnProp.call(to, key))
      __defProp(to, key, {
        get: () => mod[key],
        enumerable: true
      });
  return to;
};
var __commonJS = (cb, mod) => () => (mod || cb((mod = { exports: {} }).exports, mod), mod.exports);
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, {
      get: all[name],
      enumerable: true,
      configurable: true,
      set: (newValue) => all[name] = () => newValue
    });
};

// ../../../node_modules/fast-deep-equal/index.js
var require_fast_deep_equal = __commonJS((exports, module) => {
  module.exports = function equal(a, b) {
    if (a === b)
      return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
      if (a.constructor !== b.constructor)
        return false;
      var length, i, keys;
      if (Array.isArray(a)) {
        length = a.length;
        if (length != b.length)
          return false;
        for (i = length;i-- !== 0; )
          if (!equal(a[i], b[i]))
            return false;
        return true;
      }
      if (a.constructor === RegExp)
        return a.source === b.source && a.flags === b.flags;
      if (a.valueOf !== Object.prototype.valueOf)
        return a.valueOf() === b.valueOf();
      if (a.toString !== Object.prototype.toString)
        return a.toString() === b.toString();
      keys = Object.keys(a);
      length = keys.length;
      if (length !== Object.keys(b).length)
        return false;
      for (i = length;i-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(b, keys[i]))
          return false;
      for (i = length;i-- !== 0; ) {
        var key = keys[i];
        if (!equal(a[key], b[key]))
          return false;
      }
      return true;
    }
    return a !== a && b !== b;
  };
});

// ../../../node_modules/prop-types/lib/ReactPropTypesSecret.js
var require_ReactPropTypesSecret = __commonJS((exports, module) => {
  var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  module.exports = ReactPropTypesSecret;
});

// ../../../node_modules/prop-types/factoryWithThrowingShims.js
var require_factoryWithThrowingShims = __commonJS((exports, module) => {
  var ReactPropTypesSecret = require_ReactPropTypesSecret();
  function emptyFunction() {
  }
  function emptyFunctionWithReset() {
  }
  emptyFunctionWithReset.resetWarningCache = emptyFunction;
  module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        return;
      }
      var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. " + "Use PropTypes.checkPropTypes() to call them. " + "Read more at http://fb.me/use-check-prop-types");
      err.name = "Invariant Violation";
      throw err;
    }
    shim.isRequired = shim;
    function getShim() {
      return shim;
    }
    var ReactPropTypes = {
      array: shim,
      bigint: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
});

// ../../../node_modules/prop-types/index.js
var require_prop_types = __commonJS((exports, module) => {
  if (false) {
  } else {
    module.exports = require_factoryWithThrowingShims()();
  }
  var ReactIs;
  var throwOnDirectAccess;
});

// src/framework/theme/mantine-passthroughs.ts
import {
  useMantineTheme
} from "@mantine/core";

// src/framework/theme/ThemeProvider.tsx
import {
  MantineProvider
} from "@mantine/core";
import"@mantine/core/styles.css";
import { ModalsProvider } from "@mantine/modals";
import { Notifications } from "@mantine/notifications";
import { jsx, jsxs } from "react/jsx-runtime";
var makeVariablesResolver = (theme) => {
  if (!theme) {
    return () => ({
      variables: {},
      light: {},
      dark: {}
    });
  }
  const colors = theme.colors ?? {};
  const lightBase = {
    ["--mantine-color-high-contrast-background"]: "var(--mantine-color-gray-8)",
    ["--mantine-color-high-contrast-foreground"]: "var(--mantine-color-white)",
    ["--mantine-color-high-contrast-inverted-background"]: "var(--mantine-color-white)",
    ["--mantine-color-high-contrast-inverted-foreground"]: "var(--mantine-color-gray-8)"
  };
  const light = Object.entries(colors).reduce((acc, [name, shades]) => {
    if (shades?.length !== 10) {
      return acc;
    }
    return {
      ...acc,
      [`--mantine-color-${name}-background-hover`]: shades[0],
      [`--mantine-color-${name}-background`]: shades[7],
      [`--mantine-color-${name}-foreground`]: shades[2],
      [`--mantine-color-${name}-text`]: shades[6],
      [`--mantine-color-${name}-light`]: `var(--mantine-color-${name}-0)`
    };
  }, lightBase);
  const darkBase = {
    ["--mantine-color-high-contrast-background"]: "var(--mantine-color-white)",
    ["--mantine-color-high-contrast-foreground"]: "var(--mantine-color-gray-8)",
    ["--mantine-color-high-contrast-inverted-background"]: "var(--mantine-color-gray-8)",
    ["--mantine-color-high-contrast-inverted-foreground"]: "var(--mantine-color-white)"
  };
  const dark = Object.entries(colors).reduce((acc, [name, shades]) => {
    if (shades?.length !== 10) {
      return acc;
    }
    return {
      ...acc,
      [`--mantine-color-${name}-background-hover`]: shades[9],
      [`--mantine-color-${name}-background`]: shades[2],
      [`--mantine-color-${name}-foreground`]: shades[7],
      [`--mantine-color-${name}-text`]: shades[2]
    };
  }, darkBase);
  return () => ({
    variables: {},
    light,
    dark
  });
};
var ThemeProvider = ({
  theme = {},
  children,
  ...restProps
}) => {
  const cssVariablesResolver = makeVariablesResolver(theme);
  return /* @__PURE__ */ jsxs(MantineProvider, {
    ...restProps,
    theme,
    cssVariablesResolver,
    children: [
      /* @__PURE__ */ jsx(Notifications, {}),
      /* @__PURE__ */ jsx(ModalsProvider, {
        children
      })
    ]
  });
};

// src/framework/theme/util/create-theme.ts
import {
  defaultVariantColorsResolver,
  createTheme as mantineCreateTheme,
  rgba
} from "@mantine/core";

// style-helper:__style_helper__
function injectStyle(text) {
  if (typeof document !== "undefined") {
    const styleTag = document.getElementById("bun_lightningcss");
    if (styleTag) {
      const node2 = document.createTextNode(text);
      styleTag.appendChild(node2);
      return;
    }
    var style = document.createElement("style");
    style.id = "bun_lightningcss";
    var node = document.createTextNode(text);
    style.appendChild(node);
    document.head.appendChild(style);
  }
}

// src/components/notification/notification.module.css
injectStyle(".uYXYeW_root:before{content:none}.uYXYeW_root{background-color:var(--bkg-color);padding:var(--mantine-spacing-xxxs)var(--mantine-spacing-xxxs)var(--mantine-spacing-xxxs)var(--mantine-spacing-xs)}.uYXYeW_title,.uYXYeW_description,.uYXYeW_closeButton{color:var(--mantine-color-white)}.uYXYeW_description{padding-block:var(--mantine-spacing-xxs)}.uYXYeW_closeButton{--cb-size:2.5rem;align-self:start;--cb-icon-size:1.5rem!important}:where([data-mantine-color-scheme=light]) .uYXYeW_closeButton:hover{background-color:var(--hover-bkg-color)}");
var notification_module_default = { description: "uYXYeW_description", title: "uYXYeW_title", root: "uYXYeW_root", closeButton: "uYXYeW_closeButton" };

// src/framework/theme/util/storybook.ts
var BASIC_COLOR_VARIANTS = [
  "black",
  "white",
  "currentColor"
];
var COLOR_VARIANTS = [
  "gray",
  "saving",
  "primary",
  "secondary",
  "error",
  "success",
  "warning",
  "info",
  "notice"
];
var COLOR_VARIANTS_SUMMARY = COLOR_VARIANTS.join(" | ");

// src/framework/theme/util/get-style-for-color.ts
var getStyleForColor = (color) => {
  if (color === "inherit") {
    return {
      bg: "inherit",
      c: "currentColor"
    };
  }
  if (!COLOR_VARIANTS.includes(color)) {
    throw new Error('Only colors in the "semantic" palette may be passed to this function');
  }
  return {
    bg: `var(--mantine-color-${color}-background)`,
    c: `var(--mantine-color-${color}-foreground)`
  };
};

// src/framework/theme/util/create-theme.ts
var createTheme = (theme) => {
  return mantineCreateTheme({
    ...theme,
    components: {
      Notification: {
        defaultProps: {
          radius: "xxs"
        },
        classNames: notification_module_default
      }
    },
    other: {
      ...theme.other ?? {},
      fontWeights: {
        bold: 600,
        medium: 500,
        regular: 400
      },
      getStyleForColor,
      getActionableIconColor: (actionable) => {
        const color = actionable ? "primary" : "secondary";
        return getStyleForColor(color).bg;
      },
      getIconColor: (color) => {
        if (color === "black" || color === "white" || color === "currentColor") {
          return color;
        }
        return getStyleForColor(color).bg;
      },
      getTextColor: (color) => {
        return `var(--mantine-color-${color}-text)`;
      }
    },
    variantColorResolver: (input) => {
      const defaultResolvedColors = defaultVariantColorsResolver(input);
      if (input.color === "high-contrast" || input.color === "high-contrast-inverted") {
        switch (input.variant) {
          case "outline":
            return {
              background: "transparent",
              hover: rgba(`var(--mantine-color-${input.color}-background)`, 0.15),
              color: `var(--mantine-color-${input.color}-background)`,
              border: `calc(0.0625rem * var(--mantine-scale)) solid var(--mantine-color-${input.color}-background)`
            };
          case "subtle":
            return {
              background: "transparent",
              hover: rgba(`var(--mantine-color-${input.color}-background)`, 0.15),
              color: `var(--mantine-color-${input.color}-background)`,
              border: "none"
            };
          case "filled":
          default:
            return {
              background: `var(--mantine-color-${input.color}-background)`,
              hover: rgba(`var(--mantine-color-${input.color}-background)`, 0.15),
              color: `var(--mantine-color-${input.color}-foreground)`,
              hoverColor: `var(--mantine-color-${input.color}-background)`,
              border: "none"
            };
        }
      }
      return defaultResolvedColors;
    }
  });
};

// src/framework/theme/util/misc.ts
import { px, rem } from "@mantine/core";
// src/framework/utils/constants.ts
var exports_constants = {};
__export(exports_constants, {
  unicode: () => unicode
});
var unicode = {
  BULLET: "•",
  COPYRIGHT: "©",
  DAGGER: "†",
  DEGREE_C: "℃",
  DEGREE_F: "℉",
  DOUBLE_DAGGER: "‡",
  REGISTERED: "®",
  SECTION: "§",
  TRADEMARK: "™"
};
// src/framework/utils/get-initials/get-initials.ts
var getInitials = (name) => {
  if (name.length === 0) {
    return;
  }
  if (/^[a-z]\.?[a-z]\.?$/i.test(name)) {
    return name.replaceAll(".", "").toUpperCase();
  }
  const parts = name.split(" ");
  if (parts.length > 1) {
    const first = parts.shift();
    const last = parts.pop();
    return `${first?.[0]}${last?.[0]}`.toUpperCase();
  }
  return parts[0][0].toUpperCase();
};
// src/framework/utils/format-date/format-date.ts
var formatDate = (date, options, locale = "en-US") => {
  try {
    return new Intl.DateTimeFormat(locale, options).format(date);
  } catch (error) {
    console.error(`Could not parse date: ${date} for locale: ${locale}`);
  }
};
// src/framework/utils/format-time/format-time.ts
import { useTranslation } from "react-i18next";
var formatTime = (time) => {
  const { t } = useTranslation("pds");
  const [hours, minutes, _seconds] = time.split(":").map(Number);
  const timePeriod = hours >= 12 ? t("timePeriod.pm") : t("timePeriod.am");
  const convertedHours = hours % 12 || 12;
  const paddedMinutes = minutes.toString().padStart(2, "0");
  return `${convertedHours}:${paddedMinutes} ${timePeriod}`;
};
// ../../../node_modules/@mantine/form/esm/use-form.mjs
import { useState as useState4, useCallback as useCallback6 } from "react";

// ../../../node_modules/@mantine/form/esm/actions/actions.mjs
import { useLayoutEffect, useEffect } from "react";
"use client";
function validateFormName(name) {
  if (!/^[0-9a-zA-Z-]+$/.test(name)) {
    throw new Error(`[@mantine/use-form] Form name "${name}" is invalid, it should contain only letters, numbers and dashes`);
  }
}
var useIsomorphicEffect = typeof window !== "undefined" ? useLayoutEffect : useEffect;
function useFormEvent(eventKey, handler) {
  useIsomorphicEffect(() => {
    if (eventKey) {
      window.addEventListener(eventKey, handler);
      return () => window.removeEventListener(eventKey, handler);
    }
    return;
  }, [eventKey]);
}
function useFormActions(name, form) {
  if (name) {
    validateFormName(name);
  }
  useFormEvent(`mantine-form:${name}:set-field-value`, (event) => form.setFieldValue(event.detail.path, event.detail.value));
  useFormEvent(`mantine-form:${name}:set-values`, (event) => form.setValues(event.detail));
  useFormEvent(`mantine-form:${name}:set-initial-values`, (event) => form.setInitialValues(event.detail));
  useFormEvent(`mantine-form:${name}:set-errors`, (event) => form.setErrors(event.detail));
  useFormEvent(`mantine-form:${name}:set-field-error`, (event) => form.setFieldError(event.detail.path, event.detail.error));
  useFormEvent(`mantine-form:${name}:clear-field-error`, (event) => form.clearFieldError(event.detail));
  useFormEvent(`mantine-form:${name}:clear-errors`, form.clearErrors);
  useFormEvent(`mantine-form:${name}:reset`, form.reset);
  useFormEvent(`mantine-form:${name}:validate`, form.validate);
  useFormEvent(`mantine-form:${name}:validate-field`, (event) => form.validateField(event.detail));
  useFormEvent(`mantine-form:${name}:reorder-list-item`, (event) => form.reorderListItem(event.detail.path, event.detail.payload));
  useFormEvent(`mantine-form:${name}:remove-list-item`, (event) => form.removeListItem(event.detail.path, event.detail.index));
  useFormEvent(`mantine-form:${name}:insert-list-item`, (event) => form.insertListItem(event.detail.path, event.detail.item, event.detail.index));
  useFormEvent(`mantine-form:${name}:set-dirty`, (event) => form.setDirty(event.detail));
  useFormEvent(`mantine-form:${name}:set-touched`, (event) => form.setTouched(event.detail));
  useFormEvent(`mantine-form:${name}:reset-dirty`, (event) => form.resetDirty(event.detail));
  useFormEvent(`mantine-form:${name}:reset-touched`, form.resetTouched);
}

// ../../../node_modules/@mantine/form/esm/get-input-on-change/get-input-on-change.mjs
"use client";
function getInputOnChange(setValue) {
  return (val) => {
    if (!val) {
      setValue(val);
    } else if (typeof val === "function") {
      setValue(val);
    } else if (typeof val === "object" && "nativeEvent" in val) {
      const { currentTarget } = val;
      if (currentTarget instanceof HTMLInputElement) {
        if (currentTarget.type === "checkbox") {
          setValue(currentTarget.checked);
        } else {
          setValue(currentTarget.value);
        }
      } else if (currentTarget instanceof HTMLTextAreaElement || currentTarget instanceof HTMLSelectElement) {
        setValue(currentTarget.value);
      }
    } else {
      setValue(val);
    }
  };
}

// ../../../node_modules/@mantine/form/esm/hooks/use-form-errors/use-form-errors.mjs
import { useState, useRef, useCallback } from "react";

// ../../../node_modules/@mantine/form/esm/hooks/use-form-errors/filter-errors/filter-errors.mjs
"use client";
function filterErrors(errors) {
  if (errors === null || typeof errors !== "object") {
    return {};
  }
  return Object.keys(errors).reduce((acc, key) => {
    const errorValue = errors[key];
    if (errorValue !== undefined && errorValue !== null && errorValue !== false) {
      acc[key] = errorValue;
    }
    return acc;
  }, {});
}

// ../../../node_modules/@mantine/form/esm/hooks/use-form-errors/use-form-errors.mjs
"use client";
function useFormErrors(initialErrors) {
  const [errorsState, setErrorsState] = useState(filterErrors(initialErrors));
  const errorsRef = useRef(errorsState);
  const setErrors = useCallback((errors) => {
    setErrorsState((current) => {
      const newErrors = filterErrors(typeof errors === "function" ? errors(current) : errors);
      errorsRef.current = newErrors;
      return newErrors;
    });
  }, []);
  const clearErrors = useCallback(() => setErrors({}), []);
  const clearFieldError = useCallback((path) => {
    if (errorsRef.current[path] === undefined) {
      return;
    }
    setErrors((current) => {
      const errors = { ...current };
      delete errors[path];
      return errors;
    });
  }, [errorsState]);
  const setFieldError = useCallback((path, error) => {
    if (error == null || error === false) {
      clearFieldError(path);
    } else if (errorsRef.current[path] !== error) {
      setErrors((current) => ({ ...current, [path]: error }));
    }
  }, [errorsState]);
  return {
    errorsState,
    setErrors,
    clearErrors,
    setFieldError,
    clearFieldError
  };
}

// ../../../node_modules/@mantine/form/esm/hooks/use-form-list/use-form-list.mjs
import { useCallback as useCallback2 } from "react";

// ../../../node_modules/@mantine/form/esm/lists/clear-list-state.mjs
"use client";
function clearListState(field, state) {
  if (state === null || typeof state !== "object") {
    return {};
  }
  const clone = { ...state };
  Object.keys(state).forEach((errorKey) => {
    if (errorKey.includes(`${String(field)}.`)) {
      delete clone[errorKey];
    }
  });
  return clone;
}

// ../../../node_modules/@mantine/form/esm/lists/change-error-indices.mjs
"use client";
function getIndexFromKeyAfterPath(key, path) {
  const split = key.substring(path.length + 1).split(".")[0];
  return parseInt(split, 10);
}
function changeErrorIndices(path, index, errors, change) {
  if (index === undefined) {
    return errors;
  }
  const pathString = `${String(path)}`;
  let clearedErrors = errors;
  if (change === -1) {
    clearedErrors = clearListState(`${pathString}.${index}`, clearedErrors);
  }
  const cloned = { ...clearedErrors };
  const changedKeys = /* @__PURE__ */ new Set;
  Object.entries(clearedErrors).filter(([key]) => {
    if (!key.startsWith(`${pathString}.`)) {
      return false;
    }
    const currIndex = getIndexFromKeyAfterPath(key, pathString);
    if (Number.isNaN(currIndex)) {
      return false;
    }
    return currIndex >= index;
  }).forEach(([key, value]) => {
    const currIndex = getIndexFromKeyAfterPath(key, pathString);
    const newKey = key.replace(`${pathString}.${currIndex}`, `${pathString}.${currIndex + change}`);
    cloned[newKey] = value;
    changedKeys.add(newKey);
    if (!changedKeys.has(key)) {
      delete cloned[key];
    }
  });
  return cloned;
}

// ../../../node_modules/@mantine/form/esm/lists/reorder-errors.mjs
"use client";
function reorderErrors(path, { from, to }, errors) {
  const oldKeyStart = `${path}.${from}`;
  const newKeyStart = `${path}.${to}`;
  const clone = { ...errors };
  Object.keys(errors).every((key) => {
    let oldKey;
    let newKey;
    if (key.startsWith(oldKeyStart)) {
      oldKey = key;
      newKey = key.replace(oldKeyStart, newKeyStart);
    }
    if (key.startsWith(newKeyStart)) {
      oldKey = key.replace(newKeyStart, oldKeyStart);
      newKey = key;
    }
    if (oldKey && newKey) {
      const value1 = clone[oldKey];
      const value2 = clone[newKey];
      value2 === undefined ? delete clone[oldKey] : clone[oldKey] = value2;
      value1 === undefined ? delete clone[newKey] : clone[newKey] = value1;
      return false;
    }
    return true;
  });
  return clone;
}

// ../../../node_modules/klona/full/index.mjs
function set(obj, key, val) {
  if (typeof val.value === "object")
    val.value = klona(val.value);
  if (!val.enumerable || val.get || val.set || !val.configurable || !val.writable || key === "__proto__") {
    Object.defineProperty(obj, key, val);
  } else
    obj[key] = val.value;
}
function klona(x) {
  if (typeof x !== "object")
    return x;
  var i = 0, k, list, tmp, str = Object.prototype.toString.call(x);
  if (str === "[object Object]") {
    tmp = Object.create(x.__proto__ || null);
  } else if (str === "[object Array]") {
    tmp = Array(x.length);
  } else if (str === "[object Set]") {
    tmp = new Set;
    x.forEach(function(val) {
      tmp.add(klona(val));
    });
  } else if (str === "[object Map]") {
    tmp = new Map;
    x.forEach(function(val, key) {
      tmp.set(klona(key), klona(val));
    });
  } else if (str === "[object Date]") {
    tmp = new Date(+x);
  } else if (str === "[object RegExp]") {
    tmp = new RegExp(x.source, x.flags);
  } else if (str === "[object DataView]") {
    tmp = new x.constructor(klona(x.buffer));
  } else if (str === "[object ArrayBuffer]") {
    tmp = x.slice(0);
  } else if (str.slice(-6) === "Array]") {
    tmp = new x.constructor(x);
  }
  if (tmp) {
    for (list = Object.getOwnPropertySymbols(x);i < list.length; i++) {
      set(tmp, list[i], Object.getOwnPropertyDescriptor(x, list[i]));
    }
    for (i = 0, list = Object.getOwnPropertyNames(x);i < list.length; i++) {
      if (Object.hasOwnProperty.call(tmp, k = list[i]) && tmp[k] === x[k])
        continue;
      set(tmp, k, Object.getOwnPropertyDescriptor(x, k));
    }
  }
  return tmp || x;
}

// ../../../node_modules/@mantine/form/esm/paths/get-splitted-path.mjs
"use client";
function getSplittedPath(path) {
  if (typeof path !== "string") {
    return [];
  }
  return path.split(".");
}

// ../../../node_modules/@mantine/form/esm/paths/get-path.mjs
"use client";
function getPath(path, values) {
  const splittedPath = getSplittedPath(path);
  if (splittedPath.length === 0 || typeof values !== "object" || values === null) {
    return;
  }
  let value = values[splittedPath[0]];
  for (let i = 1;i < splittedPath.length; i += 1) {
    if (value == null) {
      break;
    }
    value = value[splittedPath[i]];
  }
  return value;
}

// ../../../node_modules/@mantine/form/esm/paths/set-path.mjs
"use client";
function setPath(path, value, values) {
  const splittedPath = getSplittedPath(path);
  if (splittedPath.length === 0) {
    return values;
  }
  const cloned = klona(values);
  if (splittedPath.length === 1) {
    cloned[splittedPath[0]] = value;
    return cloned;
  }
  let val = cloned[splittedPath[0]];
  for (let i = 1;i < splittedPath.length - 1; i += 1) {
    if (val === undefined) {
      return cloned;
    }
    val = val[splittedPath[i]];
  }
  val[splittedPath[splittedPath.length - 1]] = value;
  return cloned;
}

// ../../../node_modules/@mantine/form/esm/paths/reorder-path.mjs
"use client";
function reorderPath(path, { from, to }, values) {
  const currentValue = getPath(path, values);
  if (!Array.isArray(currentValue)) {
    return values;
  }
  const cloned = [...currentValue];
  const item = currentValue[from];
  cloned.splice(from, 1);
  cloned.splice(to, 0, item);
  return setPath(path, cloned, values);
}

// ../../../node_modules/@mantine/form/esm/paths/insert-path.mjs
"use client";
function insertPath(path, value, index, values) {
  const currentValue = getPath(path, values);
  if (!Array.isArray(currentValue)) {
    return values;
  }
  const cloned = [...currentValue];
  cloned.splice(typeof index === "number" ? index : cloned.length, 0, value);
  return setPath(path, cloned, values);
}

// ../../../node_modules/@mantine/form/esm/paths/remove-path.mjs
"use client";
function removePath(path, index, values) {
  const currentValue = getPath(path, values);
  if (!Array.isArray(currentValue)) {
    return values;
  }
  return setPath(path, currentValue.filter((_, itemIndex) => itemIndex !== index), values);
}

// ../../../node_modules/@mantine/form/esm/paths/replace-path.mjs
"use client";
function replacePath(path, item, index, values) {
  const currentValue = getPath(path, values);
  if (!Array.isArray(currentValue)) {
    return values;
  }
  if (currentValue.length <= index) {
    return values;
  }
  const cloned = [...currentValue];
  cloned[index] = item;
  return setPath(path, cloned, values);
}

// ../../../node_modules/@mantine/form/esm/hooks/use-form-list/use-form-list.mjs
"use client";
function useFormList({
  $values,
  $errors,
  $status
}) {
  const reorderListItem = useCallback2((path, payload) => {
    $status.clearFieldDirty(path);
    $errors.setErrors((errs) => reorderErrors(path, payload, errs));
    $values.setValues({
      values: reorderPath(path, payload, $values.refValues.current),
      updateState: true
    });
  }, []);
  const removeListItem = useCallback2((path, index) => {
    $status.clearFieldDirty(path);
    $errors.setErrors((errs) => changeErrorIndices(path, index, errs, -1));
    $values.setValues({
      values: removePath(path, index, $values.refValues.current),
      updateState: true
    });
  }, []);
  const insertListItem = useCallback2((path, item, index) => {
    $status.clearFieldDirty(path);
    $errors.setErrors((errs) => changeErrorIndices(path, index, errs, 1));
    $values.setValues({
      values: insertPath(path, item, index, $values.refValues.current),
      updateState: true
    });
  }, []);
  const replaceListItem = useCallback2((path, index, item) => {
    $status.clearFieldDirty(path);
    $values.setValues({
      values: replacePath(path, item, index, $values.refValues.current),
      updateState: true
    });
  }, []);
  return { reorderListItem, removeListItem, insertListItem, replaceListItem };
}

// ../../../node_modules/@mantine/form/esm/hooks/use-form-status/use-form-status.mjs
var import_fast_deep_equal = __toESM(require_fast_deep_equal(), 1);
import { useState as useState2, useRef as useRef2, useCallback as useCallback3 } from "react";

// ../../../node_modules/@mantine/form/esm/get-status/get-status.mjs
"use client";
function getStatus(status, path) {
  const paths = Object.keys(status);
  if (typeof path === "string") {
    const nestedPaths = paths.filter((statusPath) => statusPath.startsWith(`${path}.`));
    return status[path] || nestedPaths.some((statusPath) => status[statusPath]) || false;
  }
  return paths.some((statusPath) => status[statusPath]);
}

// ../../../node_modules/@mantine/form/esm/hooks/use-form-status/use-form-status.mjs
"use client";
function useFormStatus({
  initialDirty,
  initialTouched,
  mode,
  $values
}) {
  const [touchedState, setTouchedState] = useState2(initialTouched);
  const [dirtyState, setDirtyState] = useState2(initialDirty);
  const touchedRef = useRef2(initialTouched);
  const dirtyRef = useRef2(initialDirty);
  const setTouched = useCallback3((values) => {
    const resolvedValues = typeof values === "function" ? values(touchedRef.current) : values;
    touchedRef.current = resolvedValues;
    if (mode === "controlled") {
      setTouchedState(resolvedValues);
    }
  }, []);
  const setDirty = useCallback3((values, forceUpdate = false) => {
    const resolvedValues = typeof values === "function" ? values(dirtyRef.current) : values;
    dirtyRef.current = resolvedValues;
    if (mode === "controlled" || forceUpdate) {
      setDirtyState(resolvedValues);
    }
  }, []);
  const resetTouched = useCallback3(() => setTouched({}), []);
  const resetDirty = useCallback3((values) => {
    const newSnapshot = values ? { ...$values.refValues.current, ...values } : $values.refValues.current;
    $values.setValuesSnapshot(newSnapshot);
    setDirty({});
  }, []);
  const setFieldTouched = useCallback3((path, touched) => {
    setTouched((currentTouched) => {
      if (getStatus(currentTouched, path) === touched) {
        return currentTouched;
      }
      return { ...currentTouched, [path]: touched };
    });
  }, []);
  const setFieldDirty = useCallback3((path, dirty, forceUpdate) => {
    setDirty((currentDirty) => {
      if (getStatus(currentDirty, path) === dirty) {
        return currentDirty;
      }
      return { ...currentDirty, [path]: dirty };
    }, forceUpdate);
  }, []);
  const setCalculatedFieldDirty = useCallback3((path, value) => {
    const currentDirty = getStatus(dirtyRef.current, path);
    const dirty = !import_fast_deep_equal.default(getPath(path, $values.getValuesSnapshot()), value);
    const clearedState = clearListState(path, dirtyRef.current);
    clearedState[path] = dirty;
    setDirty(clearedState, currentDirty !== dirty);
  }, []);
  const isTouched = useCallback3((path) => getStatus(touchedRef.current, path), []);
  const clearFieldDirty = useCallback3((path) => setDirty((current) => {
    if (typeof path !== "string") {
      return current;
    }
    const result = clearListState(path, current);
    delete result[path];
    if (import_fast_deep_equal.default(result, current)) {
      return current;
    }
    return result;
  }), []);
  const isDirty = useCallback3((path) => {
    if (path) {
      const overriddenValue = getPath(path, dirtyRef.current);
      if (typeof overriddenValue === "boolean") {
        return overriddenValue;
      }
      const sliceOfValues = getPath(path, $values.refValues.current);
      const sliceOfInitialValues = getPath(path, $values.valuesSnapshot.current);
      return !import_fast_deep_equal.default(sliceOfValues, sliceOfInitialValues);
    }
    const isOverridden = Object.keys(dirtyRef.current).length > 0;
    if (isOverridden) {
      return getStatus(dirtyRef.current);
    }
    return !import_fast_deep_equal.default($values.refValues.current, $values.valuesSnapshot.current);
  }, []);
  const getDirty = useCallback3(() => dirtyRef.current, []);
  const getTouched = useCallback3(() => touchedRef.current, []);
  return {
    touchedState,
    dirtyState,
    touchedRef,
    dirtyRef,
    setTouched,
    setDirty,
    resetDirty,
    resetTouched,
    isTouched,
    setFieldTouched,
    setFieldDirty,
    setTouchedState,
    setDirtyState,
    clearFieldDirty,
    isDirty,
    getDirty,
    getTouched,
    setCalculatedFieldDirty
  };
}

// ../../../node_modules/@mantine/form/esm/hooks/use-form-values/use-form-values.mjs
import { useRef as useRef3, useState as useState3, useCallback as useCallback4 } from "react";
"use client";
function useFormValues({
  initialValues,
  onValuesChange,
  mode
}) {
  const initialized = useRef3(false);
  const [stateValues, setStateValues] = useState3(initialValues || {});
  const refValues = useRef3(stateValues);
  const valuesSnapshot = useRef3(stateValues);
  const setValues = useCallback4(({
    values,
    subscribers,
    updateState = true,
    mergeWithPreviousValues = true
  }) => {
    const previousValues = refValues.current;
    const resolvedValues = values instanceof Function ? values(refValues.current) : values;
    const updatedValues = mergeWithPreviousValues ? { ...previousValues, ...resolvedValues } : resolvedValues;
    refValues.current = updatedValues;
    updateState && setStateValues(updatedValues);
    onValuesChange?.(updatedValues, previousValues);
    subscribers?.filter(Boolean).forEach((subscriber) => subscriber({ updatedValues, previousValues }));
  }, [onValuesChange]);
  const setFieldValue = useCallback4((payload) => {
    const currentValue = getPath(payload.path, refValues.current);
    const updatedValue = payload.value instanceof Function ? payload.value(currentValue) : payload.value;
    if (currentValue !== updatedValue) {
      const previousValues = refValues.current;
      const updatedValues = setPath(payload.path, updatedValue, refValues.current);
      setValues({ values: updatedValues, updateState: payload.updateState });
      payload.subscribers?.filter(Boolean).forEach((subscriber) => subscriber({ path: payload.path, updatedValues, previousValues }));
    }
  }, [setValues]);
  const setValuesSnapshot = useCallback4((payload) => {
    valuesSnapshot.current = payload;
  }, []);
  const initialize = useCallback4((values, onInitialize) => {
    if (!initialized.current) {
      initialized.current = true;
      setValues({ values, updateState: mode === "controlled" });
      setValuesSnapshot(values);
      onInitialize();
    }
  }, [setValues]);
  const resetValues = useCallback4(() => {
    setValues({
      values: valuesSnapshot.current,
      updateState: true,
      mergeWithPreviousValues: false
    });
  }, [setValues]);
  const getValues = useCallback4(() => refValues.current, []);
  const getValuesSnapshot = useCallback4(() => valuesSnapshot.current, []);
  return {
    initialized,
    stateValues,
    refValues,
    valuesSnapshot,
    setValues,
    setFieldValue,
    resetValues,
    setValuesSnapshot,
    initialize,
    getValues,
    getValuesSnapshot
  };
}

// ../../../node_modules/@mantine/form/esm/hooks/use-form-watch/use-form-watch.mjs
import { useRef as useRef4, useCallback as useCallback5, useEffect as useEffect2 } from "react";
"use client";
function useFormWatch({
  $status
}) {
  const subscribers = useRef4({});
  const watch = useCallback5((path, callback) => {
    useEffect2(() => {
      subscribers.current[path] = subscribers.current[path] || [];
      subscribers.current[path].push(callback);
      return () => {
        subscribers.current[path] = subscribers.current[path].filter((cb) => cb !== callback);
      };
    }, [callback]);
  }, []);
  const getFieldSubscribers = useCallback5((path) => {
    if (!subscribers.current[path]) {
      return [];
    }
    return subscribers.current[path].map((callback) => (input) => callback({
      previousValue: getPath(path, input.previousValues),
      value: getPath(path, input.updatedValues),
      touched: $status.isTouched(path),
      dirty: $status.isDirty(path)
    }));
  }, []);
  return {
    subscribers,
    watch,
    getFieldSubscribers
  };
}

// ../../../node_modules/@mantine/form/esm/paths/get-data-path.mjs
"use client";
function getDataPath(formName, fieldPath) {
  return formName ? `${formName}-${fieldPath.toString()}` : fieldPath.toString();
}

// ../../../node_modules/@mantine/form/esm/validate/validate-values.mjs
"use client";
function getValidationResults(errors) {
  const filteredErrors = filterErrors(errors);
  return { hasErrors: Object.keys(filteredErrors).length > 0, errors: filteredErrors };
}
function validateRulesRecord(rules, values, path = "", errors = {}) {
  if (typeof rules !== "object" || rules === null) {
    return errors;
  }
  return Object.keys(rules).reduce((acc, ruleKey) => {
    const rule = rules[ruleKey];
    const rulePath = `${path === "" ? "" : `${path}.`}${ruleKey}`;
    const value = getPath(rulePath, values);
    let arrayValidation = false;
    if (typeof rule === "function") {
      acc[rulePath] = rule(value, values, rulePath);
    }
    if (typeof rule === "object" && Array.isArray(value)) {
      arrayValidation = true;
      value.forEach((_item, index) => validateRulesRecord(rule, values, `${rulePath}.${index}`, acc));
    }
    if (typeof rule === "object" && typeof value === "object" && value !== null) {
      if (!arrayValidation) {
        validateRulesRecord(rule, values, rulePath, acc);
      }
    }
    return acc;
  }, errors);
}
function validateValues(validate, values) {
  if (typeof validate === "function") {
    return getValidationResults(validate(values));
  }
  return getValidationResults(validateRulesRecord(validate, values));
}

// ../../../node_modules/@mantine/form/esm/validate/validate-field-value.mjs
"use client";
function validateFieldValue(path, rules, values) {
  if (typeof path !== "string") {
    return { hasError: false, error: null };
  }
  const results = validateValues(rules, values);
  const pathInError = Object.keys(results.errors).find((errorKey) => path.split(".").every((pathPart, i) => pathPart === errorKey.split(".")[i]));
  return { hasError: !!pathInError, error: pathInError ? results.errors[pathInError] : null };
}

// ../../../node_modules/@mantine/form/esm/form-index.mjs
"use client";
var FORM_INDEX = "__MANTINE_FORM_INDEX__";

// ../../../node_modules/@mantine/form/esm/validate/should-validate-on-change.mjs
"use client";
function shouldValidateOnChange(path, validateInputOnChange) {
  if (!validateInputOnChange) {
    return false;
  }
  if (typeof validateInputOnChange === "boolean") {
    return validateInputOnChange;
  }
  if (Array.isArray(validateInputOnChange)) {
    return validateInputOnChange.includes(path.replace(/[.][0-9]+/g, `.${FORM_INDEX}`));
  }
  return false;
}

// ../../../node_modules/@mantine/form/esm/use-form.mjs
"use client";
function useForm({
  name,
  mode = "controlled",
  initialValues,
  initialErrors = {},
  initialDirty = {},
  initialTouched = {},
  clearInputErrorOnChange = true,
  validateInputOnChange = false,
  validateInputOnBlur = false,
  onValuesChange,
  transformValues = (values) => values,
  enhanceGetInputProps,
  validate: rules,
  onSubmitPreventDefault = "always",
  touchTrigger = "change"
} = {}) {
  const $errors = useFormErrors(initialErrors);
  const $values = useFormValues({ initialValues, onValuesChange, mode });
  const $status = useFormStatus({ initialDirty, initialTouched, $values, mode });
  const $list = useFormList({ $values, $errors, $status });
  const $watch = useFormWatch({ $status });
  const [formKey, setFormKey] = useState4(0);
  const [fieldKeys, setFieldKeys] = useState4({});
  const [submitting, setSubmitting] = useState4(false);
  const reset = useCallback6(() => {
    $values.resetValues();
    $errors.clearErrors();
    $status.resetDirty();
    $status.resetTouched();
    mode === "uncontrolled" && setFormKey((key2) => key2 + 1);
  }, []);
  const handleValuesChanges = useCallback6((previousValues) => {
    clearInputErrorOnChange && $errors.clearErrors();
    mode === "uncontrolled" && setFormKey((key2) => key2 + 1);
    Object.keys($watch.subscribers.current).forEach((path) => {
      const value = getPath(path, $values.refValues.current);
      const previousValue = getPath(path, previousValues);
      if (value !== previousValue) {
        $watch.getFieldSubscribers(path).forEach((cb) => cb({ previousValues, updatedValues: $values.refValues.current }));
      }
    });
  }, [clearInputErrorOnChange]);
  const initialize = useCallback6((values) => {
    const previousValues = $values.refValues.current;
    $values.initialize(values, () => mode === "uncontrolled" && setFormKey((key2) => key2 + 1));
    handleValuesChanges(previousValues);
  }, [handleValuesChanges]);
  const setFieldValue = useCallback6((path, value, options) => {
    const shouldValidate = shouldValidateOnChange(path, validateInputOnChange);
    const resolvedValue = value instanceof Function ? value(getPath(path, $values.refValues.current)) : value;
    $status.setCalculatedFieldDirty(path, resolvedValue);
    touchTrigger === "change" && $status.setFieldTouched(path, true);
    !shouldValidate && clearInputErrorOnChange && $errors.clearFieldError(path);
    $values.setFieldValue({
      path,
      value,
      updateState: mode === "controlled",
      subscribers: [
        ...$watch.getFieldSubscribers(path),
        shouldValidate ? (payload) => {
          const validationResults = validateFieldValue(path, rules, payload.updatedValues);
          validationResults.hasError ? $errors.setFieldError(path, validationResults.error) : $errors.clearFieldError(path);
        } : null,
        options?.forceUpdate !== false && mode !== "controlled" ? () => setFieldKeys((keys) => ({
          ...keys,
          [path]: (keys[path] || 0) + 1
        })) : null
      ]
    });
  }, [onValuesChange, rules]);
  const setValues = useCallback6((values) => {
    const previousValues = $values.refValues.current;
    $values.setValues({ values, updateState: mode === "controlled" });
    handleValuesChanges(previousValues);
  }, [onValuesChange, handleValuesChanges]);
  const validate = useCallback6(() => {
    const results = validateValues(rules, $values.refValues.current);
    $errors.setErrors(results.errors);
    return results;
  }, [rules]);
  const validateField = useCallback6((path) => {
    const results = validateFieldValue(path, rules, $values.refValues.current);
    results.hasError ? $errors.setFieldError(path, results.error) : $errors.clearFieldError(path);
    return results;
  }, [rules]);
  const getInputProps = (path, { type = "input", withError = true, withFocus = true, ...otherOptions } = {}) => {
    const onChange = getInputOnChange((value) => setFieldValue(path, value, { forceUpdate: false }));
    const payload = { onChange, "data-path": getDataPath(name, path) };
    if (withError) {
      payload.error = $errors.errorsState[path];
    }
    if (type === "checkbox") {
      payload[mode === "controlled" ? "checked" : "defaultChecked"] = getPath(path, $values.refValues.current);
    } else {
      payload[mode === "controlled" ? "value" : "defaultValue"] = getPath(path, $values.refValues.current);
    }
    if (withFocus) {
      payload.onFocus = () => $status.setFieldTouched(path, true);
      payload.onBlur = () => {
        if (shouldValidateOnChange(path, validateInputOnBlur)) {
          const validationResults = validateFieldValue(path, rules, $values.refValues.current);
          validationResults.hasError ? $errors.setFieldError(path, validationResults.error) : $errors.clearFieldError(path);
        }
      };
    }
    return Object.assign(payload, enhanceGetInputProps?.({
      inputProps: payload,
      field: path,
      options: { type, withError, withFocus, ...otherOptions },
      form
    }));
  };
  const onSubmit = (handleSubmit, handleValidationFailure) => (event) => {
    if (onSubmitPreventDefault === "always") {
      event?.preventDefault();
    }
    const results = validate();
    if (results.hasErrors) {
      if (onSubmitPreventDefault === "validation-failed") {
        event?.preventDefault();
      }
      handleValidationFailure?.(results.errors, $values.refValues.current, event);
    } else {
      const submitResult = handleSubmit?.(transformValues($values.refValues.current), event);
      if (submitResult instanceof Promise) {
        setSubmitting(true);
        submitResult.finally(() => setSubmitting(false));
      }
    }
  };
  const getTransformedValues = (input) => transformValues(input || $values.refValues.current);
  const onReset = useCallback6((event) => {
    event.preventDefault();
    reset();
  }, []);
  const isValid = useCallback6((path) => path ? !validateFieldValue(path, rules, $values.refValues.current).hasError : !validateValues(rules, $values.refValues.current).hasErrors, [rules]);
  const key = (path) => `${formKey}-${path}-${fieldKeys[path] || 0}`;
  const getInputNode = useCallback6((path) => document.querySelector(`[data-path="${getDataPath(name, path)}"]`), []);
  const form = {
    watch: $watch.watch,
    initialized: $values.initialized.current,
    values: $values.stateValues,
    getValues: $values.getValues,
    setInitialValues: $values.setValuesSnapshot,
    initialize,
    setValues,
    setFieldValue,
    submitting,
    setSubmitting,
    errors: $errors.errorsState,
    setErrors: $errors.setErrors,
    setFieldError: $errors.setFieldError,
    clearFieldError: $errors.clearFieldError,
    clearErrors: $errors.clearErrors,
    resetDirty: $status.resetDirty,
    setTouched: $status.setTouched,
    setDirty: $status.setDirty,
    isTouched: $status.isTouched,
    resetTouched: $status.resetTouched,
    isDirty: $status.isDirty,
    getTouched: $status.getTouched,
    getDirty: $status.getDirty,
    reorderListItem: $list.reorderListItem,
    insertListItem: $list.insertListItem,
    removeListItem: $list.removeListItem,
    replaceListItem: $list.replaceListItem,
    reset,
    validate,
    validateField,
    getInputProps,
    onSubmit,
    onReset,
    isValid,
    getTransformedValues,
    key,
    getInputNode
  };
  useFormActions(name, form);
  return form;
}
// ../../../node_modules/@mantine/form/esm/FormProvider/FormProvider.mjs
import { jsx as jsx2 } from "react/jsx-runtime";
import { createContext, useContext } from "react";
"use client";
function createFormContext() {
  const FormContext = createContext(null);
  function FormProvider({ form, children }) {
    return /* @__PURE__ */ jsx2(FormContext.Provider, { value: form, children });
  }
  function useFormContext() {
    const ctx = useContext(FormContext);
    if (!ctx) {
      throw new Error("useFormContext was called outside of FormProvider context");
    }
    return ctx;
  }
  return [FormProvider, useFormContext, useForm];
}
// ../../../node_modules/@mantine/form/esm/use-field.mjs
import { useState as useState5, useRef as useRef5, useMemo, useCallback as useCallback7 } from "react";
"use client";
function useField({
  mode = "controlled",
  clearErrorOnChange = true,
  initialValue,
  initialError = null,
  initialTouched = false,
  onValueChange,
  validateOnChange = false,
  validateOnBlur = false,
  validate,
  resolveValidationError,
  type = "input"
}) {
  const [valueState, setValueState] = useState5(initialValue);
  const valueRef = useRef5(valueState);
  const [key, setKey] = useState5(0);
  const [error, setError] = useState5(initialError || null);
  const touchedRef = useRef5(initialTouched || false);
  const [, setTouchedState] = useState5(touchedRef.current);
  const [isValidating, setIsValidating] = useState5(false);
  const errorResolver = useMemo(() => resolveValidationError || ((err) => err), [resolveValidationError]);
  const setTouched = useCallback7((val, { updateState = mode === "controlled" } = {}) => {
    touchedRef.current = val;
    updateState && setTouchedState(val);
  }, []);
  const setValue = useCallback7((value, {
    updateKey = mode === "uncontrolled",
    updateState = mode === "controlled"
  } = {}) => {
    if (valueRef.current === value) {
      return;
    }
    valueRef.current = value;
    onValueChange?.(value);
    if (clearErrorOnChange && error !== null) {
      setError(null);
    }
    if (updateState) {
      setValueState(value);
    }
    if (updateKey) {
      setKey((currentKey) => currentKey + 1);
    }
    if (validateOnChange) {
      _validate();
    }
  }, [error, clearErrorOnChange]);
  const reset = useCallback7(() => {
    setValue(initialValue);
    setError(null);
    setTouched(false);
  }, [initialValue]);
  const getValue = useCallback7(() => valueRef.current, []);
  const isTouched = useCallback7(() => touchedRef.current, []);
  const isDirty = useCallback7(() => valueRef.current !== initialValue, [initialValue]);
  const _validate = useCallback7(async () => {
    const validationResult = validate?.(valueRef.current);
    if (validationResult instanceof Promise) {
      setIsValidating(true);
      try {
        const result = await validationResult;
        setIsValidating(false);
        setError(result);
      } catch (err) {
        setIsValidating(false);
        const resolvedError = errorResolver(err);
        setError(resolvedError);
        return resolvedError;
      }
    } else {
      setError(validationResult);
      return validationResult;
    }
  }, []);
  const getInputProps = ({ withError = true, withFocus = true } = {}) => {
    const onChange = getInputOnChange((val) => setValue(val, { updateKey: false }));
    const payload = { onChange };
    if (withError) {
      payload.error = error;
    }
    if (type === "checkbox") {
      payload[mode === "controlled" ? "checked" : "defaultChecked"] = valueRef.current;
    } else {
      payload[mode === "controlled" ? "value" : "defaultValue"] = valueRef.current;
    }
    if (withFocus) {
      payload.onFocus = () => {
        setTouched(true);
      };
      payload.onBlur = () => {
        if (shouldValidateOnChange("", !!validateOnBlur)) {
          _validate();
        }
      };
    }
    return payload;
  };
  const resetTouched = useCallback7(() => setTouched(false), []);
  return {
    key,
    getValue,
    setValue,
    reset,
    getInputProps,
    isValidating,
    validate: _validate,
    error,
    setError,
    isTouched,
    isDirty,
    resetTouched
  };
}
// src/hooks/form/make-use-form-hook.ts
import { zodResolver } from "mantine-form-zod-resolver";
var makeUseFormHook = (useFormBase) => {
  return ({
    schema,
    ...restProps
  }) => {
    const useFormProps = {
      ...restProps
    };
    if (schema) {
      useFormProps.validate = zodResolver(schema);
    }
    return useFormBase(useFormProps);
  };
};

// src/hooks/form/create-form-context.ts
var createFormContext2 = () => {
  const [Provider, useFormContext, useFormBase] = createFormContext();
  const useForm2 = makeUseFormHook(useFormBase);
  return [Provider, useFormContext, useForm2];
};

// src/hooks/form/use-form.ts
var useForm2 = makeUseFormHook(useForm);
// src/hooks/form-validation/use-dob-zod-schema.ts
import { useTranslation as useTranslation2 } from "react-i18next";

// ../../../node_modules/zod/lib/index.mjs
var util;
(function(util2) {
  util2.assertEqual = (val) => val;
  function assertIs(_arg) {
  }
  util2.assertIs = assertIs;
  function assertNever(_x) {
    throw new Error;
  }
  util2.assertNever = assertNever;
  util2.arrayToEnum = (items) => {
    const obj = {};
    for (const item of items) {
      obj[item] = item;
    }
    return obj;
  };
  util2.getValidEnumValues = (obj) => {
    const validKeys = util2.objectKeys(obj).filter((k) => typeof obj[obj[k]] !== "number");
    const filtered = {};
    for (const k of validKeys) {
      filtered[k] = obj[k];
    }
    return util2.objectValues(filtered);
  };
  util2.objectValues = (obj) => {
    return util2.objectKeys(obj).map(function(e) {
      return obj[e];
    });
  };
  util2.objectKeys = typeof Object.keys === "function" ? (obj) => Object.keys(obj) : (object) => {
    const keys = [];
    for (const key in object) {
      if (Object.prototype.hasOwnProperty.call(object, key)) {
        keys.push(key);
      }
    }
    return keys;
  };
  util2.find = (arr, checker) => {
    for (const item of arr) {
      if (checker(item))
        return item;
    }
    return;
  };
  util2.isInteger = typeof Number.isInteger === "function" ? (val) => Number.isInteger(val) : (val) => typeof val === "number" && isFinite(val) && Math.floor(val) === val;
  function joinValues(array, separator = " | ") {
    return array.map((val) => typeof val === "string" ? `'${val}'` : val).join(separator);
  }
  util2.joinValues = joinValues;
  util2.jsonStringifyReplacer = (_, value) => {
    if (typeof value === "bigint") {
      return value.toString();
    }
    return value;
  };
})(util || (util = {}));
var objectUtil;
(function(objectUtil2) {
  objectUtil2.mergeShapes = (first, second) => {
    return {
      ...first,
      ...second
    };
  };
})(objectUtil || (objectUtil = {}));
var ZodParsedType = util.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]);
var getParsedType = (data) => {
  const t = typeof data;
  switch (t) {
    case "undefined":
      return ZodParsedType.undefined;
    case "string":
      return ZodParsedType.string;
    case "number":
      return isNaN(data) ? ZodParsedType.nan : ZodParsedType.number;
    case "boolean":
      return ZodParsedType.boolean;
    case "function":
      return ZodParsedType.function;
    case "bigint":
      return ZodParsedType.bigint;
    case "symbol":
      return ZodParsedType.symbol;
    case "object":
      if (Array.isArray(data)) {
        return ZodParsedType.array;
      }
      if (data === null) {
        return ZodParsedType.null;
      }
      if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") {
        return ZodParsedType.promise;
      }
      if (typeof Map !== "undefined" && data instanceof Map) {
        return ZodParsedType.map;
      }
      if (typeof Set !== "undefined" && data instanceof Set) {
        return ZodParsedType.set;
      }
      if (typeof Date !== "undefined" && data instanceof Date) {
        return ZodParsedType.date;
      }
      return ZodParsedType.object;
    default:
      return ZodParsedType.unknown;
  }
};
var ZodIssueCode = util.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
var quotelessJson = (obj) => {
  const json = JSON.stringify(obj, null, 2);
  return json.replace(/"([^"]+)":/g, "$1:");
};

class ZodError extends Error {
  constructor(issues) {
    super();
    this.issues = [];
    this.addIssue = (sub) => {
      this.issues = [...this.issues, sub];
    };
    this.addIssues = (subs = []) => {
      this.issues = [...this.issues, ...subs];
    };
    const actualProto = new.target.prototype;
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(this, actualProto);
    } else {
      this.__proto__ = actualProto;
    }
    this.name = "ZodError";
    this.issues = issues;
  }
  get errors() {
    return this.issues;
  }
  format(_mapper) {
    const mapper = _mapper || function(issue) {
      return issue.message;
    };
    const fieldErrors = { _errors: [] };
    const processError = (error) => {
      for (const issue of error.issues) {
        if (issue.code === "invalid_union") {
          issue.unionErrors.map(processError);
        } else if (issue.code === "invalid_return_type") {
          processError(issue.returnTypeError);
        } else if (issue.code === "invalid_arguments") {
          processError(issue.argumentsError);
        } else if (issue.path.length === 0) {
          fieldErrors._errors.push(mapper(issue));
        } else {
          let curr = fieldErrors;
          let i = 0;
          while (i < issue.path.length) {
            const el = issue.path[i];
            const terminal = i === issue.path.length - 1;
            if (!terminal) {
              curr[el] = curr[el] || { _errors: [] };
            } else {
              curr[el] = curr[el] || { _errors: [] };
              curr[el]._errors.push(mapper(issue));
            }
            curr = curr[el];
            i++;
          }
        }
      }
    };
    processError(this);
    return fieldErrors;
  }
  static assert(value) {
    if (!(value instanceof ZodError)) {
      throw new Error(`Not a ZodError: ${value}`);
    }
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, util.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(mapper = (issue) => issue.message) {
    const fieldErrors = {};
    const formErrors = [];
    for (const sub of this.issues) {
      if (sub.path.length > 0) {
        fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
        fieldErrors[sub.path[0]].push(mapper(sub));
      } else {
        formErrors.push(mapper(sub));
      }
    }
    return { formErrors, fieldErrors };
  }
  get formErrors() {
    return this.flatten();
  }
}
ZodError.create = (issues) => {
  const error = new ZodError(issues);
  return error;
};
var errorMap = (issue, _ctx) => {
  let message;
  switch (issue.code) {
    case ZodIssueCode.invalid_type:
      if (issue.received === ZodParsedType.undefined) {
        message = "Required";
      } else {
        message = `Expected ${issue.expected}, received ${issue.received}`;
      }
      break;
    case ZodIssueCode.invalid_literal:
      message = `Invalid literal value, expected ${JSON.stringify(issue.expected, util.jsonStringifyReplacer)}`;
      break;
    case ZodIssueCode.unrecognized_keys:
      message = `Unrecognized key(s) in object: ${util.joinValues(issue.keys, ", ")}`;
      break;
    case ZodIssueCode.invalid_union:
      message = `Invalid input`;
      break;
    case ZodIssueCode.invalid_union_discriminator:
      message = `Invalid discriminator value. Expected ${util.joinValues(issue.options)}`;
      break;
    case ZodIssueCode.invalid_enum_value:
      message = `Invalid enum value. Expected ${util.joinValues(issue.options)}, received '${issue.received}'`;
      break;
    case ZodIssueCode.invalid_arguments:
      message = `Invalid function arguments`;
      break;
    case ZodIssueCode.invalid_return_type:
      message = `Invalid function return type`;
      break;
    case ZodIssueCode.invalid_date:
      message = `Invalid date`;
      break;
    case ZodIssueCode.invalid_string:
      if (typeof issue.validation === "object") {
        if ("includes" in issue.validation) {
          message = `Invalid input: must include "${issue.validation.includes}"`;
          if (typeof issue.validation.position === "number") {
            message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
          }
        } else if ("startsWith" in issue.validation) {
          message = `Invalid input: must start with "${issue.validation.startsWith}"`;
        } else if ("endsWith" in issue.validation) {
          message = `Invalid input: must end with "${issue.validation.endsWith}"`;
        } else {
          util.assertNever(issue.validation);
        }
      } else if (issue.validation !== "regex") {
        message = `Invalid ${issue.validation}`;
      } else {
        message = "Invalid";
      }
      break;
    case ZodIssueCode.too_small:
      if (issue.type === "array")
        message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
      else if (issue.type === "string")
        message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
      else if (issue.type === "number")
        message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
      else if (issue.type === "date")
        message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
      else
        message = "Invalid input";
      break;
    case ZodIssueCode.too_big:
      if (issue.type === "array")
        message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
      else if (issue.type === "string")
        message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
      else if (issue.type === "number")
        message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
      else if (issue.type === "bigint")
        message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
      else if (issue.type === "date")
        message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
      else
        message = "Invalid input";
      break;
    case ZodIssueCode.custom:
      message = `Invalid input`;
      break;
    case ZodIssueCode.invalid_intersection_types:
      message = `Intersection results could not be merged`;
      break;
    case ZodIssueCode.not_multiple_of:
      message = `Number must be a multiple of ${issue.multipleOf}`;
      break;
    case ZodIssueCode.not_finite:
      message = "Number must be finite";
      break;
    default:
      message = _ctx.defaultError;
      util.assertNever(issue);
  }
  return { message };
};
var overrideErrorMap = errorMap;
function setErrorMap(map) {
  overrideErrorMap = map;
}
function getErrorMap() {
  return overrideErrorMap;
}
var makeIssue = (params) => {
  const { data, path, errorMaps, issueData } = params;
  const fullPath = [...path, ...issueData.path || []];
  const fullIssue = {
    ...issueData,
    path: fullPath
  };
  if (issueData.message !== undefined) {
    return {
      ...issueData,
      path: fullPath,
      message: issueData.message
    };
  }
  let errorMessage = "";
  const maps = errorMaps.filter((m) => !!m).slice().reverse();
  for (const map of maps) {
    errorMessage = map(fullIssue, { data, defaultError: errorMessage }).message;
  }
  return {
    ...issueData,
    path: fullPath,
    message: errorMessage
  };
};
var EMPTY_PATH = [];
function addIssueToContext(ctx, issueData) {
  const overrideMap = getErrorMap();
  const issue = makeIssue({
    issueData,
    data: ctx.data,
    path: ctx.path,
    errorMaps: [
      ctx.common.contextualErrorMap,
      ctx.schemaErrorMap,
      overrideMap,
      overrideMap === errorMap ? undefined : errorMap
    ].filter((x) => !!x)
  });
  ctx.common.issues.push(issue);
}

class ParseStatus {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    if (this.value === "valid")
      this.value = "dirty";
  }
  abort() {
    if (this.value !== "aborted")
      this.value = "aborted";
  }
  static mergeArray(status, results) {
    const arrayValue = [];
    for (const s of results) {
      if (s.status === "aborted")
        return INVALID;
      if (s.status === "dirty")
        status.dirty();
      arrayValue.push(s.value);
    }
    return { status: status.value, value: arrayValue };
  }
  static async mergeObjectAsync(status, pairs) {
    const syncPairs = [];
    for (const pair of pairs) {
      const key = await pair.key;
      const value = await pair.value;
      syncPairs.push({
        key,
        value
      });
    }
    return ParseStatus.mergeObjectSync(status, syncPairs);
  }
  static mergeObjectSync(status, pairs) {
    const finalObject = {};
    for (const pair of pairs) {
      const { key, value } = pair;
      if (key.status === "aborted")
        return INVALID;
      if (value.status === "aborted")
        return INVALID;
      if (key.status === "dirty")
        status.dirty();
      if (value.status === "dirty")
        status.dirty();
      if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) {
        finalObject[key.value] = value.value;
      }
    }
    return { status: status.value, value: finalObject };
  }
}
var INVALID = Object.freeze({
  status: "aborted"
});
var DIRTY = (value) => ({ status: "dirty", value });
var OK = (value) => ({ status: "valid", value });
var isAborted = (x) => x.status === "aborted";
var isDirty = (x) => x.status === "dirty";
var isValid = (x) => x.status === "valid";
var isAsync = (x) => typeof Promise !== "undefined" && x instanceof Promise;
function __classPrivateFieldGet(receiver, state, kind, f) {
  if (kind === "a" && !f)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
  if (kind === "m")
    throw new TypeError("Private method is not writable");
  if (kind === "a" && !f)
    throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
var errorUtil;
(function(errorUtil2) {
  errorUtil2.errToObj = (message) => typeof message === "string" ? { message } : message || {};
  errorUtil2.toString = (message) => typeof message === "string" ? message : message === null || message === undefined ? undefined : message.message;
})(errorUtil || (errorUtil = {}));
var _ZodEnum_cache;
var _ZodNativeEnum_cache;

class ParseInputLazyPath {
  constructor(parent, value, path, key) {
    this._cachedPath = [];
    this.parent = parent;
    this.data = value;
    this._path = path;
    this._key = key;
  }
  get path() {
    if (!this._cachedPath.length) {
      if (this._key instanceof Array) {
        this._cachedPath.push(...this._path, ...this._key);
      } else {
        this._cachedPath.push(...this._path, this._key);
      }
    }
    return this._cachedPath;
  }
}
var handleResult = (ctx, result) => {
  if (isValid(result)) {
    return { success: true, data: result.value };
  } else {
    if (!ctx.common.issues.length) {
      throw new Error("Validation failed but no issues detected.");
    }
    return {
      success: false,
      get error() {
        if (this._error)
          return this._error;
        const error = new ZodError(ctx.common.issues);
        this._error = error;
        return this._error;
      }
    };
  }
};
function processCreateParams(params) {
  if (!params)
    return {};
  const { errorMap: errorMap2, invalid_type_error, required_error, description } = params;
  if (errorMap2 && (invalid_type_error || required_error)) {
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  }
  if (errorMap2)
    return { errorMap: errorMap2, description };
  const customMap = (iss, ctx) => {
    var _a, _b;
    const { message } = params;
    if (iss.code === "invalid_enum_value") {
      return { message: message !== null && message !== undefined ? message : ctx.defaultError };
    }
    if (typeof ctx.data === "undefined") {
      return { message: (_a = message !== null && message !== undefined ? message : required_error) !== null && _a !== undefined ? _a : ctx.defaultError };
    }
    if (iss.code !== "invalid_type")
      return { message: ctx.defaultError };
    return { message: (_b = message !== null && message !== undefined ? message : invalid_type_error) !== null && _b !== undefined ? _b : ctx.defaultError };
  };
  return { errorMap: customMap, description };
}

class ZodType {
  constructor(def) {
    this.spa = this.safeParseAsync;
    this._def = def;
    this.parse = this.parse.bind(this);
    this.safeParse = this.safeParse.bind(this);
    this.parseAsync = this.parseAsync.bind(this);
    this.safeParseAsync = this.safeParseAsync.bind(this);
    this.spa = this.spa.bind(this);
    this.refine = this.refine.bind(this);
    this.refinement = this.refinement.bind(this);
    this.superRefine = this.superRefine.bind(this);
    this.optional = this.optional.bind(this);
    this.nullable = this.nullable.bind(this);
    this.nullish = this.nullish.bind(this);
    this.array = this.array.bind(this);
    this.promise = this.promise.bind(this);
    this.or = this.or.bind(this);
    this.and = this.and.bind(this);
    this.transform = this.transform.bind(this);
    this.brand = this.brand.bind(this);
    this.default = this.default.bind(this);
    this.catch = this.catch.bind(this);
    this.describe = this.describe.bind(this);
    this.pipe = this.pipe.bind(this);
    this.readonly = this.readonly.bind(this);
    this.isNullable = this.isNullable.bind(this);
    this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(input) {
    return getParsedType(input.data);
  }
  _getOrReturnCtx(input, ctx) {
    return ctx || {
      common: input.parent.common,
      data: input.data,
      parsedType: getParsedType(input.data),
      schemaErrorMap: this._def.errorMap,
      path: input.path,
      parent: input.parent
    };
  }
  _processInputParams(input) {
    return {
      status: new ParseStatus,
      ctx: {
        common: input.parent.common,
        data: input.data,
        parsedType: getParsedType(input.data),
        schemaErrorMap: this._def.errorMap,
        path: input.path,
        parent: input.parent
      }
    };
  }
  _parseSync(input) {
    const result = this._parse(input);
    if (isAsync(result)) {
      throw new Error("Synchronous parse encountered promise.");
    }
    return result;
  }
  _parseAsync(input) {
    const result = this._parse(input);
    return Promise.resolve(result);
  }
  parse(data, params) {
    const result = this.safeParse(data, params);
    if (result.success)
      return result.data;
    throw result.error;
  }
  safeParse(data, params) {
    var _a;
    const ctx = {
      common: {
        issues: [],
        async: (_a = params === null || params === undefined ? undefined : params.async) !== null && _a !== undefined ? _a : false,
        contextualErrorMap: params === null || params === undefined ? undefined : params.errorMap
      },
      path: (params === null || params === undefined ? undefined : params.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data,
      parsedType: getParsedType(data)
    };
    const result = this._parseSync({ data, path: ctx.path, parent: ctx });
    return handleResult(ctx, result);
  }
  async parseAsync(data, params) {
    const result = await this.safeParseAsync(data, params);
    if (result.success)
      return result.data;
    throw result.error;
  }
  async safeParseAsync(data, params) {
    const ctx = {
      common: {
        issues: [],
        contextualErrorMap: params === null || params === undefined ? undefined : params.errorMap,
        async: true
      },
      path: (params === null || params === undefined ? undefined : params.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data,
      parsedType: getParsedType(data)
    };
    const maybeAsyncResult = this._parse({ data, path: ctx.path, parent: ctx });
    const result = await (isAsync(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
    return handleResult(ctx, result);
  }
  refine(check, message) {
    const getIssueProperties = (val) => {
      if (typeof message === "string" || typeof message === "undefined") {
        return { message };
      } else if (typeof message === "function") {
        return message(val);
      } else {
        return message;
      }
    };
    return this._refinement((val, ctx) => {
      const result = check(val);
      const setError = () => ctx.addIssue({
        code: ZodIssueCode.custom,
        ...getIssueProperties(val)
      });
      if (typeof Promise !== "undefined" && result instanceof Promise) {
        return result.then((data) => {
          if (!data) {
            setError();
            return false;
          } else {
            return true;
          }
        });
      }
      if (!result) {
        setError();
        return false;
      } else {
        return true;
      }
    });
  }
  refinement(check, refinementData) {
    return this._refinement((val, ctx) => {
      if (!check(val)) {
        ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
        return false;
      } else {
        return true;
      }
    });
  }
  _refinement(refinement) {
    return new ZodEffects({
      schema: this,
      typeName: ZodFirstPartyTypeKind.ZodEffects,
      effect: { type: "refinement", refinement }
    });
  }
  superRefine(refinement) {
    return this._refinement(refinement);
  }
  optional() {
    return ZodOptional.create(this, this._def);
  }
  nullable() {
    return ZodNullable.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return ZodArray.create(this, this._def);
  }
  promise() {
    return ZodPromise.create(this, this._def);
  }
  or(option) {
    return ZodUnion.create([this, option], this._def);
  }
  and(incoming) {
    return ZodIntersection.create(this, incoming, this._def);
  }
  transform(transform) {
    return new ZodEffects({
      ...processCreateParams(this._def),
      schema: this,
      typeName: ZodFirstPartyTypeKind.ZodEffects,
      effect: { type: "transform", transform }
    });
  }
  default(def) {
    const defaultValueFunc = typeof def === "function" ? def : () => def;
    return new ZodDefault({
      ...processCreateParams(this._def),
      innerType: this,
      defaultValue: defaultValueFunc,
      typeName: ZodFirstPartyTypeKind.ZodDefault
    });
  }
  brand() {
    return new ZodBranded({
      typeName: ZodFirstPartyTypeKind.ZodBranded,
      type: this,
      ...processCreateParams(this._def)
    });
  }
  catch(def) {
    const catchValueFunc = typeof def === "function" ? def : () => def;
    return new ZodCatch({
      ...processCreateParams(this._def),
      innerType: this,
      catchValue: catchValueFunc,
      typeName: ZodFirstPartyTypeKind.ZodCatch
    });
  }
  describe(description) {
    const This = this.constructor;
    return new This({
      ...this._def,
      description
    });
  }
  pipe(target) {
    return ZodPipeline.create(this, target);
  }
  readonly() {
    return ZodReadonly.create(this);
  }
  isOptional() {
    return this.safeParse(undefined).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
var cuidRegex = /^c[^\s-]{8,}$/i;
var cuid2Regex = /^[0-9a-z]+$/;
var ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
var uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
var nanoidRegex = /^[a-z0-9_-]{21}$/i;
var durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
var emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
var _emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
var emojiRegex;
var ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
var ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
var base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
var dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
var dateRegex = new RegExp(`^${dateRegexSource}$`);
function timeRegexSource(args) {
  let regex = `([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d`;
  if (args.precision) {
    regex = `${regex}\\.\\d{${args.precision}}`;
  } else if (args.precision == null) {
    regex = `${regex}(\\.\\d+)?`;
  }
  return regex;
}
function timeRegex(args) {
  return new RegExp(`^${timeRegexSource(args)}$`);
}
function datetimeRegex(args) {
  let regex = `${dateRegexSource}T${timeRegexSource(args)}`;
  const opts = [];
  opts.push(args.local ? `Z?` : `Z`);
  if (args.offset)
    opts.push(`([+-]\\d{2}:?\\d{2})`);
  regex = `${regex}(${opts.join("|")})`;
  return new RegExp(`^${regex}$`);
}
function isValidIP(ip, version) {
  if ((version === "v4" || !version) && ipv4Regex.test(ip)) {
    return true;
  }
  if ((version === "v6" || !version) && ipv6Regex.test(ip)) {
    return true;
  }
  return false;
}

class ZodString extends ZodType {
  _parse(input) {
    if (this._def.coerce) {
      input.data = String(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.string) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.string,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    const status = new ParseStatus;
    let ctx = undefined;
    for (const check of this._def.checks) {
      if (check.kind === "min") {
        if (input.data.length < check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            minimum: check.value,
            type: "string",
            inclusive: true,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        if (input.data.length > check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            maximum: check.value,
            type: "string",
            inclusive: true,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "length") {
        const tooBig = input.data.length > check.value;
        const tooSmall = input.data.length < check.value;
        if (tooBig || tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          if (tooBig) {
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_big,
              maximum: check.value,
              type: "string",
              inclusive: true,
              exact: true,
              message: check.message
            });
          } else if (tooSmall) {
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_small,
              minimum: check.value,
              type: "string",
              inclusive: true,
              exact: true,
              message: check.message
            });
          }
          status.dirty();
        }
      } else if (check.kind === "email") {
        if (!emailRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "email",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "emoji") {
        if (!emojiRegex) {
          emojiRegex = new RegExp(_emojiRegex, "u");
        }
        if (!emojiRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "emoji",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "uuid") {
        if (!uuidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "uuid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "nanoid") {
        if (!nanoidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "nanoid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "cuid") {
        if (!cuidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "cuid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "cuid2") {
        if (!cuid2Regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "cuid2",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "ulid") {
        if (!ulidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "ulid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "url") {
        try {
          new URL(input.data);
        } catch (_a) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "url",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "regex") {
        check.regex.lastIndex = 0;
        const testResult = check.regex.test(input.data);
        if (!testResult) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "regex",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "trim") {
        input.data = input.data.trim();
      } else if (check.kind === "includes") {
        if (!input.data.includes(check.value, check.position)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: { includes: check.value, position: check.position },
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "toLowerCase") {
        input.data = input.data.toLowerCase();
      } else if (check.kind === "toUpperCase") {
        input.data = input.data.toUpperCase();
      } else if (check.kind === "startsWith") {
        if (!input.data.startsWith(check.value)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: { startsWith: check.value },
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "endsWith") {
        if (!input.data.endsWith(check.value)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: { endsWith: check.value },
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "datetime") {
        const regex = datetimeRegex(check);
        if (!regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: "datetime",
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "date") {
        const regex = dateRegex;
        if (!regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: "date",
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "time") {
        const regex = timeRegex(check);
        if (!regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: "time",
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "duration") {
        if (!durationRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "duration",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "ip") {
        if (!isValidIP(input.data, check.version)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "ip",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "base64") {
        if (!base64Regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "base64",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return { status: status.value, value: input.data };
  }
  _regex(regex, validation, message) {
    return this.refinement((data) => regex.test(data), {
      validation,
      code: ZodIssueCode.invalid_string,
      ...errorUtil.errToObj(message)
    });
  }
  _addCheck(check) {
    return new ZodString({
      ...this._def,
      checks: [...this._def.checks, check]
    });
  }
  email(message) {
    return this._addCheck({ kind: "email", ...errorUtil.errToObj(message) });
  }
  url(message) {
    return this._addCheck({ kind: "url", ...errorUtil.errToObj(message) });
  }
  emoji(message) {
    return this._addCheck({ kind: "emoji", ...errorUtil.errToObj(message) });
  }
  uuid(message) {
    return this._addCheck({ kind: "uuid", ...errorUtil.errToObj(message) });
  }
  nanoid(message) {
    return this._addCheck({ kind: "nanoid", ...errorUtil.errToObj(message) });
  }
  cuid(message) {
    return this._addCheck({ kind: "cuid", ...errorUtil.errToObj(message) });
  }
  cuid2(message) {
    return this._addCheck({ kind: "cuid2", ...errorUtil.errToObj(message) });
  }
  ulid(message) {
    return this._addCheck({ kind: "ulid", ...errorUtil.errToObj(message) });
  }
  base64(message) {
    return this._addCheck({ kind: "base64", ...errorUtil.errToObj(message) });
  }
  ip(options) {
    return this._addCheck({ kind: "ip", ...errorUtil.errToObj(options) });
  }
  datetime(options) {
    var _a, _b;
    if (typeof options === "string") {
      return this._addCheck({
        kind: "datetime",
        precision: null,
        offset: false,
        local: false,
        message: options
      });
    }
    return this._addCheck({
      kind: "datetime",
      precision: typeof (options === null || options === undefined ? undefined : options.precision) === "undefined" ? null : options === null || options === undefined ? undefined : options.precision,
      offset: (_a = options === null || options === undefined ? undefined : options.offset) !== null && _a !== undefined ? _a : false,
      local: (_b = options === null || options === undefined ? undefined : options.local) !== null && _b !== undefined ? _b : false,
      ...errorUtil.errToObj(options === null || options === undefined ? undefined : options.message)
    });
  }
  date(message) {
    return this._addCheck({ kind: "date", message });
  }
  time(options) {
    if (typeof options === "string") {
      return this._addCheck({
        kind: "time",
        precision: null,
        message: options
      });
    }
    return this._addCheck({
      kind: "time",
      precision: typeof (options === null || options === undefined ? undefined : options.precision) === "undefined" ? null : options === null || options === undefined ? undefined : options.precision,
      ...errorUtil.errToObj(options === null || options === undefined ? undefined : options.message)
    });
  }
  duration(message) {
    return this._addCheck({ kind: "duration", ...errorUtil.errToObj(message) });
  }
  regex(regex, message) {
    return this._addCheck({
      kind: "regex",
      regex,
      ...errorUtil.errToObj(message)
    });
  }
  includes(value, options) {
    return this._addCheck({
      kind: "includes",
      value,
      position: options === null || options === undefined ? undefined : options.position,
      ...errorUtil.errToObj(options === null || options === undefined ? undefined : options.message)
    });
  }
  startsWith(value, message) {
    return this._addCheck({
      kind: "startsWith",
      value,
      ...errorUtil.errToObj(message)
    });
  }
  endsWith(value, message) {
    return this._addCheck({
      kind: "endsWith",
      value,
      ...errorUtil.errToObj(message)
    });
  }
  min(minLength, message) {
    return this._addCheck({
      kind: "min",
      value: minLength,
      ...errorUtil.errToObj(message)
    });
  }
  max(maxLength, message) {
    return this._addCheck({
      kind: "max",
      value: maxLength,
      ...errorUtil.errToObj(message)
    });
  }
  length(len, message) {
    return this._addCheck({
      kind: "length",
      value: len,
      ...errorUtil.errToObj(message)
    });
  }
  nonempty(message) {
    return this.min(1, errorUtil.errToObj(message));
  }
  trim() {
    return new ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((ch) => ch.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((ch) => ch.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((ch) => ch.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((ch) => ch.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((ch) => ch.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((ch) => ch.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((ch) => ch.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((ch) => ch.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((ch) => ch.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((ch) => ch.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((ch) => ch.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((ch) => ch.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((ch) => ch.kind === "ip");
  }
  get isBase64() {
    return !!this._def.checks.find((ch) => ch.kind === "base64");
  }
  get minLength() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min;
  }
  get maxLength() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max;
  }
}
ZodString.create = (params) => {
  var _a;
  return new ZodString({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodString,
    coerce: (_a = params === null || params === undefined ? undefined : params.coerce) !== null && _a !== undefined ? _a : false,
    ...processCreateParams(params)
  });
};
function floatSafeRemainder(val, step) {
  const valDecCount = (val.toString().split(".")[1] || "").length;
  const stepDecCount = (step.toString().split(".")[1] || "").length;
  const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
  const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
  const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
  return valInt % stepInt / Math.pow(10, decCount);
}

class ZodNumber extends ZodType {
  constructor() {
    super(...arguments);
    this.min = this.gte;
    this.max = this.lte;
    this.step = this.multipleOf;
  }
  _parse(input) {
    if (this._def.coerce) {
      input.data = Number(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.number) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.number,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    let ctx = undefined;
    const status = new ParseStatus;
    for (const check of this._def.checks) {
      if (check.kind === "int") {
        if (!util.isInteger(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_type,
            expected: "integer",
            received: "float",
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "min") {
        const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
        if (tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            minimum: check.value,
            type: "number",
            inclusive: check.inclusive,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
        if (tooBig) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            maximum: check.value,
            type: "number",
            inclusive: check.inclusive,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "multipleOf") {
        if (floatSafeRemainder(input.data, check.value) !== 0) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.not_multiple_of,
            multipleOf: check.value,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "finite") {
        if (!Number.isFinite(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.not_finite,
            message: check.message
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return { status: status.value, value: input.data };
  }
  gte(value, message) {
    return this.setLimit("min", value, true, errorUtil.toString(message));
  }
  gt(value, message) {
    return this.setLimit("min", value, false, errorUtil.toString(message));
  }
  lte(value, message) {
    return this.setLimit("max", value, true, errorUtil.toString(message));
  }
  lt(value, message) {
    return this.setLimit("max", value, false, errorUtil.toString(message));
  }
  setLimit(kind, value, inclusive, message) {
    return new ZodNumber({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind,
          value,
          inclusive,
          message: errorUtil.toString(message)
        }
      ]
    });
  }
  _addCheck(check) {
    return new ZodNumber({
      ...this._def,
      checks: [...this._def.checks, check]
    });
  }
  int(message) {
    return this._addCheck({
      kind: "int",
      message: errorUtil.toString(message)
    });
  }
  positive(message) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  negative(message) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  nonpositive(message) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  nonnegative(message) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  multipleOf(value, message) {
    return this._addCheck({
      kind: "multipleOf",
      value,
      message: errorUtil.toString(message)
    });
  }
  finite(message) {
    return this._addCheck({
      kind: "finite",
      message: errorUtil.toString(message)
    });
  }
  safe(message) {
    return this._addCheck({
      kind: "min",
      inclusive: true,
      value: Number.MIN_SAFE_INTEGER,
      message: errorUtil.toString(message)
    })._addCheck({
      kind: "max",
      inclusive: true,
      value: Number.MAX_SAFE_INTEGER,
      message: errorUtil.toString(message)
    });
  }
  get minValue() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min;
  }
  get maxValue() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max;
  }
  get isInt() {
    return !!this._def.checks.find((ch) => ch.kind === "int" || ch.kind === "multipleOf" && util.isInteger(ch.value));
  }
  get isFinite() {
    let max = null, min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") {
        return true;
      } else if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      } else if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return Number.isFinite(min) && Number.isFinite(max);
  }
}
ZodNumber.create = (params) => {
  return new ZodNumber({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodNumber,
    coerce: (params === null || params === undefined ? undefined : params.coerce) || false,
    ...processCreateParams(params)
  });
};

class ZodBigInt extends ZodType {
  constructor() {
    super(...arguments);
    this.min = this.gte;
    this.max = this.lte;
  }
  _parse(input) {
    if (this._def.coerce) {
      input.data = BigInt(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.bigint) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.bigint,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    let ctx = undefined;
    const status = new ParseStatus;
    for (const check of this._def.checks) {
      if (check.kind === "min") {
        const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
        if (tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            type: "bigint",
            minimum: check.value,
            inclusive: check.inclusive,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
        if (tooBig) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            type: "bigint",
            maximum: check.value,
            inclusive: check.inclusive,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "multipleOf") {
        if (input.data % check.value !== BigInt(0)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.not_multiple_of,
            multipleOf: check.value,
            message: check.message
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return { status: status.value, value: input.data };
  }
  gte(value, message) {
    return this.setLimit("min", value, true, errorUtil.toString(message));
  }
  gt(value, message) {
    return this.setLimit("min", value, false, errorUtil.toString(message));
  }
  lte(value, message) {
    return this.setLimit("max", value, true, errorUtil.toString(message));
  }
  lt(value, message) {
    return this.setLimit("max", value, false, errorUtil.toString(message));
  }
  setLimit(kind, value, inclusive, message) {
    return new ZodBigInt({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind,
          value,
          inclusive,
          message: errorUtil.toString(message)
        }
      ]
    });
  }
  _addCheck(check) {
    return new ZodBigInt({
      ...this._def,
      checks: [...this._def.checks, check]
    });
  }
  positive(message) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  negative(message) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  nonpositive(message) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  nonnegative(message) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  multipleOf(value, message) {
    return this._addCheck({
      kind: "multipleOf",
      value,
      message: errorUtil.toString(message)
    });
  }
  get minValue() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min;
  }
  get maxValue() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max;
  }
}
ZodBigInt.create = (params) => {
  var _a;
  return new ZodBigInt({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodBigInt,
    coerce: (_a = params === null || params === undefined ? undefined : params.coerce) !== null && _a !== undefined ? _a : false,
    ...processCreateParams(params)
  });
};

class ZodBoolean extends ZodType {
  _parse(input) {
    if (this._def.coerce) {
      input.data = Boolean(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.boolean) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.boolean,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
}
ZodBoolean.create = (params) => {
  return new ZodBoolean({
    typeName: ZodFirstPartyTypeKind.ZodBoolean,
    coerce: (params === null || params === undefined ? undefined : params.coerce) || false,
    ...processCreateParams(params)
  });
};

class ZodDate extends ZodType {
  _parse(input) {
    if (this._def.coerce) {
      input.data = new Date(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.date) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.date,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    if (isNaN(input.data.getTime())) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_date
      });
      return INVALID;
    }
    const status = new ParseStatus;
    let ctx = undefined;
    for (const check of this._def.checks) {
      if (check.kind === "min") {
        if (input.data.getTime() < check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            message: check.message,
            inclusive: true,
            exact: false,
            minimum: check.value,
            type: "date"
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        if (input.data.getTime() > check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            message: check.message,
            inclusive: true,
            exact: false,
            maximum: check.value,
            type: "date"
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return {
      status: status.value,
      value: new Date(input.data.getTime())
    };
  }
  _addCheck(check) {
    return new ZodDate({
      ...this._def,
      checks: [...this._def.checks, check]
    });
  }
  min(minDate, message) {
    return this._addCheck({
      kind: "min",
      value: minDate.getTime(),
      message: errorUtil.toString(message)
    });
  }
  max(maxDate, message) {
    return this._addCheck({
      kind: "max",
      value: maxDate.getTime(),
      message: errorUtil.toString(message)
    });
  }
  get minDate() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min != null ? new Date(min) : null;
  }
  get maxDate() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max != null ? new Date(max) : null;
  }
}
ZodDate.create = (params) => {
  return new ZodDate({
    checks: [],
    coerce: (params === null || params === undefined ? undefined : params.coerce) || false,
    typeName: ZodFirstPartyTypeKind.ZodDate,
    ...processCreateParams(params)
  });
};

class ZodSymbol extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.symbol) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.symbol,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
}
ZodSymbol.create = (params) => {
  return new ZodSymbol({
    typeName: ZodFirstPartyTypeKind.ZodSymbol,
    ...processCreateParams(params)
  });
};

class ZodUndefined extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.undefined) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.undefined,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
}
ZodUndefined.create = (params) => {
  return new ZodUndefined({
    typeName: ZodFirstPartyTypeKind.ZodUndefined,
    ...processCreateParams(params)
  });
};

class ZodNull extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.null) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.null,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
}
ZodNull.create = (params) => {
  return new ZodNull({
    typeName: ZodFirstPartyTypeKind.ZodNull,
    ...processCreateParams(params)
  });
};

class ZodAny extends ZodType {
  constructor() {
    super(...arguments);
    this._any = true;
  }
  _parse(input) {
    return OK(input.data);
  }
}
ZodAny.create = (params) => {
  return new ZodAny({
    typeName: ZodFirstPartyTypeKind.ZodAny,
    ...processCreateParams(params)
  });
};

class ZodUnknown extends ZodType {
  constructor() {
    super(...arguments);
    this._unknown = true;
  }
  _parse(input) {
    return OK(input.data);
  }
}
ZodUnknown.create = (params) => {
  return new ZodUnknown({
    typeName: ZodFirstPartyTypeKind.ZodUnknown,
    ...processCreateParams(params)
  });
};

class ZodNever extends ZodType {
  _parse(input) {
    const ctx = this._getOrReturnCtx(input);
    addIssueToContext(ctx, {
      code: ZodIssueCode.invalid_type,
      expected: ZodParsedType.never,
      received: ctx.parsedType
    });
    return INVALID;
  }
}
ZodNever.create = (params) => {
  return new ZodNever({
    typeName: ZodFirstPartyTypeKind.ZodNever,
    ...processCreateParams(params)
  });
};

class ZodVoid extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.undefined) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.void,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
}
ZodVoid.create = (params) => {
  return new ZodVoid({
    typeName: ZodFirstPartyTypeKind.ZodVoid,
    ...processCreateParams(params)
  });
};

class ZodArray extends ZodType {
  _parse(input) {
    const { ctx, status } = this._processInputParams(input);
    const def = this._def;
    if (ctx.parsedType !== ZodParsedType.array) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.array,
        received: ctx.parsedType
      });
      return INVALID;
    }
    if (def.exactLength !== null) {
      const tooBig = ctx.data.length > def.exactLength.value;
      const tooSmall = ctx.data.length < def.exactLength.value;
      if (tooBig || tooSmall) {
        addIssueToContext(ctx, {
          code: tooBig ? ZodIssueCode.too_big : ZodIssueCode.too_small,
          minimum: tooSmall ? def.exactLength.value : undefined,
          maximum: tooBig ? def.exactLength.value : undefined,
          type: "array",
          inclusive: true,
          exact: true,
          message: def.exactLength.message
        });
        status.dirty();
      }
    }
    if (def.minLength !== null) {
      if (ctx.data.length < def.minLength.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_small,
          minimum: def.minLength.value,
          type: "array",
          inclusive: true,
          exact: false,
          message: def.minLength.message
        });
        status.dirty();
      }
    }
    if (def.maxLength !== null) {
      if (ctx.data.length > def.maxLength.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_big,
          maximum: def.maxLength.value,
          type: "array",
          inclusive: true,
          exact: false,
          message: def.maxLength.message
        });
        status.dirty();
      }
    }
    if (ctx.common.async) {
      return Promise.all([...ctx.data].map((item, i) => {
        return def.type._parseAsync(new ParseInputLazyPath(ctx, item, ctx.path, i));
      })).then((result2) => {
        return ParseStatus.mergeArray(status, result2);
      });
    }
    const result = [...ctx.data].map((item, i) => {
      return def.type._parseSync(new ParseInputLazyPath(ctx, item, ctx.path, i));
    });
    return ParseStatus.mergeArray(status, result);
  }
  get element() {
    return this._def.type;
  }
  min(minLength, message) {
    return new ZodArray({
      ...this._def,
      minLength: { value: minLength, message: errorUtil.toString(message) }
    });
  }
  max(maxLength, message) {
    return new ZodArray({
      ...this._def,
      maxLength: { value: maxLength, message: errorUtil.toString(message) }
    });
  }
  length(len, message) {
    return new ZodArray({
      ...this._def,
      exactLength: { value: len, message: errorUtil.toString(message) }
    });
  }
  nonempty(message) {
    return this.min(1, message);
  }
}
ZodArray.create = (schema, params) => {
  return new ZodArray({
    type: schema,
    minLength: null,
    maxLength: null,
    exactLength: null,
    typeName: ZodFirstPartyTypeKind.ZodArray,
    ...processCreateParams(params)
  });
};
function deepPartialify(schema) {
  if (schema instanceof ZodObject) {
    const newShape = {};
    for (const key in schema.shape) {
      const fieldSchema = schema.shape[key];
      newShape[key] = ZodOptional.create(deepPartialify(fieldSchema));
    }
    return new ZodObject({
      ...schema._def,
      shape: () => newShape
    });
  } else if (schema instanceof ZodArray) {
    return new ZodArray({
      ...schema._def,
      type: deepPartialify(schema.element)
    });
  } else if (schema instanceof ZodOptional) {
    return ZodOptional.create(deepPartialify(schema.unwrap()));
  } else if (schema instanceof ZodNullable) {
    return ZodNullable.create(deepPartialify(schema.unwrap()));
  } else if (schema instanceof ZodTuple) {
    return ZodTuple.create(schema.items.map((item) => deepPartialify(item)));
  } else {
    return schema;
  }
}

class ZodObject extends ZodType {
  constructor() {
    super(...arguments);
    this._cached = null;
    this.nonstrict = this.passthrough;
    this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const shape = this._def.shape();
    const keys = util.objectKeys(shape);
    return this._cached = { shape, keys };
  }
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.object) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    const { status, ctx } = this._processInputParams(input);
    const { shape, keys: shapeKeys } = this._getCached();
    const extraKeys = [];
    if (!(this._def.catchall instanceof ZodNever && this._def.unknownKeys === "strip")) {
      for (const key in ctx.data) {
        if (!shapeKeys.includes(key)) {
          extraKeys.push(key);
        }
      }
    }
    const pairs = [];
    for (const key of shapeKeys) {
      const keyValidator = shape[key];
      const value = ctx.data[key];
      pairs.push({
        key: { status: "valid", value: key },
        value: keyValidator._parse(new ParseInputLazyPath(ctx, value, ctx.path, key)),
        alwaysSet: key in ctx.data
      });
    }
    if (this._def.catchall instanceof ZodNever) {
      const unknownKeys = this._def.unknownKeys;
      if (unknownKeys === "passthrough") {
        for (const key of extraKeys) {
          pairs.push({
            key: { status: "valid", value: key },
            value: { status: "valid", value: ctx.data[key] }
          });
        }
      } else if (unknownKeys === "strict") {
        if (extraKeys.length > 0) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.unrecognized_keys,
            keys: extraKeys
          });
          status.dirty();
        }
      } else if (unknownKeys === "strip")
        ;
      else {
        throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
      }
    } else {
      const catchall = this._def.catchall;
      for (const key of extraKeys) {
        const value = ctx.data[key];
        pairs.push({
          key: { status: "valid", value: key },
          value: catchall._parse(new ParseInputLazyPath(ctx, value, ctx.path, key)),
          alwaysSet: key in ctx.data
        });
      }
    }
    if (ctx.common.async) {
      return Promise.resolve().then(async () => {
        const syncPairs = [];
        for (const pair of pairs) {
          const key = await pair.key;
          const value = await pair.value;
          syncPairs.push({
            key,
            value,
            alwaysSet: pair.alwaysSet
          });
        }
        return syncPairs;
      }).then((syncPairs) => {
        return ParseStatus.mergeObjectSync(status, syncPairs);
      });
    } else {
      return ParseStatus.mergeObjectSync(status, pairs);
    }
  }
  get shape() {
    return this._def.shape();
  }
  strict(message) {
    errorUtil.errToObj;
    return new ZodObject({
      ...this._def,
      unknownKeys: "strict",
      ...message !== undefined ? {
        errorMap: (issue, ctx) => {
          var _a, _b, _c, _d;
          const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === undefined ? undefined : _b.call(_a, issue, ctx).message) !== null && _c !== undefined ? _c : ctx.defaultError;
          if (issue.code === "unrecognized_keys")
            return {
              message: (_d = errorUtil.errToObj(message).message) !== null && _d !== undefined ? _d : defaultError
            };
          return {
            message: defaultError
          };
        }
      } : {}
    });
  }
  strip() {
    return new ZodObject({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new ZodObject({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  extend(augmentation) {
    return new ZodObject({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...augmentation
      })
    });
  }
  merge(merging) {
    const merged = new ZodObject({
      unknownKeys: merging._def.unknownKeys,
      catchall: merging._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...merging._def.shape()
      }),
      typeName: ZodFirstPartyTypeKind.ZodObject
    });
    return merged;
  }
  setKey(key, schema) {
    return this.augment({ [key]: schema });
  }
  catchall(index) {
    return new ZodObject({
      ...this._def,
      catchall: index
    });
  }
  pick(mask) {
    const shape = {};
    util.objectKeys(mask).forEach((key) => {
      if (mask[key] && this.shape[key]) {
        shape[key] = this.shape[key];
      }
    });
    return new ZodObject({
      ...this._def,
      shape: () => shape
    });
  }
  omit(mask) {
    const shape = {};
    util.objectKeys(this.shape).forEach((key) => {
      if (!mask[key]) {
        shape[key] = this.shape[key];
      }
    });
    return new ZodObject({
      ...this._def,
      shape: () => shape
    });
  }
  deepPartial() {
    return deepPartialify(this);
  }
  partial(mask) {
    const newShape = {};
    util.objectKeys(this.shape).forEach((key) => {
      const fieldSchema = this.shape[key];
      if (mask && !mask[key]) {
        newShape[key] = fieldSchema;
      } else {
        newShape[key] = fieldSchema.optional();
      }
    });
    return new ZodObject({
      ...this._def,
      shape: () => newShape
    });
  }
  required(mask) {
    const newShape = {};
    util.objectKeys(this.shape).forEach((key) => {
      if (mask && !mask[key]) {
        newShape[key] = this.shape[key];
      } else {
        const fieldSchema = this.shape[key];
        let newField = fieldSchema;
        while (newField instanceof ZodOptional) {
          newField = newField._def.innerType;
        }
        newShape[key] = newField;
      }
    });
    return new ZodObject({
      ...this._def,
      shape: () => newShape
    });
  }
  keyof() {
    return createZodEnum(util.objectKeys(this.shape));
  }
}
ZodObject.create = (shape, params) => {
  return new ZodObject({
    shape: () => shape,
    unknownKeys: "strip",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject,
    ...processCreateParams(params)
  });
};
ZodObject.strictCreate = (shape, params) => {
  return new ZodObject({
    shape: () => shape,
    unknownKeys: "strict",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject,
    ...processCreateParams(params)
  });
};
ZodObject.lazycreate = (shape, params) => {
  return new ZodObject({
    shape,
    unknownKeys: "strip",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject,
    ...processCreateParams(params)
  });
};

class ZodUnion extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const options = this._def.options;
    function handleResults(results) {
      for (const result of results) {
        if (result.result.status === "valid") {
          return result.result;
        }
      }
      for (const result of results) {
        if (result.result.status === "dirty") {
          ctx.common.issues.push(...result.ctx.common.issues);
          return result.result;
        }
      }
      const unionErrors = results.map((result) => new ZodError(result.ctx.common.issues));
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_union,
        unionErrors
      });
      return INVALID;
    }
    if (ctx.common.async) {
      return Promise.all(options.map(async (option) => {
        const childCtx = {
          ...ctx,
          common: {
            ...ctx.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: childCtx
          }),
          ctx: childCtx
        };
      })).then(handleResults);
    } else {
      let dirty = undefined;
      const issues = [];
      for (const option of options) {
        const childCtx = {
          ...ctx,
          common: {
            ...ctx.common,
            issues: []
          },
          parent: null
        };
        const result = option._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: childCtx
        });
        if (result.status === "valid") {
          return result;
        } else if (result.status === "dirty" && !dirty) {
          dirty = { result, ctx: childCtx };
        }
        if (childCtx.common.issues.length) {
          issues.push(childCtx.common.issues);
        }
      }
      if (dirty) {
        ctx.common.issues.push(...dirty.ctx.common.issues);
        return dirty.result;
      }
      const unionErrors = issues.map((issues2) => new ZodError(issues2));
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_union,
        unionErrors
      });
      return INVALID;
    }
  }
  get options() {
    return this._def.options;
  }
}
ZodUnion.create = (types, params) => {
  return new ZodUnion({
    options: types,
    typeName: ZodFirstPartyTypeKind.ZodUnion,
    ...processCreateParams(params)
  });
};
var getDiscriminator = (type) => {
  if (type instanceof ZodLazy) {
    return getDiscriminator(type.schema);
  } else if (type instanceof ZodEffects) {
    return getDiscriminator(type.innerType());
  } else if (type instanceof ZodLiteral) {
    return [type.value];
  } else if (type instanceof ZodEnum) {
    return type.options;
  } else if (type instanceof ZodNativeEnum) {
    return util.objectValues(type.enum);
  } else if (type instanceof ZodDefault) {
    return getDiscriminator(type._def.innerType);
  } else if (type instanceof ZodUndefined) {
    return [undefined];
  } else if (type instanceof ZodNull) {
    return [null];
  } else if (type instanceof ZodOptional) {
    return [undefined, ...getDiscriminator(type.unwrap())];
  } else if (type instanceof ZodNullable) {
    return [null, ...getDiscriminator(type.unwrap())];
  } else if (type instanceof ZodBranded) {
    return getDiscriminator(type.unwrap());
  } else if (type instanceof ZodReadonly) {
    return getDiscriminator(type.unwrap());
  } else if (type instanceof ZodCatch) {
    return getDiscriminator(type._def.innerType);
  } else {
    return [];
  }
};

class ZodDiscriminatedUnion extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.object) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const discriminator = this.discriminator;
    const discriminatorValue = ctx.data[discriminator];
    const option = this.optionsMap.get(discriminatorValue);
    if (!option) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_union_discriminator,
        options: Array.from(this.optionsMap.keys()),
        path: [discriminator]
      });
      return INVALID;
    }
    if (ctx.common.async) {
      return option._parseAsync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
    } else {
      return option._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
    }
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  static create(discriminator, options, params) {
    const optionsMap = new Map;
    for (const type of options) {
      const discriminatorValues = getDiscriminator(type.shape[discriminator]);
      if (!discriminatorValues.length) {
        throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
      }
      for (const value of discriminatorValues) {
        if (optionsMap.has(value)) {
          throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
        }
        optionsMap.set(value, type);
      }
    }
    return new ZodDiscriminatedUnion({
      typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
      discriminator,
      options,
      optionsMap,
      ...processCreateParams(params)
    });
  }
}
function mergeValues(a, b) {
  const aType = getParsedType(a);
  const bType = getParsedType(b);
  if (a === b) {
    return { valid: true, data: a };
  } else if (aType === ZodParsedType.object && bType === ZodParsedType.object) {
    const bKeys = util.objectKeys(b);
    const sharedKeys = util.objectKeys(a).filter((key) => bKeys.indexOf(key) !== -1);
    const newObj = { ...a, ...b };
    for (const key of sharedKeys) {
      const sharedValue = mergeValues(a[key], b[key]);
      if (!sharedValue.valid) {
        return { valid: false };
      }
      newObj[key] = sharedValue.data;
    }
    return { valid: true, data: newObj };
  } else if (aType === ZodParsedType.array && bType === ZodParsedType.array) {
    if (a.length !== b.length) {
      return { valid: false };
    }
    const newArray = [];
    for (let index = 0;index < a.length; index++) {
      const itemA = a[index];
      const itemB = b[index];
      const sharedValue = mergeValues(itemA, itemB);
      if (!sharedValue.valid) {
        return { valid: false };
      }
      newArray.push(sharedValue.data);
    }
    return { valid: true, data: newArray };
  } else if (aType === ZodParsedType.date && bType === ZodParsedType.date && +a === +b) {
    return { valid: true, data: a };
  } else {
    return { valid: false };
  }
}

class ZodIntersection extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    const handleParsed = (parsedLeft, parsedRight) => {
      if (isAborted(parsedLeft) || isAborted(parsedRight)) {
        return INVALID;
      }
      const merged = mergeValues(parsedLeft.value, parsedRight.value);
      if (!merged.valid) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_intersection_types
        });
        return INVALID;
      }
      if (isDirty(parsedLeft) || isDirty(parsedRight)) {
        status.dirty();
      }
      return { status: status.value, value: merged.data };
    };
    if (ctx.common.async) {
      return Promise.all([
        this._def.left._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        }),
        this._def.right._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        })
      ]).then(([left, right]) => handleParsed(left, right));
    } else {
      return handleParsed(this._def.left._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      }), this._def.right._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      }));
    }
  }
}
ZodIntersection.create = (left, right, params) => {
  return new ZodIntersection({
    left,
    right,
    typeName: ZodFirstPartyTypeKind.ZodIntersection,
    ...processCreateParams(params)
  });
};

class ZodTuple extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.array) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.array,
        received: ctx.parsedType
      });
      return INVALID;
    }
    if (ctx.data.length < this._def.items.length) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.too_small,
        minimum: this._def.items.length,
        inclusive: true,
        exact: false,
        type: "array"
      });
      return INVALID;
    }
    const rest = this._def.rest;
    if (!rest && ctx.data.length > this._def.items.length) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.too_big,
        maximum: this._def.items.length,
        inclusive: true,
        exact: false,
        type: "array"
      });
      status.dirty();
    }
    const items = [...ctx.data].map((item, itemIndex) => {
      const schema = this._def.items[itemIndex] || this._def.rest;
      if (!schema)
        return null;
      return schema._parse(new ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
    }).filter((x) => !!x);
    if (ctx.common.async) {
      return Promise.all(items).then((results) => {
        return ParseStatus.mergeArray(status, results);
      });
    } else {
      return ParseStatus.mergeArray(status, items);
    }
  }
  get items() {
    return this._def.items;
  }
  rest(rest) {
    return new ZodTuple({
      ...this._def,
      rest
    });
  }
}
ZodTuple.create = (schemas, params) => {
  if (!Array.isArray(schemas)) {
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  }
  return new ZodTuple({
    items: schemas,
    typeName: ZodFirstPartyTypeKind.ZodTuple,
    rest: null,
    ...processCreateParams(params)
  });
};

class ZodRecord extends ZodType {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.object) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const pairs = [];
    const keyType = this._def.keyType;
    const valueType = this._def.valueType;
    for (const key in ctx.data) {
      pairs.push({
        key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, key)),
        value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
        alwaysSet: key in ctx.data
      });
    }
    if (ctx.common.async) {
      return ParseStatus.mergeObjectAsync(status, pairs);
    } else {
      return ParseStatus.mergeObjectSync(status, pairs);
    }
  }
  get element() {
    return this._def.valueType;
  }
  static create(first, second, third) {
    if (second instanceof ZodType) {
      return new ZodRecord({
        keyType: first,
        valueType: second,
        typeName: ZodFirstPartyTypeKind.ZodRecord,
        ...processCreateParams(third)
      });
    }
    return new ZodRecord({
      keyType: ZodString.create(),
      valueType: first,
      typeName: ZodFirstPartyTypeKind.ZodRecord,
      ...processCreateParams(second)
    });
  }
}

class ZodMap extends ZodType {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.map) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.map,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const keyType = this._def.keyType;
    const valueType = this._def.valueType;
    const pairs = [...ctx.data.entries()].map(([key, value], index) => {
      return {
        key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, [index, "key"])),
        value: valueType._parse(new ParseInputLazyPath(ctx, value, ctx.path, [index, "value"]))
      };
    });
    if (ctx.common.async) {
      const finalMap = new Map;
      return Promise.resolve().then(async () => {
        for (const pair of pairs) {
          const key = await pair.key;
          const value = await pair.value;
          if (key.status === "aborted" || value.status === "aborted") {
            return INVALID;
          }
          if (key.status === "dirty" || value.status === "dirty") {
            status.dirty();
          }
          finalMap.set(key.value, value.value);
        }
        return { status: status.value, value: finalMap };
      });
    } else {
      const finalMap = new Map;
      for (const pair of pairs) {
        const key = pair.key;
        const value = pair.value;
        if (key.status === "aborted" || value.status === "aborted") {
          return INVALID;
        }
        if (key.status === "dirty" || value.status === "dirty") {
          status.dirty();
        }
        finalMap.set(key.value, value.value);
      }
      return { status: status.value, value: finalMap };
    }
  }
}
ZodMap.create = (keyType, valueType, params) => {
  return new ZodMap({
    valueType,
    keyType,
    typeName: ZodFirstPartyTypeKind.ZodMap,
    ...processCreateParams(params)
  });
};

class ZodSet extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.set) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.set,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const def = this._def;
    if (def.minSize !== null) {
      if (ctx.data.size < def.minSize.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_small,
          minimum: def.minSize.value,
          type: "set",
          inclusive: true,
          exact: false,
          message: def.minSize.message
        });
        status.dirty();
      }
    }
    if (def.maxSize !== null) {
      if (ctx.data.size > def.maxSize.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_big,
          maximum: def.maxSize.value,
          type: "set",
          inclusive: true,
          exact: false,
          message: def.maxSize.message
        });
        status.dirty();
      }
    }
    const valueType = this._def.valueType;
    function finalizeSet(elements2) {
      const parsedSet = new Set;
      for (const element of elements2) {
        if (element.status === "aborted")
          return INVALID;
        if (element.status === "dirty")
          status.dirty();
        parsedSet.add(element.value);
      }
      return { status: status.value, value: parsedSet };
    }
    const elements = [...ctx.data.values()].map((item, i) => valueType._parse(new ParseInputLazyPath(ctx, item, ctx.path, i)));
    if (ctx.common.async) {
      return Promise.all(elements).then((elements2) => finalizeSet(elements2));
    } else {
      return finalizeSet(elements);
    }
  }
  min(minSize, message) {
    return new ZodSet({
      ...this._def,
      minSize: { value: minSize, message: errorUtil.toString(message) }
    });
  }
  max(maxSize, message) {
    return new ZodSet({
      ...this._def,
      maxSize: { value: maxSize, message: errorUtil.toString(message) }
    });
  }
  size(size, message) {
    return this.min(size, message).max(size, message);
  }
  nonempty(message) {
    return this.min(1, message);
  }
}
ZodSet.create = (valueType, params) => {
  return new ZodSet({
    valueType,
    minSize: null,
    maxSize: null,
    typeName: ZodFirstPartyTypeKind.ZodSet,
    ...processCreateParams(params)
  });
};

class ZodFunction extends ZodType {
  constructor() {
    super(...arguments);
    this.validate = this.implement;
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.function) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.function,
        received: ctx.parsedType
      });
      return INVALID;
    }
    function makeArgsIssue(args, error) {
      return makeIssue({
        data: args,
        path: ctx.path,
        errorMaps: [
          ctx.common.contextualErrorMap,
          ctx.schemaErrorMap,
          getErrorMap(),
          errorMap
        ].filter((x) => !!x),
        issueData: {
          code: ZodIssueCode.invalid_arguments,
          argumentsError: error
        }
      });
    }
    function makeReturnsIssue(returns, error) {
      return makeIssue({
        data: returns,
        path: ctx.path,
        errorMaps: [
          ctx.common.contextualErrorMap,
          ctx.schemaErrorMap,
          getErrorMap(),
          errorMap
        ].filter((x) => !!x),
        issueData: {
          code: ZodIssueCode.invalid_return_type,
          returnTypeError: error
        }
      });
    }
    const params = { errorMap: ctx.common.contextualErrorMap };
    const fn = ctx.data;
    if (this._def.returns instanceof ZodPromise) {
      const me = this;
      return OK(async function(...args) {
        const error = new ZodError([]);
        const parsedArgs = await me._def.args.parseAsync(args, params).catch((e) => {
          error.addIssue(makeArgsIssue(args, e));
          throw error;
        });
        const result = await Reflect.apply(fn, this, parsedArgs);
        const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e) => {
          error.addIssue(makeReturnsIssue(result, e));
          throw error;
        });
        return parsedReturns;
      });
    } else {
      const me = this;
      return OK(function(...args) {
        const parsedArgs = me._def.args.safeParse(args, params);
        if (!parsedArgs.success) {
          throw new ZodError([makeArgsIssue(args, parsedArgs.error)]);
        }
        const result = Reflect.apply(fn, this, parsedArgs.data);
        const parsedReturns = me._def.returns.safeParse(result, params);
        if (!parsedReturns.success) {
          throw new ZodError([makeReturnsIssue(result, parsedReturns.error)]);
        }
        return parsedReturns.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...items) {
    return new ZodFunction({
      ...this._def,
      args: ZodTuple.create(items).rest(ZodUnknown.create())
    });
  }
  returns(returnType) {
    return new ZodFunction({
      ...this._def,
      returns: returnType
    });
  }
  implement(func) {
    const validatedFunc = this.parse(func);
    return validatedFunc;
  }
  strictImplement(func) {
    const validatedFunc = this.parse(func);
    return validatedFunc;
  }
  static create(args, returns, params) {
    return new ZodFunction({
      args: args ? args : ZodTuple.create([]).rest(ZodUnknown.create()),
      returns: returns || ZodUnknown.create(),
      typeName: ZodFirstPartyTypeKind.ZodFunction,
      ...processCreateParams(params)
    });
  }
}

class ZodLazy extends ZodType {
  get schema() {
    return this._def.getter();
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const lazySchema = this._def.getter();
    return lazySchema._parse({ data: ctx.data, path: ctx.path, parent: ctx });
  }
}
ZodLazy.create = (getter, params) => {
  return new ZodLazy({
    getter,
    typeName: ZodFirstPartyTypeKind.ZodLazy,
    ...processCreateParams(params)
  });
};

class ZodLiteral extends ZodType {
  _parse(input) {
    if (input.data !== this._def.value) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode.invalid_literal,
        expected: this._def.value
      });
      return INVALID;
    }
    return { status: "valid", value: input.data };
  }
  get value() {
    return this._def.value;
  }
}
ZodLiteral.create = (value, params) => {
  return new ZodLiteral({
    value,
    typeName: ZodFirstPartyTypeKind.ZodLiteral,
    ...processCreateParams(params)
  });
};
function createZodEnum(values, params) {
  return new ZodEnum({
    values,
    typeName: ZodFirstPartyTypeKind.ZodEnum,
    ...processCreateParams(params)
  });
}

class ZodEnum extends ZodType {
  constructor() {
    super(...arguments);
    _ZodEnum_cache.set(this, undefined);
  }
  _parse(input) {
    if (typeof input.data !== "string") {
      const ctx = this._getOrReturnCtx(input);
      const expectedValues = this._def.values;
      addIssueToContext(ctx, {
        expected: util.joinValues(expectedValues),
        received: ctx.parsedType,
        code: ZodIssueCode.invalid_type
      });
      return INVALID;
    }
    if (!__classPrivateFieldGet(this, _ZodEnum_cache, "f")) {
      __classPrivateFieldSet(this, _ZodEnum_cache, new Set(this._def.values), "f");
    }
    if (!__classPrivateFieldGet(this, _ZodEnum_cache, "f").has(input.data)) {
      const ctx = this._getOrReturnCtx(input);
      const expectedValues = this._def.values;
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode.invalid_enum_value,
        options: expectedValues
      });
      return INVALID;
    }
    return OK(input.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const enumValues = {};
    for (const val of this._def.values) {
      enumValues[val] = val;
    }
    return enumValues;
  }
  get Values() {
    const enumValues = {};
    for (const val of this._def.values) {
      enumValues[val] = val;
    }
    return enumValues;
  }
  get Enum() {
    const enumValues = {};
    for (const val of this._def.values) {
      enumValues[val] = val;
    }
    return enumValues;
  }
  extract(values, newDef = this._def) {
    return ZodEnum.create(values, {
      ...this._def,
      ...newDef
    });
  }
  exclude(values, newDef = this._def) {
    return ZodEnum.create(this.options.filter((opt) => !values.includes(opt)), {
      ...this._def,
      ...newDef
    });
  }
}
_ZodEnum_cache = new WeakMap;
ZodEnum.create = createZodEnum;

class ZodNativeEnum extends ZodType {
  constructor() {
    super(...arguments);
    _ZodNativeEnum_cache.set(this, undefined);
  }
  _parse(input) {
    const nativeEnumValues = util.getValidEnumValues(this._def.values);
    const ctx = this._getOrReturnCtx(input);
    if (ctx.parsedType !== ZodParsedType.string && ctx.parsedType !== ZodParsedType.number) {
      const expectedValues = util.objectValues(nativeEnumValues);
      addIssueToContext(ctx, {
        expected: util.joinValues(expectedValues),
        received: ctx.parsedType,
        code: ZodIssueCode.invalid_type
      });
      return INVALID;
    }
    if (!__classPrivateFieldGet(this, _ZodNativeEnum_cache, "f")) {
      __classPrivateFieldSet(this, _ZodNativeEnum_cache, new Set(util.getValidEnumValues(this._def.values)), "f");
    }
    if (!__classPrivateFieldGet(this, _ZodNativeEnum_cache, "f").has(input.data)) {
      const expectedValues = util.objectValues(nativeEnumValues);
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode.invalid_enum_value,
        options: expectedValues
      });
      return INVALID;
    }
    return OK(input.data);
  }
  get enum() {
    return this._def.values;
  }
}
_ZodNativeEnum_cache = new WeakMap;
ZodNativeEnum.create = (values, params) => {
  return new ZodNativeEnum({
    values,
    typeName: ZodFirstPartyTypeKind.ZodNativeEnum,
    ...processCreateParams(params)
  });
};

class ZodPromise extends ZodType {
  unwrap() {
    return this._def.type;
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.promise && ctx.common.async === false) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.promise,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const promisified = ctx.parsedType === ZodParsedType.promise ? ctx.data : Promise.resolve(ctx.data);
    return OK(promisified.then((data) => {
      return this._def.type.parseAsync(data, {
        path: ctx.path,
        errorMap: ctx.common.contextualErrorMap
      });
    }));
  }
}
ZodPromise.create = (schema, params) => {
  return new ZodPromise({
    type: schema,
    typeName: ZodFirstPartyTypeKind.ZodPromise,
    ...processCreateParams(params)
  });
};

class ZodEffects extends ZodType {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    const effect = this._def.effect || null;
    const checkCtx = {
      addIssue: (arg) => {
        addIssueToContext(ctx, arg);
        if (arg.fatal) {
          status.abort();
        } else {
          status.dirty();
        }
      },
      get path() {
        return ctx.path;
      }
    };
    checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
    if (effect.type === "preprocess") {
      const processed = effect.transform(ctx.data, checkCtx);
      if (ctx.common.async) {
        return Promise.resolve(processed).then(async (processed2) => {
          if (status.value === "aborted")
            return INVALID;
          const result = await this._def.schema._parseAsync({
            data: processed2,
            path: ctx.path,
            parent: ctx
          });
          if (result.status === "aborted")
            return INVALID;
          if (result.status === "dirty")
            return DIRTY(result.value);
          if (status.value === "dirty")
            return DIRTY(result.value);
          return result;
        });
      } else {
        if (status.value === "aborted")
          return INVALID;
        const result = this._def.schema._parseSync({
          data: processed,
          path: ctx.path,
          parent: ctx
        });
        if (result.status === "aborted")
          return INVALID;
        if (result.status === "dirty")
          return DIRTY(result.value);
        if (status.value === "dirty")
          return DIRTY(result.value);
        return result;
      }
    }
    if (effect.type === "refinement") {
      const executeRefinement = (acc) => {
        const result = effect.refinement(acc, checkCtx);
        if (ctx.common.async) {
          return Promise.resolve(result);
        }
        if (result instanceof Promise) {
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        }
        return acc;
      };
      if (ctx.common.async === false) {
        const inner = this._def.schema._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (inner.status === "aborted")
          return INVALID;
        if (inner.status === "dirty")
          status.dirty();
        executeRefinement(inner.value);
        return { status: status.value, value: inner.value };
      } else {
        return this._def.schema._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx }).then((inner) => {
          if (inner.status === "aborted")
            return INVALID;
          if (inner.status === "dirty")
            status.dirty();
          return executeRefinement(inner.value).then(() => {
            return { status: status.value, value: inner.value };
          });
        });
      }
    }
    if (effect.type === "transform") {
      if (ctx.common.async === false) {
        const base = this._def.schema._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (!isValid(base))
          return base;
        const result = effect.transform(base.value, checkCtx);
        if (result instanceof Promise) {
          throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
        }
        return { status: status.value, value: result };
      } else {
        return this._def.schema._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx }).then((base) => {
          if (!isValid(base))
            return base;
          return Promise.resolve(effect.transform(base.value, checkCtx)).then((result) => ({ status: status.value, value: result }));
        });
      }
    }
    util.assertNever(effect);
  }
}
ZodEffects.create = (schema, effect, params) => {
  return new ZodEffects({
    schema,
    typeName: ZodFirstPartyTypeKind.ZodEffects,
    effect,
    ...processCreateParams(params)
  });
};
ZodEffects.createWithPreprocess = (preprocess, schema, params) => {
  return new ZodEffects({
    schema,
    effect: { type: "preprocess", transform: preprocess },
    typeName: ZodFirstPartyTypeKind.ZodEffects,
    ...processCreateParams(params)
  });
};

class ZodOptional extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType === ZodParsedType.undefined) {
      return OK(undefined);
    }
    return this._def.innerType._parse(input);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ZodOptional.create = (type, params) => {
  return new ZodOptional({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodOptional,
    ...processCreateParams(params)
  });
};

class ZodNullable extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType === ZodParsedType.null) {
      return OK(null);
    }
    return this._def.innerType._parse(input);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ZodNullable.create = (type, params) => {
  return new ZodNullable({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodNullable,
    ...processCreateParams(params)
  });
};

class ZodDefault extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    let data = ctx.data;
    if (ctx.parsedType === ZodParsedType.undefined) {
      data = this._def.defaultValue();
    }
    return this._def.innerType._parse({
      data,
      path: ctx.path,
      parent: ctx
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
ZodDefault.create = (type, params) => {
  return new ZodDefault({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodDefault,
    defaultValue: typeof params.default === "function" ? params.default : () => params.default,
    ...processCreateParams(params)
  });
};

class ZodCatch extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const newCtx = {
      ...ctx,
      common: {
        ...ctx.common,
        issues: []
      }
    };
    const result = this._def.innerType._parse({
      data: newCtx.data,
      path: newCtx.path,
      parent: {
        ...newCtx
      }
    });
    if (isAsync(result)) {
      return result.then((result2) => {
        return {
          status: "valid",
          value: result2.status === "valid" ? result2.value : this._def.catchValue({
            get error() {
              return new ZodError(newCtx.common.issues);
            },
            input: newCtx.data
          })
        };
      });
    } else {
      return {
        status: "valid",
        value: result.status === "valid" ? result.value : this._def.catchValue({
          get error() {
            return new ZodError(newCtx.common.issues);
          },
          input: newCtx.data
        })
      };
    }
  }
  removeCatch() {
    return this._def.innerType;
  }
}
ZodCatch.create = (type, params) => {
  return new ZodCatch({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodCatch,
    catchValue: typeof params.catch === "function" ? params.catch : () => params.catch,
    ...processCreateParams(params)
  });
};

class ZodNaN extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.nan) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.nan,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return { status: "valid", value: input.data };
  }
}
ZodNaN.create = (params) => {
  return new ZodNaN({
    typeName: ZodFirstPartyTypeKind.ZodNaN,
    ...processCreateParams(params)
  });
};
var BRAND = Symbol("zod_brand");

class ZodBranded extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const data = ctx.data;
    return this._def.type._parse({
      data,
      path: ctx.path,
      parent: ctx
    });
  }
  unwrap() {
    return this._def.type;
  }
}

class ZodPipeline extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.common.async) {
      const handleAsync = async () => {
        const inResult = await this._def.in._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (inResult.status === "aborted")
          return INVALID;
        if (inResult.status === "dirty") {
          status.dirty();
          return DIRTY(inResult.value);
        } else {
          return this._def.out._parseAsync({
            data: inResult.value,
            path: ctx.path,
            parent: ctx
          });
        }
      };
      return handleAsync();
    } else {
      const inResult = this._def.in._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
      if (inResult.status === "aborted")
        return INVALID;
      if (inResult.status === "dirty") {
        status.dirty();
        return {
          status: "dirty",
          value: inResult.value
        };
      } else {
        return this._def.out._parseSync({
          data: inResult.value,
          path: ctx.path,
          parent: ctx
        });
      }
    }
  }
  static create(a, b) {
    return new ZodPipeline({
      in: a,
      out: b,
      typeName: ZodFirstPartyTypeKind.ZodPipeline
    });
  }
}

class ZodReadonly extends ZodType {
  _parse(input) {
    const result = this._def.innerType._parse(input);
    const freeze = (data) => {
      if (isValid(data)) {
        data.value = Object.freeze(data.value);
      }
      return data;
    };
    return isAsync(result) ? result.then((data) => freeze(data)) : freeze(result);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ZodReadonly.create = (type, params) => {
  return new ZodReadonly({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodReadonly,
    ...processCreateParams(params)
  });
};
function custom(check, params = {}, fatal) {
  if (check)
    return ZodAny.create().superRefine((data, ctx) => {
      var _a, _b;
      if (!check(data)) {
        const p = typeof params === "function" ? params(data) : typeof params === "string" ? { message: params } : params;
        const _fatal = (_b = (_a = p.fatal) !== null && _a !== undefined ? _a : fatal) !== null && _b !== undefined ? _b : true;
        const p2 = typeof p === "string" ? { message: p } : p;
        ctx.addIssue({ code: "custom", ...p2, fatal: _fatal });
      }
    });
  return ZodAny.create();
}
var late = {
  object: ZodObject.lazycreate
};
var ZodFirstPartyTypeKind;
(function(ZodFirstPartyTypeKind2) {
  ZodFirstPartyTypeKind2["ZodString"] = "ZodString";
  ZodFirstPartyTypeKind2["ZodNumber"] = "ZodNumber";
  ZodFirstPartyTypeKind2["ZodNaN"] = "ZodNaN";
  ZodFirstPartyTypeKind2["ZodBigInt"] = "ZodBigInt";
  ZodFirstPartyTypeKind2["ZodBoolean"] = "ZodBoolean";
  ZodFirstPartyTypeKind2["ZodDate"] = "ZodDate";
  ZodFirstPartyTypeKind2["ZodSymbol"] = "ZodSymbol";
  ZodFirstPartyTypeKind2["ZodUndefined"] = "ZodUndefined";
  ZodFirstPartyTypeKind2["ZodNull"] = "ZodNull";
  ZodFirstPartyTypeKind2["ZodAny"] = "ZodAny";
  ZodFirstPartyTypeKind2["ZodUnknown"] = "ZodUnknown";
  ZodFirstPartyTypeKind2["ZodNever"] = "ZodNever";
  ZodFirstPartyTypeKind2["ZodVoid"] = "ZodVoid";
  ZodFirstPartyTypeKind2["ZodArray"] = "ZodArray";
  ZodFirstPartyTypeKind2["ZodObject"] = "ZodObject";
  ZodFirstPartyTypeKind2["ZodUnion"] = "ZodUnion";
  ZodFirstPartyTypeKind2["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
  ZodFirstPartyTypeKind2["ZodIntersection"] = "ZodIntersection";
  ZodFirstPartyTypeKind2["ZodTuple"] = "ZodTuple";
  ZodFirstPartyTypeKind2["ZodRecord"] = "ZodRecord";
  ZodFirstPartyTypeKind2["ZodMap"] = "ZodMap";
  ZodFirstPartyTypeKind2["ZodSet"] = "ZodSet";
  ZodFirstPartyTypeKind2["ZodFunction"] = "ZodFunction";
  ZodFirstPartyTypeKind2["ZodLazy"] = "ZodLazy";
  ZodFirstPartyTypeKind2["ZodLiteral"] = "ZodLiteral";
  ZodFirstPartyTypeKind2["ZodEnum"] = "ZodEnum";
  ZodFirstPartyTypeKind2["ZodEffects"] = "ZodEffects";
  ZodFirstPartyTypeKind2["ZodNativeEnum"] = "ZodNativeEnum";
  ZodFirstPartyTypeKind2["ZodOptional"] = "ZodOptional";
  ZodFirstPartyTypeKind2["ZodNullable"] = "ZodNullable";
  ZodFirstPartyTypeKind2["ZodDefault"] = "ZodDefault";
  ZodFirstPartyTypeKind2["ZodCatch"] = "ZodCatch";
  ZodFirstPartyTypeKind2["ZodPromise"] = "ZodPromise";
  ZodFirstPartyTypeKind2["ZodBranded"] = "ZodBranded";
  ZodFirstPartyTypeKind2["ZodPipeline"] = "ZodPipeline";
  ZodFirstPartyTypeKind2["ZodReadonly"] = "ZodReadonly";
})(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));
var instanceOfType = (cls, params = {
  message: `Input not instance of ${cls.name}`
}) => custom((data) => data instanceof cls, params);
var stringType = ZodString.create;
var numberType = ZodNumber.create;
var nanType = ZodNaN.create;
var bigIntType = ZodBigInt.create;
var booleanType = ZodBoolean.create;
var dateType = ZodDate.create;
var symbolType = ZodSymbol.create;
var undefinedType = ZodUndefined.create;
var nullType = ZodNull.create;
var anyType = ZodAny.create;
var unknownType = ZodUnknown.create;
var neverType = ZodNever.create;
var voidType = ZodVoid.create;
var arrayType = ZodArray.create;
var objectType = ZodObject.create;
var strictObjectType = ZodObject.strictCreate;
var unionType = ZodUnion.create;
var discriminatedUnionType = ZodDiscriminatedUnion.create;
var intersectionType = ZodIntersection.create;
var tupleType = ZodTuple.create;
var recordType = ZodRecord.create;
var mapType = ZodMap.create;
var setType = ZodSet.create;
var functionType = ZodFunction.create;
var lazyType = ZodLazy.create;
var literalType = ZodLiteral.create;
var enumType = ZodEnum.create;
var nativeEnumType = ZodNativeEnum.create;
var promiseType = ZodPromise.create;
var effectsType = ZodEffects.create;
var optionalType = ZodOptional.create;
var nullableType = ZodNullable.create;
var preprocessType = ZodEffects.createWithPreprocess;
var pipelineType = ZodPipeline.create;
var ostring = () => stringType().optional();
var onumber = () => numberType().optional();
var oboolean = () => booleanType().optional();
var coerce = {
  string: (arg) => ZodString.create({ ...arg, coerce: true }),
  number: (arg) => ZodNumber.create({ ...arg, coerce: true }),
  boolean: (arg) => ZodBoolean.create({
    ...arg,
    coerce: true
  }),
  bigint: (arg) => ZodBigInt.create({ ...arg, coerce: true }),
  date: (arg) => ZodDate.create({ ...arg, coerce: true })
};
var NEVER = INVALID;
var z = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: errorMap,
  setErrorMap,
  getErrorMap,
  makeIssue,
  EMPTY_PATH,
  addIssueToContext,
  ParseStatus,
  INVALID,
  DIRTY,
  OK,
  isAborted,
  isDirty,
  isValid,
  isAsync,
  get util() {
    return util;
  },
  get objectUtil() {
    return objectUtil;
  },
  ZodParsedType,
  getParsedType,
  ZodType,
  datetimeRegex,
  ZodString,
  ZodNumber,
  ZodBigInt,
  ZodBoolean,
  ZodDate,
  ZodSymbol,
  ZodUndefined,
  ZodNull,
  ZodAny,
  ZodUnknown,
  ZodNever,
  ZodVoid,
  ZodArray,
  ZodObject,
  ZodUnion,
  ZodDiscriminatedUnion,
  ZodIntersection,
  ZodTuple,
  ZodRecord,
  ZodMap,
  ZodSet,
  ZodFunction,
  ZodLazy,
  ZodLiteral,
  ZodEnum,
  ZodNativeEnum,
  ZodPromise,
  ZodEffects,
  ZodTransformer: ZodEffects,
  ZodOptional,
  ZodNullable,
  ZodDefault,
  ZodCatch,
  ZodNaN,
  BRAND,
  ZodBranded,
  ZodPipeline,
  ZodReadonly,
  custom,
  Schema: ZodType,
  ZodSchema: ZodType,
  late,
  get ZodFirstPartyTypeKind() {
    return ZodFirstPartyTypeKind;
  },
  coerce,
  any: anyType,
  array: arrayType,
  bigint: bigIntType,
  boolean: booleanType,
  date: dateType,
  discriminatedUnion: discriminatedUnionType,
  effect: effectsType,
  enum: enumType,
  function: functionType,
  instanceof: instanceOfType,
  intersection: intersectionType,
  lazy: lazyType,
  literal: literalType,
  map: mapType,
  nan: nanType,
  nativeEnum: nativeEnumType,
  never: neverType,
  null: nullType,
  nullable: nullableType,
  number: numberType,
  object: objectType,
  oboolean,
  onumber,
  optional: optionalType,
  ostring,
  pipeline: pipelineType,
  preprocess: preprocessType,
  promise: promiseType,
  record: recordType,
  set: setType,
  strictObject: strictObjectType,
  string: stringType,
  symbol: symbolType,
  transformer: effectsType,
  tuple: tupleType,
  undefined: undefinedType,
  union: unionType,
  unknown: unknownType,
  void: voidType,
  NEVER,
  ZodIssueCode,
  quotelessJson,
  ZodError
});

// src/hooks/form-validation/use-dob-zod-schema.ts
var useDobZodSchema = (withMinimumAge = true) => {
  const { t } = useTranslation2("pds");
  return z.string().regex(/^\d{2}\/\d{2}\/\d{4}$/, {
    message: t("common.formErrors.dob.invalid")
  }).superRefine((val, ctx) => {
    const dayParts = val.split("/");
    const month = Number.parseInt(dayParts[0], 10);
    const day = Number.parseInt(dayParts[1], 10);
    const year = Number.parseInt(dayParts[2], 10);
    if (Number.isNaN(day) || Number.isNaN(month) || Number.isNaN(year)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: t("common.formErrors.dob.required"),
        fatal: true
      });
      return z.NEVER;
    }
  }).superRefine((val, ctx) => {
    const dayParts = val.split("/");
    const month = Number.parseInt(dayParts[0], 10);
    const day = Number.parseInt(dayParts[1], 10);
    const year = Number.parseInt(dayParts[2], 10);
    if (day < 1 || day > 31 || month < 1 || month > 12 || year < 1900) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: t("common.formErrors.dob.invalid"),
        fatal: true
      });
      return z.NEVER;
    }
  }).superRefine((val, ctx) => {
    if (!withMinimumAge) {
      return;
    }
    const dayParts = val.split("/");
    const month = Number.parseInt(dayParts[0], 10);
    const day = Number.parseInt(dayParts[1], 10);
    const year = Number.parseInt(dayParts[2], 10);
    const today = new Date;
    const minimumAge = new Date(today.getFullYear() - 13, today.getMonth(), today.getDate());
    const dob = new Date(Number(year), Number(month) - 1, Number(day)).getTime();
    if (minimumAge.getTime() - dob <= 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: t("common.formErrors.dob.tooYoung"),
        fatal: true
      });
      return z.NEVER;
    }
  }).superRefine((val, ctx) => {
    const dayParts = val.split("/");
    const month = Number.parseInt(dayParts[0], 10);
    const day = Number.parseInt(dayParts[1], 10);
    const year = Number.parseInt(dayParts[2], 10);
    const today = new Date;
    const dob = new Date(Number(year), Number(month) - 1, Number(day)).getTime();
    if (today.getTime() - dob <= 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: t("common.formErrors.dob.future"),
        fatal: true
      });
      return z.NEVER;
    }
  });
};

// src/hooks/form-validation/use-full-name-field-validation.ts
import { useEffect as useEffect3 } from "react";
import { useTranslation as useTranslation3 } from "react-i18next";
var useFullNameFieldValidation = (form) => {
  const { t } = useTranslation3("pds");
  useEffect3(() => {
    if (form.errors.firstName || form.errors.lastName) {
      form.setFieldError("name", t("common.formErrors.name.required"));
      return;
    }
    form.clearFieldError("name");
  }, [form.errors.firstName, form.errors.lastName]);
};

// src/hooks/form-validation/use-name-zod-schema.ts
var NAME_REGEX = /^([a-zA-Z0-9.\- "']|[à-ú]|[À-Ú])+$/;
var useNameZodSchema = () => {
  return z.string().trim().min(1).regex(NAME_REGEX);
};
// src/hooks/layout/use-is-mobile.ts
var useIsMobile = (breakpoint = "sm") => {
  const theme2 = useMantineTheme();
  return useMediaQuery(`(max-width: calc(${theme2.breakpoints[breakpoint]} - 1px))`);
};

// src/hooks/layout/use-safe-scroll-top.ts
import { useEffect as useEffect4, useRef as useRef6 } from "react";
var useSafeScrollTop = (active) => {
  const scrollXRef = useRef6(-1);
  const scrollYRef = useRef6(-1);
  useEffect4(() => {
    if (active) {
      scrollXRef.current = window.scrollX;
      scrollYRef.current = window.scrollY;
      window.scroll({ top: 0, left: 0, behavior: "instant" });
      return;
    }
    if (scrollXRef.current !== -1 && scrollYRef.current !== -1) {
      window.scroll({
        top: scrollYRef.current,
        left: scrollXRef.current,
        behavior: "instant"
      });
      scrollXRef.current = -1;
      scrollYRef.current = -1;
    }
  }, [active]);
};
// src/hooks/mantine-passthroughs/index.ts
import {
  getHotkeyHandler,
  useClickOutside,
  useDebouncedCallback,
  useDebouncedState,
  useDebouncedValue,
  useDisclosure,
  useFocusWithin,
  useHotkeys,
  useHover,
  useId,
  useIdle,
  useMediaQuery,
  useToggle,
  useViewportSize,
  useWindowScroll
} from "@mantine/hooks";
// src/components/accordion/Accordion.tsx
import { Accordion as MantineAccordion } from "@mantine/core";

// src/components/card/BaseCard.tsx
import {
  Card as MantineCard
} from "@mantine/core";

// src/components/card/internal/CardContents.tsx
import { Fragment as Fragment2 } from "react";

// src/components/avatar/Avatar.tsx
import { Avatar as MantineAvatar, Text } from "@mantine/core";
import { useEffect as useEffect5, useState as useState6 } from "react";

// ../../../node_modules/@material-symbols/svg-700/outlined/add-fill.svg
import * as React from "react";
import { jsx as jsx3 } from "react/jsx-runtime";
var SvgComponent = (props) => /* @__PURE__ */ jsx3("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx3("path", {
    d: "M433-433H175v-94h258v-259h94v259h259v94H527v258h-94v-258Z"
  })
});
var add_fill_default = SvgComponent;

// ../../../node_modules/@material-symbols/svg-700/outlined/add.svg
import * as React2 from "react";
import { jsx as jsx4 } from "react/jsx-runtime";
var SvgComponent2 = (props) => /* @__PURE__ */ jsx4("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx4("path", {
    d: "M433-433H175v-94h258v-259h94v259h259v94H527v258h-94v-258Z"
  })
});
var add_default = SvgComponent2;

// ../../../node_modules/@material-symbols/svg-700/rounded/add-fill.svg
import * as React3 from "react";
import { jsx as jsx5 } from "react/jsx-runtime";
var SvgComponent3 = (props) => /* @__PURE__ */ jsx5("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx5("path", {
    d: "M433-433H222q-19.75 0-33.37-13.68Q175-460.35 175-480.18q0-19.82 13.63-33.32Q202.25-527 222-527h211v-211q0-19.63 13.68-33.81Q460.35-786 480.18-786q19.82 0 33.32 14.19Q527-757.63 527-738v211h211q19.63 0 33.81 13.68Q786-499.65 786-479.82q0 19.82-14.19 33.32Q757.63-433 738-433H527v211q0 19.75-13.68 33.37Q499.65-175 479.82-175q-19.82 0-33.32-13.63Q433-202.25 433-222v-211Z"
  })
});
var add_fill_default2 = SvgComponent3;

// ../../../node_modules/@material-symbols/svg-700/rounded/add.svg
import * as React4 from "react";
import { jsx as jsx6 } from "react/jsx-runtime";
var SvgComponent4 = (props) => /* @__PURE__ */ jsx6("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx6("path", {
    d: "M433-433H222q-19.75 0-33.37-13.68Q175-460.35 175-480.18q0-19.82 13.63-33.32Q202.25-527 222-527h211v-211q0-19.63 13.68-33.81Q460.35-786 480.18-786q19.82 0 33.32 14.19Q527-757.63 527-738v211h211q19.63 0 33.81 13.68Q786-499.65 786-479.82q0 19.82-14.19 33.32Q757.63-433 738-433H527v211q0 19.75-13.68 33.37Q499.65-175 479.82-175q-19.82 0-33.32-13.63Q433-202.25 433-222v-211Z"
  })
});
var add_default2 = SvgComponent4;

// ../../../node_modules/@material-symbols/svg-700/sharp/add-fill.svg
import * as React5 from "react";
import { jsx as jsx7 } from "react/jsx-runtime";
var SvgComponent5 = (props) => /* @__PURE__ */ jsx7("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx7("path", {
    d: "M433-433H175v-94h258v-259h94v259h259v94H527v258h-94v-258Z"
  })
});
var add_fill_default3 = SvgComponent5;

// ../../../node_modules/@material-symbols/svg-700/sharp/add.svg
import * as React6 from "react";
import { jsx as jsx8 } from "react/jsx-runtime";
var SvgComponent6 = (props) => /* @__PURE__ */ jsx8("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx8("path", {
    d: "M433-433H175v-94h258v-259h94v259h259v94H527v258h-94v-258Z"
  })
});
var add_default3 = SvgComponent6;

// src/components/icon/variants/IconAdd.tsx
import { useTranslation as useTranslation4 } from "react-i18next";

// src/components/icon/Icon.tsx
import { jsx as jsx9 } from "react/jsx-runtime";
var DEFAULT_VARIANT = "rounded";
var Icon = ({
  color = "currentColor",
  style = {},
  SvgIcon,
  height = rem("24px"),
  width = rem("24px"),
  alt
}) => {
  const theme2 = useMantineTheme();
  const iconColor = theme2.other.getIconColor(color);
  return /* @__PURE__ */ jsx9(SvgIcon, {
    fill: iconColor,
    style: {
      ...style,
      height,
      width,
      minHeight: height,
      minWidth: width
    },
    "data-testid": "icon",
    "aria-label": alt
  });
};

// src/components/icon/variants/IconAdd.tsx
import { jsx as jsx10 } from "react/jsx-runtime";
var componentMap = {
  outlined: add_default,
  "outlined-fill": add_fill_default,
  rounded: add_default2,
  "rounded-fill": add_fill_default2,
  sharp: add_default3,
  "sharp-fill": add_fill_default3
};
var IconAdd = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation4("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap[key] ?? componentMap[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx10(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// src/components/icon/variants/IconAdminMeds.tsx
import { useTranslation as useTranslation5 } from "react-i18next";

// src/components/icon/static/admin-meds.svg
import * as React7 from "react";
import { jsx as jsx11 } from "react/jsx-runtime";
var SvgComponent7 = (props) => /* @__PURE__ */ jsx11("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /* @__PURE__ */ jsx11("path", {
    d: "M12.7147 16.7152C12.0253 17.4058 11.1893 17.7511 10.2068 17.7511C9.2244 17.7511 8.38788 17.4062 7.6973 16.7164C7.00672 16.0266 6.66142 15.1945 6.66142 14.2202C6.66142 13.2459 7.00672 12.4134 7.6973 11.7228L11.7098 7.69132C12.4003 7.00074 13.2375 6.65545 14.2214 6.65545C15.2053 6.65545 16.0426 7.00035 16.7332 7.69015C17.4237 8.37993 17.769 9.212 17.769 10.1863C17.769 11.1607 17.4237 11.9931 16.7332 12.6837L12.7147 16.7152ZM9.25272 15.1348C9.59222 15.4743 9.9502 15.6038 10.3266 15.5234C10.7031 15.4429 10.9723 15.3217 11.1342 15.1598L12.3777 13.8913L10.5152 12.0288L9.25272 13.2783C8.98932 13.5412 8.85763 13.8505 8.85763 14.2061C8.85763 14.5618 8.98932 14.8714 9.25272 15.1348ZM15.1718 9.27175C14.8323 8.93227 14.4743 8.80174 14.0979 8.88017C13.7214 8.95862 13.4522 9.08082 13.2902 9.24675L12.0408 10.5212L13.9033 12.3837L15.1718 11.1283C15.4312 10.8649 15.5619 10.5555 15.5639 10.2C15.5659 9.84459 15.4352 9.53517 15.1718 9.27175ZM5.27502 21.4065C4.64939 21.4065 4.11382 21.1838 3.6683 20.7382C3.22277 20.2927 3 19.7572 3 19.1315V5.27502C3 4.64939 3.22277 4.11382 3.6683 3.6683C4.11382 3.22277 4.64939 3 5.27502 3H9.27772C9.52229 2.39203 9.90871 1.90671 10.437 1.54402C10.9652 1.18134 11.554 1 12.2033 1C12.8526 1 13.4413 1.18134 13.9696 1.54402C14.4978 1.90671 14.8843 2.39203 15.1288 3H19.1315C19.7572 3 20.2927 3.22277 20.7382 3.6683C21.1838 4.11382 21.4065 4.64939 21.4065 5.27502V19.1315C21.4065 19.7572 21.1838 20.2927 20.7382 20.7382C20.2927 21.1838 19.7572 21.4065 19.1315 21.4065H5.27502ZM5.27502 19.1315H19.1315V5.27502H5.27502V19.1315ZM12.2033 4.5011C12.4338 4.5011 12.6244 4.42575 12.7751 4.27505C12.9258 4.12435 13.0011 3.93376 13.0011 3.70327C13.0011 3.47279 12.9258 3.2822 12.7751 3.1315C12.6244 2.9808 12.4338 2.90545 12.2033 2.90545C11.9728 2.90545 11.7822 2.9808 11.6315 3.1315C11.4808 3.2822 11.4055 3.47279 11.4055 3.70327C11.4055 3.93376 11.4808 4.12435 11.6315 4.27505C11.7822 4.42575 11.9728 4.5011 12.2033 4.5011Z"
  })
});
var admin_meds_default = SvgComponent7;

// src/components/icon/variants/IconAdminMeds.tsx
import { jsx as jsx12 } from "react/jsx-runtime";
var IconAdminMeds = ({
  color,
  height,
  style = {},
  width
}) => {
  const { t } = useTranslation5("pds");
  return /* @__PURE__ */ jsx12(Icon, {
    SvgIcon: admin_meds_default,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/approval_delegation-fill.svg
import * as React8 from "react";
import { jsx as jsx13 } from "react/jsx-runtime";
var SvgComponent8 = (props) => /* @__PURE__ */ jsx13("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx13("path", {
    d: "M245-103v-391h94q8 0 16.5 1.5T372-488l218 81q42 16 71 48t29 76q0 1-.5 3t-3.5 2h-81q-34 0-68-5.5T471-299l-78-22-15 42 71 24q39 13 80 17.5t84 4.5h177q50 0 83 40.5t33 91.5L569-9l-324-94ZM19-55v-439h165v439H19Zm541-504L372-748l67-67 121 122 234-233 67 65-301 302Z"
  })
});
var approval_delegation_fill_default = SvgComponent8;

// ../../../node_modules/@material-symbols/svg-700/outlined/approval_delegation.svg
import * as React9 from "react";
import { jsx as jsx14 } from "react/jsx-runtime";
var SvgComponent9 = (props) => /* @__PURE__ */ jsx14("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx14("path", {
    d: "M560-559 372-748l67-67 121 122 234-233 67 65-301 302ZM269-195l296 88 248-78q0-20-15.5-33.5T761-232H545q-10 0-24.83-2.5-14.82-2.5-30.17-7.18L394-270l21-61 101 34q7 3 16 4.5t20 .5h56q0-21-14-36.5T560-352l-218-83h-73v240ZM20-55v-463h319q8 0 16.5 1.5T373-512l215 81q44 17 75 53.5t31 85.5h67q60.58 0 102.79 33.5Q906-225 906-167v43L570-21l-301-87v53H20Zm83-82h82v-298h-82v298Z"
  })
});
var approval_delegation_default = SvgComponent9;

// ../../../node_modules/@material-symbols/svg-700/rounded/approval_delegation-fill.svg
import * as React10 from "react";
import { jsx as jsx15 } from "react/jsx-runtime";
var SvgComponent10 = (props) => /* @__PURE__ */ jsx15("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx15("path", {
    d: "m542-17-297-86v-391h94q9 0 17 1.5t16 4.5l218 81q44 17 72 52.5t28 71.5q0 1-.5 3t-3.5 2h-81q-36 0-68-5t-66-16l-53-15q-11-3-20 0t-13 14q-3 10 2 18t14 11l48 16q27 9 66.5 15.5T613-233h157q74 0 105 31.5T906-101L594-16q-14 3-26 3t-26-4ZM19-120v-308q0-27 19.5-46.5T85-494h34q27 0 46 19.5t19 46.5v308q0 27-19 46t-46 19H85q-27 0-46.5-19T19-120Zm541-573 202-201q14-14 33-13.5t33 13.5q14 14 14 33.5T828-827L594-593q-14 15-34 15t-34-15L405-715q-14-14-14.5-32.5T404-781q14-14 34-14t34 14l88 88Z"
  })
});
var approval_delegation_fill_default2 = SvgComponent10;

// ../../../node_modules/@material-symbols/svg-700/rounded/approval_delegation.svg
import * as React11 from "react";
import { jsx as jsx16 } from "react/jsx-runtime";
var SvgComponent11 = (props) => /* @__PURE__ */ jsx16("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx16("path", {
    d: "m560-693 202-201q14-14 33-13.5t33 13.5q14 14 14 33.5T828-827L594-593q-14.73 15-34.36 15Q540-578 526-593L405-715q-14-14-14.5-32.5T404-781q14-14 34-14t34 14l88 88Zm5 586 248-78q0-20-15.5-34T761-232H545q-10 1-24.83-2-14.82-3-30.17-7.94l-66-19.83q-12-2.95-18-15.14-6-12.18-2-24.38 4-11.85 15.5-17.78Q431-325 443-320l73 23q7 3 16.24 4.43 9.23 1.43 19.87.57h55.96-.07q0-21-14-36.5T560-352l-218-83h-73v240l296 88Zm-23 78-273-79q-9 28-37 40.5T175-55h-61q-39.03 0-66.51-27.49Q20-109.97 20-149v-275q0-39.02 27.49-66.51Q74.97-518 114-518h225q8 0 16.5 1.5T373-512l215 81q48 19 77 54.5t29 84.5h67q60.58 0 102.79 33.5Q906-225 906-167q0 18.72-10.5 33.86T870-113L596-29q-13 3-27 3t-27-3ZM103-137h82v-298h-82v298Z"
  })
});
var approval_delegation_default2 = SvgComponent11;

// ../../../node_modules/@material-symbols/svg-700/sharp/approval_delegation-fill.svg
import * as React12 from "react";
import { jsx as jsx17 } from "react/jsx-runtime";
var SvgComponent12 = (props) => /* @__PURE__ */ jsx17("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx17("path", {
    d: "M560-559 372-748l67-67 121 122 234-233 67 65-301 302ZM19-55v-439h165v439H19Zm549 45-323-92v-392h110l327 121v95H534l-142-45-14 43 136 47h391v132L568-10Z"
  })
});
var approval_delegation_fill_default3 = SvgComponent12;

// ../../../node_modules/@material-symbols/svg-700/sharp/approval_delegation.svg
import * as React13 from "react";
import { jsx as jsx18 } from "react/jsx-runtime";
var SvgComponent13 = (props) => /* @__PURE__ */ jsx18("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx18("path", {
    d: "M560-559 372-748l67-67 121 122 234-233 67 65-301 302Zm8 538-299-87v53H20v-439h336l338 126v90h212v154L568-21ZM102-137h83v-274h-83v274Zm462 30 256-78v-33H518l-126-40 22-58 115 38h77v-32L341-411h-72v216l295 88Z"
  })
});
var approval_delegation_default3 = SvgComponent13;

// src/components/icon/variants/IconApprovalDelegation.tsx
import { useTranslation as useTranslation6 } from "react-i18next";
import { jsx as jsx19 } from "react/jsx-runtime";
var componentMap2 = {
  outlined: approval_delegation_default,
  "outlined-fill": approval_delegation_fill_default,
  rounded: approval_delegation_default2,
  "rounded-fill": approval_delegation_fill_default2,
  sharp: approval_delegation_default3,
  "sharp-fill": approval_delegation_fill_default3
};
var IconApprovalDelegation = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation6("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap2[key] ?? componentMap2[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx19(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/archive-fill.svg
import * as React14 from "react";
import { jsx as jsx20 } from "react/jsx-runtime";
var SvgComponent14 = (props) => /* @__PURE__ */ jsx20("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx20("path", {
    d: "M480.5-279 638-437l-53-54-65 65v-150h-80v150l-65-64-52 54 157.5 157ZM189-95q-39.8 0-66.9-27.1Q95-149.2 95-189v-493q0-15.88 5.5-31.06Q106-728.24 116-741l73-92q12.75-16.03 30.82-24.52Q237.88-866 258-866h444q19.09 0 37.16 8.48Q757.24-849.03 770-833l75 92q9 12.76 15 27.94 6 15.18 6 31.06v493q0 39.8-27.39 66.9Q811.21-95 771-95H189Zm34-631h513l-36.41-46H259l-36 46Z"
  })
});
var archive_fill_default = SvgComponent14;

// ../../../node_modules/@material-symbols/svg-700/outlined/archive.svg
import * as React15 from "react";
import { jsx as jsx21 } from "react/jsx-runtime";
var SvgComponent15 = (props) => /* @__PURE__ */ jsx21("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx21("path", {
    d: "M480.5-279 638-437l-53-54-65 65v-150h-80v150l-65-64-52 54 157.5 157ZM189-639v450h582v-450H189Zm0 544q-39.8 0-66.9-27.1Q95-149.2 95-189v-493q0-15.88 5.5-31.06Q106-728.24 116-741l73-92q12.75-16.03 30.61-24.52Q237.47-866 258-866h444q19.5 0 37.37 8.48Q757.24-849.03 770-833l75 92q9 12.76 15 27.94 6 15.18 6 31.06v493q0 39.8-27.39 66.9Q811.21-95 771-95H189Zm34-631h513l-36.41-46H259l-36 46Zm257 312Z"
  })
});
var archive_default = SvgComponent15;

// ../../../node_modules/@material-symbols/svg-700/rounded/archive-fill.svg
import * as React16 from "react";
import { jsx as jsx22 } from "react/jsx-runtime";
var SvgComponent16 = (props) => /* @__PURE__ */ jsx22("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx22("path", {
    d: "M189-95q-39.8 0-66.9-27.1Q95-149.2 95-189v-493q0-15.88 5.5-31.06Q106-728.24 116-741l73-92q12.75-16.03 30.82-24.52Q237.88-866 258-866h444q19.09 0 37.16 8.48Q757.24-849.03 770-833l75 92q9 12.76 15 27.94 6 15.18 6 31.06v493q0 39.8-27.39 66.9Q811.21-95 771-95H189Zm34-631h513l-36.41-46H259l-36 46Zm256.63 150q-16.63 0-28.13 11.76Q440-552.47 440-536v125l-46-46q-11.09-11-26.04-10.5Q353-467 341-454.64q-11 11.35-10.5 26.49.5 15.13 11.5 26.15l104 105q14 14 33.5 14t33.5-14l106-106q11-11.09 11-26.54Q630-445 618.14-457q-10.37-11-25.75-11Q577-468 566-457l-46 46v-125q0-16.47-11.87-28.24Q496.26-576 479.63-576Z"
  })
});
var archive_fill_default2 = SvgComponent16;

// ../../../node_modules/@material-symbols/svg-700/rounded/archive.svg
import * as React17 from "react";
import { jsx as jsx23 } from "react/jsx-runtime";
var SvgComponent17 = (props) => /* @__PURE__ */ jsx23("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx23("path", {
    d: "M479.63-576q-16.63 0-28.13 11.76Q440-552.47 440-536v125l-46-46q-11.09-11-26.04-10.5Q353-467 341-454.64q-11 11.35-10.5 26.49.5 15.13 11.5 26.15l104 105q14 14 33.5 14t33.5-14l106-106q11-11.09 11-26.54Q630-445 618.14-457q-10.37-11-25.75-11Q577-468 566-457l-46 46v-125q0-16.47-11.87-28.24Q496.26-576 479.63-576ZM189-639v450h582v-450H189Zm0 544q-39.8 0-66.9-27.1Q95-149.2 95-189v-493q0-15.88 5.5-31.06Q106-728.24 116-741l73-92q12.75-16.03 30.82-24.52Q237.88-866 258-866h444q19.09 0 37.16 8.48Q757.24-849.03 770-833l75 92q9 12.76 15 27.94 6 15.18 6 31.06v493q0 39.8-27.39 66.9Q811.21-95 771-95H189Zm34-631h513l-36.41-46H259l-36 46Zm257 312Z"
  })
});
var archive_default2 = SvgComponent17;

// ../../../node_modules/@material-symbols/svg-700/sharp/archive-fill.svg
import * as React18 from "react";
import { jsx as jsx24 } from "react/jsx-runtime";
var SvgComponent18 = (props) => /* @__PURE__ */ jsx24("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx24("path", {
    d: "m480-279 158-158-53-54-65 65v-150h-80v150l-65-64-52 54 157 157ZM95-95v-621l121-150h528l122 150v621H95Zm128-631h513l-36-46H259l-36 46Z"
  })
});
var archive_fill_default3 = SvgComponent18;

// ../../../node_modules/@material-symbols/svg-700/sharp/archive.svg
import * as React19 from "react";
import { jsx as jsx25 } from "react/jsx-runtime";
var SvgComponent19 = (props) => /* @__PURE__ */ jsx25("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx25("path", {
    d: "m480-279 158-158-53-54-65 65v-150h-80v150l-65-64-52 54 157 157ZM189-639v450h582v-450H189ZM95-95v-621l121-150h528l122 150v621H95Zm128-631h513l-36-46H259l-36 46Zm257 312Z"
  })
});
var archive_default3 = SvgComponent19;

// src/components/icon/variants/IconArchive.tsx
import { useTranslation as useTranslation7 } from "react-i18next";
import { jsx as jsx26 } from "react/jsx-runtime";
var componentMap3 = {
  outlined: archive_default,
  "outlined-fill": archive_fill_default,
  rounded: archive_default2,
  "rounded-fill": archive_fill_default2,
  sharp: archive_default3,
  "sharp-fill": archive_fill_default3
};
var IconArchive = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation7("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap3[key] ?? componentMap3[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx26(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/assignment-fill.svg
import * as React20 from "react";
import { jsx as jsx27 } from "react/jsx-runtime";
var SvgComponent20 = (props) => /* @__PURE__ */ jsx27("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx27("path", {
    d: "M189-95q-39.03 0-66.51-27.49Q95-149.97 95-189v-582q0-39.44 27.49-67.22Q149.97-866 189-866h180q11-35 41-57.5t70-22.5q40 0 70 22.5t41 57.5h180q39.44 0 67.22 27.78T866-771v582q0 39.03-27.78 66.51Q810.44-95 771-95H189Zm100-194h262v-60H289v60Zm0-161h382v-60H289v60Zm0-161h382v-60H289v60Zm191-180q17.47 0 29.23-11.77Q521-814.53 521-832t-11.77-29.23Q497.47-873 480-873t-29.23 11.77Q439-849.47 439-832t11.77 29.23Q462.53-791 480-791Z"
  })
});
var assignment_fill_default = SvgComponent20;

// ../../../node_modules/@material-symbols/svg-700/outlined/assignment.svg
import * as React21 from "react";
import { jsx as jsx28 } from "react/jsx-runtime";
var SvgComponent21 = (props) => /* @__PURE__ */ jsx28("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx28("path", {
    d: "M189-95q-38.78 0-66.39-27.61T95-189v-582q0-39.19 27.61-67.09Q150.22-866 189-866h180q11-35 41-57.5t70-22.5q40 0 70 22.5t41 57.5h180q39.19 0 67.09 27.91Q866-810.19 866-771v582q0 38.78-27.91 66.39Q810.19-95 771-95H189Zm0-94h582v-582H189v582Zm100-100h262v-60H289v60Zm0-161h382v-60H289v60Zm0-161h382v-60H289v60Zm191-180q17.47 0 29.23-11.77Q521-814.53 521-832t-11.77-29.23Q497.47-873 480-873t-29.23 11.77Q439-849.47 439-832t11.77 29.23Q462.53-791 480-791ZM189-189v-582 582Z"
  })
});
var assignment_default = SvgComponent21;

// ../../../node_modules/@material-symbols/svg-700/rounded/assignment-fill.svg
import * as React22 from "react";
import { jsx as jsx29 } from "react/jsx-runtime";
var SvgComponent22 = (props) => /* @__PURE__ */ jsx29("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx29("path", {
    d: "M189-95q-38.78 0-66.39-27.61T95-189v-582q0-39.19 27.61-67.09Q150.22-866 189-866h180q11-35 41-57.5t70-22.5q40 0 70 22.5t41 57.5h180q39.19 0 67.09 27.91Q866-810.19 866-771v582q0 38.78-27.91 66.39Q810.19-95 771-95H189Zm130.29-194h201.42q13.04 0 21.67-8.68 8.62-8.67 8.62-21.5 0-12.82-8.62-21.32-8.63-8.5-21.67-8.5H319.29q-13.04 0-21.66 8.68-8.63 8.67-8.63 21.5 0 12.82 8.63 21.32 8.62 8.5 21.66 8.5Zm0-161h321.42q13.04 0 21.67-8.68 8.62-8.67 8.62-21.5 0-12.82-8.62-21.32-8.63-8.5-21.67-8.5H319.29q-13.04 0-21.66 8.68-8.63 8.67-8.63 21.5 0 12.82 8.63 21.32 8.62 8.5 21.66 8.5Zm0-161h321.42q13.04 0 21.67-8.68 8.62-8.67 8.62-21.5 0-12.82-8.62-21.32-8.63-8.5-21.67-8.5H319.29q-13.04 0-21.66 8.68-8.63 8.67-8.63 21.5 0 12.82 8.63 21.32 8.62 8.5 21.66 8.5ZM480-791q17.47 0 29.23-11.77Q521-814.53 521-832t-11.77-29.23Q497.47-873 480-873t-29.23 11.77Q439-849.47 439-832t11.77 29.23Q462.53-791 480-791Z"
  })
});
var assignment_fill_default2 = SvgComponent22;

// ../../../node_modules/@material-symbols/svg-700/rounded/assignment.svg
import * as React23 from "react";
import { jsx as jsx30 } from "react/jsx-runtime";
var SvgComponent23 = (props) => /* @__PURE__ */ jsx30("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx30("path", {
    d: "M189-95q-38.78 0-66.39-27.61T95-189v-582q0-39.19 27.61-67.09Q150.22-866 189-866h180q11-35 41-57.5t70-22.5q40 0 70 22.5t41 57.5h180q39.19 0 67.09 27.91Q866-810.19 866-771v582q0 38.78-27.91 66.39Q810.19-95 771-95H189Zm0-94h582v-582H189v582Zm130.29-100h201.42q13.04 0 21.67-8.68 8.62-8.67 8.62-21.5 0-12.82-8.62-21.32-8.63-8.5-21.67-8.5H319.29q-13.04 0-21.66 8.68-8.63 8.67-8.63 21.5 0 12.82 8.63 21.32 8.62 8.5 21.66 8.5Zm0-161h321.42q13.04 0 21.67-8.68 8.62-8.67 8.62-21.5 0-12.82-8.62-21.32-8.63-8.5-21.67-8.5H319.29q-13.04 0-21.66 8.68-8.63 8.67-8.63 21.5 0 12.82 8.63 21.32 8.62 8.5 21.66 8.5Zm0-161h321.42q13.04 0 21.67-8.68 8.62-8.67 8.62-21.5 0-12.82-8.62-21.32-8.63-8.5-21.67-8.5H319.29q-13.04 0-21.66 8.68-8.63 8.67-8.63 21.5 0 12.82 8.63 21.32 8.62 8.5 21.66 8.5ZM480-791q17.47 0 29.23-11.77Q521-814.53 521-832t-11.77-29.23Q497.47-873 480-873t-29.23 11.77Q439-849.47 439-832t11.77 29.23Q462.53-791 480-791ZM189-189v-582 582Z"
  })
});
var assignment_default2 = SvgComponent23;

// ../../../node_modules/@material-symbols/svg-700/sharp/assignment-fill.svg
import * as React24 from "react";
import { jsx as jsx31 } from "react/jsx-runtime";
var SvgComponent24 = (props) => /* @__PURE__ */ jsx31("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx31("path", {
    d: "M95-95v-771h274q11-35 41-57.5t70-22.5q40 0 70 22.5t41 57.5h275v771H95Zm194-194h262v-60H289v60Zm0-161h382v-60H289v60Zm0-161h382v-60H289v60Zm191-180q17.47 0 29.23-11.77Q521-814.53 521-832t-11.77-29.23Q497.47-873 480-873t-29.23 11.77Q439-849.47 439-832t11.77 29.23Q462.53-791 480-791Z"
  })
});
var assignment_fill_default3 = SvgComponent24;

// ../../../node_modules/@material-symbols/svg-700/sharp/assignment.svg
import * as React25 from "react";
import { jsx as jsx32 } from "react/jsx-runtime";
var SvgComponent25 = (props) => /* @__PURE__ */ jsx32("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx32("path", {
    d: "M95-95v-771h274q11-35 41-57.5t70-22.5q40 0 70 22.5t41 57.5h275v771H95Zm94-94h582v-582H189v582Zm100-100h262v-60H289v60Zm0-161h382v-60H289v60Zm0-161h382v-60H289v60Zm191-180q17.47 0 29.23-11.77Q521-814.53 521-832t-11.77-29.23Q497.47-873 480-873t-29.23 11.77Q439-849.47 439-832t11.77 29.23Q462.53-791 480-791ZM189-189v-582 582Z"
  })
});
var assignment_default3 = SvgComponent25;

// src/components/icon/variants/IconAssignment.tsx
import { useTranslation as useTranslation8 } from "react-i18next";
import { jsx as jsx33 } from "react/jsx-runtime";
var componentMap4 = {
  outlined: assignment_default,
  "outlined-fill": assignment_fill_default,
  rounded: assignment_default2,
  "rounded-fill": assignment_fill_default2,
  sharp: assignment_default3,
  "sharp-fill": assignment_fill_default3
};
var IconAssignment = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation8("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap4[key] ?? componentMap4[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx33(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/badge-fill.svg
import * as React26 from "react";
import { jsx as jsx34 } from "react/jsx-runtime";
var SvgComponent26 = (props) => /* @__PURE__ */ jsx34("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx34("path", {
    d: "M149-55q-39.05 0-66.53-27.47Q55-109.95 55-149v-462q0-39.46 27.47-67.23Q109.95-706 149-706h216v-122q0-34 21.38-56 21.39-22 57.12-22H518q34 0 56 22t22 56v122h215q39.46 0 67.23 27.77Q906-650.46 906-611v462q0 39.05-27.77 66.53Q850.46-55 811-55H149Zm83-183h239v-14q0-18-9-32t-23-19q-32-11-50-14.5t-35-3.5q-19 0-40.5 4.5T265-303q-15 5-24 19t-9 32v14Zm336-67h170v-50H568v50Zm-214-50q23 0 38.5-15.5T408-409q0-23-15.5-38.5T354-463q-23 0-38.5 15.5T300-409q0 23 15.5 38.5T354-355Zm214-63h170v-50H568v50ZM452-608h57v-211h-57v211Z"
  })
});
var badge_fill_default = SvgComponent26;

// ../../../node_modules/@material-symbols/svg-700/outlined/badge.svg
import * as React27 from "react";
import { jsx as jsx35 } from "react/jsx-runtime";
var SvgComponent27 = (props) => /* @__PURE__ */ jsx35("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx35("path", {
    d: "M149-55q-39.05 0-66.53-27.47Q55-109.95 55-149v-462q0-39.46 27.47-67.23Q109.95-706 149-706h216v-122q0-34 21.38-56 21.39-22 57.53-22h73.68Q552-906 574-884t22 56v122h215q39.46 0 67.23 27.77Q906-650.46 906-611v462q0 39.05-27.77 66.53Q850.46-55 811-55H149Zm0-94h662v-462H594v30q-4 30-27.5 45t-48.91 15h-74.18Q417-521 393-536.5 369-552 366-581v-30H149v462Zm83-89h239v-14q0-18-9-32t-23-19q-32-11-50-14.5t-35-3.5q-19 0-40.5 4.5T265-303q-15 5-24 19t-9 32v14Zm336-67h170v-50H568v50Zm-214-50q22.5 0 38.25-15.75T408-409q0-22.5-15.75-38.25T354-463q-22.5 0-38.25 15.75T300-409q0 22.5 15.75 38.25T354-355Zm214-63h170v-50H568v50ZM452-608h57v-211h-57v211Zm28 228Z"
  })
});
var badge_default = SvgComponent27;

// ../../../node_modules/@material-symbols/svg-700/rounded/badge-fill.svg
import * as React28 from "react";
import { jsx as jsx36 } from "react/jsx-runtime";
var SvgComponent28 = (props) => /* @__PURE__ */ jsx36("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx36("path", {
    d: "M232-238h239v-14q0-18-9-32t-23-19q-32-11-50-14.5t-35-3.5q-19 0-40.5 4.5T265-303q-15 5-24 19t-9 32v14Zm361-67h120q10.83 0 17.92-7.12 7.08-7.11 7.08-18 0-10.88-7.08-17.88-7.09-7-17.92-7H593q-10.83 0-17.92 7.12-7.08 7.11-7.08 18 0 10.88 7.08 17.88 7.09 7 17.92 7Zm-239-50q22.5 0 38.25-15.75T408-409q0-22.5-15.75-38.25T354-463q-22.5 0-38.25 15.75T300-409q0 22.5 15.75 38.25T354-355Zm239-63h120q10.83 0 17.92-7.12 7.08-7.11 7.08-18 0-10.88-7.08-17.88-7.09-7-17.92-7H593q-10.83 0-17.92 7.12-7.08 7.11-7.08 18 0 10.88 7.08 17.88 7.09 7 17.92 7ZM149-55q-39.05 0-66.53-27.47Q55-109.95 55-149v-462q0-39.46 27.47-67.23Q109.95-706 149-706h216v-122q0-34 21.38-56 21.39-22 57.53-22h73.68Q552-906 574-884t22 56v122h215q39.46 0 67.23 27.77Q906-650.46 906-611v462q0 39.05-27.77 66.53Q850.46-55 811-55H149Zm303-553h57v-211h-57v211Z"
  })
});
var badge_fill_default2 = SvgComponent28;

// ../../../node_modules/@material-symbols/svg-700/rounded/badge.svg
import * as React29 from "react";
import { jsx as jsx37 } from "react/jsx-runtime";
var SvgComponent29 = (props) => /* @__PURE__ */ jsx37("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx37("path", {
    d: "M232-238h239v-14q0-18-9-32t-23-19q-32-11-50-14.5t-35-3.5q-19 0-40.5 4.5T265-303q-15 5-24 19t-9 32v14Zm361-67h120q10.83 0 17.92-7.12 7.08-7.11 7.08-18 0-10.88-7.08-17.88-7.09-7-17.92-7H593q-10.83 0-17.92 7.12-7.08 7.11-7.08 18 0 10.88 7.08 17.88 7.09 7 17.92 7Zm-239-50q22.5 0 38.25-15.75T408-409q0-22.5-15.75-38.25T354-463q-22.5 0-38.25 15.75T300-409q0 22.5 15.75 38.25T354-355Zm239-63h120q10.83 0 17.92-7.12 7.08-7.11 7.08-18 0-10.88-7.08-17.88-7.09-7-17.92-7H593q-10.83 0-17.92 7.12-7.08 7.11-7.08 18 0 10.88 7.08 17.88 7.09 7 17.92 7ZM149-55q-39.05 0-66.53-27.47Q55-109.95 55-149v-462q0-39.46 27.47-67.23Q109.95-706 149-706h216v-122q0-34 21.38-56 21.39-22 57.53-22h73.68Q552-906 574-884t22 56v122h215q39.46 0 67.23 27.77Q906-650.46 906-611v462q0 39.05-27.77 66.53Q850.46-55 811-55H149Zm0-94h662v-462H594v30q-4 30-27.5 45t-48.91 15h-74.18Q417-521 393-536.5 369-552 366-581v-30H149v462Zm303-459h57v-211h-57v211Zm28 228Z"
  })
});
var badge_default2 = SvgComponent29;

// ../../../node_modules/@material-symbols/svg-700/sharp/badge-fill.svg
import * as React30 from "react";
import { jsx as jsx38 } from "react/jsx-runtime";
var SvgComponent30 = (props) => /* @__PURE__ */ jsx38("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx38("path", {
    d: "M232-238h239v-14q0-18-9-32t-23-19q-32-11-50-14.5t-35-3.5q-19 0-40.5 4.5T265-303q-15 5-24 19t-9 32v14Zm336-67h170v-50H568v50Zm-214-50q22.5 0 38.25-15.75T408-409q0-22.5-15.75-38.25T354-463q-22.5 0-38.25 15.75T300-409q0 22.5 15.75 38.25T354-355Zm214-63h170v-50H568v50ZM55-55v-651h310v-200h231v200h310v651H55Zm397-553h57v-211h-57v211Z"
  })
});
var badge_fill_default3 = SvgComponent30;

// ../../../node_modules/@material-symbols/svg-700/sharp/badge.svg
import * as React31 from "react";
import { jsx as jsx39 } from "react/jsx-runtime";
var SvgComponent31 = (props) => /* @__PURE__ */ jsx39("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx39("path", {
    d: "M232-238h239v-14q0-18-9-32t-23-19q-32-11-50-14.5t-35-3.5q-19 0-40.5 4.5T265-303q-15 5-24 19t-9 32v14Zm336-67h170v-50H568v50Zm-214-50q22.5 0 38.25-15.75T408-409q0-22.5-15.75-38.25T354-463q-22.5 0-38.25 15.75T300-409q0 22.5 15.75 38.25T354-355Zm214-63h170v-50H568v50ZM55-55v-651h310v-200h231v200h310v651H55Zm94-94h662v-462H594v90H366v-90H149v462Zm303-459h57v-211h-57v211Zm28 228Z"
  })
});
var badge_default3 = SvgComponent31;

// src/components/icon/variants/IconBadge.tsx
import { useTranslation as useTranslation9 } from "react-i18next";
import { jsx as jsx40 } from "react/jsx-runtime";
var componentMap5 = {
  outlined: badge_default,
  "outlined-fill": badge_fill_default,
  rounded: badge_default2,
  "rounded-fill": badge_fill_default2,
  sharp: badge_default3,
  "sharp-fill": badge_fill_default3
};
var IconBadge = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation9("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap5[key] ?? componentMap5[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx40(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/bolt-fill.svg
import * as React32 from "react";
import { jsx as jsx41 } from "react/jsx-runtime";
var SvgComponent32 = (props) => /* @__PURE__ */ jsx41("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx41("path", {
    d: "m298-52 40-280H123l399-577h113l-40 320h260L409-52H298Z"
  })
});
var bolt_fill_default = SvgComponent32;

// ../../../node_modules/@material-symbols/svg-700/outlined/bolt.svg
import * as React33 from "react";
import { jsx as jsx42 } from "react/jsx-runtime";
var SvgComponent33 = (props) => /* @__PURE__ */ jsx42("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx42("path", {
    d: "m404-181 265-321H497l33-264-241 347h149l-34 238ZM298-52l40-280H123l399-577h113l-40 320h260L409-52H298Zm182-422Z"
  })
});
var bolt_default = SvgComponent33;

// ../../../node_modules/@material-symbols/svg-700/rounded/bolt-fill.svg
import * as React34 from "react";
import { jsx as jsx43 } from "react/jsx-runtime";
var SvgComponent34 = (props) => /* @__PURE__ */ jsx43("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx43("path", {
    d: "M338-332H213q-29 0-42.5-25t3.5-49l376-542q10-14 25-18.5t30 1.5q15 5 24 19.5t7 30.5l-41 326h159q30 0 42.5 27t-5.5 50L381-18Q371-5 355.5-1.5T325-5q-14-6-21.5-19.5T298-55l40-277Z"
  })
});
var bolt_fill_default2 = SvgComponent34;

// ../../../node_modules/@material-symbols/svg-700/rounded/bolt.svg
import * as React35 from "react";
import { jsx as jsx44 } from "react/jsx-runtime";
var SvgComponent35 = (props) => /* @__PURE__ */ jsx44("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx44("path", {
    d: "m404-181 265-321H497l33-264-241 347h149l-34 238Zm-66-151H213q-28.87 0-42.44-25Q157-382 174-406l376-542q10-14 25-18.5t30 1.5q15 5 24 19.67 9 14.67 7 30.33l-41 326h159q30.36 0 42.68 27T791-512L381-18Q370.56-5.1 355.28-1.55 340 2 325-5.25q-14-6.25-21.5-19.63Q296-38.25 298-55l40-277Zm140-140Z"
  })
});
var bolt_default2 = SvgComponent35;

// ../../../node_modules/@material-symbols/svg-700/sharp/bolt-fill.svg
import * as React36 from "react";
import { jsx as jsx45 } from "react/jsx-runtime";
var SvgComponent36 = (props) => /* @__PURE__ */ jsx45("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx45("path", {
    d: "m298-52 40-280H123l399-577h113l-40 320h260L409-52H298Z"
  })
});
var bolt_fill_default3 = SvgComponent36;

// ../../../node_modules/@material-symbols/svg-700/sharp/bolt.svg
import * as React37 from "react";
import { jsx as jsx46 } from "react/jsx-runtime";
var SvgComponent37 = (props) => /* @__PURE__ */ jsx46("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx46("path", {
    d: "m404-181 265-321H497l33-264-241 347h149l-34 238ZM298-52l40-280H123l399-577h113l-40 320h260L409-52H298Zm182-422Z"
  })
});
var bolt_default3 = SvgComponent37;

// src/components/icon/variants/IconBolt.tsx
import { useTranslation as useTranslation10 } from "react-i18next";
import { jsx as jsx47 } from "react/jsx-runtime";
var componentMap6 = {
  outlined: bolt_default,
  "outlined-fill": bolt_fill_default,
  rounded: bolt_default2,
  "rounded-fill": bolt_fill_default2,
  sharp: bolt_default3,
  "sharp-fill": bolt_fill_default3
};
var IconBolt = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation10("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap6[key] ?? componentMap6[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx47(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/box-fill.svg
import * as React38 from "react";
import { jsx as jsx48 } from "react/jsx-runtime";
var SvgComponent38 = (props) => /* @__PURE__ */ jsx48("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx48("path", {
    d: "M189-95q-39.8 0-66.9-27.1Q95-149.2 95-189v-493q0-15.88 5.5-31.06 5.5-15.18 15.69-27.9L189-836q12.75-16.03 30.61-23.02Q237.47-866 258-866h444q19.5 0 37.37 6.98Q757.24-852.03 770-836l74.81 95.04q9.19 12.72 15.19 27.9 6 15.18 6 31.06v493q0 39.8-27.39 66.9Q811.21-95 771-95H189Zm34-631h513l-36.41-46H259l-36 46Zm431 87H307v344l173-87 174 87v-344Z"
  })
});
var box_fill_default = SvgComponent38;

// ../../../node_modules/@material-symbols/svg-700/outlined/box.svg
import * as React39 from "react";
import { jsx as jsx49 } from "react/jsx-runtime";
var SvgComponent39 = (props) => /* @__PURE__ */ jsx49("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx49("path", {
    d: "M189-639v450h582v-450H654v344l-174-87-173 87v-344H189Zm0 544q-39.8 0-66.9-27.1Q95-149.2 95-189v-493q0-15.88 5.5-31.06 5.5-15.18 15.69-27.9L189-836q12.75-16.03 30.61-23.02Q237.47-866 258-866h444q19.5 0 37.37 6.98Q757.24-852.03 770-836l74.81 95.04q9.19 12.72 15.19 27.9 6 15.18 6 31.06v493q0 39.8-27.39 66.9Q811.21-95 771-95H189Zm34-631h513l-36.41-46H259l-36 46Zm171 87v203l86-43 87 43v-203H394Zm-205 0h582-582Z"
  })
});
var box_default = SvgComponent39;

// ../../../node_modules/@material-symbols/svg-700/rounded/box-fill.svg
import * as React40 from "react";
import { jsx as jsx50 } from "react/jsx-runtime";
var SvgComponent40 = (props) => /* @__PURE__ */ jsx50("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx50("path", {
    d: "M189-95q-39.8 0-66.9-27.1Q95-149.2 95-189v-493q0-15.88 5.5-31.06Q106-728.24 116-741l73-95q12.75-16.03 30.82-23.02Q237.88-866 258-866h444q19.09 0 37.16 6.98Q757.24-852.03 770-836l75 95q9 12.76 15 27.94 6 15.18 6 31.06v493q0 39.8-27.39 66.9Q811.21-95 771-95H189Zm34-631h513l-36.41-46H259l-36 46Zm431 87H307v267q0 26 22 40.5t45 2.5l106-53 106 53q23 12 45.5-2.5T654-372v-267Z"
  })
});
var box_fill_default2 = SvgComponent40;

// ../../../node_modules/@material-symbols/svg-700/rounded/box.svg
import * as React41 from "react";
import { jsx as jsx51 } from "react/jsx-runtime";
var SvgComponent41 = (props) => /* @__PURE__ */ jsx51("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx51("path", {
    d: "M189-639v450h582v-450H654v267q0 26-22.5 40.5T586-329l-106-53-106 53q-23 12-45-2.5T307-372v-267H189Zm0 544q-39.8 0-66.9-27.1Q95-149.2 95-189v-493q0-15.88 5.5-31.06 5.5-15.18 15.69-27.9L189-836q12.75-16.03 30.61-23.02Q237.47-866 258-866h444q19.5 0 37.37 6.98Q757.24-852.03 770-836l74.81 95.04q9.19 12.72 15.19 27.9 6 15.18 6 31.06v493q0 39.8-27.39 66.9Q811.21-95 771-95H189Zm34-631h513l-36.41-46H259l-36 46Zm171 87v203l86-43 87 43v-203H394Zm-205 0h582-582Z"
  })
});
var box_default2 = SvgComponent41;

// ../../../node_modules/@material-symbols/svg-700/sharp/box-fill.svg
import * as React42 from "react";
import { jsx as jsx52 } from "react/jsx-runtime";
var SvgComponent42 = (props) => /* @__PURE__ */ jsx52("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx52("path", {
    d: "M95-95v-620l118-151h534l119 151v620H95Zm128-631h513l-36-46H259l-36 46Zm84 431 173-87 174 87v-344H307v344Z"
  })
});
var box_fill_default3 = SvgComponent42;

// ../../../node_modules/@material-symbols/svg-700/sharp/box.svg
import * as React43 from "react";
import { jsx as jsx53 } from "react/jsx-runtime";
var SvgComponent43 = (props) => /* @__PURE__ */ jsx53("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx53("path", {
    d: "M189-639v450h582v-450H654v344l-174-87-173 87v-344H189ZM95-95v-620l118-151h534l119 151v620H95Zm128-631h513l-36-46H259l-36 46Zm171 87v203l86-43 87 43v-203H394Zm-205 0h582-582Z"
  })
});
var box_default3 = SvgComponent43;

// src/components/icon/variants/IconBox.tsx
import { useTranslation as useTranslation11 } from "react-i18next";
import { jsx as jsx54 } from "react/jsx-runtime";
var componentMap7 = {
  outlined: box_default,
  "outlined-fill": box_fill_default,
  rounded: box_default2,
  "rounded-fill": box_fill_default2,
  sharp: box_default3,
  "sharp-fill": box_fill_default3
};
var IconBox = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation11("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap7[key] ?? componentMap7[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx54(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/cached-fill.svg
import * as React44 from "react";
import { jsx as jsx55 } from "react/jsx-runtime";
var SvgComponent44 = (props) => /* @__PURE__ */ jsx55("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx55("path", {
    d: "M480-140q-136 0-236-98T144-470v-46l-69 69-46-47 162-163 163 163-47 47-69-69v44q0 97 71.5 167T480-235q31 0 59-6t52-18l66 65q-41 28-85.5 41T480-140Zm291-160L608-463l48-48 68 68v-40q0-96-72-166.5T482-720q-32 0-60 6.5T370-697l-65-66q41-27 85-39.5t92-12.5q135 0 235.5 98.5T818-485v44l68-69 47 47-162 163Z"
  })
});
var cached_fill_default = SvgComponent44;

// ../../../node_modules/@material-symbols/svg-700/outlined/cached.svg
import * as React45 from "react";
import { jsx as jsx56 } from "react/jsx-runtime";
var SvgComponent45 = (props) => /* @__PURE__ */ jsx56("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx56("path", {
    d: "M480-140q-136 0-236-98T144-470v-46l-69 69-46-47 162-163 163 163-47 47-69-69v44q0 97 71.5 167T480-235q31 0 59-6t52-18l66 65q-41 28-85.5 41T480-140Zm291-160L608-463l48-48 68 68v-40q0-96-72-166.5T482-720q-32 0-60 6.5T370-697l-65-66q41-27 85-39.5t92-12.5q135 0 235.5 98.5T818-485v44l68-69 47 47-162 163Z"
  })
});
var cached_default = SvgComponent45;

// ../../../node_modules/@material-symbols/svg-700/rounded/cached-fill.svg
import * as React46 from "react";
import { jsx as jsx57 } from "react/jsx-runtime";
var SvgComponent46 = (props) => /* @__PURE__ */ jsx57("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx57("path", {
    d: "M480-140q-136 0-236-98T144-470v-46l-46 46q-10 10-23 10t-23-10q-10-10-10-23.5T52-517l105-107q14-14 34-14t34 14l106 107q10 10 10 23t-10 23q-10 10-24 10t-23-10l-46-45v44q0 97 71.5 167T480-235q18 0 34.5-1.5T547-242q19-5 38.5.5T613-219q9 17 3.5 35T593-160q-27 10-55.5 15t-57.5 5Zm2-580q-19 0-35.5 2t-32.5 6q-19 4-38-1t-28-22q-10-18-4-36.5t23-25.5q28-9 56.5-13.5T482-815q135 0 235.5 98.5T818-485v44l45-45q10-11 23-10.5t23 10.5q10 10 10 23t-10 24L804-333q-14 14-33.5 14T737-333L632-439q-10-10-10.5-23.5T632-487q11-11 24.5-11t23.5 11l44 44v-40q0-96-72-166.5T482-720Z"
  })
});
var cached_fill_default2 = SvgComponent46;

// ../../../node_modules/@material-symbols/svg-700/rounded/cached.svg
import * as React47 from "react";
import { jsx as jsx58 } from "react/jsx-runtime";
var SvgComponent47 = (props) => /* @__PURE__ */ jsx58("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx58("path", {
    d: "M480-140q-136 0-236-98T144-470v-46l-46 46q-10 10-23 10t-23-10q-10-10-10-23.5T52-517l105-107q14-14 34-14t34 14l106 107q10 10 10 23t-10 23q-10 10-24 10t-23-10l-46-45v44q0 97 71.5 167T480-235q18 0 34.5-1.5T547-242q19-5 38.5.5T613-219q9 17 3.5 35T593-160q-27 10-55.5 15t-57.5 5Zm2-580q-19 0-35.5 2t-32.5 6q-19 4-38-1t-28-22q-10-18-4-36.5t23-25.5q28-9 56.5-13.5T482-815q135 0 235.5 98.5T818-485v44l45-45q10-11 23-10.5t23 10.5q10 10 10 23t-10 24L804-333q-14 14-33.5 14T737-333L632-439q-10-10-10.5-23.5T632-487q11-11 24.5-11t23.5 11l44 44v-40q0-96-72-166.5T482-720Z"
  })
});
var cached_default2 = SvgComponent47;

// ../../../node_modules/@material-symbols/svg-700/sharp/cached-fill.svg
import * as React48 from "react";
import { jsx as jsx59 } from "react/jsx-runtime";
var SvgComponent48 = (props) => /* @__PURE__ */ jsx59("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx59("path", {
    d: "M480-140q-136 0-236-98T144-470v-46l-69 69-46-47 162-163 163 163-47 47-69-69v44q0 97 71.5 167T480-235q31 0 59-6t52-18l66 65q-41 28-85.5 41T480-140Zm291-160L608-463l48-48 68 68v-40q0-96-72-166.5T482-720q-32 0-60 6.5T370-697l-65-66q41-27 85-39.5t92-12.5q135 0 235.5 98.5T818-485v44l68-69 47 47-162 163Z"
  })
});
var cached_fill_default3 = SvgComponent48;

// ../../../node_modules/@material-symbols/svg-700/sharp/cached.svg
import * as React49 from "react";
import { jsx as jsx60 } from "react/jsx-runtime";
var SvgComponent49 = (props) => /* @__PURE__ */ jsx60("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx60("path", {
    d: "M480-140q-136 0-236-98T144-470v-46l-69 69-46-47 162-163 163 163-47 47-69-69v44q0 97 71.5 167T480-235q31 0 59-6t52-18l66 65q-41 28-85.5 41T480-140Zm291-160L608-463l48-48 68 68v-40q0-96-72-166.5T482-720q-32 0-60 6.5T370-697l-65-66q41-27 85-39.5t92-12.5q135 0 235.5 98.5T818-485v44l68-69 47 47-162 163Z"
  })
});
var cached_default3 = SvgComponent49;

// src/components/icon/variants/IconCached.tsx
import { useTranslation as useTranslation12 } from "react-i18next";
import { jsx as jsx61 } from "react/jsx-runtime";
var componentMap8 = {
  outlined: cached_default,
  "outlined-fill": cached_fill_default,
  rounded: cached_default2,
  "rounded-fill": cached_fill_default2,
  sharp: cached_default3,
  "sharp-fill": cached_fill_default3
};
var IconCached = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation12("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap8[key] ?? componentMap8[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx61(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/calendar_today-fill.svg
import * as React50 from "react";
import { jsx as jsx62 } from "react/jsx-runtime";
var SvgComponent50 = (props) => /* @__PURE__ */ jsx62("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx62("path", {
    d: "M189-55q-39.05 0-66.53-27.47Q95-109.95 95-149v-602q0-39.46 27.47-67.23Q149.95-846 189-846h56v-60h82v60h306v-60h82v60h56q39.46 0 67.23 27.77Q866-790.46 866-751v602q0 39.05-27.77 66.53Q810.46-55 771-55H189Zm0-94h582v-421H189v421Z"
  })
});
var calendar_today_fill_default = SvgComponent50;

// ../../../node_modules/@material-symbols/svg-700/outlined/calendar_today.svg
import * as React51 from "react";
import { jsx as jsx63 } from "react/jsx-runtime";
var SvgComponent51 = (props) => /* @__PURE__ */ jsx63("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx63("path", {
    d: "M189-55q-39.05 0-66.53-27.47Q95-109.95 95-149v-602q0-39.46 27.47-67.23Q149.95-846 189-846h56v-60h82v60h306v-60h82v60h56q39.46 0 67.23 27.77Q866-790.46 866-751v602q0 39.05-27.77 66.53Q810.46-55 771-55H189Zm0-94h582v-421H189v421Zm0-481h582v-121H189v121Zm0 0v-121 121Z"
  })
});
var calendar_today_default = SvgComponent51;

// ../../../node_modules/@material-symbols/svg-700/rounded/calendar_today-fill.svg
import * as React52 from "react";
import { jsx as jsx64 } from "react/jsx-runtime";
var SvgComponent52 = (props) => /* @__PURE__ */ jsx64("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx64("path", {
    d: "M189-55q-39.05 0-66.53-27.47Q95-109.95 95-149v-602q0-39.46 27.47-67.23Q149.95-846 189-846h56v-19q0-16.75 12.39-28.88 12.4-12.12 28.8-12.12 16.83 0 28.82 12.12Q327-881.75 327-865v19h306v-19q0-16.75 12.39-28.88 12.4-12.12 28.8-12.12 16.84 0 28.82 12.12Q715-881.75 715-865v19h56q39.46 0 67.23 27.77Q866-790.46 866-751v602q0 39.05-27.77 66.53Q810.46-55 771-55H189Zm0-94h582v-421H189v421Z"
  })
});
var calendar_today_fill_default2 = SvgComponent52;

// ../../../node_modules/@material-symbols/svg-700/rounded/calendar_today.svg
import * as React53 from "react";
import { jsx as jsx65 } from "react/jsx-runtime";
var SvgComponent53 = (props) => /* @__PURE__ */ jsx65("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx65("path", {
    d: "M189-55q-39.05 0-66.53-27.47Q95-109.95 95-149v-602q0-39.46 27.47-67.23Q149.95-846 189-846h56v-19q0-16.75 12.39-28.88 12.4-12.12 28.8-12.12 16.83 0 28.82 12.12Q327-881.75 327-865v19h306v-19q0-16.75 12.39-28.88 12.4-12.12 28.8-12.12 16.84 0 28.82 12.12Q715-881.75 715-865v19h56q39.46 0 67.23 27.77Q866-790.46 866-751v602q0 39.05-27.77 66.53Q810.46-55 771-55H189Zm0-94h582v-421H189v421Zm0-481h582v-121H189v121Zm0 0v-121 121Z"
  })
});
var calendar_today_default2 = SvgComponent53;

// ../../../node_modules/@material-symbols/svg-700/sharp/calendar_today-fill.svg
import * as React54 from "react";
import { jsx as jsx66 } from "react/jsx-runtime";
var SvgComponent54 = (props) => /* @__PURE__ */ jsx66("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx66("path", {
    d: "M95-55v-791h150.2v-60H327v60h306v-60h82.2v60H866v791H95Zm94-94h582v-421H189v421Z"
  })
});
var calendar_today_fill_default3 = SvgComponent54;

// ../../../node_modules/@material-symbols/svg-700/sharp/calendar_today.svg
import * as React55 from "react";
import { jsx as jsx67 } from "react/jsx-runtime";
var SvgComponent55 = (props) => /* @__PURE__ */ jsx67("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx67("path", {
    d: "M95-55v-791h150.2v-60H327v60h306v-60h82.2v60H866v791H95Zm94-94h582v-421H189v421Zm0-481h582v-121H189v121Zm0 0v-121 121Z"
  })
});
var calendar_today_default3 = SvgComponent55;

// src/components/icon/variants/IconCalendarToday.tsx
import { useTranslation as useTranslation13 } from "react-i18next";
import { jsx as jsx68 } from "react/jsx-runtime";
var componentMap9 = {
  outlined: calendar_today_default,
  "outlined-fill": calendar_today_fill_default,
  rounded: calendar_today_default2,
  "rounded-fill": calendar_today_fill_default2,
  sharp: calendar_today_default3,
  "sharp-fill": calendar_today_fill_default3
};
var IconCalendarToday = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation13("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap9[key] ?? componentMap9[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx68(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/call-fill.svg
import * as React56 from "react";
import { jsx as jsx69 } from "react/jsx-runtime";
var SvgComponent56 = (props) => /* @__PURE__ */ jsx69("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx69("path", {
    d: "M797-95q-122 0-247-58T319-317Q212-424 153.5-549.5T95-796q0-29 20-49.5t49-20.5h140q31 0 50.5 16.5T381-802l27 110q4 26-1.5 46T385-612l-104 95q22 36 47 68t57 62q33 35 66.5 61t68.5 44l100-101q17-18 38-24t45 0l99 23q31 9 47.5 29t16.5 50v141q0 29-20.5 49T797-95Z"
  })
});
var call_fill_default = SvgComponent56;

// ../../../node_modules/@material-symbols/svg-700/outlined/call.svg
import * as React57 from "react";
import { jsx as jsx70 } from "react/jsx-runtime";
var SvgComponent57 = (props) => /* @__PURE__ */ jsx70("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx70("path", {
    d: "M797-95q-122.1 0-247.05-58Q425-211 318.5-317.5 212-424 153.5-549.46 95-674.92 95-796q0-29.43 20-49.71Q135-866 164-866h140q31 0 50.5 16.5T381-802l26.93 109.64Q412-666 406.5-646t-21.73 34.23L281-517q22 36 47 68t57 62q33 35 66.5 61t68.5 44l100-101q17-18 38.15-24t44.85 0l99 23q31 9 47.5 29.04Q866-334.91 866-305v141q0 29.57-20.36 49.29Q825.29-95 797-95ZM234-600l80-75-22-96H191q1 36 10.46 77.44Q210.91-652.12 234-600Zm372 367q36 17 79.5 28t85.5 14v-102.82L683-313l-77 80ZM234-600Zm372 367Z"
  })
});
var call_default = SvgComponent57;

// ../../../node_modules/@material-symbols/svg-700/rounded/call-fill.svg
import * as React58 from "react";
import { jsx as jsx71 } from "react/jsx-runtime";
var SvgComponent58 = (props) => /* @__PURE__ */ jsx71("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx71("path", {
    d: "M797-95q-122 0-247-58T319-317Q212-424 153.5-549.5T95-796q0-29 20-49.5t49-20.5h140q31 0 50.5 16.5T381-802l27 110q4 26-1.5 46T385-612l-104 95q22 36 47 68t57 62q33 35 66.5 61t68.5 44l100-101q17-18 38-24t45 0l99 23q31 9 47.5 29t16.5 50v141q0 29-20.5 49T797-95Z"
  })
});
var call_fill_default2 = SvgComponent58;

// ../../../node_modules/@material-symbols/svg-700/rounded/call.svg
import * as React59 from "react";
import { jsx as jsx72 } from "react/jsx-runtime";
var SvgComponent59 = (props) => /* @__PURE__ */ jsx72("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx72("path", {
    d: "M797-95q-122.1 0-247.05-58Q425-211 318.5-317.5 212-424 153.5-549.46 95-674.92 95-796q0-29.43 20-49.71Q135-866 164-866h140q31 0 50.5 16.5T381-802l26.93 109.64Q412-666 406.5-646t-21.73 34.23L281-517q22 36 47 68t57 62q33 35 66.5 61t68.5 44l100-101q17-18 38.15-24t44.85 0l99 23q31 9 47.5 29.04Q866-334.91 866-305v141q0 29.57-20.36 49.29Q825.29-95 797-95ZM234-600l80-75-22-96H191q1 36 10.46 77.44Q210.91-652.12 234-600Zm372 367q36 17 79.5 28t85.5 14v-102.82L683-313l-77 80ZM234-600Zm372 367Z"
  })
});
var call_default2 = SvgComponent59;

// ../../../node_modules/@material-symbols/svg-700/sharp/call-fill.svg
import * as React60 from "react";
import { jsx as jsx73 } from "react/jsx-runtime";
var SvgComponent60 = (props) => /* @__PURE__ */ jsx73("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx73("path", {
    d: "M777-95q-108 0-230-59T319-319Q212-424 153.5-543.5T95-776v-90h272l51 224-138 126q24 37 49.5 69t53.5 61q32 32 66 58.5t71 46.5l135-137 211 49v274h-89Z"
  })
});
var call_fill_default3 = SvgComponent60;

// ../../../node_modules/@material-symbols/svg-700/sharp/call.svg
import * as React61 from "react";
import { jsx as jsx74 } from "react/jsx-runtime";
var SvgComponent61 = (props) => /* @__PURE__ */ jsx74("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx74("path", {
    d: "M777-95q-108 0-230-59T319-319Q212-424 153.5-543.51 95-663.02 95-776v-90h272l51 224-138 126q24.16 37.15 49.58 69.07Q355-415 383.03-385.97 415-354 449-327.5t71 46.5l135-137 211 48.58V-95h-89ZM234-600l80-75-22-96H191q-2 33 8.5 74.5T234-600Zm372 367q34 16 77.5 27.5T771-191v-102.82L683-313l-77 80ZM234-600Zm372 367Z"
  })
});
var call_default3 = SvgComponent61;

// src/components/icon/variants/IconCall.tsx
import { useTranslation as useTranslation14 } from "react-i18next";
import { jsx as jsx75 } from "react/jsx-runtime";
var componentMap10 = {
  outlined: call_default,
  "outlined-fill": call_fill_default,
  rounded: call_default2,
  "rounded-fill": call_fill_default2,
  sharp: call_default3,
  "sharp-fill": call_fill_default3
};
var IconCall = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation14("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap10[key] ?? componentMap10[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx75(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/cancel-fill.svg
import * as React62 from "react";
import { jsx as jsx76 } from "react/jsx-runtime";
var SvgComponent62 = (props) => /* @__PURE__ */ jsx76("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx76("path", {
    d: "m338-288 142-142 142 142 50-50-142-142 142-142-50-50-142 142-142-142-50 50 142 142-142 142 50 50ZM480.14-55Q392-55 314.51-88.08q-77.48-33.09-135.41-91.02-57.93-57.93-91.02-135.27Q55-391.72 55-479.86 55-569 88.08-646.49q33.09-77.48 90.86-134.97 57.77-57.48 135.19-91.01Q391.56-906 479.78-906q89.22 0 166.83 33.45 77.6 33.46 135.01 90.81t90.89 134.87Q906-569.34 906-480q0 88.28-33.53 165.75t-91.01 135.28q-57.49 57.8-134.83 90.89Q569.28-55 480.14-55Z"
  })
});
var cancel_fill_default = SvgComponent62;

// ../../../node_modules/@material-symbols/svg-700/outlined/cancel.svg
import * as React63 from "react";
import { jsx as jsx77 } from "react/jsx-runtime";
var SvgComponent63 = (props) => /* @__PURE__ */ jsx77("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx77("path", {
    d: "m338-288 142-142 142 142 50-50-142-142 142-142-50-50-142 142-142-142-50 50 142 142-142 142 50 50ZM480.14-55Q392-55 314.51-88.08q-77.48-33.09-135.41-91.02-57.93-57.93-91.02-135.27Q55-391.72 55-479.86 55-569 88.08-646.49q33.09-77.48 90.86-134.97 57.77-57.48 135.19-91.01Q391.56-906 479.78-906q89.22 0 166.83 33.45 77.6 33.46 135.01 90.81t90.89 134.87Q906-569.34 906-480q0 88.28-33.53 165.75t-91.01 135.28q-57.49 57.8-134.83 90.89Q569.28-55 480.14-55Zm-.14-94q138 0 234.5-96.37T811-480q0-138-96.5-234.5t-235-96.5q-137.5 0-234 96.5t-96.5 235q0 137.5 96.37 234T480-149Zm0-331Z"
  })
});
var cancel_default = SvgComponent63;

// ../../../node_modules/@material-symbols/svg-700/rounded/cancel-fill.svg
import * as React64 from "react";
import { jsx as jsx78 } from "react/jsx-runtime";
var SvgComponent64 = (props) => /* @__PURE__ */ jsx78("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx78("path", {
    d: "m480-430 117 117q11 11 25 11t25-11.51q12-11.5 12-25.24 0-13.74-12-25.25L530-480l117-117q11-11 11.5-25T647-647q-11.41-12-25-12t-25 12L480-530 363-647q-11-11-24.5-11.5T314-647q-12 11.41-12 25t12 25l116 117-117 117q-11 11-11 24.5t11.51 24.5q11.5 12 25.24 12 13.74 0 25.25-12l116-116Zm.14 375Q392-55 314.5-88 237-121 179-179T88-314.36q-33-77.36-33-165.5Q55-569 88-646.5q33-77.5 90.84-135.05 57.85-57.56 135.28-91Q391.56-906 479.78-906q89.22 0 166.84 33.37t135.09 90.79q57.48 57.42 90.89 134.96Q906-569.34 906-480q0 88.28-33.45 165.76-33.44 77.48-91 135.36Q724-121 646.64-88q-77.36 33-166.5 33Z"
  })
});
var cancel_fill_default2 = SvgComponent64;

// ../../../node_modules/@material-symbols/svg-700/rounded/cancel.svg
import * as React65 from "react";
import { jsx as jsx79 } from "react/jsx-runtime";
var SvgComponent65 = (props) => /* @__PURE__ */ jsx79("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx79("path", {
    d: "m480-430 117 117q11 11 25 11t25-11.51q12-11.5 12-25.24 0-13.74-12-25.25L530-480l117-117q11-11 11.5-25T647-647q-11.41-12-25-12t-25 12L480-530 363-647q-11-11-24.5-11.5T314-647q-12 11.41-12 25t12 25l116 117-117 117q-11 11-11 24.5t11.51 24.5q11.5 12 25.24 12 13.74 0 25.25-12l116-116Zm.14 375Q392-55 314.5-88 237-121 179-179T88-314.36q-33-77.36-33-165.5Q55-569 88-646.5q33-77.5 90.84-135.05 57.85-57.56 135.28-91Q391.56-906 479.78-906q89.22 0 166.84 33.37t135.09 90.79q57.48 57.42 90.89 134.96Q906-569.34 906-480q0 88.28-33.45 165.76-33.44 77.48-91 135.36Q724-121 646.64-88q-77.36 33-166.5 33Zm-.14-94q138 0 234.5-96.37T811-480q0-138-96.5-234.5t-235-96.5q-137.5 0-234 96.5t-96.5 235q0 137.5 96.37 234T480-149Zm0-331Z"
  })
});
var cancel_default2 = SvgComponent65;

// ../../../node_modules/@material-symbols/svg-700/sharp/cancel-fill.svg
import * as React66 from "react";
import { jsx as jsx80 } from "react/jsx-runtime";
var SvgComponent66 = (props) => /* @__PURE__ */ jsx80("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx80("path", {
    d: "m338-288 142-142 142 142 50-50-142-142 142-142-50-50-142 142-142-142-50 50 142 142-142 142 50 50ZM480.14-55Q392-55 314.51-88.08q-77.48-33.09-135.41-91.02-57.93-57.93-91.02-135.27Q55-391.72 55-479.86 55-569 88.08-646.49q33.09-77.48 90.86-134.97 57.77-57.48 135.19-91.01Q391.56-906 479.78-906q89.22 0 166.83 33.45 77.6 33.46 135.01 90.81t90.89 134.87Q906-569.34 906-480q0 88.28-33.53 165.75t-91.01 135.28q-57.49 57.8-134.83 90.89Q569.28-55 480.14-55Z"
  })
});
var cancel_fill_default3 = SvgComponent66;

// ../../../node_modules/@material-symbols/svg-700/sharp/cancel.svg
import * as React67 from "react";
import { jsx as jsx81 } from "react/jsx-runtime";
var SvgComponent67 = (props) => /* @__PURE__ */ jsx81("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx81("path", {
    d: "m338-288 142-142 142 142 50-50-142-142 142-142-50-50-142 142-142-142-50 50 142 142-142 142 50 50ZM480.14-55Q392-55 314.51-88.08q-77.48-33.09-135.41-91.02-57.93-57.93-91.02-135.27Q55-391.72 55-479.86 55-569 88.08-646.49q33.09-77.48 90.86-134.97 57.77-57.48 135.19-91.01Q391.56-906 479.78-906q89.22 0 166.83 33.45 77.6 33.46 135.01 90.81t90.89 134.87Q906-569.34 906-480q0 88.28-33.53 165.75t-91.01 135.28q-57.49 57.8-134.83 90.89Q569.28-55 480.14-55Zm-.14-94q138 0 234.5-96.37T811-480q0-138-96.5-234.5t-235-96.5q-137.5 0-234 96.5t-96.5 235q0 137.5 96.37 234T480-149Zm0-331Z"
  })
});
var cancel_default3 = SvgComponent67;

// src/components/icon/variants/IconCancel.tsx
import { useTranslation as useTranslation15 } from "react-i18next";
import { jsx as jsx82 } from "react/jsx-runtime";
var componentMap11 = {
  outlined: cancel_default,
  "outlined-fill": cancel_fill_default,
  rounded: cancel_default2,
  "rounded-fill": cancel_fill_default2,
  sharp: cancel_default3,
  "sharp-fill": cancel_fill_default3
};
var IconCancel = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation15("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap11[key] ?? componentMap11[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx82(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/check-fill.svg
import * as React68 from "react";
import { jsx as jsx83 } from "react/jsx-runtime";
var SvgComponent68 = (props) => /* @__PURE__ */ jsx83("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx83("path", {
    d: "M378-222 130-470l68-68 180 180 383-383 68 68-451 451Z"
  })
});
var check_fill_default = SvgComponent68;

// ../../../node_modules/@material-symbols/svg-700/outlined/check.svg
import * as React69 from "react";
import { jsx as jsx84 } from "react/jsx-runtime";
var SvgComponent69 = (props) => /* @__PURE__ */ jsx84("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx84("path", {
    d: "M378-222 130-470l68-68 180 180 383-383 68 68-451 451Z"
  })
});
var check_default = SvgComponent69;

// ../../../node_modules/@material-symbols/svg-700/rounded/check-fill.svg
import * as React70 from "react";
import { jsx as jsx85 } from "react/jsx-runtime";
var SvgComponent70 = (props) => /* @__PURE__ */ jsx85("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx85("path", {
    d: "m378-358 350-349q14.36-14 34.18-14T796-706.95q14 14.06 14 33.8 0 19.75-14 34.15L412-256q-14.36 14-34.18 14T344-256L164-436q-14-14.47-14-34.23Q150-490 164.05-504q14.06-14 33.8-14 19.75 0 34.15 14l146 146Z"
  })
});
var check_fill_default2 = SvgComponent70;

// ../../../node_modules/@material-symbols/svg-700/rounded/check.svg
import * as React71 from "react";
import { jsx as jsx86 } from "react/jsx-runtime";
var SvgComponent71 = (props) => /* @__PURE__ */ jsx86("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx86("path", {
    d: "m378-358 350-349q14.36-14 34.18-14T796-706.95q14 14.06 14 33.8 0 19.75-14 34.15L412-256q-14.36 14-34.18 14T344-256L164-436q-14-14.47-14-34.23Q150-490 164.05-504q14.06-14 33.8-14 19.75 0 34.15 14l146 146Z"
  })
});
var check_default2 = SvgComponent71;

// ../../../node_modules/@material-symbols/svg-700/sharp/check-fill.svg
import * as React72 from "react";
import { jsx as jsx87 } from "react/jsx-runtime";
var SvgComponent72 = (props) => /* @__PURE__ */ jsx87("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx87("path", {
    d: "M378-222 130-470l68-68 180 180 383-383 68 68-451 451Z"
  })
});
var check_fill_default3 = SvgComponent72;

// ../../../node_modules/@material-symbols/svg-700/sharp/check.svg
import * as React73 from "react";
import { jsx as jsx88 } from "react/jsx-runtime";
var SvgComponent73 = (props) => /* @__PURE__ */ jsx88("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx88("path", {
    d: "M378-222 130-470l68-68 180 180 383-383 68 68-451 451Z"
  })
});
var check_default3 = SvgComponent73;

// src/components/icon/variants/IconCheck.tsx
import { useTranslation as useTranslation16 } from "react-i18next";
import { jsx as jsx89 } from "react/jsx-runtime";
var componentMap12 = {
  outlined: check_default,
  "outlined-fill": check_fill_default,
  rounded: check_default2,
  "rounded-fill": check_fill_default2,
  sharp: check_default3,
  "sharp-fill": check_fill_default3
};
var IconCheck = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation16("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap12[key] ?? componentMap12[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx89(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/check_circle-fill.svg
import * as React74 from "react";
import { jsx as jsx90 } from "react/jsx-runtime";
var SvgComponent74 = (props) => /* @__PURE__ */ jsx90("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx90("path", {
    d: "m419-283 294-294-66-66-228 228-111-111-65 66 176 177Zm61.14 228Q392-55 314.51-88.08q-77.48-33.09-135.41-91.02-57.93-57.93-91.02-135.27Q55-391.72 55-479.86 55-569 88.08-646.49q33.09-77.48 90.86-134.97 57.77-57.48 135.19-91.01Q391.56-906 479.78-906q89.22 0 166.83 33.45 77.6 33.46 135.01 90.81t90.89 134.87Q906-569.34 906-480q0 88.28-33.53 165.75t-91.01 135.28q-57.49 57.8-134.83 90.89Q569.28-55 480.14-55Z"
  })
});
var check_circle_fill_default = SvgComponent74;

// ../../../node_modules/@material-symbols/svg-700/outlined/check_circle.svg
import * as React75 from "react";
import { jsx as jsx91 } from "react/jsx-runtime";
var SvgComponent75 = (props) => /* @__PURE__ */ jsx91("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx91("path", {
    d: "m419-283 294-294-66-66-228 228-111-111-65 66 176 177Zm61.14 228Q392-55 314.51-88.08q-77.48-33.09-135.41-91.02-57.93-57.93-91.02-135.27Q55-391.72 55-479.86 55-569 88.08-646.49q33.09-77.48 90.86-134.97 57.77-57.48 135.19-91.01Q391.56-906 479.78-906q89.22 0 166.83 33.45 77.6 33.46 135.01 90.81t90.89 134.87Q906-569.34 906-480q0 88.28-33.53 165.75t-91.01 135.28q-57.49 57.8-134.83 90.89Q569.28-55 480.14-55Zm-.14-94q138 0 234.5-96.37T811-480q0-138-96.5-234.5t-235-96.5q-137.5 0-234 96.5t-96.5 235q0 137.5 96.37 234T480-149Zm0-331Z"
  })
});
var check_circle_default = SvgComponent75;

// ../../../node_modules/@material-symbols/svg-700/rounded/check_circle-fill.svg
import * as React76 from "react";
import { jsx as jsx92 } from "react/jsx-runtime";
var SvgComponent76 = (props) => /* @__PURE__ */ jsx92("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx92("path", {
    d: "m419-415-79-79q-13-13-32.11-13T274-493q-13 14-13 33t14 32l110 111q14.45 14 33.73 14Q438-303 453-317l227-228q15-14 15-32.61T680-611q-14-13-33.61-12.5T613-610L419-415Zm61.14 360Q392-55 314.51-88.08q-77.48-33.09-135.41-91.02-57.93-57.93-91.02-135.27Q55-391.72 55-479.86 55-569 88.08-646.49q33.09-77.48 90.86-134.97 57.77-57.48 135.19-91.01Q391.56-906 479.78-906q89.22 0 166.83 33.45 77.6 33.46 135.01 90.81t90.89 134.87Q906-569.34 906-480q0 88.28-33.53 165.75t-91.01 135.28q-57.49 57.8-134.83 90.89Q569.28-55 480.14-55Z"
  })
});
var check_circle_fill_default2 = SvgComponent76;

// ../../../node_modules/@material-symbols/svg-700/rounded/check_circle.svg
import * as React77 from "react";
import { jsx as jsx93 } from "react/jsx-runtime";
var SvgComponent77 = (props) => /* @__PURE__ */ jsx93("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx93("path", {
    d: "m419-415-79-79q-13-13-32.11-13T274-493q-13 14-13 33t14 32l110 111q14.45 14 33.73 14Q438-303 453-317l227-228q15-14 15-32.61T680-611q-14-13-33.61-12.5T613-610L419-415Zm61.14 360Q392-55 314.51-88.08q-77.48-33.09-135.41-91.02-57.93-57.93-91.02-135.27Q55-391.72 55-479.86 55-569 88.08-646.49q33.09-77.48 90.86-134.97 57.77-57.48 135.19-91.01Q391.56-906 479.78-906q89.22 0 166.83 33.45 77.6 33.46 135.01 90.81t90.89 134.87Q906-569.34 906-480q0 88.28-33.53 165.75t-91.01 135.28q-57.49 57.8-134.83 90.89Q569.28-55 480.14-55Zm-.14-94q138 0 234.5-96.37T811-480q0-138-96.5-234.5t-235-96.5q-137.5 0-234 96.5t-96.5 235q0 137.5 96.37 234T480-149Zm0-331Z"
  })
});
var check_circle_default2 = SvgComponent77;

// ../../../node_modules/@material-symbols/svg-700/sharp/check_circle-fill.svg
import * as React78 from "react";
import { jsx as jsx94 } from "react/jsx-runtime";
var SvgComponent78 = (props) => /* @__PURE__ */ jsx94("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx94("path", {
    d: "m419-283 294-294-66-66-228 228-111-111-65 66 176 177Zm61.14 228Q392-55 314.51-88.08q-77.48-33.09-135.41-91.02-57.93-57.93-91.02-135.27Q55-391.72 55-479.86 55-569 88.08-646.49q33.09-77.48 90.86-134.97 57.77-57.48 135.19-91.01Q391.56-906 479.78-906q89.22 0 166.83 33.45 77.6 33.46 135.01 90.81t90.89 134.87Q906-569.34 906-480q0 88.28-33.53 165.75t-91.01 135.28q-57.49 57.8-134.83 90.89Q569.28-55 480.14-55Z"
  })
});
var check_circle_fill_default3 = SvgComponent78;

// ../../../node_modules/@material-symbols/svg-700/sharp/check_circle.svg
import * as React79 from "react";
import { jsx as jsx95 } from "react/jsx-runtime";
var SvgComponent79 = (props) => /* @__PURE__ */ jsx95("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx95("path", {
    d: "m419-283 294-294-66-66-228 228-111-111-65 66 176 177Zm61.14 228Q392-55 314.51-88.08q-77.48-33.09-135.41-91.02-57.93-57.93-91.02-135.27Q55-391.72 55-479.86 55-569 88.08-646.49q33.09-77.48 90.86-134.97 57.77-57.48 135.19-91.01Q391.56-906 479.78-906q89.22 0 166.83 33.45 77.6 33.46 135.01 90.81t90.89 134.87Q906-569.34 906-480q0 88.28-33.53 165.75t-91.01 135.28q-57.49 57.8-134.83 90.89Q569.28-55 480.14-55Zm-.14-94q138 0 234.5-96.37T811-480q0-138-96.5-234.5t-235-96.5q-137.5 0-234 96.5t-96.5 235q0 137.5 96.37 234T480-149Zm0-331Z"
  })
});
var check_circle_default3 = SvgComponent79;

// src/components/icon/variants/IconCheckCircle.tsx
import { useTranslation as useTranslation17 } from "react-i18next";
import { jsx as jsx96 } from "react/jsx-runtime";
var componentMap13 = {
  outlined: check_circle_default,
  "outlined-fill": check_circle_fill_default,
  rounded: check_circle_default2,
  "rounded-fill": check_circle_fill_default2,
  sharp: check_circle_default3,
  "sharp-fill": check_circle_fill_default3
};
var IconCheckCircle = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation17("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap13[key] ?? componentMap13[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx96(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/chevron_left-fill.svg
import * as React80 from "react";
import { jsx as jsx97 } from "react/jsx-runtime";
var SvgComponent80 = (props) => /* @__PURE__ */ jsx97("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx97("path", {
    d: "M561-216 296-481l265-265 67 67-198 198 198 198-67 67Z"
  })
});
var chevron_left_fill_default = SvgComponent80;

// ../../../node_modules/@material-symbols/svg-700/outlined/chevron_left.svg
import * as React81 from "react";
import { jsx as jsx98 } from "react/jsx-runtime";
var SvgComponent81 = (props) => /* @__PURE__ */ jsx98("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx98("path", {
    d: "M561-216 296-481l265-265 67 67-198 198 198 198-67 67Z"
  })
});
var chevron_left_default = SvgComponent81;

// ../../../node_modules/@material-symbols/svg-700/rounded/chevron_left-fill.svg
import * as React82 from "react";
import { jsx as jsx99 } from "react/jsx-runtime";
var SvgComponent82 = (props) => /* @__PURE__ */ jsx99("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx99("path", {
    d: "m430-481 165 165q14 14 13.5 33T594-250q-14 14-33.5 14T527-250L330-447q-7-7-11-16t-4-18q0-9 4-18t11-16l198-198q14-14 33.5-14t33.5 14q14 14 14 33.5T595-646L430-481Z"
  })
});
var chevron_left_fill_default2 = SvgComponent82;

// ../../../node_modules/@material-symbols/svg-700/rounded/chevron_left.svg
import * as React83 from "react";
import { jsx as jsx100 } from "react/jsx-runtime";
var SvgComponent83 = (props) => /* @__PURE__ */ jsx100("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx100("path", {
    d: "m430-481 165 165q14 14 13.5 33T594-250q-14 14-33.5 14T527-250L330-447q-7-7-11-16t-4-18q0-9 4-18t11-16l198-198q14-14 33.5-14t33.5 14q14 14 14 33.5T595-646L430-481Z"
  })
});
var chevron_left_default2 = SvgComponent83;

// ../../../node_modules/@material-symbols/svg-700/sharp/chevron_left-fill.svg
import * as React84 from "react";
import { jsx as jsx101 } from "react/jsx-runtime";
var SvgComponent84 = (props) => /* @__PURE__ */ jsx101("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx101("path", {
    d: "M561-216 296-481l265-265 67 67-198 198 198 198-67 67Z"
  })
});
var chevron_left_fill_default3 = SvgComponent84;

// ../../../node_modules/@material-symbols/svg-700/sharp/chevron_left.svg
import * as React85 from "react";
import { jsx as jsx102 } from "react/jsx-runtime";
var SvgComponent85 = (props) => /* @__PURE__ */ jsx102("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx102("path", {
    d: "M561-216 296-481l265-265 67 67-198 198 198 198-67 67Z"
  })
});
var chevron_left_default3 = SvgComponent85;

// src/components/icon/variants/IconChevronLeft.tsx
import { useTranslation as useTranslation18 } from "react-i18next";
import { jsx as jsx103 } from "react/jsx-runtime";
var componentMap14 = {
  outlined: chevron_left_default,
  "outlined-fill": chevron_left_fill_default,
  rounded: chevron_left_default2,
  "rounded-fill": chevron_left_fill_default2,
  sharp: chevron_left_default3,
  "sharp-fill": chevron_left_fill_default3
};
var IconChevronLeft = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation18("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap14[key] ?? componentMap14[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx103(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/chevron_right-fill.svg
import * as React86 from "react";
import { jsx as jsx104 } from "react/jsx-runtime";
var SvgComponent86 = (props) => /* @__PURE__ */ jsx104("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx104("path", {
    d: "M506-481 308-679l67-67 265 265-265 265-67-67 198-198Z"
  })
});
var chevron_right_fill_default = SvgComponent86;

// ../../../node_modules/@material-symbols/svg-700/outlined/chevron_right.svg
import * as React87 from "react";
import { jsx as jsx105 } from "react/jsx-runtime";
var SvgComponent87 = (props) => /* @__PURE__ */ jsx105("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx105("path", {
    d: "M506-481 308-679l67-67 265 265-265 265-67-67 198-198Z"
  })
});
var chevron_right_default = SvgComponent87;

// ../../../node_modules/@material-symbols/svg-700/rounded/chevron_right-fill.svg
import * as React88 from "react";
import { jsx as jsx106 } from "react/jsx-runtime";
var SvgComponent88 = (props) => /* @__PURE__ */ jsx106("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx106("path", {
    d: "M506-481 341-646q-14-14-13.5-33t14.5-33q14-14 33.5-14t33.5 14l197 197q7 7 11 16t4 18q0 9-4 18t-11 16L408-249q-14 14-33 13.5T342-250q-14-14-14-33.5t14-33.5l164-164Z"
  })
});
var chevron_right_fill_default2 = SvgComponent88;

// ../../../node_modules/@material-symbols/svg-700/rounded/chevron_right.svg
import * as React89 from "react";
import { jsx as jsx107 } from "react/jsx-runtime";
var SvgComponent89 = (props) => /* @__PURE__ */ jsx107("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx107("path", {
    d: "M506-481 341-646q-14-14-13.5-33t14.5-33q14-14 33.5-14t33.5 14l197 197q7 7 11 16t4 18q0 9-4 18t-11 16L408-249q-14 14-33 13.5T342-250q-14-14-14-33.5t14-33.5l164-164Z"
  })
});
var chevron_right_default2 = SvgComponent89;

// ../../../node_modules/@material-symbols/svg-700/sharp/chevron_right-fill.svg
import * as React90 from "react";
import { jsx as jsx108 } from "react/jsx-runtime";
var SvgComponent90 = (props) => /* @__PURE__ */ jsx108("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx108("path", {
    d: "M506-481 308-679l67-67 265 265-265 265-67-67 198-198Z"
  })
});
var chevron_right_fill_default3 = SvgComponent90;

// ../../../node_modules/@material-symbols/svg-700/sharp/chevron_right.svg
import * as React91 from "react";
import { jsx as jsx109 } from "react/jsx-runtime";
var SvgComponent91 = (props) => /* @__PURE__ */ jsx109("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx109("path", {
    d: "M506-481 308-679l67-67 265 265-265 265-67-67 198-198Z"
  })
});
var chevron_right_default3 = SvgComponent91;

// src/components/icon/variants/IconChevronRight.tsx
import { useTranslation as useTranslation19 } from "react-i18next";
import { jsx as jsx110 } from "react/jsx-runtime";
var componentMap15 = {
  outlined: chevron_right_default,
  "outlined-fill": chevron_right_fill_default,
  rounded: chevron_right_default2,
  "rounded-fill": chevron_right_fill_default2,
  sharp: chevron_right_default3,
  "sharp-fill": chevron_right_fill_default3
};
var IconChevronRight = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation19("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap15[key] ?? componentMap15[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx110(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/close-fill.svg
import * as React92 from "react";
import { jsx as jsx111 } from "react/jsx-runtime";
var SvgComponent92 = (props) => /* @__PURE__ */ jsx111("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx111("path", {
    d: "m249-183-66-66 231-231-231-231 66-66 231 231 231-231 66 66-231 231 231 231-66 66-231-231-231 231Z"
  })
});
var close_fill_default = SvgComponent92;

// ../../../node_modules/@material-symbols/svg-700/outlined/close.svg
import * as React93 from "react";
import { jsx as jsx112 } from "react/jsx-runtime";
var SvgComponent93 = (props) => /* @__PURE__ */ jsx112("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx112("path", {
    d: "m249-183-66-66 231-231-231-231 66-66 231 231 231-231 66 66-231 231 231 231-66 66-231-231-231 231Z"
  })
});
var close_default = SvgComponent93;

// ../../../node_modules/@material-symbols/svg-700/rounded/close-fill.svg
import * as React94 from "react";
import { jsx as jsx113 } from "react/jsx-runtime";
var SvgComponent94 = (props) => /* @__PURE__ */ jsx113("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx113("path", {
    d: "M480-414 282-216q-14 14-33 14t-33-14q-14-14-14-33t14-33l198-198-198-198q-14-14-14-33t14-33q14-14 33-14t33 14l198 198 198-198q14-14 33-14t33 14q14 14 14 33t-14 33L546-480l198 198q14 14 14 33t-14 33q-14 14-33 14t-33-14L480-414Z"
  })
});
var close_fill_default2 = SvgComponent94;

// ../../../node_modules/@material-symbols/svg-700/rounded/close.svg
import * as React95 from "react";
import { jsx as jsx114 } from "react/jsx-runtime";
var SvgComponent95 = (props) => /* @__PURE__ */ jsx114("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx114("path", {
    d: "M480-414 282-216q-14 14-33 14t-33-14q-14-14-14-33t14-33l198-198-198-198q-14-14-14-33t14-33q14-14 33-14t33 14l198 198 198-198q14-14 33-14t33 14q14 14 14 33t-14 33L546-480l198 198q14 14 14 33t-14 33q-14 14-33 14t-33-14L480-414Z"
  })
});
var close_default2 = SvgComponent95;

// ../../../node_modules/@material-symbols/svg-700/sharp/close-fill.svg
import * as React96 from "react";
import { jsx as jsx115 } from "react/jsx-runtime";
var SvgComponent96 = (props) => /* @__PURE__ */ jsx115("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx115("path", {
    d: "m249-183-66-66 231-231-231-231 66-66 231 231 231-231 66 66-231 231 231 231-66 66-231-231-231 231Z"
  })
});
var close_fill_default3 = SvgComponent96;

// ../../../node_modules/@material-symbols/svg-700/sharp/close.svg
import * as React97 from "react";
import { jsx as jsx116 } from "react/jsx-runtime";
var SvgComponent97 = (props) => /* @__PURE__ */ jsx116("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx116("path", {
    d: "m249-183-66-66 231-231-231-231 66-66 231 231 231-231 66 66-231 231 231 231-66 66-231-231-231 231Z"
  })
});
var close_default3 = SvgComponent97;

// src/components/icon/variants/IconClose.tsx
import { useTranslation as useTranslation20 } from "react-i18next";
import { jsx as jsx117 } from "react/jsx-runtime";
var componentMap16 = {
  outlined: close_default,
  "outlined-fill": close_fill_default,
  rounded: close_default2,
  "rounded-fill": close_fill_default2,
  sharp: close_default3,
  "sharp-fill": close_fill_default3
};
var IconClose = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation20("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap16[key] ?? componentMap16[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx117(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// src/components/icon/variants/IconControlledSubstance.tsx
import { useTranslation as useTranslation21 } from "react-i18next";

// src/components/icon/static/controlled-substance-gray.svg
import * as React98 from "react";
import { jsx as jsx118, jsxs as jsxs2 } from "react/jsx-runtime";
var SvgComponent98 = (props) => /* @__PURE__ */ jsxs2("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: [
    /* @__PURE__ */ jsx118("path", {
      d: "M12.2033 22.4065C10.7881 22.4065 9.46018 22.1389 8.21965 21.6036C6.97912 21.0683 5.90002 20.3418 4.98237 19.4242C4.06472 18.5065 3.33825 17.4274 2.80295 16.1869C2.26765 14.9464 2 13.6185 2 12.2033C2 10.7881 2.26765 9.46018 2.80295 8.21965C3.33825 6.97912 4.06472 5.90002 4.98237 4.98237C5.90002 4.06472 6.97912 3.33825 8.21965 2.80295C9.46018 2.26765 10.7881 2 12.2033 2C13.6185 2 14.9464 2.26765 16.1869 2.80295C17.4274 3.33825 18.5065 4.06472 19.4242 4.98237C20.3418 5.90002 21.0683 6.97912 21.6036 8.21965C22.1389 9.46018 22.4065 10.7881 22.4065 12.2033C22.4065 13.6185 22.1389 14.9464 21.6036 16.1869C21.0683 17.4274 20.3418 18.5065 19.4242 19.4242C18.5065 20.3418 17.4274 21.0683 16.1869 21.6036C14.9464 22.1389 13.6185 22.4065 12.2033 22.4065ZM12.2033 20.1315C14.4207 20.1315 16.2964 19.3645 17.8304 17.8304C19.3645 16.2964 20.1315 14.4207 20.1315 12.2033C20.1315 9.98589 19.3645 8.11017 17.8304 6.5761C16.2964 5.04205 14.4207 4.27502 12.2033 4.27502C9.98589 4.27502 8.11017 5.04205 6.5761 6.5761C5.04205 8.11017 4.27502 9.98589 4.27502 12.2033C4.27502 14.4207 5.04205 16.2964 6.5761 17.8304C8.11017 19.3645 9.98589 20.1315 12.2033 20.1315Z",
      fill: "#7D808C"
    }),
    /* @__PURE__ */ jsx118("path", {
      d: "M9.28855 15C8.70943 15 8.16479 14.8774 7.65462 14.6323C7.15823 14.3871 6.75837 14.0323 6.45502 13.5677C6.15167 13.1032 6 12.5484 6 11.9032C6.01379 11.0129 6.32403 10.3097 6.93072 9.79355C7.53741 9.26452 8.32336 9 9.28855 9C9.66084 9 10.0262 9.03871 10.3847 9.11613C10.7432 9.19355 11.0535 9.33548 11.3155 9.54194C11.5223 9.69677 11.6257 9.89677 11.6257 10.1419C11.6257 10.3484 11.543 10.5355 11.3775 10.7032C11.2258 10.871 11.0328 10.9548 10.7984 10.9548C10.6467 10.9548 10.5088 10.9161 10.3847 10.8387C10.1779 10.7355 9.99176 10.6645 9.8263 10.6258C9.67462 10.5871 9.50227 10.5677 9.30923 10.5677C8.85421 10.5677 8.48192 10.6903 8.19237 10.9355C7.90281 11.1806 7.75803 11.5097 7.75803 11.9226C7.75803 12.4 7.9166 12.7742 8.23373 13.0452C8.55087 13.3032 8.92315 13.4323 9.3506 13.4323C9.83319 13.4323 10.2882 13.2645 10.7157 12.929C10.8811 12.8129 11.0397 12.7548 11.1914 12.7548C11.412 12.7548 11.5981 12.8387 11.7498 13.0065C11.9152 13.1742 11.998 13.3677 11.998 13.5871C11.998 13.6774 11.9773 13.7806 11.9359 13.8968C11.8946 14 11.8187 14.1032 11.7084 14.2065C11.3361 14.4903 10.9363 14.6903 10.5088 14.8065C10.0952 14.9355 9.68841 15 9.28855 15Z",
      fill: "#7D808C"
    }),
    /* @__PURE__ */ jsx118("path", {
      d: "M15.2906 15C14.353 15 13.5808 14.8194 12.9741 14.4581C12.85 14.3806 12.7604 14.2903 12.7052 14.1871C12.6501 14.071 12.6225 13.9613 12.6225 13.8581C12.6225 13.6387 12.6983 13.4387 12.85 13.2581C13.0155 13.0774 13.2154 12.9871 13.4498 12.9871C13.5601 12.9871 13.6704 13.0129 13.7807 13.0645C14.0289 13.1677 14.3116 13.2581 14.6287 13.3355C14.9459 13.4 15.2354 13.4323 15.4974 13.4323C16.0076 13.4323 16.2627 13.3226 16.2627 13.1032C16.2627 12.9742 16.2006 12.8645 16.0765 12.7742C15.9524 12.671 15.6629 12.6 15.2078 12.5613C15.0286 12.5484 14.7942 12.5226 14.5046 12.4839C14.2289 12.4452 13.9531 12.3742 13.6773 12.271C13.4015 12.1548 13.1671 11.9871 12.9741 11.7677C12.7949 11.5484 12.7052 11.2516 12.7052 10.8774C12.7052 10.2968 12.9396 9.83871 13.4084 9.50323C13.8773 9.16774 14.5046 9 15.2906 9C15.7456 9 16.173 9.04516 16.5729 9.13548C16.9865 9.22581 17.2968 9.36129 17.5036 9.54194C17.6967 9.70968 17.7932 9.90323 17.7932 10.1226C17.7932 10.3161 17.7173 10.4903 17.5657 10.6452C17.414 10.8 17.221 10.8774 16.9865 10.8774C16.8625 10.8774 16.7453 10.8516 16.6349 10.8C16.4695 10.6968 16.2558 10.6194 15.9938 10.5677C15.7456 10.5161 15.4905 10.4903 15.2285 10.4903C14.7046 10.4903 14.4426 10.5935 14.4426 10.8C14.4426 10.8903 14.4908 10.9742 14.5874 11.0516C14.6977 11.1161 14.939 11.1742 15.3112 11.2258C15.5457 11.2516 15.8145 11.2903 16.1179 11.3419C16.4212 11.3806 16.7108 11.4581 16.9865 11.5742C17.2761 11.6774 17.5174 11.8516 17.7104 12.0968C17.9035 12.3419 18 12.6774 18 13.1032C18 13.6839 17.7518 14.1484 17.2554 14.4968C16.759 14.8323 16.1041 15 15.2906 15Z",
      fill: "#7D808C"
    }),
    /* @__PURE__ */ jsx118("path", {
      d: "M17.5036 9.54194L17.5365 9.50428C17.3208 9.31591 17.0015 9.17791 16.5838 9.08668C16.18 8.99548 15.7488 8.95 15.2906 8.95C14.4979 8.95 13.8592 9.11915 13.3793 9.46256C12.8973 9.80752 12.6552 10.2808 12.6552 10.8774C12.6552 11.2594 12.7468 11.5686 12.9354 11.7994L12.9354 11.7994L12.9366 11.8008C13.1347 12.0259 13.3754 12.1981 13.6579 12.317L13.6579 12.3171L13.6598 12.3178C13.9388 12.4222 14.2181 12.4941 14.4977 12.5334L14.498 12.5334C14.7879 12.5722 15.0233 12.5981 15.2039 12.6111C15.4299 12.6304 15.6131 12.6575 15.7544 12.6921C15.897 12.7271 15.9914 12.7684 16.0445 12.8126L16.0445 12.8127L16.0471 12.8146C16.161 12.8976 16.2127 12.9933 16.2127 13.1032C16.2127 13.1476 16.2 13.1847 16.1753 13.2165C16.1501 13.2491 16.1101 13.2789 16.0516 13.3041C15.9335 13.3548 15.7504 13.3823 15.4974 13.3823C15.2397 13.3823 14.9538 13.3505 14.6396 13.2867C14.3253 13.2099 14.0458 13.1205 13.8009 13.0188C13.685 12.9647 13.5678 12.9371 13.4498 12.9371C13.2007 12.9371 12.9876 13.0338 12.8131 13.2243L12.8131 13.2243L12.8117 13.2259C12.6531 13.4148 12.5725 13.626 12.5725 13.8581C12.5725 13.9703 12.6025 14.0873 12.6601 14.2085L12.66 14.2086L12.6611 14.2107C12.7213 14.3233 12.8179 14.4196 12.9476 14.5005L12.9476 14.5005L12.9485 14.501C13.5651 14.8682 14.3468 15.05 15.2906 15.05C16.1106 15.05 16.7763 14.8809 17.2834 14.5382L17.2834 14.5382L17.2841 14.5377C17.7932 14.1804 18.05 13.701 18.05 13.1032C18.05 12.6703 17.9519 12.3225 17.7497 12.0658C17.5513 11.8138 17.3026 11.6341 17.0047 11.5276C16.7253 11.4101 16.4321 11.3317 16.1252 11.2925C15.8219 11.2409 15.5526 11.2021 15.3174 11.1762C15.1325 11.1505 14.9811 11.1234 14.8628 11.0949C14.7458 11.0668 14.6647 11.0381 14.6157 11.0103C14.5285 10.9394 14.4926 10.8693 14.4926 10.8C14.4926 10.76 14.5049 10.7263 14.5299 10.6968C14.5556 10.6664 14.5968 10.6382 14.6574 10.6143C14.7795 10.5662 14.9684 10.5403 15.2285 10.5403C15.4872 10.5403 15.7389 10.5658 15.9836 10.6167L15.9841 10.6168C16.2422 10.6676 16.4497 10.7434 16.6085 10.8424L16.6083 10.8427L16.6138 10.8453C16.7308 10.9001 16.8553 10.9274 16.9865 10.9274C17.2332 10.9274 17.4395 10.8454 17.6014 10.6802C17.761 10.5172 17.8432 10.3308 17.8432 10.1226C17.8432 9.88629 17.7384 9.67969 17.5364 9.50419L17.5036 9.54194ZM17.5036 9.54194C17.6967 9.70968 17.7932 9.90323 17.7932 10.1226C17.7932 10.3161 17.7173 10.4903 17.5657 10.6452C17.414 10.8 17.221 10.8774 16.9865 10.8774C16.8625 10.8774 16.7453 10.8516 16.6349 10.8M17.5036 9.54194C17.2968 9.36129 16.9865 9.22581 16.5729 9.13548C16.173 9.04516 15.7456 9 15.2906 9C14.5046 9 13.8773 9.16774 13.4084 9.50323C12.9396 9.83871 12.7052 10.2968 12.7052 10.8774C12.7052 11.2516 12.7949 11.5484 12.9741 11.7677L16.6349 10.8M16.6349 10.8C16.4695 10.6968 16.2558 10.6194 15.9938 10.5677L16.6349 10.8ZM7.63247 14.6771L7.63296 14.6773C8.15005 14.9258 8.70211 15.05 9.28855 15.05C9.69358 15.05 10.1051 14.9847 10.5228 14.8545C10.9565 14.7365 11.3619 14.5336 11.7387 14.2462L11.7389 14.2464L11.7426 14.243C11.8564 14.1364 11.9375 14.0274 11.9823 13.9154L11.9824 13.9154L11.983 13.9136C12.0257 13.7939 12.048 13.6848 12.048 13.5871C12.048 13.3539 11.9596 13.1483 11.7861 12.9721C11.6254 12.7947 11.4261 12.7048 11.1914 12.7048C11.0265 12.7048 10.858 12.768 10.6869 12.8881L10.6869 12.888L10.6848 12.8897C10.265 13.2192 9.8206 13.3823 9.3506 13.3823C8.9343 13.3823 8.57345 13.257 8.26576 13.0068C7.96172 12.7468 7.80803 12.3875 7.80803 11.9226C7.80803 11.5229 7.94741 11.2084 8.22467 10.9736C8.50348 10.7376 8.86358 10.6177 9.30923 10.6177C9.49903 10.6177 9.66711 10.6368 9.81393 10.6743L9.81393 10.6743L9.81491 10.6745C9.97496 10.7119 10.1567 10.7809 10.3603 10.8824C10.4921 10.9641 10.6385 11.0048 10.7984 11.0048C11.046 11.0048 11.2524 10.9157 11.4139 10.7376C11.5866 10.5621 11.6757 10.3631 11.6757 10.1419C11.6757 9.88026 11.5642 9.66593 11.3459 9.50229C11.0775 9.29088 10.7603 9.14607 10.3953 9.06726C10.0333 8.98908 9.66433 8.95 9.28855 8.95C8.31392 8.95 7.51559 9.21731 6.89809 9.75566C6.27923 10.2823 5.96399 10.9997 5.95001 11.9025L5.95 11.9025V11.9032C5.95 12.5565 6.10368 13.1212 6.41315 13.5951C6.72138 14.0671 7.12805 14.428 7.63247 14.6771Z",
      stroke: "#7D808C",
      strokeWidth: 0.1
    })
  ]
});
var controlled_substance_gray_default = SvgComponent98;

// src/components/icon/static/controlled-substance-secondary.svg
import * as React99 from "react";
import { jsx as jsx119, jsxs as jsxs3 } from "react/jsx-runtime";
var SvgComponent99 = (props) => /* @__PURE__ */ jsxs3("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: [
    /* @__PURE__ */ jsx119("path", {
      d: "M12.2033 22.4065C10.7881 22.4065 9.46018 22.1389 8.21965 21.6036C6.97912 21.0683 5.90002 20.3418 4.98237 19.4242C4.06472 18.5065 3.33825 17.4274 2.80295 16.1869C2.26765 14.9464 2 13.6185 2 12.2033C2 10.7881 2.26765 9.46018 2.80295 8.21965C3.33825 6.97912 4.06472 5.90002 4.98237 4.98237C5.90002 4.06472 6.97912 3.33825 8.21965 2.80295C9.46018 2.26765 10.7881 2 12.2033 2C13.6185 2 14.9464 2.26765 16.1869 2.80295C17.4274 3.33825 18.5065 4.06472 19.4242 4.98237C20.3418 5.90002 21.0683 6.97912 21.6036 8.21965C22.1389 9.46018 22.4065 10.7881 22.4065 12.2033C22.4065 13.6185 22.1389 14.9464 21.6036 16.1869C21.0683 17.4274 20.3418 18.5065 19.4242 19.4242C18.5065 20.3418 17.4274 21.0683 16.1869 21.6036C14.9464 22.1389 13.6185 22.4065 12.2033 22.4065ZM12.2033 20.1315C14.4207 20.1315 16.2964 19.3645 17.8304 17.8304C19.3645 16.2964 20.1315 14.4207 20.1315 12.2033C20.1315 9.98589 19.3645 8.11017 17.8304 6.5761C16.2964 5.04205 14.4207 4.27502 12.2033 4.27502C9.98589 4.27502 8.11017 5.04205 6.5761 6.5761C5.04205 8.11017 4.27502 9.98589 4.27502 12.2033C4.27502 14.4207 5.04205 16.2964 6.5761 17.8304C8.11017 19.3645 9.98589 20.1315 12.2033 20.1315Z",
      fill: "#8F3781"
    }),
    /* @__PURE__ */ jsx119("path", {
      d: "M9.28855 15C8.70943 15 8.16479 14.8774 7.65462 14.6323C7.15823 14.3871 6.75837 14.0323 6.45502 13.5677C6.15167 13.1032 6 12.5484 6 11.9032C6.01379 11.0129 6.32403 10.3097 6.93072 9.79355C7.53741 9.26452 8.32336 9 9.28855 9C9.66084 9 10.0262 9.03871 10.3847 9.11613C10.7432 9.19355 11.0535 9.33548 11.3155 9.54194C11.5223 9.69677 11.6257 9.89677 11.6257 10.1419C11.6257 10.3484 11.543 10.5355 11.3775 10.7032C11.2258 10.871 11.0328 10.9548 10.7984 10.9548C10.6467 10.9548 10.5088 10.9161 10.3847 10.8387C10.1779 10.7355 9.99176 10.6645 9.8263 10.6258C9.67462 10.5871 9.50227 10.5677 9.30923 10.5677C8.85421 10.5677 8.48192 10.6903 8.19237 10.9355C7.90281 11.1806 7.75803 11.5097 7.75803 11.9226C7.75803 12.4 7.9166 12.7742 8.23373 13.0452C8.55087 13.3032 8.92315 13.4323 9.3506 13.4323C9.83319 13.4323 10.2882 13.2645 10.7157 12.929C10.8811 12.8129 11.0397 12.7548 11.1914 12.7548C11.412 12.7548 11.5981 12.8387 11.7498 13.0065C11.9152 13.1742 11.998 13.3677 11.998 13.5871C11.998 13.6774 11.9773 13.7806 11.9359 13.8968C11.8946 14 11.8187 14.1032 11.7084 14.2065C11.3361 14.4903 10.9363 14.6903 10.5088 14.8065C10.0952 14.9355 9.68841 15 9.28855 15Z",
      fill: "#8F3781"
    }),
    /* @__PURE__ */ jsx119("path", {
      d: "M15.2906 15C14.353 15 13.5808 14.8194 12.9741 14.4581C12.85 14.3806 12.7604 14.2903 12.7052 14.1871C12.6501 14.071 12.6225 13.9613 12.6225 13.8581C12.6225 13.6387 12.6983 13.4387 12.85 13.2581C13.0155 13.0774 13.2154 12.9871 13.4498 12.9871C13.5601 12.9871 13.6704 13.0129 13.7807 13.0645C14.0289 13.1677 14.3116 13.2581 14.6287 13.3355C14.9459 13.4 15.2354 13.4323 15.4974 13.4323C16.0076 13.4323 16.2627 13.3226 16.2627 13.1032C16.2627 12.9742 16.2006 12.8645 16.0765 12.7742C15.9524 12.671 15.6629 12.6 15.2078 12.5613C15.0286 12.5484 14.7942 12.5226 14.5046 12.4839C14.2289 12.4452 13.9531 12.3742 13.6773 12.271C13.4015 12.1548 13.1671 11.9871 12.9741 11.7677C12.7949 11.5484 12.7052 11.2516 12.7052 10.8774C12.7052 10.2968 12.9396 9.83871 13.4084 9.50323C13.8773 9.16774 14.5046 9 15.2906 9C15.7456 9 16.173 9.04516 16.5729 9.13548C16.9865 9.22581 17.2968 9.36129 17.5036 9.54194C17.6967 9.70968 17.7932 9.90323 17.7932 10.1226C17.7932 10.3161 17.7173 10.4903 17.5657 10.6452C17.414 10.8 17.221 10.8774 16.9865 10.8774C16.8625 10.8774 16.7453 10.8516 16.6349 10.8C16.4695 10.6968 16.2558 10.6194 15.9938 10.5677C15.7456 10.5161 15.4905 10.4903 15.2285 10.4903C14.7046 10.4903 14.4426 10.5935 14.4426 10.8C14.4426 10.8903 14.4908 10.9742 14.5874 11.0516C14.6977 11.1161 14.939 11.1742 15.3112 11.2258C15.5457 11.2516 15.8145 11.2903 16.1179 11.3419C16.4212 11.3806 16.7108 11.4581 16.9865 11.5742C17.2761 11.6774 17.5174 11.8516 17.7104 12.0968C17.9035 12.3419 18 12.6774 18 13.1032C18 13.6839 17.7518 14.1484 17.2554 14.4968C16.759 14.8323 16.1041 15 15.2906 15Z",
      fill: "#8F3781"
    }),
    /* @__PURE__ */ jsx119("path", {
      d: "M17.5036 9.54194L17.5365 9.50428C17.3208 9.31591 17.0015 9.17791 16.5838 9.08668C16.18 8.99548 15.7488 8.95 15.2906 8.95C14.4979 8.95 13.8592 9.11915 13.3793 9.46256C12.8973 9.80752 12.6552 10.2808 12.6552 10.8774C12.6552 11.2594 12.7468 11.5686 12.9354 11.7994L12.9354 11.7994L12.9366 11.8008C13.1347 12.0259 13.3754 12.1981 13.6579 12.317L13.6579 12.3171L13.6598 12.3178C13.9388 12.4222 14.2181 12.4941 14.4977 12.5334L14.498 12.5334C14.7879 12.5722 15.0233 12.5981 15.2039 12.6111C15.4299 12.6304 15.6131 12.6575 15.7544 12.6921C15.897 12.7271 15.9914 12.7684 16.0445 12.8126L16.0445 12.8127L16.0471 12.8146C16.161 12.8976 16.2127 12.9933 16.2127 13.1032C16.2127 13.1476 16.2 13.1847 16.1753 13.2165C16.1501 13.2491 16.1101 13.2789 16.0516 13.3041C15.9335 13.3548 15.7504 13.3823 15.4974 13.3823C15.2397 13.3823 14.9538 13.3505 14.6396 13.2867C14.3253 13.2099 14.0458 13.1205 13.8009 13.0188C13.685 12.9647 13.5678 12.9371 13.4498 12.9371C13.2007 12.9371 12.9876 13.0338 12.8131 13.2243L12.8131 13.2243L12.8117 13.2259C12.6531 13.4148 12.5725 13.626 12.5725 13.8581C12.5725 13.9703 12.6025 14.0873 12.6601 14.2085L12.66 14.2086L12.6611 14.2107C12.7213 14.3233 12.8179 14.4196 12.9476 14.5005L12.9476 14.5005L12.9485 14.501C13.5651 14.8682 14.3468 15.05 15.2906 15.05C16.1106 15.05 16.7763 14.8809 17.2834 14.5382L17.2834 14.5382L17.2841 14.5377C17.7932 14.1804 18.05 13.701 18.05 13.1032C18.05 12.6703 17.9519 12.3225 17.7497 12.0658C17.5513 11.8138 17.3026 11.6341 17.0047 11.5276C16.7253 11.4101 16.4321 11.3317 16.1252 11.2925C15.8219 11.2409 15.5526 11.2021 15.3174 11.1762C15.1325 11.1505 14.9811 11.1234 14.8628 11.0949C14.7458 11.0668 14.6647 11.0381 14.6157 11.0103C14.5285 10.9394 14.4926 10.8693 14.4926 10.8C14.4926 10.76 14.5049 10.7263 14.5299 10.6968C14.5556 10.6664 14.5968 10.6382 14.6574 10.6143C14.7795 10.5662 14.9684 10.5403 15.2285 10.5403C15.4872 10.5403 15.7389 10.5658 15.9836 10.6167L15.9841 10.6168C16.2422 10.6676 16.4497 10.7434 16.6085 10.8424L16.6083 10.8427L16.6138 10.8453C16.7308 10.9001 16.8553 10.9274 16.9865 10.9274C17.2332 10.9274 17.4395 10.8454 17.6014 10.6802C17.761 10.5172 17.8432 10.3308 17.8432 10.1226C17.8432 9.88629 17.7384 9.67969 17.5364 9.50419L17.5036 9.54194ZM17.5036 9.54194C17.6967 9.70968 17.7932 9.90323 17.7932 10.1226C17.7932 10.3161 17.7173 10.4903 17.5657 10.6452C17.414 10.8 17.221 10.8774 16.9865 10.8774C16.8625 10.8774 16.7453 10.8516 16.6349 10.8M17.5036 9.54194C17.2968 9.36129 16.9865 9.22581 16.5729 9.13548C16.173 9.04516 15.7456 9 15.2906 9C14.5046 9 13.8773 9.16774 13.4084 9.50323C12.9396 9.83871 12.7052 10.2968 12.7052 10.8774C12.7052 11.2516 12.7949 11.5484 12.9741 11.7677L16.6349 10.8M16.6349 10.8C16.4695 10.6968 16.2558 10.6194 15.9938 10.5677L16.6349 10.8ZM7.63247 14.6771L7.63296 14.6773C8.15005 14.9258 8.70211 15.05 9.28855 15.05C9.69358 15.05 10.1051 14.9847 10.5228 14.8545C10.9565 14.7365 11.3619 14.5336 11.7387 14.2462L11.7389 14.2464L11.7426 14.243C11.8564 14.1364 11.9375 14.0274 11.9823 13.9154L11.9824 13.9154L11.983 13.9136C12.0257 13.7939 12.048 13.6848 12.048 13.5871C12.048 13.3539 11.9596 13.1483 11.7861 12.9721C11.6254 12.7947 11.4261 12.7048 11.1914 12.7048C11.0265 12.7048 10.858 12.768 10.6869 12.8881L10.6869 12.888L10.6848 12.8897C10.265 13.2192 9.8206 13.3823 9.3506 13.3823C8.9343 13.3823 8.57345 13.257 8.26576 13.0068C7.96172 12.7468 7.80803 12.3875 7.80803 11.9226C7.80803 11.5229 7.94741 11.2084 8.22467 10.9736C8.50348 10.7376 8.86358 10.6177 9.30923 10.6177C9.49903 10.6177 9.66711 10.6368 9.81393 10.6743L9.81393 10.6743L9.81491 10.6745C9.97496 10.7119 10.1567 10.7809 10.3603 10.8824C10.4921 10.9641 10.6385 11.0048 10.7984 11.0048C11.046 11.0048 11.2524 10.9157 11.4139 10.7376C11.5866 10.5621 11.6757 10.3631 11.6757 10.1419C11.6757 9.88026 11.5642 9.66593 11.3459 9.50229C11.0775 9.29088 10.7603 9.14607 10.3953 9.06726C10.0333 8.98908 9.66433 8.95 9.28855 8.95C8.31392 8.95 7.51559 9.21731 6.89809 9.75566C6.27923 10.2823 5.96399 10.9997 5.95001 11.9025L5.95 11.9025V11.9032C5.95 12.5565 6.10368 13.1212 6.41315 13.5951C6.72138 14.0671 7.12805 14.428 7.63247 14.6771Z",
      stroke: "#8F3781",
      strokeWidth: 0.1
    })
  ]
});
var controlled_substance_secondary_default = SvgComponent99;

// src/components/icon/static/controlled-substance.svg
import * as React100 from "react";
import { jsx as jsx120, jsxs as jsxs4 } from "react/jsx-runtime";
var SvgComponent100 = (props) => /* @__PURE__ */ jsxs4("svg", {
  width: 24,
  height: 25,
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: [
    /* @__PURE__ */ jsx120("path", {
      d: "M12.2033 22.9065C10.7881 22.9065 9.46018 22.6389 8.21965 22.1036C6.97912 21.5683 5.90002 20.8418 4.98237 19.9242C4.06472 19.0065 3.33825 17.9274 2.80295 16.6869C2.26765 15.4464 2 14.1185 2 12.7033C2 11.2881 2.26765 9.96018 2.80295 8.71965C3.33825 7.47912 4.06472 6.40002 4.98237 5.48237C5.90002 4.56472 6.97912 3.83825 8.21965 3.30295C9.46018 2.76765 10.7881 2.5 12.2033 2.5C13.6185 2.5 14.9464 2.76765 16.1869 3.30295C17.4274 3.83825 18.5065 4.56472 19.4242 5.48237C20.3418 6.40002 21.0683 7.47912 21.6036 8.71965C22.1389 9.96018 22.4065 11.2881 22.4065 12.7033C22.4065 14.1185 22.1389 15.4464 21.6036 16.6869C21.0683 17.9274 20.3418 19.0065 19.4242 19.9242C18.5065 20.8418 17.4274 21.5683 16.1869 22.1036C14.9464 22.6389 13.6185 22.9065 12.2033 22.9065ZM12.2033 20.6315C14.4207 20.6315 16.2964 19.8645 17.8304 18.3304C19.3645 16.7964 20.1315 14.9207 20.1315 12.7033C20.1315 10.4859 19.3645 8.61017 17.8304 7.0761C16.2964 5.54205 14.4207 4.77502 12.2033 4.77502C9.98589 4.77502 8.11017 5.54205 6.5761 7.0761C5.04205 8.61017 4.27502 10.4859 4.27502 12.7033C4.27502 14.9207 5.04205 16.7964 6.5761 18.3304C8.11017 19.8645 9.98589 20.6315 12.2033 20.6315Z",
      fill: "#6341A3"
    }),
    /* @__PURE__ */ jsx120("path", {
      d: "M9.28855 15.5C8.70943 15.5 8.16479 15.3774 7.65462 15.1323C7.15823 14.8871 6.75837 14.5323 6.45502 14.0677C6.15167 13.6032 6 13.0484 6 12.4032C6.01379 11.5129 6.32403 10.8097 6.93072 10.2935C7.53741 9.76452 8.32336 9.5 9.28855 9.5C9.66084 9.5 10.0262 9.53871 10.3847 9.61613C10.7432 9.69355 11.0535 9.83548 11.3155 10.0419C11.5223 10.1968 11.6257 10.3968 11.6257 10.6419C11.6257 10.8484 11.543 11.0355 11.3775 11.2032C11.2258 11.371 11.0328 11.4548 10.7984 11.4548C10.6467 11.4548 10.5088 11.4161 10.3847 11.3387C10.1779 11.2355 9.99176 11.1645 9.8263 11.1258C9.67462 11.0871 9.50227 11.0677 9.30923 11.0677C8.85421 11.0677 8.48192 11.1903 8.19237 11.4355C7.90281 11.6806 7.75803 12.0097 7.75803 12.4226C7.75803 12.9 7.9166 13.2742 8.23373 13.5452C8.55087 13.8032 8.92315 13.9323 9.3506 13.9323C9.83319 13.9323 10.2882 13.7645 10.7157 13.429C10.8811 13.3129 11.0397 13.2548 11.1914 13.2548C11.412 13.2548 11.5981 13.3387 11.7498 13.5065C11.9152 13.6742 11.998 13.8677 11.998 14.0871C11.998 14.1774 11.9773 14.2806 11.9359 14.3968C11.8946 14.5 11.8187 14.6032 11.7084 14.7065C11.3361 14.9903 10.9363 15.1903 10.5088 15.3065C10.0952 15.4355 9.68841 15.5 9.28855 15.5Z",
      fill: "#6341A3"
    }),
    /* @__PURE__ */ jsx120("path", {
      d: "M15.2906 15.5C14.353 15.5 13.5808 15.3194 12.9741 14.9581C12.85 14.8806 12.7604 14.7903 12.7052 14.6871C12.6501 14.571 12.6225 14.4613 12.6225 14.3581C12.6225 14.1387 12.6983 13.9387 12.85 13.7581C13.0155 13.5774 13.2154 13.4871 13.4498 13.4871C13.5601 13.4871 13.6704 13.5129 13.7807 13.5645C14.0289 13.6677 14.3116 13.7581 14.6287 13.8355C14.9459 13.9 15.2354 13.9323 15.4974 13.9323C16.0076 13.9323 16.2627 13.8226 16.2627 13.6032C16.2627 13.4742 16.2006 13.3645 16.0765 13.2742C15.9524 13.171 15.6629 13.1 15.2078 13.0613C15.0286 13.0484 14.7942 13.0226 14.5046 12.9839C14.2289 12.9452 13.9531 12.8742 13.6773 12.771C13.4015 12.6548 13.1671 12.4871 12.9741 12.2677C12.7949 12.0484 12.7052 11.7516 12.7052 11.3774C12.7052 10.7968 12.9396 10.3387 13.4084 10.0032C13.8773 9.66774 14.5046 9.5 15.2906 9.5C15.7456 9.5 16.173 9.54516 16.5729 9.63548C16.9865 9.72581 17.2968 9.86129 17.5036 10.0419C17.6967 10.2097 17.7932 10.4032 17.7932 10.6226C17.7932 10.8161 17.7173 10.9903 17.5657 11.1452C17.414 11.3 17.221 11.3774 16.9865 11.3774C16.8625 11.3774 16.7453 11.3516 16.6349 11.3C16.4695 11.1968 16.2558 11.1194 15.9938 11.0677C15.7456 11.0161 15.4905 10.9903 15.2285 10.9903C14.7046 10.9903 14.4426 11.0935 14.4426 11.3C14.4426 11.3903 14.4908 11.4742 14.5874 11.5516C14.6977 11.6161 14.939 11.6742 15.3112 11.7258C15.5457 11.7516 15.8145 11.7903 16.1179 11.8419C16.4212 11.8806 16.7108 11.9581 16.9865 12.0742C17.2761 12.1774 17.5174 12.3516 17.7104 12.5968C17.9035 12.8419 18 13.1774 18 13.6032C18 14.1839 17.7518 14.6484 17.2554 14.9968C16.759 15.3323 16.1041 15.5 15.2906 15.5Z",
      fill: "#6341A3"
    }),
    /* @__PURE__ */ jsx120("path", {
      d: "M17.5036 10.0419L17.5365 10.0043C17.3208 9.81591 17.0015 9.67791 16.5838 9.58668C16.18 9.49548 15.7488 9.45 15.2906 9.45C14.4979 9.45 13.8592 9.61915 13.3793 9.96256C12.8973 10.3075 12.6552 10.7808 12.6552 11.3774C12.6552 11.7594 12.7468 12.0686 12.9354 12.2994L12.9354 12.2994L12.9366 12.3008C13.1347 12.5259 13.3754 12.6981 13.6579 12.817L13.6579 12.8171L13.6598 12.8178C13.9388 12.9222 14.2181 12.9941 14.4977 13.0334L14.498 13.0334C14.7879 13.0722 15.0233 13.0981 15.2039 13.1111C15.4299 13.1304 15.6131 13.1575 15.7544 13.1921C15.897 13.2271 15.9914 13.2684 16.0445 13.3126L16.0445 13.3127L16.0471 13.3146C16.161 13.3976 16.2127 13.4933 16.2127 13.6032C16.2127 13.6476 16.2 13.6847 16.1753 13.7165C16.1501 13.7491 16.1101 13.7789 16.0516 13.8041C15.9335 13.8548 15.7504 13.8823 15.4974 13.8823C15.2397 13.8823 14.9538 13.8505 14.6396 13.7867C14.3253 13.7099 14.0458 13.6205 13.8009 13.5188C13.685 13.4647 13.5678 13.4371 13.4498 13.4371C13.2007 13.4371 12.9876 13.5338 12.8131 13.7243L12.8131 13.7243L12.8117 13.7259C12.6531 13.9148 12.5725 14.126 12.5725 14.3581C12.5725 14.4703 12.6025 14.5873 12.6601 14.7085L12.66 14.7086L12.6611 14.7107C12.7213 14.8233 12.8179 14.9196 12.9476 15.0005L12.9476 15.0005L12.9485 15.001C13.5651 15.3682 14.3468 15.55 15.2906 15.55C16.1106 15.55 16.7763 15.3809 17.2834 15.0382L17.2834 15.0382L17.2841 15.0377C17.7932 14.6804 18.05 14.201 18.05 13.6032C18.05 13.1703 17.9519 12.8225 17.7497 12.5658C17.5513 12.3138 17.3026 12.1341 17.0047 12.0276C16.7253 11.9101 16.4321 11.8317 16.1252 11.7925C15.8219 11.7409 15.5526 11.7021 15.3174 11.6762C15.1325 11.6505 14.9811 11.6234 14.8628 11.5949C14.7458 11.5668 14.6647 11.5381 14.6157 11.5103C14.5285 11.4394 14.4926 11.3693 14.4926 11.3C14.4926 11.26 14.5049 11.2263 14.5299 11.1968C14.5556 11.1664 14.5968 11.1382 14.6574 11.1143C14.7795 11.0662 14.9684 11.0403 15.2285 11.0403C15.4872 11.0403 15.7389 11.0658 15.9836 11.1167L15.9841 11.1168C16.2422 11.1676 16.4497 11.2434 16.6085 11.3424L16.6083 11.3427L16.6138 11.3453C16.7308 11.4001 16.8553 11.4274 16.9865 11.4274C17.2332 11.4274 17.4395 11.3454 17.6014 11.1802C17.761 11.0172 17.8432 10.8308 17.8432 10.6226C17.8432 10.3863 17.7384 10.1797 17.5364 10.0042L17.5036 10.0419ZM17.5036 10.0419C17.6967 10.2097 17.7932 10.4032 17.7932 10.6226C17.7932 10.8161 17.7173 10.9903 17.5657 11.1452C17.414 11.3 17.221 11.3774 16.9865 11.3774C16.8625 11.3774 16.7453 11.3516 16.6349 11.3M17.5036 10.0419C17.2968 9.86129 16.9865 9.72581 16.5729 9.63548C16.173 9.54516 15.7456 9.5 15.2906 9.5C14.5046 9.5 13.8773 9.66774 13.4084 10.0032C12.9396 10.3387 12.7052 10.7968 12.7052 11.3774C12.7052 11.7516 12.7949 12.0484 12.9741 12.2677L16.6349 11.3M16.6349 11.3C16.4695 11.1968 16.2558 11.1194 15.9938 11.0677L16.6349 11.3ZM7.63247 15.1771L7.63296 15.1773C8.15005 15.4258 8.70211 15.55 9.28855 15.55C9.69358 15.55 10.1051 15.4847 10.5228 15.3545C10.9565 15.2365 11.3619 15.0336 11.7387 14.7462L11.7389 14.7464L11.7426 14.743C11.8564 14.6364 11.9375 14.5274 11.9823 14.4154L11.9824 14.4154L11.983 14.4136C12.0257 14.2939 12.048 14.1848 12.048 14.0871C12.048 13.8539 11.9596 13.6483 11.7861 13.4721C11.6254 13.2947 11.4261 13.2048 11.1914 13.2048C11.0265 13.2048 10.858 13.268 10.6869 13.3881L10.6869 13.388L10.6848 13.3897C10.265 13.7192 9.8206 13.8823 9.3506 13.8823C8.9343 13.8823 8.57345 13.757 8.26576 13.5068C7.96172 13.2468 7.80803 12.8875 7.80803 12.4226C7.80803 12.0229 7.94741 11.7084 8.22467 11.4736C8.50348 11.2376 8.86358 11.1177 9.30923 11.1177C9.49903 11.1177 9.66711 11.1368 9.81393 11.1743L9.81393 11.1743L9.81491 11.1745C9.97496 11.2119 10.1567 11.2809 10.3603 11.3824C10.4921 11.4641 10.6385 11.5048 10.7984 11.5048C11.046 11.5048 11.2524 11.4157 11.4139 11.2376C11.5866 11.0621 11.6757 10.8631 11.6757 10.6419C11.6757 10.3803 11.5642 10.1659 11.3459 10.0023C11.0775 9.79088 10.7603 9.64607 10.3953 9.56726C10.0333 9.48908 9.66433 9.45 9.28855 9.45C8.31392 9.45 7.51559 9.71731 6.89809 10.2557C6.27923 10.7823 5.96399 11.4997 5.95001 12.4025L5.95 12.4025V12.4032C5.95 13.0565 6.10368 13.6212 6.41315 14.0951C6.72138 14.5671 7.12805 14.928 7.63247 15.1771Z",
      stroke: "#6341A3",
      strokeWidth: 0.1
    })
  ]
});
var controlled_substance_default = SvgComponent100;

// src/components/icon/variants/IconControlledSubstance.tsx
import { jsx as jsx121 } from "react/jsx-runtime";
var IconControlledSubstance = ({
  color,
  height,
  style = {},
  width
}) => {
  const { t } = useTranslation21("pds");
  return /* @__PURE__ */ jsx121(Icon, {
    SvgIcon: color === "secondary" ? controlled_substance_secondary_default : color === "gray" ? controlled_substance_gray_default : controlled_substance_default,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/delete-fill.svg
import * as React101 from "react";
import { jsx as jsx122 } from "react/jsx-runtime";
var SvgComponent101 = (props) => /* @__PURE__ */ jsx122("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx122("path", {
    d: "M253-95q-39.46 0-67.23-27.47Q158-149.95 158-189v-553h-58v-94h231v-48h297v48h232v94h-58v553q0 39.05-27.77 66.53Q746.46-95 707-95H253Zm101-172h77v-399h-77v399Zm175 0h78v-399h-78v399Z"
  })
});
var delete_fill_default = SvgComponent101;

// ../../../node_modules/@material-symbols/svg-700/outlined/delete.svg
import * as React102 from "react";
import { jsx as jsx123 } from "react/jsx-runtime";
var SvgComponent102 = (props) => /* @__PURE__ */ jsx123("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx123("path", {
    d: "M253-95q-40.21 0-67.61-27.1Q158-149.2 158-189v-553h-58v-94h231v-48h297v48h232v94h-58v553q0 39.05-27.77 66.53Q746.46-95 707-95H253Zm454-647H253v553h454v-553ZM354-267h77v-399h-77v399Zm175 0h78v-399h-78v399ZM253-742v553-553Z"
  })
});
var delete_default = SvgComponent102;

// ../../../node_modules/@material-symbols/svg-700/rounded/delete-fill.svg
import * as React103 from "react";
import { jsx as jsx124 } from "react/jsx-runtime";
var SvgComponent103 = (props) => /* @__PURE__ */ jsx124("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx124("path", {
    d: "M253-95q-40.21 0-67.61-27.1Q158-149.2 158-189v-553h-11q-19.75 0-33.37-13.68Q100-769.35 100-789.18q0-19.82 13.63-33.32Q127.25-836 147-836h184q0-20 13.63-34 13.62-14 33.37-14h203q19.75 0 33.38 14.19Q628-855.63 628-836h185q19.75 0 33.38 13.68Q860-808.65 860-788.82q0 19.82-13.62 33.32Q832.75-742 813-742h-11v553q0 39.8-27.39 66.9Q747.21-95 707-95H253Zm139.68-172Q409-267 420-278.26T431-305v-323q0-15.47-11.31-26.74Q408.37-666 392.82-666 376-666 365-654.74q-11 11.27-11 26.74v323q0 15.48 11.18 26.74Q376.35-267 392.68-267Zm175.69 0q15.63 0 27.13-11.26Q607-289.52 607-305v-323q0-15.47-11.57-26.74Q583.86-666 567.93-666t-27.43 11.26Q529-643.47 529-628v323q0 15.48 11.87 26.74Q552.74-267 568.37-267Z"
  })
});
var delete_fill_default2 = SvgComponent103;

// ../../../node_modules/@material-symbols/svg-700/rounded/delete.svg
import * as React104 from "react";
import { jsx as jsx125 } from "react/jsx-runtime";
var SvgComponent104 = (props) => /* @__PURE__ */ jsx125("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx125("path", {
    d: "M253-95q-40.21 0-67.61-27.1Q158-149.2 158-189v-553h-11q-19.75 0-33.37-13.68Q100-769.35 100-789.18q0-19.82 13.63-33.32Q127.25-836 147-836h184q0-20 13.63-34 13.62-14 33.37-14h203q19.75 0 33.38 14.19Q628-855.63 628-836h185q19.75 0 33.38 13.68Q860-808.65 860-788.82q0 19.82-13.62 33.32Q832.75-742 813-742h-11v553q0 39.8-27.39 66.9Q747.21-95 707-95H253Zm454-647H253v553h454v-553ZM392.68-267Q409-267 420-278.26T431-305v-323q0-15.47-11.31-26.74Q408.37-666 392.82-666 376-666 365-654.74q-11 11.27-11 26.74v323q0 15.48 11.18 26.74Q376.35-267 392.68-267Zm175.69 0q15.63 0 27.13-11.26Q607-289.52 607-305v-323q0-15.47-11.57-26.74Q583.86-666 567.93-666t-27.43 11.26Q529-643.47 529-628v323q0 15.48 11.87 26.74Q552.74-267 568.37-267ZM253-742v553-553Z"
  })
});
var delete_default2 = SvgComponent104;

// ../../../node_modules/@material-symbols/svg-700/sharp/delete-fill.svg
import * as React105 from "react";
import { jsx as jsx126 } from "react/jsx-runtime";
var SvgComponent105 = (props) => /* @__PURE__ */ jsx126("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx126("path", {
    d: "M354-267h77v-399h-77v399Zm175 0h78v-399h-78v399ZM158-95v-647h-58v-94h231v-48h297v48h232v94h-58v647H158Z"
  })
});
var delete_fill_default3 = SvgComponent105;

// ../../../node_modules/@material-symbols/svg-700/sharp/delete.svg
import * as React106 from "react";
import { jsx as jsx127 } from "react/jsx-runtime";
var SvgComponent106 = (props) => /* @__PURE__ */ jsx127("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx127("path", {
    d: "M158-95v-647h-58v-94h231v-48h297v48h232v94h-58v647H158Zm95-94h454v-553H253v553Zm101-78h77v-399h-77v399Zm175 0h78v-399h-78v399ZM253-742v553-553Z"
  })
});
var delete_default3 = SvgComponent106;

// src/components/icon/variants/IconDelete.tsx
import { useTranslation as useTranslation22 } from "react-i18next";
import { jsx as jsx128 } from "react/jsx-runtime";
var componentMap17 = {
  outlined: delete_default,
  "outlined-fill": delete_fill_default,
  rounded: delete_default2,
  "rounded-fill": delete_fill_default2,
  sharp: delete_default3,
  "sharp-fill": delete_fill_default3
};
var IconDelete = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation22("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap17[key] ?? componentMap17[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx128(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// src/components/icon/variants/IconDeliverBox.tsx
import { useTranslation as useTranslation23 } from "react-i18next";

// src/components/icon/static/deliver-box.svg
import * as React107 from "react";
import { jsx as jsx129 } from "react/jsx-runtime";
var SvgComponent107 = (props) => /* @__PURE__ */ jsx129("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /* @__PURE__ */ jsx129("path", {
    d: "M1.93438 20.3824C1.61521 20.3824 1.34579 20.2726 1.12613 20.0531C0.906625 19.8336 0.796875 19.5642 0.796875 19.2449C0.796875 18.9257 0.906625 18.6564 1.12613 18.4369C1.34579 18.2172 1.61521 18.1074 1.93438 18.1074H5.79688V16.3226H2.93438C2.61521 16.3226 2.34579 16.2129 2.12612 15.9934C1.90662 15.7739 1.79688 15.5045 1.79688 15.1851C1.79688 14.866 1.90662 14.5966 2.12612 14.3771C2.34579 14.1575 2.61521 14.0476 2.93438 14.0476H5.79688V12.2569H3.98437C3.66521 12.2569 3.39579 12.1471 3.17613 11.9276C2.95663 11.708 2.84687 11.4385 2.84687 11.1194C2.84687 10.8002 2.95663 10.5309 3.17613 10.3114C3.39579 10.0917 3.66521 9.98187 3.98437 9.98187H5.79688V7.01987L4.26588 3.70212C4.13321 3.42012 4.12071 3.13204 4.22838 2.83787C4.33604 2.5437 4.53279 2.33028 4.81863 2.19762C5.10046 2.06512 5.38746 2.05262 5.67963 2.16012C5.97196 2.26778 6.18437 2.46254 6.31687 2.74437L8.30188 6.98187H19.6984L18.1676 3.70812C18.035 3.42212 18.0225 3.13204 18.1301 2.83787C18.2376 2.5437 18.4343 2.33028 18.7201 2.19762C19.0021 2.06512 19.2892 2.05262 19.5814 2.16012C19.8735 2.26778 20.086 2.46254 20.2186 2.74437L21.9794 6.52812C22.054 6.68145 22.11 6.83787 22.1474 6.99737C22.1847 7.15704 22.2034 7.32178 22.2034 7.49162V18.1074C22.2034 18.7372 21.9816 19.2739 21.5381 19.7174C21.0946 20.1607 20.558 20.3824 19.9284 20.3824H1.93438ZM12.0001 13.2569H16.0001C16.2955 13.2569 16.544 13.156 16.7456 12.9544C16.9471 12.7529 17.0479 12.5045 17.0479 12.2091C17.0479 11.9138 16.9471 11.6663 16.7456 11.4666C16.544 11.2671 16.2955 11.1674 16.0001 11.1674H12.0001C11.7048 11.1674 11.4563 11.2671 11.2546 11.4666C11.0531 11.6663 10.9524 11.9138 10.9524 12.2091C10.9524 12.5045 11.0531 12.7529 11.2546 12.9544C11.4563 13.156 11.7048 13.2569 12.0001 13.2569ZM8.07188 18.1074H19.9284V9.25687H8.07188V18.1074Z"
  })
});
var deliver_box_default = SvgComponent107;

// src/components/icon/variants/IconDeliverBox.tsx
import { jsx as jsx130 } from "react/jsx-runtime";
var IconDeliverBox = ({
  color,
  height,
  style = {},
  width
}) => {
  const { t } = useTranslation23("pds");
  return /* @__PURE__ */ jsx130(Icon, {
    SvgIcon: deliver_box_default,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/description-fill.svg
import * as React108 from "react";
import { jsx as jsx131 } from "react/jsx-runtime";
var SvgComponent108 = (props) => /* @__PURE__ */ jsx131("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx131("path", {
    d: "M319-248h322v-71H319v71Zm0-170h322v-71H319v71ZM229-55q-39.05 0-66.52-27.47Q135-109.95 135-149v-662q0-39.46 27.48-67.23Q189.95-906 229-906h363l234 234v523q0 39.05-27.77 66.53Q770.46-55 731-55H229Zm313-570h189L542-811v186Z"
  })
});
var description_fill_default = SvgComponent108;

// ../../../node_modules/@material-symbols/svg-700/outlined/description.svg
import * as React109 from "react";
import { jsx as jsx132 } from "react/jsx-runtime";
var SvgComponent109 = (props) => /* @__PURE__ */ jsx132("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx132("path", {
    d: "M319-248h322v-71H319v71Zm0-170h322v-71H319v71ZM229-55q-39.05 0-66.52-27.47Q135-109.95 135-149v-662q0-39.46 27.48-67.23Q189.95-906 229-906h363l234 234v523q0 39.05-27.77 66.53Q770.46-55 731-55H229Zm313-570v-186H229v662h502v-476H542ZM229-811v186-186 662-662Z"
  })
});
var description_default = SvgComponent109;

// ../../../node_modules/@material-symbols/svg-700/rounded/description-fill.svg
import * as React110 from "react";
import { jsx as jsx133 } from "react/jsx-runtime";
var SvgComponent110 = (props) => /* @__PURE__ */ jsx133("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx133("path", {
    d: "M355-248h251q14.9 0 24.95-10.57Q641-269.14 641-284.07T630.95-309Q620.9-319 606-319H354q-14.9 0-24.95 10.07-10.05 10.07-10.05 25t10.55 25.43Q340.1-248 355-248Zm0-170h251q14.9 0 24.95-10.57Q641-439.14 641-454.07T630.95-479Q620.9-489 606-489H354q-14.9 0-24.95 10.07-10.05 10.07-10.05 25t10.55 25.43Q340.1-418 355-418ZM229-55q-39.05 0-66.52-27.47Q135-109.95 135-149v-662q0-39.46 27.48-67.23Q189.95-906 229-906h323q19.31 0 37.16 8Q607-890 620-877l177 177q13 13 21 30.84 8 17.85 8 37.16v483q0 39.05-27.77 66.53Q770.46-55 731-55H229Zm313-617q0 19.75 13.63 33.37Q569.25-625 589-625h142L542-811v139Z"
  })
});
var description_fill_default2 = SvgComponent110;

// ../../../node_modules/@material-symbols/svg-700/rounded/description.svg
import * as React111 from "react";
import { jsx as jsx134 } from "react/jsx-runtime";
var SvgComponent111 = (props) => /* @__PURE__ */ jsx134("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx134("path", {
    d: "M355-248h251q14.88 0 24.94-10.37t10.06-25.7q0-14.91-10.06-24.92Q620.88-319 606-319H354q-14.87 0-24.94 10.09-10.06 10.09-10.06 25t10.35 25.41Q339.7-248 355-248Zm0-170h251q14.88 0 24.94-10.37t10.06-25.7q0-14.91-10.06-24.92Q620.88-489 606-489H354q-14.87 0-24.94 10.09-10.06 10.09-10.06 25t10.35 25.41Q339.7-418 355-418ZM229-55q-39.05 0-66.52-27.47Q135-109.95 135-149v-662q0-39.46 27.48-67.23Q189.95-906 229-906h323q19.56 0 37.28 8Q607-890 620-877l177 177q13 13 21 30.72t8 37.28v483q0 39.05-27.77 66.53Q770.46-55 731-55H229Zm313-617v-139H229v662h502v-476H589q-19.75 0-33.37-13.63Q542-652.25 542-672ZM229-811v186-186 662-662Z"
  })
});
var description_default2 = SvgComponent111;

// ../../../node_modules/@material-symbols/svg-700/sharp/description-fill.svg
import * as React112 from "react";
import { jsx as jsx135 } from "react/jsx-runtime";
var SvgComponent112 = (props) => /* @__PURE__ */ jsx135("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx135("path", {
    d: "M319-248h322v-71H319v71Zm0-170h322v-71H319v71ZM135-55v-851h457l234 234.3V-55H135Zm407-570h189L542-811v186Z"
  })
});
var description_fill_default3 = SvgComponent112;

// ../../../node_modules/@material-symbols/svg-700/sharp/description.svg
import * as React113 from "react";
import { jsx as jsx136 } from "react/jsx-runtime";
var SvgComponent113 = (props) => /* @__PURE__ */ jsx136("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx136("path", {
    d: "M319-248h322v-71H319v71Zm0-170h322v-71H319v71ZM135-55v-851h457l234 234.3V-55H135Zm407-570v-186H229v662h502v-476H542ZM229-811v186-186 662-662Z"
  })
});
var description_default3 = SvgComponent113;

// src/components/icon/variants/IconDescription.tsx
import { useTranslation as useTranslation24 } from "react-i18next";
import { jsx as jsx137 } from "react/jsx-runtime";
var componentMap18 = {
  outlined: description_default,
  "outlined-fill": description_fill_default,
  rounded: description_default2,
  "rounded-fill": description_fill_default2,
  sharp: description_default3,
  "sharp-fill": description_fill_default3
};
var IconDescription = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation24("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap18[key] ?? componentMap18[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx137(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/download-fill.svg
import * as React114 from "react";
import { jsx as jsx138 } from "react/jsx-runtime";
var SvgComponent114 = (props) => /* @__PURE__ */ jsx138("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx138("path", {
    d: "M480-322 251-551l68-66 114 114v-323h94v323l114-114 68 66-229 229ZM229-135q-39.05 0-66.52-27.48Q135-189.95 135-229v-143h94v143h502v-143h95v143q0 39-27.77 66.5T731-135H229Z"
  })
});
var download_fill_default = SvgComponent114;

// ../../../node_modules/@material-symbols/svg-700/outlined/download.svg
import * as React115 from "react";
import { jsx as jsx139 } from "react/jsx-runtime";
var SvgComponent115 = (props) => /* @__PURE__ */ jsx139("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx139("path", {
    d: "M480-322 251-551l68-66 114 114v-323h94v323l114-114 68 66-229 229ZM229-135q-39.05 0-66.52-27.48Q135-189.95 135-229v-143h94v143h502v-143h95v143q0 39-27.77 66.5T731-135H229Z"
  })
});
var download_default = SvgComponent115;

// ../../../node_modules/@material-symbols/svg-700/rounded/download-fill.svg
import * as React116 from "react";
import { jsx as jsx140 } from "react/jsx-runtime";
var SvgComponent116 = (props) => /* @__PURE__ */ jsx140("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx140("path", {
    d: "M479.76-341q-8.76 0-17.71-4.05Q453.1-349.09 446-356L284-518q-14-14.27-13.5-33.64Q271-571 284.61-585q14.79-14.15 34.09-13.58Q338-598 352-584l81 81v-275q0-19.63 13.68-33.81Q460.35-826 480.18-826q19.82 0 33.32 14.19Q527-797.63 527-778v275l82-81q13.8-14 32.25-14.58 18.45-.58 32.91 13.5Q689-571 688.5-551.18T674-517L514-356q-7.17 6.91-16.33 10.95-9.16 4.05-17.91 4.05ZM229-135q-39.05 0-66.52-27.48Q135-189.95 135-229v-96q0-19.75 13.68-33.38Q162.35-372 182.18-372q19.82 0 33.32 13.62Q229-344.75 229-325v96h502v-96q0-19.75 13.68-33.38Q758.35-372 778.09-372q19.73 0 33.82 13.62Q826-344.75 826-325v96q0 39.05-27.77 66.52Q770.46-135 731-135H229Z"
  })
});
var download_fill_default2 = SvgComponent116;

// ../../../node_modules/@material-symbols/svg-700/rounded/download.svg
import * as React117 from "react";
import { jsx as jsx141 } from "react/jsx-runtime";
var SvgComponent117 = (props) => /* @__PURE__ */ jsx141("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx141("path", {
    d: "M479.76-341q-8.76 0-17.71-4.05Q453.1-349.09 446-356L284-518q-14-14.27-13.5-33.64Q271-571 284.61-585q14.79-14.15 34.09-13.58Q338-598 352-584l81 81v-275q0-19.63 13.68-33.81Q460.35-826 480.18-826q19.82 0 33.32 14.19Q527-797.63 527-778v275l82-81q13.8-14 32.25-14.58 18.45-.58 32.91 13.5Q689-571 688.5-551.18T674-517L514-356q-7.17 6.91-16.33 10.95-9.16 4.05-17.91 4.05ZM229-135q-39.05 0-66.52-27.48Q135-189.95 135-229v-96q0-19.75 13.68-33.38Q162.35-372 182.18-372q19.82 0 33.32 13.62Q229-344.75 229-325v96h502v-96q0-19.75 13.68-33.38Q758.35-372 778.09-372q19.73 0 33.82 13.62Q826-344.75 826-325v96q0 39.05-27.77 66.52Q770.46-135 731-135H229Z"
  })
});
var download_default2 = SvgComponent117;

// ../../../node_modules/@material-symbols/svg-700/sharp/download-fill.svg
import * as React118 from "react";
import { jsx as jsx142 } from "react/jsx-runtime";
var SvgComponent118 = (props) => /* @__PURE__ */ jsx142("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx142("path", {
    d: "M480-322 251-551l68-66 114 114v-323h94v323l114-114 68 66-229 229ZM135-135v-237h94v143h502v-143h95v237H135Z"
  })
});
var download_fill_default3 = SvgComponent118;

// ../../../node_modules/@material-symbols/svg-700/sharp/download.svg
import * as React119 from "react";
import { jsx as jsx143 } from "react/jsx-runtime";
var SvgComponent119 = (props) => /* @__PURE__ */ jsx143("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx143("path", {
    d: "M480-322 251-551l68-66 114 114v-323h94v323l114-114 68 66-229 229ZM135-135v-237h94v143h502v-143h95v237H135Z"
  })
});
var download_default3 = SvgComponent119;

// src/components/icon/variants/IconDownload.tsx
import { useTranslation as useTranslation25 } from "react-i18next";
import { jsx as jsx144 } from "react/jsx-runtime";
var componentMap19 = {
  outlined: download_default,
  "outlined-fill": download_fill_default,
  rounded: download_default2,
  "rounded-fill": download_fill_default2,
  sharp: download_default3,
  "sharp-fill": download_fill_default3
};
var IconDownload = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation25("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap19[key] ?? componentMap19[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx144(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/edit-fill.svg
import * as React120 from "react";
import { jsx as jsx145 } from "react/jsx-runtime";
var SvgComponent120 = (props) => /* @__PURE__ */ jsx145("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx145("path", {
    d: "M95-95v-176l573-573q9-10 22.5-15.5T718-865q13 0 26 5.5t25 14.5l77 74q10 12 15 25.5t5 27.5q0 14-5.5 27.5T846-667L272-95H95Zm628-585 40-39-42-43-41 40 43 42Z"
  })
});
var edit_fill_default = SvgComponent120;

// ../../../node_modules/@material-symbols/svg-700/outlined/edit.svg
import * as React121 from "react";
import { jsx as jsx146 } from "react/jsx-runtime";
var SvgComponent121 = (props) => /* @__PURE__ */ jsx146("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx146("path", {
    d: "M188-189h45l421-420-43-44-423 421v43ZM95-95v-176l573-573q9-10 22.36-15.5Q703.71-865 718-865q13 0 26 5.5t25 14.5l77 74q10 12 15 25.5t5 27.5q0 14-5.5 27.5T846-667L272-95H95Zm668-624-42-43 42 43Zm-130 87-22-21 43 44-21-23Z"
  })
});
var edit_default = SvgComponent121;

// ../../../node_modules/@material-symbols/svg-700/rounded/edit-fill.svg
import * as React122 from "react";
import { jsx as jsx147 } from "react/jsx-runtime";
var SvgComponent122 = (props) => /* @__PURE__ */ jsx147("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx147("path", {
    d: "M142-95q-20 0-33.5-13.5T95-142v-89q0-19 7.5-37t20.5-31l545-545q9-10 22.5-15.5T718-865q13 0 26 5.5t25 14.5l77 74q10 12 15 25.5t5 27.5q0 14-5.5 27.5T846-667L301-123q-14 13-31.5 20.5T233-95h-91Zm581-585 40-39-42-43-41 40 43 42Z"
  })
});
var edit_fill_default2 = SvgComponent122;

// ../../../node_modules/@material-symbols/svg-700/rounded/edit.svg
import * as React123 from "react";
import { jsx as jsx148 } from "react/jsx-runtime";
var SvgComponent123 = (props) => /* @__PURE__ */ jsx148("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx148("path", {
    d: "M188-189h45l421-420-43-44-423 421v43Zm-46 94q-20 0-33.5-13.5T95-142v-89q0-19 7.5-37t20.5-31l545-545q9-10 22.5-15.5T718-865q13 0 26 5.5t25 14.5l77 74q10 12 15 25.5t5 27.5q0 14-5.5 27.5T846-667L301-123q-14 13-31.5 20.5T233-95h-91Zm621-624-42-43 42 43Zm-130 87-22-21 43 44-21-23Z"
  })
});
var edit_default2 = SvgComponent123;

// ../../../node_modules/@material-symbols/svg-700/sharp/edit-fill.svg
import * as React124 from "react";
import { jsx as jsx149 } from "react/jsx-runtime";
var SvgComponent124 = (props) => /* @__PURE__ */ jsx149("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx149("path", {
    d: "M96-95v-176l622-623 181 174L273-95H96Zm627-585 40-39-42-43-41 40 43 42Z"
  })
});
var edit_fill_default3 = SvgComponent124;

// ../../../node_modules/@material-symbols/svg-700/sharp/edit.svg
import * as React125 from "react";
import { jsx as jsx150 } from "react/jsx-runtime";
var SvgComponent125 = (props) => /* @__PURE__ */ jsx150("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx150("path", {
    d: "M188-189h45l421-420-43-44-423 421v43ZM95-95v-176l623-624 179 175L272-95H95Zm668-624-42-43 42 43Zm-130 87-22-21 43 44-21-23Z"
  })
});
var edit_default3 = SvgComponent125;

// src/components/icon/variants/IconEdit.tsx
import { useTranslation as useTranslation26 } from "react-i18next";
import { jsx as jsx151 } from "react/jsx-runtime";
var componentMap20 = {
  outlined: edit_default,
  "outlined-fill": edit_fill_default,
  rounded: edit_default2,
  "rounded-fill": edit_fill_default2,
  sharp: edit_default3,
  "sharp-fill": edit_fill_default3
};
var IconEdit = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation26("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap20[key] ?? componentMap20[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx151(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/error-fill.svg
import * as React126 from "react";
import { jsx as jsx152 } from "react/jsx-runtime";
var SvgComponent126 = (props) => /* @__PURE__ */ jsx152("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx152("path", {
    d: "M479.75-255q24.25 0 39.75-14.75 15.5-14.76 15.5-39Q535-333 519.75-349q-15.26-16-39.5-16-24.25 0-39.75 15.98T425-308.79q0 24.25 15.25 39.02Q455.51-255 479.75-255ZM436-432h94v-270h-94v270Zm44.4 377q-88.87 0-166.12-33.08-77.25-33.09-135.18-91.02-57.93-57.93-91.02-135.12Q55-391.41 55-480.36q0-88.96 33.08-166.29 33.09-77.32 90.86-134.81 57.77-57.48 135.03-91.01Q391.24-906 480.28-906t166.49 33.45q77.44 33.46 134.85 90.81t90.89 134.87Q906-569.34 906-480.27q0 89.01-33.53 166.25t-91.01 134.86q-57.49 57.62-134.83 90.89Q569.28-55 480.4-55Z"
  })
});
var error_fill_default = SvgComponent126;

// ../../../node_modules/@material-symbols/svg-700/outlined/error.svg
import * as React127 from "react";
import { jsx as jsx153 } from "react/jsx-runtime";
var SvgComponent127 = (props) => /* @__PURE__ */ jsx153("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx153("path", {
    d: "M479.75-255q24.25 0 39.75-14.75 15.5-14.76 15.5-39Q535-333 519.75-349q-15.26-16-39.5-16-24.25 0-39.75 15.98T425-308.79q0 24.25 15.25 39.02Q455.51-255 479.75-255ZM436-432h94v-270h-94v270Zm44.4 377q-88.87 0-166.12-33.08-77.25-33.09-135.18-91.02-57.93-57.93-91.02-135.12Q55-391.41 55-480.36q0-88.96 33.08-166.29 33.09-77.32 90.86-134.81 57.77-57.48 135.03-91.01Q391.24-906 480.28-906t166.49 33.45q77.44 33.46 134.85 90.81t90.89 134.87Q906-569.34 906-480.27q0 89.01-33.53 166.25t-91.01 134.86q-57.49 57.62-134.83 90.89Q569.28-55 480.4-55Zm.1-94q137.5 0 234-96.37T811-480.5q0-137.5-96.31-234T479.5-811q-137.5 0-234 96.31T149-479.5q0 137.5 96.37 234T480.5-149Zm-.5-331Z"
  })
});
var error_default = SvgComponent127;

// ../../../node_modules/@material-symbols/svg-700/rounded/error-fill.svg
import * as React128 from "react";
import { jsx as jsx154 } from "react/jsx-runtime";
var SvgComponent128 = (props) => /* @__PURE__ */ jsx154("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx154("path", {
    d: "M479.75-255q24.25 0 39.75-14.75 15.5-14.76 15.5-39Q535-333 519.75-349q-15.26-16-39.5-16-24.25 0-39.75 15.98T425-308.79q0 24.25 15.25 39.02Q455.51-255 479.75-255Zm3.43-177q19.82 0 33.32-13.63Q530-459.25 530-479v-176q0-19.75-13.68-33.38Q502.65-702 482.82-702q-19.82 0-33.32 13.62Q436-674.75 436-655v176q0 19.75 13.68 33.37Q463.35-432 483.18-432ZM480.4-55q-88.87 0-166.12-33.08-77.25-33.09-135.18-91.02-57.93-57.93-91.02-135.12Q55-391.41 55-480.36q0-88.96 33.08-166.29 33.09-77.32 90.86-134.81 57.77-57.48 135.03-91.01Q391.24-906 480.28-906t166.49 33.45q77.44 33.46 134.85 90.81t90.89 134.87Q906-569.34 906-480.27q0 89.01-33.53 166.25t-91.01 134.86q-57.49 57.62-134.83 90.89Q569.28-55 480.4-55Z"
  })
});
var error_fill_default2 = SvgComponent128;

// ../../../node_modules/@material-symbols/svg-700/rounded/error.svg
import * as React129 from "react";
import { jsx as jsx155 } from "react/jsx-runtime";
var SvgComponent129 = (props) => /* @__PURE__ */ jsx155("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx155("path", {
    d: "M479.75-255q24.25 0 39.75-14.75 15.5-14.76 15.5-39Q535-333 519.75-349q-15.26-16-39.5-16-24.25 0-39.75 15.98T425-308.79q0 24.25 15.25 39.02Q455.51-255 479.75-255Zm3.43-177q19.82 0 33.32-13.63Q530-459.25 530-479v-176q0-19.75-13.68-33.38Q502.65-702 482.82-702q-19.82 0-33.32 13.62Q436-674.75 436-655v176q0 19.75 13.68 33.37Q463.35-432 483.18-432ZM480.4-55q-88.87 0-166.12-33.08-77.25-33.09-135.18-91.02-57.93-57.93-91.02-135.12Q55-391.41 55-480.36q0-88.96 33.08-166.29 33.09-77.32 90.86-134.81 57.77-57.48 135.03-91.01Q391.24-906 480.28-906t166.49 33.45q77.44 33.46 134.85 90.81t90.89 134.87Q906-569.34 906-480.27q0 89.01-33.53 166.25t-91.01 134.86q-57.49 57.62-134.83 90.89Q569.28-55 480.4-55Zm.1-94q137.5 0 234-96.37T811-480.5q0-137.5-96.31-234T479.5-811q-137.5 0-234 96.31T149-479.5q0 137.5 96.37 234T480.5-149Zm-.5-331Z"
  })
});
var error_default2 = SvgComponent129;

// ../../../node_modules/@material-symbols/svg-700/sharp/error-fill.svg
import * as React130 from "react";
import { jsx as jsx156 } from "react/jsx-runtime";
var SvgComponent130 = (props) => /* @__PURE__ */ jsx156("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx156("path", {
    d: "M479.75-255q24.25 0 39.75-14.75 15.5-14.76 15.5-39Q535-333 519.75-349q-15.26-16-39.5-16-24.25 0-39.75 15.98T425-308.79q0 24.25 15.25 39.02Q455.51-255 479.75-255ZM436-432h94v-270h-94v270Zm44.4 377q-88.87 0-166.12-33.08-77.25-33.09-135.18-91.02-57.93-57.93-91.02-135.12Q55-391.41 55-480.36q0-88.96 33.08-166.29 33.09-77.32 90.86-134.81 57.77-57.48 135.03-91.01Q391.24-906 480.28-906t166.49 33.45q77.44 33.46 134.85 90.81t90.89 134.87Q906-569.34 906-480.27q0 89.01-33.53 166.25t-91.01 134.86q-57.49 57.62-134.83 90.89Q569.28-55 480.4-55Z"
  })
});
var error_fill_default3 = SvgComponent130;

// ../../../node_modules/@material-symbols/svg-700/sharp/error.svg
import * as React131 from "react";
import { jsx as jsx157 } from "react/jsx-runtime";
var SvgComponent131 = (props) => /* @__PURE__ */ jsx157("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx157("path", {
    d: "M479.75-255q24.25 0 39.75-14.75 15.5-14.76 15.5-39Q535-333 519.75-349q-15.26-16-39.5-16-24.25 0-39.75 15.98T425-308.79q0 24.25 15.25 39.02Q455.51-255 479.75-255ZM436-432h94v-270h-94v270Zm44.4 377q-88.87 0-166.12-33.08-77.25-33.09-135.18-91.02-57.93-57.93-91.02-135.12Q55-391.41 55-480.36q0-88.96 33.08-166.29 33.09-77.32 90.86-134.81 57.77-57.48 135.03-91.01Q391.24-906 480.28-906t166.49 33.45q77.44 33.46 134.85 90.81t90.89 134.87Q906-569.34 906-480.27q0 89.01-33.53 166.25t-91.01 134.86q-57.49 57.62-134.83 90.89Q569.28-55 480.4-55Zm.1-94q137.5 0 234-96.37T811-480.5q0-137.5-96.31-234T479.5-811q-137.5 0-234 96.31T149-479.5q0 137.5 96.37 234T480.5-149Zm-.5-331Z"
  })
});
var error_default3 = SvgComponent131;

// src/components/icon/variants/IconError.tsx
import { useTranslation as useTranslation27 } from "react-i18next";
import { jsx as jsx158 } from "react/jsx-runtime";
var componentMap21 = {
  outlined: error_default,
  "outlined-fill": error_fill_default,
  rounded: error_default2,
  "rounded-fill": error_fill_default2,
  sharp: error_default3,
  "sharp-fill": error_fill_default3
};
var IconError = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation27("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap21[key] ?? componentMap21[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx158(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/event-fill.svg
import * as React132 from "react";
import { jsx as jsx159 } from "react/jsx-runtime";
var SvgComponent132 = (props) => /* @__PURE__ */ jsx159("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx159("path", {
    d: "M596.82-220Q556-220 528-248.18q-28-28.19-28-69Q500-358 528.18-386q28.19-28 69-28Q638-414 666-385.82q28 28.19 28 69Q694-276 665.82-248q-28.19 28-69 28ZM189-55q-39.05 0-66.53-27.47Q95-109.95 95-149v-602q0-39.46 27.47-67.23Q149.95-846 189-846h56v-60h82v60h306v-60h82v60h56q39.46 0 67.23 27.77Q866-790.46 866-751v602q0 39.05-27.77 66.53Q810.46-55 771-55H189Zm0-94h582v-421H189v421Z"
  })
});
var event_fill_default = SvgComponent132;

// ../../../node_modules/@material-symbols/svg-700/outlined/event.svg
import * as React133 from "react";
import { jsx as jsx160 } from "react/jsx-runtime";
var SvgComponent133 = (props) => /* @__PURE__ */ jsx160("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx160("path", {
    d: "M596.82-220Q556-220 528-248.18q-28-28.19-28-69Q500-358 528.18-386q28.19-28 69-28Q638-414 666-385.82q28 28.19 28 69Q694-276 665.82-248q-28.19 28-69 28ZM189-55q-39.05 0-66.53-27.47Q95-109.95 95-149v-602q0-39.46 27.47-67.23Q149.95-846 189-846h56v-60h82v60h306v-60h82v60h56q39.46 0 67.23 27.77Q866-790.46 866-751v602q0 39.05-27.77 66.53Q810.46-55 771-55H189Zm0-94h582v-421H189v421Zm0-481h582v-121H189v121Zm0 0v-121 121Z"
  })
});
var event_default = SvgComponent133;

// ../../../node_modules/@material-symbols/svg-700/rounded/event-fill.svg
import * as React134 from "react";
import { jsx as jsx161 } from "react/jsx-runtime";
var SvgComponent134 = (props) => /* @__PURE__ */ jsx161("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx161("path", {
    d: "M596.82-220Q556-220 528-248.18q-28-28.19-28-69Q500-358 528.18-386q28.19-28 69-28Q638-414 666-385.82q28 28.19 28 69Q694-276 665.82-248q-28.19 28-69 28ZM189-55q-39.05 0-66.53-27.47Q95-109.95 95-149v-602q0-39.46 27.47-67.23Q149.95-846 189-846h56v-19q0-16.75 12.39-28.88 12.4-12.12 28.8-12.12 16.83 0 28.82 12.12Q327-881.75 327-865v19h306v-19q0-16.75 12.39-28.88 12.4-12.12 28.8-12.12 16.84 0 28.82 12.12Q715-881.75 715-865v19h56q39.46 0 67.23 27.77Q866-790.46 866-751v602q0 39.05-27.77 66.53Q810.46-55 771-55H189Zm0-94h582v-421H189v421Z"
  })
});
var event_fill_default2 = SvgComponent134;

// ../../../node_modules/@material-symbols/svg-700/rounded/event.svg
import * as React135 from "react";
import { jsx as jsx162 } from "react/jsx-runtime";
var SvgComponent135 = (props) => /* @__PURE__ */ jsx162("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx162("path", {
    d: "M596.82-220Q556-220 528-248.18q-28-28.19-28-69Q500-358 528.18-386q28.19-28 69-28Q638-414 666-385.82q28 28.19 28 69Q694-276 665.82-248q-28.19 28-69 28ZM189-55q-39.05 0-66.53-27.47Q95-109.95 95-149v-602q0-39.46 27.47-67.23Q149.95-846 189-846h56v-19q0-16.75 12.39-28.88 12.4-12.12 28.8-12.12 16.83 0 28.82 12.12Q327-881.75 327-865v19h306v-19q0-16.75 12.39-28.88 12.4-12.12 28.8-12.12 16.84 0 28.82 12.12Q715-881.75 715-865v19h56q39.46 0 67.23 27.77Q866-790.46 866-751v602q0 39.05-27.77 66.53Q810.46-55 771-55H189Zm0-94h582v-421H189v421Zm0-481h582v-121H189v121Zm0 0v-121 121Z"
  })
});
var event_default2 = SvgComponent135;

// ../../../node_modules/@material-symbols/svg-700/sharp/event-fill.svg
import * as React136 from "react";
import { jsx as jsx163 } from "react/jsx-runtime";
var SvgComponent136 = (props) => /* @__PURE__ */ jsx163("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx163("path", {
    d: "M596.82-220Q556-220 528-248.18q-28-28.19-28-69Q500-358 528.18-386q28.19-28 69-28Q638-414 666-385.82q28 28.19 28 69Q694-276 665.82-248q-28.19 28-69 28ZM95-55v-791h150.2v-60H327v60h306v-60h82.2v60H866v791H95Zm94-94h582v-421H189v421Z"
  })
});
var event_fill_default3 = SvgComponent136;

// ../../../node_modules/@material-symbols/svg-700/sharp/event.svg
import * as React137 from "react";
import { jsx as jsx164 } from "react/jsx-runtime";
var SvgComponent137 = (props) => /* @__PURE__ */ jsx164("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx164("path", {
    d: "M596.82-220Q556-220 528-248.18q-28-28.19-28-69Q500-358 528.18-386q28.19-28 69-28Q638-414 666-385.82q28 28.19 28 69Q694-276 665.82-248q-28.19 28-69 28ZM95-55v-791h150.2v-60H327v60h306v-60h82.2v60H866v791H95Zm94-94h582v-421H189v421Zm0-481h582v-121H189v121Zm0 0v-121 121Z"
  })
});
var event_default3 = SvgComponent137;

// src/components/icon/variants/IconEvent.tsx
import { useTranslation as useTranslation28 } from "react-i18next";
import { jsx as jsx165 } from "react/jsx-runtime";
var componentMap22 = {
  outlined: event_default,
  "outlined-fill": event_fill_default,
  rounded: event_default2,
  "rounded-fill": event_fill_default2,
  sharp: event_default3,
  "sharp-fill": event_fill_default3
};
var IconEvent = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation28("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap22[key] ?? componentMap22[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx165(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/event_busy-fill.svg
import * as React138 from "react";
import { jsx as jsx166 } from "react/jsx-runtime";
var SvgComponent138 = (props) => /* @__PURE__ */ jsx166("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx166("path", {
    d: "m385-214-51-51 96-95-96-95 51-52 95 97 95-97 52 52-97 95 97 95-52 51-95-96-95 96ZM189-55q-39.05 0-66.53-27.47Q95-109.95 95-149v-602q0-39.46 27.47-67.23Q149.95-846 189-846h56v-60h82v60h306v-60h82v60h56q39.46 0 67.23 27.77Q866-790.46 866-751v602q0 39.05-27.77 66.53Q810.46-55 771-55H189Zm0-94h582v-421H189v421Z"
  })
});
var event_busy_fill_default = SvgComponent138;

// ../../../node_modules/@material-symbols/svg-700/outlined/event_busy.svg
import * as React139 from "react";
import { jsx as jsx167 } from "react/jsx-runtime";
var SvgComponent139 = (props) => /* @__PURE__ */ jsx167("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx167("path", {
    d: "m385-214-51-51 96-95-96-95 51-52 95 97 95-97 52 52-97 95 97 95-52 51-95-96-95 96ZM189-55q-39.05 0-66.53-27.47Q95-109.95 95-149v-602q0-39.46 27.47-67.23Q149.95-846 189-846h56v-60h82v60h306v-60h82v60h56q39.46 0 67.23 27.77Q866-790.46 866-751v602q0 39.05-27.77 66.53Q810.46-55 771-55H189Zm0-94h582v-421H189v421Zm0-481h582v-121H189v121Zm0 0v-121 121Z"
  })
});
var event_busy_default = SvgComponent139;

// ../../../node_modules/@material-symbols/svg-700/rounded/event_busy-fill.svg
import * as React140 from "react";
import { jsx as jsx168 } from "react/jsx-runtime";
var SvgComponent140 = (props) => /* @__PURE__ */ jsx168("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx168("path", {
    d: "m480-310-70 72q-11 11-25 10.5T360-239q-11-11-11-25.5t11-25.5l70-70-72-71q-11-10-10.5-24.12.5-14.12 11.5-25.88 11-11 25.5-11t25.5 11l70 71 71-72q10-11 24.12-11 14.12 0 25.88 11 11 11.51 11 25.76Q612-442 601-431l-71 71 72 70q11 11 11 25t-11.41 25q-11.41 11-25.5 11T551-240l-71-70ZM189-55q-39.05 0-66.53-27.47Q95-109.95 95-149v-602q0-39.46 27.47-67.23Q149.95-846 189-846h56v-19q0-17.15 12.19-29.08 12.2-11.92 29-11.92Q303-906 315-894.08q12 11.93 12 29.08v19h306v-19q0-17.15 12.19-29.08 12.2-11.92 29-11.92Q691-906 703-894.08q12 11.93 12 29.08v19h56q39.46 0 67.23 27.77Q866-790.46 866-751v602q0 39.05-27.77 66.53Q810.46-55 771-55H189Zm0-94h582v-421H189v421Z"
  })
});
var event_busy_fill_default2 = SvgComponent140;

// ../../../node_modules/@material-symbols/svg-700/rounded/event_busy.svg
import * as React141 from "react";
import { jsx as jsx169 } from "react/jsx-runtime";
var SvgComponent141 = (props) => /* @__PURE__ */ jsx169("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx169("path", {
    d: "m480-310-70 72q-11 11-25 10.5T360-239q-11-11-11-25.5t11-25.5l70-70-72-71q-11-10-10.5-24.12.5-14.12 11.5-25.88 11-11 25.5-11t25.5 11l70 71 71-72q10-11 24.12-11 14.12 0 25.88 11 11 11.51 11 25.76Q612-442 601-431l-71 71 72 70q11 11 11 25t-11.41 25q-11.41 11-25.5 11T551-240l-71-70ZM189-55q-39.05 0-66.53-27.47Q95-109.95 95-149v-602q0-39.46 27.47-67.23Q149.95-846 189-846h56v-19q0-16.75 12.39-28.88 12.4-12.12 28.8-12.12 16.83 0 28.82 12.12Q327-881.75 327-865v19h306v-19q0-16.75 12.39-28.88 12.4-12.12 28.8-12.12 16.84 0 28.82 12.12Q715-881.75 715-865v19h56q39.46 0 67.23 27.77Q866-790.46 866-751v602q0 39.05-27.77 66.53Q810.46-55 771-55H189Zm0-94h582v-421H189v421Zm0-481h582v-121H189v121Zm0 0v-121 121Z"
  })
});
var event_busy_default2 = SvgComponent141;

// ../../../node_modules/@material-symbols/svg-700/sharp/event_busy-fill.svg
import * as React142 from "react";
import { jsx as jsx170 } from "react/jsx-runtime";
var SvgComponent142 = (props) => /* @__PURE__ */ jsx170("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx170("path", {
    d: "m385-214-51-51 96-95-96-95 51-52 95 97 95-97 52 52-97 95 97 95-52 51-95-96-95 96ZM95-55v-791h150.2v-60H327v60h306v-60h82.2v60H866v791H95Zm94-94h582v-421H189v421Z"
  })
});
var event_busy_fill_default3 = SvgComponent142;

// ../../../node_modules/@material-symbols/svg-700/sharp/event_busy.svg
import * as React143 from "react";
import { jsx as jsx171 } from "react/jsx-runtime";
var SvgComponent143 = (props) => /* @__PURE__ */ jsx171("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx171("path", {
    d: "m385-214-51-51 96-95-96-95 51-52 95 97 95-97 52 52-97 95 97 95-52 51-95-96-95 96ZM95-55v-791h150.2v-60H327v60h306v-60h82.2v60H866v791H95Zm94-94h582v-421H189v421Zm0-481h582v-121H189v121Zm0 0v-121 121Z"
  })
});
var event_busy_default3 = SvgComponent143;

// src/components/icon/variants/IconEventBusy.tsx
import { useTranslation as useTranslation29 } from "react-i18next";
import { jsx as jsx172 } from "react/jsx-runtime";
var componentMap23 = {
  outlined: event_busy_default,
  "outlined-fill": event_busy_fill_default,
  rounded: event_busy_default2,
  "rounded-fill": event_busy_fill_default2,
  sharp: event_busy_default3,
  "sharp-fill": event_busy_fill_default3
};
var IconEventBusy = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation29("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap23[key] ?? componentMap23[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx172(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/favorite-fill.svg
import * as React144 from "react";
import { jsx as jsx173 } from "react/jsx-runtime";
var SvgComponent144 = (props) => /* @__PURE__ */ jsx173("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx173("path", {
    d: "m479-87-58-52Q312-239 241.5-311.5T129-441.5q-42-57.5-58.5-105T54-643q0-101 67.5-169T289-880q56 0 104 24t86 71q44-50 90-72.5T669-880q101 0 169 68t68 169q0 49-16.5 96T831-442.5Q789-385 718-312T538-139l-59 52Z"
  })
});
var favorite_fill_default = SvgComponent144;

// ../../../node_modules/@material-symbols/svg-700/outlined/favorite.svg
import * as React145 from "react";
import { jsx as jsx174 } from "react/jsx-runtime";
var SvgComponent145 = (props) => /* @__PURE__ */ jsx174("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx174("path", {
    d: "m479-87-58-52Q312.23-239.12 241.62-311.56 171-384 129-441.5t-58.5-105Q54-594 54-643.1q0-101.22 67.66-169.06T289-880q56.29 0 104.14 24Q441-832 479-785q44-50 90.03-72.5Q615.07-880 669-880q101.38 0 169.19 67.87T906-643q0 48.97-16.5 95.99Q873-500 831-442.5 789-385 718.02-311.95 647.03-238.9 538-139l-59 52Zm-.5-124q100.74-93 165.12-158Q708-434 745.5-482.5t52-86.28q14.5-37.79 14.5-74.05 0-62.17-39.86-102.67T669.71-786q-49.01 0-91.36 32T509-666h-60q-25.75-56-68.93-88-43.18-32-91.13-32-61.21 0-100.58 39.86Q149-706.29 149-642.68q0 37.77 14.94 76.34t52.5 87.46Q254-430 317.5-365.5t161 154.5Zm2.5-288Z"
  })
});
var favorite_default = SvgComponent145;

// ../../../node_modules/@material-symbols/svg-700/rounded/favorite-fill.svg
import * as React146 from "react";
import { jsx as jsx175 } from "react/jsx-runtime";
var SvgComponent146 = (props) => /* @__PURE__ */ jsx175("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx175("path", {
    d: "M479-118q-18 0-34.5-6T415-143l-54-51Q238-306 146.5-413.5T55-643q0-101 67-169t167-68q50 0 99 21.5t91 73.5q47-52 93-73.5t97-21.5q101 0 169 68t68 169q0 122-93 229.5T598-193l-54 50q-13 13-30 19t-35 6Z"
  })
});
var favorite_fill_default2 = SvgComponent146;

// ../../../node_modules/@material-symbols/svg-700/rounded/favorite.svg
import * as React147 from "react";
import { jsx as jsx176 } from "react/jsx-runtime";
var SvgComponent147 = (props) => /* @__PURE__ */ jsx176("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx176("path", {
    d: "M479.04-118q-17.74 0-34.32-5.87-16.58-5.87-29.99-19.38L361-194Q238-306 146.5-413.5T55-643q0-101.26 66.92-169.13Q188.85-880 289-880q50 0 99 21.5t91 73.5q47-52 93-73.5t97-21.5q101.38 0 169.19 67.87T906-643q0 122-93 229.5T598-193l-54 50q-13.25 13.38-30.09 19.19-16.84 5.81-34.87 5.81ZM448-679q-23-45-68-76t-90.73-31q-61.83 0-101.05 39.86Q149-706.29 149-642.57q0 56.02 37.59 117.93 37.58 61.92 89.9 120.12 52.32 58.21 109.11 108.94 56.78 50.73 93.59 84.58 37.19-34 93.7-85.14 56.51-51.13 109.31-109.5Q735-464 773.5-525.46 812-586.92 812-643.21 812-706 771.64-746q-40.36-40-102.15-40-47.49 0-91.99 30.5Q533-725 509-679q-5.3 10-13.65 14.5Q487-660 477.5-660q-9.5 0-17.11-4.5Q452.78-669 448-679Zm32 180Z"
  })
});
var favorite_default2 = SvgComponent147;

// ../../../node_modules/@material-symbols/svg-700/sharp/favorite-fill.svg
import * as React148 from "react";
import { jsx as jsx177 } from "react/jsx-runtime";
var SvgComponent148 = (props) => /* @__PURE__ */ jsx177("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx177("path", {
    d: "m479-87-58-52Q312-239 241.5-311.5T129-441.5q-42-57.5-58.5-105T54-643q0-101 67.5-169T289-880q56 0 104 24t86 71q44-50 90-72.5T669-880q101 0 169 68t68 169q0 49-16.5 96T831-442.5Q789-385 718-312T538-139l-59 52Z"
  })
});
var favorite_fill_default3 = SvgComponent148;

// ../../../node_modules/@material-symbols/svg-700/sharp/favorite.svg
import * as React149 from "react";
import { jsx as jsx178 } from "react/jsx-runtime";
var SvgComponent149 = (props) => /* @__PURE__ */ jsx178("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx178("path", {
    d: "m479-87-58-52Q312.23-239.12 241.62-311.56 171-384 129-441.5t-58.5-105Q54-594 54-643.1q0-101.22 67.66-169.06T289-880q56.29 0 104.14 24Q441-832 479-785q44-50 90.03-72.5Q615.07-880 669-880q101.38 0 169.19 67.87T906-643q0 48.97-16.5 95.99Q873-500 831-442.5 789-385 718.02-311.95 647.03-238.9 538-139l-59 52Zm-.5-124q100.74-93 165.12-158Q708-434 745.5-482.5t52-86.28q14.5-37.79 14.5-74.05 0-62.17-39.86-102.67T669.71-786q-49.01 0-91.36 32T509-666h-60q-25.75-56-68.93-88-43.18-32-91.13-32-61.21 0-100.58 39.86Q149-706.29 149-642.68q0 37.77 14.94 76.34t52.5 87.46Q254-430 317.5-365.5t161 154.5Zm2.5-288Z"
  })
});
var favorite_default3 = SvgComponent149;

// src/components/icon/variants/IconFavorite.tsx
import { useTranslation as useTranslation30 } from "react-i18next";
import { jsx as jsx179 } from "react/jsx-runtime";
var componentMap24 = {
  outlined: favorite_default,
  "outlined-fill": favorite_fill_default,
  rounded: favorite_default2,
  "rounded-fill": favorite_fill_default2,
  sharp: favorite_default3,
  "sharp-fill": favorite_fill_default3
};
var IconFavorite = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation30("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap24[key] ?? componentMap24[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx179(Icon, {
    SvgIcon,
    alt: t("icon.favorite"),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/file_open-fill.svg
import * as React150 from "react";
import { jsx as jsx180 } from "react/jsx-runtime";
var SvgComponent150 = (props) => /* @__PURE__ */ jsx180("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx180("path", {
    d: "M878-54 767-166v117h-94v-278h278v94H833l111 111-66 68ZM511-591h220L511-811v220ZM229-55q-39.05 0-66.52-27.47Q135-109.95 135-149v-662q0-39.46 27.48-67.23Q189.95-906 229-906h342l255 255v264H613v332H229Z"
  })
});
var file_open_fill_default = SvgComponent150;

// ../../../node_modules/@material-symbols/svg-700/outlined/file_open.svg
import * as React151 from "react";
import { jsx as jsx181 } from "react/jsx-runtime";
var SvgComponent151 = (props) => /* @__PURE__ */ jsx181("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx181("path", {
    d: "M229-55q-39.05 0-66.52-27.47Q135-109.95 135-149v-662q0-39.46 27.48-67.23Q189.95-906 229-906h342l255 255v264h-95v-204H511v-220H229v662h384v94H229Zm649 1L767-166v117h-94v-278h278v94H833l111 111-66 68Zm-649-95v-662 662Z"
  })
});
var file_open_default = SvgComponent151;

// ../../../node_modules/@material-symbols/svg-700/rounded/file_open-fill.svg
import * as React152 from "react";
import { jsx as jsx182 } from "react/jsx-runtime";
var SvgComponent152 = (props) => /* @__PURE__ */ jsx182("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx182("path", {
    d: "M720-327h184q19.75 0 33.38 13.68Q951-299.65 951-279.82q0 19.82-13.62 33.32Q923.75-233 904-233h-71l78 78q14 14 14.5 33.16.5 19.16-13.11 33Q898-75 878.03-74.5 858.07-74 844-88l-77-78v70q0 19.75-13.68 33.37Q739.65-49 719.82-49 700-49 686.5-62.63 673-76.25 673-96v-184q0-19.75 13.63-33.38Q700.25-327 720-327ZM511-811v173q0 19.75 13.63 33.37Q538.25-591 558-591h173L511-811Zm-282-95h302q19.44 0 37.22 8Q586-890 599-877l198 198q13 13 21 30.78t8 37.22v176q0 20.75-14.12 34.37Q797.75-387 778-387H660q-19.75 0-33.37 13.62Q613-359.75 613-340v238q0 19.75-13.62 33.37Q585.75-55 566-55H229q-39 0-66.5-27.5T135-149v-662q0-39 27.5-67t66.5-28Z"
  })
});
var file_open_fill_default2 = SvgComponent152;

// ../../../node_modules/@material-symbols/svg-700/rounded/file_open.svg
import * as React153 from "react";
import { jsx as jsx183 } from "react/jsx-runtime";
var SvgComponent153 = (props) => /* @__PURE__ */ jsx183("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx183("path", {
    d: "M229-55q-39.05 0-66.52-27.47Q135-109.95 135-149v-662q0-39.46 27.48-67.23Q189.95-906 229-906h302q19.56 0 37.28 8Q586-890 599-877l198 198q13 13 21 30.72t8 37.28v176q0 20.75-14.26 34.37-14.27 13.63-34 13.63-19.74 0-33.24-13.63Q731-414.25 731-435v-156H558q-19.75 0-33.37-13.63Q511-618.25 511-638v-173H229v662h337q19.75 0 33.38 13.68Q613-121.65 613-101.82 613-82 599.38-68.5 585.75-55 566-55H229Zm538-111v70q0 19.75-13.68 33.37Q739.65-49 719.82-49 700-49 686.5-62.63 673-76.25 673-96v-184q0-19.75 13.63-33.38Q700.25-327 720-327h184q19.75 0 33.38 13.68Q951-299.65 951-279.82q0 19.82-13.62 33.32Q923.75-233 904-233h-71l78 78q14 14.5 14.5 33.41.5 18.91-12.89 32.75Q898-75 878.23-74.5 858.47-74 844-88l-77-78Zm-538 17v-662 662Z"
  })
});
var file_open_default2 = SvgComponent153;

// ../../../node_modules/@material-symbols/svg-700/sharp/file_open-fill.svg
import * as React154 from "react";
import { jsx as jsx184 } from "react/jsx-runtime";
var SvgComponent154 = (props) => /* @__PURE__ */ jsx184("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx184("path", {
    d: "M878-54 767-166v117h-94v-278h278v94H833l111 111-66 68ZM511-591h220L511-811v220ZM135-55v-851h436l255 255v264H613v332H135Z"
  })
});
var file_open_fill_default3 = SvgComponent154;

// ../../../node_modules/@material-symbols/svg-700/sharp/file_open.svg
import * as React155 from "react";
import { jsx as jsx185 } from "react/jsx-runtime";
var SvgComponent155 = (props) => /* @__PURE__ */ jsx185("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx185("path", {
    d: "M135-55v-851h436l255 255v264h-95v-204H511v-220H229v662h384v94H135Zm743 1L767-166v117h-94v-278h278v94H833l111 111-66 68Zm-649-95v-662 662Z"
  })
});
var file_open_default3 = SvgComponent155;

// src/components/icon/variants/IconFileOpen.tsx
import { useTranslation as useTranslation31 } from "react-i18next";
import { jsx as jsx186 } from "react/jsx-runtime";
var componentMap25 = {
  outlined: file_open_default,
  "outlined-fill": file_open_fill_default,
  rounded: file_open_default2,
  "rounded-fill": file_open_fill_default2,
  sharp: file_open_default3,
  "sharp-fill": file_open_fill_default3
};
var IconFileOpen = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation31("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap25[key] ?? componentMap25[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx186(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// src/components/icon/variants/IconFilter.tsx
import { useTranslation as useTranslation32 } from "react-i18next";

// src/components/icon/static/filter.svg
import * as React156 from "react";
import { jsx as jsx187, jsxs as jsxs5 } from "react/jsx-runtime";
var SvgComponent156 = (props) => /* @__PURE__ */ jsxs5("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: [
    /* @__PURE__ */ jsx187("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.85005 8C6.85005 7.36487 7.36492 6.85 8.00005 6.85L19.85 6.85C20.4852 6.85 21 7.36487 21 8C21 8.63513 20.4852 9.15 19.85 9.15L8.00005 9.15C7.36492 9.15 6.85005 8.63513 6.85005 8Z"
    }),
    /* @__PURE__ */ jsx187("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.00005 8.7C6.38665 8.7 6.70005 8.3866 6.70005 8C6.70005 7.6134 6.38665 7.3 6.00005 7.3C5.61345 7.3 5.30005 7.6134 5.30005 8C5.30005 8.3866 5.61345 8.7 6.00005 8.7ZM6.00005 11C7.6569 11 9.00005 9.65685 9.00005 8C9.00005 6.34315 7.6569 5 6.00005 5C4.34319 5 3.00005 6.34315 3.00005 8C3.00005 9.65685 4.34319 11 6.00005 11Z"
    }),
    /* @__PURE__ */ jsx187("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.00005 16C3.00005 15.3649 3.51492 14.85 4.15005 14.85L16 14.85C16.6352 14.85 17.15 15.3649 17.15 16C17.15 16.6351 16.6352 17.15 16 17.15L4.15005 17.15C3.51492 17.15 3.00005 16.6351 3.00005 16Z"
    }),
    /* @__PURE__ */ jsx187("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18 16.7C18.3866 16.7 18.7 16.3866 18.7 16C18.7 15.6134 18.3866 15.3 18 15.3C17.6134 15.3 17.3 15.6134 17.3 16C17.3 16.3866 17.6134 16.7 18 16.7ZM18 19C19.6569 19 21 17.6569 21 16C21 14.3431 19.6569 13 18 13C16.3432 13 15 14.3431 15 16C15 17.6569 16.3432 19 18 19Z"
    })
  ]
});
var filter_default = SvgComponent156;

// src/components/icon/variants/IconFilter.tsx
import { jsx as jsx188 } from "react/jsx-runtime";
var IconFilter = ({
  color,
  height,
  style = {},
  width
}) => {
  const { t } = useTranslation32("pds");
  return /* @__PURE__ */ jsx188(Icon, {
    SvgIcon: filter_default,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/filter_list-fill.svg
import * as React157 from "react";
import { jsx as jsx189 } from "react/jsx-runtime";
var SvgComponent157 = (props) => /* @__PURE__ */ jsx189("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx189("path", {
    d: "M382-190v-94h196v94H382ZM218-434v-93h524v93H218ZM95-677v-94h771v94H95Z"
  })
});
var filter_list_fill_default = SvgComponent157;

// ../../../node_modules/@material-symbols/svg-700/outlined/filter_list.svg
import * as React158 from "react";
import { jsx as jsx190 } from "react/jsx-runtime";
var SvgComponent158 = (props) => /* @__PURE__ */ jsx190("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx190("path", {
    d: "M382-190v-94h196v94H382ZM218-434v-93h524v93H218ZM95-677v-94h771v94H95Z"
  })
});
var filter_list_default = SvgComponent158;

// ../../../node_modules/@material-symbols/svg-700/rounded/filter_list-fill.svg
import * as React159 from "react";
import { jsx as jsx191 } from "react/jsx-runtime";
var SvgComponent159 = (props) => /* @__PURE__ */ jsx191("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx191("path", {
    d: "M429-190q-19.98 0-33.49-12.93Q382-215.86 382-235.84q0-19.98 13.63-34.07Q409.25-284 429-284h103q19.55 0 32.78 14.26Q578-255.47 578-235.49t-13.62 32.74Q550.75-190 531-190H429ZM264-434q-20.1 0-33.05-12.93-12.95-12.93-12.95-33t12.95-33.57Q243.9-527 264-527h431q19.97 0 33.49 13.68Q742-499.65 742-479.58t-13.51 32.83Q714.97-434 695-434H264ZM141-677q-20.1 0-33.05-13.52Q95-704.04 95-724.02t13.63-33.48Q122.25-771 142-771h677q19.97 0 33.49 13.68Q866-743.65 866-723.67q0 19.99-14.19 33.33Q837.63-677 818-677H141Z"
  })
});
var filter_list_fill_default2 = SvgComponent159;

// ../../../node_modules/@material-symbols/svg-700/rounded/filter_list.svg
import * as React160 from "react";
import { jsx as jsx192 } from "react/jsx-runtime";
var SvgComponent160 = (props) => /* @__PURE__ */ jsx192("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx192("path", {
    d: "M429-190q-19.98 0-33.49-12.93Q382-215.86 382-235.84q0-19.98 13.63-34.07Q409.25-284 429-284h103q19.55 0 32.78 14.26Q578-255.47 578-235.49t-13.62 32.74Q550.75-190 531-190H429ZM264-434q-20.1 0-33.05-12.93-12.95-12.93-12.95-33t12.95-33.57Q243.9-527 264-527h431q19.97 0 33.49 13.68Q742-499.65 742-479.58t-13.51 32.83Q714.97-434 695-434H264ZM141-677q-20.1 0-33.05-13.52Q95-704.04 95-724.02t13.63-33.48Q122.25-771 142-771h677q19.97 0 33.49 13.68Q866-743.65 866-723.67q0 19.99-14.19 33.33Q837.63-677 818-677H141Z"
  })
});
var filter_list_default2 = SvgComponent160;

// ../../../node_modules/@material-symbols/svg-700/sharp/filter_list-fill.svg
import * as React161 from "react";
import { jsx as jsx193 } from "react/jsx-runtime";
var SvgComponent161 = (props) => /* @__PURE__ */ jsx193("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx193("path", {
    d: "M382-190v-94h196v94H382ZM218-434v-93h524v93H218ZM95-677v-94h771v94H95Z"
  })
});
var filter_list_fill_default3 = SvgComponent161;

// ../../../node_modules/@material-symbols/svg-700/sharp/filter_list.svg
import * as React162 from "react";
import { jsx as jsx194 } from "react/jsx-runtime";
var SvgComponent162 = (props) => /* @__PURE__ */ jsx194("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx194("path", {
    d: "M382-190v-94h196v94H382ZM218-434v-93h524v93H218ZM95-677v-94h771v94H95Z"
  })
});
var filter_list_default3 = SvgComponent162;

// src/components/icon/variants/IconFilterList.tsx
import { useTranslation as useTranslation33 } from "react-i18next";
import { jsx as jsx195 } from "react/jsx-runtime";
var componentMap26 = {
  outlined: filter_list_default,
  "outlined-fill": filter_list_fill_default,
  rounded: filter_list_default2,
  "rounded-fill": filter_list_fill_default2,
  sharp: filter_list_default3,
  "sharp-fill": filter_list_fill_default3
};
var IconFilterList = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation33("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap26[key] ?? componentMap26[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx195(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/flag-fill.svg
import * as React163 from "react";
import { jsx as jsx196 } from "react/jsx-runtime";
var SvgComponent163 = (props) => /* @__PURE__ */ jsx196("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx196("path", {
    d: "M175-95v-731h389l19.33 86H826v421H523l-19-85H269v309h-94Z"
  })
});
var flag_fill_default = SvgComponent163;

// ../../../node_modules/@material-symbols/svg-700/outlined/flag.svg
import * as React164 from "react";
import { jsx as jsx197 } from "react/jsx-runtime";
var SvgComponent164 = (props) => /* @__PURE__ */ jsx197("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx197("path", {
    d: "M175-95v-731h389l19.33 86H826v421H523l-18.93-85H269v309h-94Zm325-477Zm103 159h128v-232H502.93L484-731H269v233h315.05L603-413Z"
  })
});
var flag_default = SvgComponent164;

// ../../../node_modules/@material-symbols/svg-700/rounded/flag-fill.svg
import * as React165 from "react";
import { jsx as jsx198 } from "react/jsx-runtime";
var SvgComponent165 = (props) => /* @__PURE__ */ jsx198("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx198("path", {
    d: "M269-404v262q0 19.75-13.68 33.37Q241.65-95 221.82-95 202-95 188.5-108.63 175-122.25 175-142v-636q0-19.75 13.63-33.88Q202.25-826 222-826h304q16.5 0 29.75 11.5T572-787l11 47h195q19.75 0 33.88 14.12Q826-711.75 826-692v326q0 19.75-14.12 33.37Q797.75-319 778-319H561q-16.5 0-29.75-10.5T515-356l-11-48H269Z"
  })
});
var flag_fill_default2 = SvgComponent165;

// ../../../node_modules/@material-symbols/svg-700/rounded/flag.svg
import * as React166 from "react";
import { jsx as jsx199 } from "react/jsx-runtime";
var SvgComponent166 = (props) => /* @__PURE__ */ jsx199("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx199("path", {
    d: "M269-404v262q0 19.75-13.68 33.37Q241.65-95 221.82-95 202-95 188.5-108.63 175-122.25 175-142v-636q0-19.75 13.63-33.88Q202.25-826 222-826h304q16.5 0 29.75 11.5T572-787l11 47h195q19.75 0 33.88 14.12Q826-711.75 826-692v326q0 19.75-14.12 33.37Q797.75-319 778-319H561q-16.5 0-29.75-10.5T515-356l-11-48H269Zm334-9h128v-232H541q-16.5 0-29.75-11T495-683l-11-48H269v233h277q16.5 0 29.75 10.5T592-461l11 48ZM500-572Z"
  })
});
var flag_default2 = SvgComponent166;

// ../../../node_modules/@material-symbols/svg-700/sharp/flag-fill.svg
import * as React167 from "react";
import { jsx as jsx200 } from "react/jsx-runtime";
var SvgComponent167 = (props) => /* @__PURE__ */ jsx200("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx200("path", {
    d: "M175-95v-731h389l19.33 86H826v421H523l-19-85H269v309h-94Z"
  })
});
var flag_fill_default3 = SvgComponent167;

// ../../../node_modules/@material-symbols/svg-700/sharp/flag.svg
import * as React168 from "react";
import { jsx as jsx201 } from "react/jsx-runtime";
var SvgComponent168 = (props) => /* @__PURE__ */ jsx201("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx201("path", {
    d: "M175-95v-731h389l19.33 86H826v421H523l-18.93-85H269v309h-94Zm325-477Zm103 159h128v-232H502.93L484-731H269v233h315.05L603-413Z"
  })
});
var flag_default3 = SvgComponent168;

// src/components/icon/variants/IconFlag.tsx
import { useTranslation as useTranslation34 } from "react-i18next";
import { jsx as jsx202 } from "react/jsx-runtime";
var componentMap27 = {
  outlined: flag_default,
  "outlined-fill": flag_fill_default,
  rounded: flag_default2,
  "rounded-fill": flag_fill_default2,
  sharp: flag_default3,
  "sharp-fill": flag_fill_default3
};
var IconFlag = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation34("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap27[key] ?? componentMap27[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx202(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/forward_to_inbox-fill.svg
import * as React169 from "react";
import { jsx as jsx203 } from "react/jsx-runtime";
var SvgComponent169 = (props) => /* @__PURE__ */ jsx203("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx203("path", {
    d: "m785-16-51-52 65-67H594v-75h205l-66-66 52-53 157 157L785-16ZM149-135q-40.05 0-67.03-26.98Q55-188.95 55-229v-502q0-40.46 26.97-67.73Q108.95-826 149-826h662q40.46 0 67.73 27.27Q906-771.46 906-731v358q-28.1-15-57.58-23-29.49-8-60.42-8-105.75 0-179.87 73.5Q534-257 534-152v17H149Zm331-296 331-217v-83L480-518 149-731v83l331 217Z"
  })
});
var forward_to_inbox_fill_default = SvgComponent169;

// ../../../node_modules/@material-symbols/svg-700/outlined/forward_to_inbox.svg
import * as React170 from "react";
import { jsx as jsx204 } from "react/jsx-runtime";
var SvgComponent170 = (props) => /* @__PURE__ */ jsx204("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx204("path", {
    d: "M480-436 149-653v424h385v94H149q-39.05 0-66.53-27.48Q55-189.95 55-229v-502q0-39.46 27.47-67.23Q109.95-826 149-826h662q39.46 0 67.23 27.77Q906-770.46 906-731v327h-95v-249L480-436Zm0-82 331-213H149l331 213ZM785-16l-51-52 65-67H594v-75h205l-66-66 52-53 157 157L785-16ZM149-653v501-252 3-330 78Z"
  })
});
var forward_to_inbox_default = SvgComponent170;

// ../../../node_modules/@material-symbols/svg-700/rounded/forward_to_inbox-fill.svg
import * as React171 from "react";
import { jsx as jsx205 } from "react/jsx-runtime";
var SvgComponent171 = (props) => /* @__PURE__ */ jsx205("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx205("path", {
    d: "M799-135H631q-15.72 0-26.36-10.69-10.64-10.7-10.64-26.5Q594-188 604.64-199q10.64-11 26.36-11h168l-40-40q-11-11-11-26t11-26q11-12 26.5-11.5t26.71 11.71L908-206q7 7 10.5 16.05 3.5 9.04 3.5 17.95 0 9-3.5 17.5T908-138l-95.81 95.81Q800-30 785.1-30.5T759-43q-11-11-11-25t11-26l40-41Zm-650 0q-40.05 0-67.03-26.98Q55-188.95 55-229v-502q0-40.46 26.97-67.73Q108.95-826 149-826h662q40.46 0 67.73 27.27Q906-771.46 906-731v295q0 22.16-18.5 34.08Q869-390 848-397q-14.94-4.45-29.97-5.73Q803-404 788.21-404q-105.84 0-180.02 73.5Q534-257 534-152q0 7-5.36 12T517-135H149Zm331-383L203-696q-17-11-35.5-1.25T149-666q0 9.25 4.5 16.12Q158-643 165-638l289 190q12 8 26 8t26-8l289-190q7-5 11.5-11.82t4.5-16Q811-687 792.5-697t-35.5 1L480-518Z"
  })
});
var forward_to_inbox_fill_default2 = SvgComponent171;

// ../../../node_modules/@material-symbols/svg-700/rounded/forward_to_inbox.svg
import * as React172 from "react";
import { jsx as jsx206 } from "react/jsx-runtime";
var SvgComponent172 = (props) => /* @__PURE__ */ jsx206("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx206("path", {
    d: "M811-731H149v502h338q19.75 0 33.38 13.68Q534-201.65 534-181.82q0 19.82-13.62 33.32Q506.75-135 487-135H149q-39.05 0-66.53-27.48Q55-189.95 55-229v-502q0-39.46 27.47-67.23Q109.95-826 149-826h662q39.46 0 67.23 27.77Q906-770.46 906-731v280q0 19.75-14.26 33.37-14.27 13.63-34 13.63-19.74 0-33.24-13.63Q811-431.25 811-451v-280Zm-662 0v502-175 3-330Zm331 218 331-218v78L506-448q-11.75 8-25.87 8-14.13 0-26.13-8L149-646v-85l331 218Zm319 378H631q-15.72 0-26.36-10.69-10.64-10.7-10.64-26.5Q594-188 604.64-199q10.64-11 26.36-11h168l-40-40q-11-11-11-26t11-26.39q11-11.61 26.5-11.11t26.71 11.71L908-206q7 7 10.5 16.14 3.5 9.13 3.5 17.86 0 9-3.5 17.5T908-138l-95.81 95.81Q800-30 785.1-30.5t-26.23-12.63Q748-54 748-68q0-14 11-26l40-41Z"
  })
});
var forward_to_inbox_default2 = SvgComponent172;

// ../../../node_modules/@material-symbols/svg-700/sharp/forward_to_inbox-fill.svg
import * as React173 from "react";
import { jsx as jsx207 } from "react/jsx-runtime";
var SvgComponent173 = (props) => /* @__PURE__ */ jsx207("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx207("path", {
    d: "m785-16-51-52 65-67H594v-75h205l-66-66 52-53 157 157L785-16ZM55-135v-691h851v453q-28.1-15-57.52-23T788-404q-106.17 0-180.08 73.71Q534-256.58 534-152v17H55Zm425-296 331-217v-83L480-518 149-731v83l331 217Z"
  })
});
var forward_to_inbox_fill_default3 = SvgComponent173;

// ../../../node_modules/@material-symbols/svg-700/sharp/forward_to_inbox.svg
import * as React174 from "react";
import { jsx as jsx208 } from "react/jsx-runtime";
var SvgComponent174 = (props) => /* @__PURE__ */ jsx208("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx208("path", {
    d: "M480-436 149-653v424h385v94H55v-691h851v422h-95v-249L480-436Zm0-82 331-213H149l331 213ZM785-16l-51-52 65-67H594v-75h205l-66-66 52-53 157 157L785-16ZM149-653v501-252 3-330 78Z"
  })
});
var forward_to_inbox_default3 = SvgComponent174;

// src/components/icon/variants/IconForwardToInbox.tsx
import { useTranslation as useTranslation35 } from "react-i18next";
import { jsx as jsx209 } from "react/jsx-runtime";
var componentMap28 = {
  outlined: forward_to_inbox_default,
  "outlined-fill": forward_to_inbox_fill_default,
  rounded: forward_to_inbox_default2,
  "rounded-fill": forward_to_inbox_fill_default2,
  sharp: forward_to_inbox_default3,
  "sharp-fill": forward_to_inbox_fill_default3
};
var IconForwardToInbox = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation35("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap28[key] ?? componentMap28[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx209(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// src/components/icon/variants/IconGenericHome.tsx
import { useTranslation as useTranslation36 } from "react-i18next";

// src/components/icon/static/generic-home.svg
import * as React175 from "react";
import { jsx as jsx210, jsxs as jsxs6 } from "react/jsx-runtime";
var SvgComponent175 = (props) => /* @__PURE__ */ jsxs6("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: [
    /* @__PURE__ */ jsx210("path", {
      d: "M5.49562 21.6325C4.80474 21.6325 4.21602 21.3893 3.72947 20.9027C3.24291 20.4162 2.99963 19.8274 2.99963 19.1366V9.38054C2.99963 8.98609 3.08718 8.6124 3.26229 8.25947C3.4374 7.90654 3.68178 7.61421 3.99541 7.38246L10.4994 2.50443C10.9403 2.16814 11.4403 2 11.9996 2C12.5589 2 13.059 2.16814 13.4998 2.50443L20.0039 7.38246C20.3175 7.61421 20.5619 7.90654 20.737 8.25947C20.9121 8.6124 20.9996 8.98609 20.9996 9.38054V19.1366C20.9996 19.8274 20.7564 20.4162 20.2698 20.9027C19.7832 21.3893 19.1945 21.6325 18.5037 21.6325H5.49562ZM5.49562 19.1366H18.5037V9.38054L11.9996 4.50251L5.49562 9.38054V19.1366Z"
    }),
    /* @__PURE__ */ jsx210("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 8.85C12.6351 8.85 13.15 9.36487 13.15 10V16C13.15 16.6351 12.6351 17.15 12 17.15C11.3649 17.15 10.85 16.6351 10.85 16V10C10.85 9.36487 11.3649 8.85 12 8.85Z"
    }),
    /* @__PURE__ */ jsx210("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.15 13C16.15 13.6351 15.6351 14.15 15 14.15L9 14.15C8.36487 14.15 7.85 13.6351 7.85 13C7.85 12.3649 8.36487 11.85 9 11.85H15C15.6351 11.85 16.15 12.3649 16.15 13Z"
    })
  ]
});
var generic_home_default = SvgComponent175;

// src/components/icon/variants/IconGenericHome.tsx
import { jsx as jsx211 } from "react/jsx-runtime";
var IconGenericHome = ({
  color,
  height,
  style = {},
  width
}) => {
  const { t } = useTranslation36("pds");
  return /* @__PURE__ */ jsx211(Icon, {
    SvgIcon: generic_home_default,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// src/components/icon/variants/IconGenericPharmacy.tsx
import { useTranslation as useTranslation37 } from "react-i18next";

// src/components/icon/static/generic-pharmacy.svg
import * as React176 from "react";
import { jsx as jsx212, jsxs as jsxs7 } from "react/jsx-runtime";
var SvgComponent176 = (props) => /* @__PURE__ */ jsxs7("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: [
    /* @__PURE__ */ jsx212("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.24391 4.1501L3.3455 7.8501H20.6531L19.7473 4.1501H4.24391ZM2.14412 3.05092C2.34002 2.29584 3.03342 1.8501 3.71986 1.8501H20.2703C20.9293 1.8501 21.6713 2.26866 21.8533 3.08034L23.1022 8.18176C23.3936 9.32103 22.4188 10.1501 21.5244 10.1501H2.47601C1.5526 10.1501 0.611821 9.30487 0.897828 8.18303L2.14186 3.05963L2.14412 3.05092Z"
    }),
    /* @__PURE__ */ jsx212("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.15 10.1501V19.8501H19.85V10.1501H4.15ZM1.85 9.60645C1.85 8.59452 2.68991 7.8501 3.63051 7.8501H20.3695C21.3101 7.8501 22.15 8.59452 22.15 9.60645V20.3937C22.15 21.4057 21.3101 22.1501 20.3695 22.1501H3.63051C2.68991 22.1501 1.85 21.4057 1.85 20.3937V9.60645Z"
    }),
    /* @__PURE__ */ jsx212("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 10.8501C12.6351 10.8501 13.15 11.365 13.15 12.0001V18.0001C13.15 18.6352 12.6351 19.1501 12 19.1501C11.3649 19.1501 10.85 18.6352 10.85 18.0001V12.0001C10.85 11.365 11.3649 10.8501 12 10.8501Z"
    }),
    /* @__PURE__ */ jsx212("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.15 15.0001C16.15 15.6352 15.6351 16.1501 15 16.1501H9C8.36487 16.1501 7.85 15.6352 7.85 15.0001C7.85 14.365 8.36487 13.8501 9 13.8501L15 13.8501C15.6351 13.8501 16.15 14.365 16.15 15.0001Z"
    })
  ]
});
var generic_pharmacy_default = SvgComponent176;

// src/components/icon/variants/IconGenericPharmacy.tsx
import { jsx as jsx213 } from "react/jsx-runtime";
var IconGenericPharmacy = ({
  color,
  height,
  style = {},
  width
}) => {
  const { t } = useTranslation37("pds");
  return /* @__PURE__ */ jsx213(Icon, {
    SvgIcon: generic_pharmacy_default,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/group-fill.svg
import * as React177 from "react";
import { jsx as jsx214 } from "react/jsx-runtime";
var SvgComponent177 = (props) => /* @__PURE__ */ jsx214("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx214("path", {
    d: "M15-122v-121q0-42.3 21.7-76.1Q58.39-352.9 97-371q75-32 136.47-47 61.48-15 126.55-15 66.98 0 127.48 14.5T623-371q38.34 16.83 60.67 50.7Q706-286.43 706-243.05V-122H15Zm762 0v-119q0-65-31.5-109.5T660-431q61 9 115.5 23.5T866-375q36 19 57.5 54.81t21.5 82.24V-122H777ZM360.25-494Q288-494 243-539t-45-117.5q0-72.5 45.04-117.5 45.05-45 117-45 71.96 0 117.46 45.03T523-657q0 73-45.25 118t-117.5 45ZM757-657.01q0 72.01-45.45 117.51-45.44 45.5-117.8 45.5-12.06 0-24.4-2-12.35-2-26.35-7 26-27 38.5-65.85 12.5-38.85 12.5-87.5t-12.65-86.13q-12.66-37.49-38.35-67.65 12-3.87 25.24-6.37 13.24-2.5 25.51-2.5 71.99 0 117.62 45.52Q757-727.96 757-657.01Z"
  })
});
var group_fill_default = SvgComponent177;

// ../../../node_modules/@material-symbols/svg-700/outlined/group.svg
import * as React178 from "react";
import { jsx as jsx215 } from "react/jsx-runtime";
var SvgComponent178 = (props) => /* @__PURE__ */ jsx215("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx215("path", {
    d: "M15-122v-121q0-42.3 21.7-76.1Q58.39-352.9 97-371q75-32 136.47-47 61.48-15 126.55-15 66.98 0 127.48 14.5T623-371q38.34 16.83 60.67 50.7Q706-286.43 706-243.05V-122H15Zm762 0v-119q0-65-31.5-109.5T660-431q61 9 115.5 23.5T866-375q36 19 57.5 54.81t21.5 82.24V-122H777ZM360.25-494Q288-494 243-539t-45-117.5q0-72.5 45.04-117.5 45.05-45 117-45 71.96 0 117.46 45.03T523-657q0 73-45.25 118t-117.5 45ZM757-657.01q0 72.01-45.45 117.51-45.44 45.5-117.8 45.5-12.06 0-24.4-2-12.35-2-26.35-7 26-27 38.5-65.85 12.5-38.85 12.5-87.5t-12.65-86.13q-12.66-37.49-38.35-67.65 12-3.87 25.24-6.37 13.24-2.5 25.51-2.5 71.99 0 117.62 45.52Q757-727.96 757-657.01ZM109-216h502v-23q0-15.35-9.5-29.82T578-289q-68-29-114-39t-104-10q-56 0-104 10t-115 39q-13 5.56-22.5 20.08Q109-254.41 109-239v23Zm250.84-361q34.81 0 57.49-22.38 22.67-22.38 22.67-57 0-34.62-22.38-57.12t-57-22.5q-34.62 0-57.12 22.22T281-657.16q0 34.81 22.22 57.49Q325.44-577 359.84-577Zm.16 361Zm0-441Z"
  })
});
var group_default = SvgComponent178;

// ../../../node_modules/@material-symbols/svg-700/rounded/group-fill.svg
import * as React179 from "react";
import { jsx as jsx216 } from "react/jsx-runtime";
var SvgComponent179 = (props) => /* @__PURE__ */ jsx216("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx216("path", {
    d: "M15-243q0-42 21.5-76T97-371q75-32 136.5-47T360-433q67 0 127.5 14.5T623-371q39 17 61 51t22 77v27q0 39-27.5 66.5T611-122H109q-39 0-66.5-27.5T15-216v-27Zm721 121q13-22 21.5-45t8.5-49v-21q0-68-29-116t-98-82q64 9 126.5 25T866-375q36 19 57.5 55t21.5 82v22q0 39-27.5 66.5T851-122H736ZM360-494q-72 0-117-45t-45-118q0-72 45-117t117-45q72 0 117.5 45T523-657q0 73-45.5 118T360-494Zm397-163q0 72-45.5 117.5T594-494q-12 0-24.5-2t-26.5-7q26-27 38.5-66t12.5-88q0-48-12.5-85.5T543-810q12-4 25-6.5t26-2.5q72 0 117.5 45.5T757-657Z"
  })
});
var group_fill_default2 = SvgComponent179;

// ../../../node_modules/@material-symbols/svg-700/rounded/group.svg
import * as React180 from "react";
import { jsx as jsx217 } from "react/jsx-runtime";
var SvgComponent180 = (props) => /* @__PURE__ */ jsx217("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx217("path", {
    d: "M15-243q0-42.3 21.7-76.1Q58.39-352.9 97-371q75-32 136.47-47 61.48-15 126.55-15 66.98 0 127.48 14.5T623-371q38.34 16.83 60.67 50.7Q706-286.43 706-243v27q0 38.75-27.39 66.37Q651.21-122 611-122H109q-38.75 0-66.37-27.63Q15-177.25 15-216v-27Zm836 121H736q13-22 21.5-45t8.5-49v-21q0-68-29-116t-98-82q64 9 126.5 25T866-375q36 19 57.5 54.81T945-238v22q0 38.75-27.62 66.37Q889.75-122 851-122ZM360.25-494Q288-494 243-539t-45-117.5q0-72.5 45.04-117.5 45.05-45 117-45 71.96 0 117.46 45.03T523-657q0 73-45.25 118t-117.5 45ZM757-657.01q0 72.01-45.45 117.51-45.44 45.5-117.8 45.5-12.06 0-24.4-2-12.35-2-26.35-7 26-27 38.5-65.85 12.5-38.85 12.5-87.5t-12.65-86.13q-12.66-37.49-38.35-67.65 12-3.87 25.24-6.37 13.24-2.5 25.51-2.5 71.99 0 117.62 45.52Q757-727.96 757-657.01ZM109-216h502v-23q0-15.35-9.5-29.82T578-289q-68-29-114-39t-104-10q-56 0-104 10t-115 39q-13 5.56-22.5 20.08Q109-254.41 109-239v23Zm250.84-361q34.81 0 57.49-22.38 22.67-22.38 22.67-57 0-34.62-22.38-57.12t-57-22.5q-34.62 0-57.12 22.22T281-657.16q0 34.81 22.22 57.49Q325.44-577 359.84-577Zm.16 361Zm0-441Z"
  })
});
var group_default2 = SvgComponent180;

// ../../../node_modules/@material-symbols/svg-700/sharp/group-fill.svg
import * as React181 from "react";
import { jsx as jsx218 } from "react/jsx-runtime";
var SvgComponent181 = (props) => /* @__PURE__ */ jsx218("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx218("path", {
    d: "M15-122v-121q0-42.3 21.7-76.1Q58.39-352.9 97-371q75-32 136.47-47 61.48-15 126.55-15 66.98 0 127.48 14.5T623-371q38.34 16.83 60.67 50.7Q706-286.43 706-243.05V-122H15Zm762 0v-119q0-65-31.5-109.5T660-431q61 9 115.5 23.5T866-375q36 19 57.5 54.81t21.5 82.24V-122H777ZM360.25-494Q288-494 243-539t-45-117.5q0-72.5 45.04-117.5 45.05-45 117-45 71.96 0 117.46 45.03T523-657q0 73-45.25 118t-117.5 45ZM757-657.01q0 72.01-45.45 117.51-45.44 45.5-117.8 45.5-12.06 0-24.4-2-12.35-2-26.35-7 26-27 38.5-65.85 12.5-38.85 12.5-87.5t-12.65-86.13q-12.66-37.49-38.35-67.65 12-3.87 25.24-6.37 13.24-2.5 25.51-2.5 71.99 0 117.62 45.52Q757-727.96 757-657.01Z"
  })
});
var group_fill_default3 = SvgComponent181;

// ../../../node_modules/@material-symbols/svg-700/sharp/group.svg
import * as React182 from "react";
import { jsx as jsx219 } from "react/jsx-runtime";
var SvgComponent182 = (props) => /* @__PURE__ */ jsx219("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx219("path", {
    d: "M15-122v-121q0-42.3 21.7-76.1Q58.39-352.9 97-371q75-32 136.47-47 61.48-15 126.55-15 66.98 0 127.48 14.5T623-371q38.34 16.83 60.67 50.7Q706-286.43 706-243.05V-122H15Zm762 0v-119q0-65-31.5-109.5T660-431q61 9 115.5 23.5T866-375q36 19 57.5 54.81t21.5 82.24V-122H777ZM360.25-494Q288-494 243-539t-45-117.5q0-72.5 45.04-117.5 45.05-45 117-45 71.96 0 117.46 45.03T523-657q0 73-45.25 118t-117.5 45ZM757-657.01q0 72.01-45.45 117.51-45.44 45.5-117.8 45.5-12.06 0-24.4-2-12.35-2-26.35-7 26-27 38.5-65.85 12.5-38.85 12.5-87.5t-12.65-86.13q-12.66-37.49-38.35-67.65 12-3.87 25.24-6.37 13.24-2.5 25.51-2.5 71.99 0 117.62 45.52Q757-727.96 757-657.01ZM109-216h502v-23q0-15.35-9.5-29.82T578-289q-68-29-114-39t-104-10q-56 0-104 10t-115 39q-13 5.56-22.5 20.08Q109-254.41 109-239v23Zm250.84-361q34.81 0 57.49-22.38 22.67-22.38 22.67-57 0-34.62-22.38-57.12t-57-22.5q-34.62 0-57.12 22.22T281-657.16q0 34.81 22.22 57.49Q325.44-577 359.84-577Zm.16 361Zm0-441Z"
  })
});
var group_default3 = SvgComponent182;

// src/components/icon/variants/IconGroup.tsx
import { useTranslation as useTranslation38 } from "react-i18next";
import { jsx as jsx220 } from "react/jsx-runtime";
var componentMap29 = {
  outlined: group_default,
  "outlined-fill": group_fill_default,
  rounded: group_default2,
  "rounded-fill": group_fill_default2,
  sharp: group_default3,
  "sharp-fill": group_fill_default3
};
var IconGroup = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation38("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap29[key] ?? componentMap29[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx220(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/headphones-fill.svg
import * as React183 from "react";
import { jsx as jsx221 } from "react/jsx-runtime";
var SvgComponent183 = (props) => /* @__PURE__ */ jsx221("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx221("path", {
    d: "M349-97H189q-39.05 0-66.53-27.47Q95-151.95 95-191v-289q0-80 30-150t82.5-122.5Q260-805 330-835.5T480-866q80 0 150 30.5t122.5 83Q805-700 835.5-630T866-480v289q0 39.05-27.77 66.53Q810.46-97 771-97H611v-342h160v-41q0-121.25-84.82-206.13-84.82-84.87-206-84.87T274-686.13Q189-601.25 189-480v41h160v342Z"
  })
});
var headphones_fill_default = SvgComponent183;

// ../../../node_modules/@material-symbols/svg-700/outlined/headphones.svg
import * as React184 from "react";
import { jsx as jsx222 } from "react/jsx-runtime";
var SvgComponent184 = (props) => /* @__PURE__ */ jsx222("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx222("path", {
    d: "M349-97H189q-39.05 0-66.53-27.47Q95-151.95 95-191v-289q0-80 30-150t82.5-122.5Q260-805 330-835.5T480-866q80 0 150 30.5t122.5 83Q805-700 835.5-630T866-480v289q0 39.05-27.77 66.53Q810.46-97 771-97H611v-342h160v-41q0-121.6-84.65-206.3Q601.69-771 480.17-771q-121.53 0-206.35 84.7T189-480v41h160v342Zm-94-248h-66v154h66v-154Zm451 0v154h65v-154h-65Zm-451 0h-66 66Zm451 0h65-65Z"
  })
});
var headphones_default = SvgComponent184;

// ../../../node_modules/@material-symbols/svg-700/rounded/headphones-fill.svg
import * as React185 from "react";
import { jsx as jsx223 } from "react/jsx-runtime";
var SvgComponent185 = (props) => /* @__PURE__ */ jsx223("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx223("path", {
    d: "M255-97h-66q-39 0-66.5-27.5T95-191v-289q0-80 30-150t82.5-122.5Q260-805 330-835.5T480-866q80 0 150 30.5t122.5 83Q805-700 835.5-630T866-480v289q0 39-28 66.5T771-97h-65q-39.75 0-67.37-27.63Q611-152.25 611-191v-154q0-38.75 27.63-66.38Q666.25-439 706-439h65v-41q0-121.36-84.82-206.18Q601.36-771 480-771q-121.36 0-206.18 84.82Q189-601.36 189-480v41h66q38.75 0 66.38 27.62Q349-383.75 349-345v154q0 38.75-27.62 66.37Q293.75-97 255-97Z"
  })
});
var headphones_fill_default2 = SvgComponent185;

// ../../../node_modules/@material-symbols/svg-700/rounded/headphones.svg
import * as React186 from "react";
import { jsx as jsx224 } from "react/jsx-runtime";
var SvgComponent186 = (props) => /* @__PURE__ */ jsx224("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx224("path", {
    d: "M255-97h-66q-39.05 0-66.53-27.47Q95-151.95 95-191v-289q0-80 30-150t82.5-122.5Q260-805 330-835.5T480-866q80 0 150 30.5t122.5 83Q805-700 835.5-630T866-480v289q0 39.05-27.77 66.53Q810.46-97 771-97h-65q-40.21 0-67.61-27.63Q611-152.25 611-191v-154q0-38.75 27.39-66.38Q665.79-439 706-439h65v-41q0-121.6-84.65-206.3Q601.69-771 480.17-771q-121.53 0-206.35 84.7T189-480v41h66q38.75 0 66.38 27.62Q349-383.75 349-345v154q0 38.75-27.62 66.37Q293.75-97 255-97Zm0-248h-66v154h66v-154Zm451 0v154h65v-154h-65Zm-451 0h-66 66Zm451 0h65-65Z"
  })
});
var headphones_default2 = SvgComponent186;

// ../../../node_modules/@material-symbols/svg-700/sharp/headphones-fill.svg
import * as React187 from "react";
import { jsx as jsx225 } from "react/jsx-runtime";
var SvgComponent187 = (props) => /* @__PURE__ */ jsx225("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx225("path", {
    d: "M349-97H95v-382.62Q95-560 125-630t82.5-122.5Q260-805 330-835.5T480-866q80 0 150 30.5t122.5 83Q805-700 835.5-630T866-479.62V-97H611v-342h160v-41q0-121.6-84.65-206.3Q601.69-771 480.17-771q-121.53 0-206.35 84.7T189-480v41h160v342Z"
  })
});
var headphones_fill_default3 = SvgComponent187;

// ../../../node_modules/@material-symbols/svg-700/sharp/headphones.svg
import * as React188 from "react";
import { jsx as jsx226 } from "react/jsx-runtime";
var SvgComponent188 = (props) => /* @__PURE__ */ jsx226("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx226("path", {
    d: "M349-97H95v-382.62Q95-560 125-630t82.5-122.5Q260-805 330-835.5T480-866q80 0 150 30.5t122.5 83Q805-700 835.5-630T866-479.62V-97H611v-342h160v-41q0-121.6-84.65-206.3Q601.69-771 480.17-771q-121.53 0-206.35 84.7T189-480v41h160v342Zm-94-248h-66v154h66v-154Zm451 0v154h65v-154h-65Zm-451 0h-66 66Zm451 0h65-65Z"
  })
});
var headphones_default3 = SvgComponent188;

// src/components/icon/variants/IconHeadphones.tsx
import { useTranslation as useTranslation39 } from "react-i18next";
import { jsx as jsx227 } from "react/jsx-runtime";
var componentMap30 = {
  outlined: headphones_default,
  "outlined-fill": headphones_fill_default,
  rounded: headphones_default2,
  "rounded-fill": headphones_fill_default2,
  sharp: headphones_default3,
  "sharp-fill": headphones_fill_default3
};
var IconHeadphones = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation39("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap30[key] ?? componentMap30[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx227(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/health_and_safety-fill.svg
import * as React189 from "react";
import { jsx as jsx228 } from "react/jsx-runtime";
var SvgComponent189 = (props) => /* @__PURE__ */ jsx228("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx228("path", {
    d: "M440-360h80v-100h100v-80H520v-100h-80v100H340v80h100v100Zm39.94 305Q329.1-92.81 232.05-227.41 135-362.01 135-522.67v-255.79L480-907l346 128.57V-523q0 160.79-97.62 295.49Q630.77-92.81 479.94-55Z"
  })
});
var health_and_safety_fill_default = SvgComponent189;

// ../../../node_modules/@material-symbols/svg-700/outlined/health_and_safety.svg
import * as React190 from "react";
import { jsx as jsx229 } from "react/jsx-runtime";
var SvgComponent190 = (props) => /* @__PURE__ */ jsx229("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx229("path", {
    d: "M440-360h80v-100h100v-80H520v-100h-80v100H340v80h100v100Zm39.94 305Q329.1-92.81 232.05-227.41 135-362.01 135-522.67v-255.79L480-907l346 128.57V-523q0 160.79-97.62 295.49Q630.77-92.81 479.94-55Zm.06-96q110-43 180.5-144T731-522.71V-712l-251-95-251 95.48v188.35Q229-396 299.5-295 370-194 480-151Zm0-328Z"
  })
});
var health_and_safety_default = SvgComponent190;

// ../../../node_modules/@material-symbols/svg-700/rounded/health_and_safety-fill.svg
import * as React191 from "react";
import { jsx as jsx230 } from "react/jsx-runtime";
var SvgComponent191 = (props) => /* @__PURE__ */ jsx230("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx230("path", {
    d: "M440-460v83q0 6 5.5 11.5T457-360h48q7 0 11-5.5t4-11.5v-83h85q7 0 11-5.5t4-11.5v-48q0-7-4-11t-11-4h-85v-85q0-7-4-11t-11-4h-48q-6 0-11.5 4t-5.5 11v85h-83q-6 0-11.5 4t-5.5 11v48q0 6 5.5 11.5T357-460h83Zm40 400q-8 0-15.5-1.5T450-66q-144-47-229.5-177.5T135-523v-189q0-30 16.5-55t44.5-35l251-94q16-6 33-6t33 6l251 94q28 10 45 35t17 55v189q0 149-86 279.5T510-66q-7 3-14.5 4.5T480-60Z"
  })
});
var health_and_safety_fill_default2 = SvgComponent191;

// ../../../node_modules/@material-symbols/svg-700/rounded/health_and_safety.svg
import * as React192 from "react";
import { jsx as jsx231 } from "react/jsx-runtime";
var SvgComponent192 = (props) => /* @__PURE__ */ jsx231("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx231("path", {
    d: "M440-460v83q0 5.85 5.58 11.42Q451.15-360 457-360h48q7.2 0 11.1-5.58 3.9-5.57 3.9-11.42v-83h85q7.2 0 11.1-5.58 3.9-5.57 3.9-11.42v-48q0-7.2-3.9-11.1-3.9-3.9-11.1-3.9h-85v-85q0-7.2-3.9-11.1-3.9-3.9-11.1-3.9h-48q-5.85 0-11.42 3.9Q440-632.2 440-625v85h-83q-5.85 0-11.42 3.9Q340-532.2 340-525v48q0 5.85 5.58 11.42Q351.15-460 357-460h83Zm40 400q-8.32 0-15.88-1.5Q456.56-63 450-66q-144-47-229.5-177.6Q135-374.19 135-523.11V-712q0-30.26 16.38-55.16Q167.75-792.07 196-802l251-94q16-6 33-6t33 6l251 94q28.25 9.93 45.13 34.84Q826-742.26 826-712v188.89q0 148.92-86 279.51Q654-113 510-66q-6.56 3-14.12 4.5T480-60Zm0-91q110-43 180.5-144T731-523.17V-712l-251-95-251 95v188.83Q229-396 299.5-295 370-194 480-151Zm0-328Z"
  })
});
var health_and_safety_default2 = SvgComponent192;

// ../../../node_modules/@material-symbols/svg-700/sharp/health_and_safety-fill.svg
import * as React193 from "react";
import { jsx as jsx232 } from "react/jsx-runtime";
var SvgComponent193 = (props) => /* @__PURE__ */ jsx232("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx232("path", {
    d: "M440-360h80v-100h100v-80H520v-100h-80v100H340v80h100v100Zm39.94 305Q329.1-92.81 232.05-227.41 135-362.01 135-522.67v-255.79L480-907l346 128.57V-523q0 160.79-97.62 295.49Q630.77-92.81 479.94-55Z"
  })
});
var health_and_safety_fill_default3 = SvgComponent193;

// ../../../node_modules/@material-symbols/svg-700/sharp/health_and_safety.svg
import * as React194 from "react";
import { jsx as jsx233 } from "react/jsx-runtime";
var SvgComponent194 = (props) => /* @__PURE__ */ jsx233("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx233("path", {
    d: "M440-360h80v-100h100v-80H520v-100h-80v100H340v80h100v100Zm39.94 305Q329.1-92.81 232.05-227.41 135-362.01 135-522.67v-255.79L480-907l346 128.57V-523q0 160.79-97.62 295.49Q630.77-92.81 479.94-55Zm.06-96q110-43 180.5-144T731-522.71V-712l-251-95-251 95.48v188.35Q229-396 299.5-295 370-194 480-151Zm0-328Z"
  })
});
var health_and_safety_default3 = SvgComponent194;

// src/components/icon/variants/IconHealthAndSafety.tsx
import { useTranslation as useTranslation40 } from "react-i18next";
import { jsx as jsx234 } from "react/jsx-runtime";
var componentMap31 = {
  outlined: health_and_safety_default,
  "outlined-fill": health_and_safety_fill_default,
  rounded: health_and_safety_default2,
  "rounded-fill": health_and_safety_fill_default2,
  sharp: health_and_safety_default3,
  "sharp-fill": health_and_safety_fill_default3
};
var IconHealthAndSafety = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation40("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap31[key] ?? componentMap31[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx234(Icon, {
    SvgIcon,
    alt: t("icon.healthAndSafety"),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/help_center-fill.svg
import * as React195 from "react";
import { jsx as jsx235 } from "react/jsx-runtime";
var SvgComponent195 = (props) => /* @__PURE__ */ jsx235("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx235("path", {
    d: "M473.5-246q18.5 0 32.5-14t14-32.5q0-18.5-13.92-32T473-338q-18 0-31.5 13.42T428-292q0 18 13.5 32t32 14ZM433-394h72q0-26 9-47.72 9-21.71 37-47.28 25-26 38.5-51.78 13.5-25.77 13.5-57.85Q603-656 567-687q-36-31-91-31-55.17 0-93.08 30Q345-658 327-614l69 28q14-24 31.9-40.5T475-643q26 0 40 13.83t14 35.2q0 17.97-11 34.47T491-527q-40 39-49 63t-9 70ZM189-95q-39.05 0-66.53-27.47Q95-149.95 95-189v-582q0-39.46 27.47-67.23Q149.95-866 189-866h582q39.46 0 67.23 27.77Q866-810.46 866-771v582q0 39.05-27.77 66.53Q810.46-95 771-95H189Z"
  })
});
var help_center_fill_default = SvgComponent195;

// ../../../node_modules/@material-symbols/svg-700/outlined/help_center.svg
import * as React196 from "react";
import { jsx as jsx236 } from "react/jsx-runtime";
var SvgComponent196 = (props) => /* @__PURE__ */ jsx236("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx236("path", {
    d: "M473.39-246Q492-246 506-260.03t14-32.64q0-18.61-13.95-31.97T472.83-338q-18.11 0-31.47 13.31Q428-311.39 428-292.11 428-274 441.39-260q13.38 14 32 14ZM433-394h72q0-26 9-47.72 9-21.71 36.72-47Q576-515 589.5-540.78q13.5-25.77 13.5-57.85Q603-656 567-687q-36-31-90.52-31-56.04 0-93.76 30Q345-658 327-614l69 28q14-24 32.1-40.5T475-643q26 0 40 13.83t14 35.3q0 17.87-11 34.37-11 16.5-27 32.5-40 39-49 63t-9 70ZM189-95q-39.05 0-66.53-27.47Q95-149.95 95-189v-582q0-39.46 27.47-67.23Q149.95-866 189-866h582q39.46 0 67.23 27.77Q866-810.46 866-771v582q0 39.05-27.77 66.53Q810.46-95 771-95H189Zm0-94h582v-582H189v582Zm0-582v582-582Z"
  })
});
var help_center_default = SvgComponent196;

// ../../../node_modules/@material-symbols/svg-700/rounded/help_center-fill.svg
import * as React197 from "react";
import { jsx as jsx237 } from "react/jsx-runtime";
var SvgComponent197 = (props) => /* @__PURE__ */ jsx237("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx237("path", {
    d: "M473.5-246q18.5 0 32.5-14t14-32.5q0-18.5-13.92-32T473-338q-18 0-31.5 13.42T428-292q0 18 13.5 32t32 14ZM603-598.81q0-54.63-34.5-86.91Q534-718 476-718q-41 0-75.5 18.5T343-646q-8 12-2 26t21 20q13 5 27.5 1t25.5-16q12-15 26.58-21.5 14.58-6.5 33.39-6.5 24.68 0 39.36 13Q529-617 529-593.63q0 15.07-9.5 30.75Q510-547.19 491-527q-32 31-42.93 51-10.94 20-14.07 48-1 14.24 9.69 24.12Q454.37-394 469-394q14 0 24-9.5t15-26q5-14.5 15.5-29t27.53-30.88Q577-516 590-542.5q13-26.5 13-56.31ZM189-95q-39.05 0-66.53-27.47Q95-149.95 95-189v-582q0-39.46 27.47-67.23Q149.95-866 189-866h582q39.46 0 67.23 27.77Q866-810.46 866-771v582q0 39.05-27.77 66.53Q810.46-95 771-95H189Z"
  })
});
var help_center_fill_default2 = SvgComponent197;

// ../../../node_modules/@material-symbols/svg-700/rounded/help_center.svg
import * as React198 from "react";
import { jsx as jsx238 } from "react/jsx-runtime";
var SvgComponent198 = (props) => /* @__PURE__ */ jsx238("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx238("path", {
    d: "M473.39-246Q492-246 506-260.03t14-32.64q0-18.61-13.95-31.97T472.83-338q-18.11 0-31.47 13.31Q428-311.39 428-292.11 428-274 441.39-260q13.38 14 32 14ZM603-598.96q0-54.48-34.27-86.76Q534.45-718 476-718q-41 0-75.72 18.47Q365.55-681.06 343-646q-8 12-1.94 26.06 6.05 14.06 20.79 19.58Q375-595 389.5-599q14.5-4 25.5-16 12-15 26.68-21.5 14.69-6.5 33.29-6.5 24.68 0 39.36 13.04Q529-616.92 529-593.63q0 15.07-9.5 30.75Q510-547.19 491-527q-32 31-42.93 51-10.94 20-14.07 48-1 14.24 9.52 24.12 10.53 9.88 25.56 9.88 13.59 0 23.75-9.5Q503-413 508-429.5q5-14.5 15.5-29t27.53-30.88Q577-516 590-542.5q13-26.5 13-56.46ZM189-95q-39.05 0-66.53-27.47Q95-149.95 95-189v-582q0-39.46 27.47-67.23Q149.95-866 189-866h582q39.46 0 67.23 27.77Q866-810.46 866-771v582q0 39.05-27.77 66.53Q810.46-95 771-95H189Zm0-94h582v-582H189v582Zm0-582v582-582Z"
  })
});
var help_center_default2 = SvgComponent198;

// ../../../node_modules/@material-symbols/svg-700/sharp/help_center-fill.svg
import * as React199 from "react";
import { jsx as jsx239 } from "react/jsx-runtime";
var SvgComponent199 = (props) => /* @__PURE__ */ jsx239("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx239("path", {
    d: "M473.03-246Q492-246 506-260.03t14-32q0-18.97-14.03-32.47t-33-13.5q-17.97 0-31.47 13.53t-13.5 32.5Q428-274 441.53-260t31.5 14ZM433-394h72q0-26 9-47.5t36.72-47.22Q576-515 589.5-541t13.5-58q0-57-36-88t-90.52-31q-55.87 0-93.67 30Q345-658 327-614l69 28q14-24 32.2-40.5Q446.4-643 475-643q26 0 40 14t14 35.1q0 17.9-11 34.4T491-527q-40 39-49 63t-9 70ZM95-95v-771h771v771H95Z"
  })
});
var help_center_fill_default3 = SvgComponent199;

// ../../../node_modules/@material-symbols/svg-700/sharp/help_center.svg
import * as React200 from "react";
import { jsx as jsx240 } from "react/jsx-runtime";
var SvgComponent200 = (props) => /* @__PURE__ */ jsx240("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx240("path", {
    d: "M473.53-246Q492-246 506-260.03t14-32.5q0-18.47-13.95-31.97T472.97-338q-17.97 0-31.47 13.45T428-291.97Q428-274 441.53-260t32 14ZM433-394h72q0-26 9-47.72 9-21.71 36.72-47Q576-515 589.5-540.78q13.5-25.77 13.5-57.85Q603-656 567-687q-36-31-90.52-31-56.04 0-93.76 30Q345-658 327-614l69 28q14-24 32.1-40.5T475-643q26 0 40 13.83t14 35.3q0 17.87-11 34.37-11 16.5-27 32.5-40 39-49 63t-9 70ZM95-95v-771h771v771H95Zm94-94h582v-582H189v582Zm0 0v-582 582Z"
  })
});
var help_center_default3 = SvgComponent200;

// src/components/icon/variants/IconHelpCenter.tsx
import { useTranslation as useTranslation41 } from "react-i18next";
import { jsx as jsx241 } from "react/jsx-runtime";
var componentMap32 = {
  outlined: help_center_default,
  "outlined-fill": help_center_fill_default,
  rounded: help_center_default2,
  "rounded-fill": help_center_fill_default2,
  sharp: help_center_default3,
  "sharp-fill": help_center_fill_default3
};
var IconHelpCenter = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation41("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap32[key] ?? componentMap32[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx241(Icon, {
    SvgIcon,
    alt: t("icon.helpCenter"),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/home-fill.svg
import * as React201 from "react";
import { jsx as jsx242 } from "react/jsx-runtime";
var SvgComponent201 = (props) => /* @__PURE__ */ jsx242("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx242("path", {
    d: "M135-95v-517.67L480-872l346 259v518H566v-311H394v311H135Z"
  })
});
var home_fill_default = SvgComponent201;

// ../../../node_modules/@material-symbols/svg-700/outlined/home.svg
import * as React202 from "react";
import { jsx as jsx243 } from "react/jsx-runtime";
var SvgComponent202 = (props) => /* @__PURE__ */ jsx243("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx243("path", {
    d: "M229-189h124v-258h254v258h124v-377L480-754 229-565.67V-189Zm-94 94v-518l345-259 346 259v518H524v-269h-88v269H135Zm345-377Z"
  })
});
var home_default = SvgComponent202;

// ../../../node_modules/@material-symbols/svg-700/rounded/home-fill.svg
import * as React203 from "react";
import { jsx as jsx244 } from "react/jsx-runtime";
var SvgComponent203 = (props) => /* @__PURE__ */ jsx244("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx244("path", {
    d: "M135-189v-377q0-22.25 9.38-42 9.37-19.75 27.62-33l251-189q24.68-19 56.84-19Q512-849 537-830l251 189q18.25 13.25 28.13 33 9.87 19.75 9.87 42v377q0 39.75-27.62 66.87Q770.75-95 731-95H613q-19.75 0-33.37-13.63Q566-122.25 566-142v-217q0-19.75-13.62-33.38Q538.75-406 519-406h-78q-19.75 0-33.37 13.62Q394-378.75 394-359v217q0 19.75-13.62 33.37Q366.75-95 347-95H229q-39.75 0-66.87-27.13Q135-149.25 135-189Z"
  })
});
var home_fill_default2 = SvgComponent203;

// ../../../node_modules/@material-symbols/svg-700/rounded/home.svg
import * as React204 from "react";
import { jsx as jsx245 } from "react/jsx-runtime";
var SvgComponent204 = (props) => /* @__PURE__ */ jsx245("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx245("path", {
    d: "M229-189h124v-211q0-19.75 13.63-33.38Q380.25-447 400-447h160q19.75 0 33.38 13.62Q607-419.75 607-400v211h124v-376.67L480-754 229-565.67V-189Zm-94 0v-377q0-22.04 9.55-41.75Q154.09-627.47 172-641l251-189q24.68-19 56.84-19Q512-849 537-830l251 189q18.38 13.53 28.19 33.25Q826-588.04 826-566v377q0 39.8-27.39 66.9Q771.21-95 731-95H571q-19.75 0-33.37-13.63Q524-122.25 524-142v-222h-88v222q0 19.75-13.62 33.37Q408.75-95 389-95H229q-39.8 0-66.9-27.1Q135-149.2 135-189Zm345-283Z"
  })
});
var home_default2 = SvgComponent204;

// ../../../node_modules/@material-symbols/svg-700/sharp/home-fill.svg
import * as React205 from "react";
import { jsx as jsx246 } from "react/jsx-runtime";
var SvgComponent205 = (props) => /* @__PURE__ */ jsx246("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx246("path", {
    d: "M135-95v-517.67L480-872l346 259v518H566v-311H394v311H135Z"
  })
});
var home_fill_default3 = SvgComponent205;

// ../../../node_modules/@material-symbols/svg-700/sharp/home.svg
import * as React206 from "react";
import { jsx as jsx247 } from "react/jsx-runtime";
var SvgComponent206 = (props) => /* @__PURE__ */ jsx247("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx247("path", {
    d: "M229-189h124v-258h254v258h124v-377L480-754 229-565.67V-189Zm-94 94v-518l345-259 346 259v518H524v-269h-88v269H135Zm345-377Z"
  })
});
var home_default3 = SvgComponent206;

// src/components/icon/variants/IconHome.tsx
import { useTranslation as useTranslation42 } from "react-i18next";
import { jsx as jsx248 } from "react/jsx-runtime";
var componentMap33 = {
  outlined: home_default,
  "outlined-fill": home_fill_default,
  rounded: home_default2,
  "rounded-fill": home_fill_default2,
  sharp: home_default3,
  "sharp-fill": home_fill_default3
};
var IconHome = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation42("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap33[key] ?? componentMap33[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx248(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/image-fill.svg
import * as React207 from "react";
import { jsx as jsx249 } from "react/jsx-runtime";
var SvgComponent207 = (props) => /* @__PURE__ */ jsx249("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx249("path", {
    d: "M189-95q-39.05 0-66.53-27.47Q95-149.95 95-189v-582q0-39.46 27.47-67.23Q149.95-866 189-866h582q39.46 0 67.23 27.77Q866-810.46 866-771v582q0 39.05-27.77 66.53Q810.46-95 771-95H189Zm34-173h515L578-488 446-317l-93-127-130 176Z"
  })
});
var image_fill_default = SvgComponent207;

// ../../../node_modules/@material-symbols/svg-700/outlined/image.svg
import * as React208 from "react";
import { jsx as jsx250 } from "react/jsx-runtime";
var SvgComponent208 = (props) => /* @__PURE__ */ jsx250("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx250("path", {
    d: "M189-95q-39.05 0-66.53-27.47Q95-149.95 95-189v-582q0-39.46 27.47-67.23Q149.95-866 189-866h582q39.46 0 67.23 27.77Q866-810.46 866-771v582q0 39.05-27.77 66.53Q810.46-95 771-95H189Zm0-94h582v-582H189v582Zm34-79h515L578-488 446-317l-93-127-130 176Zm-34 79v-582 582Z"
  })
});
var image_default = SvgComponent208;

// ../../../node_modules/@material-symbols/svg-700/rounded/image-fill.svg
import * as React209 from "react";
import { jsx as jsx251 } from "react/jsx-runtime";
var SvgComponent209 = (props) => /* @__PURE__ */ jsx251("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx251("path", {
    d: "M189-95q-39.05 0-66.53-27.47Q95-149.95 95-189v-582q0-39.46 27.47-67.23Q149.95-866 189-866h582q39.46 0 67.23 27.77Q866-810.46 866-771v582q0 39.05-27.77 66.53Q810.46-95 771-95H189Zm80-173h423q15.5 0 21.25-12.63Q719-293.25 711-306L597-462q-7.31-9-19.15-9.5Q566-472 559-462L446-317l-73-101q-8.31-10-20.15-9.5Q341-427 334-418l-83 112q-9 12.75-3.25 25.37Q253.5-268 269-268Z"
  })
});
var image_fill_default2 = SvgComponent209;

// ../../../node_modules/@material-symbols/svg-700/rounded/image.svg
import * as React210 from "react";
import { jsx as jsx252 } from "react/jsx-runtime";
var SvgComponent210 = (props) => /* @__PURE__ */ jsx252("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx252("path", {
    d: "M189-95q-39.05 0-66.53-27.47Q95-149.95 95-189v-582q0-39.46 27.47-67.23Q149.95-866 189-866h582q39.46 0 67.23 27.77Q866-810.46 866-771v582q0 39.05-27.77 66.53Q810.46-95 771-95H189Zm0-94h582v-582H189v582Zm0 0v-582 582Zm80-79h423q15 0 21-12.63 6-12.62-2-25.37L597-462q-7.31-9-19.15-9.5Q566-472 559-462L446-317l-73-101q-8.31-10-20.15-9.5Q341-427 334-418l-83 112q-9 12.75-3 25.37Q254-268 269-268Z"
  })
});
var image_default2 = SvgComponent210;

// ../../../node_modules/@material-symbols/svg-700/sharp/image-fill.svg
import * as React211 from "react";
import { jsx as jsx253 } from "react/jsx-runtime";
var SvgComponent211 = (props) => /* @__PURE__ */ jsx253("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx253("path", {
    d: "M223-268h515L578-488 446-317l-93-127-130 176ZM95-95v-771h771v771H95Z"
  })
});
var image_fill_default3 = SvgComponent211;

// ../../../node_modules/@material-symbols/svg-700/sharp/image.svg
import * as React212 from "react";
import { jsx as jsx254 } from "react/jsx-runtime";
var SvgComponent212 = (props) => /* @__PURE__ */ jsx254("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx254("path", {
    d: "M223-268h515L578-488 446-317l-93-127-130 176ZM95-95v-771h771v771H95Zm94-94h582v-582H189v582Zm0 0v-582 582Z"
  })
});
var image_default3 = SvgComponent212;

// src/components/icon/variants/IconImage.tsx
import { useTranslation as useTranslation43 } from "react-i18next";
import { jsx as jsx255 } from "react/jsx-runtime";
var componentMap34 = {
  outlined: image_default,
  "outlined-fill": image_fill_default,
  rounded: image_default2,
  "rounded-fill": image_fill_default2,
  sharp: image_default3,
  "sharp-fill": image_fill_default3
};
var IconImage = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation43("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap34[key] ?? componentMap34[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx255(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/info-fill.svg
import * as React213 from "react";
import { jsx as jsx256 } from "react/jsx-runtime";
var SvgComponent213 = (props) => /* @__PURE__ */ jsx256("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx256("path", {
    d: "M442-269h82v-251h-82v251Zm38.07-310q20.43 0 34.18-13.51Q528-606.03 528-626q0-21.95-13.79-35.47Q500.41-675 480.02-675q-21.52 0-34.77 13.53Q432-647.95 432-626.5q0 20.6 13.82 34.05Q459.64-579 480.07-579Zm.33 524q-88.87 0-166.12-33.08-77.25-33.09-135.18-91.02-57.93-57.93-91.02-135.12Q55-391.41 55-480.36q0-88.96 33.08-166.29 33.09-77.32 90.86-134.81 57.77-57.48 135.03-91.01Q391.24-906 480.28-906t166.49 33.45q77.44 33.46 134.85 90.81t90.89 134.87Q906-569.34 906-480.27q0 89.01-33.53 166.25t-91.01 134.86q-57.49 57.62-134.83 90.89Q569.28-55 480.4-55Z"
  })
});
var info_fill_default = SvgComponent213;

// ../../../node_modules/@material-symbols/svg-700/outlined/info.svg
import * as React214 from "react";
import { jsx as jsx257 } from "react/jsx-runtime";
var SvgComponent214 = (props) => /* @__PURE__ */ jsx257("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx257("path", {
    d: "M442-269h82v-251h-82v251Zm38.07-310q20.43 0 34.18-13.51Q528-606.03 528-626q0-21.95-13.79-35.47Q500.41-675 480.02-675q-21.52 0-34.77 13.53Q432-647.95 432-626.5q0 20.6 13.82 34.05Q459.64-579 480.07-579Zm.33 524q-88.87 0-166.12-33.08-77.25-33.09-135.18-91.02-57.93-57.93-91.02-135.12Q55-391.41 55-480.36q0-88.96 33.08-166.29 33.09-77.32 90.86-134.81 57.77-57.48 135.03-91.01Q391.24-906 480.28-906t166.49 33.45q77.44 33.46 134.85 90.81t90.89 134.87Q906-569.34 906-480.27q0 89.01-33.53 166.25t-91.01 134.86q-57.49 57.62-134.83 90.89Q569.28-55 480.4-55Zm.1-94q137.5 0 234-96.37T811-480.5q0-137.5-96.31-234T479.5-811q-137.5 0-234 96.31T149-479.5q0 137.5 96.37 234T480.5-149Zm-.5-331Z"
  })
});
var info_default = SvgComponent214;

// ../../../node_modules/@material-symbols/svg-700/rounded/info-fill.svg
import * as React215 from "react";
import { jsx as jsx258 } from "react/jsx-runtime";
var SvgComponent215 = (props) => /* @__PURE__ */ jsx258("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx258("path", {
    d: "M482.96-269q17.42 0 29.23-11.79Q524-292.58 524-310v-169q0-17.42-11.78-29.21Q500.45-520 483.04-520t-29.23 11.79Q442-496.42 442-479v169q0 17.42 11.78 29.21Q465.55-269 482.96-269Zm-2.89-310q20.43 0 34.18-13.51Q528-606.03 528-626q0-21.95-13.79-35.47Q500.41-675 480.02-675q-21.52 0-34.77 13.53Q432-647.95 432-626.5q0 20.6 13.82 34.05Q459.64-579 480.07-579Zm.33 524q-88.87 0-166.12-33.08-77.25-33.09-135.18-91.02-57.93-57.93-91.02-135.12Q55-391.41 55-480.36q0-88.96 33.08-166.29 33.09-77.32 90.86-134.81 57.77-57.48 135.03-91.01Q391.24-906 480.28-906t166.49 33.45q77.44 33.46 134.85 90.81t90.89 134.87Q906-569.34 906-480.27q0 89.01-33.53 166.25t-91.01 134.86q-57.49 57.62-134.83 90.89Q569.28-55 480.4-55Z"
  })
});
var info_fill_default2 = SvgComponent215;

// ../../../node_modules/@material-symbols/svg-700/rounded/info.svg
import * as React216 from "react";
import { jsx as jsx259 } from "react/jsx-runtime";
var SvgComponent216 = (props) => /* @__PURE__ */ jsx259("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx259("path", {
    d: "M482.96-269q17.42 0 29.23-11.79Q524-292.58 524-310v-169q0-17.42-11.78-29.21Q500.45-520 483.04-520t-29.23 11.79Q442-496.42 442-479v169q0 17.42 11.78 29.21Q465.55-269 482.96-269Zm-2.89-310q20.43 0 34.18-13.51Q528-606.03 528-626q0-21.95-13.79-35.47Q500.41-675 480.02-675q-21.52 0-34.77 13.53Q432-647.95 432-626.5q0 20.6 13.82 34.05Q459.64-579 480.07-579Zm.33 524q-88.87 0-166.12-33.08-77.25-33.09-135.18-91.02-57.93-57.93-91.02-135.12Q55-391.41 55-480.36q0-88.96 33.08-166.29 33.09-77.32 90.86-134.81 57.77-57.48 135.03-91.01Q391.24-906 480.28-906t166.49 33.45q77.44 33.46 134.85 90.81t90.89 134.87Q906-569.34 906-480.27q0 89.01-33.53 166.25t-91.01 134.86q-57.49 57.62-134.83 90.89Q569.28-55 480.4-55Zm.1-94q137.5 0 234-96.37T811-480.5q0-137.5-96.31-234T479.5-811q-137.5 0-234 96.31T149-479.5q0 137.5 96.37 234T480.5-149Zm-.5-331Z"
  })
});
var info_default2 = SvgComponent216;

// ../../../node_modules/@material-symbols/svg-700/sharp/info-fill.svg
import * as React217 from "react";
import { jsx as jsx260 } from "react/jsx-runtime";
var SvgComponent217 = (props) => /* @__PURE__ */ jsx260("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx260("path", {
    d: "M442-269h82v-251h-82v251Zm38.07-310q20.43 0 34.18-13.51Q528-606.03 528-626q0-21.95-13.79-35.47Q500.41-675 480.02-675q-21.52 0-34.77 13.53Q432-647.95 432-626.5q0 20.6 13.82 34.05Q459.64-579 480.07-579Zm.33 524q-88.87 0-166.12-33.08-77.25-33.09-135.18-91.02-57.93-57.93-91.02-135.12Q55-391.41 55-480.36q0-88.96 33.08-166.29 33.09-77.32 90.86-134.81 57.77-57.48 135.03-91.01Q391.24-906 480.28-906t166.49 33.45q77.44 33.46 134.85 90.81t90.89 134.87Q906-569.34 906-480.27q0 89.01-33.53 166.25t-91.01 134.86q-57.49 57.62-134.83 90.89Q569.28-55 480.4-55Z"
  })
});
var info_fill_default3 = SvgComponent217;

// ../../../node_modules/@material-symbols/svg-700/sharp/info.svg
import * as React218 from "react";
import { jsx as jsx261 } from "react/jsx-runtime";
var SvgComponent218 = (props) => /* @__PURE__ */ jsx261("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx261("path", {
    d: "M442-269h82v-251h-82v251Zm38.07-310q20.43 0 34.18-13.51Q528-606.03 528-626q0-21.95-13.79-35.47Q500.41-675 480.02-675q-21.52 0-34.77 13.53Q432-647.95 432-626.5q0 20.6 13.82 34.05Q459.64-579 480.07-579Zm.33 524q-88.87 0-166.12-33.08-77.25-33.09-135.18-91.02-57.93-57.93-91.02-135.12Q55-391.41 55-480.36q0-88.96 33.08-166.29 33.09-77.32 90.86-134.81 57.77-57.48 135.03-91.01Q391.24-906 480.28-906t166.49 33.45q77.44 33.46 134.85 90.81t90.89 134.87Q906-569.34 906-480.27q0 89.01-33.53 166.25t-91.01 134.86q-57.49 57.62-134.83 90.89Q569.28-55 480.4-55Zm.1-94q137.5 0 234-96.37T811-480.5q0-137.5-96.31-234T479.5-811q-137.5 0-234 96.31T149-479.5q0 137.5 96.37 234T480.5-149Zm-.5-331Z"
  })
});
var info_default3 = SvgComponent218;

// src/components/icon/variants/IconInfo.tsx
import { useTranslation as useTranslation44 } from "react-i18next";
import { jsx as jsx262 } from "react/jsx-runtime";
var componentMap35 = {
  outlined: info_default,
  "outlined-fill": info_fill_default,
  rounded: info_default2,
  "rounded-fill": info_fill_default2,
  sharp: info_default3,
  "sharp-fill": info_fill_default3
};
var IconInfo = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation44("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap35[key] ?? componentMap35[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx262(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/ios_share-fill.svg
import * as React219 from "react";
import { jsx as jsx263 } from "react/jsx-runtime";
var SvgComponent219 = (props) => /* @__PURE__ */ jsx263("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx263("path", {
    d: "M229-10q-39.05 0-66.52-27.77Q135-65.54 135-105v-458q0-38 27.48-66 27.47-28 66.52-28h143v94H229v458h502v-458H586v-94h145q39.46 0 67.23 28Q826-601 826-563v458q0 39.46-27.77 67.23Q770.46-10 731-10H229Zm203-311v-448l-88 88-67-66 202-203 202 203-67 66-88-88v448h-94Z"
  })
});
var ios_share_fill_default = SvgComponent219;

// ../../../node_modules/@material-symbols/svg-700/outlined/ios_share.svg
import * as React220 from "react";
import { jsx as jsx264 } from "react/jsx-runtime";
var SvgComponent220 = (props) => /* @__PURE__ */ jsx264("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx264("path", {
    d: "M229-10q-39.05 0-66.52-27.77Q135-65.54 135-105v-458q0-38 27.48-66 27.47-28 66.52-28h143v94H229v458h502v-458H586v-94h145q39.46 0 67.23 28Q826-601 826-563v458q0 39.46-27.77 67.23Q770.46-10 731-10H229Zm203-311v-448l-88 88-67-66 202-203 202 203-67 66-88-88v448h-94Z"
  })
});
var ios_share_default = SvgComponent220;

// ../../../node_modules/@material-symbols/svg-700/rounded/ios_share-fill.svg
import * as React221 from "react";
import { jsx as jsx265 } from "react/jsx-runtime";
var SvgComponent221 = (props) => /* @__PURE__ */ jsx265("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx265("path", {
    d: "M229-10q-39.05 0-66.52-27.77Q135-65.54 135-105v-458q0-38 27.48-66 27.47-28 66.52-28h96q19.75 0 33.38 13.68Q372-629.65 372-609.82q0 19.82-13.62 33.32Q344.75-563 325-563h-96v458h502v-458h-97q-20.75 0-34.37-13.68Q586-590.35 586-610.18q0-19.82 13.63-33.32Q613.25-657 634-657h97q39.46 0 67.23 28Q826-601 826-563v458q0 39.46-27.77 67.23Q770.46-10 731-10H229Zm203-759-55 55q-14 14-33.38 14.54-19.38.54-32.81-13.5Q297-727 297-746.5t14.28-33.78L445-916q14.36-14 34.18-14T513-916l135 136q14 14.25 14 33.28 0 19.04-13.84 32.88Q634.7-700 615.38-700q-19.31 0-33.38-14l-56-55v401q0 19.75-13.68 33.37Q498.65-321 478.82-321q-19.82 0-33.32-13.63Q432-348.25 432-368v-401Z"
  })
});
var ios_share_fill_default2 = SvgComponent221;

// ../../../node_modules/@material-symbols/svg-700/rounded/ios_share.svg
import * as React222 from "react";
import { jsx as jsx266 } from "react/jsx-runtime";
var SvgComponent222 = (props) => /* @__PURE__ */ jsx266("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx266("path", {
    d: "M229-10q-39.05 0-66.52-27.77Q135-65.54 135-105v-458q0-38 27.48-66 27.47-28 66.52-28h96q19.75 0 33.38 13.68Q372-629.65 372-609.82q0 19.82-13.62 33.32Q344.75-563 325-563h-96v458h502v-458h-97q-20.75 0-34.37-13.68Q586-590.35 586-610.18q0-19.82 13.63-33.32Q613.25-657 634-657h97q39.46 0 67.23 28Q826-601 826-563v458q0 39.46-27.77 67.23Q770.46-10 731-10H229Zm203-759-55 55q-14 14-33.38 14.54-19.38.54-32.81-13.5Q297-727 297-746.5t14.28-33.78L445-916q14.36-14 34.18-14T513-916l135 136q14 14.25 14 33.28 0 19.04-13.84 32.88Q634.7-700 615.38-700q-19.31 0-33.38-14l-56-55v401q0 19.75-13.68 33.37Q498.65-321 478.82-321q-19.82 0-33.32-13.63Q432-348.25 432-368v-401Z"
  })
});
var ios_share_default2 = SvgComponent222;

// ../../../node_modules/@material-symbols/svg-700/sharp/ios_share-fill.svg
import * as React223 from "react";
import { jsx as jsx267 } from "react/jsx-runtime";
var SvgComponent223 = (props) => /* @__PURE__ */ jsx267("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx267("path", {
    d: "M135-10v-647h237v94H229v458h502v-458H586v-94h240v647H135Zm297-311v-448l-88 88-67-66 202-203 202 203-67 66-88-88v448h-94Z"
  })
});
var ios_share_fill_default3 = SvgComponent223;

// ../../../node_modules/@material-symbols/svg-700/sharp/ios_share.svg
import * as React224 from "react";
import { jsx as jsx268 } from "react/jsx-runtime";
var SvgComponent224 = (props) => /* @__PURE__ */ jsx268("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx268("path", {
    d: "M135-10v-647h237v94H229v458h502v-458H586v-94h240v647H135Zm297-311v-448l-88 88-67-66 202-203 202 203-67 66-88-88v448h-94Z"
  })
});
var ios_share_default3 = SvgComponent224;

// src/components/icon/variants/IconIosShare.tsx
import { useTranslation as useTranslation45 } from "react-i18next";
import { jsx as jsx269 } from "react/jsx-runtime";
var componentMap36 = {
  outlined: ios_share_default,
  "outlined-fill": ios_share_fill_default,
  rounded: ios_share_default2,
  "rounded-fill": ios_share_fill_default2,
  sharp: ios_share_default3,
  "sharp-fill": ios_share_fill_default3
};
var IconIosShare = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation45("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap36[key] ?? componentMap36[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx269(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/keep-fill.svg
import * as React225 from "react";
import { jsx as jsx270 } from "react/jsx-runtime";
var SvgComponent225 = (props) => /* @__PURE__ */ jsx270("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx270("path", {
    d: "m660-474 86 77v95H527v238l-47 47-47-47v-238H215v-95l80-77v-314h-50v-94h465v94h-50v314Z"
  })
});
var keep_fill_default = SvgComponent225;

// ../../../node_modules/@material-symbols/svg-700/outlined/keep.svg
import * as React226 from "react";
import { jsx as jsx271 } from "react/jsx-runtime";
var SvgComponent226 = (props) => /* @__PURE__ */ jsx271("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx271("path", {
    d: "m660-474 86 77v95H527v238l-47 47-47-47v-238H215v-95l80-77v-313h-50v-94h465v94h-50v313Zm-317 77h268l-46-42v-348H389v348l-46 42Zm134 0Z"
  })
});
var keep_default = SvgComponent226;

// ../../../node_modules/@material-symbols/svg-700/rounded/keep-fill.svg
import * as React227 from "react";
import { jsx as jsx272 } from "react/jsx-runtime";
var SvgComponent227 = (props) => /* @__PURE__ */ jsx272("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx272("path", {
    d: "M660-790v316l72 63q7 7 10.5 15.6 3.5 8.59 3.5 17.56v29.16q0 19.68-14.12 33.18Q717.75-302 698-302H527v230q0 19.75-13.68 33.37Q499.65-25 479.82-25 460-25 446.5-38.63 433-52.25 433-72v-230H262q-19.75 0-33.37-13.58Q215-329.17 215-348.86v-29.17q0-8.97 3-17.47 3-8.5 10-15.5l67-63v-316h-20q-13.75-5-21.87-16.68-8.13-11.67-8.13-27.5 0-19.82 13.63-33.32Q272.25-881 292-881h370q19.75 0 33.88 13.68Q710-853.65 710-833.82q0 15.82-8.62 27.32Q692.75-795 680-790h-20Z"
  })
});
var keep_fill_default2 = SvgComponent227;

// ../../../node_modules/@material-symbols/svg-700/rounded/keep.svg
import * as React228 from "react";
import { jsx as jsx273 } from "react/jsx-runtime";
var SvgComponent228 = (props) => /* @__PURE__ */ jsx273("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx273("path", {
    d: "M660-790v316l72 63q7 7 10.5 15.6 3.5 8.59 3.5 17.56v29.16q0 19.68-14.12 33.18Q717.75-302 698-302H527v230q0 19.75-13.68 33.37Q499.65-25 479.82-25 460-25 446.5-38.63 433-52.25 433-72v-230H262q-19.75 0-33.37-13.58Q215-329.17 215-348.86v-29.17q0-8.97 3-17.47 3-8.5 10-15.5l67-63v-316h-20q-13.75-5-21.87-16.68-8.13-11.67-8.13-27.5 0-19.82 13.63-33.32Q272.25-881 292-881h370q19.75 0 33.88 13.68Q710-853.65 710-833.82q0 15.82-8.62 27.32Q692.75-795 680-790h-20ZM343-397h268l-46-42v-348H389v348l-46 42Zm134 0Z"
  })
});
var keep_default2 = SvgComponent228;

// ../../../node_modules/@material-symbols/svg-700/sharp/keep-fill.svg
import * as React229 from "react";
import { jsx as jsx274 } from "react/jsx-runtime";
var SvgComponent229 = (props) => /* @__PURE__ */ jsx274("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx274("path", {
    d: "m660-474 86 77v95H527v238l-47 47-47-47v-238H215v-95l80-77v-314h-50v-94h465v94h-50v314Z"
  })
});
var keep_fill_default3 = SvgComponent229;

// ../../../node_modules/@material-symbols/svg-700/sharp/keep.svg
import * as React230 from "react";
import { jsx as jsx275 } from "react/jsx-runtime";
var SvgComponent230 = (props) => /* @__PURE__ */ jsx275("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx275("path", {
    d: "m660-474 86 77v95H527v238l-47 47-47-47v-238H215v-95l80-77v-313h-50v-94h465v94h-50v313Zm-317 77h268l-46-42v-348H389v348l-46 42Zm134 0Z"
  })
});
var keep_default3 = SvgComponent230;

// src/components/icon/variants/IconKeep.tsx
import { useTranslation as useTranslation46 } from "react-i18next";
import { jsx as jsx276 } from "react/jsx-runtime";
var componentMap37 = {
  outlined: keep_default,
  "outlined-fill": keep_fill_default,
  rounded: keep_default2,
  "rounded-fill": keep_fill_default2,
  sharp: keep_default3,
  "sharp-fill": keep_fill_default3
};
var IconKeep = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation46("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap37[key] ?? componentMap37[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx276(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/keyboard_arrow_down-fill.svg
import * as React231 from "react";
import { jsx as jsx277 } from "react/jsx-runtime";
var SvgComponent231 = (props) => /* @__PURE__ */ jsx277("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx277("path", {
    d: "M480-320 216-584l67-67 197 197 197-197 67 67-264 264Z"
  })
});
var keyboard_arrow_down_fill_default = SvgComponent231;

// ../../../node_modules/@material-symbols/svg-700/outlined/keyboard_arrow_down.svg
import * as React232 from "react";
import { jsx as jsx278 } from "react/jsx-runtime";
var SvgComponent232 = (props) => /* @__PURE__ */ jsx278("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx278("path", {
    d: "M480-320 216-584l67-67 197 197 197-197 67 67-264 264Z"
  })
});
var keyboard_arrow_down_default = SvgComponent232;

// ../../../node_modules/@material-symbols/svg-700/rounded/keyboard_arrow_down-fill.svg
import * as React233 from "react";
import { jsx as jsx279 } from "react/jsx-runtime";
var SvgComponent233 = (props) => /* @__PURE__ */ jsx279("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx279("path", {
    d: "M480-339q-9 0-18-4t-16-11L249-551q-14-14-13.5-33.5T250-618q14-14 33.5-14t33.5 14l163 164 164-164q14-14 33-13.5t33 14.5q14 14 14 33.5T710-550L514-354q-7 7-16 11t-18 4Z"
  })
});
var keyboard_arrow_down_fill_default2 = SvgComponent233;

// ../../../node_modules/@material-symbols/svg-700/rounded/keyboard_arrow_down.svg
import * as React234 from "react";
import { jsx as jsx280 } from "react/jsx-runtime";
var SvgComponent234 = (props) => /* @__PURE__ */ jsx280("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx280("path", {
    d: "M480-339q-9 0-18-4t-16-11L249-551q-14-14-13.5-33.5T250-618q14-14 33.5-14t33.5 14l163 164 164-164q14-14 33-13.5t33 14.5q14 14 14 33.5T710-550L514-354q-7 7-16 11t-18 4Z"
  })
});
var keyboard_arrow_down_default2 = SvgComponent234;

// ../../../node_modules/@material-symbols/svg-700/sharp/keyboard_arrow_down-fill.svg
import * as React235 from "react";
import { jsx as jsx281 } from "react/jsx-runtime";
var SvgComponent235 = (props) => /* @__PURE__ */ jsx281("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx281("path", {
    d: "M480-320 216-584l67-67 197 197 197-197 67 67-264 264Z"
  })
});
var keyboard_arrow_down_fill_default3 = SvgComponent235;

// ../../../node_modules/@material-symbols/svg-700/sharp/keyboard_arrow_down.svg
import * as React236 from "react";
import { jsx as jsx282 } from "react/jsx-runtime";
var SvgComponent236 = (props) => /* @__PURE__ */ jsx282("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx282("path", {
    d: "M480-320 216-584l67-67 197 197 197-197 67 67-264 264Z"
  })
});
var keyboard_arrow_down_default3 = SvgComponent236;

// src/components/icon/variants/IconKeyboardArrowDown.tsx
import { useTranslation as useTranslation47 } from "react-i18next";
import { jsx as jsx283 } from "react/jsx-runtime";
var componentMap38 = {
  outlined: keyboard_arrow_down_default,
  "outlined-fill": keyboard_arrow_down_fill_default,
  rounded: keyboard_arrow_down_default2,
  "rounded-fill": keyboard_arrow_down_fill_default2,
  sharp: keyboard_arrow_down_default3,
  "sharp-fill": keyboard_arrow_down_fill_default3
};
var IconKeyboardArrowDown = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation47("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap38[key] ?? componentMap38[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx283(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/link-fill.svg
import * as React237 from "react";
import { jsx as jsx284 } from "react/jsx-runtime";
var SvgComponent237 = (props) => /* @__PURE__ */ jsx284("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx284("path", {
    d: "M439-255H280q-94.11 0-159.56-65.42Q55-385.84 55-479.7q0-93.85 65.44-160.07Q185.89-706 280-706h159v95H280.43q-55.51 0-93.47 37.76-37.96 37.77-37.96 93Q149-425 186.96-387q37.96 38 93.47 38H439v94ZM308-444v-72h344v72H308Zm213 189v-94h158.57q55.51 0 93.47-37.76 37.96-37.77 37.96-93Q811-535 773.04-573q-37.96-38-93.47-38H521v-95h159q93.79 0 159.9 66.15 66.1 66.15 66.1 160T839.9-320.5Q773.79-255 680-255H521Z"
  })
});
var link_fill_default = SvgComponent237;

// ../../../node_modules/@material-symbols/svg-700/outlined/link.svg
import * as React238 from "react";
import { jsx as jsx285 } from "react/jsx-runtime";
var SvgComponent238 = (props) => /* @__PURE__ */ jsx285("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx285("path", {
    d: "M439-255H280q-94.11 0-159.56-65.42Q55-385.84 55-479.7q0-93.85 65.44-160.07Q185.89-706 280-706h159v95H280.43q-55.51 0-93.47 37.76-37.96 37.77-37.96 93Q149-425 186.96-387q37.96 38 93.47 38H439v94ZM308-444v-72h344v72H308Zm213 189v-94h158.57q55.51 0 93.47-37.76 37.96-37.77 37.96-93Q811-535 773.04-573q-37.96-38-93.47-38H521v-95h159q93.79 0 159.9 66.15 66.1 66.15 66.1 160T839.9-320.5Q773.79-255 680-255H521Z"
  })
});
var link_default = SvgComponent238;

// ../../../node_modules/@material-symbols/svg-700/rounded/link-fill.svg
import * as React239 from "react";
import { jsx as jsx286 } from "react/jsx-runtime";
var SvgComponent239 = (props) => /* @__PURE__ */ jsx286("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx286("path", {
    d: "M280-255q-94.11 0-159.56-65.42Q55-385.84 55-479.92T120.44-640q65.45-66 159.56-66h112q19.75 0 33.38 14.18 13.62 14.17 13.62 34 0 19.82-13.62 33.32Q411.75-611 392-611H280q-55.33 0-93.17 37.76-37.83 37.77-37.83 93Q149-425 186.83-387q37.84 38 93.17 38h112q19.75 0 33.38 13.68Q439-321.65 439-301.82q0 19.82-13.62 33.32Q411.75-255 392-255H280Zm64-189q-15.15 0-25.58-9.98-10.42-9.97-10.42-26.2 0-16.22 9.92-26.02 9.93-9.8 26.08-9.8h272q15.15 0 25.58 9.98 10.42 9.97 10.42 26.2 0 16.22-9.92 26.02-9.93 9.8-26.08 9.8H344Zm225 189q-20.75 0-34.37-13.68Q521-282.35 521-302.18q0-19.82 13.63-33.32Q548.25-349 569-349h111q55.33 0 93.17-37.76 37.83-37.77 37.83-93Q811-535 773.17-573q-37.84-38-93.17-38H569q-20.75 0-34.37-13.68Q521-638.35 521-658.18 521-678 534.63-692q13.62-14 34.37-14h111q94.11 0 160.05 65.92 65.95 65.92 65.95 160T840.05-320.5Q774.11-255 680-255H569Z"
  })
});
var link_fill_default2 = SvgComponent239;

// ../../../node_modules/@material-symbols/svg-700/rounded/link.svg
import * as React240 from "react";
import { jsx as jsx287 } from "react/jsx-runtime";
var SvgComponent240 = (props) => /* @__PURE__ */ jsx287("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx287("path", {
    d: "M280-255q-94.11 0-159.56-65.42Q55-385.84 55-479.92T120.44-640q65.45-66 159.56-66h112q19.75 0 33.38 14.18 13.62 14.17 13.62 34 0 19.82-13.62 33.32Q411.75-611 392-611H280q-55.33 0-93.17 37.76-37.83 37.77-37.83 93Q149-425 186.83-387q37.84 38 93.17 38h112q19.75 0 33.38 13.68Q439-321.65 439-301.82q0 19.82-13.62 33.32Q411.75-255 392-255H280Zm64-189q-15.15 0-25.58-9.98-10.42-9.97-10.42-26.2 0-16.22 9.92-26.02 9.93-9.8 26.08-9.8h272q15.15 0 25.58 9.98 10.42 9.97 10.42 26.2 0 16.22-9.92 26.02-9.93 9.8-26.08 9.8H344Zm225 189q-20.75 0-34.37-13.68Q521-282.35 521-302.18q0-19.82 13.63-33.32Q548.25-349 569-349h111q55.33 0 93.17-37.76 37.83-37.77 37.83-93Q811-535 773.17-573q-37.84-38-93.17-38H569q-20.75 0-34.37-13.68Q521-638.35 521-658.18 521-678 534.63-692q13.62-14 34.37-14h111q94.11 0 160.05 65.92 65.95 65.92 65.95 160T840.05-320.5Q774.11-255 680-255H569Z"
  })
});
var link_default2 = SvgComponent240;

// ../../../node_modules/@material-symbols/svg-700/sharp/link-fill.svg
import * as React241 from "react";
import { jsx as jsx288 } from "react/jsx-runtime";
var SvgComponent241 = (props) => /* @__PURE__ */ jsx288("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx288("path", {
    d: "M439-255H280q-94.11 0-159.56-65.42Q55-385.84 55-479.7q0-93.85 65.44-160.07Q185.89-706 280-706h159v95H280.43q-55.51 0-93.47 37.76-37.96 37.77-37.96 93Q149-425 186.96-387q37.96 38 93.47 38H439v94ZM308-444v-72h344v72H308Zm213 189v-94h158.57q55.51 0 93.47-37.76 37.96-37.77 37.96-93Q811-535 773.04-573q-37.96-38-93.47-38H521v-95h159q93.79 0 159.9 66.15 66.1 66.15 66.1 160T839.9-320.5Q773.79-255 680-255H521Z"
  })
});
var link_fill_default3 = SvgComponent241;

// ../../../node_modules/@material-symbols/svg-700/sharp/link.svg
import * as React242 from "react";
import { jsx as jsx289 } from "react/jsx-runtime";
var SvgComponent242 = (props) => /* @__PURE__ */ jsx289("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx289("path", {
    d: "M439-255H280q-94.11 0-159.56-65.42Q55-385.84 55-479.7q0-93.85 65.44-160.07Q185.89-706 280-706h159v95H280.43q-55.51 0-93.47 37.76-37.96 37.77-37.96 93Q149-425 186.96-387q37.96 38 93.47 38H439v94ZM308-444v-72h344v72H308Zm213 189v-94h158.57q55.51 0 93.47-37.76 37.96-37.77 37.96-93Q811-535 773.04-573q-37.96-38-93.47-38H521v-95h159q93.79 0 159.9 66.15 66.1 66.15 66.1 160T839.9-320.5Q773.79-255 680-255H521Z"
  })
});
var link_default3 = SvgComponent242;

// src/components/icon/variants/IconLink.tsx
import { useTranslation as useTranslation48 } from "react-i18next";
import { jsx as jsx290 } from "react/jsx-runtime";
var componentMap39 = {
  outlined: link_default,
  "outlined-fill": link_fill_default,
  rounded: link_default2,
  "rounded-fill": link_fill_default2,
  sharp: link_default3,
  "sharp-fill": link_fill_default3
};
var IconLink = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation48("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap39[key] ?? componentMap39[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx290(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/local_pharmacy-fill.svg
import * as React243 from "react";
import { jsx as jsx291 } from "react/jsx-runtime";
var SvgComponent243 = (props) => /* @__PURE__ */ jsx291("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx291("path", {
    d: "M87-74v-90l86-250-86-251v-90h547l65-188 111 43-50 145h113v90l-86 251 86 250v90H87Zm359-185h72v-120h120v-71H518v-120h-72v120H327v71h119v120Z"
  })
});
var local_pharmacy_fill_default = SvgComponent243;

// ../../../node_modules/@material-symbols/svg-700/outlined/local_pharmacy.svg
import * as React244 from "react";
import { jsx as jsx292 } from "react/jsx-runtime";
var SvgComponent244 = (props) => /* @__PURE__ */ jsx292("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx292("path", {
    d: "M87-74v-90l86-250-86-251v-90h547l65-188 111 43-50 145h113v90l-86 251 86 250v90H87Zm359-185h72v-120h120v-71H518v-120h-72v120H327v71h119v120Zm-259 90h587l-86-245 86-246H187l85.43 246L187-169Zm293-245Z"
  })
});
var local_pharmacy_default = SvgComponent244;

// ../../../node_modules/@material-symbols/svg-700/rounded/local_pharmacy-fill.svg
import * as React245 from "react";
import { jsx as jsx293 } from "react/jsx-runtime";
var SvgComponent245 = (props) => /* @__PURE__ */ jsx293("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx293("path", {
    d: "M188-74q-48.01 0-76.01-39.5Q84-153 99-199l74-215-74-216q-15-46 12.99-85.5 28-39.5 76.01-39.5h446l45-129q8-24 31-35t46.5-1.5q22.5 8.5 32.5 30t2 44.5l-31 91h35q40.11 0 62.56 33.5Q880-688 868-651l-81 237 74 214q15 46-12.99 86-28 40-76.01 40H188Zm258-185h72v-120h120v-71H518v-120h-72v120H327v71h119v120Zm-259 90h587l-86-245 86-246H187l85.43 246L187-169Zm12-2 82-244-82-244h563l-82 244 82 244H199Z"
  })
});
var local_pharmacy_fill_default2 = SvgComponent245;

// ../../../node_modules/@material-symbols/svg-700/rounded/local_pharmacy.svg
import * as React246 from "react";
import { jsx as jsx294 } from "react/jsx-runtime";
var SvgComponent246 = (props) => /* @__PURE__ */ jsx294("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx294("path", {
    d: "M188-74q-48.01 0-76.01-39.5Q84-153 99-199l74-215-74-216q-15-46 12.99-85.5 28-39.5 76.01-39.5h446l45-129q8-24 31-35t46.5-1.5q22.5 8.5 32.5 30t2 44.5l-31 91h35q40.11 0 62.56 33.5Q880-688 868-651l-81 237 74 214q15 46-12.99 86-28 40-76.01 40H188Zm258-185h72v-120h120v-71H518v-120h-72v120H327v71h119v120Zm-259 90h587l-86-245 86-246H187l85.43 246L187-169Zm293-246Z"
  })
});
var local_pharmacy_default2 = SvgComponent246;

// ../../../node_modules/@material-symbols/svg-700/sharp/local_pharmacy-fill.svg
import * as React247 from "react";
import { jsx as jsx295 } from "react/jsx-runtime";
var SvgComponent247 = (props) => /* @__PURE__ */ jsx295("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx295("path", {
    d: "M87-74v-90l86-250-86-251v-90h547l65-188 111 43-50 145h113v90l-86 251 86 250v90H87Zm359-185h72v-120h120v-71H518v-120h-72v120H327v71h119v120Z"
  })
});
var local_pharmacy_fill_default3 = SvgComponent247;

// ../../../node_modules/@material-symbols/svg-700/sharp/local_pharmacy.svg
import * as React248 from "react";
import { jsx as jsx296 } from "react/jsx-runtime";
var SvgComponent248 = (props) => /* @__PURE__ */ jsx296("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx296("path", {
    d: "M87-74v-90l86-250-86-251v-90h547l65-188 111 43-50 145h113v90l-86 251 86 250v90H87Zm359-185h72v-120h120v-71H518v-120h-72v120H327v71h119v120Zm-259 90h587l-86-245 86-246H187l85.43 246L187-169Zm293-245Z"
  })
});
var local_pharmacy_default3 = SvgComponent248;

// src/components/icon/variants/IconLocalPharmacy.tsx
import { useTranslation as useTranslation49 } from "react-i18next";
import { jsx as jsx297 } from "react/jsx-runtime";
var componentMap40 = {
  outlined: local_pharmacy_default,
  "outlined-fill": local_pharmacy_fill_default,
  rounded: local_pharmacy_default2,
  "rounded-fill": local_pharmacy_fill_default2,
  sharp: local_pharmacy_default3,
  "sharp-fill": local_pharmacy_fill_default3
};
var IconLocalPharmacy = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation49("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap40[key] ?? componentMap40[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx297(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/local_shipping-fill.svg
import * as React249 from "react";
import { jsx as jsx298 } from "react/jsx-runtime";
var SvgComponent249 = (props) => /* @__PURE__ */ jsx298("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx298("path", {
    d: "M230.12-138q-51.12 0-88.62-33.42Q104-204.83 102-256H17v-473q0-39.05 27.47-66.53Q71.95-823 111-823h579v155h98l155 207.56V-256h-83q-3 51.17-40.38 84.58Q782.24-138 731.12-138t-88.62-33.42Q605-204.83 603-256H358q-3 50-39.88 84t-88 34Zm-.12-72q24 0 41-17t17-41q0-24-17-41t-41-17q-24 0-41 17t-17 41q0 24 17 41t41 17Zm501 0q24 0 41-17t17-41q0-24-17-41t-41-17q-24 0-41 17t-17 41q0 24 17 41t41 17Zm-41-215h162L741-573h-51v148Z"
  })
});
var local_shipping_fill_default = SvgComponent249;

// ../../../node_modules/@material-symbols/svg-700/outlined/local_shipping.svg
import * as React250 from "react";
import { jsx as jsx299 } from "react/jsx-runtime";
var SvgComponent250 = (props) => /* @__PURE__ */ jsx299("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx299("path", {
    d: "M230.12-138q-51.12 0-88.62-33.42Q104-204.83 102-256H17v-473q0-39.05 27.47-66.53Q71.95-823 111-823h579v155h98l155 207.56V-256h-83q-3 51.17-40.38 84.58Q782.24-138 731.12-138t-88.62-33.42Q605-204.83 603-256H358q-3 50-39.88 84t-88 34Zm-.12-72q24 0 41-17t17-41q0-24-17-41t-41-17q-24 0-41 17t-17 41q0 24 17 41t41 17ZM111-350h26.35q16.65-22 40.59-35 23.94-13 51-13t51.54 12.87Q304.95-372.25 321-350h275v-379H111v379Zm620 140q24 0 41-17t17-41q0-24-17-41t-41-17q-24 0-41 17t-17 41q0 24 17 41t41 17Zm-41-215h162L741-573h-51v148ZM354-529Z"
  })
});
var local_shipping_default = SvgComponent250;

// ../../../node_modules/@material-symbols/svg-700/rounded/local_shipping-fill.svg
import * as React251 from "react";
import { jsx as jsx300 } from "react/jsx-runtime";
var SvgComponent251 = (props) => /* @__PURE__ */ jsx300("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx300("path", {
    d: "M230.12-138q-51.12 0-88.62-33.42Q104-204.83 102-256H64q-19.75 0-33.37-13.63Q17-283.25 17-303v-426q0-39.05 27.47-66.53Q71.95-823 111-823h485q38.75 0 66.38 27.62Q690-767.75 690-729v61h51q22.04 0 41.75 9.81Q802.47-648.38 816-630l118 157q4 6.12 6.5 13.35 2.5 7.22 2.5 15.65v141q0 19.75-13.62 33.37Q915.75-256 896-256h-36q-3 51-40.38 84.5t-88.5 33.5q-51.12 0-88.62-33.42Q605-204.83 603-256H358q-3 50-39.88 84t-88 34Zm-.12-72q24 0 41-17t17-41q0-24-17-41t-41-17q-24 0-41 17t-17 41q0 24 17 41t41 17Zm501 0q24 0 41-17t17-41q0-24-17-41t-41-17q-24 0-41 17t-17 41q0 24 17 41t41 17Zm-41-215h162L741-573h-51v148Z"
  })
});
var local_shipping_fill_default2 = SvgComponent251;

// ../../../node_modules/@material-symbols/svg-700/rounded/local_shipping.svg
import * as React252 from "react";
import { jsx as jsx301 } from "react/jsx-runtime";
var SvgComponent252 = (props) => /* @__PURE__ */ jsx301("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx301("path", {
    d: "M230.12-138q-51.12 0-88.62-33.42Q104-204.83 102-256H64q-19.75 0-33.37-13.63Q17-283.25 17-303v-426q0-39.05 27.47-66.53Q71.95-823 111-823h485q38.75 0 66.38 27.62Q690-767.75 690-729v61h51q22.04 0 41.75 9.81Q802.47-648.38 816-630l118 157q4 6.12 6.5 13.35 2.5 7.22 2.5 15.65v141q0 19.75-13.62 33.37Q915.75-256 896-256h-36q-3 51-40.38 84.5t-88.5 33.5q-51.12 0-88.62-33.42Q605-204.83 603-256H358q-3 50-39.88 84t-88 34Zm-.12-72q24 0 41-17t17-41q0-24-17-41t-41-17q-24 0-41 17t-17 41q0 24 17 41t41 17ZM111-350h26.35q16.65-22 40.59-35 23.94-13 51-13t51.54 12.87Q304.95-372.25 321-350h275v-379H111v379Zm620 140q24 0 41-17t17-41q0-24-17-41t-41-17q-24 0-41 17t-17 41q0 24 17 41t41 17Zm-41-215h162L741-573h-51v148ZM354-540Z"
  })
});
var local_shipping_default2 = SvgComponent252;

// ../../../node_modules/@material-symbols/svg-700/sharp/local_shipping-fill.svg
import * as React253 from "react";
import { jsx as jsx302 } from "react/jsx-runtime";
var SvgComponent253 = (props) => /* @__PURE__ */ jsx302("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx302("path", {
    d: "M230.12-138q-51.12 0-88.62-33.42Q104-204.83 102-256H17v-567h673v155h98l155 207.56V-256h-83q-3 51.17-40.38 84.58Q782.24-138 731.12-138t-88.62-33.42Q605-204.83 603-256H358q-3 50-39.88 84t-88 34Zm-.12-72q24 0 41-17t17-41q0-24-17-41t-41-17q-24 0-41 17t-17 41q0 24 17 41t41 17Zm501 0q24 0 41-17t17-41q0-24-17-41t-41-17q-24 0-41 17t-17 41q0 24 17 41t41 17Zm-41-215h162L741-573h-51v148Z"
  })
});
var local_shipping_fill_default3 = SvgComponent253;

// ../../../node_modules/@material-symbols/svg-700/sharp/local_shipping.svg
import * as React254 from "react";
import { jsx as jsx303 } from "react/jsx-runtime";
var SvgComponent254 = (props) => /* @__PURE__ */ jsx303("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx303("path", {
    d: "M230.12-138q-51.12 0-88.62-33.42Q104-204.83 102-256H17v-567h673v155h98l155 207.56V-256h-83q-3 51.17-40.38 84.58Q782.24-138 731.12-138t-88.62-33.42Q605-204.83 603-256H358q-3 50-39.88 84t-88 34Zm-.12-72q24 0 41-17t17-41q0-24-17-41t-41-17q-24 0-41 17t-17 41q0 24 17 41t41 17ZM111-350h26.35q16.65-22 40.59-35 23.94-13 51-13t51.54 12.87Q304.95-372.25 321-350h275v-379H111v379Zm620 140q24 0 41-17t17-41q0-24-17-41t-41-17q-24 0-41 17t-17 41q0 24 17 41t41 17Zm-41-215h162L741-573h-51v148ZM354-529Z"
  })
});
var local_shipping_default3 = SvgComponent254;

// src/components/icon/variants/IconLocalShipping.tsx
import { useTranslation as useTranslation50 } from "react-i18next";
import { jsx as jsx304 } from "react/jsx-runtime";
var componentMap41 = {
  outlined: local_shipping_default,
  "outlined-fill": local_shipping_fill_default,
  rounded: local_shipping_default2,
  "rounded-fill": local_shipping_fill_default2,
  sharp: local_shipping_default3,
  "sharp-fill": local_shipping_fill_default3
};
var IconLocalShipping = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation50("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap41[key] ?? componentMap41[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx304(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/location_on-fill.svg
import * as React255 from "react";
import { jsx as jsx305 } from "react/jsx-runtime";
var SvgComponent255 = (props) => /* @__PURE__ */ jsx305("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx305("path", {
    d: "M480.26-483q32.74 0 55.24-22.26 22.5-22.25 22.5-55 0-32.74-22.46-55.24-22.47-22.5-55.5-22.5Q447-638 425-615.54q-22 22.47-22 55.5Q403-527 425.26-505q22.25 22 55 22ZM480-55Q307-199 221-318.5T135-555q0-159.72 104.04-255.36Q343.08-906 480-906q136.49 0 241.25 95.64Q826-714.72 826-555q0 117-86.5 236.5T480-55Z"
  })
});
var location_on_fill_default = SvgComponent255;

// ../../../node_modules/@material-symbols/svg-700/outlined/location_on.svg
import * as React256 from "react";
import { jsx as jsx306 } from "react/jsx-runtime";
var SvgComponent256 = (props) => /* @__PURE__ */ jsx306("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx306("path", {
    d: "M480.26-483q32.74 0 55.24-22.26 22.5-22.25 22.5-55 0-32.74-22.46-55.24-22.47-22.5-55.5-22.5Q447-638 425-615.54q-22 22.47-22 55.5Q403-527 425.26-505q22.25 22 55 22ZM480-179q128-115 189.5-204T731-555q0-112.52-72.64-184.26T480.15-811q-105.57 0-178.36 71.74Q229-667.52 229-555q0 83 63 171.5T480-179Zm0 124Q307-199 221-318.5T135-555q0-159.72 104.04-255.36Q343.08-906 480-906q136.49 0 241.25 95.64Q826-714.72 826-555q0 117-86.5 236.5T480-55Zm0-505Z"
  })
});
var location_on_default = SvgComponent256;

// ../../../node_modules/@material-symbols/svg-700/rounded/location_on-fill.svg
import * as React257 from "react";
import { jsx as jsx307 } from "react/jsx-runtime";
var SvgComponent257 = (props) => /* @__PURE__ */ jsx307("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx307("path", {
    d: "M479.51-79q-12.51 0-26.1-4.5Q439.82-88 430-97q-48-40-100-90.5t-95.5-109Q191-355 163-420.5T135-555q0-159.72 104.25-255.36Q343.51-906 480-906t241.25 95.64Q826-714.72 826-555q0 69-28.5 134.5t-72 124Q682-238 630-187.5T531-97q-10.96 9-24.97 13.5-14.01 4.5-26.52 4.5Zm.58-404q32.91 0 55.41-22.09t22.5-55q0-32.91-22.59-55.41t-55.5-22.5Q447-638 425-615.41t-22 55.5Q403-527 425.09-505t55 22Z"
  })
});
var location_on_fill_default2 = SvgComponent257;

// ../../../node_modules/@material-symbols/svg-700/rounded/location_on.svg
import * as React258 from "react";
import { jsx as jsx308 } from "react/jsx-runtime";
var SvgComponent258 = (props) => /* @__PURE__ */ jsx308("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx308("path", {
    d: "M480-179q128-115 189.5-204T731-555q0-112.76-72.83-184.38Q585.35-811 479.96-811q-105.38 0-178.17 71.62Q229-667.76 229-555q0 83 63 171.5T480-179Zm-.49 100q-12.51 0-26.1-4.5Q439.82-88 430-97q-48-40-100-90.5t-95.5-109Q191-355 163-420.5T135-555q0-159.72 104.25-255.36Q343.51-906 480-906t241.25 95.64Q826-714.72 826-555q0 69-28.5 134.5t-72 124Q682-238 630-187.5T531-97q-10.96 9-24.97 13.5-14.01 4.5-26.52 4.5Zm.49-481Zm.09 77q32.91 0 55.41-22.09t22.5-55q0-32.91-22.59-55.41t-55.5-22.5Q447-638 425-615.41t-22 55.5Q403-527 425.09-505t55 22Z"
  })
});
var location_on_default2 = SvgComponent258;

// ../../../node_modules/@material-symbols/svg-700/sharp/location_on-fill.svg
import * as React259 from "react";
import { jsx as jsx309 } from "react/jsx-runtime";
var SvgComponent259 = (props) => /* @__PURE__ */ jsx309("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx309("path", {
    d: "M480.26-483q32.74 0 55.24-22.26 22.5-22.25 22.5-55 0-32.74-22.46-55.24-22.47-22.5-55.5-22.5Q447-638 425-615.54q-22 22.47-22 55.5Q403-527 425.26-505q22.25 22 55 22ZM480-55Q307-199 221-318.5T135-555q0-159.72 104.04-255.36Q343.08-906 480-906q136.49 0 241.25 95.64Q826-714.72 826-555q0 117-86.5 236.5T480-55Z"
  })
});
var location_on_fill_default3 = SvgComponent259;

// ../../../node_modules/@material-symbols/svg-700/sharp/location_on.svg
import * as React260 from "react";
import { jsx as jsx310 } from "react/jsx-runtime";
var SvgComponent260 = (props) => /* @__PURE__ */ jsx310("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx310("path", {
    d: "M480.26-483q32.74 0 55.24-22.26 22.5-22.25 22.5-55 0-32.74-22.46-55.24-22.47-22.5-55.5-22.5Q447-638 425-615.54q-22 22.47-22 55.5Q403-527 425.26-505q22.25 22 55 22ZM480-179q128-115 189.5-204T731-555q0-112.52-72.64-184.26T480.15-811q-105.57 0-178.36 71.74Q229-667.52 229-555q0 83 63 171.5T480-179Zm0 124Q307-199 221-318.5T135-555q0-159.72 104.04-255.36Q343.08-906 480-906q136.49 0 241.25 95.64Q826-714.72 826-555q0 117-86.5 236.5T480-55Zm0-505Z"
  })
});
var location_on_default3 = SvgComponent260;

// src/components/icon/variants/IconLocationOn.tsx
import { useTranslation as useTranslation51 } from "react-i18next";
import { jsx as jsx311 } from "react/jsx-runtime";
var componentMap42 = {
  outlined: location_on_default,
  "outlined-fill": location_on_fill_default,
  rounded: location_on_default2,
  "rounded-fill": location_on_fill_default2,
  sharp: location_on_default3,
  "sharp-fill": location_on_fill_default3
};
var IconLocationOn = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation51("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap42[key] ?? componentMap42[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx311(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/lock-fill.svg
import * as React261 from "react";
import { jsx as jsx312 } from "react/jsx-runtime";
var SvgComponent261 = (props) => /* @__PURE__ */ jsx312("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx312("path", {
    d: "M229-57q-38.78 0-66.39-27.61T135-151v-416q0-39.19 27.61-67.09Q190.22-662 229-662h50v-74q0-85.19 58.37-144.59Q395.73-940 479.87-940q84.13 0 142.63 59.41Q681-821.19 681-736v74h50q39.19 0 67.09 27.91Q826-606.19 826-567v416q0 38.78-27.91 66.39Q770.19-57 731-57H229Zm251.17-225q31.83 0 54.33-22.03T557-357q0-30-22.67-54.5t-54.5-24.5q-31.83 0-54.33 24.5t-22.5 55q0 30.5 22.67 52.5t54.5 22ZM373-662h214v-73.77q0-46.73-30.65-77.98-30.64-31.25-76-31.25Q435-845 404-813.75q-31 31.25-31 77.98V-662Z"
  })
});
var lock_fill_default = SvgComponent261;

// ../../../node_modules/@material-symbols/svg-700/outlined/lock.svg
import * as React262 from "react";
import { jsx as jsx313 } from "react/jsx-runtime";
var SvgComponent262 = (props) => /* @__PURE__ */ jsx313("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx313("path", {
    d: "M229-57q-38.78 0-66.39-27.61T135-151v-416q0-39.19 27.61-67.09Q190.22-662 229-662h50v-74q0-85.19 58.37-144.59Q395.73-940 479.87-940q84.13 0 142.63 59.41Q681-821.19 681-736v74h50q39.19 0 67.09 27.91Q826-606.19 826-567v416q0 38.78-27.91 66.39Q770.19-57 731-57H229Zm0-94h502v-416H229v416Zm251.17-131q31.83 0 54.33-22.03T557-357q0-30-22.67-54.5t-54.5-24.5q-31.83 0-54.33 24.5t-22.5 55q0 30.5 22.67 52.5t54.5 22ZM373-662h214v-73.77q0-46.73-30.65-77.98-30.64-31.25-76-31.25Q435-845 404-813.75q-31 31.25-31 77.98V-662ZM229-151v-416 416Z"
  })
});
var lock_default = SvgComponent262;

// ../../../node_modules/@material-symbols/svg-700/rounded/lock-fill.svg
import * as React263 from "react";
import { jsx as jsx314 } from "react/jsx-runtime";
var SvgComponent263 = (props) => /* @__PURE__ */ jsx314("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx314("path", {
    d: "M229-57q-38.78 0-66.39-27.61T135-151v-416q0-39.19 27.61-67.09Q190.22-662 229-662h50v-74q0-85.19 58.37-144.59Q395.73-940 479.87-940q84.13 0 142.63 59.41Q681-821.19 681-736v74h50q39.19 0 67.09 27.91Q826-606.19 826-567v416q0 38.78-27.91 66.39Q770.19-57 731-57H229Zm251.17-225q31.83 0 54.33-22.03T557-357q0-30-22.67-54.5t-54.5-24.5q-31.83 0-54.33 24.5t-22.5 55q0 30.5 22.67 52.5t54.5 22ZM373-662h214v-73.77q0-46.73-30.65-77.98-30.64-31.25-76-31.25Q435-845 404-813.75q-31 31.25-31 77.98V-662Z"
  })
});
var lock_fill_default2 = SvgComponent263;

// ../../../node_modules/@material-symbols/svg-700/rounded/lock.svg
import * as React264 from "react";
import { jsx as jsx315 } from "react/jsx-runtime";
var SvgComponent264 = (props) => /* @__PURE__ */ jsx315("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx315("path", {
    d: "M229-57q-38.78 0-66.39-27.61T135-151v-416q0-39.19 27.61-67.09Q190.22-662 229-662h50v-74q0-85.19 58.37-144.59Q395.73-940 479.87-940q84.13 0 142.63 59.41Q681-821.19 681-736v74h50q39.19 0 67.09 27.91Q826-606.19 826-567v416q0 38.78-27.91 66.39Q770.19-57 731-57H229Zm0-94h502v-416H229v416Zm251.17-131q31.83 0 54.33-22.03T557-357q0-30-22.67-54.5t-54.5-24.5q-31.83 0-54.33 24.5t-22.5 55q0 30.5 22.67 52.5t54.5 22ZM373-662h214v-73.77q0-46.73-30.65-77.98-30.64-31.25-76-31.25Q435-845 404-813.75q-31 31.25-31 77.98V-662ZM229-151v-416 416Z"
  })
});
var lock_default2 = SvgComponent264;

// ../../../node_modules/@material-symbols/svg-700/sharp/lock-fill.svg
import * as React265 from "react";
import { jsx as jsx316 } from "react/jsx-runtime";
var SvgComponent265 = (props) => /* @__PURE__ */ jsx316("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx316("path", {
    d: "M135-57v-605h144v-74q0-85.19 58.37-144.59Q395.73-940 479.87-940q84.13 0 142.63 59.41Q681-821.19 681-736v74h145v605H135Zm345.17-225q31.83 0 54.33-22.03T557-357q0-30-22.67-54.5t-54.5-24.5q-31.83 0-54.33 24.5t-22.5 55q0 30.5 22.67 52.5t54.5 22ZM373-662h214v-73.77q0-46.73-30.65-77.98-30.64-31.25-76-31.25Q435-845 404-813.75q-31 31.25-31 77.98V-662Z"
  })
});
var lock_fill_default3 = SvgComponent265;

// ../../../node_modules/@material-symbols/svg-700/sharp/lock.svg
import * as React266 from "react";
import { jsx as jsx317 } from "react/jsx-runtime";
var SvgComponent266 = (props) => /* @__PURE__ */ jsx317("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx317("path", {
    d: "M135-57v-605h144v-74q0-85.19 58.37-144.59Q395.73-940 479.87-940q84.13 0 142.63 59.41Q681-821.19 681-736v74h145v605H135Zm94-94h502v-416H229v416Zm251.17-131q31.83 0 54.33-22.03T557-357q0-30-22.67-54.5t-54.5-24.5q-31.83 0-54.33 24.5t-22.5 55q0 30.5 22.67 52.5t54.5 22ZM373-662h214v-73.77q0-46.73-30.65-77.98-30.64-31.25-76-31.25Q435-845 404-813.75q-31 31.25-31 77.98V-662ZM229-151v-416 416Z"
  })
});
var lock_default3 = SvgComponent266;

// src/components/icon/variants/IconLock.tsx
import { useTranslation as useTranslation52 } from "react-i18next";
import { jsx as jsx318 } from "react/jsx-runtime";
var componentMap43 = {
  outlined: lock_default,
  "outlined-fill": lock_fill_default,
  rounded: lock_default2,
  "rounded-fill": lock_fill_default2,
  sharp: lock_default3,
  "sharp-fill": lock_fill_default3
};
var IconLock = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation52("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap43[key] ?? componentMap43[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx318(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/logo_dev-fill.svg
import * as React267 from "react";
import { jsx as jsx319 } from "react/jsx-runtime";
var SvgComponent267 = (props) => /* @__PURE__ */ jsx319("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx319("path", {
    d: "M209-357h96q25 0 42.5-17.79Q365-392.59 365-418v-125q0-25-17.5-42.5T305-603h-96v246Zm60-61v-125h36v125h-36Zm165 61h106v-61h-79v-40h55v-45h-55v-40h79v-60H434.23q-14.23 0-23.73 9.72-9.5 9.71-9.5 23.28v179.46q0 14.54 9.72 24.04 9.71 9.5 23.28 9.5Zm237 0q20.59 0 34.8-14.5Q720-386 725-405l55-198h-65l-44 175-43-175h-65l54 198q5 20 19.2 34 14.21 14 34.8 14ZM189-95q-39.05 0-66.53-27.47Q95-149.95 95-189v-582q0-39.46 27.47-67.23Q149.95-866 189-866h582q39.46 0 67.23 27.77Q866-810.46 866-771v582q0 39.05-27.77 66.53Q810.46-95 771-95H189Z"
  })
});
var logo_dev_fill_default = SvgComponent267;

// ../../../node_modules/@material-symbols/svg-700/outlined/logo_dev.svg
import * as React268 from "react";
import { jsx as jsx320 } from "react/jsx-runtime";
var SvgComponent268 = (props) => /* @__PURE__ */ jsx320("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx320("path", {
    d: "M209-357h96q24.78 0 42.39-17.9T365-418v-125q0-24.78-17.61-42.39T305-603h-96v246Zm60-61v-125h36v125h-36Zm164.82 61H540v-61h-79v-40h55v-45h-55v-40h79v-60H434.05q-14.05 0-23.55 9.72-9.5 9.71-9.5 23.28v179.46q0 14.54 9.72 24.04 9.71 9.5 23.1 9.5ZM671-357q20.59 0 34.8-14.5Q720-386 725-405l55-198h-65l-44 175-43-175h-65l54 198q5 20 19.2 34 14.21 14 34.8 14ZM189-95q-39.05 0-66.53-27.47Q95-149.95 95-189v-582q0-39.46 27.47-67.23Q149.95-866 189-866h582q39.46 0 67.23 27.77Q866-810.46 866-771v582q0 39.05-27.77 66.53Q810.46-95 771-95H189Zm0-94h582v-582H189v582Zm0-582v582-582Z"
  })
});
var logo_dev_default = SvgComponent268;

// ../../../node_modules/@material-symbols/svg-700/rounded/logo_dev-fill.svg
import * as React269 from "react";
import { jsx as jsx321 } from "react/jsx-runtime";
var SvgComponent269 = (props) => /* @__PURE__ */ jsx321("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx321("path", {
    d: "M304.54-357q25.59 0 43.03-17.9Q365-392.8 365-418v-125q0-24.78-17.61-42.39T305-603h-70.84q-10.99 0-18.08 7.08Q209-588.83 209-578v196q0 10.83 7.08 17.92 7.09 7.08 18.08 7.08h70.38ZM269-418v-125h36v125h-36Zm165 61h76q13 0 21.5-9.08 8.5-9.09 8.5-22.36 0-12.09-8.5-20.83Q523-418 510-418h-49v-40h33.44q9.38 0 15.47-6.81t6.09-16.37q0-10-5.81-15.91T494.42-503H461v-40h49q13.04 0 21.52-8.47t8.48-21.5q0-13.03-8.48-21.53-8.48-8.5-21.52-8.5h-75.7q-14.3 0-23.8 9.72-9.5 9.71-9.5 23.28v179.46q0 14.54 9.72 24.04 9.71 9.5 23.28 9.5Zm237 0q20.59 0 34.8-14.5Q720-386 725-405l45-159q4-15.41-5.36-27.21Q755.27-603 738.8-603q-10.52 0-18.66 7T710-579l-39 151-38-152q-1.81-10.06-9.74-16.53-7.93-6.47-19.65-6.47-15.61 0-25.11 12.6-9.5 12.61-5.5 26.4l44 159q5 20 19.2 34 14.21 14 34.8 14ZM189-95q-39.05 0-66.53-27.47Q95-149.95 95-189v-582q0-39.46 27.47-67.23Q149.95-866 189-866h582q39.46 0 67.23 27.77Q866-810.46 866-771v582q0 39.05-27.77 66.53Q810.46-95 771-95H189Z"
  })
});
var logo_dev_fill_default2 = SvgComponent269;

// ../../../node_modules/@material-symbols/svg-700/rounded/logo_dev.svg
import * as React270 from "react";
import { jsx as jsx322 } from "react/jsx-runtime";
var SvgComponent270 = (props) => /* @__PURE__ */ jsx322("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx322("path", {
    d: "M304.54-357q25.59 0 43.03-17.9Q365-392.8 365-418v-125q0-24.78-17.61-42.39T305-603h-70.84q-10.99 0-18.08 7.08Q209-588.83 209-578v196q0 10.83 7.08 17.92 7.09 7.08 18.08 7.08h70.38ZM269-418v-125h36v125h-36Zm165 61h76q13 0 21.5-9.08 8.5-9.09 8.5-22.36 0-12.09-8.5-20.83Q523-418 510-418h-49v-40h33.44q9.38 0 15.47-6.81t6.09-16.37q0-10-5.81-15.91T494.42-503H461v-40h49q13.04 0 21.52-8.47t8.48-21.5q0-13.03-8.48-21.53-8.48-8.5-21.52-8.5h-75.7q-14.3 0-23.8 9.72-9.5 9.71-9.5 23.28v179.46q0 14.54 9.72 24.04 9.71 9.5 23.28 9.5Zm237 0q20.59 0 34.8-14.5Q720-386 725-405l45-159q4-15.41-5.36-27.21Q755.27-603 738.8-603q-10.52 0-18.66 7T710-579l-39 151-38-152q-1.81-10.06-9.74-16.53-7.93-6.47-19.65-6.47-15.61 0-25.11 12.6-9.5 12.61-5.5 26.4l44 159q5 20 19.2 34 14.21 14 34.8 14ZM189-95q-39.05 0-66.53-27.47Q95-149.95 95-189v-582q0-39.46 27.47-67.23Q149.95-866 189-866h582q39.46 0 67.23 27.77Q866-810.46 866-771v582q0 39.05-27.77 66.53Q810.46-95 771-95H189Zm0-94h582v-582H189v582Zm0-582v582-582Z"
  })
});
var logo_dev_default2 = SvgComponent270;

// ../../../node_modules/@material-symbols/svg-700/sharp/logo_dev-fill.svg
import * as React271 from "react";
import { jsx as jsx323 } from "react/jsx-runtime";
var SvgComponent271 = (props) => /* @__PURE__ */ jsx323("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx323("path", {
    d: "M209-357h127l29-31v-186l-29-29H209v246Zm60-61v-125h36v125h-36Zm192 0v-40h55v-45h-55v-40h79v-60H401v246h139v-61h-79Zm210-10-43-175h-65l66 246h83l68-246h-65l-44 175ZM95-95v-771h771v771H95Z"
  })
});
var logo_dev_fill_default3 = SvgComponent271;

// ../../../node_modules/@material-symbols/svg-700/sharp/logo_dev.svg
import * as React272 from "react";
import { jsx as jsx324 } from "react/jsx-runtime";
var SvgComponent272 = (props) => /* @__PURE__ */ jsx324("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx324("path", {
    d: "M209-357h127l29-31v-186l-29-29H209v246Zm60-61v-125h36v125h-36Zm192 0v-40h55v-45h-55v-40h79v-60H401v246h139v-61h-79Zm210-10-43-175h-65l66 246h83l68-246h-65l-44 175ZM95-95v-771h771v771H95Zm94-94h582v-582H189v582Zm0 0v-582 582Z"
  })
});
var logo_dev_default3 = SvgComponent272;

// src/components/icon/variants/IconLogoDev.tsx
import { useTranslation as useTranslation53 } from "react-i18next";
import { jsx as jsx325 } from "react/jsx-runtime";
var componentMap44 = {
  outlined: logo_dev_default,
  "outlined-fill": logo_dev_fill_default,
  rounded: logo_dev_default2,
  "rounded-fill": logo_dev_fill_default2,
  sharp: logo_dev_default3,
  "sharp-fill": logo_dev_fill_default3
};
var IconLogoDev = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation53("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap44[key] ?? componentMap44[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx325(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/logout-fill.svg
import * as React273 from "react";
import { jsx as jsx326 } from "react/jsx-runtime";
var SvgComponent273 = (props) => /* @__PURE__ */ jsx326("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx326("path", {
    d: "M189-95q-39.05 0-66.53-27.47Q95-149.95 95-189v-582q0-39.46 27.47-67.23Q149.95-866 189-866h296v95H189v582h296v94H189Zm467-174-67-66 97-98H354v-94h330l-97-98 67-66 212 212-210 210Z"
  })
});
var logout_fill_default = SvgComponent273;

// ../../../node_modules/@material-symbols/svg-700/outlined/logout.svg
import * as React274 from "react";
import { jsx as jsx327 } from "react/jsx-runtime";
var SvgComponent274 = (props) => /* @__PURE__ */ jsx327("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx327("path", {
    d: "M189-95q-39.05 0-66.53-27.47Q95-149.95 95-189v-582q0-39.46 27.47-67.23Q149.95-866 189-866h296v95H189v582h296v94H189Zm467-174-67-66 97-98H354v-94h330l-97-98 67-66 212 212-210 210Z"
  })
});
var logout_default = SvgComponent274;

// ../../../node_modules/@material-symbols/svg-700/rounded/logout-fill.svg
import * as React275 from "react";
import { jsx as jsx328 } from "react/jsx-runtime";
var SvgComponent275 = (props) => /* @__PURE__ */ jsx328("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx328("path", {
    d: "M189-95q-39.05 0-66.53-27.47Q95-149.95 95-189v-582q0-39.46 27.47-67.23Q149.95-866 189-866h249q19.75 0 33.38 14.26 13.62 14.27 13.62 34 0 19.74-13.62 33.24Q457.75-771 438-771H189v582h249q19.75 0 33.38 13.68Q485-161.65 485-141.82q0 19.82-13.62 33.32Q457.75-95 438-95H189Zm497-338H401q-19.75 0-33.37-13.68Q354-460.35 354-480.18q0-19.82 13.63-33.32Q381.25-527 401-527h283l-64-64q-14-14.21-13.5-33.6.5-19.4 14.5-32.9 14-14.5 33.15-14T688-657l145 145q13 14.36 13 33.18T833-446L689-302q-13.8 14-32.9 14-19.1 0-33.49-14-13.61-14-14.15-33.38-.54-19.37 14.54-33.62l63-64Z"
  })
});
var logout_fill_default2 = SvgComponent275;

// ../../../node_modules/@material-symbols/svg-700/rounded/logout.svg
import * as React276 from "react";
import { jsx as jsx329 } from "react/jsx-runtime";
var SvgComponent276 = (props) => /* @__PURE__ */ jsx329("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx329("path", {
    d: "M189-95q-39.05 0-66.53-27.47Q95-149.95 95-189v-582q0-39.46 27.47-67.23Q149.95-866 189-866h249q19.75 0 33.38 14.26 13.62 14.27 13.62 34 0 19.74-13.62 33.24Q457.75-771 438-771H189v582h249q19.75 0 33.38 13.68Q485-161.65 485-141.82q0 19.82-13.62 33.32Q457.75-95 438-95H189Zm497-338H401q-19.75 0-33.37-13.68Q354-460.35 354-480.18q0-19.82 13.63-33.32Q381.25-527 401-527h283l-64-64q-14-14.21-13.5-33.6.5-19.4 14.5-32.9 14-14.5 33.15-14T688-657l145 145q13 14.36 13 33.18T833-446L689-302q-13.8 14-32.9 14-19.1 0-33.49-14-13.61-14-14.15-33.38-.54-19.37 14.54-33.62l63-64Z"
  })
});
var logout_default2 = SvgComponent276;

// ../../../node_modules/@material-symbols/svg-700/sharp/logout-fill.svg
import * as React277 from "react";
import { jsx as jsx330 } from "react/jsx-runtime";
var SvgComponent277 = (props) => /* @__PURE__ */ jsx330("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx330("path", {
    d: "M95-95v-771h390v95H189v582h296v94H95Zm561-174-67-66 97-98H354v-94h330l-97-98 67-66 212 212-210 210Z"
  })
});
var logout_fill_default3 = SvgComponent277;

// ../../../node_modules/@material-symbols/svg-700/sharp/logout.svg
import * as React278 from "react";
import { jsx as jsx331 } from "react/jsx-runtime";
var SvgComponent278 = (props) => /* @__PURE__ */ jsx331("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx331("path", {
    d: "M95-95v-771h390v95H189v582h296v94H95Zm561-174-67-66 97-98H354v-94h330l-97-98 67-66 212 212-210 210Z"
  })
});
var logout_default3 = SvgComponent278;

// src/components/icon/variants/IconLogout.tsx
import { useTranslation as useTranslation54 } from "react-i18next";
import { jsx as jsx332 } from "react/jsx-runtime";
var componentMap45 = {
  outlined: logout_default,
  "outlined-fill": logout_fill_default,
  rounded: logout_default2,
  "rounded-fill": logout_fill_default2,
  sharp: logout_default3,
  "sharp-fill": logout_fill_default3
};
var IconLogout = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation54("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap45[key] ?? componentMap45[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx332(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// src/components/icon/variants/IconMailOrder.tsx
import { useTranslation as useTranslation55 } from "react-i18next";

// src/components/icon/static/mail-order.svg
import * as React279 from "react";
import { jsx as jsx333, jsxs as jsxs8 } from "react/jsx-runtime";
var SvgComponent279 = (props) => /* @__PURE__ */ jsxs8("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: [
    /* @__PURE__ */ jsx333("path", {
      d: "M6.00001 10.0001C6.00001 10.5524 6.44772 11.0001 7.00001 11.0001C7.55229 11.0001 8.00001 10.5524 8.00001 10.0001C8.00001 9.44781 7.55229 9.0001 7.00001 9.0001C6.44772 9.0001 6.00001 9.44781 6.00001 10.0001Z"
    }),
    /* @__PURE__ */ jsx333("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.00001 3.8501C4.15588 3.8501 1.85001 6.15597 1.85001 9.0001V18.0001C1.85001 19.1872 2.81288 20.1501 4.00001 20.1501H20C21.1871 20.1501 22.15 19.1872 22.15 18.0001V9.0001C22.15 6.15597 19.8441 3.8501 17 3.8501H7.00001ZM7.00001 6.1501C5.42613 6.1501 4.15001 7.42623 4.15001 9.0001V17.8501H9.85001V9.0001C9.85001 7.42623 8.57388 6.1501 7.00001 6.1501ZM12.15 11.1501V17.8501H19.85V9.0001C19.85 7.42623 18.5739 6.1501 17 6.1501H11.2901C11.8075 6.92738 12.1193 7.85328 12.1479 8.8501H16.5C17.4113 8.8501 18.15 9.58883 18.15 10.5001V13.0001C18.15 13.6352 17.6351 14.1501 17 14.1501C16.3649 14.1501 15.85 13.6352 15.85 13.0001V11.1501H12.15Z"
    })
  ]
});
var mail_order_default = SvgComponent279;

// src/components/icon/variants/IconMailOrder.tsx
import { jsx as jsx334 } from "react/jsx-runtime";
var IconMailOrder = ({
  color,
  height,
  style = {},
  width
}) => {
  const { t } = useTranslation55("pds");
  return /* @__PURE__ */ jsx334(Icon, {
    SvgIcon: mail_order_default,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/medication-fill.svg
import * as React280 from "react";
import { jsx as jsx335 } from "react/jsx-runtime";
var SvgComponent280 = (props) => /* @__PURE__ */ jsx335("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx335("path", {
    d: "M440-250h79v-113h116v-80H519v-113h-79v113H325v80h115v113ZM260-68q-38.78 0-66.39-27.91Q166-123.81 166-163v-479q0-38.77 27.61-66.39Q221.22-736 260-736h440q39.19 0 67.09 27.61Q795-680.77 795-642v479q0 39.19-27.91 67.09Q739.19-68 700-68H260Zm-43-729v-95h527v95H217Z"
  })
});
var medication_fill_default = SvgComponent280;

// ../../../node_modules/@material-symbols/svg-700/outlined/medication.svg
import * as React281 from "react";
import { jsx as jsx336 } from "react/jsx-runtime";
var SvgComponent281 = (props) => /* @__PURE__ */ jsx336("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx336("path", {
    d: "M440-252h79v-111h114v-80H519v-111h-79v111H327v80h113v111ZM260-68q-38.78 0-66.39-27.91Q166-123.81 166-163v-479q0-38.77 27.61-66.39Q221.22-736 260-736h440q39.19 0 67.09 27.61Q795-680.77 795-642v479q0 39.19-27.91 67.09Q739.19-68 700-68H260Zm0-95h440v-479H260v479Zm-43-634v-95h527v95H217Zm43 155v479-479Z"
  })
});
var medication_default = SvgComponent281;

// ../../../node_modules/@material-symbols/svg-700/rounded/medication-fill.svg
import * as React282 from "react";
import { jsx as jsx337 } from "react/jsx-runtime";
var SvgComponent282 = (props) => /* @__PURE__ */ jsx337("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx337("path", {
    d: "M440-363v80q0 16.67 11.74 28.33Q463.47-243 480.24-243q16.76 0 28.26-11.67Q520-266.33 520-283v-80h80q16.67 0 28.33-11.74 11.67-11.73 11.67-28Q640-419 628.33-431q-11.66-12-28.33-12h-80v-80q0-15.67-11.74-27.83Q496.53-563 479.76-563q-16.76 0-28.26 12.17Q440-538.67 440-523v80h-80q-16.67 0-28.33 12.24Q320-418.53 320-402.26q0 16.26 11.67 27.76Q343.33-363 360-363h80ZM260-68q-38.78 0-66.39-27.91Q166-123.81 166-163v-479q0-38.77 27.61-66.39Q221.22-736 260-736h440q39.19 0 67.09 27.61Q795-680.77 795-642v479q0 39.19-27.91 67.09Q739.19-68 700-68H260Zm4-729q-19.75 0-33.37-13.68-13.63-13.67-13.63-34 0-20.32 13.63-33.82Q244.25-892 264-892h432q19.75 0 33.38 13.68 13.62 13.67 13.62 34 0 20.32-13.62 33.82Q715.75-797 696-797H264Z"
  })
});
var medication_fill_default2 = SvgComponent282;

// ../../../node_modules/@material-symbols/svg-700/rounded/medication.svg
import * as React283 from "react";
import { jsx as jsx338 } from "react/jsx-runtime";
var SvgComponent283 = (props) => /* @__PURE__ */ jsx338("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx338("path", {
    d: "M440-363v72q0 17 11.74 28 11.73 11 28.5 11Q497-252 508-263.67q11-11.66 11-28.33v-71h74q16.67 0 28.33-11.74 11.67-11.73 11.67-28Q633-419 621.33-431q-11.66-12-28.33-12h-74v-72q0-16-11-27.5T480.24-554q-16.77 0-28.5 11.5Q440-531 440-515v72h-73q-16.67 0-28.33 12.24Q327-418.53 327-402.26q0 16.26 11.67 27.76Q350.33-363 367-363h73ZM260-68q-38.78 0-66.39-27.91Q166-123.81 166-163v-479q0-38.77 27.61-66.39Q221.22-736 260-736h440q39.19 0 67.09 27.61Q795-680.77 795-642v479q0 39.19-27.91 67.09Q739.19-68 700-68H260Zm0-95h440v-479H260v479Zm4-634q-19.75 0-33.37-13.68-13.63-13.67-13.63-34 0-20.32 13.63-33.82Q244.25-892 264-892h433q19.75 0 33.38 13.68 13.62 13.67 13.62 34 0 20.32-13.62 33.82Q716.75-797 697-797H264Zm-4 155v479-479Z"
  })
});
var medication_default2 = SvgComponent283;

// ../../../node_modules/@material-symbols/svg-700/sharp/medication-fill.svg
import * as React284 from "react";
import { jsx as jsx339 } from "react/jsx-runtime";
var SvgComponent284 = (props) => /* @__PURE__ */ jsx339("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx339("path", {
    d: "M440-243h80v-120h120v-80H520v-120h-80v120H320v80h120v120ZM166-68v-668h629v668H166Zm51-729v-95h526v95H217Z"
  })
});
var medication_fill_default3 = SvgComponent284;

// ../../../node_modules/@material-symbols/svg-700/sharp/medication.svg
import * as React285 from "react";
import { jsx as jsx340 } from "react/jsx-runtime";
var SvgComponent285 = (props) => /* @__PURE__ */ jsx340("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx340("path", {
    d: "M440-252h79v-111h114v-80H519v-111h-79v111H327v80h113v111ZM166-68v-668h629v668H166Zm94-95h440v-479H260v479Zm-43-634v-95h527v95H217Zm43 155v479-479Z"
  })
});
var medication_default3 = SvgComponent285;

// src/components/icon/variants/IconMedication.tsx
import { useTranslation as useTranslation56 } from "react-i18next";
import { jsx as jsx341 } from "react/jsx-runtime";
var componentMap46 = {
  outlined: medication_default,
  "outlined-fill": medication_fill_default,
  rounded: medication_default2,
  "rounded-fill": medication_fill_default2,
  sharp: medication_default3,
  "sharp-fill": medication_fill_default3
};
var IconMedication = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation56("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap46[key] ?? componentMap46[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx341(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/menu-fill.svg
import * as React286 from "react";
import { jsx as jsx342 } from "react/jsx-runtime";
var SvgComponent286 = (props) => /* @__PURE__ */ jsx342("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx342("path", {
    d: "M95-203v-95h771v95H95Zm0-230v-94h771v94H95Zm0-229v-95h771v95H95Z"
  })
});
var menu_fill_default = SvgComponent286;

// ../../../node_modules/@material-symbols/svg-700/outlined/menu.svg
import * as React287 from "react";
import { jsx as jsx343 } from "react/jsx-runtime";
var SvgComponent287 = (props) => /* @__PURE__ */ jsx343("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx343("path", {
    d: "M95-203v-95h771v95H95Zm0-230v-94h771v94H95Zm0-229v-95h771v95H95Z"
  })
});
var menu_default = SvgComponent287;

// ../../../node_modules/@material-symbols/svg-700/rounded/menu-fill.svg
import * as React288 from "react";
import { jsx as jsx344 } from "react/jsx-runtime";
var SvgComponent288 = (props) => /* @__PURE__ */ jsx344("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx344("path", {
    d: "M142-203q-19.75 0-33.37-13.68Q95-230.35 95-251.18q0-19.82 13.63-33.32Q122.25-298 142-298h676q19.75 0 33.88 13.68Q866-270.65 866-250.82q0 20.82-14.12 34.32Q837.75-203 818-203H142Zm0-230q-19.75 0-33.37-13.68Q95-460.35 95-480.18q0-19.82 13.63-33.32Q122.25-527 142-527h676q19.75 0 33.88 13.68Q866-499.65 866-479.82q0 19.82-14.12 33.32Q837.75-433 818-433H142Zm0-229q-19.75 0-33.37-13.68Q95-689.35 95-710.18q0-19.82 13.63-33.32Q122.25-757 142-757h676q19.75 0 33.88 13.68Q866-729.65 866-709.82q0 20.82-14.12 34.32Q837.75-662 818-662H142Z"
  })
});
var menu_fill_default2 = SvgComponent288;

// ../../../node_modules/@material-symbols/svg-700/rounded/menu.svg
import * as React289 from "react";
import { jsx as jsx345 } from "react/jsx-runtime";
var SvgComponent289 = (props) => /* @__PURE__ */ jsx345("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx345("path", {
    d: "M142-203q-19.75 0-33.37-13.68Q95-230.35 95-251.18q0-19.82 13.63-33.32Q122.25-298 142-298h676q19.75 0 33.88 13.68Q866-270.65 866-250.82q0 20.82-14.12 34.32Q837.75-203 818-203H142Zm0-230q-19.75 0-33.37-13.68Q95-460.35 95-480.18q0-19.82 13.63-33.32Q122.25-527 142-527h676q19.75 0 33.88 13.68Q866-499.65 866-479.82q0 19.82-14.12 33.32Q837.75-433 818-433H142Zm0-229q-19.75 0-33.37-13.68Q95-689.35 95-710.18q0-19.82 13.63-33.32Q122.25-757 142-757h676q19.75 0 33.88 13.68Q866-729.65 866-709.82q0 20.82-14.12 34.32Q837.75-662 818-662H142Z"
  })
});
var menu_default2 = SvgComponent289;

// ../../../node_modules/@material-symbols/svg-700/sharp/menu-fill.svg
import * as React290 from "react";
import { jsx as jsx346 } from "react/jsx-runtime";
var SvgComponent290 = (props) => /* @__PURE__ */ jsx346("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx346("path", {
    d: "M95-203v-95h771v95H95Zm0-230v-94h771v94H95Zm0-229v-95h771v95H95Z"
  })
});
var menu_fill_default3 = SvgComponent290;

// ../../../node_modules/@material-symbols/svg-700/sharp/menu.svg
import * as React291 from "react";
import { jsx as jsx347 } from "react/jsx-runtime";
var SvgComponent291 = (props) => /* @__PURE__ */ jsx347("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx347("path", {
    d: "M95-203v-95h771v95H95Zm0-230v-94h771v94H95Zm0-229v-95h771v95H95Z"
  })
});
var menu_default3 = SvgComponent291;

// src/components/icon/variants/IconMenu.tsx
import { useTranslation as useTranslation57 } from "react-i18next";
import { jsx as jsx348 } from "react/jsx-runtime";
var componentMap47 = {
  outlined: menu_default,
  "outlined-fill": menu_fill_default,
  rounded: menu_default2,
  "rounded-fill": menu_fill_default2,
  sharp: menu_default3,
  "sharp-fill": menu_fill_default3
};
var IconMenu = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation57("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap47[key] ?? componentMap47[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx348(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/menu_open-fill.svg
import * as React292 from "react";
import { jsx as jsx349 } from "react/jsx-runtime";
var SvgComponent292 = (props) => /* @__PURE__ */ jsx349("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx349("path", {
    d: "M95-215v-93h530v93H95Zm705-55L596-481l203-210 67 67-138 143 139 144-67 67ZM95-435v-94h416v94H95Zm0-217v-94h530v94H95Z"
  })
});
var menu_open_fill_default = SvgComponent292;

// ../../../node_modules/@material-symbols/svg-700/outlined/menu_open.svg
import * as React293 from "react";
import { jsx as jsx350 } from "react/jsx-runtime";
var SvgComponent293 = (props) => /* @__PURE__ */ jsx350("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx350("path", {
    d: "M95-215v-93h530v93H95Zm705-55L596-481l203-210 67 67-138 143 139 144-67 67ZM95-435v-94h416v94H95Zm0-217v-94h530v94H95Z"
  })
});
var menu_open_default = SvgComponent293;

// ../../../node_modules/@material-symbols/svg-700/rounded/menu_open-fill.svg
import * as React294 from "react";
import { jsx as jsx351 } from "react/jsx-runtime";
var SvgComponent294 = (props) => /* @__PURE__ */ jsx351("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx351("path", {
    d: "M141-215q-20.1 0-33.05-13.68Q95-242.35 95-262.42t12.95-32.83Q120.9-308 141-308h438q19.1 0 32.55 13.68Q625-280.65 625-260.58t-12.95 32.83Q599.1-215 579-215H141Zm627-90L627-448q-14-14-14-33t14-33l139-143q14-15 33.5-15t34.5 15q14 14 14 32.5T835-592L728-481l108 112q13 14 12.5 32.5T834-304q-14 14-33 14t-33-15ZM141-435q-20.1 0-33.05-13.68Q95-462.35 95-482.42t12.95-33.33Q120.9-529 141-529h324q19.1 0 32.55 14.18Q511-500.65 511-480.58t-12.95 32.83Q485.1-435 465-435H141Zm0-217q-20.1 0-33.05-13.68Q95-679.35 95-699.42t12.95-33.33Q120.9-746 141-746h438q19.1 0 32.55 14.18Q625-717.65 625-697.58t-12.95 32.83Q599.1-652 579-652H141Z"
  })
});
var menu_open_fill_default2 = SvgComponent294;

// ../../../node_modules/@material-symbols/svg-700/rounded/menu_open.svg
import * as React295 from "react";
import { jsx as jsx352 } from "react/jsx-runtime";
var SvgComponent295 = (props) => /* @__PURE__ */ jsx352("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx352("path", {
    d: "M141-215q-20.1 0-33.05-13.68Q95-242.35 95-262.42t12.95-32.83Q120.9-308 141-308h438q19.1 0 32.55 13.68Q625-280.65 625-260.58t-12.95 32.83Q599.1-215 579-215H141Zm627-90L627-448q-14-14-14-33t14-33l139-143q14-15 33.5-15t34.5 15q14 14 14 32.5T835-592L728-481l108 112q13 14 12.5 32.5T834-304q-14 14-33 14t-33-15ZM141-435q-20.1 0-33.05-13.68Q95-462.35 95-482.42t12.95-33.33Q120.9-529 141-529h324q19.1 0 32.55 14.18Q511-500.65 511-480.58t-12.95 32.83Q485.1-435 465-435H141Zm0-217q-20.1 0-33.05-13.68Q95-679.35 95-699.42t12.95-33.33Q120.9-746 141-746h438q19.1 0 32.55 14.18Q625-717.65 625-697.58t-12.95 32.83Q599.1-652 579-652H141Z"
  })
});
var menu_open_default2 = SvgComponent295;

// ../../../node_modules/@material-symbols/svg-700/sharp/menu_open-fill.svg
import * as React296 from "react";
import { jsx as jsx353 } from "react/jsx-runtime";
var SvgComponent296 = (props) => /* @__PURE__ */ jsx353("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx353("path", {
    d: "M95-215v-93h530v93H95Zm705-55L596-481l203-210 67 67-138 143 139 144-67 67ZM95-435v-94h416v94H95Zm0-217v-94h530v94H95Z"
  })
});
var menu_open_fill_default3 = SvgComponent296;

// ../../../node_modules/@material-symbols/svg-700/sharp/menu_open.svg
import * as React297 from "react";
import { jsx as jsx354 } from "react/jsx-runtime";
var SvgComponent297 = (props) => /* @__PURE__ */ jsx354("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx354("path", {
    d: "M95-215v-93h530v93H95Zm705-55L596-481l203-210 67 67-138 143 139 144-67 67ZM95-435v-94h416v94H95Zm0-217v-94h530v94H95Z"
  })
});
var menu_open_default3 = SvgComponent297;

// src/components/icon/variants/IconMenuOpen.tsx
import { useTranslation as useTranslation58 } from "react-i18next";
import { jsx as jsx355 } from "react/jsx-runtime";
var componentMap48 = {
  outlined: menu_open_default,
  "outlined-fill": menu_open_fill_default,
  rounded: menu_open_default2,
  "rounded-fill": menu_open_fill_default2,
  sharp: menu_open_default3,
  "sharp-fill": menu_open_fill_default3
};
var IconMenuOpen = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation58("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap48[key] ?? componentMap48[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx355(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/more_horiz-fill.svg
import * as React298 from "react";
import { jsx as jsx356 } from "react/jsx-runtime";
var SvgComponent298 = (props) => /* @__PURE__ */ jsx356("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx356("path", {
    d: "M184.78-421q-23.78 0-41.28-17.3T126-479.89Q126-505 143.37-522q17.38-17 41.77-17 23.46 0 41.66 16.89 18.2 16.9 18.2 41.5 0 24.61-18.22 42.11-18.21 17.5-42 17.5Zm295.83 0q-24.61 0-42.11-17.3T421-479.89Q421-505 438.3-522t41.59-17Q505-539 522-522.11q17 16.9 17 41.5 0 24.61-16.89 42.11-16.9 17.5-41.5 17.5Zm294.28 0q-24.82 0-42.35-17.3Q715-455.6 715-479.89 715-505 732.68-522q17.67-17 42.5-17 24.82 0 42.32 16.89 17.5 16.9 17.5 41.5 0 24.61-17.64 42.11T774.89-421Z"
  })
});
var more_horiz_fill_default = SvgComponent298;

// ../../../node_modules/@material-symbols/svg-700/outlined/more_horiz.svg
import * as React299 from "react";
import { jsx as jsx357 } from "react/jsx-runtime";
var SvgComponent299 = (props) => /* @__PURE__ */ jsx357("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx357("path", {
    d: "M184.78-421q-23.78 0-41.28-17.3T126-479.89Q126-505 143.37-522q17.38-17 41.77-17 23.46 0 41.66 16.89 18.2 16.9 18.2 41.5 0 24.61-18.22 42.11-18.21 17.5-42 17.5Zm295.83 0q-24.61 0-42.11-17.3T421-479.89Q421-505 438.3-522t41.59-17Q505-539 522-522.11q17 16.9 17 41.5 0 24.61-16.89 42.11-16.9 17.5-41.5 17.5Zm294.28 0q-24.82 0-42.35-17.3Q715-455.6 715-479.89 715-505 732.68-522q17.67-17 42.5-17 24.82 0 42.32 16.89 17.5 16.9 17.5 41.5 0 24.61-17.64 42.11T774.89-421Z"
  })
});
var more_horiz_default = SvgComponent299;

// ../../../node_modules/@material-symbols/svg-700/rounded/more_horiz-fill.svg
import * as React300 from "react";
import { jsx as jsx358 } from "react/jsx-runtime";
var SvgComponent300 = (props) => /* @__PURE__ */ jsx358("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx358("path", {
    d: "M184.78-421q-23.78 0-41.28-17.3T126-479.89Q126-505 143.37-522q17.38-17 41.77-17 23.46 0 41.66 16.89 18.2 16.9 18.2 41.5 0 24.61-18.22 42.11-18.21 17.5-42 17.5Zm295.83 0q-24.61 0-42.11-17.3T421-479.89Q421-505 438.3-522t41.59-17Q505-539 522-522.11q17 16.9 17 41.5 0 24.61-16.89 42.11-16.9 17.5-41.5 17.5Zm294.28 0q-24.82 0-42.35-17.3Q715-455.6 715-479.89 715-505 732.68-522q17.67-17 42.5-17 24.82 0 42.32 16.89 17.5 16.9 17.5 41.5 0 24.61-17.64 42.11T774.89-421Z"
  })
});
var more_horiz_fill_default2 = SvgComponent300;

// ../../../node_modules/@material-symbols/svg-700/rounded/more_horiz.svg
import * as React301 from "react";
import { jsx as jsx359 } from "react/jsx-runtime";
var SvgComponent301 = (props) => /* @__PURE__ */ jsx359("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx359("path", {
    d: "M184.78-421q-23.78 0-41.28-17.3T126-479.89Q126-505 143.37-522q17.38-17 41.77-17 23.46 0 41.66 16.89 18.2 16.9 18.2 41.5 0 24.61-18.22 42.11-18.21 17.5-42 17.5Zm295.83 0q-24.61 0-42.11-17.3T421-479.89Q421-505 438.3-522t41.59-17Q505-539 522-522.11q17 16.9 17 41.5 0 24.61-16.89 42.11-16.9 17.5-41.5 17.5Zm294.28 0q-24.82 0-42.35-17.3Q715-455.6 715-479.89 715-505 732.68-522q17.67-17 42.5-17 24.82 0 42.32 16.89 17.5 16.9 17.5 41.5 0 24.61-17.64 42.11T774.89-421Z"
  })
});
var more_horiz_default2 = SvgComponent301;

// ../../../node_modules/@material-symbols/svg-700/sharp/more_horiz-fill.svg
import * as React302 from "react";
import { jsx as jsx360 } from "react/jsx-runtime";
var SvgComponent302 = (props) => /* @__PURE__ */ jsx360("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx360("path", {
    d: "M184.78-421q-23.78 0-41.28-17.3T126-479.89Q126-505 143.37-522q17.38-17 41.77-17 23.46 0 41.66 16.89 18.2 16.9 18.2 41.5 0 24.61-18.22 42.11-18.21 17.5-42 17.5Zm295.83 0q-24.61 0-42.11-17.3T421-479.89Q421-505 438.3-522t41.59-17Q505-539 522-522.11q17 16.9 17 41.5 0 24.61-16.89 42.11-16.9 17.5-41.5 17.5Zm294.28 0q-24.82 0-42.35-17.3Q715-455.6 715-479.89 715-505 732.68-522q17.67-17 42.5-17 24.82 0 42.32 16.89 17.5 16.9 17.5 41.5 0 24.61-17.64 42.11T774.89-421Z"
  })
});
var more_horiz_fill_default3 = SvgComponent302;

// ../../../node_modules/@material-symbols/svg-700/sharp/more_horiz.svg
import * as React303 from "react";
import { jsx as jsx361 } from "react/jsx-runtime";
var SvgComponent303 = (props) => /* @__PURE__ */ jsx361("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx361("path", {
    d: "M184.78-421q-23.78 0-41.28-17.3T126-479.89Q126-505 143.37-522q17.38-17 41.77-17 23.46 0 41.66 16.89 18.2 16.9 18.2 41.5 0 24.61-18.22 42.11-18.21 17.5-42 17.5Zm295.83 0q-24.61 0-42.11-17.3T421-479.89Q421-505 438.3-522t41.59-17Q505-539 522-522.11q17 16.9 17 41.5 0 24.61-16.89 42.11-16.9 17.5-41.5 17.5Zm294.28 0q-24.82 0-42.35-17.3Q715-455.6 715-479.89 715-505 732.68-522q17.67-17 42.5-17 24.82 0 42.32 16.89 17.5 16.9 17.5 41.5 0 24.61-17.64 42.11T774.89-421Z"
  })
});
var more_horiz_default3 = SvgComponent303;

// src/components/icon/variants/IconMoreHoriz.tsx
import { useTranslation as useTranslation59 } from "react-i18next";
import { jsx as jsx362 } from "react/jsx-runtime";
var componentMap49 = {
  outlined: more_horiz_default,
  "outlined-fill": more_horiz_fill_default,
  rounded: more_horiz_default2,
  "rounded-fill": more_horiz_fill_default2,
  sharp: more_horiz_default3,
  "sharp-fill": more_horiz_fill_default3
};
var IconMoreHoriz = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation59("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap49[key] ?? componentMap49[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx362(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/more_vert-fill.svg
import * as React304 from "react";
import { jsx as jsx363 } from "react/jsx-runtime";
var SvgComponent304 = (props) => /* @__PURE__ */ jsx363("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx363("path", {
    d: "M480.61-126q-24.61 0-42.11-17.37-17.5-17.38-17.5-41.77 0-23.46 17.3-41.66 17.3-18.2 41.59-18.2Q505-245 522-226.78q17 18.21 17 42 0 23.78-16.89 41.28-16.9 17.5-41.5 17.5Zm0-295q-24.61 0-42.11-17.3T421-479.89Q421-505 438.3-522t41.59-17Q505-539 522-522.11q17 16.9 17 41.5 0 24.61-16.89 42.11-16.9 17.5-41.5 17.5Zm0-294q-24.61 0-42.11-17.68-17.5-17.67-17.5-42.5 0-24.82 17.3-42.32t41.59-17.5Q505-835 522-817.36t17 42.47q0 24.82-16.89 42.35-16.9 17.54-41.5 17.54Z"
  })
});
var more_vert_fill_default = SvgComponent304;

// ../../../node_modules/@material-symbols/svg-700/outlined/more_vert.svg
import * as React305 from "react";
import { jsx as jsx364 } from "react/jsx-runtime";
var SvgComponent305 = (props) => /* @__PURE__ */ jsx364("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx364("path", {
    d: "M480.61-126q-24.61 0-42.11-17.37-17.5-17.38-17.5-41.77 0-23.46 17.3-41.66 17.3-18.2 41.59-18.2Q505-245 522-226.78q17 18.21 17 42 0 23.78-16.89 41.28-16.9 17.5-41.5 17.5Zm0-295q-24.61 0-42.11-17.3T421-479.89Q421-505 438.3-522t41.59-17Q505-539 522-522.11q17 16.9 17 41.5 0 24.61-16.89 42.11-16.9 17.5-41.5 17.5Zm0-294q-24.61 0-42.11-17.68-17.5-17.67-17.5-42.5 0-24.82 17.3-42.32t41.59-17.5Q505-835 522-817.36t17 42.47q0 24.82-16.89 42.35-16.9 17.54-41.5 17.54Z"
  })
});
var more_vert_default = SvgComponent305;

// ../../../node_modules/@material-symbols/svg-700/rounded/more_vert-fill.svg
import * as React306 from "react";
import { jsx as jsx365 } from "react/jsx-runtime";
var SvgComponent306 = (props) => /* @__PURE__ */ jsx365("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx365("path", {
    d: "M480.61-126q-24.61 0-42.11-17.37-17.5-17.38-17.5-41.77 0-23.46 17.3-41.66 17.3-18.2 41.59-18.2Q505-245 522-226.78q17 18.21 17 42 0 23.78-16.89 41.28-16.9 17.5-41.5 17.5Zm0-295q-24.61 0-42.11-17.3T421-479.89Q421-505 438.3-522t41.59-17Q505-539 522-522.11q17 16.9 17 41.5 0 24.61-16.89 42.11-16.9 17.5-41.5 17.5Zm0-294q-24.61 0-42.11-17.68-17.5-17.67-17.5-42.5 0-24.82 17.3-42.32t41.59-17.5Q505-835 522-817.36t17 42.47q0 24.82-16.89 42.35-16.9 17.54-41.5 17.54Z"
  })
});
var more_vert_fill_default2 = SvgComponent306;

// ../../../node_modules/@material-symbols/svg-700/rounded/more_vert.svg
import * as React307 from "react";
import { jsx as jsx366 } from "react/jsx-runtime";
var SvgComponent307 = (props) => /* @__PURE__ */ jsx366("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx366("path", {
    d: "M480.61-126q-24.61 0-42.11-17.37-17.5-17.38-17.5-41.77 0-23.46 17.3-41.66 17.3-18.2 41.59-18.2Q505-245 522-226.78q17 18.21 17 42 0 23.78-16.89 41.28-16.9 17.5-41.5 17.5Zm0-295q-24.61 0-42.11-17.3T421-479.89Q421-505 438.3-522t41.59-17Q505-539 522-522.11q17 16.9 17 41.5 0 24.61-16.89 42.11-16.9 17.5-41.5 17.5Zm0-294q-24.61 0-42.11-17.68-17.5-17.67-17.5-42.5 0-24.82 17.3-42.32t41.59-17.5Q505-835 522-817.36t17 42.47q0 24.82-16.89 42.35-16.9 17.54-41.5 17.54Z"
  })
});
var more_vert_default2 = SvgComponent307;

// ../../../node_modules/@material-symbols/svg-700/sharp/more_vert-fill.svg
import * as React308 from "react";
import { jsx as jsx367 } from "react/jsx-runtime";
var SvgComponent308 = (props) => /* @__PURE__ */ jsx367("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx367("path", {
    d: "M480.61-126q-24.61 0-42.11-17.37-17.5-17.38-17.5-41.77 0-23.46 17.3-41.66 17.3-18.2 41.59-18.2Q505-245 522-226.78q17 18.21 17 42 0 23.78-16.89 41.28-16.9 17.5-41.5 17.5Zm0-295q-24.61 0-42.11-17.3T421-479.89Q421-505 438.3-522t41.59-17Q505-539 522-522.11q17 16.9 17 41.5 0 24.61-16.89 42.11-16.9 17.5-41.5 17.5Zm0-294q-24.61 0-42.11-17.68-17.5-17.67-17.5-42.5 0-24.82 17.3-42.32t41.59-17.5Q505-835 522-817.36t17 42.47q0 24.82-16.89 42.35-16.9 17.54-41.5 17.54Z"
  })
});
var more_vert_fill_default3 = SvgComponent308;

// ../../../node_modules/@material-symbols/svg-700/sharp/more_vert.svg
import * as React309 from "react";
import { jsx as jsx368 } from "react/jsx-runtime";
var SvgComponent309 = (props) => /* @__PURE__ */ jsx368("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx368("path", {
    d: "M480.61-126q-24.61 0-42.11-17.37-17.5-17.38-17.5-41.77 0-23.46 17.3-41.66 17.3-18.2 41.59-18.2Q505-245 522-226.78q17 18.21 17 42 0 23.78-16.89 41.28-16.9 17.5-41.5 17.5Zm0-295q-24.61 0-42.11-17.3T421-479.89Q421-505 438.3-522t41.59-17Q505-539 522-522.11q17 16.9 17 41.5 0 24.61-16.89 42.11-16.9 17.5-41.5 17.5Zm0-294q-24.61 0-42.11-17.68-17.5-17.67-17.5-42.5 0-24.82 17.3-42.32t41.59-17.5Q505-835 522-817.36t17 42.47q0 24.82-16.89 42.35-16.9 17.54-41.5 17.54Z"
  })
});
var more_vert_default3 = SvgComponent309;

// src/components/icon/variants/IconMoreVert.tsx
import { useTranslation as useTranslation60 } from "react-i18next";
import { jsx as jsx369 } from "react/jsx-runtime";
var componentMap50 = {
  outlined: more_vert_default,
  "outlined-fill": more_vert_fill_default,
  rounded: more_vert_default2,
  "rounded-fill": more_vert_fill_default2,
  sharp: more_vert_default3,
  "sharp-fill": more_vert_fill_default3
};
var IconMoreVert = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation60("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap50[key] ?? componentMap50[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx369(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/my_location-fill.svg
import * as React310 from "react";
import { jsx as jsx370 } from "react/jsx-runtime";
var SvgComponent310 = (props) => /* @__PURE__ */ jsx370("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx370("path", {
    d: "M439-18v-75q-139-15-235.5-111.5T93-439H18v-82h75q15-139 111.5-235.5T439-867v-75h82v75q138 14 234.5 110.5T867-521h75v82h-75q-14 138-110.5 234.5T521-93v75h-82Zm40.83-167Q602-185 688.5-271.33q86.5-86.33 86.5-208.5T688.67-688.5Q602.34-775 480.17-775T271.5-688.67Q185-602.34 185-480.17t86.33 208.67q86.33 86.5 208.5 86.5Zm.17-145q-63 0-106.5-43.5T330-480q0-63 43.5-106.5T480-630q63 0 106.5 43.5T630-480q0 63-43.5 106.5T480-330Z"
  })
});
var my_location_fill_default = SvgComponent310;

// ../../../node_modules/@material-symbols/svg-700/outlined/my_location.svg
import * as React311 from "react";
import { jsx as jsx371 } from "react/jsx-runtime";
var SvgComponent311 = (props) => /* @__PURE__ */ jsx371("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx371("path", {
    d: "M439-18v-75q-139-15-235.5-111.5T93-439H18v-82h75q15-139 111.5-235.5T439-867v-75h82v75q138 14 234.5 110.5T867-521h75v82h-75q-14 138-110.5 234.5T521-93v75h-82Zm40.83-167Q602-185 688.5-271.33q86.5-86.33 86.5-208.5T688.67-688.5Q602.34-775 480.17-775T271.5-688.67Q185-602.34 185-480.17t86.33 208.67q86.33 86.5 208.5 86.5Zm.17-145q-63 0-106.5-43.5T330-480q0-63 43.5-106.5T480-630q63 0 106.5 43.5T630-480q0 63-43.5 106.5T480-330Zm-.36-83q28.36 0 47.86-19.14 19.5-19.13 19.5-47.5 0-28.36-19.14-47.86-19.13-19.5-47.5-19.5-28.36 0-47.86 19.14-19.5 19.13-19.5 47.5 0 28.36 19.14 47.86 19.13 19.5 47.5 19.5Zm.36-67Z"
  })
});
var my_location_default = SvgComponent311;

// ../../../node_modules/@material-symbols/svg-700/rounded/my_location-fill.svg
import * as React312 from "react";
import { jsx as jsx372 } from "react/jsx-runtime";
var SvgComponent312 = (props) => /* @__PURE__ */ jsx372("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx372("path", {
    d: "M439-59v-34q-139-15-235.5-111.5T93-439H59q-17.43 0-29.21-11.78Q18-462.55 18-479.96q0-17.42 11.79-29.23Q41.57-521 59-521h34q15-139 111.5-235.5T439-867v-34q0-17.42 11.78-29.21Q462.55-942 479.96-942q17.42 0 29.23 11.79Q521-918.42 521-901v34q138 14 234.5 110.5T867-521h34q17.42 0 29.21 11.78Q942-497.45 942-480.04t-11.79 29.23Q918.42-439 901-439h-34q-14 138-110.5 234.5T521-93v34q0 17.43-11.78 29.21Q497.45-18 480.04-18t-29.23-11.79Q439-41.57 439-59Zm40.83-126Q602-185 688.5-271.33q86.5-86.33 86.5-208.5T688.67-688.5Q602.34-775 480.17-775T271.5-688.67Q185-602.34 185-480.17t86.33 208.67q86.33 86.5 208.5 86.5Zm.17-145q-63 0-106.5-43.5T330-480q0-63 43.5-106.5T480-630q63 0 106.5 43.5T630-480q0 63-43.5 106.5T480-330Z"
  })
});
var my_location_fill_default2 = SvgComponent312;

// ../../../node_modules/@material-symbols/svg-700/rounded/my_location.svg
import * as React313 from "react";
import { jsx as jsx373 } from "react/jsx-runtime";
var SvgComponent313 = (props) => /* @__PURE__ */ jsx373("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx373("path", {
    d: "M439-59v-34q-139-15-235.5-111.5T93-439H59q-17.43 0-29.21-11.78Q18-462.55 18-479.96q0-17.42 11.79-29.23Q41.57-521 59-521h34q15-139 111.5-235.5T439-867v-34q0-17.42 11.78-29.21Q462.55-942 479.96-942q17.42 0 29.23 11.79Q521-918.42 521-901v34q138 14 234.5 110.5T867-521h34q17.42 0 29.21 11.78Q942-497.45 942-480.04t-11.79 29.23Q918.42-439 901-439h-34q-14 138-110.5 234.5T521-93v34q0 17.43-11.78 29.21Q497.45-18 480.04-18t-29.23-11.79Q439-41.57 439-59Zm40.83-126Q602-185 688.5-271.33q86.5-86.33 86.5-208.5T688.67-688.5Q602.34-775 480.17-775T271.5-688.67Q185-602.34 185-480.17t86.33 208.67q86.33 86.5 208.5 86.5Zm.17-145q-63 0-106.5-43.5T330-480q0-63 43.5-106.5T480-630q63 0 106.5 43.5T630-480q0 63-43.5 106.5T480-330Zm-.36-83q28.36 0 47.86-19.14 19.5-19.13 19.5-47.5 0-28.36-19.14-47.86-19.13-19.5-47.5-19.5-28.36 0-47.86 19.14-19.5 19.13-19.5 47.5 0 28.36 19.14 47.86 19.13 19.5 47.5 19.5Zm.36-67Z"
  })
});
var my_location_default2 = SvgComponent313;

// ../../../node_modules/@material-symbols/svg-700/sharp/my_location-fill.svg
import * as React314 from "react";
import { jsx as jsx374 } from "react/jsx-runtime";
var SvgComponent314 = (props) => /* @__PURE__ */ jsx374("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx374("path", {
    d: "M439-18v-75q-139-15-235.5-111.5T93-439H18v-82h75q15-139 111.5-235.5T439-867v-75h82v75q138 14 234.5 110.5T867-521h75v82h-75q-14 138-110.5 234.5T521-93v75h-82Zm40.83-167Q602-185 688.5-271.33q86.5-86.33 86.5-208.5T688.67-688.5Q602.34-775 480.17-775T271.5-688.67Q185-602.34 185-480.17t86.33 208.67q86.33 86.5 208.5 86.5Zm.17-145q-63 0-106.5-43.5T330-480q0-63 43.5-106.5T480-630q63 0 106.5 43.5T630-480q0 63-43.5 106.5T480-330Z"
  })
});
var my_location_fill_default3 = SvgComponent314;

// ../../../node_modules/@material-symbols/svg-700/sharp/my_location.svg
import * as React315 from "react";
import { jsx as jsx375 } from "react/jsx-runtime";
var SvgComponent315 = (props) => /* @__PURE__ */ jsx375("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx375("path", {
    d: "M439-18v-75q-139-15-235.5-111.5T93-439H18v-82h75q15-139 111.5-235.5T439-867v-75h82v75q138 14 234.5 110.5T867-521h75v82h-75q-14 138-110.5 234.5T521-93v75h-82Zm40.83-167Q602-185 688.5-271.33q86.5-86.33 86.5-208.5T688.67-688.5Q602.34-775 480.17-775T271.5-688.67Q185-602.34 185-480.17t86.33 208.67q86.33 86.5 208.5 86.5Zm.17-145q-63 0-106.5-43.5T330-480q0-63 43.5-106.5T480-630q63 0 106.5 43.5T630-480q0 63-43.5 106.5T480-330Zm-.36-83q28.36 0 47.86-19.14 19.5-19.13 19.5-47.5 0-28.36-19.14-47.86-19.13-19.5-47.5-19.5-28.36 0-47.86 19.14-19.5 19.13-19.5 47.5 0 28.36 19.14 47.86 19.13 19.5 47.5 19.5Zm.36-67Z"
  })
});
var my_location_default3 = SvgComponent315;

// src/components/icon/variants/IconMyLocation.tsx
import { useTranslation as useTranslation61 } from "react-i18next";
import { jsx as jsx376 } from "react/jsx-runtime";
var componentMap51 = {
  outlined: my_location_default,
  "outlined-fill": my_location_fill_default,
  rounded: my_location_default2,
  "rounded-fill": my_location_fill_default2,
  sharp: my_location_default3,
  "sharp-fill": my_location_fill_default3
};
var IconMyLocation = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation61("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap51[key] ?? componentMap51[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx376(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/nest_clock_farsight_analog-fill.svg
import * as React316 from "react";
import { jsx as jsx377 } from "react/jsx-runtime";
var SvgComponent316 = (props) => /* @__PURE__ */ jsx377("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx377("path", {
    d: "m585-285 66-68-124-123.59V-651h-94v214l152 152ZM433-726h94v-124h-94v124Zm293 293h124v-94H726v94ZM433-110h94v-125h-94v125ZM110-433h125v-94H110v94ZM480.4-55q-88.87 0-166.12-33.08-77.25-33.09-135.18-91.02-57.93-57.93-91.02-135.12Q55-391.41 55-480.36q0-88.96 33.08-166.29 33.09-77.32 90.86-134.81 57.77-57.48 135.03-91.01Q391.24-906 480.28-906t166.49 33.45q77.44 33.46 134.85 90.81t90.89 134.87Q906-569.34 906-480.27q0 89.01-33.53 166.25t-91.01 134.86q-57.49 57.62-134.83 90.89Q569.28-55 480.4-55Z"
  })
});
var nest_clock_farsight_analog_fill_default = SvgComponent316;

// ../../../node_modules/@material-symbols/svg-700/outlined/nest_clock_farsight_analog.svg
import * as React317 from "react";
import { jsx as jsx378 } from "react/jsx-runtime";
var SvgComponent317 = (props) => /* @__PURE__ */ jsx378("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx378("path", {
    d: "M585-285 433-437v-214h94v174.41L651-353l-66 68ZM433-726v-124h94v124h-94Zm293 293v-94h124v94H726ZM433-110v-125h94v125h-94ZM110-433v-94h125v94H110ZM480.4-55q-88.87 0-166.12-33.08-77.25-33.09-135.18-91.02-57.93-57.93-91.02-135.12Q55-391.41 55-480.36q0-88.96 33.08-166.29 33.09-77.32 90.86-134.81 57.77-57.48 135.03-91.01Q391.24-906 480.28-906t166.49 33.45q77.44 33.46 134.85 90.81t90.89 134.87Q906-569.34 906-480.27q0 89.01-33.53 166.25t-91.01 134.86q-57.49 57.62-134.83 90.89Q569.28-55 480.4-55Zm.1-94q137.5 0 234-96.37T811-480.5q0-137.5-96.31-234T479.5-811q-137.5 0-234 96.31T149-479.5q0 137.5 96.37 234T480.5-149Zm-.5-331Z"
  })
});
var nest_clock_farsight_analog_default = SvgComponent317;

// ../../../node_modules/@material-symbols/svg-700/rounded/nest_clock_farsight_analog-fill.svg
import * as React318 from "react";
import { jsx as jsx379 } from "react/jsx-runtime";
var SvgComponent318 = (props) => /* @__PURE__ */ jsx379("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx379("path", {
    d: "M527-477v-126q0-19.63-13.68-33.81Q499.65-651 479.82-651q-19.82 0-33.32 14.19Q433-622.63 433-603v148q0 8.57 3 16.64T446-423l105 104q14.07 14 33.53 14 19.47 0 33.86-14.84Q632-333.48 632-352.24 632-371 618-386l-91-91Zm-46.82-249q19.82 0 33.32-13.63Q527-753.25 527-773v-30q0-19.75-13.68-33.38Q499.65-850 479.82-850q-19.82 0-33.32 13.62Q433-822.75 433-803v30q0 19.75 13.68 33.37Q460.35-726 480.18-726ZM726-479.82q0 19.82 13.63 33.32Q753.25-433 773-433h30q19.75 0 33.38-13.68Q850-460.35 850-480.18q0-19.82-13.62-33.32Q822.75-527 803-527h-30q-19.75 0-33.37 13.68Q726-499.65 726-479.82ZM479.82-235q-19.82 0-33.32 14.21-13.5 14.22-13.5 33.88v30q0 19.66 13.68 33.28Q460.35-110 480.18-110q19.82 0 33.32-13.63 13.5-13.62 13.5-33.28v-30q0-19.66-13.68-33.88Q499.65-235 479.82-235ZM235-480.18q0-19.82-14.21-33.32-14.22-13.5-33.88-13.5h-30q-19.66 0-33.28 13.68Q110-499.65 110-479.82q0 19.82 13.63 33.32 13.62 13.5 33.28 13.5h30q19.66 0 33.88-13.68Q235-460.35 235-480.18ZM480.4-55q-88.87 0-166.12-33.08-77.25-33.09-135.18-91.02-57.93-57.93-91.02-135.12Q55-391.41 55-480.36q0-88.96 33.08-166.29 33.09-77.32 90.86-134.81 57.77-57.48 135.03-91.01Q391.24-906 480.28-906t166.49 33.45q77.44 33.46 134.85 90.81t90.89 134.87Q906-569.34 906-480.27q0 89.01-33.53 166.25t-91.01 134.86q-57.49 57.62-134.83 90.89Q569.28-55 480.4-55Z"
  })
});
var nest_clock_farsight_analog_fill_default2 = SvgComponent318;

// ../../../node_modules/@material-symbols/svg-700/rounded/nest_clock_farsight_analog.svg
import * as React319 from "react";
import { jsx as jsx380 } from "react/jsx-runtime";
var SvgComponent319 = (props) => /* @__PURE__ */ jsx380("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx380("path", {
    d: "m527-477 91 91q14 14.5 14 33.57 0 19.08-13.61 32.59Q604-305 584.53-305q-19.46 0-33.53-14L446-423q-7-7.29-10-15.36T433-455v-148q0-19.63 13.68-33.81Q460.35-651 480.18-651q19.82 0 33.32 14.19Q527-622.63 527-603v126Zm-47.18-249q-19.82 0-33.32-13.63-13.5-13.62-13.5-32.98V-850h94v77.39q0 19.36-13.68 32.98Q499.65-726 479.82-726ZM726-480.18q0-19.82 13.63-33.32 13.62-13.5 32.98-13.5H850v94h-77.39q-19.36 0-32.98-13.68Q726-460.35 726-480.18ZM480.18-235q19.82 0 33.32 14.04Q527-206.91 527-187.5v77.5h-94v-77.39q0-19.36 13.68-33.49Q460.35-235 480.18-235ZM235-479.82q0 19.82-14.04 33.32Q206.91-433 187.5-433H110v-94h77.39q19.36 0 33.49 13.68Q235-499.65 235-479.82ZM480.4-55q-88.87 0-166.12-33.08-77.25-33.09-135.18-91.02-57.93-57.93-91.02-135.12Q55-391.41 55-480.36q0-88.96 33.08-166.29 33.09-77.32 90.86-134.81 57.77-57.48 135.03-91.01Q391.24-906 480.28-906t166.49 33.45q77.44 33.46 134.85 90.81t90.89 134.87Q906-569.34 906-480.27q0 89.01-33.53 166.25t-91.01 134.86q-57.49 57.62-134.83 90.89Q569.28-55 480.4-55ZM811-480.5q0-137.5-96.31-234T479.5-811q-137.5 0-234 96.31T149-479.5q0 137.5 96.37 234T480.5-149q137.5 0 234-96.37T811-480.5Zm-331 .5Z"
  })
});
var nest_clock_farsight_analog_default2 = SvgComponent319;

// ../../../node_modules/@material-symbols/svg-700/sharp/nest_clock_farsight_analog-fill.svg
import * as React320 from "react";
import { jsx as jsx381 } from "react/jsx-runtime";
var SvgComponent320 = (props) => /* @__PURE__ */ jsx381("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx381("path", {
    d: "m585-285 66-68-124-123.59V-651h-94v214l152 152ZM433-726h94v-124h-94v124Zm293 293h124v-94H726v94ZM433-110h94v-125h-94v125ZM110-433h125v-94H110v94ZM480.4-55q-88.87 0-166.12-33.08-77.25-33.09-135.18-91.02-57.93-57.93-91.02-135.12Q55-391.41 55-480.36q0-88.96 33.08-166.29 33.09-77.32 90.86-134.81 57.77-57.48 135.03-91.01Q391.24-906 480.28-906t166.49 33.45q77.44 33.46 134.85 90.81t90.89 134.87Q906-569.34 906-480.27q0 89.01-33.53 166.25t-91.01 134.86q-57.49 57.62-134.83 90.89Q569.28-55 480.4-55Z"
  })
});
var nest_clock_farsight_analog_fill_default3 = SvgComponent320;

// ../../../node_modules/@material-symbols/svg-700/sharp/nest_clock_farsight_analog.svg
import * as React321 from "react";
import { jsx as jsx382 } from "react/jsx-runtime";
var SvgComponent321 = (props) => /* @__PURE__ */ jsx382("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx382("path", {
    d: "M585-285 433-437v-214h94v174.41L651-353l-66 68ZM433-726v-124h94v124h-94Zm293 293v-94h124v94H726ZM433-110v-125h94v125h-94ZM110-433v-94h125v94H110ZM480.4-55q-88.87 0-166.12-33.08-77.25-33.09-135.18-91.02-57.93-57.93-91.02-135.12Q55-391.41 55-480.36q0-88.96 33.08-166.29 33.09-77.32 90.86-134.81 57.77-57.48 135.03-91.01Q391.24-906 480.28-906t166.49 33.45q77.44 33.46 134.85 90.81t90.89 134.87Q906-569.34 906-480.27q0 89.01-33.53 166.25t-91.01 134.86q-57.49 57.62-134.83 90.89Q569.28-55 480.4-55Zm.1-94q137.5 0 234-96.37T811-480.5q0-137.5-96.31-234T479.5-811q-137.5 0-234 96.31T149-479.5q0 137.5 96.37 234T480.5-149Zm-.5-331Z"
  })
});
var nest_clock_farsight_analog_default3 = SvgComponent321;

// src/components/icon/variants/IconNestClockFarsightAnalog.tsx
import { useTranslation as useTranslation62 } from "react-i18next";
import { jsx as jsx383 } from "react/jsx-runtime";
var componentMap52 = {
  outlined: nest_clock_farsight_analog_default,
  "outlined-fill": nest_clock_farsight_analog_fill_default,
  rounded: nest_clock_farsight_analog_default2,
  "rounded-fill": nest_clock_farsight_analog_fill_default2,
  sharp: nest_clock_farsight_analog_default3,
  "sharp-fill": nest_clock_farsight_analog_fill_default3
};
var IconNestClockFarsightAnalog = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation62("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap52[key] ?? componentMap52[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx383(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/note_alt-fill.svg
import * as React322 from "react";
import { jsx as jsx384 } from "react/jsx-runtime";
var SvgComponent322 = (props) => /* @__PURE__ */ jsx384("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx384("path", {
    d: "M287-290h60l256-256.27L544-607 287-349.73V-290Zm334-274 39-39q7-7 7.5-16t-7.5-16l-29-28q-7-8-15.36-7.5-8.37.5-15.64 7.5l-38 38 59 61ZM189-95q-39.03 0-66.51-27.49Q95-149.97 95-189v-582q0-39.44 27.49-67.22Q149.97-866 189-866h180q11-35 41-57.5t70-22.5q40 0 70 22.5t41 57.5h180q39.44 0 67.22 27.78T866-771v582q0 39.03-27.78 66.51Q810.44-95 771-95H189Zm291-696q17.47 0 29.23-11.77Q521-814.53 521-832t-11.77-29.23Q497.47-873 480-873t-29.23 11.77Q439-849.47 439-832t11.77 29.23Q462.53-791 480-791Z"
  })
});
var note_alt_fill_default = SvgComponent322;

// ../../../node_modules/@material-symbols/svg-700/outlined/note_alt.svg
import * as React323 from "react";
import { jsx as jsx385 } from "react/jsx-runtime";
var SvgComponent323 = (props) => /* @__PURE__ */ jsx385("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx385("path", {
    d: "M287-290h60l256-256.27L544-607 287-349.73V-290Zm334-274 39-39q7-7 7.5-16t-7.5-16l-29-28q-7-8-15.36-7.5-8.37.5-15.64 7.5l-38 38 59 61ZM189-95q-38.78 0-66.39-27.61T95-189v-582q0-39.19 27.61-67.09Q150.22-866 189-866h180q11-35 41-57.5t70-22.5q40 0 70 22.5t41 57.5h180q39.19 0 67.09 27.91Q866-810.19 866-771v582q0 38.78-27.91 66.39Q810.19-95 771-95H189Zm0-94h582v-582H189v582Zm291-602q17.47 0 29.23-11.77Q521-814.53 521-832t-11.77-29.23Q497.47-873 480-873t-29.23 11.77Q439-849.47 439-832t11.77 29.23Q462.53-791 480-791ZM189-189v-582 582Z"
  })
});
var note_alt_default = SvgComponent323;

// ../../../node_modules/@material-symbols/svg-700/rounded/note_alt-fill.svg
import * as React324 from "react";
import { jsx as jsx386 } from "react/jsx-runtime";
var SvgComponent324 = (props) => /* @__PURE__ */ jsx386("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx386("path", {
    d: "M189-95q-38.98 0-66.49-27.51Q95-150.02 95-189v-582q0-38.97 27.51-66.99Q150.02-866 189-866h180q11-35 41-57.5t70-22.5q40 0 70 22.5t41 57.5h180q38.97 0 66.99 28.01Q866-809.97 866-771v582q0 38.98-28.01 66.49Q809.97-95 771-95H189Zm291-696q17.47 0 29.23-11.77Q521-814.53 521-832t-11.77-29.23Q497.47-873 480-873t-29.23 11.77Q439-849.47 439-832t11.77 29.23Q462.53-791 480-791ZM311-290h16q10 0 18-3t15-10l243-243-59-61-244 244q-7 6.86-10 14.93T287-331v18q0 9 7.1 16t16.9 7Zm310-274 39-39q7-7 7.5-16t-7.5-16l-29-28q-7-8-15.5-7.5T600-663l-38 38 59 61Z"
  })
});
var note_alt_fill_default2 = SvgComponent324;

// ../../../node_modules/@material-symbols/svg-700/rounded/note_alt.svg
import * as React325 from "react";
import { jsx as jsx387 } from "react/jsx-runtime";
var SvgComponent325 = (props) => /* @__PURE__ */ jsx387("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx387("path", {
    d: "M189-95q-38.78 0-66.39-27.61T95-189v-582q0-39.19 27.61-67.09Q150.22-866 189-866h180q11-35 41-57.5t70-22.5q40 0 70 22.5t41 57.5h180q39.19 0 67.09 27.91Q866-810.19 866-771v582q0 38.78-27.91 66.39Q810.19-95 771-95H189Zm0-94h582v-582H189v582Zm291-602q17.47 0 29.23-11.77Q521-814.53 521-832t-11.77-29.23Q497.47-873 480-873t-29.23 11.77Q439-849.47 439-832t11.77 29.23Q462.53-791 480-791ZM189-189v-582 582Zm122-101h16.13q9.82 0 17.85-3 8.02-3 15.02-10l243-242.72L544-607 300-363q-7 7.29-10 15.3-3 8.01-3 16.51v18.69q0 8.5 7.2 15.5t16.8 7Zm310-274 39-39q7-7 7.5-16t-7.5-16l-29-28q-7-8-15.36-7.5-8.37.5-15.64 7.5l-38 38 59 61Z"
  })
});
var note_alt_default2 = SvgComponent325;

// ../../../node_modules/@material-symbols/svg-700/sharp/note_alt-fill.svg
import * as React326 from "react";
import { jsx as jsx388 } from "react/jsx-runtime";
var SvgComponent326 = (props) => /* @__PURE__ */ jsx388("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx388("path", {
    d: "M287-290h60l256-256.27L544-607 287-349.73V-290Zm334-274 55-55-61-59-53 53 59 61ZM95-95v-771h274q11-35 41-57.5t70-22.5q40 0 70 22.5t41 57.5h275v771H95Zm385-696q17.47 0 29.23-11.77Q521-814.53 521-832t-11.77-29.23Q497.47-873 480-873t-29.23 11.77Q439-849.47 439-832t11.77 29.23Q462.53-791 480-791Z"
  })
});
var note_alt_fill_default3 = SvgComponent326;

// ../../../node_modules/@material-symbols/svg-700/sharp/note_alt.svg
import * as React327 from "react";
import { jsx as jsx389 } from "react/jsx-runtime";
var SvgComponent327 = (props) => /* @__PURE__ */ jsx389("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx389("path", {
    d: "M287-290h60l256-256.27L544-607 287-349.73V-290Zm334-274 55-55-61-59-53 53 59 61ZM95-95v-771h274q11-35 41-57.5t70-22.5q40 0 70 22.5t41 57.5h275v771H95Zm94-94h582v-582H189v582Zm291-602q17.47 0 29.23-11.77Q521-814.53 521-832t-11.77-29.23Q497.47-873 480-873t-29.23 11.77Q439-849.47 439-832t11.77 29.23Q462.53-791 480-791ZM189-189v-582 582Z"
  })
});
var note_alt_default3 = SvgComponent327;

// src/components/icon/variants/IconNoteAlt.tsx
import { useTranslation as useTranslation63 } from "react-i18next";
import { jsx as jsx390 } from "react/jsx-runtime";
var componentMap53 = {
  outlined: note_alt_default,
  "outlined-fill": note_alt_fill_default,
  rounded: note_alt_default2,
  "rounded-fill": note_alt_fill_default2,
  sharp: note_alt_default3,
  "sharp-fill": note_alt_fill_default3
};
var IconNoteAlt = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation63("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap53[key] ?? componentMap53[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx390(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/numbers-fill.svg
import * as React328 from "react";
import { jsx as jsx391 } from "react/jsx-runtime";
var SvgComponent328 = (props) => /* @__PURE__ */ jsx391("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx391("path", {
    d: "m215-134 42-168H95l23-94h163l42-168H161l23-94h163l41-168h94l-41 168h168l41-168h94l-41 168h163l-24 94H680l-43 168h163l-24 94H614l-43 168h-94l42-168H352l-43 168h-94Zm160-262h168l42-168H418l-43 168Z"
  })
});
var numbers_fill_default = SvgComponent328;

// ../../../node_modules/@material-symbols/svg-700/outlined/numbers.svg
import * as React329 from "react";
import { jsx as jsx392 } from "react/jsx-runtime";
var SvgComponent329 = (props) => /* @__PURE__ */ jsx392("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx392("path", {
    d: "m215-134 42-168H95l23-94h163l42-168H161l23-94h163l41-168h94l-41 168h168l41-168h94l-41 168h163l-24 94H680l-43 168h163l-24 94H614l-43 168h-94l42-168H352l-43 168h-94Zm160-262h168l42-168H418l-43 168Z"
  })
});
var numbers_default = SvgComponent329;

// ../../../node_modules/@material-symbols/svg-700/rounded/numbers-fill.svg
import * as React330 from "react";
import { jsx as jsx393 } from "react/jsx-runtime";
var SvgComponent330 = (props) => /* @__PURE__ */ jsx393("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx393("path", {
    d: "m352-302-34 133q-4 15-16.5 25T274-134q-23 0-37-17.5t-8-40.5l28-110H154q-23 0-37-17.5t-8-40.5q4-15 16-25.5t29-10.5h127l42-168H220q-23 0-37-17.5t-8-40.5q4-15 16-25.5t29-10.5h127l32-133q4-15 16.5-25t27.5-10q23 0 36.5 17.5T468-769l-27 111h168l32-133q4-15 16.5-25t27.5-10q23 0 36.5 17.5T730-769l-27 111h103q23 0 37 17.5t8 40.5q-4 15-16 25.5T806-564H680l-43 168h103q23 0 37 17.5t8 40.5q-4 15-16 25.5T740-302H614l-34 133q-4 15-16.5 25T536-134q-23 0-37-17.5t-8-40.5l28-110H352Zm23-94h168l42-168H418l-43 168Z"
  })
});
var numbers_fill_default2 = SvgComponent330;

// ../../../node_modules/@material-symbols/svg-700/rounded/numbers.svg
import * as React331 from "react";
import { jsx as jsx394 } from "react/jsx-runtime";
var SvgComponent331 = (props) => /* @__PURE__ */ jsx394("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx394("path", {
    d: "m352-302-34 133q-4 15-16.5 25T274-134q-23 0-37-17.5t-8-40.5l28-110H154q-23 0-37-17.5t-8-40.5q4-15 16-25.5t29-10.5h127l42-168H220q-23 0-37-17.5t-8-40.5q4-15 16-25.5t29-10.5h127l32-133q4-15 16.5-25t27.5-10q23 0 36.5 17.5T468-769l-27 111h168l32-133q4-15 16.5-25t27.5-10q23 0 36.5 17.5T730-769l-27 111h103q23 0 37 17.5t8 40.5q-4 15-16 25.5T806-564H680l-43 168h103q23 0 37 17.5t8 40.5q-4 15-16 25.5T740-302H614l-34 133q-4 15-16.5 25T536-134q-23 0-37-17.5t-8-40.5l28-110H352Zm23-94h168l42-168H418l-43 168Z"
  })
});
var numbers_default2 = SvgComponent331;

// ../../../node_modules/@material-symbols/svg-700/sharp/numbers-fill.svg
import * as React332 from "react";
import { jsx as jsx395 } from "react/jsx-runtime";
var SvgComponent332 = (props) => /* @__PURE__ */ jsx395("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx395("path", {
    d: "m215-134 42-168H95l23-94h163l42-168H161l23-94h163l41-168h94l-41 168h168l41-168h94l-41 168h163l-24 94H680l-43 168h163l-24 94H614l-43 168h-94l42-168H352l-43 168h-94Zm160-262h168l42-168H418l-43 168Z"
  })
});
var numbers_fill_default3 = SvgComponent332;

// ../../../node_modules/@material-symbols/svg-700/sharp/numbers.svg
import * as React333 from "react";
import { jsx as jsx396 } from "react/jsx-runtime";
var SvgComponent333 = (props) => /* @__PURE__ */ jsx396("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx396("path", {
    d: "m215-134 42-168H95l23-94h163l42-168H161l23-94h163l41-168h94l-41 168h168l41-168h94l-41 168h163l-24 94H680l-43 168h163l-24 94H614l-43 168h-94l42-168H352l-43 168h-94Zm160-262h168l42-168H418l-43 168Z"
  })
});
var numbers_default3 = SvgComponent333;

// src/components/icon/variants/IconNumbers.tsx
import { useTranslation as useTranslation64 } from "react-i18next";
import { jsx as jsx397 } from "react/jsx-runtime";
var componentMap54 = {
  outlined: numbers_default,
  "outlined-fill": numbers_fill_default,
  rounded: numbers_default2,
  "rounded-fill": numbers_fill_default2,
  sharp: numbers_default3,
  "sharp-fill": numbers_fill_default3
};
var IconNumbers = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation64("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap54[key] ?? componentMap54[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx397(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/open_in_new-fill.svg
import * as React334 from "react";
import { jsx as jsx398 } from "react/jsx-runtime";
var SvgComponent334 = (props) => /* @__PURE__ */ jsx398("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx398("path", {
    d: "M189-95q-39.05 0-66.53-27.47Q95-149.95 95-189v-582q0-39.46 27.47-67.23Q149.95-866 189-866h270v95H189v582h582v-270h95v270q0 39.05-27.77 66.53Q810.46-95 771-95H189Zm216-244-65-66 366-366H519v-95h347v347h-95v-186L405-339Z"
  })
});
var open_in_new_fill_default = SvgComponent334;

// ../../../node_modules/@material-symbols/svg-700/outlined/open_in_new.svg
import * as React335 from "react";
import { jsx as jsx399 } from "react/jsx-runtime";
var SvgComponent335 = (props) => /* @__PURE__ */ jsx399("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx399("path", {
    d: "M189-95q-39.05 0-66.53-27.47Q95-149.95 95-189v-582q0-39.46 27.47-67.23Q149.95-866 189-866h270v95H189v582h582v-270h95v270q0 39.05-27.77 66.53Q810.46-95 771-95H189Zm216-244-65-66 366-366H519v-95h347v347h-95v-186L405-339Z"
  })
});
var open_in_new_default = SvgComponent335;

// ../../../node_modules/@material-symbols/svg-700/rounded/open_in_new-fill.svg
import * as React336 from "react";
import { jsx as jsx400 } from "react/jsx-runtime";
var SvgComponent336 = (props) => /* @__PURE__ */ jsx400("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx400("path", {
    d: "M189-95q-39.05 0-66.53-27.47Q95-149.95 95-189v-582q0-39.46 27.47-67.23Q149.95-866 189-866h223q19.75 0 33.38 14.26 13.62 14.27 13.62 34 0 19.74-13.62 33.24Q431.75-771 412-771H189v582h582v-223q0-19.75 13.68-33.38Q798.35-459 818.09-459q19.73 0 33.82 13.62Q866-431.75 866-412v223q0 39.05-27.77 66.53Q810.46-95 771-95H189Zm582-610L438-371q-14.78 14-32.89 13T373-373q-14-14-14-32.5t14-32.5l333-333H566q-19.75 0-33.37-13.68Q519-798.35 519-818.09q0-19.73 13.63-33.82Q546.25-866 566-866h252q19.63 0 33.81 14.19Q866-837.63 866-818v252q0 19.75-14.26 33.37-14.27 13.63-34 13.63-19.74 0-33.24-13.63Q771-546.25 771-566v-139Z"
  })
});
var open_in_new_fill_default2 = SvgComponent336;

// ../../../node_modules/@material-symbols/svg-700/rounded/open_in_new.svg
import * as React337 from "react";
import { jsx as jsx401 } from "react/jsx-runtime";
var SvgComponent337 = (props) => /* @__PURE__ */ jsx401("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx401("path", {
    d: "M189-95q-39.05 0-66.53-27.47Q95-149.95 95-189v-582q0-39.46 27.47-67.23Q149.95-866 189-866h223q19.75 0 33.38 14.26 13.62 14.27 13.62 34 0 19.74-13.62 33.24Q431.75-771 412-771H189v582h582v-223q0-19.75 13.68-33.38Q798.35-459 818.09-459q19.73 0 33.82 13.62Q866-431.75 866-412v223q0 39.05-27.77 66.53Q810.46-95 771-95H189Zm582-610L438-371q-14.78 14-32.89 13T373-373q-14-14-14-32.5t14-32.5l333-333H566q-19.75 0-33.37-13.68Q519-798.35 519-818.09q0-19.73 13.63-33.82Q546.25-866 566-866h252q19.63 0 33.81 14.19Q866-837.63 866-818v252q0 19.75-14.26 33.37-14.27 13.63-34 13.63-19.74 0-33.24-13.63Q771-546.25 771-566v-139Z"
  })
});
var open_in_new_default2 = SvgComponent337;

// ../../../node_modules/@material-symbols/svg-700/sharp/open_in_new-fill.svg
import * as React338 from "react";
import { jsx as jsx402 } from "react/jsx-runtime";
var SvgComponent338 = (props) => /* @__PURE__ */ jsx402("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx402("path", {
    d: "M95-95v-771h364v95H189v582h582v-270h95v364H95Zm310-244-65-66 366-366H519v-95h347v347h-95v-186L405-339Z"
  })
});
var open_in_new_fill_default3 = SvgComponent338;

// ../../../node_modules/@material-symbols/svg-700/sharp/open_in_new.svg
import * as React339 from "react";
import { jsx as jsx403 } from "react/jsx-runtime";
var SvgComponent339 = (props) => /* @__PURE__ */ jsx403("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx403("path", {
    d: "M95-95v-771h364v95H189v582h582v-270h95v364H95Zm310-244-65-66 366-366H519v-95h347v347h-95v-186L405-339Z"
  })
});
var open_in_new_default3 = SvgComponent339;

// src/components/icon/variants/IconOpenInNew.tsx
import { useTranslation as useTranslation65 } from "react-i18next";
import { jsx as jsx404 } from "react/jsx-runtime";
var componentMap55 = {
  outlined: open_in_new_default,
  "outlined-fill": open_in_new_fill_default,
  rounded: open_in_new_default2,
  "rounded-fill": open_in_new_fill_default2,
  sharp: open_in_new_default3,
  "sharp-fill": open_in_new_fill_default3
};
var IconOpenInNew = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation65("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap55[key] ?? componentMap55[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx404(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/paid-fill.svg
import * as React340 from "react";
import { jsx as jsx405 } from "react/jsx-runtime";
var SvgComponent340 = (props) => /* @__PURE__ */ jsx405("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx405("path", {
    d: "M445-193h67v-48q59-6 94-36.5t35-86.5q0-52-29.87-86.5Q581.27-485 509.67-514 453-538 428.5-557T404-606q0-26 20-41.5t54-15.5q29 0 51.5 14t37.5 44l59-27q-19.16-42.2-46.08-62.1Q553-714 514-720.06V-766h-67v46q-54 9-82 41.07t-28 76.54q0 52.39 33 83.89T472-460q57 24 79.5 45.05Q574-393.89 574-364q0 30-23 47.5T486.5-299q-38.5 0-67.5-22t-40-62l-62 21q20 51 53.5 80t74.5 39.35V-193Zm35.14 138Q392-55 314.5-88 237-121 179-179T88-314.36q-33-77.36-33-165.5Q55-569 88-646.5q33-77.5 90.84-135.05 57.85-57.56 135.28-91Q391.56-906 479.78-906q89.22 0 166.84 33.37t135.09 90.79q57.48 57.42 90.89 134.96Q906-569.34 906-480q0 88.28-33.45 165.76-33.44 77.48-91 135.36Q724-121 646.64-88q-77.36 33-166.5 33Z"
  })
});
var paid_fill_default = SvgComponent340;

// ../../../node_modules/@material-symbols/svg-700/outlined/paid.svg
import * as React341 from "react";
import { jsx as jsx406 } from "react/jsx-runtime";
var SvgComponent341 = (props) => /* @__PURE__ */ jsx406("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx406("path", {
    d: "M445-193h67v-48q59-6 94-36.5t35-86.5q0-52-29.87-86.5Q581.27-485 509.67-514 453-538 428.5-557T404-606q0-26 20-41.5t54-15.5q29 0 51.5 14t37.5 44l59-27q-19.16-42.2-46.08-62.1Q553-714 514-720.06V-766h-67v46q-54 9-82 41.07t-28 76.54q0 52.39 33 83.89T472-460q57 24 79.5 45.05Q574-393.89 574-364q0 30-23 47.5T486.5-299q-38.5 0-67.5-22t-40-62l-62 21q20 51 53.5 80t74.5 39.35V-193Zm35.14 138Q392-55 314.5-88 237-121 179-179T88-314.36q-33-77.36-33-165.5Q55-569 88-646.5q33-77.5 90.84-135.05 57.85-57.56 135.28-91Q391.56-906 479.78-906q89.22 0 166.84 33.37t135.09 90.79q57.48 57.42 90.89 134.96Q906-569.34 906-480q0 88.28-33.45 165.76-33.44 77.48-91 135.36Q724-121 646.64-88q-77.36 33-166.5 33Zm-.14-94q138 0 234.5-96.37T811-480q0-138-96.5-234.5t-235-96.5q-137.5 0-234 96.5t-96.5 235q0 137.5 96.37 234T480-149Zm0-331Z"
  })
});
var paid_default = SvgComponent341;

// ../../../node_modules/@material-symbols/svg-700/rounded/paid-fill.svg
import * as React342 from "react";
import { jsx as jsx407 } from "react/jsx-runtime";
var SvgComponent342 = (props) => /* @__PURE__ */ jsx407("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx407("path", {
    d: "M480.14-55Q392-55 314.5-88 237-121 179-179T88-314.36q-33-77.36-33-165.5Q55-569 88-646.5q33-77.5 90.84-135.05 57.85-57.56 135.28-91Q391.56-906 479.78-906q89.22 0 166.84 33.37t135.09 90.79q57.48 57.42 90.89 134.96Q906-569.34 906-480q0 88.28-33.45 165.76-33.44 77.48-91 135.36Q724-121 646.64-88q-77.36 33-166.5 33ZM479-193q13.2 0 23.1-8 9.9-8 9.9-24v-16q59-6 94-39.5t35-90.46q0-54.27-29.5-87.15Q582-491 509.55-514 448-535 426-555t-22-51.59q0-26.58 20-41.5Q444-663 478-663q24 0 42.5 8.5t33 27.5q9.5 11 22 12.5T599-620q13-8 15.5-20.5T609-665q-18-24-40.5-36.97Q546-714.94 514-720v-15q0-17-10.4-24t-22.6-7q-12.2 0-23.1 7-10.9 7-10.9 24v15q-54 9-82 40.57t-28 76.04Q337-551 365.5-520T472-460q61 23 81.5 41t20.5 48q0 30.03-23.5 51.02Q527-299 487-299q-31.63 0-57.65-14.5Q403.34-328 389-355q-7-11-17.5-16.5T349-373q-16 6-20 19.5t5 26.5q21 35 49 55.5t62 28.5v18q0 14 10.4 23t23.6 9Z"
  })
});
var paid_fill_default2 = SvgComponent342;

// ../../../node_modules/@material-symbols/svg-700/rounded/paid.svg
import * as React343 from "react";
import { jsx as jsx408 } from "react/jsx-runtime";
var SvgComponent343 = (props) => /* @__PURE__ */ jsx408("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx408("path", {
    d: "M480.14-55Q392-55 314.5-88 237-121 179-179T88-314.36q-33-77.36-33-165.5Q55-569 88-646.5q33-77.5 90.84-135.05 57.85-57.56 135.28-91Q391.56-906 479.78-906q89.22 0 166.84 33.37t135.09 90.79q57.48 57.42 90.89 134.96Q906-569.34 906-480q0 88.28-33.45 165.76-33.44 77.48-91 135.36Q724-121 646.64-88q-77.36 33-166.5 33Zm-.14-94q138 0 234.5-96.37T811-480q0-138-96.5-234.5t-235-96.5q-137.5 0-234 96.5t-96.5 235q0 137.5 96.37 234T480-149Zm0-331Zm-1 287q13.2 0 23.1-8 9.9-8 9.9-24v-16q59-6 94-39.5t35-90.46q0-54.27-29.5-87.15Q582-491 509.55-514 448-535 426-555t-22-51.59q0-26.58 20-41.5Q444-663 478-663q24 0 42.5 8.5t33 27.5q9.5 11 22 12.5T599-620q13-8 15.5-20.5T609-665q-18-24-40.5-36.97Q546-714.94 514-720v-15q0-17-10.4-24t-22.6-7q-12.2 0-23.1 7-10.9 7-10.9 24v15q-54 9-82 40.57t-28 76.04Q337-551 365.5-520T472-460q61 23 81.5 41t20.5 48q0 30.03-23.5 51.02Q527-299 487-299q-31.63 0-57.65-14.5Q403.34-328 389-355q-7-11-17.5-16.5T349-373q-16 6-20 19.5t5 26.5q21 35 49 55.5t62 28.5v18q0 14 10.4 23t23.6 9Z"
  })
});
var paid_default2 = SvgComponent343;

// ../../../node_modules/@material-symbols/svg-700/sharp/paid-fill.svg
import * as React344 from "react";
import { jsx as jsx409 } from "react/jsx-runtime";
var SvgComponent344 = (props) => /* @__PURE__ */ jsx409("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx409("path", {
    d: "M445-193h67v-48q59-6 94-36.5t35-86.5q0-52-29.87-86.5Q581.27-485 509.67-514 453-538 428.5-557T404-606q0-26 20-41.5t54-15.5q29 0 51.5 14t37.5 44l59-27q-19.16-42.2-46.08-62.1Q553-714 514-720.06V-766h-67v46q-54 9-82 41.07t-28 76.54q0 52.39 33 83.89T472-460q57 24 79.5 45.05Q574-393.89 574-364q0 30-23 47.5T486.5-299q-38.5 0-67.5-22t-40-62l-62 21q20 51 53.5 80t74.5 39.35V-193Zm35.14 138Q392-55 314.5-88 237-121 179-179T88-314.36q-33-77.36-33-165.5Q55-569 88-646.5q33-77.5 90.84-135.05 57.85-57.56 135.28-91Q391.56-906 479.78-906q89.22 0 166.84 33.37t135.09 90.79q57.48 57.42 90.89 134.96Q906-569.34 906-480q0 88.28-33.45 165.76-33.44 77.48-91 135.36Q724-121 646.64-88q-77.36 33-166.5 33Z"
  })
});
var paid_fill_default3 = SvgComponent344;

// ../../../node_modules/@material-symbols/svg-700/sharp/paid.svg
import * as React345 from "react";
import { jsx as jsx410 } from "react/jsx-runtime";
var SvgComponent345 = (props) => /* @__PURE__ */ jsx410("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx410("path", {
    d: "M445-193h67v-48q59-6 94-36.5t35-86.5q0-52-29.87-86.5Q581.27-485 509.67-514 453-538 428.5-557T404-606q0-26 20-41.5t54-15.5q29 0 51.5 14t37.5 44l59-27q-19.16-42.2-46.08-62.1Q553-714 514-720.06V-766h-67v46q-54 9-82 41.07t-28 76.54q0 52.39 33 83.89T472-460q57 24 79.5 45.05Q574-393.89 574-364q0 30-23 47.5T486.5-299q-38.5 0-67.5-22t-40-62l-62 21q20 51 53.5 80t74.5 39.35V-193Zm35.14 138Q392-55 314.5-88 237-121 179-179T88-314.36q-33-77.36-33-165.5Q55-569 88-646.5q33-77.5 90.84-135.05 57.85-57.56 135.28-91Q391.56-906 479.78-906q89.22 0 166.84 33.37t135.09 90.79q57.48 57.42 90.89 134.96Q906-569.34 906-480q0 88.28-33.45 165.76-33.44 77.48-91 135.36Q724-121 646.64-88q-77.36 33-166.5 33Zm-.14-94q138 0 234.5-96.37T811-480q0-138-96.5-234.5t-235-96.5q-137.5 0-234 96.5t-96.5 235q0 137.5 96.37 234T480-149Zm0-331Z"
  })
});
var paid_default3 = SvgComponent345;

// src/components/icon/variants/IconPaid.tsx
import { useTranslation as useTranslation66 } from "react-i18next";
import { jsx as jsx411 } from "react/jsx-runtime";
var componentMap56 = {
  outlined: paid_default,
  "outlined-fill": paid_fill_default,
  rounded: paid_default2,
  "rounded-fill": paid_fill_default2,
  sharp: paid_default3,
  "sharp-fill": paid_fill_default3
};
var IconPaid = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation66("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap56[key] ?? componentMap56[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx411(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/payments-fill.svg
import * as React346 from "react";
import { jsx as jsx412 } from "react/jsx-runtime";
var SvgComponent346 = (props) => /* @__PURE__ */ jsx412("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx412("path", {
    d: "M111-137q-38.78 0-66.39-27.61T17-231v-449h94v449h689v94H111Zm144-143q-39.73 0-67.36-27.64Q160-335.27 160-375v-376q0-39.19 27.64-67.09Q215.27-846 255-846h594q38.77 0 66.39 27.91Q943-790.19 943-751v376q0 39.73-27.61 67.36Q887.77-280 849-280H255Zm88-83q0-42-29-71t-71-29v100h100Zm417 0h100v-100q-42 0-71 29t-29 71Zm-209-80q50 0 85-35t35-85q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 50 35 85t85 35ZM243-663q42 0 71-29.5t29-70.5H243v100Zm617 0v-100H760q0 41 29 70.5t71 29.5Z"
  })
});
var payments_fill_default = SvgComponent346;

// ../../../node_modules/@material-symbols/svg-700/outlined/payments.svg
import * as React347 from "react";
import { jsx as jsx413 } from "react/jsx-runtime";
var SvgComponent347 = (props) => /* @__PURE__ */ jsx413("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx413("path", {
    d: "M551-443q-50 0-85-35t-35-85q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35ZM255-280q-39.73 0-67.36-27.64Q160-335.27 160-375v-376q0-39.19 27.64-67.09Q215.27-846 255-846h594q38.77 0 66.39 27.91Q943-790.19 943-751v376q0 39.73-27.61 67.36Q887.77-280 849-280H255Zm88-83h417q0-42 29-71t71-29v-200q-42 0-71-29.5T760-763H343q0 41-29 70.5T243-663v200q42 0 71 29t29 71Zm457 226H111q-38.78 0-66.39-27.61T17-231v-449h94v449h689v94ZM243-363v-400 400Z"
  })
});
var payments_default = SvgComponent347;

// ../../../node_modules/@material-symbols/svg-700/rounded/payments-fill.svg
import * as React348 from "react";
import { jsx as jsx414 } from "react/jsx-runtime";
var SvgComponent348 = (props) => /* @__PURE__ */ jsx414("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx414("path", {
    d: "M111-137q-38.78 0-66.39-27.61T17-231v-402q0-19.75 13.68-33.38Q44.35-680 64.18-680 84-680 97.5-666.38 111-652.75 111-633v402h642q19.75 0 33.38 13.68Q800-203.65 800-183.82q0 19.82-13.62 33.32Q772.75-137 753-137H111Zm144-143q-39.73 0-67.36-27.64Q160-335.27 160-375v-376q0-39.19 27.64-67.09Q215.27-846 255-846h594q38.77 0 66.39 27.91Q943-790.19 943-751v376q0 39.73-27.61 67.36Q887.77-280 849-280H255Zm88-83q0-42-29-71t-71-29v100h100Zm417 0h100v-100q-42 0-71 29t-29 71Zm-209-80q50 0 85-35t35-85q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 50 35 85t85 35ZM243-663q42 0 71-29.5t29-70.5H243v100Zm617 0v-100H760q0 41 29 70.5t71 29.5Z"
  })
});
var payments_fill_default2 = SvgComponent348;

// ../../../node_modules/@material-symbols/svg-700/rounded/payments.svg
import * as React349 from "react";
import { jsx as jsx415 } from "react/jsx-runtime";
var SvgComponent349 = (props) => /* @__PURE__ */ jsx415("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx415("path", {
    d: "M551-443q-50 0-85-35t-35-85q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35ZM255-280q-39.73 0-67.36-27.64Q160-335.27 160-375v-376q0-39.19 27.64-67.09Q215.27-846 255-846h594q38.77 0 66.39 27.91Q943-790.19 943-751v376q0 39.73-27.61 67.36Q887.77-280 849-280H255Zm88-83h417q0-42 29-71t71-29v-200q-42 0-71-29.5T760-763H343q0 41-29 70.5T243-663v200q42 0 71 29t29 71Zm410 226H111q-38.78 0-66.39-27.61T17-231v-402q0-19.75 13.68-33.38Q44.35-680 64.18-680 84-680 97.5-666.38 111-652.75 111-633v402h642q19.75 0 33.38 13.68Q800-203.65 800-183.82q0 19.82-13.62 33.32Q772.75-137 753-137ZM243-363v-400 400Z"
  })
});
var payments_default2 = SvgComponent349;

// ../../../node_modules/@material-symbols/svg-700/sharp/payments-fill.svg
import * as React350 from "react";
import { jsx as jsx416 } from "react/jsx-runtime";
var SvgComponent350 = (props) => /* @__PURE__ */ jsx416("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx416("path", {
    d: "M17-137v-543h94v449h689v94H17Zm143-143v-566h783v566H160Zm183-83q0-42-29-71t-71-29v100h100Zm417 0h100v-100q-42 0-71 29t-29 71Zm-209-80q50 0 85-35t35-85q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 50 35 85t85 35ZM243-663q42 0 71-29.5t29-70.5H243v100Zm617 0v-100H760q0 41 29 70.5t71 29.5Z"
  })
});
var payments_fill_default3 = SvgComponent350;

// ../../../node_modules/@material-symbols/svg-700/sharp/payments.svg
import * as React351 from "react";
import { jsx as jsx417 } from "react/jsx-runtime";
var SvgComponent351 = (props) => /* @__PURE__ */ jsx417("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx417("path", {
    d: "M551-443q-50 0-85-35t-35-85q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35ZM160-280v-566h783v566H160Zm183-83h417q0-42 29-71t71-29v-200q-42 0-71-29.5T760-763H343q0 41-29 70.5T243-663v200q42 0 71 29t29 71ZM17-137v-543h94v449h689v94H17Zm226-226v-400 400Z"
  })
});
var payments_default3 = SvgComponent351;

// src/components/icon/variants/IconPayments.tsx
import { jsx as jsx418 } from "react/jsx-runtime";
var componentMap57 = {
  outlined: payments_default,
  "outlined-fill": payments_fill_default,
  rounded: payments_default2,
  "rounded-fill": payments_fill_default2,
  sharp: payments_default3,
  "sharp-fill": payments_fill_default3
};
var IconPayments = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap57[key] ?? componentMap57[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx418(Icon, {
    alt: "",
    SvgIcon,
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/picture_as_pdf-fill.svg
import * as React352 from "react";
import { jsx as jsx419 } from "react/jsx-runtime";
var SvgComponent352 = (props) => /* @__PURE__ */ jsx419("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx419("path", {
    d: "M353-448h37v-83h48q15.73 0 26.36-10.64Q475-552.28 475-568v-48q0-15.72-10.64-26.36Q453.73-653 438-653h-85v205Zm37-120v-48h48v48h-48Zm122 120h84q15 0 26-10.64 11-10.63 11-26.36v-131q0-15.72-11-26.36Q611-653 596-653h-84v205Zm37-37v-131h47v131h-47Zm129 37h37v-83h50v-37h-50v-48h50v-37h-87v205ZM286-192q-39.05 0-66.52-27.48Q192-246.95 192-286v-542q0-39.46 27.48-67.23Q246.95-923 286-923h542q39.46 0 67.23 27.77Q923-867.46 923-828v542q0 39.05-27.77 66.52Q867.46-192 828-192H286ZM132-37q-39.46 0-67.23-27.77Q37-92.54 37-132v-636h95v636h636v95H132Z"
  })
});
var picture_as_pdf_fill_default = SvgComponent352;

// ../../../node_modules/@material-symbols/svg-700/outlined/picture_as_pdf.svg
import * as React353 from "react";
import { jsx as jsx420 } from "react/jsx-runtime";
var SvgComponent353 = (props) => /* @__PURE__ */ jsx420("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx420("path", {
    d: "M353-448h37v-83h48q15.73 0 26.36-10.64Q475-552.28 475-568v-48q0-15.72-10.64-26.36Q453.73-653 438-653h-85v205Zm37-120v-48h48v48h-48Zm122 120h84q15 0 26-10.64 11-10.63 11-26.36v-131q0-15.72-11-26.36Q611-653 596-653h-84v205Zm37-37v-131h47v131h-47Zm129 37h37v-83h50v-37h-50v-48h50v-37h-87v205ZM286-192q-39.05 0-66.52-27.48Q192-246.95 192-286v-542q0-39.46 27.48-67.23Q246.95-923 286-923h542q39.46 0 67.23 27.77Q923-867.46 923-828v542q0 39.05-27.77 66.52Q867.46-192 828-192H286Zm0-94h542v-542H286v542ZM132-37q-39.46 0-67.23-27.77Q37-92.54 37-132v-636h95v636h636v95H132Zm154-791v542-542Z"
  })
});
var picture_as_pdf_default = SvgComponent353;

// ../../../node_modules/@material-symbols/svg-700/rounded/picture_as_pdf-fill.svg
import * as React354 from "react";
import { jsx as jsx421 } from "react/jsx-runtime";
var SvgComponent354 = (props) => /* @__PURE__ */ jsx421("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx421("path", {
    d: "M390-531h48q15.73 0 26.36-10.64Q475-552.28 475-568v-48q0-15.72-10.64-26.36Q453.73-653 438-653h-66q-7.6 0-13.3 5-5.7 5-5.7 13.41v168.18q0 7.41 5.7 12.91T372-448q7 0 12.5-6.2T390-467v-64Zm0-37v-48h48v48h-48Zm206 120q15 0 26-10.64 11-10.63 11-26.36v-131q0-15.72-11-26.36Q611-653 596-653h-65q-7.6 0-13.3 5-5.7 5-5.7 13.36v167.28q0 7.36 5.7 13.36 5.7 6 13.3 6h65Zm-47-37v-131h47v131h-47Zm166-46h32q7 0 12.5-6.2t5.5-13.3q0-7.5-5.5-12.5t-12.5-5h-32v-48h32q7 0 12.5-6.2t5.5-13.3q0-7.5-5.5-12.5t-12.5-5h-50q-7.6 0-13.3 5-5.7 5-5.7 13.41v168.18q0 7.41 5.7 12.91T697-448q7 0 12.5-6.2T715-467v-64ZM286-192q-39.05 0-66.52-27.48Q192-246.95 192-286v-542q0-39.46 27.48-67.23Q246.95-923 286-923h542q39.46 0 67.23 27.77Q923-867.46 923-828v542q0 39.05-27.77 66.52Q867.46-192 828-192H286ZM132-37q-39.46 0-67.23-27.77Q37-92.54 37-132v-589q0-19.75 13.68-33.38Q64.35-768 84.68-768q20.32 0 33.82 13.62Q132-740.75 132-721v589h589q19.75 0 33.38 13.68 13.62 13.67 13.62 34Q768-64 754.38-50.5 740.75-37 721-37H132Z"
  })
});
var picture_as_pdf_fill_default2 = SvgComponent354;

// ../../../node_modules/@material-symbols/svg-700/rounded/picture_as_pdf.svg
import * as React355 from "react";
import { jsx as jsx422 } from "react/jsx-runtime";
var SvgComponent355 = (props) => /* @__PURE__ */ jsx422("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx422("path", {
    d: "M390-531h48q15.73 0 26.36-10.64Q475-552.28 475-568v-48q0-15.72-10.64-26.36Q453.73-653 438-653h-66q-7.6 0-13.3 5-5.7 5-5.7 13.41v168.18q0 7.41 5.7 12.91T372-448q7 0 12.5-6.2T390-467v-64Zm0-37v-48h48v48h-48Zm206 120q15 0 26-10.64 11-10.63 11-26.36v-131q0-15.72-11-26.36Q611-653 596-653h-65q-7.6 0-13.3 5-5.7 5-5.7 13.36v167.28q0 7.36 5.7 13.36 5.7 6 13.3 6h65Zm-47-37v-131h47v131h-47Zm166-46h32q7 0 12.5-6.2t5.5-13.3q0-7.5-5.5-12.5t-12.5-5h-32v-48h32q7 0 12.5-6.2t5.5-13.3q0-7.5-5.5-12.5t-12.5-5h-50q-7.6 0-13.3 5-5.7 5-5.7 13.41v168.18q0 7.41 5.7 12.91T697-448q7 0 12.5-6.2T715-467v-64ZM286-192q-39.05 0-66.52-27.48Q192-246.95 192-286v-542q0-39.46 27.48-67.23Q246.95-923 286-923h542q39.46 0 67.23 27.77Q923-867.46 923-828v542q0 39.05-27.77 66.52Q867.46-192 828-192H286Zm0-94h542v-542H286v542ZM132-37q-39.46 0-67.23-27.77Q37-92.54 37-132v-589q0-19.75 13.68-33.38Q64.35-768 84.68-768q20.32 0 33.82 13.62Q132-740.75 132-721v589h589q19.75 0 33.38 13.68 13.62 13.67 13.62 34Q768-64 754.38-50.5 740.75-37 721-37H132Zm154-791v542-542Z"
  })
});
var picture_as_pdf_default2 = SvgComponent355;

// ../../../node_modules/@material-symbols/svg-700/sharp/picture_as_pdf-fill.svg
import * as React356 from "react";
import { jsx as jsx423 } from "react/jsx-runtime";
var SvgComponent356 = (props) => /* @__PURE__ */ jsx423("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx423("path", {
    d: "M353-448h37v-83h62l23-24v-75l-23-23h-99v205Zm37-120v-48h48v48h-48Zm122 120h98l23-24v-158l-23-23h-98v205Zm37-37v-131h47v131h-47Zm129 37h37v-83h50v-37h-50v-48h50v-37h-87v205ZM192-192v-731h731v731H192ZM37-37v-731h95v636h636v95H37Z"
  })
});
var picture_as_pdf_fill_default3 = SvgComponent356;

// ../../../node_modules/@material-symbols/svg-700/sharp/picture_as_pdf.svg
import * as React357 from "react";
import { jsx as jsx424 } from "react/jsx-runtime";
var SvgComponent357 = (props) => /* @__PURE__ */ jsx424("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx424("path", {
    d: "M353-448h37v-83h62l23-24v-75l-23-23h-99v205Zm37-120v-48h48v48h-48Zm122 120h98l23-24v-158l-23-23h-98v205Zm37-37v-131h47v131h-47Zm129 37h37v-83h50v-37h-50v-48h50v-37h-87v205ZM192-192v-731h731v731H192Zm94-94h542v-542H286v542ZM37-37v-731h95v636h636v95H37Zm249-791v542-542Z"
  })
});
var picture_as_pdf_default3 = SvgComponent357;

// src/components/icon/variants/IconPDF.tsx
import { useTranslation as useTranslation67 } from "react-i18next";
import { jsx as jsx425 } from "react/jsx-runtime";
var componentMap58 = {
  outlined: picture_as_pdf_default,
  "outlined-fill": picture_as_pdf_fill_default,
  rounded: picture_as_pdf_default2,
  "rounded-fill": picture_as_pdf_fill_default2,
  sharp: picture_as_pdf_default3,
  "sharp-fill": picture_as_pdf_fill_default3
};
var IconPDF = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation67("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap58[key] ?? componentMap58[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx425(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/perm_contact_calendar-fill.svg
import * as React358 from "react";
import { jsx as jsx426 } from "react/jsx-runtime";
var SvgComponent358 = (props) => /* @__PURE__ */ jsx426("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx426("path", {
    d: "M189-204q58-53 131-82t160-29q87 0 159.5 28T771-206v-545H189v547Zm291-175q-59 0-100.5-41.5T338-521q0-59 41.5-100T480-662q59 0 100.5 41T622-521q0 59-41.5 100.5T480-379ZM189-55q-39.05 0-66.53-27.47Q95-109.95 95-149v-602q0-39.46 27.47-67.23Q149.95-846 189-846h56v-60h82v60h306v-60h82v60h56q39.46 0 67.23 27.77Q866-790.46 866-751v602q0 39.05-27.77 66.53Q810.46-55 771-55H189Z"
  })
});
var perm_contact_calendar_fill_default = SvgComponent358;

// ../../../node_modules/@material-symbols/svg-700/outlined/perm_contact_calendar.svg
import * as React359 from "react";
import { jsx as jsx427 } from "react/jsx-runtime";
var SvgComponent359 = (props) => /* @__PURE__ */ jsx427("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx427("path", {
    d: "M479.5-244Q414-244 354-222.5T240-155v6h480q-50-45-112.5-70t-128-25ZM189-204q58-53 131-82t160-29q87 0 159.5 28T771-206v-545H189v547Zm291-175q-59 0-100.5-41.5T338-521q0-59 41.5-100T480-662q59 0 100.5 41T622-521q0 59-41.5 100.5T480-379Zm.47-71q28.53 0 49.03-21.18 20.5-21.17 20.5-50 0-28.82-20.97-49.32t-49.5-20.5q-28.53 0-49.03 20.97t-20.5 49.5Q410-492 430.97-471t49.5 21ZM189-55q-39.05 0-66.53-27.47Q95-109.95 95-149v-602q0-39.46 27.47-67.23Q149.95-846 189-846h56v-60h82v60h306v-60h82v60h56q39.46 0 67.23 27.77Q866-790.46 866-751v602q0 39.05-27.77 66.53Q810.46-55 771-55H189Zm291-466Zm0 372h240-480 240Z"
  })
});
var perm_contact_calendar_default = SvgComponent359;

// ../../../node_modules/@material-symbols/svg-700/rounded/perm_contact_calendar-fill.svg
import * as React360 from "react";
import { jsx as jsx428 } from "react/jsx-runtime";
var SvgComponent360 = (props) => /* @__PURE__ */ jsx428("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx428("path", {
    d: "M189-204q58-53 131-82t160-29q87 0 159.5 28T771-206v-545H189v547Zm291-175q-59 0-100.5-41.5T338-521q0-59 41.5-100T480-662q59 0 100.5 41T622-521q0 59-41.5 100.5T480-379ZM189-55q-39.05 0-66.53-27.47Q95-109.95 95-149v-602q0-39.46 27.47-67.23Q149.95-846 189-846h56v-19q0-16.75 12.39-28.88 12.4-12.12 28.8-12.12 16.83 0 28.82 12.12Q327-881.75 327-865v19h306v-19q0-16.75 12.39-28.88 12.4-12.12 28.8-12.12 16.84 0 28.82 12.12Q715-881.75 715-865v19h56q39.46 0 67.23 27.77Q866-790.46 866-751v602q0 39.05-27.77 66.53Q810.46-55 771-55H189Z"
  })
});
var perm_contact_calendar_fill_default2 = SvgComponent360;

// ../../../node_modules/@material-symbols/svg-700/rounded/perm_contact_calendar.svg
import * as React361 from "react";
import { jsx as jsx429 } from "react/jsx-runtime";
var SvgComponent361 = (props) => /* @__PURE__ */ jsx429("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx429("path", {
    d: "M479.5-244Q414-244 354-222.5T240-155v6h480q-50-45-112.5-70t-128-25ZM189-204q58-53 131-82t160-29q87 0 159.5 28T771-206v-545H189v547Zm291-175q-59 0-100.5-41.5T338-521q0-59 41.5-100T480-662q59 0 100.5 41T622-521q0 59-41.5 100.5T480-379Zm.47-71q28.53 0 49.03-21.18 20.5-21.17 20.5-50 0-28.82-20.97-49.32t-49.5-20.5q-28.53 0-49.03 20.97t-20.5 49.5Q410-492 430.97-471t49.5 21ZM189-55q-39.05 0-66.53-27.47Q95-109.95 95-149v-602q0-39.46 27.47-67.23Q149.95-846 189-846h56v-19q0-16.75 12.39-28.88 12.4-12.12 28.8-12.12 16.83 0 28.82 12.12Q327-881.75 327-865v19h306v-19q0-16.75 12.39-28.88 12.4-12.12 28.8-12.12 16.84 0 28.82 12.12Q715-881.75 715-865v19h56q39.46 0 67.23 27.77Q866-790.46 866-751v602q0 39.05-27.77 66.53Q810.46-55 771-55H189Zm291-466Zm0 372h240-480 240Z"
  })
});
var perm_contact_calendar_default2 = SvgComponent361;

// ../../../node_modules/@material-symbols/svg-700/sharp/perm_contact_calendar-fill.svg
import * as React362 from "react";
import { jsx as jsx430 } from "react/jsx-runtime";
var SvgComponent362 = (props) => /* @__PURE__ */ jsx430("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx430("path", {
    d: "M189-204q58-53 131-82t160-29q87 0 159.5 28T771-206v-545H189v547Zm291-175q-59 0-100.5-41.5T338-521q0-59 41.5-100T480-662q59 0 100.5 41T622-521q0 59-41.5 100.5T480-379ZM95-55v-791h150.2v-60H327v60h306v-60h82.2v60H866v791H95Z"
  })
});
var perm_contact_calendar_fill_default3 = SvgComponent362;

// ../../../node_modules/@material-symbols/svg-700/sharp/perm_contact_calendar.svg
import * as React363 from "react";
import { jsx as jsx431 } from "react/jsx-runtime";
var SvgComponent363 = (props) => /* @__PURE__ */ jsx431("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx431("path", {
    d: "M479.5-244Q414-244 354-222.5T240-155v6h480q-50-45-112.5-70t-128-25ZM189-204q58-53 131-82t160-29q87 0 159.5 28T771-206v-545H189v547Zm291-175q-59 0-100.5-41.5T338-521q0-59 41.5-100T480-662q59 0 100.5 41T622-521q0 59-41.5 100.5T480-379Zm.47-71q28.53 0 49.03-21.18 20.5-21.17 20.5-50 0-28.82-20.97-49.32t-49.5-20.5q-28.53 0-49.03 20.97t-20.5 49.5Q410-492 430.97-471t49.5 21ZM95-55v-791h150.2v-60H327v60h306v-60h82.2v60H866v791H95Zm385-466Zm0 372h240-480 240Z"
  })
});
var perm_contact_calendar_default3 = SvgComponent363;

// src/components/icon/variants/IconPermContactCalendar.tsx
import { useTranslation as useTranslation68 } from "react-i18next";
import { jsx as jsx432 } from "react/jsx-runtime";
var componentMap59 = {
  outlined: perm_contact_calendar_default,
  "outlined-fill": perm_contact_calendar_fill_default,
  rounded: perm_contact_calendar_default2,
  "rounded-fill": perm_contact_calendar_fill_default2,
  sharp: perm_contact_calendar_default3,
  "sharp-fill": perm_contact_calendar_fill_default3
};
var IconPermContactCalendar = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation68("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap59[key] ?? componentMap59[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx432(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/person-fill.svg
import * as React364 from "react";
import { jsx as jsx433 } from "react/jsx-runtime";
var SvgComponent364 = (props) => /* @__PURE__ */ jsx433("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx433("path", {
    d: "M479.8-494q-77.21 0-126-48.8-48.8-48.79-48.8-126 0-77.2 48.8-126.2 48.79-49 126-49 77.2 0 126.7 49T656-668.8q0 77.21-49.5 126Q557-494 479.8-494ZM135-122v-120.79q0-44.51 22.83-77.73Q180.66-353.73 217-371q69-31 133.46-46.5Q414.92-433 479.73-433q66.73 0 130.5 16Q674-401 742-371q37.61 15.96 60.8 49.48Q826-288 826-243.05V-122H135Z"
  })
});
var person_fill_default = SvgComponent364;

// ../../../node_modules/@material-symbols/svg-700/outlined/person.svg
import * as React365 from "react";
import { jsx as jsx434 } from "react/jsx-runtime";
var SvgComponent365 = (props) => /* @__PURE__ */ jsx434("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx434("path", {
    d: "M479.8-494q-77.21 0-126-48.8-48.8-48.79-48.8-126 0-77.2 48.8-126.2 48.79-49 126-49 77.2 0 126.7 49T656-668.8q0 77.21-49.5 126Q557-494 479.8-494ZM135-122v-120.79q0-44.51 22.83-77.73Q180.66-353.73 217-371q69-31 133.46-46.5Q414.92-433 479.73-433q66.73 0 130.5 16 63.77 16 131.69 46.19 37.91 16.09 61 49.45Q826-288 826-243.05V-122H135Zm94-94h502v-23q0-15.35-9.5-29.32T698-289q-60-28-110.5-38.5-50.49-10.5-108-10.5-55.5 0-108 10.5t-110.07 38.34Q247-282.44 238-268.42q-9 14.01-9 29.42v23Zm250.8-372q35.2 0 58.2-22.85 23-22.84 23-58.11 0-35.69-22.8-58.37-22.79-22.67-58-22.67-35.2 0-58.2 22.72t-23 57.82q0 35.51 22.8 58.49 22.79 22.97 58 22.97Zm.2-81Zm0 453Z"
  })
});
var person_default = SvgComponent365;

// ../../../node_modules/@material-symbols/svg-700/rounded/person-fill.svg
import * as React366 from "react";
import { jsx as jsx435 } from "react/jsx-runtime";
var SvgComponent366 = (props) => /* @__PURE__ */ jsx435("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx435("path", {
    d: "M479.8-494q-77.21 0-126-48.8-48.8-48.79-48.8-126 0-77.2 48.8-126.2 48.79-49 126-49 77.2 0 126.7 49T656-668.8q0 77.21-49.5 126Q557-494 479.8-494ZM135-216v-27q0-44 22.63-77.42Q180.27-353.83 217-371q69-31 133.5-46.5T479.73-433q66.73 0 130.5 16Q674-401 742-371q38 16 61 49.5t23 78.5v27q0 39-27.27 66.5T731-122H229q-40.05 0-67.02-27.5Q135-177 135-216Z"
  })
});
var person_fill_default2 = SvgComponent366;

// ../../../node_modules/@material-symbols/svg-700/rounded/person.svg
import * as React367 from "react";
import { jsx as jsx436 } from "react/jsx-runtime";
var SvgComponent367 = (props) => /* @__PURE__ */ jsx436("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx436("path", {
    d: "M479.8-494q-77.21 0-126-48.8-48.8-48.79-48.8-126 0-77.2 48.8-126.2 48.79-49 126-49 77.2 0 126.7 49T656-668.8q0 77.21-49.5 126Q557-494 479.8-494ZM135-216v-27q0-44.3 22.83-77.52Q180.66-353.73 217-371q69-31 133.46-46.5Q414.92-433 479.73-433q66.73 0 130.5 16 63.77 16 131.69 46.19 37.91 16.09 61 49.45Q826-288 826-243v27q0 38.75-27.39 66.37Q771.21-122 731-122H229q-39.8 0-66.9-27.63Q135-177.25 135-216Zm94 0h502v-23q0-15.35-9.5-29.32T698-289q-60-28-110.5-38.5-50.49-10.5-108-10.5-55.5 0-108 10.5t-110.07 38.34Q247-282.44 238-268.42q-9 14.01-9 29.42v23Zm250.8-372q35.2 0 58.2-22.85 23-22.84 23-58.11 0-35.69-22.8-58.37-22.79-22.67-58-22.67-35.2 0-58.2 22.72t-23 57.82q0 35.51 22.8 58.49 22.79 22.97 58 22.97Zm.2-81Zm0 453Z"
  })
});
var person_default2 = SvgComponent367;

// ../../../node_modules/@material-symbols/svg-700/sharp/person-fill.svg
import * as React368 from "react";
import { jsx as jsx437 } from "react/jsx-runtime";
var SvgComponent368 = (props) => /* @__PURE__ */ jsx437("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx437("path", {
    d: "M479.8-494q-77.21 0-126-48.8-48.8-48.79-48.8-126 0-77.2 48.8-126.2 48.79-49 126-49 77.2 0 126.7 49T656-668.8q0 77.21-49.5 126Q557-494 479.8-494ZM135-122v-120.79q0-44.51 22.83-77.73Q180.66-353.73 217-371q69-31 133.46-46.5Q414.92-433 479.73-433q66.73 0 130.5 16Q674-401 742-371q37.61 15.96 60.8 49.48Q826-288 826-243.05V-122H135Z"
  })
});
var person_fill_default3 = SvgComponent368;

// ../../../node_modules/@material-symbols/svg-700/sharp/person.svg
import * as React369 from "react";
import { jsx as jsx438 } from "react/jsx-runtime";
var SvgComponent369 = (props) => /* @__PURE__ */ jsx438("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx438("path", {
    d: "M479.8-494q-77.21 0-126-48.8-48.8-48.79-48.8-126 0-77.2 48.8-126.2 48.79-49 126-49 77.2 0 126.7 49T656-668.8q0 77.21-49.5 126Q557-494 479.8-494ZM135-122v-120.79q0-44.51 22.83-77.73Q180.66-353.73 217-371q69-31 133.46-46.5Q414.92-433 479.73-433q66.73 0 130.5 16 63.77 16 131.69 46.19 37.91 16.09 61 49.45Q826-288 826-243.05V-122H135Zm94-94h502v-23q0-15.35-9.5-29.32T698-289q-60-28-110.5-38.5-50.49-10.5-108-10.5-55.5 0-108 10.5t-110.07 38.34Q247-282.44 238-268.42q-9 14.01-9 29.42v23Zm250.8-372q35.2 0 58.2-22.85 23-22.84 23-58.11 0-35.69-22.8-58.37-22.79-22.67-58-22.67-35.2 0-58.2 22.72t-23 57.82q0 35.51 22.8 58.49 22.79 22.97 58 22.97Zm.2-81Zm0 453Z"
  })
});
var person_default3 = SvgComponent369;

// src/components/icon/variants/IconPerson.tsx
import { useTranslation as useTranslation69 } from "react-i18next";
import { jsx as jsx439 } from "react/jsx-runtime";
var componentMap60 = {
  outlined: person_default,
  "outlined-fill": person_fill_default,
  rounded: person_default2,
  "rounded-fill": person_fill_default2,
  sharp: person_default3,
  "sharp-fill": person_fill_default3
};
var IconPerson = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation69("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap60[key] ?? componentMap60[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx439(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// src/components/icon/variants/IconPrescription.tsx
import { useTranslation as useTranslation70 } from "react-i18next";

// src/components/icon/static/prescription.svg
import * as React370 from "react";
import { jsx as jsx440 } from "react/jsx-runtime";
var SvgComponent370 = (props) => /* @__PURE__ */ jsx440("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /* @__PURE__ */ jsx440("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.99991 3.16162C2.99991 2.52007 3.51998 2 4.16152 2H9.96961C12.4242 2 14.414 3.98985 14.414 6.44444C14.414 8.43312 13.1079 10.1167 11.3067 10.6842L14.5151 13.8926L18.9967 9.41094C19.4503 8.9573 20.1858 8.9573 20.6395 9.41094C21.0931 9.86458 21.0931 10.6001 20.6395 11.0537L16.1578 15.5354L20.6395 20.017C21.0931 20.4706 21.0931 21.2061 20.6395 21.6598C20.1858 22.1134 19.4503 22.1134 18.9967 21.6598L14.5151 17.1781L10.0334 21.6598C9.57978 22.1134 8.84428 22.1134 8.39064 21.6598C7.937 21.2061 7.937 20.4706 8.39064 20.017L12.8723 15.5354L8.22582 10.8889H5.32314V17.8081C5.32314 18.4496 4.80307 18.9697 4.16152 18.9697C3.51998 18.9697 2.99991 18.4496 2.99991 17.8081V3.16162ZM5.32314 8.56566H9.96961C11.1411 8.56566 12.0908 7.61596 12.0908 6.44444C12.0908 5.27293 11.1411 4.32323 9.96961 4.32323H5.32314V8.56566Z"
  })
});
var prescription_default = SvgComponent370;

// src/components/icon/variants/IconPrescription.tsx
import { jsx as jsx441 } from "react/jsx-runtime";
var IconPrescription = ({
  color,
  height,
  style = {},
  width
}) => {
  const { t } = useTranslation70("pds");
  return /* @__PURE__ */ jsx441(Icon, {
    SvgIcon: prescription_default,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/privacy_tip-fill.svg
import * as React371 from "react";
import { jsx as jsx442 } from "react/jsx-runtime";
var SvgComponent371 = (props) => /* @__PURE__ */ jsx442("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx442("path", {
    d: "M444-280h72v-263h-72v263Zm36-311q19.83 0 32.41-13.22Q525-617.45 525-637q0-19.13-12.59-32.06Q499.83-682 480-682t-32.41 13.08Q435-655.84 435-636.51q0 19.34 12.59 32.42Q460.17-591 480-591Zm-.06 536Q329.1-92.81 232.05-227.41 135-362.01 135-522.67v-255.79L480-907l346 128.57V-523q0 160.79-97.62 295.49Q630.77-92.81 479.94-55Z"
  })
});
var privacy_tip_fill_default = SvgComponent371;

// ../../../node_modules/@material-symbols/svg-700/outlined/privacy_tip.svg
import * as React372 from "react";
import { jsx as jsx443 } from "react/jsx-runtime";
var SvgComponent372 = (props) => /* @__PURE__ */ jsx443("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx443("path", {
    d: "M444-280h72v-263h-72v263Zm36-311q19.83 0 32.41-13.22Q525-617.45 525-637q0-19.13-12.59-32.06Q499.83-682 480-682t-32.41 13.08Q435-655.84 435-636.51q0 19.34 12.59 32.42Q460.17-591 480-591Zm-.06 536Q329.1-92.81 232.05-227.41 135-362.01 135-522.67v-255.79L480-907l346 128.57V-523q0 160.79-97.62 295.49Q630.77-92.81 479.94-55Zm.06-96q110-43 180.5-144T731-522.71V-712l-251-95-251 95.48v188.35Q229-396 299.5-295 370-194 480-151Zm0-328Z"
  })
});
var privacy_tip_default = SvgComponent372;

// ../../../node_modules/@material-symbols/svg-700/rounded/privacy_tip-fill.svg
import * as React373 from "react";
import { jsx as jsx444 } from "react/jsx-runtime";
var SvgComponent373 = (props) => /* @__PURE__ */ jsx444("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx444("path", {
    d: "M480.18-280q16.22 0 26.02-9.92 9.8-9.93 9.8-26.08v-191q0-15.15-9.98-25.58-9.97-10.42-26.2-10.42-16.22 0-26.02 10.42Q444-522.15 444-507v191q0 16.15 9.98 26.08 9.97 9.92 26.2 9.92ZM480-591q19.83 0 32.41-13.09Q525-617.17 525-637q0-18.83-12.59-31.91Q499.83-682 480-682t-32.41 13.09Q435-655.83 435-637q0 19.83 12.59 32.91Q460.17-591 480-591Zm0 531q-8.32 0-15.88-1.5Q456.56-63 450-66q-144-47-229.5-177.5T135-523.11V-712q0-30.26 16.38-55.16Q167.75-792.07 196-802l251-94q16-6 33-6t33 6l251 94q28.25 9.93 45.13 34.84Q826-742.26 826-712v188.89Q826-374 740-243.5T510-66q-6.56 3-14.12 4.5T480-60Z"
  })
});
var privacy_tip_fill_default2 = SvgComponent373;

// ../../../node_modules/@material-symbols/svg-700/rounded/privacy_tip.svg
import * as React374 from "react";
import { jsx as jsx445 } from "react/jsx-runtime";
var SvgComponent374 = (props) => /* @__PURE__ */ jsx445("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx445("path", {
    d: "M480.18-280q16.22 0 26.02-9.92 9.8-9.93 9.8-26.27V-507q0-15.3-9.98-25.65-9.97-10.35-26.2-10.35-16.22 0-26.02 10.35T444-507v190.81q0 16.34 9.98 26.27 9.97 9.92 26.2 9.92ZM480-591q19.83 0 32.41-13.22Q525-617.45 525-637q0-19.13-12.59-32.06Q499.83-682 480-682t-32.41 13.08Q435-655.84 435-636.51q0 19.34 12.59 32.42Q460.17-591 480-591Zm0 531q-8.32 0-15.88-1.5Q456.56-63 450-66q-144-47-229.5-177.6Q135-374.19 135-523.11V-712q0-30.26 16.38-55.16Q167.75-792.07 196-802l251-94q16-6 33-6t33 6l251 94q28.25 9.93 45.13 34.84Q826-742.26 826-712v188.89q0 148.92-86 279.51Q654-113 510-66q-6.56 3-14.12 4.5T480-60Zm0-91q110-43 180.5-144T731-522.71V-712l-251-95-251 95.48v188.35Q229-396 299.5-295 370-194 480-151Zm0-328Z"
  })
});
var privacy_tip_default2 = SvgComponent374;

// ../../../node_modules/@material-symbols/svg-700/sharp/privacy_tip-fill.svg
import * as React375 from "react";
import { jsx as jsx446 } from "react/jsx-runtime";
var SvgComponent375 = (props) => /* @__PURE__ */ jsx446("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx446("path", {
    d: "M444-280h72v-263h-72v263Zm36-311q19.83 0 32.41-13.22Q525-617.45 525-637q0-19.13-12.59-32.06Q499.83-682 480-682t-32.41 13.08Q435-655.84 435-636.51q0 19.34 12.59 32.42Q460.17-591 480-591Zm-.06 536Q329.1-92.81 232.05-227.41 135-362.01 135-522.67v-255.79L480-907l346 128.57V-523q0 160.79-97.62 295.49Q630.77-92.81 479.94-55Z"
  })
});
var privacy_tip_fill_default3 = SvgComponent375;

// ../../../node_modules/@material-symbols/svg-700/sharp/privacy_tip.svg
import * as React376 from "react";
import { jsx as jsx447 } from "react/jsx-runtime";
var SvgComponent376 = (props) => /* @__PURE__ */ jsx447("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx447("path", {
    d: "M444-280h72v-263h-72v263Zm36-311q19.83 0 32.41-13.22Q525-617.45 525-637q0-19.13-12.59-32.06Q499.83-682 480-682t-32.41 13.08Q435-655.84 435-636.51q0 19.34 12.59 32.42Q460.17-591 480-591Zm-.06 536Q329.1-92.81 232.05-227.41 135-362.01 135-522.67v-255.79L480-907l346 128.57V-523q0 160.79-97.62 295.49Q630.77-92.81 479.94-55Zm.06-96q110-43 180.5-144T731-522.71V-712l-251-95-251 95.48v188.35Q229-396 299.5-295 370-194 480-151Zm0-328Z"
  })
});
var privacy_tip_default3 = SvgComponent376;

// src/components/icon/variants/IconPrivacyTip.tsx
import { useTranslation as useTranslation71 } from "react-i18next";
import { jsx as jsx448 } from "react/jsx-runtime";
var componentMap61 = {
  outlined: privacy_tip_default,
  "outlined-fill": privacy_tip_fill_default,
  rounded: privacy_tip_default2,
  "rounded-fill": privacy_tip_fill_default2,
  sharp: privacy_tip_default3,
  "sharp-fill": privacy_tip_fill_default3
};
var IconPrivacyTip = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation71("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap61[key] ?? componentMap61[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx448(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/reply-fill.svg
import * as React377 from "react";
import { jsx as jsx449 } from "react/jsx-runtime";
var SvgComponent377 = (props) => /* @__PURE__ */ jsx449("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx449("path", {
    d: "M771-175v-181q0-54-33.5-87.5T650-477H275l146 146-66 67L95-524l260-260 66 67-146 146h375q92 0 154 62t62 153v181h-95Z"
  })
});
var reply_fill_default = SvgComponent377;

// ../../../node_modules/@material-symbols/svg-700/outlined/reply.svg
import * as React378 from "react";
import { jsx as jsx450 } from "react/jsx-runtime";
var SvgComponent378 = (props) => /* @__PURE__ */ jsx450("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx450("path", {
    d: "M771-175v-181q0-54-33.5-87.5T650-477H275l146 146-66 67L95-524l260-260 66 67-146 146h375q92 0 154 62t62 153v181h-95Z"
  })
});
var reply_default = SvgComponent378;

// ../../../node_modules/@material-symbols/svg-700/rounded/reply-fill.svg
import * as React379 from "react";
import { jsx as jsx451 } from "react/jsx-runtime";
var SvgComponent379 = (props) => /* @__PURE__ */ jsx451("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx451("path", {
    d: "m275-477 113 113q13 14 13 33t-13 33q-14 14-34 14t-33-14L128-490q-14-14-14-34t14-34l194-193q14-14 33.5-14t33.5 14q13 14 13 33.5T389-685L275-571h375q92 0 154 62t62 153v134q0 20-14 33.5T818-175q-20 0-33.5-13.5T771-222v-134q0-54-33.5-87.5T650-477H275Z"
  })
});
var reply_fill_default2 = SvgComponent379;

// ../../../node_modules/@material-symbols/svg-700/rounded/reply.svg
import * as React380 from "react";
import { jsx as jsx452 } from "react/jsx-runtime";
var SvgComponent380 = (props) => /* @__PURE__ */ jsx452("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx452("path", {
    d: "m275-477 113 113q13 14 13 33t-13 33q-14 14-34 14t-33-14L128-490q-14-14-14-34t14-34l194-193q14-14 33.5-14t33.5 14q13 14 13 33.5T389-685L275-571h375q92 0 154 62t62 153v134q0 20-14 33.5T818-175q-20 0-33.5-13.5T771-222v-134q0-54-33.5-87.5T650-477H275Z"
  })
});
var reply_default2 = SvgComponent380;

// ../../../node_modules/@material-symbols/svg-700/sharp/reply-fill.svg
import * as React381 from "react";
import { jsx as jsx453 } from "react/jsx-runtime";
var SvgComponent381 = (props) => /* @__PURE__ */ jsx453("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx453("path", {
    d: "M771-175v-181q0-54-33.5-87.5T650-477H275l146 146-66 67L95-524l260-260 66 67-146 146h375q92 0 154 62t62 153v181h-95Z"
  })
});
var reply_fill_default3 = SvgComponent381;

// ../../../node_modules/@material-symbols/svg-700/sharp/reply.svg
import * as React382 from "react";
import { jsx as jsx454 } from "react/jsx-runtime";
var SvgComponent382 = (props) => /* @__PURE__ */ jsx454("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx454("path", {
    d: "M771-175v-181q0-54-33.5-87.5T650-477H275l146 146-66 67L95-524l260-260 66 67-146 146h375q92 0 154 62t62 153v181h-95Z"
  })
});
var reply_default3 = SvgComponent382;

// src/components/icon/variants/IconReply.tsx
import { useTranslation as useTranslation72 } from "react-i18next";
import { jsx as jsx455 } from "react/jsx-runtime";
var componentMap62 = {
  outlined: reply_default,
  "outlined-fill": reply_fill_default,
  rounded: reply_default2,
  "rounded-fill": reply_fill_default2,
  sharp: reply_default3,
  "sharp-fill": reply_fill_default3
};
var IconReply = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation72("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap62[key] ?? componentMap62[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx455(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/route-fill.svg
import * as React383 from "react";
import { jsx as jsx456 } from "react/jsx-runtime";
var SvgComponent383 = (props) => /* @__PURE__ */ jsx456("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx456("path", {
    d: "M344-103q-78 0-131-53t-53-130v-327q-36-16.47-58-47.24Q80-691 80-730q0-53.5 37.65-90.25 37.64-36.75 89-36.75Q260-857 297-820.25q37 36.75 37 90.25 0 38.83-22 69.92Q290-629 254-613v327.03q0 36.82 25.59 62.89Q305.17-197 344-197q39 0 64-25.99t25-62.68V-674q0-78 52.5-130.5T616-857q79 0 132 52.5T801-674v327q35 16 57.5 46.98 22.5 30.99 22.5 69.69 0 52.33-37.06 89.83t-91 37.5q-51.94 0-89.44-37.75T626-230q0-38.84 22-69.92T706-347v-327q0-38-25.59-63.5Q654.83-763 616-763q-38 0-63.5 25.5T527-674v388q0 77-52.5 130T344-103Z"
  })
});
var route_fill_default = SvgComponent383;

// ../../../node_modules/@material-symbols/svg-700/outlined/route.svg
import * as React384 from "react";
import { jsx as jsx457 } from "react/jsx-runtime";
var SvgComponent384 = (props) => /* @__PURE__ */ jsx457("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx457("path", {
    d: "M344-103q-78 0-131-53.03T160-286v-327q-36-16.47-58-46.85-22-30.39-22-69.82 0-53.41 37.44-90.37 37.44-36.96 90-36.96T297-819.9q37 37.09 37 90.09 0 38.93-22 69.87Q290-629 254-613v327.06q0 36.97 25.59 62.96Q305.17-197 344.5-197q38.5 0 63.5-26.05 25-26.04 25-62.62V-674q0-78 52.5-130.5t131-52.5q78.5 0 131.5 52.5T801-674v327q35 16 57.5 46.7 22.5 30.71 22.5 69.97 0 52.33-37.23 89.83T753.35-103q-52.35 0-89.85-37.75Q626-178.5 626-230q0-39 22-70t58-47v-327q0-38-25.59-63.5Q654.83-763 616-763q-38 0-63.5 25.5T527-674.44V-286q0 76.94-52.5 129.97T344-103ZM207.28-686Q226-686 239-698.78t13-31.5q0-18.72-12.95-31.22T207.28-774q-18.72 0-31.5 12.53Q163-748.94 163-730.42 163-712 175.78-699t31.5 13Zm546.54 500q17.81 0 30.5-12.78Q797-211.56 797-230.28t-12.56-31.22Q771.88-274 753.32-274q-17.32 0-30.82 12.53T709-230.42Q709-212 722.5-199t31.32 13ZM208-730Zm545 500Z"
  })
});
var route_default = SvgComponent384;

// ../../../node_modules/@material-symbols/svg-700/rounded/route-fill.svg
import * as React385 from "react";
import { jsx as jsx458 } from "react/jsx-runtime";
var SvgComponent385 = (props) => /* @__PURE__ */ jsx458("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx458("path", {
    d: "M344-103q-78 0-131-53t-53-130v-327q-36-16.47-58-47.24Q80-691 80-730q0-53.5 37.65-90.25 37.64-36.75 89-36.75Q260-857 297-820.25q37 36.75 37 90.25 0 38.83-22 69.92Q290-629 254-613v327.03q0 36.82 25.59 62.89Q305.17-197 344-197q39 0 64-25.99t25-62.68V-674q0-78 52.5-130.5T616-857q79 0 132 52.5T801-674v327q35 16 57.5 46.98 22.5 30.99 22.5 69.69 0 52.33-37.06 89.83t-91 37.5q-51.94 0-89.44-37.75T626-230q0-38.84 22-69.92T706-347v-327q0-38-25.59-63.5Q654.83-763 616-763q-38 0-63.5 25.5T527-674v388q0 77-52.5 130T344-103Z"
  })
});
var route_fill_default2 = SvgComponent385;

// ../../../node_modules/@material-symbols/svg-700/rounded/route.svg
import * as React386 from "react";
import { jsx as jsx459 } from "react/jsx-runtime";
var SvgComponent386 = (props) => /* @__PURE__ */ jsx459("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx459("path", {
    d: "M344-103q-78 0-131-53.03T160-286v-327q-36-16.47-58-46.85-22-30.39-22-69.82 0-53.41 37.44-90.37 37.44-36.96 90-36.96T297-819.9q37 37.09 37 90.09 0 38.93-22 69.87Q290-629 254-613v327.06q0 36.97 25.59 62.96Q305.17-197 344.5-197q38.5 0 63.5-26.05 25-26.04 25-62.62V-674q0-78 52.5-130.5t131-52.5q78.5 0 131.5 52.5T801-674v327q35 16 57.5 46.7 22.5 30.71 22.5 69.97 0 52.33-37.23 89.83T753.35-103q-52.35 0-89.85-37.75Q626-178.5 626-230q0-39 22-70t58-47v-327q0-38-25.59-63.5Q654.83-763 616-763q-38 0-63.5 25.5T527-674.44V-286q0 76.94-52.5 129.97T344-103ZM207.28-686Q226-686 239-698.78t13-31.5q0-18.72-12.95-31.22T207.28-774q-18.72 0-31.5 12.53Q163-748.94 163-730.42 163-712 175.78-699t31.5 13Zm546.54 500q17.81 0 30.5-12.78Q797-211.56 797-230.28t-12.56-31.22Q771.88-274 753.32-274q-17.32 0-30.82 12.53T709-230.42Q709-212 722.5-199t31.32 13ZM208-730Zm545 500Z"
  })
});
var route_default2 = SvgComponent386;

// ../../../node_modules/@material-symbols/svg-700/sharp/route-fill.svg
import * as React387 from "react";
import { jsx as jsx460 } from "react/jsx-runtime";
var SvgComponent387 = (props) => /* @__PURE__ */ jsx460("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx460("path", {
    d: "M160-103v-509.56q-36-16.91-58-47.29-22-30.39-22-69.82 0-53.41 37.44-90.37 37.44-36.96 90-36.96T297-819.9q37 37.09 37 90.09 0 38.93-22 69.87Q290-629 254-613v416h179v-660h368v509.56q35 16.44 57.5 47.14 22.5 30.71 22.5 69.97 0 52.33-37.23 89.83T753.35-103q-52.35 0-89.85-37.75Q626-178.5 626-230q0-39 22-70t58-47v-416H527v660H160Z"
  })
});
var route_fill_default3 = SvgComponent387;

// ../../../node_modules/@material-symbols/svg-700/sharp/route.svg
import * as React388 from "react";
import { jsx as jsx461 } from "react/jsx-runtime";
var SvgComponent388 = (props) => /* @__PURE__ */ jsx461("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx461("path", {
    d: "M160-103v-509.56q-36-16.91-58-47.29-22-30.39-22-69.82 0-53.41 37.44-90.37 37.44-36.96 90-36.96T297-819.9q37 37.09 37 90.09 0 38.93-22 69.87Q290-629 254-613v416h179v-660h368v509.56q35 16.44 57.5 47.14 22.5 30.71 22.5 69.97 0 52.33-37.23 89.83T753.35-103q-52.35 0-89.85-37.75Q626-178.5 626-230q0-39 22-70t58-47v-416H527v660H160Zm47.28-583Q226-686 239-698.78t13-31.5q0-18.72-12.95-31.22T207.28-774q-18.72 0-31.5 12.53Q163-748.94 163-730.42 163-712 175.78-699t31.5 13Zm546.54 500q17.81 0 30.5-12.78Q797-211.56 797-230.28t-12.56-31.22Q771.88-274 753.32-274q-17.32 0-30.82 12.53T709-230.42Q709-212 722.5-199t31.32 13ZM208-730Zm545 500Z"
  })
});
var route_default3 = SvgComponent388;

// src/components/icon/variants/IconRoute.tsx
import { useTranslation as useTranslation73 } from "react-i18next";
import { jsx as jsx462 } from "react/jsx-runtime";
var componentMap63 = {
  outlined: route_default,
  "outlined-fill": route_fill_default,
  rounded: route_default2,
  "rounded-fill": route_fill_default2,
  sharp: route_default3,
  "sharp-fill": route_fill_default3
};
var IconRoute = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation73("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap63[key] ?? componentMap63[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx462(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/savings-fill.svg
import * as React389 from "react";
import { jsx as jsx463 } from "react/jsx-runtime";
var SvgComponent389 = (props) => /* @__PURE__ */ jsx463("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx463("path", {
    d: "M639-492q23.45 0 40.22-16.5Q696-525 696-549t-16.89-40.5q-16.88-16.5-40.5-16.5Q615-606 598-589.5T581-549q0 24 17.06 40.5Q615.13-492 639-492Zm-352-91h232v-84H287v84ZM140-95q-36-120-71-239.53T34-580q0-102 71.41-174t173.69-72H504q32.28-38 77.24-59 44.96-21 94.76-21 34.67 0 59.83 24.67Q761-856.67 761-822q0 6.78-5 29-3 8-5.5 16.31-2.5 8.32-4.5 17.69l73 73h107v324l-123 38-68 229H472v-80h-69v80H140Z"
  })
});
var savings_fill_default = SvgComponent389;

// ../../../node_modules/@material-symbols/svg-700/outlined/savings.svg
import * as React390 from "react";
import { jsx as jsx464 } from "react/jsx-runtime";
var SvgComponent390 = (props) => /* @__PURE__ */ jsx464("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx464("path", {
    d: "M639-492q23.45 0 40.22-16.5Q696-525 696-549t-16.89-40.5q-16.88-16.5-40.5-16.5Q615-606 598-589.5T581-549q0 24 17.06 40.5Q615.13-492 639-492Zm-352-91h232v-84H287v84ZM140-95q-36-120-71-239.53T34-580q0-102 71.41-174t173.69-72H504q32.28-38 77.24-59 44.96-21 94.76-21 34.67 0 59.83 24.67Q761-856.67 761-822q0 8-1.5 15t-3.5 14q-3 8-5.5 16.31-2.5 8.32-4.5 17.69l73 73h107v324l-123 38-68 229H472v-80h-69v80H140Zm71.23-94H314v-80h246v80h103l62.61-208.86L831-431v-160h-52L651-719q1-24 6-47.5t12-47.5q-37 11-68.5 30.79Q569-763.43 549-731H279q-63.53 0-107.26 43.74Q128-643.53 128-580q0 101.19 28 197.59Q184-286 211.23-189ZM480-502Z"
  })
});
var savings_default = SvgComponent390;

// ../../../node_modules/@material-symbols/svg-700/rounded/savings-fill.svg
import * as React391 from "react";
import { jsx as jsx465 } from "react/jsx-runtime";
var SvgComponent391 = (props) => /* @__PURE__ */ jsx465("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx465("path", {
    d: "M224-95q-36.12 0-67.05-23.46Q126.02-141.93 116-176q-25-84-40.54-144.96-15.54-60.96-24.87-107.68-9.32-46.72-12.95-82.29Q34-546.49 34-580q0-102 71.41-174t173.69-72H504q30-36 74.88-58 44.87-22 97.12-22 39 0 62 24.67 23 24.66 23 59.33 0 7.74-1.5 14.98T756-793q-3 7-5.5 15.26-2.5 8.25-4.5 18.74l73 73h60q19.75 0 33.38 14.19Q926-657.63 926-638v240q0 16.27-9 29.14Q908-356 893-352l-89.93 28.3L755-162q-8.75 29.51-33.7 48.25Q696.34-95 664-95h-98q-33.45 0-60.23-17.13Q479-129.25 471-155v-20h-68v20q-8 25.75-34.48 42.87Q342.04-95 309-95h-85Zm415-397q23.45 0 40.22-16.5Q696-525 696-549t-16.89-40.5q-16.88-16.5-40.5-16.5Q615-606 598-589.5T581-549q0 24 17.06 40.5Q615.13-492 639-492Zm-162.45-91q18.2 0 30.33-12.18Q519-607.35 519-624.98q0-17.63-12.12-29.83Q494.75-667 476.55-667h-148.1q-18.2 0-29.82 12.37-11.63 12.37-11.63 30Q287-607 299.13-595q12.12 12 30.32 12h147.1Z"
  })
});
var savings_fill_default2 = SvgComponent391;

// ../../../node_modules/@material-symbols/svg-700/rounded/savings.svg
import * as React392 from "react";
import { jsx as jsx466 } from "react/jsx-runtime";
var SvgComponent392 = (props) => /* @__PURE__ */ jsx466("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx466("path", {
    d: "M224-95q-36.12 0-67.05-23.46Q126.02-141.93 116-176q-25-84-40.6-144.96-15.6-60.97-24.87-107.69-9.26-46.71-12.89-82.28Q34-546.49 34-580q0-102.22 71.3-174.11Q176.6-826 279.1-826h225.38q29.52-36 74.4-58 44.87-22 97.12-22 39 0 62 24.5t23 59.5q0 7.57-1.5 15.13Q758-799.3 756-793q-3 7-5.5 15.26-2.5 8.25-4.5 18.74l73 73h60q19.75 0 33.38 14.19Q926-657.63 926-638v240q0 16.55-9 29.27Q908-356 893-352l-89.93 28.3L755-162q-8.75 29.51-33.7 48.25Q696.34-95 664-95h-98q-33.45 0-60.23-17.13Q479-129.25 471-155v-20h-68v20q-8 25.75-34.48 42.87Q342.04-95 309-95h-85Zm-13-94h103v-80h246v80h103l62.61-208.86L831-431v-160h-52L651-719q1-15 5.5-39.5T669-814q-40 12-72 35t-47.53 48H279q-62.56 0-106.78 44.25T128-579.91q0 41.88 21.5 144.4Q171-333 211-189Zm428-303q23.45 0 40.22-16.5Q696-525 696-549t-16.89-40.5q-16.88-16.5-40.5-16.5Q615-606 598-589.5T581-549q0 24 17.06 40.5Q615.13-492 639-492Zm-162.45-91q18.58 0 30.51-12.18Q519-607.35 519-624.98q0-17.63-11.94-29.83Q495.13-667 476.55-667h-148.1q-18.57 0-30.01 12.18Q287-642.64 287-624.63 287-607 299.13-595q12.12 12 30.32 12h147.1Zm3.45 81Z"
  })
});
var savings_default2 = SvgComponent392;

// ../../../node_modules/@material-symbols/svg-700/sharp/savings-fill.svg
import * as React393 from "react";
import { jsx as jsx467 } from "react/jsx-runtime";
var SvgComponent393 = (props) => /* @__PURE__ */ jsx467("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx467("path", {
    d: "M639-492q23.45 0 40.22-16.5Q696-525 696-549t-16.89-40.5q-16.88-16.5-40.5-16.5Q615-606 598-589.5T581-549q0 24 17.06 40.5Q615.13-492 639-492Zm-352-91h232v-84H287v84ZM140-95q-36-120-71-239.53T34-580q0-102 71.41-174t173.69-72H504q32.28-38 77.24-59 44.96-21 94.76-21 34.67 0 59.83 24.67Q761-856.67 761-822q0 6.78-5 29-3 8-5.5 16.31-2.5 8.32-4.5 17.69l73 73h107v324l-123 38-68 229H472v-80h-69v80H140Z"
  })
});
var savings_fill_default3 = SvgComponent393;

// ../../../node_modules/@material-symbols/svg-700/sharp/savings.svg
import * as React394 from "react";
import { jsx as jsx468 } from "react/jsx-runtime";
var SvgComponent394 = (props) => /* @__PURE__ */ jsx468("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx468("path", {
    d: "M639-492q23.45 0 40.22-16.5Q696-525 696-549t-16.89-40.5q-16.88-16.5-40.5-16.5Q615-606 598-589.5T581-549q0 24 17.06 40.5Q615.13-492 639-492Zm-352-91h232v-84H287v84ZM140-95q-36-120-71-239.53T34-580q0-102 71.41-174t173.69-72H504q32.28-38 77.24-59 44.96-21 94.76-21 34.67 0 59.83 24.67Q761-856.67 761-822q0 8-1.5 15t-3.5 14q-3 8-5.5 16.31-2.5 8.32-4.5 17.69l73 73h107v324l-123 38-68 229H472v-80h-69v80H140Zm71.23-94H314v-80h246v80h103l62.61-208.86L831-431v-160h-52L651-719q1-24 6-47.5t12-47.5q-37 11-68.5 30.79Q569-763.43 549-731H279q-63.53 0-107.26 43.74Q128-643.53 128-580q0 101.19 28 197.59Q184-286 211.23-189ZM480-502Z"
  })
});
var savings_default3 = SvgComponent394;

// src/components/icon/variants/IconSavings.tsx
import { useTranslation as useTranslation74 } from "react-i18next";
import { jsx as jsx469 } from "react/jsx-runtime";
var componentMap64 = {
  outlined: savings_default,
  "outlined-fill": savings_fill_default,
  rounded: savings_default2,
  "rounded-fill": savings_fill_default2,
  sharp: savings_default3,
  "sharp-fill": savings_fill_default3
};
var IconSavings = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation74("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap64[key] ?? componentMap64[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx469(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/schedule-fill.svg
import * as React395 from "react";
import { jsx as jsx470 } from "react/jsx-runtime";
var SvgComponent395 = (props) => /* @__PURE__ */ jsx470("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx470("path", {
    d: "m616-283 62-60-154-155.23V-689h-82v224.56L616-283ZM480.14-55Q392-55 314.62-88.37q-77.37-33.36-135.11-91.06-57.73-57.7-91.12-135.03Q55-391.78 55-479.89q0-88.11 33.58-165.6 33.59-77.48 91.02-134.91 57.43-57.43 134.82-91.52Q391.81-906 480-906q88.19 0 165.58 34.08 77.39 34.09 134.82 91.52 57.43 57.43 91.52 134.82Q906-568.19 906-480q0 88.19-34.08 165.58-34.09 77.39-91.52 134.82-57.43 57.43-134.77 91.02Q568.28-55 480.14-55Z"
  })
});
var schedule_fill_default = SvgComponent395;

// ../../../node_modules/@material-symbols/svg-700/outlined/schedule.svg
import * as React396 from "react";
import { jsx as jsx471 } from "react/jsx-runtime";
var SvgComponent396 = (props) => /* @__PURE__ */ jsx471("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx471("path", {
    d: "m616-283 62-60-154-155.23V-689h-82v224.56L616-283ZM480.14-55Q392-55 314.62-88.37q-77.37-33.36-135.11-91.06-57.73-57.7-91.12-135.03Q55-391.78 55-479.89q0-88.11 33.58-165.6 33.59-77.48 91.02-134.91 57.43-57.43 134.82-91.52Q391.81-906 480-906q88.19 0 165.58 34.08 77.39 34.09 134.82 91.52 57.43 57.43 91.52 134.82Q906-568.19 906-480q0 88.19-34.08 165.58-34.09 77.39-91.52 134.82-57.43 57.43-134.77 91.02Q568.28-55 480.14-55ZM480-480Zm-.51 331Q616-149 713.5-245.5t97.5-234Q811-617 713.63-714t-233.62-97Q343-811 246-714.12 149-617.25 149-480q0 138 96.99 234.5t233.5 96.5Z"
  })
});
var schedule_default = SvgComponent396;

// ../../../node_modules/@material-symbols/svg-700/rounded/schedule-fill.svg
import * as React397 from "react";
import { jsx as jsx472 } from "react/jsx-runtime";
var SvgComponent397 = (props) => /* @__PURE__ */ jsx472("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx472("path", {
    d: "M524-498.45V-648q0-17.67-11.6-29.34Q500.8-689 483.21-689q-17.58 0-29.4 11.66Q442-665.67 442-648v166q0 9 3 16.86 3 7.85 9 15.14l132 137q13.27 13 30.63 12.5Q634-301 647-313t13-30q0-18-13-31L524-498.45ZM480.14-55Q392-55 314.62-88.37q-77.37-33.36-135.11-91.06-57.73-57.7-91.12-135.03Q55-391.78 55-479.89q0-88.11 33.58-165.6 33.59-77.48 91.02-134.91 57.43-57.43 134.82-91.52Q391.81-906 480-906q88.19 0 165.58 34.08 77.39 34.09 134.82 91.52 57.43 57.43 91.52 134.82Q906-568.19 906-480q0 88.19-34.08 165.58-34.09 77.39-91.52 134.82-57.43 57.43-134.77 91.02Q568.28-55 480.14-55Z"
  })
});
var schedule_fill_default2 = SvgComponent397;

// ../../../node_modules/@material-symbols/svg-700/rounded/schedule.svg
import * as React398 from "react";
import { jsx as jsx473 } from "react/jsx-runtime";
var SvgComponent398 = (props) => /* @__PURE__ */ jsx473("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx473("path", {
    d: "M524-498.45V-648q0-17.67-11.6-29.34Q500.8-689 483.21-689q-17.58 0-29.4 11.66Q442-665.67 442-648v166q0 9 3 16.86 3 7.85 9 15.14l132 137q13.27 13 30.63 12.5Q634-301 647-313t13-30q0-18-13-31L524-498.45ZM480.14-55Q392-55 314.62-88.37q-77.37-33.36-135.11-91.06-57.73-57.7-91.12-135.03Q55-391.78 55-479.89q0-88.11 33.58-165.6 33.59-77.48 91.02-134.91 57.43-57.43 134.82-91.52Q391.81-906 480-906q88.19 0 165.58 34.08 77.39 34.09 134.82 91.52 57.43 57.43 91.52 134.82Q906-568.19 906-480q0 88.19-34.08 165.58-34.09 77.39-91.52 134.82-57.43 57.43-134.77 91.02Q568.28-55 480.14-55ZM480-480Zm-.51 331Q616-149 713.5-245.5t97.5-234Q811-617 713.63-714t-233.62-97Q343-811 246-714.12 149-617.25 149-480q0 138 96.99 234.5t233.5 96.5Z"
  })
});
var schedule_default2 = SvgComponent398;

// ../../../node_modules/@material-symbols/svg-700/sharp/schedule-fill.svg
import * as React399 from "react";
import { jsx as jsx474 } from "react/jsx-runtime";
var SvgComponent399 = (props) => /* @__PURE__ */ jsx474("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx474("path", {
    d: "m616-283 62-60-154-155.23V-689h-82v224.56L616-283ZM480.14-55Q392-55 314.62-88.37q-77.37-33.36-135.11-91.06-57.73-57.7-91.12-135.03Q55-391.78 55-479.89q0-88.11 33.58-165.6 33.59-77.48 91.02-134.91 57.43-57.43 134.82-91.52Q391.81-906 480-906q88.19 0 165.58 34.08 77.39 34.09 134.82 91.52 57.43 57.43 91.52 134.82Q906-568.19 906-480q0 88.19-34.08 165.58-34.09 77.39-91.52 134.82-57.43 57.43-134.77 91.02Q568.28-55 480.14-55Z"
  })
});
var schedule_fill_default3 = SvgComponent399;

// ../../../node_modules/@material-symbols/svg-700/sharp/schedule.svg
import * as React400 from "react";
import { jsx as jsx475 } from "react/jsx-runtime";
var SvgComponent400 = (props) => /* @__PURE__ */ jsx475("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx475("path", {
    d: "m616-283 62-60-154-155.23V-689h-82v224.56L616-283ZM480.14-55Q392-55 314.62-88.37q-77.37-33.36-135.11-91.06-57.73-57.7-91.12-135.03Q55-391.78 55-479.89q0-88.11 33.58-165.6 33.59-77.48 91.02-134.91 57.43-57.43 134.82-91.52Q391.81-906 480-906q88.19 0 165.58 34.08 77.39 34.09 134.82 91.52 57.43 57.43 91.52 134.82Q906-568.19 906-480q0 88.19-34.08 165.58-34.09 77.39-91.52 134.82-57.43 57.43-134.77 91.02Q568.28-55 480.14-55ZM480-480Zm-.51 331Q616-149 713.5-245.5t97.5-234Q811-617 713.63-714t-233.62-97Q343-811 246-714.12 149-617.25 149-480q0 138 96.99 234.5t233.5 96.5Z"
  })
});
var schedule_default3 = SvgComponent400;

// src/components/icon/variants/IconSchedule.tsx
import { useTranslation as useTranslation75 } from "react-i18next";
import { jsx as jsx476 } from "react/jsx-runtime";
var componentMap65 = {
  outlined: schedule_default,
  "outlined-fill": schedule_fill_default,
  rounded: schedule_default2,
  "rounded-fill": schedule_fill_default2,
  sharp: schedule_default3,
  "sharp-fill": schedule_fill_default3
};
var IconSchedule = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation75("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap65[key] ?? componentMap65[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx476(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/search-fill.svg
import * as React401 from "react";
import { jsx as jsx477 } from "react/jsx-runtime";
var SvgComponent401 = (props) => /* @__PURE__ */ jsx477("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx477("path", {
    d: "M795-93 526-361q-29 22.92-68.46 35.96Q418.08-312 372-312q-115.16 0-195.08-80Q97-472 97-585t80-193q80-80 193.5-80t193 80Q643-698 643-584.85q0 44.85-12.5 83.35Q618-463 593-429l270 268-68 68ZM371.35-406q74.9 0 126.28-52.25Q549-510.5 549-585t-51.52-126.75Q445.96-764 371.35-764q-75.43 0-127.89 52.25Q191-659.5 191-585t52.31 126.75Q295.62-406 371.35-406Z"
  })
});
var search_fill_default = SvgComponent401;

// ../../../node_modules/@material-symbols/svg-700/outlined/search.svg
import * as React402 from "react";
import { jsx as jsx478 } from "react/jsx-runtime";
var SvgComponent402 = (props) => /* @__PURE__ */ jsx478("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx478("path", {
    d: "M795-93 526-361q-29 22.92-68.46 35.96Q418.08-312 372-312q-115.16 0-195.08-80Q97-472 97-585t80-193q80-80 193.5-80t193 80Q643-698 643-584.85q0 44.85-12.5 83.35Q618-463 593-429l270 268-68 68ZM371.35-406q74.9 0 126.28-52.25Q549-510.5 549-585t-51.52-126.75Q445.96-764 371.35-764q-75.43 0-127.89 52.25Q191-659.5 191-585t52.31 126.75Q295.62-406 371.35-406Z"
  })
});
var search_default = SvgComponent402;

// ../../../node_modules/@material-symbols/svg-700/rounded/search-fill.svg
import * as React403 from "react";
import { jsx as jsx479 } from "react/jsx-runtime";
var SvgComponent403 = (props) => /* @__PURE__ */ jsx479("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx479("path", {
    d: "M372-312q-115.16 0-195.08-80Q97-472 97-585t80-193q80-80 193.5-80t193 80Q643-698 643-584.85q0 44.85-12.5 83.35Q618-463 593-429l236 234q14 14.56 14 34.28T829-127q-14.53 15-34.49 15-19.95 0-33.51-15L526-361q-29 22.92-68.46 35.96Q418.08-312 372-312Zm-.65-94q74.9 0 126.28-52.25Q549-510.5 549-585t-51.52-126.75Q445.96-764 371.35-764q-75.43 0-127.89 52.25Q191-659.5 191-585t52.31 126.75Q295.62-406 371.35-406Z"
  })
});
var search_fill_default2 = SvgComponent403;

// ../../../node_modules/@material-symbols/svg-700/rounded/search.svg
import * as React404 from "react";
import { jsx as jsx480 } from "react/jsx-runtime";
var SvgComponent404 = (props) => /* @__PURE__ */ jsx480("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx480("path", {
    d: "M372-312q-115.16 0-195.08-80Q97-472 97-585t80-193q80-80 193.5-80t193 80Q643-698 643-584.85q0 44.85-12.5 83.35Q618-463 593-429l236 234q14 14.56 14 34.28T829-127q-14.53 15-34.49 15-19.95 0-33.51-15L526-361q-29 22.92-68.46 35.96Q418.08-312 372-312Zm-.65-94q74.9 0 126.28-52.25Q549-510.5 549-585t-51.52-126.75Q445.96-764 371.35-764q-75.43 0-127.89 52.25Q191-659.5 191-585t52.31 126.75Q295.62-406 371.35-406Z"
  })
});
var search_default2 = SvgComponent404;

// ../../../node_modules/@material-symbols/svg-700/sharp/search-fill.svg
import * as React405 from "react";
import { jsx as jsx481 } from "react/jsx-runtime";
var SvgComponent405 = (props) => /* @__PURE__ */ jsx481("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx481("path", {
    d: "M795-93 526-361q-29 22.92-68.46 35.96Q418.08-312 372-312q-115.16 0-195.08-80Q97-472 97-585t80-193q80-80 193.5-80t193 80Q643-698 643-584.85q0 44.85-12.5 83.35Q618-463 593-429l270 268-68 68ZM371.35-406q74.9 0 126.28-52.25Q549-510.5 549-585t-51.52-126.75Q445.96-764 371.35-764q-75.43 0-127.89 52.25Q191-659.5 191-585t52.31 126.75Q295.62-406 371.35-406Z"
  })
});
var search_fill_default3 = SvgComponent405;

// ../../../node_modules/@material-symbols/svg-700/sharp/search.svg
import * as React406 from "react";
import { jsx as jsx482 } from "react/jsx-runtime";
var SvgComponent406 = (props) => /* @__PURE__ */ jsx482("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx482("path", {
    d: "M795-93 526-361q-29 22.92-68.46 35.96Q418.08-312 372-312q-115.16 0-195.08-80Q97-472 97-585t80-193q80-80 193.5-80t193 80Q643-698 643-584.85q0 44.85-12.5 83.35Q618-463 593-429l270 268-68 68ZM371.35-406q74.9 0 126.28-52.25Q549-510.5 549-585t-51.52-126.75Q445.96-764 371.35-764q-75.43 0-127.89 52.25Q191-659.5 191-585t52.31 126.75Q295.62-406 371.35-406Z"
  })
});
var search_default3 = SvgComponent406;

// src/components/icon/variants/IconSearch.tsx
import { useTranslation as useTranslation76 } from "react-i18next";
import { jsx as jsx483 } from "react/jsx-runtime";
var componentMap66 = {
  outlined: search_default,
  "outlined-fill": search_fill_default,
  rounded: search_default2,
  "rounded-fill": search_fill_default2,
  sharp: search_default3,
  "sharp-fill": search_fill_default3
};
var IconSearch = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation76("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap66[key] ?? componentMap66[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx483(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/send-fill.svg
import * as React407 from "react";
import { jsx as jsx484 } from "react/jsx-runtime";
var SvgComponent407 = (props) => /* @__PURE__ */ jsx484("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx484("path", {
    d: "M97-136v-248l336-96-336-98v-246l813 344L97-136Z"
  })
});
var send_fill_default = SvgComponent407;

// ../../../node_modules/@material-symbols/svg-700/outlined/send.svg
import * as React408 from "react";
import { jsx as jsx485 } from "react/jsx-runtime";
var SvgComponent408 = (props) => /* @__PURE__ */ jsx485("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx485("path", {
    d: "M97-136v-688l813 344L97-136Zm83-128 516-216-516-219v146l253 73-253 71v145Zm0 0v-435 435Z"
  })
});
var send_default = SvgComponent408;

// ../../../node_modules/@material-symbols/svg-700/rounded/send-fill.svg
import * as React409 from "react";
import { jsx as jsx486 } from "react/jsx-runtime";
var SvgComponent409 = (props) => /* @__PURE__ */ jsx486("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx486("path", {
    d: "M163-165q-24 10-45-3.5T97-207v-177l336-96-336-98v-175q0-25 21-38.5t45-4.5l644 272q29 12 29 44t-29 44L163-165Z"
  })
});
var send_fill_default2 = SvgComponent409;

// ../../../node_modules/@material-symbols/svg-700/rounded/send.svg
import * as React410 from "react";
import { jsx as jsx487 } from "react/jsx-runtime";
var SvgComponent410 = (props) => /* @__PURE__ */ jsx487("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx487("path", {
    d: "M807-436 163-165q-24 10-45-3.5T97-207v-546q0-25 21-38.5t45-4.5l644 272q29 12 29 44t-29 44ZM180-264l516-216-516-219v146l253 73-253 71v145Zm0 0v-435 435Z"
  })
});
var send_default2 = SvgComponent410;

// ../../../node_modules/@material-symbols/svg-700/sharp/send-fill.svg
import * as React411 from "react";
import { jsx as jsx488 } from "react/jsx-runtime";
var SvgComponent411 = (props) => /* @__PURE__ */ jsx488("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx488("path", {
    d: "M97-136v-248l336-96-336-98v-246l813 344L97-136Z"
  })
});
var send_fill_default3 = SvgComponent411;

// ../../../node_modules/@material-symbols/svg-700/sharp/send.svg
import * as React412 from "react";
import { jsx as jsx489 } from "react/jsx-runtime";
var SvgComponent412 = (props) => /* @__PURE__ */ jsx489("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx489("path", {
    d: "M97-136v-688l813 344L97-136Zm83-128 516-216-516-219v146l253 73-253 71v145Zm0 0v-435 435Z"
  })
});
var send_default3 = SvgComponent412;

// src/components/icon/variants/IconSend.tsx
import { useTranslation as useTranslation77 } from "react-i18next";
import { jsx as jsx490 } from "react/jsx-runtime";
var componentMap67 = {
  outlined: send_default,
  "outlined-fill": send_fill_default,
  rounded: send_default2,
  "rounded-fill": send_fill_default2,
  sharp: send_default3,
  "sharp-fill": send_fill_default3
};
var IconSend = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation77("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap67[key] ?? componentMap67[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx490(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/settings-fill.svg
import * as React413 from "react";
import { jsx as jsx491 } from "react/jsx-runtime";
var SvgComponent413 = (props) => /* @__PURE__ */ jsx491("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx491("path", {
    d: "m366-55-21-134q-13-4-29.5-13.5T288-221l-125 58L47-368l114-83q-1-6-1.5-14.5T159-480q0-6 .5-14.5T161-509L47-593l116-203 127 57q10-8 26-17t29-13l21-137h228l21 136q13 5 29.5 13.5T672-739l126-57 115 203-115 82q1 7 2 15.5t1 15.5q0 7-1 15t-2 15l115 82-116 205-126-58q-11 9-26.5 18.5T615-189L594-55H366Zm112-295q54 0 92-38t38-92q0-54-38-92t-92-38q-54 0-92 38t-38 92q0 54 38 92t92 38Z"
  })
});
var settings_fill_default = SvgComponent413;

// ../../../node_modules/@material-symbols/svg-700/outlined/settings.svg
import * as React414 from "react";
import { jsx as jsx492 } from "react/jsx-runtime";
var SvgComponent414 = (props) => /* @__PURE__ */ jsx492("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx492("path", {
    d: "m366-55-21-134q-13-4-29.5-13.5T288-221l-125 58L47-368l114-83q-1-6-1.5-14.5T159-480q0-6 .5-14.5T161-509L47-593l116-203 127 57q10-8 26-17t29-13l21-137h228l21 136q13 5 29.5 13.5T672-739l126-57 115 203-115 82q1 7 2 15.5t1 15.5q0 7-1 15t-2 15l115 82-116 205-126-58q-11 9-26.5 18.5T615-189L594-55H366Zm78-94h71l15-111q34-8 65-25t55-44l106 46 31-59-92-67q4-18 7-35.5t3-35.5q0-18-2.5-35.5T695-551l93-67-32-59-105 46q-23-28-54-47t-67-23l-14-110h-72l-13 110q-36 6-67.5 24.5T308-631l-104-46-32 59 91 66q-4 18-7 36t-3 36q0 18 3 36.5t7 35.5l-91 66 32 59 104-46q25 26 56.5 44t66.5 26l13 110Zm34-201q54 0 92-38t38-92q0-54-38-92t-92-38q-54 0-92 38t-38 92q0 54 38 92t92 38Zm2-130Z"
  })
});
var settings_default = SvgComponent414;

// ../../../node_modules/@material-symbols/svg-700/rounded/settings-fill.svg
import * as React415 from "react";
import { jsx as jsx493 } from "react/jsx-runtime";
var SvgComponent415 = (props) => /* @__PURE__ */ jsx493("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx493("path", {
    d: "M407-55q-17.84 0-31.51-10.63Q361.83-76.26 360-94l-15-95q-13-4-29.5-13.5T288-221l-85 40q-16.88 7-34.75 2.12Q150.37-183.77 141-201L69-331q-10-15-6-32.5T82-392l79-59q-1-6.04-1.5-14.5T159-480q0-6.04.5-14.5T161-509l-79-58q-16-11-19.5-28.5T69-629l72.38-130.19Q150-774 167.5-780q17.5-6 34.5 1l88 40q10-8 26-17t29-13l15-95.57Q362-884 375.61-895q13.62-11 31.39-11h146q17.84 0 31.51 10.92Q598.17-884.16 600-865l15 95q12.81 5.05 29.4 13.53Q661-748 672-739l85-40q17-7 34.5-1t26.38 20.84l74.24 130.32Q901-613 897.5-595q-3.5 18-19.5 28l-80 56q1 7 2 15.5t1 15.53q0 7.03-1 14.98-1 7.96-2 14.99l80 57q16 10 19.5 28t-5.37 33.59L819-201q-9.37 16.23-26.75 21.62Q774.88-174 758-181l-87-40q-11 9-26.5 18.5T615-189l-15 95q-1.83 17.74-15.49 28.37Q570.84-55 553-55H407Zm71-295q54 0 92-38t38-92q0-54-38-92t-92-38q-54 0-92 38t-38 92q0 54 38 92t92 38Z"
  })
});
var settings_fill_default2 = SvgComponent415;

// ../../../node_modules/@material-symbols/svg-700/rounded/settings.svg
import * as React416 from "react";
import { jsx as jsx494 } from "react/jsx-runtime";
var SvgComponent416 = (props) => /* @__PURE__ */ jsx494("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx494("path", {
    d: "M407-55q-18 0-31.5-10.5T360-94l-15-95q-13-4-29.5-13.5T288-221l-85 40q-17 7-35 2t-27-22L69-331q-10-15-6-32.5T82-392l79-59q-1-6-1.5-14.5T159-480q0-6 .5-14.5T161-509l-79-58q-16-11-19.5-28.5T69-629l72-130q9-15 26.5-21t34.5 1l88 40q10-8 26-17t29-13l15-96q2-19 15.5-30t31.5-11h146q18 0 31.5 11t15.5 30l15 95q13 5 29.5 13.5T672-739l85-40q17-7 34.5-1t26.5 21l74 130q9 16 5.5 34T878-567l-80 56q1 7 2 15.5t1 15.5q0 7-1 15t-2 15l80 57q16 10 19.5 28t-5.5 34l-73 130q-9 16-26.5 21.5T758-181l-87-40q-11 9-26.5 18.5T615-189l-15 95q-2 18-15.5 28.5T553-55H407Zm37-94h71l15-111q34-8 65-25t55-44l106 46 31-59-92-67q4-18 7-35.5t3-35.5q0-18-2.5-35.5T695-551l93-67-32-59-105 46q-23-28-54-47t-67-23l-14-110h-72l-13 110q-36 6-67.5 24.5T308-631l-104-46-32 59 91 66q-4 18-7 36t-3 36q0 18 3 36.5t7 35.5l-91 66 32 59 104-46q25 26 56.5 44t66.5 26l13 110Zm34-201q54 0 92-38t38-92q0-54-38-92t-92-38q-54 0-92 38t-38 92q0 54 38 92t92 38Zm2-130Z"
  })
});
var settings_default2 = SvgComponent416;

// ../../../node_modules/@material-symbols/svg-700/sharp/settings-fill.svg
import * as React417 from "react";
import { jsx as jsx495 } from "react/jsx-runtime";
var SvgComponent417 = (props) => /* @__PURE__ */ jsx495("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx495("path", {
    d: "m366-55-21-134q-13-4-29.5-13.5T288-221l-125 58L47-368l114-83q-1-6-1.5-14.5T159-480q0-6 .5-14.5T161-509L47-593l116-203 127 57q10-8 26-17t29-13l21-137h228l21 136q13 5 29.5 13.5T672-739l126-57 115 203-115 82q1 7 2 15.5t1 15.5q0 7-1 15t-2 15l115 82-116 205-126-58q-11 9-26.5 18.5T615-189L594-55H366Zm112-295q54 0 92-38t38-92q0-54-38-92t-92-38q-54 0-92 38t-38 92q0 54 38 92t92 38Z"
  })
});
var settings_fill_default3 = SvgComponent417;

// ../../../node_modules/@material-symbols/svg-700/sharp/settings.svg
import * as React418 from "react";
import { jsx as jsx496 } from "react/jsx-runtime";
var SvgComponent418 = (props) => /* @__PURE__ */ jsx496("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx496("path", {
    d: "m366-55-21-134q-13-4-29.5-13.5T288-221l-125 58L47-368l114-83q-1-6-1.5-14.5T159-480q0-6 .5-14.5T161-509L47-593l116-203 127 57q10-8 26-17t29-13l21-137h228l21 136q13 5 29.5 13.5T672-739l126-57 115 203-115 82q1 7 2 15.5t1 15.5q0 7-1 15t-2 15l115 82-116 205-126-58q-11 9-26.5 18.5T615-189L594-55H366Zm78-94h71l15-111q34-8 65-25t55-44l106 46 31-59-92-67q4-18 7-35.5t3-35.5q0-18-2.5-35.5T695-551l93-67-32-59-105 46q-23-28-54-47t-67-23l-14-110h-72l-13 110q-36 6-67.5 24.5T308-631l-104-46-32 59 91 66q-4 18-7 36t-3 36q0 18 3 36.5t7 35.5l-91 66 32 59 104-46q25 26 56.5 44t66.5 26l13 110Zm34-201q54 0 92-38t38-92q0-54-38-92t-92-38q-54 0-92 38t-38 92q0 54 38 92t92 38Zm2-130Z"
  })
});
var settings_default3 = SvgComponent418;

// src/components/icon/variants/IconSettings.tsx
import { useTranslation as useTranslation78 } from "react-i18next";
import { jsx as jsx497 } from "react/jsx-runtime";
var componentMap68 = {
  outlined: settings_default,
  "outlined-fill": settings_fill_default,
  rounded: settings_default2,
  "rounded-fill": settings_fill_default2,
  sharp: settings_default3,
  "sharp-fill": settings_fill_default3
};
var IconSettings = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation78("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap68[key] ?? componentMap68[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx497(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/shopping_bag-fill.svg
import * as React419 from "react";
import { jsx as jsx498 } from "react/jsx-runtime";
var SvgComponent419 = (props) => /* @__PURE__ */ jsx498("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx498("path", {
    d: "M229-55q-39.05 0-66.52-27.47Q135-109.95 135-149v-490q0-39.46 27.48-67.23Q189.95-734 229-734h84v-10q2-68 50.5-115T480-906q68 0 116.5 47T647-744v10h84q39.46 0 67.23 27.77Q826-678.46 826-639v490q0 39.05-27.77 66.53Q770.46-55 731-55H229Zm179-679h144v-10q-2-28-22.5-47.5T480-811q-29 0-49.5 19.5T408-744v10Zm192 215q20 0 33.5-13.5T647-566v-73h-94v73q0 20 13.5 33.5T600-519Zm-240 0q20 0 33.5-13.5T407-566v-73h-94v73q0 20 13.5 33.5T360-519Z"
  })
});
var shopping_bag_fill_default = SvgComponent419;

// ../../../node_modules/@material-symbols/svg-700/outlined/shopping_bag.svg
import * as React420 from "react";
import { jsx as jsx499 } from "react/jsx-runtime";
var SvgComponent420 = (props) => /* @__PURE__ */ jsx499("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx499("path", {
    d: "M229-55q-39.05 0-66.52-27.47Q135-109.95 135-149v-490q0-39.46 27.48-67.23Q189.95-734 229-734h84v-10q2-68 50.32-115 48.33-47 116.5-47 68.18 0 116.68 47T647-744v10h84q39.46 0 67.23 27.77Q826-678.46 826-639v490q0 39.05-27.77 66.53Q770.46-55 731-55H229Zm0-94h502v-490h-84v73q0 19.75-13.68 33.37Q619.65-519 599.82-519q-19.82 0-33.32-13.63Q553-546.25 553-566v-73H407v73q0 19.75-13.68 33.37Q379.65-519 359.82-519q-19.82 0-33.32-13.63Q313-546.25 313-566v-73h-84v490Zm179-585h144v-10q-2-28-22.6-47.5-20.59-19.5-49.5-19.5-28.9 0-49.4 19.5T408-744v10ZM229-149v-490 490Z"
  })
});
var shopping_bag_default = SvgComponent420;

// ../../../node_modules/@material-symbols/svg-700/rounded/shopping_bag-fill.svg
import * as React421 from "react";
import { jsx as jsx500 } from "react/jsx-runtime";
var SvgComponent421 = (props) => /* @__PURE__ */ jsx500("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx500("path", {
    d: "M229-55q-39.05 0-66.52-27.47Q135-109.95 135-149v-490q0-39.46 27.48-67.23Q189.95-734 229-734h84v-10q2-68 50.5-115T480-906q68 0 116.5 47T647-744v10h84q39.46 0 67.23 27.77Q826-678.46 826-639v490q0 39.05-27.77 66.53Q770.46-55 731-55H229Zm179-679h144v-10q-2-28-22.5-47.5T480-811q-29 0-49.5 19.5T408-744v10Zm192 215q20 0 33.5-13.5T647-566v-73h-94v73q0 20 13.5 33.5T600-519Zm-240 0q20 0 33.5-13.5T407-566v-73h-94v73q0 20 13.5 33.5T360-519Z"
  })
});
var shopping_bag_fill_default2 = SvgComponent421;

// ../../../node_modules/@material-symbols/svg-700/rounded/shopping_bag.svg
import * as React422 from "react";
import { jsx as jsx501 } from "react/jsx-runtime";
var SvgComponent422 = (props) => /* @__PURE__ */ jsx501("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx501("path", {
    d: "M229-55q-39.05 0-66.52-27.47Q135-109.95 135-149v-490q0-39.46 27.48-67.23Q189.95-734 229-734h84v-10q2-68 50.32-115 48.33-47 116.5-47 68.18 0 116.68 47T647-744v10h84q39.46 0 67.23 27.77Q826-678.46 826-639v490q0 39.05-27.77 66.53Q770.46-55 731-55H229Zm0-94h502v-490h-84v73q0 19.75-13.68 33.37Q619.65-519 599.82-519q-19.82 0-33.32-13.63Q553-546.25 553-566v-73H407v73q0 19.75-13.68 33.37Q379.65-519 359.82-519q-19.82 0-33.32-13.63Q313-546.25 313-566v-73h-84v490Zm179-585h144v-10q-2-28-22.6-47.5-20.59-19.5-49.5-19.5-28.9 0-49.4 19.5T408-744v10ZM229-149v-490 490Z"
  })
});
var shopping_bag_default2 = SvgComponent422;

// ../../../node_modules/@material-symbols/svg-700/sharp/shopping_bag-fill.svg
import * as React423 from "react";
import { jsx as jsx502 } from "react/jsx-runtime";
var SvgComponent423 = (props) => /* @__PURE__ */ jsx502("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx502("path", {
    d: "M135-55v-679h178v-10q2-68 50.32-115 48.33-47 116.5-47 68.18 0 116.68 47T647-744v10h179v679H135Zm273-679h144v-10q-2-28-22.6-47.5-20.59-19.5-49.5-19.5-28.9 0-49.4 19.5T408-744v10Zm-95 215h94v-120h-94v120Zm240 0h94v-120h-94v120Z"
  })
});
var shopping_bag_fill_default3 = SvgComponent423;

// ../../../node_modules/@material-symbols/svg-700/sharp/shopping_bag.svg
import * as React424 from "react";
import { jsx as jsx503 } from "react/jsx-runtime";
var SvgComponent424 = (props) => /* @__PURE__ */ jsx503("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx503("path", {
    d: "M135-55v-679h178v-10q2-68 50.32-115 48.33-47 116.5-47 68.18 0 116.68 47T647-744v10h179v679H135Zm94-94h502v-490h-84v120h-94v-120H407v120h-94v-120h-84v490Zm179-585h144v-10q-2-28-22.6-47.5-20.59-19.5-49.5-19.5-28.9 0-49.4 19.5T408-744v10ZM229-149v-490 490Z"
  })
});
var shopping_bag_default3 = SvgComponent424;

// src/components/icon/variants/IconShoppingBag.tsx
import { useTranslation as useTranslation79 } from "react-i18next";
import { jsx as jsx504 } from "react/jsx-runtime";
var componentMap69 = {
  outlined: shopping_bag_default,
  "outlined-fill": shopping_bag_fill_default,
  rounded: shopping_bag_default2,
  "rounded-fill": shopping_bag_fill_default2,
  sharp: shopping_bag_default3,
  "sharp-fill": shopping_bag_fill_default3
};
var IconShoppingBag = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation79("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap69[key] ?? componentMap69[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx504(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/sms-fill.svg
import * as React425 from "react";
import { jsx as jsx505 } from "react/jsx-runtime";
var SvgComponent425 = (props) => /* @__PURE__ */ jsx505("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx505("path", {
    d: "M55-55v-756q0-39.46 27.47-67.23Q109.95-906 149-906h662q39.46 0 67.23 27.77Q906-850.46 906-811v502q0 39.05-27.77 66.52Q850.46-215 811-215H215L55-55Zm239.12-459Q315-514 329-528.12q14-14.13 14-35Q343-584 328.88-598q-14.13-14-35-14Q273-612 259-597.88q-14 14.13-14 35Q245-542 259.12-528q14.13 14 35 14Zm189 0Q504-514 518-528.12q14-14.13 14-35Q532-584 517.88-598q-14.13-14-35-14Q462-612 448-597.88q-14 14.13-14 35Q434-542 448.12-528q14.13 14 35 14Zm182 0Q686-514 700-528.12q14-14.13 14-35Q714-584 699.88-598q-14.13-14-35-14Q644-612 630-597.88q-14 14.13-14 35Q616-542 630.12-528q14.13 14 35 14Z"
  })
});
var sms_fill_default = SvgComponent425;

// ../../../node_modules/@material-symbols/svg-700/outlined/sms.svg
import * as React426 from "react";
import { jsx as jsx506 } from "react/jsx-runtime";
var SvgComponent426 = (props) => /* @__PURE__ */ jsx506("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx506("path", {
    d: "M294.12-514Q315-514 329-528.12q14-14.13 14-35Q343-584 328.88-598q-14.13-14-35-14Q273-612 259-597.88q-14 14.13-14 35Q245-542 259.12-528q14.13 14 35 14Zm189 0Q504-514 518-528.12q14-14.13 14-35Q532-584 517.88-598q-14.13-14-35-14Q462-612 448-597.88q-14 14.13-14 35Q434-542 448.12-528q14.13 14 35 14Zm182 0Q686-514 700-528.12q14-14.13 14-35Q714-584 699.88-598q-14.13-14-35-14Q644-612 630-597.88q-14 14.13-14 35Q616-542 630.12-528q14.13 14 35 14ZM55-55v-756q0-39.46 27.47-67.23Q109.95-906 149-906h662q39.46 0 67.23 27.77Q906-850.46 906-811v502q0 39.05-27.77 66.52Q850.46-215 811-215H215L55-55Zm134-254h622v-502H149v548l40-46Zm-40 0v-502 502Z"
  })
});
var sms_default = SvgComponent426;

// ../../../node_modules/@material-symbols/svg-700/rounded/sms-fill.svg
import * as React427 from "react";
import { jsx as jsx507 } from "react/jsx-runtime";
var SvgComponent427 = (props) => /* @__PURE__ */ jsx507("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx507("path", {
    d: "m215-215-79 79q-23 23-52 10.97T55-168v-643q0-39.46 27.47-67.23Q109.95-906 149-906h662q39.46 0 67.23 27.77Q906-850.46 906-811v502q0 39.05-27.77 66.52Q850.46-215 811-215H215Zm79.12-299Q315-514 329-528.12q14-14.13 14-35Q343-584 328.88-598q-14.13-14-35-14Q273-612 259-597.88q-14 14.13-14 35Q245-542 259.12-528q14.13 14 35 14Zm189 0Q504-514 518-528.12q14-14.13 14-35Q532-584 517.88-598q-14.13-14-35-14Q462-612 448-597.88q-14 14.13-14 35Q434-542 448.12-528q14.13 14 35 14Zm182 0Q686-514 700-528.12q14-14.13 14-35Q714-584 699.88-598q-14.13-14-35-14Q644-612 630-597.88q-14 14.13-14 35Q616-542 630.12-528q14.13 14 35 14Z"
  })
});
var sms_fill_default2 = SvgComponent427;

// ../../../node_modules/@material-symbols/svg-700/rounded/sms.svg
import * as React428 from "react";
import { jsx as jsx508 } from "react/jsx-runtime";
var SvgComponent428 = (props) => /* @__PURE__ */ jsx508("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx508("path", {
    d: "m215-215-79 79q-23 23-52 10.97T55-168v-643q0-39.46 27.47-67.23Q109.95-906 149-906h662q39.46 0 67.23 27.77Q906-850.46 906-811v502q0 39.05-27.77 66.52Q850.46-215 811-215H215Zm-26-94h622v-502H149v548l40-46Zm-40 0v-502 502Zm145.12-205Q315-514 329-528.12q14-14.13 14-35Q343-584 328.88-598q-14.13-14-35-14Q273-612 259-597.88q-14 14.13-14 35Q245-542 259.12-528q14.13 14 35 14Zm189 0Q504-514 518-528.12q14-14.13 14-35Q532-584 517.88-598q-14.13-14-35-14Q462-612 448-597.88q-14 14.13-14 35Q434-542 448.12-528q14.13 14 35 14Zm182 0Q686-514 700-528.12q14-14.13 14-35Q714-584 699.88-598q-14.13-14-35-14Q644-612 630-597.88q-14 14.13-14 35Q616-542 630.12-528q14.13 14 35 14Z"
  })
});
var sms_default2 = SvgComponent428;

// ../../../node_modules/@material-symbols/svg-700/sharp/sms-fill.svg
import * as React429 from "react";
import { jsx as jsx509 } from "react/jsx-runtime";
var SvgComponent429 = (props) => /* @__PURE__ */ jsx509("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx509("path", {
    d: "M55-55v-851h851v691H215L55-55Zm239.12-459Q315-514 329-528.12q14-14.13 14-35Q343-584 328.88-598q-14.13-14-35-14Q273-612 259-597.88q-14 14.13-14 35Q245-542 259.12-528q14.13 14 35 14Zm189 0Q504-514 518-528.12q14-14.13 14-35Q532-584 517.88-598q-14.13-14-35-14Q462-612 448-597.88q-14 14.13-14 35Q434-542 448.12-528q14.13 14 35 14Zm182 0Q686-514 700-528.12q14-14.13 14-35Q714-584 699.88-598q-14.13-14-35-14Q644-612 630-597.88q-14 14.13-14 35Q616-542 630.12-528q14.13 14 35 14Z"
  })
});
var sms_fill_default3 = SvgComponent429;

// ../../../node_modules/@material-symbols/svg-700/sharp/sms.svg
import * as React430 from "react";
import { jsx as jsx510 } from "react/jsx-runtime";
var SvgComponent430 = (props) => /* @__PURE__ */ jsx510("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx510("path", {
    d: "M294.12-514Q315-514 329-528.12q14-14.13 14-35Q343-584 328.88-598q-14.13-14-35-14Q273-612 259-597.88q-14 14.13-14 35Q245-542 259.12-528q14.13 14 35 14Zm189 0Q504-514 518-528.12q14-14.13 14-35Q532-584 517.88-598q-14.13-14-35-14Q462-612 448-597.88q-14 14.13-14 35Q434-542 448.12-528q14.13 14 35 14Zm182 0Q686-514 700-528.12q14-14.13 14-35Q714-584 699.88-598q-14.13-14-35-14Q644-612 630-597.88q-14 14.13-14 35Q616-542 630.12-528q14.13 14 35 14ZM55-55v-851h851v691H215L55-55Zm134-254h622v-502H149v548l40-46Zm-40 0v-502 502Z"
  })
});
var sms_default3 = SvgComponent430;

// src/components/icon/variants/IconSms.tsx
import { useTranslation as useTranslation80 } from "react-i18next";
import { jsx as jsx511 } from "react/jsx-runtime";
var componentMap70 = {
  outlined: sms_default,
  "outlined-fill": sms_fill_default,
  rounded: sms_default2,
  "rounded-fill": sms_fill_default2,
  sharp: sms_default3,
  "sharp-fill": sms_fill_default3
};
var IconSms = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation80("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap70[key] ?? componentMap70[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx511(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/stethoscope-fill.svg
import * as React431 from "react";
import { jsx as jsx512 } from "react/jsx-runtime";
var SvgComponent431 = (props) => /* @__PURE__ */ jsx512("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx512("path", {
    d: "M553-36q-129 0-214-90.37T254-344v-19q-100-16-167-90.52Q20-528.03 20-631v-247h147v-47h95v189h-95v-47h-52v152q0 75 53 126t128.54 51q75.54 0 129-51Q479-556 479-631v-152h-53v47h-94v-189h94v47h147v247q0 101-64.5 175T348-365v21q0 86.75 58.04 149.87Q464.09-131 553.29-131 637-131 697-193q60-62 60-151v-70q-39-15-64-49.56t-25-78.5q0-56.81 39.21-96.37Q746.42-678 803.5-678q57.08 0 96.79 39.57Q940-598.87 940-542.06q0 43.94-25 78.5T851-414v70q0 128.45-87 218.22Q677-36 553-36Z"
  })
});
var stethoscope_fill_default = SvgComponent431;

// ../../../node_modules/@material-symbols/svg-700/outlined/stethoscope.svg
import * as React432 from "react";
import { jsx as jsx513 } from "react/jsx-runtime";
var SvgComponent432 = (props) => /* @__PURE__ */ jsx513("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx513("path", {
    d: "M553-36q-129 0-214-90.37T254-344v-19q-100-16-167-90.73Q20-528.45 20-631v-247h147v-47h95v189h-95v-47h-52v151.68Q115-556 168-505t128.54 51q75.54 0 129-51Q479-556 479-631.32V-783h-53v47h-94v-189h94v47h147v247q0 100.58-64.5 174.79T348-365v21q0 86.75 58.04 149.87Q464.09-131 553.29-131 637-131 697-193.15q60-62.15 60-151.08V-414q-39-15-64-49.56t-25-78.5q0-56.64 39.33-96.29Q746.65-678 803.62-678q56.96 0 96.67 39.65T940-542.06q0 43.94-25 78.5T851-414v70q0 128.45-87 218.22Q677-36 553-36Zm250.82-458Q824-494 838-507.82q14-13.83 14-34Q852-562 838.18-576q-13.83-14-34-14Q784-590 770-576.18q-14 13.83-14 34Q756-522 769.82-508q13.83 14 34 14Zm.18-48Z"
  })
});
var stethoscope_default = SvgComponent432;

// ../../../node_modules/@material-symbols/svg-700/rounded/stethoscope-fill.svg
import * as React433 from "react";
import { jsx as jsx514 } from "react/jsx-runtime";
var SvgComponent433 = (props) => /* @__PURE__ */ jsx514("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx514("path", {
    d: "M553-36q-129 0-214-90.5T254-344v-19q-100-16-167-90.5T20-631v-199q0-19.88 13.5-33.94Q47-878 67-878h101v-10q3-16 15.79-26.5t30-10.5Q234-925 248-911.5t14 33.5v95.05q0 19.95-14.09 33.45-14.09 13.5-34 13.5Q197-736 184-746t-16-27v-10h-53v152q0 75 53 126t128.54 51q75.54 0 129-51Q479-556 479-631v-152h-54v10q-3 16-15.79 26.5t-30 10.5q-20.21 0-33.71-13.5T332-783v-95q0-20 13.5-33.5t33.71-13.5q17.21 0 30 10.5T425-888v10h101q20 0 33.5 14.06T573-830v199q0 101-64.5 175T348-365v21q0 86.75 57.79 149.87Q463.59-131 553.29-131 637-131 697-193q60-62 60-151v-70q-39-14-64-49t-25-79.06q0-57.22 39-96.58T803.5-678q57.5 0 97 39.36t39.5 96.58Q940-498 915-463t-64 49v70q0 128.18-87 218.09T553-36Z"
  })
});
var stethoscope_fill_default2 = SvgComponent433;

// ../../../node_modules/@material-symbols/svg-700/rounded/stethoscope.svg
import * as React434 from "react";
import { jsx as jsx515 } from "react/jsx-runtime";
var SvgComponent434 = (props) => /* @__PURE__ */ jsx515("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx515("path", {
    d: "M553-36q-129 0-214-90.5T254-344v-19q-100-16-167-90.71T20-631v-199q0-19.63 13.63-33.81Q47.25-878 67-878h101v-10q3-15.75 15.96-26.38 12.97-10.62 30-10.62Q234-925 248-911.38q14 13.63 14 33.38v95.05q0 19.95-14.26 33.45-14.27 13.5-34 13.5Q197-736 184-746.13q-13-10.12-16-26.87v-10h-53v152q0 75 53 126t128.54 51q75.54 0 129-51Q479-556 479-631v-152h-54v10q-3 16-15.96 26.5-12.97 10.5-30 10.5-20.04 0-33.54-13.63Q332-763.25 332-783v-95q0-19.75 13.68-33.38Q359.35-925 379.39-925q17.03 0 29.82 10.62Q422-903.75 425-888v10h101q19.75 0 33.38 14.19Q573-849.63 573-830v199q0 100.58-64.5 174.79T348-365v21q0 86.75 57.79 149.87Q463.59-131 553.29-131 637-131 697-193.15q60-62.15 60-151.08V-414q-39-14-64-49t-25-79.06q0-57.06 39.12-96.5t96.5-39.44q57.38 0 96.88 39.44 39.5 39.44 39.5 96.5Q940-498 915-463t-64 49v70q0 128.18-87 218.09T553-36Zm250.82-458Q824-494 838-507.82q14-13.83 14-34Q852-562 838.18-576q-13.83-14-34-14Q784-590 770-576.18q-14 13.83-14 34Q756-522 769.82-508q13.83 14 34 14Zm.18-48Z"
  })
});
var stethoscope_default2 = SvgComponent434;

// ../../../node_modules/@material-symbols/svg-700/sharp/stethoscope-fill.svg
import * as React435 from "react";
import { jsx as jsx516 } from "react/jsx-runtime";
var SvgComponent435 = (props) => /* @__PURE__ */ jsx516("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx516("path", {
    d: "M553-36q-129 0-214-90.37T254-344v-19q-100-16-167-90.52Q20-528.03 20-631v-247h147v-47h95v189h-95v-47h-52v152q0 75 53 126t128.54 51q75.54 0 129-51Q479-556 479-631v-152h-53v47h-94v-189h94v47h147v247q0 101-64.5 175T348-365v21q0 86.75 58.04 149.87Q464.09-131 553.29-131 637-131 697-193q60-62 60-151v-70q-39-15-64-49.56t-25-78.5q0-56.81 39.21-96.37Q746.42-678 803.5-678q57.08 0 96.79 39.57Q940-598.87 940-542.06q0 43.94-25 78.5T851-414v70q0 128.45-87 218.22Q677-36 553-36Z"
  })
});
var stethoscope_fill_default3 = SvgComponent435;

// ../../../node_modules/@material-symbols/svg-700/sharp/stethoscope.svg
import * as React436 from "react";
import { jsx as jsx517 } from "react/jsx-runtime";
var SvgComponent436 = (props) => /* @__PURE__ */ jsx517("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx517("path", {
    d: "M553-36q-129 0-214-90.37T254-344v-19q-100-16-167-90.73Q20-528.45 20-631v-247h147v-47h95v189h-95v-47h-52v151.68Q115-556 168-505t128.54 51q75.54 0 129-51Q479-556 479-631.32V-783h-53v47h-94v-189h94v47h147v247q0 100.58-64.5 174.79T348-365v21q0 86.75 58.04 149.87Q464.09-131 553.29-131 637-131 697-193.15q60-62.15 60-151.08V-414q-39-15-64-49.56t-25-78.5q0-56.64 39.33-96.29Q746.65-678 803.62-678q56.96 0 96.67 39.65T940-542.06q0 43.94-25 78.5T851-414v70q0 128.45-87 218.22Q677-36 553-36Zm250.82-458Q824-494 838-507.82q14-13.83 14-34Q852-562 838.18-576q-13.83-14-34-14Q784-590 770-576.18q-14 13.83-14 34Q756-522 769.82-508q13.83 14 34 14Zm.18-48Z"
  })
});
var stethoscope_default3 = SvgComponent436;

// src/components/icon/variants/IconStethoscope.tsx
import { useTranslation as useTranslation81 } from "react-i18next";
import { jsx as jsx518 } from "react/jsx-runtime";
var componentMap71 = {
  outlined: stethoscope_default,
  "outlined-fill": stethoscope_fill_default,
  rounded: stethoscope_default2,
  "rounded-fill": stethoscope_fill_default2,
  sharp: stethoscope_default3,
  "sharp-fill": stethoscope_fill_default3
};
var IconStethoscope = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation81("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap71[key] ?? componentMap71[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx518(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/support_agent-fill.svg
import * as React437 from "react";
import { jsx as jsx519 } from "react/jsx-runtime";
var SvgComponent437 = (props) => /* @__PURE__ */ jsx519("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx519("path", {
    d: "M423-95v-94h347v-305q0-115.61-85.19-194.81Q599.61-768 481-768q-119.36 0-205.18 79.66Q190-608.69 190-493v269h-41q-38.78 0-66.39-26.68T55-316.5V-409q0-21.72 11-40.86T95-482v-20q2-76 33.5-142.5T212-760q52-49 120.89-77.5t147-28.5Q558-866 627-837.5 696-809 748-760t83.5 115.5Q863-578 865-501l1 19q18 12 29 30.86 11 18.85 11 41.14v94q0 25-10 47.5T866-233v45q0 37.8-26.62 65.4Q812.75-95 775-95H423Zm-54.09-295q-14.49 0-24.2-9.68-9.71-9.69-9.71-24 0-14.32 9.8-23.82t24.29-9.5q14.49 0 24.2 9.51 9.71 9.52 9.71 23.58 0 14.49-9.8 24.2-9.8 9.71-24.29 9.71Zm222 0q-14.49 0-24.2-9.68-9.71-9.69-9.71-24 0-14.32 9.8-23.82t24.29-9.5q14.49 0 24.2 9.51 9.71 9.52 9.71 23.58 0 14.49-9.8 24.2-9.8 9.71-24.29 9.71ZM250-482q-4-96 65.15-162.5Q384.29-711 481-711q81.59 0 142.29 53.5Q684-604 698-523q-79-1-147.5-38T440.72-666Q422-597 370.5-549T250-482Z"
  })
});
var support_agent_fill_default = SvgComponent437;

// ../../../node_modules/@material-symbols/svg-700/outlined/support_agent.svg
import * as React438 from "react";
import { jsx as jsx520 } from "react/jsx-runtime";
var SvgComponent438 = (props) => /* @__PURE__ */ jsx520("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx520("path", {
    d: "M423-95v-94h347v-305q0-115.61-85.19-194.81Q599.61-768 481-768q-119.36 0-205.18 79.66Q190-608.69 190-493v269h-41q-38.78 0-66.39-26.68T55-316.5V-409q0-21.72 11-40.86T95-482v-20q2-76 33.5-142.5T212-760q52-49 120.89-77.5t147-28.5Q558-866 627-837.5 696-809 748-760t83.5 115.5Q863-578 865-501l1 19q18 12 29 30.86 11 18.85 11 41.14v94q0 25-10 47.5T866-233v45q0 37.8-26.62 65.4Q812.75-95 775-95H423Zm-54.09-295q-14.49 0-24.2-9.68-9.71-9.69-9.71-24 0-14.32 9.8-23.82t24.29-9.5q14.49 0 24.2 9.51 9.71 9.52 9.71 23.58 0 14.49-9.8 24.2-9.8 9.71-24.29 9.71Zm222 0q-14.49 0-24.2-9.68-9.71-9.69-9.71-24 0-14.32 9.8-23.82t24.29-9.5q14.49 0 24.2 9.51 9.71 9.52 9.71 23.58 0 14.49-9.8 24.2-9.8 9.71-24.29 9.71ZM250-482q-4-96 65.15-162.5Q384.29-711 481-711q81.59 0 142.29 53.5Q684-604 698-523q-79-1-147.5-38T440.72-666Q422-597 370.5-549T250-482Z"
  })
});
var support_agent_default = SvgComponent438;

// ../../../node_modules/@material-symbols/svg-700/rounded/support_agent-fill.svg
import * as React439 from "react";
import { jsx as jsx521 } from "react/jsx-runtime";
var SvgComponent439 = (props) => /* @__PURE__ */ jsx521("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx521("path", {
    d: "M470-95q-19.75 0-33.37-13.68Q423-122.35 423-142.18q0-19.82 13.63-33.32Q450.25-189 470-189h300v-305q0-115.61-85.19-194.81Q599.61-768 481-768q-119.36 0-205.18 79.66Q190-608.69 190-493v232q0 16.5-10.75 26.75T153-224h-4q-38.94 0-66.47-26.68T55-316.5V-409q0-22 11-41t29-32v-20q2-76 33.5-142.5T212-760q52-49 120.89-77.5t147-28.5Q558-866 627-837.5 696-809 748-760t83.5 115.5Q863-578 865-501l1 19q18 12 29 30.86 11 18.85 11 41.14v94q0 24.57-10 47.29Q886-246 866-233v45q0 37.8-26.62 65.4Q812.75-95 775-95H470ZM368.82-390q-14.4 0-24.11-9.77-9.71-9.77-9.71-24t9.89-23.73q9.89-9.5 24.29-9.5 14.4 0 24.11 9.6 9.71 9.6 9.71 23.58 0 14.4-9.89 24.11-9.89 9.71-24.29 9.71Zm222 0q-14.4 0-24.11-9.77-9.71-9.77-9.71-24t9.89-23.73q9.89-9.5 24.29-9.5 14.4 0 24.11 9.6 9.71 9.6 9.71 23.58 0 14.4-9.89 24.11-9.89 9.71-24.29 9.71ZM250-482q-4-96 65.15-162.5Q384.29-711 481-711q81.59 0 142.29 53.5Q684-604 698-523q-79-1-147.5-38T440.72-666Q422-597 370.5-549T250-482Z"
  })
});
var support_agent_fill_default2 = SvgComponent439;

// ../../../node_modules/@material-symbols/svg-700/rounded/support_agent.svg
import * as React440 from "react";
import { jsx as jsx522 } from "react/jsx-runtime";
var SvgComponent440 = (props) => /* @__PURE__ */ jsx522("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx522("path", {
    d: "M470-95q-19.75 0-33.37-13.68Q423-122.35 423-142.18q0-19.82 13.63-33.32Q450.25-189 470-189h300v-305q0-115.61-85.19-194.81Q599.61-768 481-768q-119.36 0-205.18 79.66Q190-608.69 190-493v232q0 16.5-10.75 26.75T153-224h-4q-38.94 0-66.47-26.68T55-316.5V-409q0-22 11-41t29-32v-20q2-76 33.5-142.5T212-760q52-49 120.89-77.5t147-28.5Q558-866 627-837.5 696-809 748-760t83.5 115.5Q863-578 865-501l1 19q18 12 29 30.86 11 18.85 11 41.14v94q0 24.57-10 47.29Q886-246 866-233v45q0 37.8-26.62 65.4Q812.75-95 775-95H470ZM368.82-390q-14.4 0-24.11-9.77-9.71-9.77-9.71-24t9.89-23.73q9.89-9.5 24.29-9.5 14.4 0 24.11 9.6 9.71 9.6 9.71 23.58 0 14.4-9.89 24.11-9.89 9.71-24.29 9.71Zm222 0q-14.4 0-24.11-9.77-9.71-9.77-9.71-24t9.89-23.73q9.89-9.5 24.29-9.5 14.4 0 24.11 9.6 9.71 9.6 9.71 23.58 0 14.4-9.89 24.11-9.89 9.71-24.29 9.71ZM250-482q-4-96 65.15-162.5Q384.29-711 481-711q81.59 0 142.29 53.5Q684-604 698-523q-79-1-147.5-38T440.72-666Q422-597 370.5-549T250-482Z"
  })
});
var support_agent_default2 = SvgComponent440;

// ../../../node_modules/@material-symbols/svg-700/sharp/support_agent-fill.svg
import * as React441 from "react";
import { jsx as jsx523 } from "react/jsx-runtime";
var SvgComponent441 = (props) => /* @__PURE__ */ jsx523("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx523("path", {
    d: "M423-95v-94h347v-305q0-115.61-85.19-194.81Q599.61-768 481-768q-119.36 0-205.18 79.66Q190-608.69 190-493v269H55v-258h40v-20q2-76 33.5-142.5T212-760q52-49 120.89-77.5t147-28.5Q558-866 627-837.5 696-809 748-760t83.5 115.5Q863-578 865-501l1 19h40v258h-40v129H423Zm-54.09-295q-14.49 0-24.2-9.68-9.71-9.69-9.71-24 0-14.32 9.8-23.82t24.29-9.5q14.49 0 24.2 9.51 9.71 9.52 9.71 23.58 0 14.49-9.8 24.2-9.8 9.71-24.29 9.71Zm222 0q-14.49 0-24.2-9.68-9.71-9.69-9.71-24 0-14.32 9.8-23.82t24.29-9.5q14.49 0 24.2 9.51 9.71 9.52 9.71 23.58 0 14.49-9.8 24.2-9.8 9.71-24.29 9.71ZM250-482q-4-96 65.15-162.5Q384.29-711 481-711q81.59 0 142.29 53.5Q684-604 698-523q-79-1-147.5-38T440.72-666Q422-597 370.5-549T250-482Z"
  })
});
var support_agent_fill_default3 = SvgComponent441;

// ../../../node_modules/@material-symbols/svg-700/sharp/support_agent.svg
import * as React442 from "react";
import { jsx as jsx524 } from "react/jsx-runtime";
var SvgComponent442 = (props) => /* @__PURE__ */ jsx524("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx524("path", {
    d: "M423-95v-94h347v-305q0-115.61-85.19-194.81Q599.61-768 481-768q-119.36 0-205.18 79.66Q190-608.69 190-493v269H55v-258h40v-20q2-76 33.5-142.5T212-760q52-49 120.89-77.5t147-28.5Q558-866 627-837.5 696-809 748-760t83.5 115.5Q863-578 865-501l1 19h40v258h-40v129H423Zm-54.09-295q-14.49 0-24.2-9.68-9.71-9.69-9.71-24 0-14.32 9.8-23.82t24.29-9.5q14.49 0 24.2 9.51 9.71 9.52 9.71 23.58 0 14.49-9.8 24.2-9.8 9.71-24.29 9.71Zm222 0q-14.49 0-24.2-9.68-9.71-9.69-9.71-24 0-14.32 9.8-23.82t24.29-9.5q14.49 0 24.2 9.51 9.71 9.52 9.71 23.58 0 14.49-9.8 24.2-9.8 9.71-24.29 9.71ZM250-482q-4-96 65.15-162.5Q384.29-711 481-711q81.59 0 142.29 53.5Q684-604 698-523q-79-1-147.5-38T440.72-666Q422-597 370.5-549T250-482Z"
  })
});
var support_agent_default3 = SvgComponent442;

// src/components/icon/variants/IconSupportAgent.tsx
import { useTranslation as useTranslation82 } from "react-i18next";
import { jsx as jsx525 } from "react/jsx-runtime";
var componentMap72 = {
  outlined: support_agent_default,
  "outlined-fill": support_agent_fill_default,
  rounded: support_agent_default2,
  "rounded-fill": support_agent_fill_default2,
  sharp: support_agent_default3,
  "sharp-fill": support_agent_fill_default3
};
var IconSupportAgent = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation82("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap72[key] ?? componentMap72[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx525(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/translate-fill.svg
import * as React443 from "react";
import { jsx as jsx526 } from "react/jsx-runtime";
var SvgComponent443 = (props) => /* @__PURE__ */ jsx526("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx526("path", {
    d: "m447-55 187-514h131L951-55H848l-33-85H581l-33 85H447ZM150-169l-67-67 197-196q-58-61-94.5-116.5T134-651h108q10 31 37 69t69 82q44-48 80-112t50-119H10v-95h290v-80h95v80h290v95H582q-18 74-64 155T413-432l66 67-37 102-97-101-195 195Zm463-61h170l-85-228-85 228Z"
  })
});
var translate_fill_default = SvgComponent443;

// ../../../node_modules/@material-symbols/svg-700/outlined/translate.svg
import * as React444 from "react";
import { jsx as jsx527 } from "react/jsx-runtime";
var SvgComponent444 = (props) => /* @__PURE__ */ jsx527("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx527("path", {
    d: "m447-55 187-514h131L951-55H848l-33-85H581l-33 85H447ZM150-169l-67-67 197-196q-58-61-94.5-116.5T134-651h108q10 31 37 69t69 82q44-48 80-112t50-119H10v-95h290v-80h95v80h290v95H582q-18 74-64 155T413-432l66 67-37 102-97-101-195 195Zm463-61h170l-85-228-85 228Z"
  })
});
var translate_default = SvgComponent444;

// ../../../node_modules/@material-symbols/svg-700/rounded/translate-fill.svg
import * as React445 from "react";
import { jsx as jsx528 } from "react/jsx-runtime";
var SvgComponent445 = (props) => /* @__PURE__ */ jsx528("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx528("path", {
    d: "m581-140-22 54q-5 14-17 22.5T515-55q-25 0-39-19.5t-6-43.5l150-410q6-18 21.5-29.5T677-569h45q19 0 35 11.5t22 29.5l149 408q9 25-5.5 45T882-55q-15 0-28-9t-18-23l-21-53H581ZM345-364 183-202q-15 14-33.5 14T117-203q-15-14-15-33t15-33l163-163q-58-61-94.5-116.5T134-651h108q10 31 37 69t69 82q44-48 80-112t50-119H57q-20 0-33.5-13.5T10-778q0-20 13.5-34T57-826h243v-32q0-20 13.5-34t33.5-14q20 0 34 14t14 34v32h242q20 0 34 14t14 34q0 20-14 33.5T637-731h-55q-18 74-64 155T413-432l66 67-37 102-97-101Zm268 134h170l-85-228-85 228Z"
  })
});
var translate_fill_default2 = SvgComponent445;

// ../../../node_modules/@material-symbols/svg-700/rounded/translate.svg
import * as React446 from "react";
import { jsx as jsx529 } from "react/jsx-runtime";
var SvgComponent446 = (props) => /* @__PURE__ */ jsx529("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx529("path", {
    d: "m581-140-22 54q-5 14-17 22.5T515-55q-25 0-39-19.5t-6-43.5l150-410q6-18 21.5-29.5T677-569h45q19 0 35 11.5t22 29.5l149 408q9 25-5.5 45T882-55q-15 0-28-9t-18-23l-21-53H581ZM345-364 183-202q-15 14-33.5 14T117-203q-15-14-15-33t15-33l163-163q-58-61-94.5-116.5T134-651h108q10 31 37 69t69 82q44-48 80-112t50-119H57q-20 0-33.5-13.5T10-778q0-20 13.5-34T57-826h243v-32q0-20 13.5-34t33.5-14q20 0 34 14t14 34v32h242q20 0 34 14t14 34q0 20-14 33.5T637-731h-55q-18 74-64 155T413-432l66 67-37 102-97-101Zm268 134h170l-85-228-85 228Z"
  })
});
var translate_default2 = SvgComponent446;

// ../../../node_modules/@material-symbols/svg-700/sharp/translate-fill.svg
import * as React447 from "react";
import { jsx as jsx530 } from "react/jsx-runtime";
var SvgComponent447 = (props) => /* @__PURE__ */ jsx530("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx530("path", {
    d: "m447-55 187-514h131L951-55H848l-33-85H581l-33 85H447ZM150-169l-67-67 197-196q-58-61-94.5-116.5T134-651h108q10 31 37 69t69 82q44-48 80-112t50-119H10v-95h290v-80h95v80h290v95H582q-18 74-64 155T413-432l66 67-37 102-97-101-195 195Zm463-61h170l-85-228-85 228Z"
  })
});
var translate_fill_default3 = SvgComponent447;

// ../../../node_modules/@material-symbols/svg-700/sharp/translate.svg
import * as React448 from "react";
import { jsx as jsx531 } from "react/jsx-runtime";
var SvgComponent448 = (props) => /* @__PURE__ */ jsx531("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx531("path", {
    d: "m447-55 187-514h131L951-55H848l-33-85H581l-33 85H447ZM150-169l-67-67 197-196q-58-61-94.5-116.5T134-651h108q10 31 37 69t69 82q44-48 80-112t50-119H10v-95h290v-80h95v80h290v95H582q-18 74-64 155T413-432l66 67-37 102-97-101-195 195Zm463-61h170l-85-228-85 228Z"
  })
});
var translate_default3 = SvgComponent448;

// src/components/icon/variants/IconTranslate.tsx
import { useTranslation as useTranslation83 } from "react-i18next";
import { jsx as jsx532 } from "react/jsx-runtime";
var componentMap73 = {
  outlined: translate_default,
  "outlined-fill": translate_fill_default,
  rounded: translate_default2,
  "rounded-fill": translate_fill_default2,
  sharp: translate_default3,
  "sharp-fill": translate_fill_default3
};
var IconTranslate = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation83("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap73[key] ?? componentMap73[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx532(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/tune-fill.svg
import * as React449 from "react";
import { jsx as jsx533 } from "react/jsx-runtime";
var SvgComponent449 = (props) => /* @__PURE__ */ jsx533("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx533("path", {
    d: "M421-97v-248h83v83h353v83H504v82h-83Zm-318-82v-83h270v83H103Zm187-178v-82H103v-82h187v-84h83v248h-83Zm131-82v-82h436v82H421Zm166-176v-248h83v82h187v83H670v83h-83Zm-484-83v-83h436v83H103Z"
  })
});
var tune_fill_default = SvgComponent449;

// ../../../node_modules/@material-symbols/svg-700/outlined/tune.svg
import * as React450 from "react";
import { jsx as jsx534 } from "react/jsx-runtime";
var SvgComponent450 = (props) => /* @__PURE__ */ jsx534("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx534("path", {
    d: "M421-97v-248h83v83h353v83H504v82h-83Zm-318-82v-83h270v83H103Zm187-178v-82H103v-82h187v-84h83v248h-83Zm131-82v-82h436v82H421Zm166-176v-248h83v82h187v83H670v83h-83Zm-484-83v-83h436v83H103Z"
  })
});
var tune_default = SvgComponent450;

// ../../../node_modules/@material-symbols/svg-700/rounded/tune-fill.svg
import * as React451 from "react";
import { jsx as jsx535 } from "react/jsx-runtime";
var SvgComponent451 = (props) => /* @__PURE__ */ jsx535("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx535("path", {
    d: "M462.82-97Q445-97 433-108.44T421-138v-166q0-18.13 12.18-29.56 12.17-11.44 30-11.44 17.82 0 29.32 11.44Q504-322.13 504-304v42h312q18.13 0 29.56 11.49Q857-239.02 857-220.82 857-203 845.56-191q-11.43 12-29.56 12H504v41q0 18.12-11.49 29.56Q481.02-97 462.82-97ZM144-179q-18.12 0-29.56-12.18-11.44-12.17-11.44-30 0-17.82 11.44-29.32T144-262h188q18.13 0 29.56 11.49Q373-239.02 373-220.82 373-203 361.56-191q-11.43 12-29.56 12H144Zm187.82-178Q314-357 302-369.13q-12-12.12-12-29.87v-40H144q-17.12 0-29.06-11.99Q103-462.98 103-480.18q0-17.2 11.94-29.01Q126.88-521 144-521h146v-43q0-18.13 12.18-29.56 12.17-11.44 30-11.44 17.82 0 29.32 11.44Q373-582.13 373-564v166q0 18.12-11.49 29.56Q350.02-357 331.82-357ZM462-439q-17.12 0-29.06-11.99Q421-462.98 421-480.18q0-17.2 11.94-29.01Q444.88-521 462-521h354q17.13 0 29.06 11.99Q857-497.02 857-479.82q0 17.19-11.94 29.01Q833.13-439 816-439H462Zm166.82-176Q611-615 599-626.44T587-656v-166q0-18.13 12.18-29.56 12.17-11.44 30-11.44 17.82 0 29.32 11.44Q670-840.13 670-822v41h146q18.13 0 29.56 11.49Q857-758.02 857-739.82 857-722 845.56-710q-11.43 12-29.56 12H670v42q0 18.12-11.49 29.56Q647.02-615 628.82-615ZM144-698q-18.12 0-29.56-12.18-11.44-12.17-11.44-30 0-17.82 11.44-29.32T144-781h354q18.13 0 29.56 11.49Q539-758.02 539-739.82 539-722 527.56-710q-11.43 12-29.56 12H144Z"
  })
});
var tune_fill_default2 = SvgComponent451;

// ../../../node_modules/@material-symbols/svg-700/rounded/tune.svg
import * as React452 from "react";
import { jsx as jsx536 } from "react/jsx-runtime";
var SvgComponent452 = (props) => /* @__PURE__ */ jsx536("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx536("path", {
    d: "M462.82-97Q445-97 433-108.44T421-138v-166q0-18.13 12.18-29.56 12.17-11.44 30-11.44 17.82 0 29.32 11.44Q504-322.13 504-304v42h312q18.13 0 29.56 11.49Q857-239.02 857-220.82 857-203 845.56-191q-11.43 12-29.56 12H504v41q0 18.12-11.49 29.56Q481.02-97 462.82-97ZM144-179q-18.12 0-29.56-12.18-11.44-12.17-11.44-30 0-17.82 11.44-29.32T144-262h188q18.13 0 29.56 11.49Q373-239.02 373-220.82 373-203 361.56-191q-11.43 12-29.56 12H144Zm187.82-178Q314-357 302-369.13q-12-12.12-12-29.87v-40H144q-17.12 0-29.06-11.99Q103-462.98 103-480.18q0-17.2 11.94-29.01Q126.88-521 144-521h146v-43q0-18.13 12.18-29.56 12.17-11.44 30-11.44 17.82 0 29.32 11.44Q373-582.13 373-564v166q0 18.12-11.49 29.56Q350.02-357 331.82-357ZM462-439q-17.12 0-29.06-11.99Q421-462.98 421-480.18q0-17.2 11.94-29.01Q444.88-521 462-521h354q17.13 0 29.06 11.99Q857-497.02 857-479.82q0 17.19-11.94 29.01Q833.13-439 816-439H462Zm166.82-176Q611-615 599-626.44T587-656v-166q0-18.13 12.18-29.56 12.17-11.44 30-11.44 17.82 0 29.32 11.44Q670-840.13 670-822v41h146q18.13 0 29.56 11.49Q857-758.02 857-739.82 857-722 845.56-710q-11.43 12-29.56 12H670v42q0 18.12-11.49 29.56Q647.02-615 628.82-615ZM144-698q-18.12 0-29.56-12.18-11.44-12.17-11.44-30 0-17.82 11.44-29.32T144-781h354q18.13 0 29.56 11.49Q539-758.02 539-739.82 539-722 527.56-710q-11.43 12-29.56 12H144Z"
  })
});
var tune_default2 = SvgComponent452;

// ../../../node_modules/@material-symbols/svg-700/sharp/tune-fill.svg
import * as React453 from "react";
import { jsx as jsx537 } from "react/jsx-runtime";
var SvgComponent453 = (props) => /* @__PURE__ */ jsx537("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx537("path", {
    d: "M421-97v-248h83v83h353v83H504v82h-83Zm-318-82v-83h270v83H103Zm187-178v-82H103v-82h187v-84h83v248h-83Zm131-82v-82h436v82H421Zm166-176v-248h83v82h187v83H670v83h-83Zm-484-83v-83h436v83H103Z"
  })
});
var tune_fill_default3 = SvgComponent453;

// ../../../node_modules/@material-symbols/svg-700/sharp/tune.svg
import * as React454 from "react";
import { jsx as jsx538 } from "react/jsx-runtime";
var SvgComponent454 = (props) => /* @__PURE__ */ jsx538("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx538("path", {
    d: "M421-97v-248h83v83h353v83H504v82h-83Zm-318-82v-83h270v83H103Zm187-178v-82H103v-82h187v-84h83v248h-83Zm131-82v-82h436v82H421Zm166-176v-248h83v82h187v83H670v83h-83Zm-484-83v-83h436v83H103Z"
  })
});
var tune_default3 = SvgComponent454;

// src/components/icon/variants/IconTune.tsx
import { useTranslation as useTranslation84 } from "react-i18next";
import { jsx as jsx539 } from "react/jsx-runtime";
var componentMap74 = {
  outlined: tune_default,
  "outlined-fill": tune_fill_default,
  rounded: tune_default2,
  "rounded-fill": tune_fill_default2,
  sharp: tune_default3,
  "sharp-fill": tune_fill_default3
};
var IconTune = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation84("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap74[key] ?? componentMap74[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx539(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/unarchive-fill.svg
import * as React455 from "react";
import { jsx as jsx540 } from "react/jsx-runtime";
var SvgComponent455 = (props) => /* @__PURE__ */ jsx540("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx540("path", {
    d: "M480.5-576 323-418l52 54 65-65v150h80v-150l65 64 53-54-157.5-157ZM189-95q-39.8 0-66.9-27.1Q95-149.2 95-189v-493q0-15.88 5.5-31.06Q106-728.24 116-741l73-92q12.75-16.03 30.82-24.52Q237.88-866 258-866h444q19.09 0 37.16 8.48Q757.24-849.03 770-833l75 92q9 12.76 15 27.94 6 15.18 6 31.06v493q0 39.8-27.39 66.9Q811.21-95 771-95H189Zm34-631h513l-36.41-46H259l-36 46Z"
  })
});
var unarchive_fill_default = SvgComponent455;

// ../../../node_modules/@material-symbols/svg-700/outlined/unarchive.svg
import * as React456 from "react";
import { jsx as jsx541 } from "react/jsx-runtime";
var SvgComponent456 = (props) => /* @__PURE__ */ jsx541("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx541("path", {
    d: "M480.5-576 323-419l52 54 65-64v150h80v-150l65 65 53-54-157.5-158ZM189-639v450h582v-450H189Zm0 544q-39.8 0-66.9-27.1Q95-149.2 95-189v-493q0-15.88 5.5-31.06Q106-728.24 116-741l73-92q12.75-16.03 30.61-24.52Q237.47-866 258-866h444q19.5 0 37.37 8.48Q757.24-849.03 770-833l75 92q9 12.76 15 27.94 6 15.18 6 31.06v493q0 39.8-27.39 66.9Q811.21-95 771-95H189Zm34-631h513l-36.41-46H259l-36 46Zm257 312Z"
  })
});
var unarchive_default = SvgComponent456;

// ../../../node_modules/@material-symbols/svg-700/rounded/unarchive-fill.svg
import * as React457 from "react";
import { jsx as jsx542 } from "react/jsx-runtime";
var SvgComponent457 = (props) => /* @__PURE__ */ jsx542("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx542("path", {
    d: "M480.37-278q16.63 0 28.13-11.76T520-318v-125l46 46q11.09 11 26.04 10.5Q607-387 619-399.36q11-11.35 10.5-26.36T618-452L514-558q-14.36-13-33.68-13T447-557L342-451q-11 11.09-11.5 26.54-.5 15.46 12.36 27.96 9.85 10.5 24.86 10.5T394-397l46-46v125q0 16.48 11.87 28.24Q463.74-278 480.37-278ZM189-95q-39.8 0-66.9-27.1Q95-149.2 95-189v-493q0-15.88 5.5-31.06Q106-728.24 116-741l73-92q12.75-16.03 30.82-24.52Q237.88-866 258-866h444q19.09 0 37.16 8.48Q757.24-849.03 770-833l75 92q9 12.76 15 27.94 6 15.18 6 31.06v493q0 39.8-27.39 66.9Q811.21-95 771-95H189Zm34-631h513l-36.41-46H259l-36 46Z"
  })
});
var unarchive_fill_default2 = SvgComponent457;

// ../../../node_modules/@material-symbols/svg-700/rounded/unarchive.svg
import * as React458 from "react";
import { jsx as jsx543 } from "react/jsx-runtime";
var SvgComponent458 = (props) => /* @__PURE__ */ jsx543("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx543("path", {
    d: "M480.37-278q16.63 0 28.13-11.76T520-318v-125l46 46q11.09 11 26.04 10.5Q607-387 619-399.36q11-11.35 10.5-26.36T618-452L514-558q-14.45-13-33.73-13Q461-571 447-557L342-451q-11 11.09-11.5 26.54-.5 15.46 12.36 27.96 9.54 10.5 24.71 10.5 15.16 0 26.43-11l46-46v125q0 16.48 11.87 28.24Q463.74-278 480.37-278ZM189-639v450h582v-450H189Zm0 544q-39.8 0-66.9-27.1Q95-149.2 95-189v-493q0-15.88 5.5-31.06Q106-728.24 116-741l73-92q12.75-16.03 30.61-24.52Q237.47-866 258-866h444q19.5 0 37.37 8.48Q757.24-849.03 770-833l75 92q9 12.76 15 27.94 6 15.18 6 31.06v493q0 39.8-27.39 66.9Q811.21-95 771-95H189Zm34-631h513l-36.41-46H259l-36 46Zm257 312Z"
  })
});
var unarchive_default2 = SvgComponent458;

// ../../../node_modules/@material-symbols/svg-700/sharp/unarchive-fill.svg
import * as React459 from "react";
import { jsx as jsx544 } from "react/jsx-runtime";
var SvgComponent459 = (props) => /* @__PURE__ */ jsx544("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx544("path", {
    d: "M480-576 323-418l52 54 65-65v150h80v-150l65 64 53-54-158-157ZM95-95v-621l121-150h528l122 150v621H95Zm128-631h513l-36-46H259l-36 46Z"
  })
});
var unarchive_fill_default3 = SvgComponent459;

// ../../../node_modules/@material-symbols/svg-700/sharp/unarchive.svg
import * as React460 from "react";
import { jsx as jsx545 } from "react/jsx-runtime";
var SvgComponent460 = (props) => /* @__PURE__ */ jsx545("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx545("path", {
    d: "M480-576 323-419l52 54 65-64v150h80v-150l65 65 53-54-158-158Zm-291-63v450h582v-450H189ZM95-95v-621l121-150h528l122 150v621H95Zm128-631h513l-36-46H259l-36 46Zm257 312Z"
  })
});
var unarchive_default3 = SvgComponent460;

// src/components/icon/variants/IconUnarchive.tsx
import { useTranslation as useTranslation85 } from "react-i18next";
import { jsx as jsx546 } from "react/jsx-runtime";
var componentMap75 = {
  outlined: unarchive_default,
  "outlined-fill": unarchive_fill_default,
  rounded: unarchive_default2,
  "rounded-fill": unarchive_fill_default2,
  sharp: unarchive_default3,
  "sharp-fill": unarchive_fill_default3
};
var IconUnarchive = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation85("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap75[key] ?? componentMap75[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx546(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/unfold_more-fill.svg
import * as React461 from "react";
import { jsx as jsx547 } from "react/jsx-runtime";
var SvgComponent461 = (props) => /* @__PURE__ */ jsx547("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx547("path", {
    d: "M480-96 274-302l68-68 138 139 138-139 68 68L480-96ZM342-589l-68-67 206-206 206 206-68 67-138-138-138 138Z"
  })
});
var unfold_more_fill_default = SvgComponent461;

// ../../../node_modules/@material-symbols/svg-700/outlined/unfold_more.svg
import * as React462 from "react";
import { jsx as jsx548 } from "react/jsx-runtime";
var SvgComponent462 = (props) => /* @__PURE__ */ jsx548("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx548("path", {
    d: "M480-96 274-302l68-68 138 139 138-139 68 68L480-96ZM342-589l-68-67 206-206 206 206-68 67-138-138-138 138Z"
  })
});
var unfold_more_default = SvgComponent462;

// ../../../node_modules/@material-symbols/svg-700/rounded/unfold_more-fill.svg
import * as React463 from "react";
import { jsx as jsx549 } from "react/jsx-runtime";
var SvgComponent463 = (props) => /* @__PURE__ */ jsx549("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx549("path", {
    d: "m480-231 105-105q14.57-14 33.78-14Q638-350 652-335.9q14 14.11 14 33.79T652-268L514-130q-7.17 6.91-16.33 10.95-9.16 4.05-17.91 4.05-8.76 0-17.71-4.05Q453.1-123.09 446-130L308-268q-14-14.57-14-34.28 0-19.72 14.1-34.22 14.11-13.5 33.79-13.5T376-336l104 105Zm0-496L375-622q-14.57 14-33.78 14Q322-608 308-622.1q-14-14.11-14-33.79T308-690l138-139q7.16-6 16.31-10.5 9.16-4.5 17.9-4.5 8.75 0 17.77 4.5T514-829l138 139q14 14.57 14 34.28 0 19.72-14.1 34.22-14.11 13.5-34 13Q598-609 584-623L480-727Z"
  })
});
var unfold_more_fill_default2 = SvgComponent463;

// ../../../node_modules/@material-symbols/svg-700/rounded/unfold_more.svg
import * as React464 from "react";
import { jsx as jsx550 } from "react/jsx-runtime";
var SvgComponent464 = (props) => /* @__PURE__ */ jsx550("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx550("path", {
    d: "m480-231 105-105q14.57-14 33.78-14Q638-350 652-335.9q14 14.11 14 33.79T652-268L514-130q-7.17 6.91-16.33 10.95-9.16 4.05-17.91 4.05-8.76 0-17.71-4.05Q453.1-123.09 446-130L308-268q-14-14.57-14-34.28 0-19.72 14.1-34.22 14.11-13.5 33.79-13.5T376-336l104 105Zm0-496L375-622q-14.57 14-33.78 14Q322-608 308-622.1q-14-14.11-14-33.79T308-690l138-139q7.16-6 16.31-10.5 9.16-4.5 17.9-4.5 8.75 0 17.77 4.5T514-829l138 139q14 14.57 14 34.28 0 19.72-14.1 34.22-14.11 13.5-34 13Q598-609 584-623L480-727Z"
  })
});
var unfold_more_default2 = SvgComponent464;

// ../../../node_modules/@material-symbols/svg-700/sharp/unfold_more-fill.svg
import * as React465 from "react";
import { jsx as jsx551 } from "react/jsx-runtime";
var SvgComponent465 = (props) => /* @__PURE__ */ jsx551("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx551("path", {
    d: "M480-96 274-302l68-68 138 139 138-139 68 68L480-96ZM342-589l-68-67 206-206 206 206-68 67-138-138-138 138Z"
  })
});
var unfold_more_fill_default3 = SvgComponent465;

// ../../../node_modules/@material-symbols/svg-700/sharp/unfold_more.svg
import * as React466 from "react";
import { jsx as jsx552 } from "react/jsx-runtime";
var SvgComponent466 = (props) => /* @__PURE__ */ jsx552("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx552("path", {
    d: "M480-96 274-302l68-68 138 139 138-139 68 68L480-96ZM342-589l-68-67 206-206 206 206-68 67-138-138-138 138Z"
  })
});
var unfold_more_default3 = SvgComponent466;

// src/components/icon/variants/IconUnfoldMore.tsx
import { useTranslation as useTranslation86 } from "react-i18next";
import { jsx as jsx553 } from "react/jsx-runtime";
var componentMap76 = {
  outlined: unfold_more_default,
  "outlined-fill": unfold_more_fill_default,
  rounded: unfold_more_default2,
  "rounded-fill": unfold_more_fill_default2,
  sharp: unfold_more_default3,
  "sharp-fill": unfold_more_fill_default3
};
var IconUnfoldMore = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation86("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap76[key] ?? componentMap76[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx553(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/update-fill.svg
import * as React467 from "react";
import { jsx as jsx554 } from "react/jsx-runtime";
var SvgComponent467 = (props) => /* @__PURE__ */ jsx554("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx554("path", {
    d: "M483.81-95q-79.48 0-150.64-30.5Q262-156 209.5-208.5t-83.5-123Q95-402 95-482t31-149.5Q157-701 209.5-753t123.73-82.5Q404.46-866 484-866q81 0 153.5 34T766-739v-95h71v227H608v-73h84q-42.27-42.27-95.64-66.63Q543-771 484-771q-122 0-208 82.82t-86 203Q190-362 275.37-275.5 360.75-189 484-189q120 0 203.38-85.35Q770.75-359.7 772-481h94q0 161-111 273.5T483.81-95ZM600-311 446-463v-220h71v189l135 131-52 52Z"
  })
});
var update_fill_default = SvgComponent467;

// ../../../node_modules/@material-symbols/svg-700/outlined/update.svg
import * as React468 from "react";
import { jsx as jsx555 } from "react/jsx-runtime";
var SvgComponent468 = (props) => /* @__PURE__ */ jsx555("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx555("path", {
    d: "M483.81-95q-79.48 0-150.64-30.5Q262-156 209.5-208.5t-83.5-123Q95-402 95-482t31-149.5Q157-701 209.5-753t123.73-82.5Q404.46-866 484-866q81 0 153.5 34T766-739v-95h71v227H608v-73h84q-42.27-42.27-95.64-66.63Q543-771 484-771q-122 0-208 82.82t-86 203Q190-362 275.37-275.5 360.75-189 484-189q120 0 203.38-85.35Q770.75-359.7 772-481h94q0 161-111 273.5T483.81-95ZM600-311 446-463v-220h71v189l135 131-52 52Z"
  })
});
var update_default = SvgComponent468;

// ../../../node_modules/@material-symbols/svg-700/rounded/update-fill.svg
import * as React469 from "react";
import { jsx as jsx556 } from "react/jsx-runtime";
var SvgComponent469 = (props) => /* @__PURE__ */ jsx556("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx556("path", {
    d: "M483.88-95Q404-95 333-125.5t-123.5-83Q157-261 126-331.5T95-482q0-80 31-149.5T209.5-753q52.5-52 123.73-82.5T484-866q81 0 153.5 34T766-739v-60q0-15.15 10-25.08 10-9.92 25.5-9.92t25.5 9.92q10 9.93 10 25.08v145q0 20-13.5 33.5T790-607H644q-14.72 0-25.36-10.5Q608-628 608-643.5t10-26q10-10.5 26-10.5h48q-42.27-42.27-95.64-66.63Q543-771 484-771q-122 0-208 82.82t-86 203Q190-362 275.37-275.5 360.75-189 484-189q110.33 0 188.66-72Q751-333 766-438q4-19 18.5-30.5t33.56-10.5Q838-478 851-464q13 14 10 32-17.35 143.12-123.67 240.06Q631-95 483.88-95ZM517-493.74l107.8 104.57Q637-377 637-362.63q0 14.36-11.51 25.63-11.5 12-25.74 12-14.24 0-25.75-12L459-450q-7-6-10-14.35T446-483v-165q0-15.15 10.39-25.08 10.4-9.92 25.5-9.92 15.11 0 25.11 9.92 10 9.93 10 25.08v154.26Z"
  })
});
var update_fill_default2 = SvgComponent469;

// ../../../node_modules/@material-symbols/svg-700/rounded/update.svg
import * as React470 from "react";
import { jsx as jsx557 } from "react/jsx-runtime";
var SvgComponent470 = (props) => /* @__PURE__ */ jsx557("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx557("path", {
    d: "M483.88-95Q404-95 333-125.5t-123.5-83Q157-261 126-331.5T95-482q0-80 31-149.5T209.5-753q52.5-52 123.73-82.5T484-866q81 0 153.5 34T766-739v-60q0-15.15 10-25.08 10-9.92 25.5-9.92t25.5 9.92q10 9.93 10 25.08v145q0 20-13.5 33.5T790-607H644q-14.72 0-25.36-10.5Q608-628 608-643.5t10-26q10-10.5 26-10.5h48q-42.27-42.27-95.64-66.63Q543-771 484-771q-122 0-208 82.82t-86 203Q190-362 275.37-275.5 360.75-189 484-189q110.33 0 188.66-72Q751-333 766-438q4-19 18.5-30.5t33.56-10.5Q838-478 851-464q13 14 10 32-17.35 143.12-123.67 240.06Q631-95 483.88-95ZM517-493.74l107.8 104.57Q637-377 637-362.63q0 14.36-11.51 25.63-11.5 12-25.74 12-14.24 0-25.75-12L459-450q-7-6-10-14.35T446-483v-165q0-15.15 10.39-25.08 10.4-9.92 25.5-9.92 15.11 0 25.11 9.92 10 9.93 10 25.08v154.26Z"
  })
});
var update_default2 = SvgComponent470;

// ../../../node_modules/@material-symbols/svg-700/sharp/update-fill.svg
import * as React471 from "react";
import { jsx as jsx558 } from "react/jsx-runtime";
var SvgComponent471 = (props) => /* @__PURE__ */ jsx558("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx558("path", {
    d: "M483.81-95q-79.48 0-150.64-30.5Q262-156 209.5-208.5t-83.5-123Q95-402 95-482t31-149.5Q157-701 209.5-753t123.73-82.5Q404.46-866 484-866q81 0 153.5 34T766-739v-95h71v227H608v-73h84q-42.27-42.27-95.64-66.63Q543-771 484-771q-122 0-208 82.82t-86 203Q190-362 275.37-275.5 360.75-189 484-189q120 0 203.38-85.35Q770.75-359.7 772-481h94q0 161-111 273.5T483.81-95ZM600-311 446-463v-220h71v189l135 131-52 52Z"
  })
});
var update_fill_default3 = SvgComponent471;

// ../../../node_modules/@material-symbols/svg-700/sharp/update.svg
import * as React472 from "react";
import { jsx as jsx559 } from "react/jsx-runtime";
var SvgComponent472 = (props) => /* @__PURE__ */ jsx559("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx559("path", {
    d: "M483.81-95q-79.48 0-150.64-30.5Q262-156 209.5-208.5t-83.5-123Q95-402 95-482t31-149.5Q157-701 209.5-753t123.73-82.5Q404.46-866 484-866q81 0 153.5 34T766-739v-95h71v227H608v-73h84q-42.27-42.27-95.64-66.63Q543-771 484-771q-122 0-208 82.82t-86 203Q190-362 275.37-275.5 360.75-189 484-189q120 0 203.38-85.35Q770.75-359.7 772-481h94q0 161-111 273.5T483.81-95ZM600-311 446-463v-220h71v189l135 131-52 52Z"
  })
});
var update_default3 = SvgComponent472;

// src/components/icon/variants/IconUpdate.tsx
import { useTranslation as useTranslation87 } from "react-i18next";
import { jsx as jsx560 } from "react/jsx-runtime";
var componentMap77 = {
  outlined: update_default,
  "outlined-fill": update_fill_default,
  rounded: update_default2,
  "rounded-fill": update_fill_default2,
  sharp: update_default3,
  "sharp-fill": update_fill_default3
};
var IconUpdate = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation87("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap77[key] ?? componentMap77[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx560(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/upload-fill.svg
import * as React473 from "react";
import { jsx as jsx561 } from "react/jsx-runtime";
var SvgComponent473 = (props) => /* @__PURE__ */ jsx561("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx561("path", {
    d: "M433-322v-323L319-530l-68-67 229-229 229 229-68 67-114-115v323h-94ZM229-135q-39.05 0-66.52-27.48Q135-189.95 135-229v-143h94v143h502v-143h95v143q0 39-27.77 66.5T731-135H229Z"
  })
});
var upload_fill_default = SvgComponent473;

// ../../../node_modules/@material-symbols/svg-700/outlined/upload.svg
import * as React474 from "react";
import { jsx as jsx562 } from "react/jsx-runtime";
var SvgComponent474 = (props) => /* @__PURE__ */ jsx562("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx562("path", {
    d: "M433-322v-323L319-530l-68-67 229-229 229 229-68 67-114-115v323h-94ZM229-135q-39.05 0-66.52-27.48Q135-189.95 135-229v-143h94v143h502v-143h95v143q0 39-27.77 66.5T731-135H229Z"
  })
});
var upload_default = SvgComponent474;

// ../../../node_modules/@material-symbols/svg-700/rounded/upload-fill.svg
import * as React475 from "react";
import { jsx as jsx563 } from "react/jsx-runtime";
var SvgComponent475 = (props) => /* @__PURE__ */ jsx563("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx563("path", {
    d: "M229-135q-39.05 0-66.52-27.48Q135-189.95 135-229v-96q0-19.75 13.68-33.38Q162.35-372 182.18-372q19.82 0 33.32 13.62Q229-344.75 229-325v96h502v-96q0-19.75 13.68-33.38Q758.35-372 778.09-372q19.73 0 33.82 13.62Q826-344.75 826-325v96q0 39.05-27.77 66.52Q770.46-135 731-135H229Zm204-510-82 82q-13.8 14-32.4 14-18.6 0-32.99-14.07-14.78-14.07-14.19-33.5Q272-616 286-631l160-161q7.17-6.91 16.33-10.95 9.16-4.05 17.91-4.05 8.76 0 17.71 4.05Q506.9-798.91 514-792l162 162q14 14 14 33.5T676.39-564q-14.79 15.08-34.09 14.54Q623-550 609-564l-82-81v276q0 19.75-13.68 33.37Q499.65-322 479.82-322q-19.82 0-33.32-13.63Q433-349.25 433-369v-276Z"
  })
});
var upload_fill_default2 = SvgComponent475;

// ../../../node_modules/@material-symbols/svg-700/rounded/upload.svg
import * as React476 from "react";
import { jsx as jsx564 } from "react/jsx-runtime";
var SvgComponent476 = (props) => /* @__PURE__ */ jsx564("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx564("path", {
    d: "M229-135q-39.05 0-66.52-27.48Q135-189.95 135-229v-96q0-19.75 13.68-33.38Q162.35-372 182.18-372q19.82 0 33.32 13.62Q229-344.75 229-325v96h502v-96q0-19.75 13.68-33.38Q758.35-372 778.09-372q19.73 0 33.82 13.62Q826-344.75 826-325v96q0 39.05-27.77 66.52Q770.46-135 731-135H229Zm204-510-82 82q-13.8 14-32.4 14-18.6 0-32.99-14.07-14.78-14.07-14.19-33.5Q272-616 286-631l160-161q7.17-6.91 16.33-10.95 9.16-4.05 17.91-4.05 8.76 0 17.71 4.05Q506.9-798.91 514-792l162 162q14 14 14 33.5T676.39-564q-14.79 15.08-34.09 14.54Q623-550 609-564l-82-81v276q0 19.75-13.68 33.37Q499.65-322 479.82-322q-19.82 0-33.32-13.63Q433-349.25 433-369v-276Z"
  })
});
var upload_default2 = SvgComponent476;

// ../../../node_modules/@material-symbols/svg-700/sharp/upload-fill.svg
import * as React477 from "react";
import { jsx as jsx565 } from "react/jsx-runtime";
var SvgComponent477 = (props) => /* @__PURE__ */ jsx565("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx565("path", {
    d: "M433-322v-323L319-530l-68-67 229-229 229 229-68 67-114-115v323h-94ZM135-135v-237h94v143h502v-143h95v237H135Z"
  })
});
var upload_fill_default3 = SvgComponent477;

// ../../../node_modules/@material-symbols/svg-700/sharp/upload.svg
import * as React478 from "react";
import { jsx as jsx566 } from "react/jsx-runtime";
var SvgComponent478 = (props) => /* @__PURE__ */ jsx566("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx566("path", {
    d: "M433-322v-323L319-530l-68-67 229-229 229 229-68 67-114-115v323h-94ZM135-135v-237h94v143h502v-143h95v237H135Z"
  })
});
var upload_default3 = SvgComponent478;

// src/components/icon/variants/IconUpload.tsx
import { useTranslation as useTranslation88 } from "react-i18next";
import { jsx as jsx567 } from "react/jsx-runtime";
var componentMap78 = {
  outlined: upload_default,
  "outlined-fill": upload_fill_default,
  rounded: upload_default2,
  "rounded-fill": upload_fill_default2,
  sharp: upload_default3,
  "sharp-fill": upload_fill_default3
};
var IconUpload = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation88("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap78[key] ?? componentMap78[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx567(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/visibility-fill.svg
import * as React479 from "react";
import { jsx as jsx568 } from "react/jsx-runtime";
var SvgComponent479 = (props) => /* @__PURE__ */ jsx568("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx568("path", {
    d: "M480.12-330q70.88 0 120.38-49.62t49.5-120.5q0-70.88-49.62-120.38T479.88-670Q409-670 359.5-620.38T310-499.88q0 70.88 49.62 120.38t120.5 49.5Zm-.12-74q-40 0-68-28t-28-68q0-40 28-68t68-28q40 0 68 28t28 68q0 40-28 68t-68 28Zm0 227q-154 0-278-90T17-500q61-143 185-233t278-90q154 0 278 90t185 233q-61 143-185 233t-278 90Z"
  })
});
var visibility_fill_default = SvgComponent479;

// ../../../node_modules/@material-symbols/svg-700/outlined/visibility.svg
import * as React480 from "react";
import { jsx as jsx569 } from "react/jsx-runtime";
var SvgComponent480 = (props) => /* @__PURE__ */ jsx569("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx569("path", {
    d: "M480.12-330q70.88 0 120.38-49.62t49.5-120.5q0-70.88-49.62-120.38T479.88-670Q409-670 359.5-620.38T310-499.88q0 70.88 49.62 120.38t120.5 49.5Zm-.12-74q-40 0-68-28t-28-68q0-40 28-68t68-28q40 0 68 28t28 68q0 40-28 68t-68 28Zm0 227q-154 0-278-90T17-500q61-143 185-233t278-90q154 0 278 90t185 233q-61 143-185 233t-278 90Zm0-323Zm-.08 240q120.45 0 221.27-65.5Q802-391 855-500q-53-109-153.73-174.5Q600.53-740 480.08-740t-221.27 65.5Q158-609 104-500q54 109 154.73 174.5Q359.47-260 479.92-260Z"
  })
});
var visibility_default = SvgComponent480;

// ../../../node_modules/@material-symbols/svg-700/rounded/visibility-fill.svg
import * as React481 from "react";
import { jsx as jsx570 } from "react/jsx-runtime";
var SvgComponent481 = (props) => /* @__PURE__ */ jsx570("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx570("path", {
    d: "M480.12-330q70.88 0 120.38-49.62t49.5-120.5q0-70.88-49.62-120.38T479.88-670Q409-670 359.5-620.38T310-499.88q0 70.88 49.62 120.38t120.5 49.5Zm-.12-74q-40 0-68-28t-28-68q0-40 28-68t68-28q40 0 68 28t28 68q0 40-28 68t-68 28Zm0 227q-140 0-254.95-77.18Q110.1-331.35 42-454q-6-10.92-9-22.66-3-11.75-3-23.32t3-23.26q3-11.69 9-22.76 68.1-122.65 183.05-199.82Q340-823 480-823t254.95 77.18Q849.9-668.65 918-546q6 10.92 9 22.66 3 11.75 3 23.32t-3 23.26q-3 11.69-9 22.76-68.1 122.65-183.05 199.82Q620-177 480-177Z"
  })
});
var visibility_fill_default2 = SvgComponent481;

// ../../../node_modules/@material-symbols/svg-700/rounded/visibility.svg
import * as React482 from "react";
import { jsx as jsx571 } from "react/jsx-runtime";
var SvgComponent482 = (props) => /* @__PURE__ */ jsx571("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx571("path", {
    d: "M480.12-330q70.88 0 120.38-49.62t49.5-120.5q0-70.88-49.62-120.38T479.88-670Q409-670 359.5-620.38T310-499.88q0 70.88 49.62 120.38t120.5 49.5Zm-.12-74q-40 0-68-28t-28-68q0-40 28-68t68-28q40 0 68 28t28 68q0 40-28 68t-68 28Zm0 227q-140 0-254.95-77.18Q110.1-331.35 42-454q-6-10.92-9-22.66-3-11.75-3-23.32t3-23.26q3-11.69 9-22.76 68.1-122.65 183.05-199.82Q340-823 480-823t254.95 77.18Q849.9-668.65 918-546q6 10.92 9 22.66 3 11.75 3 23.32t-3 23.26q-3 11.69-9 22.76-68.1 122.65-183.05 199.82Q620-177 480-177Zm0-323Zm-.08 240Q601-260 701.5-325.5 802-391 855-500q-53-109-153.42-174.5Q601.16-740 480.08-740T258.5-674.5Q158-609 104-500q54 109 154.42 174.5Q358.84-260 479.92-260Z"
  })
});
var visibility_default2 = SvgComponent482;

// ../../../node_modules/@material-symbols/svg-700/sharp/visibility-fill.svg
import * as React483 from "react";
import { jsx as jsx572 } from "react/jsx-runtime";
var SvgComponent483 = (props) => /* @__PURE__ */ jsx572("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx572("path", {
    d: "M480.12-330q70.88 0 120.38-49.62t49.5-120.5q0-70.88-49.62-120.38T479.88-670Q409-670 359.5-620.38T310-499.88q0 70.88 49.62 120.38t120.5 49.5Zm-.12-74q-40 0-68-28t-28-68q0-40 28-68t68-28q40 0 68 28t28 68q0 40-28 68t-68 28Zm0 227q-154 0-278-90T17-500q61-143 185-233t278-90q154 0 278 90t185 233q-61 143-185 233t-278 90Z"
  })
});
var visibility_fill_default3 = SvgComponent483;

// ../../../node_modules/@material-symbols/svg-700/sharp/visibility.svg
import * as React484 from "react";
import { jsx as jsx573 } from "react/jsx-runtime";
var SvgComponent484 = (props) => /* @__PURE__ */ jsx573("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx573("path", {
    d: "M480.12-330q70.88 0 120.38-49.62t49.5-120.5q0-70.88-49.62-120.38T479.88-670Q409-670 359.5-620.38T310-499.88q0 70.88 49.62 120.38t120.5 49.5Zm-.12-74q-40 0-68-28t-28-68q0-40 28-68t68-28q40 0 68 28t28 68q0 40-28 68t-68 28Zm0 227q-154 0-278-90T17-500q61-143 185-233t278-90q154 0 278 90t185 233q-61 143-185 233t-278 90Zm0-323Zm-.08 240q120.45 0 221.27-65.5Q802-391 855-500q-53-109-153.73-174.5Q600.53-740 480.08-740t-221.27 65.5Q158-609 104-500q54 109 154.73 174.5Q359.47-260 479.92-260Z"
  })
});
var visibility_default3 = SvgComponent484;

// src/components/icon/variants/IconVisibility.tsx
import { useTranslation as useTranslation89 } from "react-i18next";
import { jsx as jsx574 } from "react/jsx-runtime";
var componentMap79 = {
  outlined: visibility_default,
  "outlined-fill": visibility_fill_default,
  rounded: visibility_default2,
  "rounded-fill": visibility_fill_default2,
  sharp: visibility_default3,
  "sharp-fill": visibility_fill_default3
};
var IconVisibility = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation89("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap79[key] ?? componentMap79[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx574(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/visibility_off-fill.svg
import * as React485 from "react";
import { jsx as jsx575 } from "react/jsx-runtime";
var SvgComponent485 = (props) => /* @__PURE__ */ jsx575("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx575("path", {
    d: "M807-55 653-207q-35 14-80 22t-93 8q-151 0-276.5-85.5T17-500q18-51 55-103t86-100L35-824l50-52 769 769-47 52ZM480-330q11 0 23.5-2.5T524-339L317-544q-3 9-5 21t-2 23q0 72 50 121t120 49Zm302 48L633-432q8-12 12.5-32t4.5-36q0-71-49.5-120.5T480-670q-17 0-35 4t-33 12L283-783q35-16 92.5-28T485-823q147 0 272 85t186 238q-25 66-67.5 121.5T782-282ZM556-509l-73-73q13-8 30-7t31 12q13 13 17.5 28.5T556-509Z"
  })
});
var visibility_off_fill_default = SvgComponent485;

// ../../../node_modules/@material-symbols/svg-700/outlined/visibility_off.svg
import * as React486 from "react";
import { jsx as jsx576 } from "react/jsx-runtime";
var SvgComponent486 = (props) => /* @__PURE__ */ jsx576("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx576("path", {
    d: "m634-432-77-76q21-44-12.5-69t-62.5-6l-70-71q15-8 33-12t35-4q71 0 120.5 49.5T650-500q0 16-4 36t-12 32Zm148 150-55-56q44-35 76.5-77t52.5-85q-52-110-150.5-175T490-740q-42 0-82 7t-59 16l-66-66q35-16 92.5-28T485-823q147 0 272 85t186 238q-25 66-67.5 121.5T782-282Zm25 227L653-207q-35 14-80 22t-93 8q-151 0-276.5-85.5T17-500q18-51 55-103t86-100L35-824l50-52 769 769-47 52ZM216-646q-36 29-66 68.5T104-500q52 111 153 175.5T488-260q27 0 55.5-3t44.5-11l-64-64q-8 4-20.5 6t-23.5 2q-70 0-120-49t-50-121q0-11 1.5-23t4.5-21L216-646Zm323 128Zm-137 69Z"
  })
});
var visibility_off_default = SvgComponent486;

// ../../../node_modules/@material-symbols/svg-700/rounded/visibility_off-fill.svg
import * as React487 from "react";
import { jsx as jsx577 } from "react/jsx-runtime";
var SvgComponent487 = (props) => /* @__PURE__ */ jsx577("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx577("path", {
    d: "M781-81 653-207q-42 17-85.5 23.5T480-177q-140 0-256-77T40-455q-6-10-8-21.5T30-500q0-12 2-23.5t8-21.5q24-43 52.5-83.5T158-703l-97-97q-11-10-11.5-24T60-849q11-11 25.5-11t25.5 11l720 720q10 10 9 23.5T831-82q-10 12-24.5 12T781-81ZM480-330q11 0 22-2t22-7L317-544q-4 11-5.5 22t-1.5 22q0 71 49.5 120.5T480-330Zm5-493q140 0 255 77.5T921-543q5 11 7.5 21t2.5 22q0 12-2.5 22.5T921-456q-20 38-44.5 73.5T821-319q-15 17-37.5 16.5T745-320l-94-94q-8-8-10-19t1-22q5-11 6.5-22.5T650-500q0-71-49.5-120.5T480-670q-11 0-22.5 2t-22.5 6q-11 3-21.5 1T395-671l-49-49q-22-23-15-52.5t37-36.5q28-8 58-11t59-3Zm59 246q13 13 17 29.5t-2 33.5q-1 2-3 2.5t-4-1.5l-65-65q-1-1-1.5-3.5t1.5-3.5q14-7 29.5-4.5T544-577Z"
  })
});
var visibility_off_fill_default2 = SvgComponent487;

// ../../../node_modules/@material-symbols/svg-700/rounded/visibility_off.svg
import * as React488 from "react";
import { jsx as jsx578 } from "react/jsx-runtime";
var SvgComponent488 = (props) => /* @__PURE__ */ jsx578("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx578("path", {
    d: "M600-620q19 19 31.5 50t11.5 60q0 18.33-12 30.17Q619-468 600.76-468q-18.23 0-30-11.83Q559-491.67 559-510q8-19 4-36t-16-29q-12-12-29.5-15.5T482-585q-16.75 0-28.37-11.65Q442-608.31 442-625.15q0-16.85 11.63-28.35Q465.25-665 482-665q31-2 63.5 10.5T600-620ZM490-740q-26 0-51.5 2.5t-49.01 9.5Q371-725 355-732.5q-16-7.5-22-24.5-7-16 1-30.5t24-18.5q31-10 62.65-13.5Q452.31-823 485-823q141.74 0 259.37 79T925-535.82q4 8.82 6.5 17.85 2.5 9.03 2.5 18t-1.5 18.47Q931-472 927-464q-22 45-51 83.5T810-309q-12 13-27.5 11T756-312q-11-12-10-28t13-28q31-28 56-60.5t41-71.5q-51.14-108-148.91-174T490-740Zm-10.1 563q-140.9 0-257.4-77.5Q106-332 39-457q-5-11-7.5-21T29-499.95q0-11.94 3-23Q35-534 39-544q23-45 53.11-84.56Q122.22-668.13 158-703l-97-97q-11-10.47-11-24.23Q50-838 60-849q11-11 25.5-11t25.5 11l720 720q10 10 9 23.5t-9.43 23.46Q821-70 806.5-70T781-81L653-207q-42 17-85.7 23.5-43.71 6.5-87.4 6.5ZM215.74-646Q179-617 150.5-580 122-543 104-500q52.14 112 155.91 176T488-260q26 0 51-.5t49-13.5l-64-64q-11 5-22 6.5t-22 1.5q-71 0-120.5-49.5T310-500q0-11 1.5-22t4.5-22L215.74-646ZM539-518Zm-137 69Z"
  })
});
var visibility_off_default2 = SvgComponent488;

// ../../../node_modules/@material-symbols/svg-700/sharp/visibility_off-fill.svg
import * as React489 from "react";
import { jsx as jsx579 } from "react/jsx-runtime";
var SvgComponent489 = (props) => /* @__PURE__ */ jsx579("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx579("path", {
    d: "M807-55 653-207q-35 14-80 22t-93 8q-151 0-276.5-85.5T17-500q18-51 55-103t86-100L35-824l50-52 769 769-47 52ZM480-330q11 0 23.5-2.5T524-339L317-544q-3 9-5 21t-2 23q0 72 50 121t120 49Zm302 48L633-432q8-12 12.5-32t4.5-36q0-71-49.5-120.5T480-670q-17 0-35 4t-33 12L283-783q35-16 92.5-28T485-823q147 0 272 85t186 238q-25 66-67.5 121.5T782-282ZM556-509l-73-73q13-8 30-7t31 12q13 13 17.5 28.5T556-509Z"
  })
});
var visibility_off_fill_default3 = SvgComponent489;

// ../../../node_modules/@material-symbols/svg-700/sharp/visibility_off.svg
import * as React490 from "react";
import { jsx as jsx580 } from "react/jsx-runtime";
var SvgComponent490 = (props) => /* @__PURE__ */ jsx580("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx580("path", {
    d: "m634-432-77-76q21-44-12.5-69t-62.5-6l-70-71q15-8 33-12t35-4q71 0 120.5 49.5T650-500q0 16-4 36t-12 32Zm148 150-55-56q44-35 76.5-77t52.5-85q-52-110-150.5-175T490-740q-42 0-82 7t-59 16l-66-66q35-16 92.5-28T485-823q147 0 272 85t186 238q-25 66-67.5 121.5T782-282Zm25 227L653-207q-35 14-80 22t-93 8q-151 0-276.5-85.5T17-500q18-51 55-103t86-100L35-824l50-52 769 769-47 52ZM216-646q-36 29-66 68.5T104-500q52 111 153 175.5T488-260q27 0 55.5-3t44.5-11l-64-64q-8 4-20.5 6t-23.5 2q-70 0-120-49t-50-121q0-11 1.5-23t4.5-21L216-646Zm323 128Zm-137 69Z"
  })
});
var visibility_off_default3 = SvgComponent490;

// src/components/icon/variants/IconVisibilityOff.tsx
import { useTranslation as useTranslation90 } from "react-i18next";
import { jsx as jsx581 } from "react/jsx-runtime";
var componentMap80 = {
  outlined: visibility_off_default,
  "outlined-fill": visibility_off_fill_default,
  rounded: visibility_off_default2,
  "rounded-fill": visibility_off_fill_default2,
  sharp: visibility_off_default3,
  "sharp-fill": visibility_off_fill_default3
};
var IconVisibilityOff = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation90("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap80[key] ?? componentMap80[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx581(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// ../../../node_modules/@material-symbols/svg-700/outlined/warning-fill.svg
import * as React491 from "react";
import { jsx as jsx582 } from "react/jsx-runtime";
var SvgComponent491 = (props) => /* @__PURE__ */ jsx582("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx582("path", {
    d: "m18-107 462-799 462 799H18Zm466.18-132q13.4 0 23.61-10.39Q518-259.78 518-273.18q0-13.4-10.39-23.11-10.39-9.71-23.79-9.71-13.4 0-23.61 9.89Q450-286.22 450-272.82q0 13.4 10.39 23.61Q470.78-239 484.18-239ZM454-348h60v-216h-60v216Z"
  })
});
var warning_fill_default = SvgComponent491;

// ../../../node_modules/@material-symbols/svg-700/outlined/warning.svg
import * as React492 from "react";
import { jsx as jsx583 } from "react/jsx-runtime";
var SvgComponent492 = (props) => /* @__PURE__ */ jsx583("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx583("path", {
    d: "m18-107 462-799 462 799H18Zm145-84h634L480-739 163-191Zm321.18-48q13.4 0 23.61-10.39Q518-259.78 518-273.18q0-13.4-10.39-23.11-10.39-9.71-23.79-9.71-13.4 0-23.61 9.89Q450-286.22 450-272.82q0 13.4 10.39 23.61Q470.78-239 484.18-239ZM454-348h60v-216h-60v216Zm26-117Z"
  })
});
var warning_default = SvgComponent492;

// ../../../node_modules/@material-symbols/svg-700/rounded/warning-fill.svg
import * as React493 from "react";
import { jsx as jsx584 } from "react/jsx-runtime";
var SvgComponent493 = (props) => /* @__PURE__ */ jsx584("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx584("path", {
    d: "M100-107q-14.48 0-24.98-6.93Q64.52-120.85 59-131q-6.17-9.6-6.58-22.38Q52-166.16 59-179l380-656q7-12 18.1-17.5 11.11-5.5 23-5.5 11.9 0 22.9 5.5 11 5.5 18 17.5l380 656q7 12.84 6.58 25.62-.41 12.78-6.58 22.38-5.7 9.75-16.11 16.87Q874.48-107 860-107H100Zm384.18-132q13.4 0 23.61-10.39Q518-259.78 518-273.18q0-13.4-10.39-23.11-10.39-9.71-23.79-9.71-13.4 0-23.61 9.89Q450-286.22 450-272.82q0 13.4 10.39 23.61Q470.78-239 484.18-239Zm0-109q12.82 0 21.32-8.63 8.5-8.62 8.5-21.37v-156q0-12.75-8.68-21.38-8.67-8.62-21.5-8.62-12.82 0-21.32 8.62-8.5 8.63-8.5 21.38v156q0 12.75 8.68 21.37 8.67 8.63 21.5 8.63Z"
  })
});
var warning_fill_default2 = SvgComponent493;

// ../../../node_modules/@material-symbols/svg-700/rounded/warning.svg
import * as React494 from "react";
import { jsx as jsx585 } from "react/jsx-runtime";
var SvgComponent494 = (props) => /* @__PURE__ */ jsx585("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx585("path", {
    d: "M100-107q-14.48 0-24.98-6.93Q64.52-120.85 59-131q-6.17-9.6-6.58-22.38Q52-166.16 59-179l380-656q7-12 18.1-17.5 11.11-5.5 23-5.5 11.9 0 22.9 5.5 11 5.5 18 17.5l380 656q7 12.84 6.58 25.62-.41 12.78-6.58 22.38-5.7 9.75-16.11 16.87Q874.48-107 860-107H100Zm63-84h634L480-739 163-191Zm321.18-48q13.4 0 23.61-10.39Q518-259.78 518-273.18q0-13.4-10.39-23.11-10.39-9.71-23.79-9.71-13.4 0-23.61 9.89Q450-286.22 450-272.82q0 13.4 10.39 23.61Q470.78-239 484.18-239Zm0-109q12.82 0 21.32-8.63 8.5-8.62 8.5-21.37v-156q0-12.75-8.68-21.38-8.67-8.62-21.5-8.62-12.82 0-21.32 8.62-8.5 8.63-8.5 21.38v156q0 12.75 8.68 21.37 8.67 8.63 21.5 8.63ZM480-465Z"
  })
});
var warning_default2 = SvgComponent494;

// ../../../node_modules/@material-symbols/svg-700/sharp/warning-fill.svg
import * as React495 from "react";
import { jsx as jsx586 } from "react/jsx-runtime";
var SvgComponent495 = (props) => /* @__PURE__ */ jsx586("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx586("path", {
    d: "m18-107 462-799 462 799H18Zm466.18-132q13.4 0 23.61-10.39Q518-259.78 518-273.18q0-13.4-10.39-23.11-10.39-9.71-23.79-9.71-13.4 0-23.61 9.89Q450-286.22 450-272.82q0 13.4 10.39 23.61Q470.78-239 484.18-239ZM454-348h60v-216h-60v216Z"
  })
});
var warning_fill_default3 = SvgComponent495;

// ../../../node_modules/@material-symbols/svg-700/sharp/warning.svg
import * as React496 from "react";
import { jsx as jsx587 } from "react/jsx-runtime";
var SvgComponent496 = (props) => /* @__PURE__ */ jsx587("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960",
  ...props,
  children: /* @__PURE__ */ jsx587("path", {
    d: "m18-107 462-799 462 799H18Zm145-84h634L480-739 163-191Zm321.18-48q13.4 0 23.61-10.39Q518-259.78 518-273.18q0-13.4-10.39-23.11-10.39-9.71-23.79-9.71-13.4 0-23.61 9.89Q450-286.22 450-272.82q0 13.4 10.39 23.61Q470.78-239 484.18-239ZM454-348h60v-216h-60v216Zm26-117Z"
  })
});
var warning_default3 = SvgComponent496;

// src/components/icon/variants/IconWarning.tsx
import { useTranslation as useTranslation91 } from "react-i18next";
import { jsx as jsx588 } from "react/jsx-runtime";
var componentMap81 = {
  outlined: warning_default,
  "outlined-fill": warning_fill_default,
  rounded: warning_default2,
  "rounded-fill": warning_fill_default2,
  sharp: warning_default3,
  "sharp-fill": warning_fill_default3
};
var IconWarning = ({
  color,
  filled,
  height,
  variant = "rounded",
  style = {},
  width
}) => {
  const { t } = useTranslation91("pds");
  const key = `${variant}${filled ? "-fill" : ""}`;
  const SvgIcon = componentMap81[key] ?? componentMap81[DEFAULT_VARIANT];
  return /* @__PURE__ */ jsx588(Icon, {
    SvgIcon,
    alt: t(""),
    color,
    style,
    height,
    width
  });
};
// src/components/avatar/avatar.module.css
injectStyle(".xKLHAG_root[data-action=true]{cursor:pointer}");
var avatar_module_default = { root: "xKLHAG_root" };

// src/components/avatar/Avatar.tsx
import { jsx as jsx589 } from "react/jsx-runtime";
var sizeMap = {
  sm: {
    pixelSize: "2rem",
    fontSize: "sm",
    fontWeight: 400
  },
  md: {
    pixelSize: "2.5rem",
    fontSize: "lg",
    fontWeight: 600
  },
  lg: {
    pixelSize: "3rem",
    fontSize: "xl",
    fontWeight: 600
  },
  xl: {
    pixelSize: "3.5rem",
    fontSize: "xl",
    fontWeight: 600
  }
};
var AvatarContent = ({
  AvatarIcon,
  initials,
  children,
  size = "md",
  color = "primary"
}) => {
  const { fontSize, fontWeight, pixelSize } = sizeMap[size];
  if (initials) {
    return /* @__PURE__ */ jsx589(Text, {
      size: fontSize,
      fw: fontWeight,
      children: initials
    });
  }
  if (AvatarIcon) {
    return /* @__PURE__ */ jsx589(AvatarIcon, {
      color,
      width: `calc(${pixelSize} * 0.6)`,
      height: `calc(${pixelSize} * 0.6)`
    });
  }
  return children;
};
var Avatar = ({
  size = "md",
  src,
  alt,
  initials,
  AvatarIcon,
  color = "primary",
  children,
  onClick
}) => {
  const [altText, setAltText] = useState6(alt);
  const theme2 = useMantineTheme();
  const iconColor = theme2.other.getIconColor(color);
  useEffect5(() => {
    if (src === undefined) {
      setAltText(undefined);
    }
  }, [src]);
  return /* @__PURE__ */ jsx589(MantineAvatar, {
    src,
    alt: altText,
    size: sizeMap[size].pixelSize,
    "data-testid": "avatar",
    "data-action": Boolean(onClick),
    imageProps: {
      onError: () => {
        setAltText(undefined);
      }
    },
    color: iconColor,
    classNames: avatar_module_default,
    onClick,
    children: /* @__PURE__ */ jsx589(AvatarContent, {
      AvatarIcon: AvatarIcon ?? IconPerson,
      initials: initials?.slice(0, 2).toUpperCase(),
      size,
      children
    })
  });
};

// src/components/mantine-passthroughs/index.ts
import {
  Affix,
  AvatarGroup,
  Blockquote,
  Box as Box3,
  Center,
  CloseButton,
  Collapse,
  Flex,
  Grid,
  GridCol,
  Group,
  Image,
  AppShell,
  Popover,
  ScrollArea,
  Space,
  Spoiler,
  Stack,
  Switch,
  Table,
  Text as Text2,
  Tooltip,
  Transition
} from "@mantine/core";
import { modals } from "@mantine/modals";

// ../../../node_modules/@mantine/dropzone/esm/Dropzone.mjs
import { jsx as jsx591, jsxs as jsxs9 } from "react/jsx-runtime";

// ../../../node_modules/react-dropzone-esm/dist/esm/index.mjs
var import_prop_types = __toESM(require_prop_types(), 1);
import React497, { forwardRef, useImperativeHandle, Fragment, useMemo as useMemo2, useRef as useRef7, useReducer, useEffect as useEffect6, useCallback as useCallback8 } from "react";

// ../../../node_modules/react-dropzone-esm/dist/esm/file.mjs
var COMMON_MIME_TYPES = /* @__PURE__ */ new Map([
  ["1km", "application/vnd.1000minds.decision-model+xml"],
  ["3dml", "text/vnd.in3d.3dml"],
  ["3ds", "image/x-3ds"],
  ["3g2", "video/3gpp2"],
  ["3gp", "video/3gp"],
  ["3gpp", "video/3gpp"],
  ["3mf", "model/3mf"],
  ["7z", "application/x-7z-compressed"],
  ["7zip", "application/x-7z-compressed"],
  ["123", "application/vnd.lotus-1-2-3"],
  ["aab", "application/x-authorware-bin"],
  ["aac", "audio/x-acc"],
  ["aam", "application/x-authorware-map"],
  ["aas", "application/x-authorware-seg"],
  ["abw", "application/x-abiword"],
  ["ac", "application/vnd.nokia.n-gage.ac+xml"],
  ["ac3", "audio/ac3"],
  ["acc", "application/vnd.americandynamics.acc"],
  ["ace", "application/x-ace-compressed"],
  ["acu", "application/vnd.acucobol"],
  ["acutc", "application/vnd.acucorp"],
  ["adp", "audio/adpcm"],
  ["aep", "application/vnd.audiograph"],
  ["afm", "application/x-font-type1"],
  ["afp", "application/vnd.ibm.modcap"],
  ["ahead", "application/vnd.ahead.space"],
  ["ai", "application/pdf"],
  ["aif", "audio/x-aiff"],
  ["aifc", "audio/x-aiff"],
  ["aiff", "audio/x-aiff"],
  ["air", "application/vnd.adobe.air-application-installer-package+zip"],
  ["ait", "application/vnd.dvb.ait"],
  ["ami", "application/vnd.amiga.ami"],
  ["amr", "audio/amr"],
  ["apk", "application/vnd.android.package-archive"],
  ["apng", "image/apng"],
  ["appcache", "text/cache-manifest"],
  ["application", "application/x-ms-application"],
  ["apr", "application/vnd.lotus-approach"],
  ["arc", "application/x-freearc"],
  ["arj", "application/x-arj"],
  ["asc", "application/pgp-signature"],
  ["asf", "video/x-ms-asf"],
  ["asm", "text/x-asm"],
  ["aso", "application/vnd.accpac.simply.aso"],
  ["asx", "video/x-ms-asf"],
  ["atc", "application/vnd.acucorp"],
  ["atom", "application/atom+xml"],
  ["atomcat", "application/atomcat+xml"],
  ["atomdeleted", "application/atomdeleted+xml"],
  ["atomsvc", "application/atomsvc+xml"],
  ["atx", "application/vnd.antix.game-component"],
  ["au", "audio/x-au"],
  ["avi", "video/x-msvideo"],
  ["avif", "image/avif"],
  ["aw", "application/applixware"],
  ["azf", "application/vnd.airzip.filesecure.azf"],
  ["azs", "application/vnd.airzip.filesecure.azs"],
  ["azv", "image/vnd.airzip.accelerator.azv"],
  ["azw", "application/vnd.amazon.ebook"],
  ["b16", "image/vnd.pco.b16"],
  ["bat", "application/x-msdownload"],
  ["bcpio", "application/x-bcpio"],
  ["bdf", "application/x-font-bdf"],
  ["bdm", "application/vnd.syncml.dm+wbxml"],
  ["bdoc", "application/x-bdoc"],
  ["bed", "application/vnd.realvnc.bed"],
  ["bh2", "application/vnd.fujitsu.oasysprs"],
  ["bin", "application/octet-stream"],
  ["blb", "application/x-blorb"],
  ["blorb", "application/x-blorb"],
  ["bmi", "application/vnd.bmi"],
  ["bmml", "application/vnd.balsamiq.bmml+xml"],
  ["bmp", "image/bmp"],
  ["book", "application/vnd.framemaker"],
  ["box", "application/vnd.previewsystems.box"],
  ["boz", "application/x-bzip2"],
  ["bpk", "application/octet-stream"],
  ["bpmn", "application/octet-stream"],
  ["bsp", "model/vnd.valve.source.compiled-map"],
  ["btif", "image/prs.btif"],
  ["buffer", "application/octet-stream"],
  ["bz", "application/x-bzip"],
  ["bz2", "application/x-bzip2"],
  ["c", "text/x-c"],
  ["c4d", "application/vnd.clonk.c4group"],
  ["c4f", "application/vnd.clonk.c4group"],
  ["c4g", "application/vnd.clonk.c4group"],
  ["c4p", "application/vnd.clonk.c4group"],
  ["c4u", "application/vnd.clonk.c4group"],
  ["c11amc", "application/vnd.cluetrust.cartomobile-config"],
  ["c11amz", "application/vnd.cluetrust.cartomobile-config-pkg"],
  ["cab", "application/vnd.ms-cab-compressed"],
  ["caf", "audio/x-caf"],
  ["cap", "application/vnd.tcpdump.pcap"],
  ["car", "application/vnd.curl.car"],
  ["cat", "application/vnd.ms-pki.seccat"],
  ["cb7", "application/x-cbr"],
  ["cba", "application/x-cbr"],
  ["cbr", "application/x-cbr"],
  ["cbt", "application/x-cbr"],
  ["cbz", "application/x-cbr"],
  ["cc", "text/x-c"],
  ["cco", "application/x-cocoa"],
  ["cct", "application/x-director"],
  ["ccxml", "application/ccxml+xml"],
  ["cdbcmsg", "application/vnd.contact.cmsg"],
  ["cda", "application/x-cdf"],
  ["cdf", "application/x-netcdf"],
  ["cdfx", "application/cdfx+xml"],
  ["cdkey", "application/vnd.mediastation.cdkey"],
  ["cdmia", "application/cdmi-capability"],
  ["cdmic", "application/cdmi-container"],
  ["cdmid", "application/cdmi-domain"],
  ["cdmio", "application/cdmi-object"],
  ["cdmiq", "application/cdmi-queue"],
  ["cdr", "application/cdr"],
  ["cdx", "chemical/x-cdx"],
  ["cdxml", "application/vnd.chemdraw+xml"],
  ["cdy", "application/vnd.cinderella"],
  ["cer", "application/pkix-cert"],
  ["cfs", "application/x-cfs-compressed"],
  ["cgm", "image/cgm"],
  ["chat", "application/x-chat"],
  ["chm", "application/vnd.ms-htmlhelp"],
  ["chrt", "application/vnd.kde.kchart"],
  ["cif", "chemical/x-cif"],
  ["cii", "application/vnd.anser-web-certificate-issue-initiation"],
  ["cil", "application/vnd.ms-artgalry"],
  ["cjs", "application/node"],
  ["cla", "application/vnd.claymore"],
  ["class", "application/octet-stream"],
  ["clkk", "application/vnd.crick.clicker.keyboard"],
  ["clkp", "application/vnd.crick.clicker.palette"],
  ["clkt", "application/vnd.crick.clicker.template"],
  ["clkw", "application/vnd.crick.clicker.wordbank"],
  ["clkx", "application/vnd.crick.clicker"],
  ["clp", "application/x-msclip"],
  ["cmc", "application/vnd.cosmocaller"],
  ["cmdf", "chemical/x-cmdf"],
  ["cml", "chemical/x-cml"],
  ["cmp", "application/vnd.yellowriver-custom-menu"],
  ["cmx", "image/x-cmx"],
  ["cod", "application/vnd.rim.cod"],
  ["coffee", "text/coffeescript"],
  ["com", "application/x-msdownload"],
  ["conf", "text/plain"],
  ["cpio", "application/x-cpio"],
  ["cpp", "text/x-c"],
  ["cpt", "application/mac-compactpro"],
  ["crd", "application/x-mscardfile"],
  ["crl", "application/pkix-crl"],
  ["crt", "application/x-x509-ca-cert"],
  ["crx", "application/x-chrome-extension"],
  ["cryptonote", "application/vnd.rig.cryptonote"],
  ["csh", "application/x-csh"],
  ["csl", "application/vnd.citationstyles.style+xml"],
  ["csml", "chemical/x-csml"],
  ["csp", "application/vnd.commonspace"],
  ["csr", "application/octet-stream"],
  ["css", "text/css"],
  ["cst", "application/x-director"],
  ["csv", "text/csv"],
  ["cu", "application/cu-seeme"],
  ["curl", "text/vnd.curl"],
  ["cww", "application/prs.cww"],
  ["cxt", "application/x-director"],
  ["cxx", "text/x-c"],
  ["dae", "model/vnd.collada+xml"],
  ["daf", "application/vnd.mobius.daf"],
  ["dart", "application/vnd.dart"],
  ["dataless", "application/vnd.fdsn.seed"],
  ["davmount", "application/davmount+xml"],
  ["dbf", "application/vnd.dbf"],
  ["dbk", "application/docbook+xml"],
  ["dcr", "application/x-director"],
  ["dcurl", "text/vnd.curl.dcurl"],
  ["dd2", "application/vnd.oma.dd2+xml"],
  ["ddd", "application/vnd.fujixerox.ddd"],
  ["ddf", "application/vnd.syncml.dmddf+xml"],
  ["dds", "image/vnd.ms-dds"],
  ["deb", "application/x-debian-package"],
  ["def", "text/plain"],
  ["deploy", "application/octet-stream"],
  ["der", "application/x-x509-ca-cert"],
  ["dfac", "application/vnd.dreamfactory"],
  ["dgc", "application/x-dgc-compressed"],
  ["dic", "text/x-c"],
  ["dir", "application/x-director"],
  ["dis", "application/vnd.mobius.dis"],
  ["disposition-notification", "message/disposition-notification"],
  ["dist", "application/octet-stream"],
  ["distz", "application/octet-stream"],
  ["djv", "image/vnd.djvu"],
  ["djvu", "image/vnd.djvu"],
  ["dll", "application/octet-stream"],
  ["dmg", "application/x-apple-diskimage"],
  ["dmn", "application/octet-stream"],
  ["dmp", "application/vnd.tcpdump.pcap"],
  ["dms", "application/octet-stream"],
  ["dna", "application/vnd.dna"],
  ["doc", "application/msword"],
  ["docm", "application/vnd.ms-word.template.macroEnabled.12"],
  [
    "docx",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  ],
  ["dot", "application/msword"],
  ["dotm", "application/vnd.ms-word.template.macroEnabled.12"],
  [
    "dotx",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.template"
  ],
  ["dp", "application/vnd.osgi.dp"],
  ["dpg", "application/vnd.dpgraph"],
  ["dra", "audio/vnd.dra"],
  ["drle", "image/dicom-rle"],
  ["dsc", "text/prs.lines.tag"],
  ["dssc", "application/dssc+der"],
  ["dtb", "application/x-dtbook+xml"],
  ["dtd", "application/xml-dtd"],
  ["dts", "audio/vnd.dts"],
  ["dtshd", "audio/vnd.dts.hd"],
  ["dump", "application/octet-stream"],
  ["dvb", "video/vnd.dvb.file"],
  ["dvi", "application/x-dvi"],
  ["dwd", "application/atsc-dwd+xml"],
  ["dwf", "model/vnd.dwf"],
  ["dwg", "image/vnd.dwg"],
  ["dxf", "image/vnd.dxf"],
  ["dxp", "application/vnd.spotfire.dxp"],
  ["dxr", "application/x-director"],
  ["ear", "application/java-archive"],
  ["ecelp4800", "audio/vnd.nuera.ecelp4800"],
  ["ecelp7470", "audio/vnd.nuera.ecelp7470"],
  ["ecelp9600", "audio/vnd.nuera.ecelp9600"],
  ["ecma", "application/ecmascript"],
  ["edm", "application/vnd.novadigm.edm"],
  ["edx", "application/vnd.novadigm.edx"],
  ["efif", "application/vnd.picsel"],
  ["ei6", "application/vnd.pg.osasli"],
  ["elc", "application/octet-stream"],
  ["emf", "image/emf"],
  ["eml", "message/rfc822"],
  ["emma", "application/emma+xml"],
  ["emotionml", "application/emotionml+xml"],
  ["emz", "application/x-msmetafile"],
  ["eol", "audio/vnd.digital-winds"],
  ["eot", "application/vnd.ms-fontobject"],
  ["eps", "application/postscript"],
  ["epub", "application/epub+zip"],
  ["es", "application/ecmascript"],
  ["es3", "application/vnd.eszigno3+xml"],
  ["esa", "application/vnd.osgi.subsystem"],
  ["esf", "application/vnd.epson.esf"],
  ["et3", "application/vnd.eszigno3+xml"],
  ["etx", "text/x-setext"],
  ["eva", "application/x-eva"],
  ["evy", "application/x-envoy"],
  ["exe", "application/octet-stream"],
  ["exi", "application/exi"],
  ["exp", "application/express"],
  ["exr", "image/aces"],
  ["ext", "application/vnd.novadigm.ext"],
  ["ez", "application/andrew-inset"],
  ["ez2", "application/vnd.ezpix-album"],
  ["ez3", "application/vnd.ezpix-package"],
  ["f", "text/x-fortran"],
  ["f4v", "video/mp4"],
  ["f77", "text/x-fortran"],
  ["f90", "text/x-fortran"],
  ["fbs", "image/vnd.fastbidsheet"],
  ["fcdt", "application/vnd.adobe.formscentral.fcdt"],
  ["fcs", "application/vnd.isac.fcs"],
  ["fdf", "application/vnd.fdf"],
  ["fdt", "application/fdt+xml"],
  ["fe_launch", "application/vnd.denovo.fcselayout-link"],
  ["fg5", "application/vnd.fujitsu.oasysgp"],
  ["fgd", "application/x-director"],
  ["fh", "image/x-freehand"],
  ["fh4", "image/x-freehand"],
  ["fh5", "image/x-freehand"],
  ["fh7", "image/x-freehand"],
  ["fhc", "image/x-freehand"],
  ["fig", "application/x-xfig"],
  ["fits", "image/fits"],
  ["flac", "audio/x-flac"],
  ["fli", "video/x-fli"],
  ["flo", "application/vnd.micrografx.flo"],
  ["flv", "video/x-flv"],
  ["flw", "application/vnd.kde.kivio"],
  ["flx", "text/vnd.fmi.flexstor"],
  ["fly", "text/vnd.fly"],
  ["fm", "application/vnd.framemaker"],
  ["fnc", "application/vnd.frogans.fnc"],
  ["fo", "application/vnd.software602.filler.form+xml"],
  ["for", "text/x-fortran"],
  ["fpx", "image/vnd.fpx"],
  ["frame", "application/vnd.framemaker"],
  ["fsc", "application/vnd.fsc.weblaunch"],
  ["fst", "image/vnd.fst"],
  ["ftc", "application/vnd.fluxtime.clip"],
  ["fti", "application/vnd.anser-web-funds-transfer-initiation"],
  ["fvt", "video/vnd.fvt"],
  ["fxp", "application/vnd.adobe.fxp"],
  ["fxpl", "application/vnd.adobe.fxp"],
  ["fzs", "application/vnd.fuzzysheet"],
  ["g2w", "application/vnd.geoplan"],
  ["g3", "image/g3fax"],
  ["g3w", "application/vnd.geospace"],
  ["gac", "application/vnd.groove-account"],
  ["gam", "application/x-tads"],
  ["gbr", "application/rpki-ghostbusters"],
  ["gca", "application/x-gca-compressed"],
  ["gdl", "model/vnd.gdl"],
  ["gdoc", "application/vnd.google-apps.document"],
  ["geo", "application/vnd.dynageo"],
  ["geojson", "application/geo+json"],
  ["gex", "application/vnd.geometry-explorer"],
  ["ggb", "application/vnd.geogebra.file"],
  ["ggt", "application/vnd.geogebra.tool"],
  ["ghf", "application/vnd.groove-help"],
  ["gif", "image/gif"],
  ["gim", "application/vnd.groove-identity-message"],
  ["glb", "model/gltf-binary"],
  ["gltf", "model/gltf+json"],
  ["gml", "application/gml+xml"],
  ["gmx", "application/vnd.gmx"],
  ["gnumeric", "application/x-gnumeric"],
  ["gpg", "application/gpg-keys"],
  ["gph", "application/vnd.flographit"],
  ["gpx", "application/gpx+xml"],
  ["gqf", "application/vnd.grafeq"],
  ["gqs", "application/vnd.grafeq"],
  ["gram", "application/srgs"],
  ["gramps", "application/x-gramps-xml"],
  ["gre", "application/vnd.geometry-explorer"],
  ["grv", "application/vnd.groove-injector"],
  ["grxml", "application/srgs+xml"],
  ["gsf", "application/x-font-ghostscript"],
  ["gsheet", "application/vnd.google-apps.spreadsheet"],
  ["gslides", "application/vnd.google-apps.presentation"],
  ["gtar", "application/x-gtar"],
  ["gtm", "application/vnd.groove-tool-message"],
  ["gtw", "model/vnd.gtw"],
  ["gv", "text/vnd.graphviz"],
  ["gxf", "application/gxf"],
  ["gxt", "application/vnd.geonext"],
  ["gz", "application/gzip"],
  ["gzip", "application/gzip"],
  ["h", "text/x-c"],
  ["h261", "video/h261"],
  ["h263", "video/h263"],
  ["h264", "video/h264"],
  ["hal", "application/vnd.hal+xml"],
  ["hbci", "application/vnd.hbci"],
  ["hbs", "text/x-handlebars-template"],
  ["hdd", "application/x-virtualbox-hdd"],
  ["hdf", "application/x-hdf"],
  ["heic", "image/heic"],
  ["heics", "image/heic-sequence"],
  ["heif", "image/heif"],
  ["heifs", "image/heif-sequence"],
  ["hej2", "image/hej2k"],
  ["held", "application/atsc-held+xml"],
  ["hh", "text/x-c"],
  ["hjson", "application/hjson"],
  ["hlp", "application/winhlp"],
  ["hpgl", "application/vnd.hp-hpgl"],
  ["hpid", "application/vnd.hp-hpid"],
  ["hps", "application/vnd.hp-hps"],
  ["hqx", "application/mac-binhex40"],
  ["hsj2", "image/hsj2"],
  ["htc", "text/x-component"],
  ["htke", "application/vnd.kenameaapp"],
  ["htm", "text/html"],
  ["html", "text/html"],
  ["hvd", "application/vnd.yamaha.hv-dic"],
  ["hvp", "application/vnd.yamaha.hv-voice"],
  ["hvs", "application/vnd.yamaha.hv-script"],
  ["i2g", "application/vnd.intergeo"],
  ["icc", "application/vnd.iccprofile"],
  ["ice", "x-conference/x-cooltalk"],
  ["icm", "application/vnd.iccprofile"],
  ["ico", "image/x-icon"],
  ["ics", "text/calendar"],
  ["ief", "image/ief"],
  ["ifb", "text/calendar"],
  ["ifm", "application/vnd.shana.informed.formdata"],
  ["iges", "model/iges"],
  ["igl", "application/vnd.igloader"],
  ["igm", "application/vnd.insors.igm"],
  ["igs", "model/iges"],
  ["igx", "application/vnd.micrografx.igx"],
  ["iif", "application/vnd.shana.informed.interchange"],
  ["img", "application/octet-stream"],
  ["imp", "application/vnd.accpac.simply.imp"],
  ["ims", "application/vnd.ms-ims"],
  ["in", "text/plain"],
  ["ini", "text/plain"],
  ["ink", "application/inkml+xml"],
  ["inkml", "application/inkml+xml"],
  ["install", "application/x-install-instructions"],
  ["iota", "application/vnd.astraea-software.iota"],
  ["ipfix", "application/ipfix"],
  ["ipk", "application/vnd.shana.informed.package"],
  ["irm", "application/vnd.ibm.rights-management"],
  ["irp", "application/vnd.irepository.package+xml"],
  ["iso", "application/x-iso9660-image"],
  ["itp", "application/vnd.shana.informed.formtemplate"],
  ["its", "application/its+xml"],
  ["ivp", "application/vnd.immervision-ivp"],
  ["ivu", "application/vnd.immervision-ivu"],
  ["jad", "text/vnd.sun.j2me.app-descriptor"],
  ["jade", "text/jade"],
  ["jam", "application/vnd.jam"],
  ["jar", "application/java-archive"],
  ["jardiff", "application/x-java-archive-diff"],
  ["java", "text/x-java-source"],
  ["jhc", "image/jphc"],
  ["jisp", "application/vnd.jisp"],
  ["jls", "image/jls"],
  ["jlt", "application/vnd.hp-jlyt"],
  ["jng", "image/x-jng"],
  ["jnlp", "application/x-java-jnlp-file"],
  ["joda", "application/vnd.joost.joda-archive"],
  ["jp2", "image/jp2"],
  ["jpe", "image/jpeg"],
  ["jpeg", "image/jpeg"],
  ["jpf", "image/jpx"],
  ["jpg", "image/jpeg"],
  ["jpg2", "image/jp2"],
  ["jpgm", "video/jpm"],
  ["jpgv", "video/jpeg"],
  ["jph", "image/jph"],
  ["jpm", "video/jpm"],
  ["jpx", "image/jpx"],
  ["js", "application/javascript"],
  ["json", "application/json"],
  ["json5", "application/json5"],
  ["jsonld", "application/ld+json"],
  ["jsonl", "application/jsonl"],
  ["jsonml", "application/jsonml+json"],
  ["jsx", "text/jsx"],
  ["jxr", "image/jxr"],
  ["jxra", "image/jxra"],
  ["jxrs", "image/jxrs"],
  ["jxs", "image/jxs"],
  ["jxsc", "image/jxsc"],
  ["jxsi", "image/jxsi"],
  ["jxss", "image/jxss"],
  ["kar", "audio/midi"],
  ["karbon", "application/vnd.kde.karbon"],
  ["kdb", "application/octet-stream"],
  ["kdbx", "application/x-keepass2"],
  ["key", "application/x-iwork-keynote-sffkey"],
  ["kfo", "application/vnd.kde.kformula"],
  ["kia", "application/vnd.kidspiration"],
  ["kml", "application/vnd.google-earth.kml+xml"],
  ["kmz", "application/vnd.google-earth.kmz"],
  ["kne", "application/vnd.kinar"],
  ["knp", "application/vnd.kinar"],
  ["kon", "application/vnd.kde.kontour"],
  ["kpr", "application/vnd.kde.kpresenter"],
  ["kpt", "application/vnd.kde.kpresenter"],
  ["kpxx", "application/vnd.ds-keypoint"],
  ["ksp", "application/vnd.kde.kspread"],
  ["ktr", "application/vnd.kahootz"],
  ["ktx", "image/ktx"],
  ["ktx2", "image/ktx2"],
  ["ktz", "application/vnd.kahootz"],
  ["kwd", "application/vnd.kde.kword"],
  ["kwt", "application/vnd.kde.kword"],
  ["lasxml", "application/vnd.las.las+xml"],
  ["latex", "application/x-latex"],
  ["lbd", "application/vnd.llamagraphics.life-balance.desktop"],
  ["lbe", "application/vnd.llamagraphics.life-balance.exchange+xml"],
  ["les", "application/vnd.hhe.lesson-player"],
  ["less", "text/less"],
  ["lgr", "application/lgr+xml"],
  ["lha", "application/octet-stream"],
  ["link66", "application/vnd.route66.link66+xml"],
  ["list", "text/plain"],
  ["list3820", "application/vnd.ibm.modcap"],
  ["listafp", "application/vnd.ibm.modcap"],
  ["litcoffee", "text/coffeescript"],
  ["lnk", "application/x-ms-shortcut"],
  ["log", "text/plain"],
  ["lostxml", "application/lost+xml"],
  ["lrf", "application/octet-stream"],
  ["lrm", "application/vnd.ms-lrm"],
  ["ltf", "application/vnd.frogans.ltf"],
  ["lua", "text/x-lua"],
  ["luac", "application/x-lua-bytecode"],
  ["lvp", "audio/vnd.lucent.voice"],
  ["lwp", "application/vnd.lotus-wordpro"],
  ["lzh", "application/octet-stream"],
  ["m1v", "video/mpeg"],
  ["m2a", "audio/mpeg"],
  ["m2v", "video/mpeg"],
  ["m3a", "audio/mpeg"],
  ["m3u", "text/plain"],
  ["m3u8", "application/vnd.apple.mpegurl"],
  ["m4a", "audio/x-m4a"],
  ["m4p", "application/mp4"],
  ["m4s", "video/iso.segment"],
  ["m4u", "application/vnd.mpegurl"],
  ["m4v", "video/x-m4v"],
  ["m13", "application/x-msmediaview"],
  ["m14", "application/x-msmediaview"],
  ["m21", "application/mp21"],
  ["ma", "application/mathematica"],
  ["mads", "application/mads+xml"],
  ["maei", "application/mmt-aei+xml"],
  ["mag", "application/vnd.ecowin.chart"],
  ["maker", "application/vnd.framemaker"],
  ["man", "text/troff"],
  ["manifest", "text/cache-manifest"],
  ["map", "application/json"],
  ["mar", "application/octet-stream"],
  ["markdown", "text/markdown"],
  ["mathml", "application/mathml+xml"],
  ["mb", "application/mathematica"],
  ["mbk", "application/vnd.mobius.mbk"],
  ["mbox", "application/mbox"],
  ["mc1", "application/vnd.medcalcdata"],
  ["mcd", "application/vnd.mcd"],
  ["mcurl", "text/vnd.curl.mcurl"],
  ["md", "text/markdown"],
  ["mdb", "application/x-msaccess"],
  ["mdi", "image/vnd.ms-modi"],
  ["mdx", "text/mdx"],
  ["me", "text/troff"],
  ["mesh", "model/mesh"],
  ["meta4", "application/metalink4+xml"],
  ["metalink", "application/metalink+xml"],
  ["mets", "application/mets+xml"],
  ["mfm", "application/vnd.mfmp"],
  ["mft", "application/rpki-manifest"],
  ["mgp", "application/vnd.osgeo.mapguide.package"],
  ["mgz", "application/vnd.proteus.magazine"],
  ["mid", "audio/midi"],
  ["midi", "audio/midi"],
  ["mie", "application/x-mie"],
  ["mif", "application/vnd.mif"],
  ["mime", "message/rfc822"],
  ["mj2", "video/mj2"],
  ["mjp2", "video/mj2"],
  ["mjs", "application/javascript"],
  ["mk3d", "video/x-matroska"],
  ["mka", "audio/x-matroska"],
  ["mkd", "text/x-markdown"],
  ["mks", "video/x-matroska"],
  ["mkv", "video/x-matroska"],
  ["mlp", "application/vnd.dolby.mlp"],
  ["mmd", "application/vnd.chipnuts.karaoke-mmd"],
  ["mmf", "application/vnd.smaf"],
  ["mml", "text/mathml"],
  ["mmr", "image/vnd.fujixerox.edmics-mmr"],
  ["mng", "video/x-mng"],
  ["mny", "application/x-msmoney"],
  ["mobi", "application/x-mobipocket-ebook"],
  ["mods", "application/mods+xml"],
  ["mov", "video/quicktime"],
  ["movie", "video/x-sgi-movie"],
  ["mp2", "audio/mpeg"],
  ["mp2a", "audio/mpeg"],
  ["mp3", "audio/mpeg"],
  ["mp4", "video/mp4"],
  ["mp4a", "audio/mp4"],
  ["mp4s", "application/mp4"],
  ["mp4v", "video/mp4"],
  ["mp21", "application/mp21"],
  ["mpc", "application/vnd.mophun.certificate"],
  ["mpd", "application/dash+xml"],
  ["mpe", "video/mpeg"],
  ["mpeg", "video/mpeg"],
  ["mpg", "video/mpeg"],
  ["mpg4", "video/mp4"],
  ["mpga", "audio/mpeg"],
  ["mpkg", "application/vnd.apple.installer+xml"],
  ["mpm", "application/vnd.blueice.multipass"],
  ["mpn", "application/vnd.mophun.application"],
  ["mpp", "application/vnd.ms-project"],
  ["mpt", "application/vnd.ms-project"],
  ["mpy", "application/vnd.ibm.minipay"],
  ["mqy", "application/vnd.mobius.mqy"],
  ["mrc", "application/marc"],
  ["mrcx", "application/marcxml+xml"],
  ["ms", "text/troff"],
  ["mscml", "application/mediaservercontrol+xml"],
  ["mseed", "application/vnd.fdsn.mseed"],
  ["mseq", "application/vnd.mseq"],
  ["msf", "application/vnd.epson.msf"],
  ["msg", "application/vnd.ms-outlook"],
  ["msh", "model/mesh"],
  ["msi", "application/x-msdownload"],
  ["msl", "application/vnd.mobius.msl"],
  ["msm", "application/octet-stream"],
  ["msp", "application/octet-stream"],
  ["msty", "application/vnd.muvee.style"],
  ["mtl", "model/mtl"],
  ["mts", "model/vnd.mts"],
  ["mus", "application/vnd.musician"],
  ["musd", "application/mmt-usd+xml"],
  ["musicxml", "application/vnd.recordare.musicxml+xml"],
  ["mvb", "application/x-msmediaview"],
  ["mvt", "application/vnd.mapbox-vector-tile"],
  ["mwf", "application/vnd.mfer"],
  ["mxf", "application/mxf"],
  ["mxl", "application/vnd.recordare.musicxml"],
  ["mxmf", "audio/mobile-xmf"],
  ["mxml", "application/xv+xml"],
  ["mxs", "application/vnd.triscape.mxs"],
  ["mxu", "video/vnd.mpegurl"],
  ["n-gage", "application/vnd.nokia.n-gage.symbian.install"],
  ["n3", "text/n3"],
  ["nb", "application/mathematica"],
  ["nbp", "application/vnd.wolfram.player"],
  ["nc", "application/x-netcdf"],
  ["ncx", "application/x-dtbncx+xml"],
  ["nfo", "text/x-nfo"],
  ["ngdat", "application/vnd.nokia.n-gage.data"],
  ["nitf", "application/vnd.nitf"],
  ["nlu", "application/vnd.neurolanguage.nlu"],
  ["nml", "application/vnd.enliven"],
  ["nnd", "application/vnd.noblenet-directory"],
  ["nns", "application/vnd.noblenet-sealer"],
  ["nnw", "application/vnd.noblenet-web"],
  ["npx", "image/vnd.net-fpx"],
  ["nq", "application/n-quads"],
  ["nsc", "application/x-conference"],
  ["nsf", "application/vnd.lotus-notes"],
  ["nt", "application/n-triples"],
  ["ntf", "application/vnd.nitf"],
  ["numbers", "application/x-iwork-numbers-sffnumbers"],
  ["nzb", "application/x-nzb"],
  ["oa2", "application/vnd.fujitsu.oasys2"],
  ["oa3", "application/vnd.fujitsu.oasys3"],
  ["oas", "application/vnd.fujitsu.oasys"],
  ["obd", "application/x-msbinder"],
  ["obgx", "application/vnd.openblox.game+xml"],
  ["obj", "model/obj"],
  ["oda", "application/oda"],
  ["odb", "application/vnd.oasis.opendocument.database"],
  ["odc", "application/vnd.oasis.opendocument.chart"],
  ["odf", "application/vnd.oasis.opendocument.formula"],
  ["odft", "application/vnd.oasis.opendocument.formula-template"],
  ["odg", "application/vnd.oasis.opendocument.graphics"],
  ["odi", "application/vnd.oasis.opendocument.image"],
  ["odm", "application/vnd.oasis.opendocument.text-master"],
  ["odp", "application/vnd.oasis.opendocument.presentation"],
  ["ods", "application/vnd.oasis.opendocument.spreadsheet"],
  ["odt", "application/vnd.oasis.opendocument.text"],
  ["oga", "audio/ogg"],
  ["ogex", "model/vnd.opengex"],
  ["ogg", "audio/ogg"],
  ["ogv", "video/ogg"],
  ["ogx", "application/ogg"],
  ["omdoc", "application/omdoc+xml"],
  ["onepkg", "application/onenote"],
  ["onetmp", "application/onenote"],
  ["onetoc", "application/onenote"],
  ["onetoc2", "application/onenote"],
  ["opf", "application/oebps-package+xml"],
  ["opml", "text/x-opml"],
  ["oprc", "application/vnd.palm"],
  ["opus", "audio/ogg"],
  ["org", "text/x-org"],
  ["osf", "application/vnd.yamaha.openscoreformat"],
  ["osfpvg", "application/vnd.yamaha.openscoreformat.osfpvg+xml"],
  ["osm", "application/vnd.openstreetmap.data+xml"],
  ["otc", "application/vnd.oasis.opendocument.chart-template"],
  ["otf", "font/otf"],
  ["otg", "application/vnd.oasis.opendocument.graphics-template"],
  ["oth", "application/vnd.oasis.opendocument.text-web"],
  ["oti", "application/vnd.oasis.opendocument.image-template"],
  ["otp", "application/vnd.oasis.opendocument.presentation-template"],
  ["ots", "application/vnd.oasis.opendocument.spreadsheet-template"],
  ["ott", "application/vnd.oasis.opendocument.text-template"],
  ["ova", "application/x-virtualbox-ova"],
  ["ovf", "application/x-virtualbox-ovf"],
  ["owl", "application/rdf+xml"],
  ["oxps", "application/oxps"],
  ["oxt", "application/vnd.openofficeorg.extension"],
  ["p", "text/x-pascal"],
  ["p7a", "application/x-pkcs7-signature"],
  ["p7b", "application/x-pkcs7-certificates"],
  ["p7c", "application/pkcs7-mime"],
  ["p7m", "application/pkcs7-mime"],
  ["p7r", "application/x-pkcs7-certreqresp"],
  ["p7s", "application/pkcs7-signature"],
  ["p8", "application/pkcs8"],
  ["p10", "application/x-pkcs10"],
  ["p12", "application/x-pkcs12"],
  ["pac", "application/x-ns-proxy-autoconfig"],
  ["pages", "application/x-iwork-pages-sffpages"],
  ["pas", "text/x-pascal"],
  ["paw", "application/vnd.pawaafile"],
  ["pbd", "application/vnd.powerbuilder6"],
  ["pbm", "image/x-portable-bitmap"],
  ["pcap", "application/vnd.tcpdump.pcap"],
  ["pcf", "application/x-font-pcf"],
  ["pcl", "application/vnd.hp-pcl"],
  ["pclxl", "application/vnd.hp-pclxl"],
  ["pct", "image/x-pict"],
  ["pcurl", "application/vnd.curl.pcurl"],
  ["pcx", "image/x-pcx"],
  ["pdb", "application/x-pilot"],
  ["pde", "text/x-processing"],
  ["pdf", "application/pdf"],
  ["pem", "application/x-x509-user-cert"],
  ["pfa", "application/x-font-type1"],
  ["pfb", "application/x-font-type1"],
  ["pfm", "application/x-font-type1"],
  ["pfr", "application/font-tdpfr"],
  ["pfx", "application/x-pkcs12"],
  ["pgm", "image/x-portable-graymap"],
  ["pgn", "application/x-chess-pgn"],
  ["pgp", "application/pgp"],
  ["php", "application/x-httpd-php"],
  ["php3", "application/x-httpd-php"],
  ["php4", "application/x-httpd-php"],
  ["phps", "application/x-httpd-php-source"],
  ["phtml", "application/x-httpd-php"],
  ["pic", "image/x-pict"],
  ["pkg", "application/octet-stream"],
  ["pki", "application/pkixcmp"],
  ["pkipath", "application/pkix-pkipath"],
  ["pkpass", "application/vnd.apple.pkpass"],
  ["pl", "application/x-perl"],
  ["plb", "application/vnd.3gpp.pic-bw-large"],
  ["plc", "application/vnd.mobius.plc"],
  ["plf", "application/vnd.pocketlearn"],
  ["pls", "application/pls+xml"],
  ["pm", "application/x-perl"],
  ["pml", "application/vnd.ctc-posml"],
  ["png", "image/png"],
  ["pnm", "image/x-portable-anymap"],
  ["portpkg", "application/vnd.macports.portpkg"],
  ["pot", "application/vnd.ms-powerpoint"],
  ["potm", "application/vnd.ms-powerpoint.presentation.macroEnabled.12"],
  [
    "potx",
    "application/vnd.openxmlformats-officedocument.presentationml.template"
  ],
  ["ppa", "application/vnd.ms-powerpoint"],
  ["ppam", "application/vnd.ms-powerpoint.addin.macroEnabled.12"],
  ["ppd", "application/vnd.cups-ppd"],
  ["ppm", "image/x-portable-pixmap"],
  ["pps", "application/vnd.ms-powerpoint"],
  ["ppsm", "application/vnd.ms-powerpoint.slideshow.macroEnabled.12"],
  [
    "ppsx",
    "application/vnd.openxmlformats-officedocument.presentationml.slideshow"
  ],
  ["ppt", "application/powerpoint"],
  ["pptm", "application/vnd.ms-powerpoint.presentation.macroEnabled.12"],
  [
    "pptx",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation"
  ],
  ["pqa", "application/vnd.palm"],
  ["prc", "application/x-pilot"],
  ["pre", "application/vnd.lotus-freelance"],
  ["prf", "application/pics-rules"],
  ["provx", "application/provenance+xml"],
  ["ps", "application/postscript"],
  ["psb", "application/vnd.3gpp.pic-bw-small"],
  ["psd", "application/x-photoshop"],
  ["psf", "application/x-font-linux-psf"],
  ["pskcxml", "application/pskc+xml"],
  ["pti", "image/prs.pti"],
  ["ptid", "application/vnd.pvi.ptid1"],
  ["pub", "application/x-mspublisher"],
  ["pvb", "application/vnd.3gpp.pic-bw-var"],
  ["pwn", "application/vnd.3m.post-it-notes"],
  ["pya", "audio/vnd.ms-playready.media.pya"],
  ["pyv", "video/vnd.ms-playready.media.pyv"],
  ["qam", "application/vnd.epson.quickanime"],
  ["qbo", "application/vnd.intu.qbo"],
  ["qfx", "application/vnd.intu.qfx"],
  ["qps", "application/vnd.publishare-delta-tree"],
  ["qt", "video/quicktime"],
  ["qwd", "application/vnd.quark.quarkxpress"],
  ["qwt", "application/vnd.quark.quarkxpress"],
  ["qxb", "application/vnd.quark.quarkxpress"],
  ["qxd", "application/vnd.quark.quarkxpress"],
  ["qxl", "application/vnd.quark.quarkxpress"],
  ["qxt", "application/vnd.quark.quarkxpress"],
  ["ra", "audio/x-realaudio"],
  ["ram", "audio/x-pn-realaudio"],
  ["raml", "application/raml+yaml"],
  ["rapd", "application/route-apd+xml"],
  ["rar", "application/x-rar"],
  ["ras", "image/x-cmu-raster"],
  ["rcprofile", "application/vnd.ipunplugged.rcprofile"],
  ["rdf", "application/rdf+xml"],
  ["rdz", "application/vnd.data-vision.rdz"],
  ["relo", "application/p2p-overlay+xml"],
  ["rep", "application/vnd.businessobjects"],
  ["res", "application/x-dtbresource+xml"],
  ["rgb", "image/x-rgb"],
  ["rif", "application/reginfo+xml"],
  ["rip", "audio/vnd.rip"],
  ["ris", "application/x-research-info-systems"],
  ["rl", "application/resource-lists+xml"],
  ["rlc", "image/vnd.fujixerox.edmics-rlc"],
  ["rld", "application/resource-lists-diff+xml"],
  ["rm", "audio/x-pn-realaudio"],
  ["rmi", "audio/midi"],
  ["rmp", "audio/x-pn-realaudio-plugin"],
  ["rms", "application/vnd.jcp.javame.midlet-rms"],
  ["rmvb", "application/vnd.rn-realmedia-vbr"],
  ["rnc", "application/relax-ng-compact-syntax"],
  ["rng", "application/xml"],
  ["roa", "application/rpki-roa"],
  ["roff", "text/troff"],
  ["rp9", "application/vnd.cloanto.rp9"],
  ["rpm", "audio/x-pn-realaudio-plugin"],
  ["rpss", "application/vnd.nokia.radio-presets"],
  ["rpst", "application/vnd.nokia.radio-preset"],
  ["rq", "application/sparql-query"],
  ["rs", "application/rls-services+xml"],
  ["rsa", "application/x-pkcs7"],
  ["rsat", "application/atsc-rsat+xml"],
  ["rsd", "application/rsd+xml"],
  ["rsheet", "application/urc-ressheet+xml"],
  ["rss", "application/rss+xml"],
  ["rtf", "text/rtf"],
  ["rtx", "text/richtext"],
  ["run", "application/x-makeself"],
  ["rusd", "application/route-usd+xml"],
  ["rv", "video/vnd.rn-realvideo"],
  ["s", "text/x-asm"],
  ["s3m", "audio/s3m"],
  ["saf", "application/vnd.yamaha.smaf-audio"],
  ["sass", "text/x-sass"],
  ["sbml", "application/sbml+xml"],
  ["sc", "application/vnd.ibm.secure-container"],
  ["scd", "application/x-msschedule"],
  ["scm", "application/vnd.lotus-screencam"],
  ["scq", "application/scvp-cv-request"],
  ["scs", "application/scvp-cv-response"],
  ["scss", "text/x-scss"],
  ["scurl", "text/vnd.curl.scurl"],
  ["sda", "application/vnd.stardivision.draw"],
  ["sdc", "application/vnd.stardivision.calc"],
  ["sdd", "application/vnd.stardivision.impress"],
  ["sdkd", "application/vnd.solent.sdkm+xml"],
  ["sdkm", "application/vnd.solent.sdkm+xml"],
  ["sdp", "application/sdp"],
  ["sdw", "application/vnd.stardivision.writer"],
  ["sea", "application/octet-stream"],
  ["see", "application/vnd.seemail"],
  ["seed", "application/vnd.fdsn.seed"],
  ["sema", "application/vnd.sema"],
  ["semd", "application/vnd.semd"],
  ["semf", "application/vnd.semf"],
  ["senmlx", "application/senml+xml"],
  ["sensmlx", "application/sensml+xml"],
  ["ser", "application/java-serialized-object"],
  ["setpay", "application/set-payment-initiation"],
  ["setreg", "application/set-registration-initiation"],
  ["sfd-hdstx", "application/vnd.hydrostatix.sof-data"],
  ["sfs", "application/vnd.spotfire.sfs"],
  ["sfv", "text/x-sfv"],
  ["sgi", "image/sgi"],
  ["sgl", "application/vnd.stardivision.writer-global"],
  ["sgm", "text/sgml"],
  ["sgml", "text/sgml"],
  ["sh", "application/x-sh"],
  ["shar", "application/x-shar"],
  ["shex", "text/shex"],
  ["shf", "application/shf+xml"],
  ["shtml", "text/html"],
  ["sid", "image/x-mrsid-image"],
  ["sieve", "application/sieve"],
  ["sig", "application/pgp-signature"],
  ["sil", "audio/silk"],
  ["silo", "model/mesh"],
  ["sis", "application/vnd.symbian.install"],
  ["sisx", "application/vnd.symbian.install"],
  ["sit", "application/x-stuffit"],
  ["sitx", "application/x-stuffitx"],
  ["siv", "application/sieve"],
  ["skd", "application/vnd.koan"],
  ["skm", "application/vnd.koan"],
  ["skp", "application/vnd.koan"],
  ["skt", "application/vnd.koan"],
  ["sldm", "application/vnd.ms-powerpoint.slide.macroenabled.12"],
  [
    "sldx",
    "application/vnd.openxmlformats-officedocument.presentationml.slide"
  ],
  ["slim", "text/slim"],
  ["slm", "text/slim"],
  ["sls", "application/route-s-tsid+xml"],
  ["slt", "application/vnd.epson.salt"],
  ["sm", "application/vnd.stepmania.stepchart"],
  ["smf", "application/vnd.stardivision.math"],
  ["smi", "application/smil"],
  ["smil", "application/smil"],
  ["smv", "video/x-smv"],
  ["smzip", "application/vnd.stepmania.package"],
  ["snd", "audio/basic"],
  ["snf", "application/x-font-snf"],
  ["so", "application/octet-stream"],
  ["spc", "application/x-pkcs7-certificates"],
  ["spdx", "text/spdx"],
  ["spf", "application/vnd.yamaha.smaf-phrase"],
  ["spl", "application/x-futuresplash"],
  ["spot", "text/vnd.in3d.spot"],
  ["spp", "application/scvp-vp-response"],
  ["spq", "application/scvp-vp-request"],
  ["spx", "audio/ogg"],
  ["sql", "application/x-sql"],
  ["src", "application/x-wais-source"],
  ["srt", "application/x-subrip"],
  ["sru", "application/sru+xml"],
  ["srx", "application/sparql-results+xml"],
  ["ssdl", "application/ssdl+xml"],
  ["sse", "application/vnd.kodak-descriptor"],
  ["ssf", "application/vnd.epson.ssf"],
  ["ssml", "application/ssml+xml"],
  ["sst", "application/octet-stream"],
  ["st", "application/vnd.sailingtracker.track"],
  ["stc", "application/vnd.sun.xml.calc.template"],
  ["std", "application/vnd.sun.xml.draw.template"],
  ["stf", "application/vnd.wt.stf"],
  ["sti", "application/vnd.sun.xml.impress.template"],
  ["stk", "application/hyperstudio"],
  ["stl", "model/stl"],
  ["stpx", "model/step+xml"],
  ["stpxz", "model/step-xml+zip"],
  ["stpz", "model/step+zip"],
  ["str", "application/vnd.pg.format"],
  ["stw", "application/vnd.sun.xml.writer.template"],
  ["styl", "text/stylus"],
  ["stylus", "text/stylus"],
  ["sub", "text/vnd.dvb.subtitle"],
  ["sus", "application/vnd.sus-calendar"],
  ["susp", "application/vnd.sus-calendar"],
  ["sv4cpio", "application/x-sv4cpio"],
  ["sv4crc", "application/x-sv4crc"],
  ["svc", "application/vnd.dvb.service"],
  ["svd", "application/vnd.svd"],
  ["svg", "image/svg+xml"],
  ["svgz", "image/svg+xml"],
  ["swa", "application/x-director"],
  ["swf", "application/x-shockwave-flash"],
  ["swi", "application/vnd.aristanetworks.swi"],
  ["swidtag", "application/swid+xml"],
  ["sxc", "application/vnd.sun.xml.calc"],
  ["sxd", "application/vnd.sun.xml.draw"],
  ["sxg", "application/vnd.sun.xml.writer.global"],
  ["sxi", "application/vnd.sun.xml.impress"],
  ["sxm", "application/vnd.sun.xml.math"],
  ["sxw", "application/vnd.sun.xml.writer"],
  ["t", "text/troff"],
  ["t3", "application/x-t3vm-image"],
  ["t38", "image/t38"],
  ["taglet", "application/vnd.mynfc"],
  ["tao", "application/vnd.tao.intent-module-archive"],
  ["tap", "image/vnd.tencent.tap"],
  ["tar", "application/x-tar"],
  ["tcap", "application/vnd.3gpp2.tcap"],
  ["tcl", "application/x-tcl"],
  ["td", "application/urc-targetdesc+xml"],
  ["teacher", "application/vnd.smart.teacher"],
  ["tei", "application/tei+xml"],
  ["teicorpus", "application/tei+xml"],
  ["tex", "application/x-tex"],
  ["texi", "application/x-texinfo"],
  ["texinfo", "application/x-texinfo"],
  ["text", "text/plain"],
  ["tfi", "application/thraud+xml"],
  ["tfm", "application/x-tex-tfm"],
  ["tfx", "image/tiff-fx"],
  ["tga", "image/x-tga"],
  ["tgz", "application/x-tar"],
  ["thmx", "application/vnd.ms-officetheme"],
  ["tif", "image/tiff"],
  ["tiff", "image/tiff"],
  ["tk", "application/x-tcl"],
  ["tmo", "application/vnd.tmobile-livetv"],
  ["toml", "application/toml"],
  ["torrent", "application/x-bittorrent"],
  ["tpl", "application/vnd.groove-tool-template"],
  ["tpt", "application/vnd.trid.tpt"],
  ["tr", "text/troff"],
  ["tra", "application/vnd.trueapp"],
  ["trig", "application/trig"],
  ["trm", "application/x-msterminal"],
  ["ts", "video/mp2t"],
  ["tsd", "application/timestamped-data"],
  ["tsv", "text/tab-separated-values"],
  ["ttc", "font/collection"],
  ["ttf", "font/ttf"],
  ["ttl", "text/turtle"],
  ["ttml", "application/ttml+xml"],
  ["twd", "application/vnd.simtech-mindmapper"],
  ["twds", "application/vnd.simtech-mindmapper"],
  ["txd", "application/vnd.genomatix.tuxedo"],
  ["txf", "application/vnd.mobius.txf"],
  ["txt", "text/plain"],
  ["u8dsn", "message/global-delivery-status"],
  ["u8hdr", "message/global-headers"],
  ["u8mdn", "message/global-disposition-notification"],
  ["u8msg", "message/global"],
  ["u32", "application/x-authorware-bin"],
  ["ubj", "application/ubjson"],
  ["udeb", "application/x-debian-package"],
  ["ufd", "application/vnd.ufdl"],
  ["ufdl", "application/vnd.ufdl"],
  ["ulx", "application/x-glulx"],
  ["umj", "application/vnd.umajin"],
  ["unityweb", "application/vnd.unity"],
  ["uoml", "application/vnd.uoml+xml"],
  ["uri", "text/uri-list"],
  ["uris", "text/uri-list"],
  ["urls", "text/uri-list"],
  ["usdz", "model/vnd.usdz+zip"],
  ["ustar", "application/x-ustar"],
  ["utz", "application/vnd.uiq.theme"],
  ["uu", "text/x-uuencode"],
  ["uva", "audio/vnd.dece.audio"],
  ["uvd", "application/vnd.dece.data"],
  ["uvf", "application/vnd.dece.data"],
  ["uvg", "image/vnd.dece.graphic"],
  ["uvh", "video/vnd.dece.hd"],
  ["uvi", "image/vnd.dece.graphic"],
  ["uvm", "video/vnd.dece.mobile"],
  ["uvp", "video/vnd.dece.pd"],
  ["uvs", "video/vnd.dece.sd"],
  ["uvt", "application/vnd.dece.ttml+xml"],
  ["uvu", "video/vnd.uvvu.mp4"],
  ["uvv", "video/vnd.dece.video"],
  ["uvva", "audio/vnd.dece.audio"],
  ["uvvd", "application/vnd.dece.data"],
  ["uvvf", "application/vnd.dece.data"],
  ["uvvg", "image/vnd.dece.graphic"],
  ["uvvh", "video/vnd.dece.hd"],
  ["uvvi", "image/vnd.dece.graphic"],
  ["uvvm", "video/vnd.dece.mobile"],
  ["uvvp", "video/vnd.dece.pd"],
  ["uvvs", "video/vnd.dece.sd"],
  ["uvvt", "application/vnd.dece.ttml+xml"],
  ["uvvu", "video/vnd.uvvu.mp4"],
  ["uvvv", "video/vnd.dece.video"],
  ["uvvx", "application/vnd.dece.unspecified"],
  ["uvvz", "application/vnd.dece.zip"],
  ["uvx", "application/vnd.dece.unspecified"],
  ["uvz", "application/vnd.dece.zip"],
  ["vbox", "application/x-virtualbox-vbox"],
  ["vbox-extpack", "application/x-virtualbox-vbox-extpack"],
  ["vcard", "text/vcard"],
  ["vcd", "application/x-cdlink"],
  ["vcf", "text/x-vcard"],
  ["vcg", "application/vnd.groove-vcard"],
  ["vcs", "text/x-vcalendar"],
  ["vcx", "application/vnd.vcx"],
  ["vdi", "application/x-virtualbox-vdi"],
  ["vds", "model/vnd.sap.vds"],
  ["vhd", "application/x-virtualbox-vhd"],
  ["vis", "application/vnd.visionary"],
  ["viv", "video/vnd.vivo"],
  ["vlc", "application/videolan"],
  ["vmdk", "application/x-virtualbox-vmdk"],
  ["vob", "video/x-ms-vob"],
  ["vor", "application/vnd.stardivision.writer"],
  ["vox", "application/x-authorware-bin"],
  ["vrml", "model/vrml"],
  ["vsd", "application/vnd.visio"],
  ["vsf", "application/vnd.vsf"],
  ["vss", "application/vnd.visio"],
  ["vst", "application/vnd.visio"],
  ["vsw", "application/vnd.visio"],
  ["vtf", "image/vnd.valve.source.texture"],
  ["vtt", "text/vtt"],
  ["vtu", "model/vnd.vtu"],
  ["vxml", "application/voicexml+xml"],
  ["w3d", "application/x-director"],
  ["wad", "application/x-doom"],
  ["wadl", "application/vnd.sun.wadl+xml"],
  ["war", "application/java-archive"],
  ["wasm", "application/wasm"],
  ["wav", "audio/x-wav"],
  ["wax", "audio/x-ms-wax"],
  ["wbmp", "image/vnd.wap.wbmp"],
  ["wbs", "application/vnd.criticaltools.wbs+xml"],
  ["wbxml", "application/wbxml"],
  ["wcm", "application/vnd.ms-works"],
  ["wdb", "application/vnd.ms-works"],
  ["wdp", "image/vnd.ms-photo"],
  ["weba", "audio/webm"],
  ["webapp", "application/x-web-app-manifest+json"],
  ["webm", "video/webm"],
  ["webmanifest", "application/manifest+json"],
  ["webp", "image/webp"],
  ["wg", "application/vnd.pmi.widget"],
  ["wgt", "application/widget"],
  ["wks", "application/vnd.ms-works"],
  ["wm", "video/x-ms-wm"],
  ["wma", "audio/x-ms-wma"],
  ["wmd", "application/x-ms-wmd"],
  ["wmf", "image/wmf"],
  ["wml", "text/vnd.wap.wml"],
  ["wmlc", "application/wmlc"],
  ["wmls", "text/vnd.wap.wmlscript"],
  ["wmlsc", "application/vnd.wap.wmlscriptc"],
  ["wmv", "video/x-ms-wmv"],
  ["wmx", "video/x-ms-wmx"],
  ["wmz", "application/x-msmetafile"],
  ["woff", "font/woff"],
  ["woff2", "font/woff2"],
  ["word", "application/msword"],
  ["wpd", "application/vnd.wordperfect"],
  ["wpl", "application/vnd.ms-wpl"],
  ["wps", "application/vnd.ms-works"],
  ["wqd", "application/vnd.wqd"],
  ["wri", "application/x-mswrite"],
  ["wrl", "model/vrml"],
  ["wsc", "message/vnd.wfa.wsc"],
  ["wsdl", "application/wsdl+xml"],
  ["wspolicy", "application/wspolicy+xml"],
  ["wtb", "application/vnd.webturbo"],
  ["wvx", "video/x-ms-wvx"],
  ["x3d", "model/x3d+xml"],
  ["x3db", "model/x3d+fastinfoset"],
  ["x3dbz", "model/x3d+binary"],
  ["x3dv", "model/x3d-vrml"],
  ["x3dvz", "model/x3d+vrml"],
  ["x3dz", "model/x3d+xml"],
  ["x32", "application/x-authorware-bin"],
  ["x_b", "model/vnd.parasolid.transmit.binary"],
  ["x_t", "model/vnd.parasolid.transmit.text"],
  ["xaml", "application/xaml+xml"],
  ["xap", "application/x-silverlight-app"],
  ["xar", "application/vnd.xara"],
  ["xav", "application/xcap-att+xml"],
  ["xbap", "application/x-ms-xbap"],
  ["xbd", "application/vnd.fujixerox.docuworks.binder"],
  ["xbm", "image/x-xbitmap"],
  ["xca", "application/xcap-caps+xml"],
  ["xcs", "application/calendar+xml"],
  ["xdf", "application/xcap-diff+xml"],
  ["xdm", "application/vnd.syncml.dm+xml"],
  ["xdp", "application/vnd.adobe.xdp+xml"],
  ["xdssc", "application/dssc+xml"],
  ["xdw", "application/vnd.fujixerox.docuworks"],
  ["xel", "application/xcap-el+xml"],
  ["xenc", "application/xenc+xml"],
  ["xer", "application/patch-ops-error+xml"],
  ["xfdf", "application/vnd.adobe.xfdf"],
  ["xfdl", "application/vnd.xfdl"],
  ["xht", "application/xhtml+xml"],
  ["xhtml", "application/xhtml+xml"],
  ["xhvml", "application/xv+xml"],
  ["xif", "image/vnd.xiff"],
  ["xl", "application/excel"],
  ["xla", "application/vnd.ms-excel"],
  ["xlam", "application/vnd.ms-excel.addin.macroEnabled.12"],
  ["xlc", "application/vnd.ms-excel"],
  ["xlf", "application/xliff+xml"],
  ["xlm", "application/vnd.ms-excel"],
  ["xls", "application/vnd.ms-excel"],
  ["xlsb", "application/vnd.ms-excel.sheet.binary.macroEnabled.12"],
  ["xlsm", "application/vnd.ms-excel.sheet.macroEnabled.12"],
  ["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  ["xlt", "application/vnd.ms-excel"],
  ["xltm", "application/vnd.ms-excel.template.macroEnabled.12"],
  [
    "xltx",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.template"
  ],
  ["xlw", "application/vnd.ms-excel"],
  ["xm", "audio/xm"],
  ["xml", "application/xml"],
  ["xns", "application/xcap-ns+xml"],
  ["xo", "application/vnd.olpc-sugar"],
  ["xop", "application/xop+xml"],
  ["xpi", "application/x-xpinstall"],
  ["xpl", "application/xproc+xml"],
  ["xpm", "image/x-xpixmap"],
  ["xpr", "application/vnd.is-xpr"],
  ["xps", "application/vnd.ms-xpsdocument"],
  ["xpw", "application/vnd.intercon.formnet"],
  ["xpx", "application/vnd.intercon.formnet"],
  ["xsd", "application/xml"],
  ["xsl", "application/xml"],
  ["xslt", "application/xslt+xml"],
  ["xsm", "application/vnd.syncml+xml"],
  ["xspf", "application/xspf+xml"],
  ["xul", "application/vnd.mozilla.xul+xml"],
  ["xvm", "application/xv+xml"],
  ["xvml", "application/xv+xml"],
  ["xwd", "image/x-xwindowdump"],
  ["xyz", "chemical/x-xyz"],
  ["xz", "application/x-xz"],
  ["yaml", "text/yaml"],
  ["yang", "application/yang"],
  ["yin", "application/yin+xml"],
  ["yml", "text/yaml"],
  ["ymp", "text/x-suse-ymp"],
  ["z", "application/x-compress"],
  ["z1", "application/x-zmachine"],
  ["z2", "application/x-zmachine"],
  ["z3", "application/x-zmachine"],
  ["z4", "application/x-zmachine"],
  ["z5", "application/x-zmachine"],
  ["z6", "application/x-zmachine"],
  ["z7", "application/x-zmachine"],
  ["z8", "application/x-zmachine"],
  ["zaz", "application/vnd.zzazz.deck+xml"],
  ["zip", "application/zip"],
  ["zir", "application/vnd.zul"],
  ["zirz", "application/vnd.zul"],
  ["zmm", "application/vnd.handheld-entertainment+xml"],
  ["zsh", "text/x-scriptzsh"]
]);
function toFileWithPath(file, path, h) {
  const f = withMimeType(file);
  const { webkitRelativePath } = file;
  const p = typeof path === "string" ? path : typeof webkitRelativePath === "string" && webkitRelativePath.length > 0 ? webkitRelativePath : `./${file.name}`;
  if (typeof f.path !== "string") {
    setObjProp(f, "path", p);
  }
  if (h !== undefined) {
    Object.defineProperty(f, "handle", {
      value: h,
      writable: false,
      configurable: false,
      enumerable: true
    });
  }
  setObjProp(f, "relativePath", p);
  return f;
}
function withMimeType(file) {
  const { name } = file;
  const hasExtension = name && name.lastIndexOf(".") !== -1;
  if (hasExtension && !file.type) {
    const ext = name.split(".").pop().toLowerCase();
    const type = COMMON_MIME_TYPES.get(ext);
    if (type) {
      Object.defineProperty(file, "type", {
        value: type,
        writable: false,
        configurable: false,
        enumerable: true
      });
    }
  }
  return file;
}
function setObjProp(f, key, value) {
  Object.defineProperty(f, key, {
    value,
    writable: false,
    configurable: false,
    enumerable: true
  });
}

// ../../../node_modules/react-dropzone-esm/dist/esm/file-selector.mjs
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
var FILES_TO_IGNORE = [
  ".DS_Store",
  "Thumbs.db"
];
function fromEvent(evt) {
  return __async(this, null, function* () {
    if (isObject(evt) && isDataTransfer(evt.dataTransfer)) {
      return getDataTransferFiles(evt.dataTransfer, evt.type);
    } else if (isChangeEvt(evt)) {
      return getInputFiles(evt);
    } else if (Array.isArray(evt) && evt.every((item) => ("getFile" in item) && typeof item.getFile === "function")) {
      return getFsHandleFiles(evt);
    }
    return [];
  });
}
function isDataTransfer(value) {
  return isObject(value);
}
function isChangeEvt(value) {
  return isObject(value) && isObject(value.target);
}
function isObject(v) {
  return typeof v === "object" && v !== null;
}
function getInputFiles(evt) {
  return fromList(evt.target.files).map((file) => toFileWithPath(file));
}
function getFsHandleFiles(handles) {
  return __async(this, null, function* () {
    const files = yield Promise.all(handles.map((h) => h.getFile()));
    return files.map((file) => toFileWithPath(file));
  });
}
function getDataTransferFiles(dt, type) {
  return __async(this, null, function* () {
    if (dt.items) {
      const items = fromList(dt.items).filter((item) => item.kind === "file");
      if (type !== "drop") {
        return items;
      }
      const files = yield Promise.all(items.map(toFilePromises));
      return noIgnoredFiles(flatten(files));
    }
    return noIgnoredFiles(fromList(dt.files).map((file) => toFileWithPath(file)));
  });
}
function noIgnoredFiles(files) {
  return files.filter((file) => FILES_TO_IGNORE.indexOf(file.name) === -1);
}
function fromList(items) {
  if (items === null) {
    return [];
  }
  const files = [];
  for (let i = 0;i < items.length; i++) {
    const file = items[i];
    files.push(file);
  }
  return files;
}
function toFilePromises(item) {
  if (typeof item.webkitGetAsEntry !== "function") {
    return fromDataTransferItem(item);
  }
  const entry = item.webkitGetAsEntry();
  if (entry && entry.isDirectory) {
    return fromDirEntry(entry);
  }
  return fromDataTransferItem(item, entry);
}
function flatten(items) {
  return items.reduce((acc, files) => [
    ...acc,
    ...Array.isArray(files) ? flatten(files) : [files]
  ], []);
}
function fromDataTransferItem(item, entry) {
  var _a;
  if (typeof item.getAsFileSystemHandle === "function") {
    return item.getAsFileSystemHandle().then((h) => __async(this, null, function* () {
      const file2 = yield h.getFile();
      file2.handle = h;
      return toFileWithPath(file2);
    }));
  }
  const file = item.getAsFile();
  if (!file) {
    return Promise.reject(`${item} is not a File`);
  }
  const fwp = toFileWithPath(file, (_a = entry == null ? undefined : entry.fullPath) != null ? _a : undefined);
  return Promise.resolve(fwp);
}
function fromEntry(entry) {
  return __async(this, null, function* () {
    return entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry);
  });
}
function fromDirEntry(entry) {
  const reader = entry.createReader();
  return new Promise((resolve, reject) => {
    const entries = [];
    function readEntries() {
      reader.readEntries((batch) => __async(this, null, function* () {
        if (!batch.length) {
          try {
            const files = yield Promise.all(entries);
            resolve(files);
          } catch (err) {
            reject(err);
          }
        } else {
          const items = Promise.all(batch.map(fromEntry));
          entries.push(items);
          readEntries();
        }
      }), (err) => {
        reject(err);
      });
    }
    readEntries();
  });
}
function fromFileEntry(entry) {
  return __async(this, null, function* () {
    return new Promise((resolve, reject) => {
      entry.file((file) => {
        const fwp = toFileWithPath(file, entry.fullPath);
        resolve(fwp);
      }, (err) => {
        reject(err);
      });
    });
  });
}

// ../../../node_modules/react-dropzone-esm/dist/esm/attr-accept.mjs
function _accepts(file, acceptedFiles) {
  if (file && acceptedFiles) {
    const acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(",");
    if (acceptedFilesArray.length === 0) {
      return true;
    }
    const fileName = file.name || "";
    const mimeType = (file.type || "").toLowerCase();
    const baseMimeType = mimeType.replace(/\/.*$/, "");
    return acceptedFilesArray.some((type) => {
      const validType = type.trim().toLowerCase();
      if (validType.charAt(0) === ".") {
        return fileName.toLowerCase().endsWith(validType);
      } else if (validType.endsWith("/*")) {
        return baseMimeType === validType.replace(/\/.*$/, "");
      }
      return mimeType === validType;
    });
  }
  return true;
}

// ../../../node_modules/react-dropzone-esm/dist/esm/utils.mjs
var __defProp2 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp2 = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => (key in obj) ? __defProp2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp2.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var accepts = typeof _accepts === "function" ? _accepts : _accepts.default;
var FILE_INVALID_TYPE = "file-invalid-type";
var FILE_TOO_LARGE = "file-too-large";
var FILE_TOO_SMALL = "file-too-small";
var TOO_MANY_FILES = "too-many-files";
var getInvalidTypeRejectionErr = (accept = "") => {
  const acceptArr = accept.split(",");
  const msg = acceptArr.length > 1 ? `one of ${acceptArr.join(", ")}` : acceptArr[0];
  return {
    code: FILE_INVALID_TYPE,
    message: `File type must be ${msg}`
  };
};
var getTooLargeRejectionErr = (maxSize) => {
  return {
    code: FILE_TOO_LARGE,
    message: `File is larger than ${maxSize} ${maxSize === 1 ? "byte" : "bytes"}`
  };
};
var getTooSmallRejectionErr = (minSize) => {
  return {
    code: FILE_TOO_SMALL,
    message: `File is smaller than ${minSize} ${minSize === 1 ? "byte" : "bytes"}`
  };
};
var TOO_MANY_FILES_REJECTION = {
  code: TOO_MANY_FILES,
  message: "Too many files"
};
function fileAccepted(file, accept) {
  const isAcceptable = file.type === "application/x-moz-file" || accepts(file, accept);
  return [
    isAcceptable,
    isAcceptable ? null : getInvalidTypeRejectionErr(accept)
  ];
}
function fileMatchSize(file, minSize, maxSize) {
  if (isDefined(file.size)) {
    if (isDefined(minSize) && isDefined(maxSize)) {
      if (file.size > maxSize)
        return [false, getTooLargeRejectionErr(maxSize)];
      if (file.size < minSize)
        return [false, getTooSmallRejectionErr(minSize)];
    } else if (isDefined(minSize) && file.size < minSize)
      return [false, getTooSmallRejectionErr(minSize)];
    else if (isDefined(maxSize) && file.size > maxSize)
      return [false, getTooLargeRejectionErr(maxSize)];
  }
  return [true, null];
}
function isDefined(value) {
  return value !== undefined && value !== null;
}
function allFilesAccepted({
  files,
  accept,
  minSize,
  maxSize,
  multiple,
  maxFiles,
  validator
}) {
  if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) {
    return false;
  }
  return files.every((file) => {
    const [accepted] = fileAccepted(file, accept);
    const [sizeMatch] = fileMatchSize(file, minSize, maxSize);
    const customErrors = validator ? validator(file) : null;
    return accepted && sizeMatch && !customErrors;
  });
}
function isPropagationStopped(event) {
  if (typeof event.isPropagationStopped === "function") {
    return event.isPropagationStopped();
  } else if (typeof event.cancelBubble !== "undefined") {
    return event.cancelBubble;
  }
  return false;
}
function isEvtWithFiles(event) {
  if (!event.dataTransfer) {
    return !!event.target && !!event.target.files;
  }
  return Array.prototype.some.call(event.dataTransfer.types, (type) => type === "Files" || type === "application/x-moz-file");
}
function onDocumentDragOver(event) {
  event.preventDefault();
}
function isIe(userAgent) {
  return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}
function isEdge(userAgent) {
  return userAgent.indexOf("Edge/") !== -1;
}
function isIeOrEdge(userAgent = window.navigator.userAgent) {
  return isIe(userAgent) || isEdge(userAgent);
}
function composeEventHandlers(...fns) {
  return (event, ...args) => fns.some((fn) => {
    if (!isPropagationStopped(event) && fn) {
      fn(event, ...args);
    }
    return isPropagationStopped(event);
  });
}
function canUseFileSystemAccessAPI() {
  return "showOpenFilePicker" in window;
}
function pickerOptionsFromAccept(accept) {
  if (isDefined(accept)) {
    const acceptForPicker = Object.entries(accept).filter(([mimeType, ext]) => {
      let ok = true;
      if (!isMIMEType(mimeType)) {
        console.warn(`Skipped "${mimeType}" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.`);
        ok = false;
      }
      if (!Array.isArray(ext) || !ext.every(isExt)) {
        console.warn(`Skipped "${mimeType}" because an invalid file extension was provided.`);
        ok = false;
      }
      return ok;
    }).reduce((agg, [mimeType, ext]) => __spreadProps(__spreadValues({}, agg), {
      [mimeType]: ext
    }), {});
    return [
      {
        description: "Files",
        accept: acceptForPicker
      }
    ];
  }
  return accept;
}
function acceptPropAsAcceptAttr(accept) {
  if (isDefined(accept)) {
    return Object.entries(accept).reduce((a, [mimeType, ext]) => [...a, mimeType, ...ext], []).filter((v) => isMIMEType(v) || isExt(v)).join(",");
  }
  return;
}
function isAbort(v) {
  return v instanceof DOMException && (v.name === "AbortError" || v.code === v.ABORT_ERR);
}
function isSecurityError(v) {
  return v instanceof DOMException && (v.name === "SecurityError" || v.code === v.SECURITY_ERR);
}
function isMIMEType(v) {
  return v === "audio/*" || v === "video/*" || v === "image/*" || v === "text/*" || v === "application/*" || /\w+\/[-+.\w]+/g.test(v);
}
function isExt(v) {
  return /^.*\.[\w]+$/.test(v);
}

// ../../../node_modules/react-dropzone-esm/dist/esm/index.mjs
"use client";
var __defProp3 = Object.defineProperty;
var __defProps2 = Object.defineProperties;
var __getOwnPropDescs2 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols2 = Object.getOwnPropertySymbols;
var __hasOwnProp3 = Object.prototype.hasOwnProperty;
var __propIsEnum2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp2 = (obj, key, value) => (key in obj) ? __defProp3(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues2 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp3.call(b, prop))
      __defNormalProp2(a, prop, b[prop]);
  if (__getOwnPropSymbols2)
    for (var prop of __getOwnPropSymbols2(b)) {
      if (__propIsEnum2.call(b, prop))
        __defNormalProp2(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps2 = (a, b) => __defProps2(a, __getOwnPropDescs2(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp3.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols2)
    for (var prop of __getOwnPropSymbols2(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum2.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var Dropzone = forwardRef((_a, ref) => {
  var _b = _a, { children } = _b, params = __objRest(_b, ["children"]);
  const _a2 = useDropzone(params), { open } = _a2, props = __objRest(_a2, ["open"]);
  useImperativeHandle(ref, () => ({ open }), [open]);
  return /* @__PURE__ */ React497.createElement(Fragment, null, children(__spreadProps2(__spreadValues2({}, props), { open })));
});
Dropzone.displayName = "Dropzone";
var defaultProps = {
  disabled: false,
  getFilesFromEvent: fromEvent,
  maxSize: Infinity,
  minSize: 0,
  multiple: true,
  maxFiles: 0,
  preventDropOnDocument: true,
  noClick: false,
  noKeyboard: false,
  noDrag: false,
  noDragEventsBubbling: false,
  validator: null,
  useFsAccessApi: false,
  autoFocus: false
};
Dropzone.defaultProps = defaultProps;
Dropzone.propTypes = {
  children: import_prop_types.default.func,
  accept: import_prop_types.default.objectOf(import_prop_types.default.arrayOf(import_prop_types.default.string)),
  multiple: import_prop_types.default.bool,
  preventDropOnDocument: import_prop_types.default.bool,
  noClick: import_prop_types.default.bool,
  noKeyboard: import_prop_types.default.bool,
  noDrag: import_prop_types.default.bool,
  noDragEventsBubbling: import_prop_types.default.bool,
  minSize: import_prop_types.default.number,
  maxSize: import_prop_types.default.number,
  maxFiles: import_prop_types.default.number,
  disabled: import_prop_types.default.bool,
  getFilesFromEvent: import_prop_types.default.func,
  onFileDialogCancel: import_prop_types.default.func,
  onFileDialogOpen: import_prop_types.default.func,
  useFsAccessApi: import_prop_types.default.bool,
  autoFocus: import_prop_types.default.bool,
  onDragEnter: import_prop_types.default.func,
  onDragLeave: import_prop_types.default.func,
  onDragOver: import_prop_types.default.func,
  onDrop: import_prop_types.default.func,
  onDropAccepted: import_prop_types.default.func,
  onDropRejected: import_prop_types.default.func,
  onError: import_prop_types.default.func,
  validator: import_prop_types.default.func
};
var initialState = {
  isFocused: false,
  isFileDialogActive: false,
  isDragActive: false,
  isDragAccept: false,
  isDragReject: false,
  acceptedFiles: [],
  fileRejections: []
};
function useDropzone(props = {}) {
  const {
    accept,
    disabled,
    getFilesFromEvent,
    maxSize,
    minSize,
    multiple,
    maxFiles,
    onDragEnter,
    onDragLeave,
    onDragOver,
    onDrop,
    onDropAccepted,
    onDropRejected,
    onFileDialogCancel,
    onFileDialogOpen,
    useFsAccessApi,
    autoFocus,
    preventDropOnDocument,
    noClick,
    noKeyboard,
    noDrag,
    noDragEventsBubbling,
    onError,
    validator
  } = __spreadValues2(__spreadValues2({}, defaultProps), props);
  const acceptAttr = useMemo2(() => acceptPropAsAcceptAttr(accept), [accept]);
  const pickerTypes = useMemo2(() => pickerOptionsFromAccept(accept), [accept]);
  const onFileDialogOpenCb = useMemo2(() => typeof onFileDialogOpen === "function" ? onFileDialogOpen : noop, [onFileDialogOpen]);
  const onFileDialogCancelCb = useMemo2(() => typeof onFileDialogCancel === "function" ? onFileDialogCancel : noop, [onFileDialogCancel]);
  const rootRef = useRef7(null);
  const inputRef = useRef7(null);
  const [state, dispatch] = useReducer(reducer, initialState);
  const { isFocused, isFileDialogActive } = state;
  const fsAccessApiWorksRef = useRef7(typeof window !== "undefined" && window.isSecureContext && useFsAccessApi && canUseFileSystemAccessAPI());
  const onWindowFocus = () => {
    if (!fsAccessApiWorksRef.current && isFileDialogActive) {
      setTimeout(() => {
        if (inputRef.current) {
          const { files } = inputRef.current;
          if (!files.length) {
            dispatch({ type: "closeDialog" });
            onFileDialogCancelCb();
          }
        }
      }, 300);
    }
  };
  useEffect6(() => {
    window.addEventListener("focus", onWindowFocus, false);
    return () => {
      window.removeEventListener("focus", onWindowFocus, false);
    };
  }, [inputRef, isFileDialogActive, onFileDialogCancelCb, fsAccessApiWorksRef]);
  const dragTargetsRef = useRef7([]);
  const onDocumentDrop = (event) => {
    if (rootRef.current && rootRef.current.contains(event.target)) {
      return;
    }
    event.preventDefault();
    dragTargetsRef.current = [];
  };
  useEffect6(() => {
    if (preventDropOnDocument) {
      document.addEventListener("dragover", onDocumentDragOver, false);
      document.addEventListener("drop", onDocumentDrop, false);
    }
    return () => {
      if (preventDropOnDocument) {
        document.removeEventListener("dragover", onDocumentDragOver);
        document.removeEventListener("drop", onDocumentDrop);
      }
    };
  }, [rootRef, preventDropOnDocument]);
  useEffect6(() => {
    if (!disabled && autoFocus && rootRef.current) {
      rootRef.current.focus();
    }
    return () => {
    };
  }, [rootRef, autoFocus, disabled]);
  const onErrCb = useCallback8((e) => {
    if (onError) {
      onError(e);
    } else {
      console.error(e);
    }
  }, [onError]);
  const onDragEnterCb = useCallback8((event) => {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [...dragTargetsRef.current, event.target];
    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then((files) => {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }
        const fileCount = files.length;
        const isDragAccept = fileCount > 0 && allFilesAccepted({
          files,
          accept: acceptAttr,
          minSize,
          maxSize,
          multiple,
          maxFiles,
          validator
        });
        const isDragReject = fileCount > 0 && !isDragAccept;
        dispatch({
          isDragAccept,
          isDragReject,
          isDragActive: true,
          type: "setDraggedFiles"
        });
        if (onDragEnter) {
          onDragEnter(event);
        }
      }).catch((e) => onErrCb(e));
    }
  }, [
    getFilesFromEvent,
    onDragEnter,
    onErrCb,
    noDragEventsBubbling,
    acceptAttr,
    minSize,
    maxSize,
    multiple,
    maxFiles,
    validator
  ]);
  const onDragOverCb = useCallback8((event) => {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    const hasFiles = isEvtWithFiles(event);
    if (hasFiles && event.dataTransfer) {
      try {
        event.dataTransfer.dropEffect = "copy";
      } catch (e) {
      }
    }
    if (hasFiles && onDragOver) {
      onDragOver(event);
    }
    return false;
  }, [onDragOver, noDragEventsBubbling]);
  const onDragLeaveCb = useCallback8((event) => {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    const targets = dragTargetsRef.current.filter((target) => rootRef.current && rootRef.current.contains(target));
    const targetIdx = targets.indexOf(event.target);
    if (targetIdx !== -1) {
      targets.splice(targetIdx, 1);
    }
    dragTargetsRef.current = targets;
    if (targets.length > 0) {
      return;
    }
    dispatch({
      type: "setDraggedFiles",
      isDragActive: false,
      isDragAccept: false,
      isDragReject: false
    });
    if (isEvtWithFiles(event) && onDragLeave) {
      onDragLeave(event);
    }
  }, [rootRef, onDragLeave, noDragEventsBubbling]);
  const setFiles = useCallback8((files, event) => {
    const acceptedFiles = [];
    const fileRejections = [];
    files.forEach((file) => {
      const [accepted, acceptError] = fileAccepted(file, acceptAttr);
      const [sizeMatch, sizeError] = fileMatchSize(file, minSize, maxSize);
      const customErrors = validator ? validator(file) : null;
      if (accepted && sizeMatch && !customErrors) {
        acceptedFiles.push(file);
      } else {
        let errors = [acceptError, sizeError];
        if (customErrors) {
          errors = errors.concat(customErrors);
        }
        fileRejections.push({ file, errors: errors.filter((e) => e) });
      }
    });
    if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
      acceptedFiles.forEach((file) => {
        fileRejections.push({ file, errors: [TOO_MANY_FILES_REJECTION] });
      });
      acceptedFiles.splice(0);
    }
    dispatch({
      acceptedFiles,
      fileRejections,
      isDragReject: fileRejections.length > 0,
      type: "setFiles"
    });
    if (onDrop) {
      onDrop(acceptedFiles, fileRejections, event);
    }
    if (fileRejections.length > 0 && onDropRejected) {
      onDropRejected(fileRejections, event);
    }
    if (acceptedFiles.length > 0 && onDropAccepted) {
      onDropAccepted(acceptedFiles, event);
    }
  }, [
    dispatch,
    multiple,
    acceptAttr,
    minSize,
    maxSize,
    maxFiles,
    onDrop,
    onDropAccepted,
    onDropRejected,
    validator
  ]);
  const onDropCb = useCallback8((event) => {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [];
    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then((files) => {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }
        setFiles(files, event);
      }).catch((e) => onErrCb(e));
    }
    dispatch({ type: "reset" });
  }, [getFilesFromEvent, setFiles, onErrCb, noDragEventsBubbling]);
  const openFileDialog = useCallback8(() => {
    if (fsAccessApiWorksRef.current) {
      dispatch({ type: "openDialog" });
      onFileDialogOpenCb();
      const opts = {
        multiple,
        types: pickerTypes
      };
      window.showOpenFilePicker(opts).then((handles) => getFilesFromEvent(handles)).then((files) => {
        setFiles(files, null);
        dispatch({ type: "closeDialog" });
      }).catch((e) => {
        if (isAbort(e)) {
          onFileDialogCancelCb(e);
          dispatch({ type: "closeDialog" });
        } else if (isSecurityError(e)) {
          fsAccessApiWorksRef.current = false;
          if (inputRef.current) {
            inputRef.current.value = null;
            inputRef.current.click();
          } else {
            onErrCb(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."));
          }
        } else {
          onErrCb(e);
        }
      });
      return;
    }
    if (inputRef.current) {
      dispatch({ type: "openDialog" });
      onFileDialogOpenCb();
      inputRef.current.value = null;
      inputRef.current.click();
    }
  }, [
    dispatch,
    onFileDialogOpenCb,
    onFileDialogCancelCb,
    useFsAccessApi,
    setFiles,
    onErrCb,
    pickerTypes,
    multiple
  ]);
  const onKeyDownCb = useCallback8((event) => {
    if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) {
      return;
    }
    if (event.key === " " || event.key === "Enter" || event.keyCode === 32 || event.keyCode === 13) {
      event.preventDefault();
      openFileDialog();
    }
  }, [rootRef, openFileDialog]);
  const onFocusCb = useCallback8(() => {
    dispatch({ type: "focus" });
  }, []);
  const onBlurCb = useCallback8(() => {
    dispatch({ type: "blur" });
  }, []);
  const onClickCb = useCallback8(() => {
    if (noClick) {
      return;
    }
    if (isIeOrEdge()) {
      setTimeout(openFileDialog, 0);
    } else {
      openFileDialog();
    }
  }, [noClick, openFileDialog]);
  const composeHandler = (fn) => {
    return disabled ? null : fn;
  };
  const composeKeyboardHandler = (fn) => {
    return noKeyboard ? null : composeHandler(fn);
  };
  const composeDragHandler = (fn) => {
    return noDrag ? null : composeHandler(fn);
  };
  const stopPropagation = (event) => {
    if (noDragEventsBubbling) {
      event.stopPropagation();
    }
  };
  const getRootProps = useMemo2(() => (_a = {}) => {
    var _b = _a, {
      refKey = "ref",
      role,
      onKeyDown,
      onFocus,
      onBlur,
      onClick,
      onDragEnter: onDragEnter2,
      onDragOver: onDragOver2,
      onDragLeave: onDragLeave2,
      onDrop: onDrop2
    } = _b, rest = __objRest(_b, [
      "refKey",
      "role",
      "onKeyDown",
      "onFocus",
      "onBlur",
      "onClick",
      "onDragEnter",
      "onDragOver",
      "onDragLeave",
      "onDrop"
    ]);
    return __spreadValues2(__spreadValues2({
      onKeyDown: composeKeyboardHandler(composeEventHandlers(onKeyDown, onKeyDownCb)),
      onFocus: composeKeyboardHandler(composeEventHandlers(onFocus, onFocusCb)),
      onBlur: composeKeyboardHandler(composeEventHandlers(onBlur, onBlurCb)),
      onClick: composeHandler(composeEventHandlers(onClick, onClickCb)),
      onDragEnter: composeDragHandler(composeEventHandlers(onDragEnter2, onDragEnterCb)),
      onDragOver: composeDragHandler(composeEventHandlers(onDragOver2, onDragOverCb)),
      onDragLeave: composeDragHandler(composeEventHandlers(onDragLeave2, onDragLeaveCb)),
      onDrop: composeDragHandler(composeEventHandlers(onDrop2, onDropCb)),
      role: typeof role === "string" && role !== "" ? role : "presentation",
      [refKey]: rootRef
    }, !disabled && !noKeyboard ? { tabIndex: 0 } : {}), rest);
  }, [
    rootRef,
    onKeyDownCb,
    onFocusCb,
    onBlurCb,
    onClickCb,
    onDragEnterCb,
    onDragOverCb,
    onDragLeaveCb,
    onDropCb,
    noKeyboard,
    noDrag,
    disabled
  ]);
  const onInputElementClick = useCallback8((event) => {
    event.stopPropagation();
  }, []);
  const getInputProps = useMemo2(() => (_a = {}) => {
    var _b = _a, { refKey = "ref", onChange, onClick } = _b, rest = __objRest(_b, ["refKey", "onChange", "onClick"]);
    const inputProps = {
      accept: acceptAttr,
      multiple,
      type: "file",
      style: {
        border: 0,
        clip: "rect(0, 0, 0, 0)",
        clipPath: "inset(50%)",
        height: "1px",
        margin: "0 -1px -1px 0",
        overflow: "hidden",
        padding: 0,
        position: "absolute",
        width: "1px",
        whiteSpace: "nowrap"
      },
      onChange: composeHandler(composeEventHandlers(onChange, onDropCb)),
      onClick: composeHandler(composeEventHandlers(onClick, onInputElementClick)),
      tabIndex: -1,
      [refKey]: inputRef
    };
    return __spreadValues2(__spreadValues2({}, inputProps), rest);
  }, [inputRef, accept, multiple, onDropCb, disabled]);
  return __spreadProps2(__spreadValues2({}, state), {
    isFocused: isFocused && !disabled,
    getRootProps,
    getInputProps,
    rootRef,
    inputRef,
    open: composeHandler(openFileDialog)
  });
}
function reducer(state, action) {
  switch (action.type) {
    case "focus":
      return __spreadProps2(__spreadValues2({}, state), {
        isFocused: true
      });
    case "blur":
      return __spreadProps2(__spreadValues2({}, state), {
        isFocused: false
      });
    case "openDialog":
      return __spreadProps2(__spreadValues2({}, initialState), {
        isFileDialogActive: true
      });
    case "closeDialog":
      return __spreadProps2(__spreadValues2({}, state), {
        isFileDialogActive: false
      });
    case "setDraggedFiles":
      return __spreadProps2(__spreadValues2({}, state), {
        isDragActive: action.isDragActive,
        isDragAccept: action.isDragAccept,
        isDragReject: action.isDragReject
      });
    case "setFiles":
      return __spreadProps2(__spreadValues2({}, state), {
        acceptedFiles: action.acceptedFiles,
        fileRejections: action.fileRejections,
        isDragReject: action.isDragReject
      });
    case "reset":
      return __spreadValues2({}, initialState);
    default:
      return state;
  }
}
function noop() {
}

// ../../../node_modules/@mantine/dropzone/esm/Dropzone.mjs
import { createVarsResolver, getRadius, factory, useProps as useProps2, useStyles, Box, LoadingOverlay } from "@mantine/core";
import { assignRef } from "@mantine/hooks";

// ../../../node_modules/@mantine/dropzone/esm/Dropzone.context.mjs
import { createSafeContext } from "@mantine/core";
"use client";
var [DropzoneProvider, useDropzoneContext] = createSafeContext("Dropzone component was not found in tree");

// ../../../node_modules/@mantine/dropzone/esm/DropzoneStatus.mjs
import { jsx as jsx590 } from "react/jsx-runtime";
import { cloneElement } from "react";
import { useProps, isElement } from "@mantine/core";
import { upperFirst } from "@mantine/hooks";
"use client";
function createDropzoneStatus(status) {
  const Component = (props) => {
    const { children, ...others } = useProps(`Dropzone${upperFirst(status)}`, {}, props);
    const ctx = useDropzoneContext();
    const _children = isElement(children) ? children : /* @__PURE__ */ jsx590("span", { children });
    if (ctx[status]) {
      return cloneElement(_children, others);
    }
    return null;
  };
  Component.displayName = `@mantine/dropzone/${upperFirst(status)}`;
  return Component;
}
var DropzoneAccept = createDropzoneStatus("accept");
var DropzoneReject = createDropzoneStatus("reject");
var DropzoneIdle = createDropzoneStatus("idle");

// ../../../node_modules/@mantine/dropzone/esm/Dropzone.module.css.mjs
"use client";
var classes = { root: "m_d46a4834", inner: "m_b85f7144", fullScreen: "m_96f6e9ad", dropzone: "m_7946116d" };

// ../../../node_modules/@mantine/dropzone/esm/Dropzone.mjs
"use client";
var defaultProps2 = {
  loading: false,
  multiple: true,
  maxSize: Infinity,
  autoFocus: false,
  activateOnClick: true,
  activateOnDrag: true,
  dragEventsBubbling: true,
  activateOnKeyboard: true,
  useFsAccessApi: true,
  variant: "light",
  rejectColor: "red"
};
var varsResolver = createVarsResolver((theme2, { radius, variant, acceptColor, rejectColor }) => {
  const acceptColors = theme2.variantColorResolver({
    color: acceptColor || theme2.primaryColor,
    theme: theme2,
    variant
  });
  const rejectColors = theme2.variantColorResolver({
    color: rejectColor || "red",
    theme: theme2,
    variant
  });
  return {
    root: {
      "--dropzone-radius": getRadius(radius),
      "--dropzone-accept-color": acceptColors.color,
      "--dropzone-accept-bg": acceptColors.background,
      "--dropzone-reject-color": rejectColors.color,
      "--dropzone-reject-bg": rejectColors.background
    }
  };
});
var Dropzone2 = factory((_props, ref) => {
  const props = useProps2("Dropzone", defaultProps2, _props);
  const {
    classNames,
    className,
    style,
    styles,
    unstyled,
    vars,
    radius,
    disabled,
    loading,
    multiple,
    maxSize,
    accept,
    children,
    onDropAny,
    onDrop,
    onReject,
    openRef,
    name,
    maxFiles,
    autoFocus,
    activateOnClick,
    activateOnDrag,
    dragEventsBubbling,
    activateOnKeyboard,
    onDragEnter,
    onDragLeave,
    onDragOver,
    onFileDialogCancel,
    onFileDialogOpen,
    preventDropOnDocument,
    useFsAccessApi,
    getFilesFromEvent,
    validator,
    rejectColor,
    acceptColor,
    enablePointerEvents,
    loaderProps,
    inputProps,
    mod,
    ...others
  } = props;
  const getStyles = useStyles({
    name: "Dropzone",
    classes,
    props,
    className,
    style,
    classNames,
    styles,
    unstyled,
    vars,
    varsResolver
  });
  const { getRootProps, getInputProps, isDragAccept, isDragReject, open } = useDropzone({
    onDrop: onDropAny,
    onDropAccepted: onDrop,
    onDropRejected: onReject,
    disabled: disabled || loading,
    accept: Array.isArray(accept) ? accept.reduce((r, key) => ({ ...r, [key]: [] }), {}) : accept,
    multiple,
    maxSize,
    maxFiles,
    autoFocus,
    noClick: !activateOnClick,
    noDrag: !activateOnDrag,
    noDragEventsBubbling: !dragEventsBubbling,
    noKeyboard: !activateOnKeyboard,
    onDragEnter,
    onDragLeave,
    onDragOver,
    onFileDialogCancel,
    onFileDialogOpen,
    preventDropOnDocument,
    useFsAccessApi,
    validator,
    ...getFilesFromEvent ? { getFilesFromEvent } : null
  });
  assignRef(openRef, open);
  const isIdle = !isDragAccept && !isDragReject;
  return /* @__PURE__ */ jsx591(DropzoneProvider, { value: { accept: isDragAccept, reject: isDragReject, idle: isIdle }, children: /* @__PURE__ */ jsxs9(Box, {
    ...getRootProps(),
    ...getStyles("root", { focusable: true }),
    ...others,
    mod: [
      {
        accept: isDragAccept,
        reject: isDragReject,
        idle: isIdle,
        disabled,
        loading,
        "activate-on-click": activateOnClick
      },
      mod
    ],
    children: [
      /* @__PURE__ */ jsx591(LoadingOverlay, {
        visible: loading,
        overlayProps: { radius },
        unstyled,
        loaderProps
      }),
      /* @__PURE__ */ jsx591("input", { ...getInputProps(inputProps), name }),
      /* @__PURE__ */ jsx591("div", {
        ...getStyles("inner"),
        ref,
        "data-enable-pointer-events": enablePointerEvents || undefined,
        children
      })
    ]
  }) });
});
Dropzone2.classes = classes;
Dropzone2.displayName = "@mantine/dropzone/Dropzone";
Dropzone2.Accept = DropzoneAccept;
Dropzone2.Idle = DropzoneIdle;
Dropzone2.Reject = DropzoneReject;

// ../../../node_modules/@mantine/dropzone/esm/DropzoneFullScreen.mjs
import { jsx as jsx592 } from "react/jsx-runtime";
import { useState as useState7, useEffect as useEffect7 } from "react";
import { getDefaultZIndex, factory as factory2, useProps as useProps3, useStyles as useStyles2, useResolvedStylesApi, OptionalPortal, Box as Box2 } from "@mantine/core";
import { useDisclosure as useDisclosure2 } from "@mantine/hooks";
"use client";
var defaultProps3 = {
  loading: false,
  maxSize: Infinity,
  activateOnClick: false,
  activateOnDrag: true,
  dragEventsBubbling: true,
  activateOnKeyboard: true,
  active: true,
  zIndex: getDefaultZIndex("max"),
  withinPortal: true
};
var DropzoneFullScreen = factory2((_props, ref) => {
  const props = useProps3("DropzoneFullScreen", defaultProps3, _props);
  const {
    classNames,
    className,
    style,
    styles,
    unstyled,
    vars,
    active,
    onDrop,
    onReject,
    zIndex,
    withinPortal,
    portalProps,
    ...others
  } = props;
  const getStyles = useStyles2({
    name: "DropzoneFullScreen",
    classes,
    props,
    className,
    style,
    classNames,
    styles,
    unstyled,
    rootSelector: "fullScreen"
  });
  const { resolvedClassNames, resolvedStyles } = useResolvedStylesApi({
    classNames,
    styles,
    props
  });
  const [counter, setCounter] = useState7(0);
  const [visible, { open, close }] = useDisclosure2(false);
  const handleDragEnter = (event) => {
    if (event.dataTransfer?.types.includes("Files")) {
      setCounter((prev) => prev + 1);
      open();
    }
  };
  const handleDragLeave = () => {
    setCounter((prev) => prev - 1);
  };
  useEffect7(() => {
    counter === 0 && close();
  }, [counter]);
  useEffect7(() => {
    if (!active) {
      return;
    }
    document.addEventListener("dragenter", handleDragEnter, false);
    document.addEventListener("dragleave", handleDragLeave, false);
    return () => {
      document.removeEventListener("dragenter", handleDragEnter, false);
      document.removeEventListener("dragleave", handleDragLeave, false);
    };
  }, [active]);
  return /* @__PURE__ */ jsx592(OptionalPortal, { ...portalProps, withinPortal, children: /* @__PURE__ */ jsx592(Box2, {
    ...getStyles("fullScreen", {
      style: { opacity: visible ? 1 : 0, pointerEvents: visible ? "all" : "none", zIndex }
    }),
    ref,
    children: /* @__PURE__ */ jsx592(Dropzone2, {
      ...others,
      classNames: resolvedClassNames,
      styles: resolvedStyles,
      unstyled,
      className: classes.dropzone,
      onDrop: (files) => {
        onDrop?.(files);
        close();
        setCounter(0);
      },
      onReject: (files) => {
        onReject?.(files);
        close();
        setCounter(0);
      }
    })
  }) });
});
DropzoneFullScreen.classes = classes;
DropzoneFullScreen.displayName = "@mantine/dropzone/DropzoneFullScreen";

// ../../../node_modules/@mantine/dropzone/esm/mime-types.mjs
"use client";
var MIME_TYPES = {
  png: "image/png",
  gif: "image/gif",
  jpeg: "image/jpeg",
  svg: "image/svg+xml",
  webp: "image/webp",
  avif: "image/avif",
  heic: "image/heic",
  heif: "image/heif",
  mp4: "video/mp4",
  zip: "application/zip",
  rar: "application/x-rar",
  "7z": "application/x-7z-compressed",
  csv: "text/csv",
  pdf: "application/pdf",
  doc: "application/msword",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  xls: "application/vnd.ms-excel",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ppt: "application/vnd.ms-powerpoint",
  pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  exe: "application/vnd.microsoft.portable-executable"
};
var IMAGE_MIME_TYPE = [
  MIME_TYPES.png,
  MIME_TYPES.gif,
  MIME_TYPES.jpeg,
  MIME_TYPES.svg,
  MIME_TYPES.webp,
  MIME_TYPES.avif,
  MIME_TYPES.heic,
  MIME_TYPES.heif
];
var PDF_MIME_TYPE = [MIME_TYPES.pdf];
var MS_WORD_MIME_TYPE = [MIME_TYPES.doc, MIME_TYPES.docx];
var MS_EXCEL_MIME_TYPE = [MIME_TYPES.xls, MIME_TYPES.xlsx];
var MS_POWERPOINT_MIME_TYPE = [MIME_TYPES.ppt, MIME_TYPES.pptx];
var EXE_MIME_TYPE = [MIME_TYPES.exe];

// ../../../node_modules/@mantine/dropzone/esm/index.mjs
Dropzone2.FullScreen = DropzoneFullScreen;
var Dropzone3 = Dropzone2;
// src/components/card/internal/CardContents.tsx
import { jsx as jsx593, jsxs as jsxs10 } from "react/jsx-runtime";
var CardContents = ({
  header = null,
  footer = null,
  Icon: Icon2,
  iconColor = "primary",
  iconBackground,
  children
}) => {
  const contents = [header, children, footer].reduce((acc, section) => {
    if (!section) {
      return acc;
    }
    return /* @__PURE__ */ jsxs10(Fragment2, {
      children: [
        acc,
        /* @__PURE__ */ jsx593(Box3, {
          children: section
        })
      ]
    });
  }, /* @__PURE__ */ jsx593(Fragment2, {}));
  if (Icon2) {
    return /* @__PURE__ */ jsxs10(Flex, {
      gap: "xxs",
      children: [
        /* @__PURE__ */ jsx593(Box3, {
          children: iconBackground ? /* @__PURE__ */ jsx593(Avatar, {
            color: iconBackground,
            AvatarIcon: () => /* @__PURE__ */ jsx593(Icon2, {
              color: iconColor
            })
          }) : /* @__PURE__ */ jsx593(Icon2, {
            color: iconColor
          })
        }),
        /* @__PURE__ */ jsx593(Stack, {
          gap: "sm",
          flex: 1,
          children: contents
        })
      ]
    });
  }
  return /* @__PURE__ */ jsx593(Stack, {
    gap: "sm",
    flex: 1,
    children: contents
  });
};

// src/components/card/BaseCard.tsx
import { jsx as jsx594 } from "react/jsx-runtime";
var BaseCard = ({
  children,
  header,
  footer,
  Icon: Icon2,
  iconColor,
  iconBackground,
  onClick,
  role,
  style = {},
  "data-testid": testId,
  ...restProps
}) => {
  const cursor = onClick ? "pointer" : "default";
  return /* @__PURE__ */ jsx594(MantineCard, {
    ...restProps,
    flex: 1,
    style: {
      ...style,
      container: "card / inline-size",
      cursor
    },
    "data-testid": testId,
    onClick,
    role,
    children: /* @__PURE__ */ jsx594(CardContents, {
      header,
      footer,
      Icon: Icon2,
      iconColor,
      iconBackground,
      children
    })
  });
};
// src/components/card/internal/CardHeader.tsx
import { jsx as jsx595 } from "react/jsx-runtime";
var CardHeader = ({ children, color }) => /* @__PURE__ */ jsx595(Box3, {
  style: { color: color ?? "var(--mantine-color-gray-9)" },
  fz: "lg",
  fw: "600",
  children
});

// src/components/card/BareCard.tsx
import { jsx as jsx596 } from "react/jsx-runtime";
var BareCard = ({
  children,
  footer,
  header,
  Icon: Icon2,
  iconColor
}) => {
  const Header = header ? /* @__PURE__ */ jsx596(CardHeader, {
    children: header
  }) : null;
  return /* @__PURE__ */ jsx596(BaseCard, {
    footer,
    header: Header,
    Icon: Icon2,
    iconColor,
    padding: 0,
    radius: 0,
    style: {
      backgroundColor: "transparent"
    },
    children
  });
};
// src/components/card/ElevatedCard.tsx
import { jsx as jsx597 } from "react/jsx-runtime";
var ElevatedCard = ({
  children,
  footer,
  header,
  Icon: Icon2,
  iconColor,
  onClick,
  "data-testid": testId,
  role,
  sharp = false
}) => {
  const Header = header ? /* @__PURE__ */ jsx597(CardHeader, {
    children: header
  }) : null;
  return /* @__PURE__ */ jsx597(BaseCard, {
    onClick,
    footer,
    header: Header,
    Icon: Icon2,
    iconColor,
    shadow: "xs",
    variant: "filled",
    padding: "sm",
    radius: sharp ? "0" : "sm",
    "data-testid": testId,
    role,
    children
  });
};
// src/components/card/FilledCard.tsx
import { jsx as jsx598 } from "react/jsx-runtime";
var InnerFilledCard = ({
  children,
  footer,
  header,
  Icon: Icon2,
  color = "primary",
  withBorder = false,
  onClick,
  role,
  "data-testid": testId,
  withOutline = false,
  sharp = false
}) => {
  const Header = header ? /* @__PURE__ */ jsx598(CardHeader, {
    children: header
  }) : null;
  return /* @__PURE__ */ jsx598(BaseCard, {
    onClick,
    role,
    withBorder,
    bg: `var(--mantine-color-${color}-0)`,
    footer,
    header: Header,
    Icon: Icon2,
    iconColor: color,
    variant: "filled",
    padding: "sm",
    radius: sharp ? "0" : "sm",
    style: {
      borderColor: "var(--card-border-color)",
      outline: "var(--card-outline-size) solid var(--card-border-color)"
    },
    __vars: {
      "--card-border-color": `var(--mantine-color-${color}-7)`,
      "--card-outline-size": withOutline ? rem("1px") : "0"
    },
    "data-testid": testId,
    children
  });
};
var FilledCard = ({
  children,
  footer,
  header,
  Icon: Icon2,
  color = "primary",
  withBorder = false,
  onClick,
  role,
  "data-testid": testId,
  sharp = false
}) => {
  return /* @__PURE__ */ jsx598(InnerFilledCard, {
    color,
    withBorder,
    header,
    footer,
    Icon: Icon2,
    onClick,
    role,
    "data-testid": testId,
    sharp,
    children
  });
};
// src/components/icon-button/IconButton.tsx
import { ActionIcon } from "@mantine/core";
import {
  forwardRef as forwardRef3,
  useCallback as useCallback10
} from "react";

// src/components/anchor/Anchor.tsx
import {
  Anchor as BaseAnchor
} from "@mantine/core";
import {
  forwardRef as forwardRef2,
  useCallback as useCallback9
} from "react";
import { Link } from "react-router-dom";
import { jsx as jsx599 } from "react/jsx-runtime";
var Anchor = forwardRef2(({
  children,
  color,
  display,
  inherit,
  inline,
  height,
  href,
  lineClamp,
  onClick,
  size,
  target,
  textDecoration,
  truncate,
  width,
  "aria-label": ariaLabel
}, ref) => {
  const handleClick = useCallback9((e) => {
    e.stopPropagation();
    onClick?.(e);
  }, [onClick]);
  const sharedProps = {
    c: color,
    display,
    h: height,
    inherit,
    inline,
    lineClamp,
    onClick: handleClick,
    size,
    target,
    truncate,
    td: textDecoration ?? (href || onClick ? "underline" : "none"),
    w: width,
    style: { cursor: href || onClick ? "pointer" : "default" },
    "aria-label": ariaLabel
  };
  if (href) {
    return /* @__PURE__ */ jsx599(BaseAnchor, {
      ...sharedProps,
      component: Link,
      to: href,
      ref,
      children
    });
  }
  const otherProps = onClick ? {
    component: "button",
    type: "button",
    ref
  } : {
    component: "span",
    ref
  };
  return /* @__PURE__ */ jsx599(BaseAnchor, {
    ...sharedProps,
    ...otherProps,
    children
  });
});
Anchor.displayName = "Anchor";

// src/components/icon-button/IconButton.tsx
import { jsx as jsx600 } from "react/jsx-runtime";
var btnSize = {
  sm: rem("40px"),
  md: rem("48px"),
  lg: rem("56px")
};
var IconButton = forwardRef3(({
  Icon: Icon2,
  color = "primary",
  size = "md",
  disabled = false,
  onClick,
  withStyles = true,
  alt,
  disableClickColor = false
}, ref) => {
  const theme2 = useMantineTheme();
  const colorProps = theme2.other.getStyleForColor(color);
  const handleClick = useCallback10((event) => {
    event.preventDefault();
    event.stopPropagation();
    onClick?.();
  }, [onClick]);
  if (!withStyles) {
    const anchorSize = `calc(${btnSize[size]} / 2)`;
    return /* @__PURE__ */ jsx600(Anchor, {
      onClick: handleClick,
      display: "inline-block",
      height: anchorSize,
      width: anchorSize,
      "aria-label": alt,
      ref,
      children: /* @__PURE__ */ jsx600(Icon2, {
        color,
        height: anchorSize,
        width: anchorSize
      })
    });
  }
  return /* @__PURE__ */ jsx600(ActionIcon, {
    color: colorProps.bg,
    variant: "subtle",
    disabled,
    radius: "50%",
    size: btnSize[size],
    onClick: handleClick,
    __vars: {
      "--ai-hover": disableClickColor ? "var(--mantine-color-body)" : `var(--mantine-color-${color}-background-hover)`
    },
    "aria-label": alt,
    ref,
    children: /* @__PURE__ */ jsx600(Icon2, {
      color: disabled ? "gray" : color,
      width: "65%",
      height: "65%"
    })
  });
});
IconButton.displayName = "IconButton";

// src/components/card/highlightedcard.module.css
injectStyle(".y4sM1q_root{border:2px solid;padding:0}.y4sM1q_root>div>div{background-color:var(--card-bg-color,inherit);padding:0 var(--card-padding)}.y4sM1q_root>div>div:first-child{background-color:var(--card-header-bg-color,inherit);padding-bottom:var(--mantine-spacing-xs);padding-top:var(--mantine-spacing-xs)}.y4sM1q_root>div>div:last-child{padding-bottom:var(--card-padding)}");
var highlightedcard_module_default = { root: "y4sM1q_root" };

// src/components/card/HighlightedCard.tsx
import { jsx as jsx601, jsxs as jsxs11 } from "react/jsx-runtime";
var ICON_WRAPPER_DIRECTION = {
  left: "row",
  right: "row-reverse"
};
var ICON_WRAPPER_JUSTIFY = {
  left: "initial",
  right: "space-between"
};
var HighlightedCard = ({
  children,
  footer,
  header,
  Icon: Icon2,
  iconPosition = "left",
  color = "primary",
  onIconClick,
  onClick,
  role,
  sharp = false
}) => {
  const theme2 = useMantineTheme();
  const colorProps = theme2.other.getStyleForColor(color);
  let Header;
  if (Icon2) {
    Header = /* @__PURE__ */ jsxs11(Flex, {
      gap: "xxxs",
      justify: ICON_WRAPPER_JUSTIFY[iconPosition],
      direction: ICON_WRAPPER_DIRECTION[iconPosition],
      children: [
        onIconClick ? /* @__PURE__ */ jsx601(IconButton, {
          onClick: onIconClick,
          Icon: Icon2,
          color,
          withStyles: false
        }) : /* @__PURE__ */ jsx601(Icon2, {
          color
        }),
        /* @__PURE__ */ jsx601(CardHeader, {
          color: colorProps.bg,
          children: header
        })
      ]
    });
  } else {
    Header = /* @__PURE__ */ jsx601(CardHeader, {
      color: colorProps.bg,
      children: header
    });
  }
  return /* @__PURE__ */ jsx601(BaseCard, {
    withBorder: true,
    footer,
    header: Header,
    variant: "filled",
    padding: "sm",
    radius: sharp ? "0" : "sm",
    classNames: highlightedcard_module_default,
    style: {
      borderColor: "var(--card-border-color)"
    },
    __vars: {
      "--card-border-color": `var(--mantine-color-${color}-7)`,
      "--card-header-bg-color": `var(--mantine-color-${color}-0)`,
      "--card-header-padding-bottom": "var(--card-padding)"
    },
    onClick,
    role,
    children
  });
};
// src/components/card/OutlinedCard.tsx
import { jsx as jsx602 } from "react/jsx-runtime";
var OutlinedCard = ({
  children,
  footer,
  header,
  Icon: Icon2,
  iconColor,
  iconBackground,
  onClick,
  role,
  shadow,
  padding = "sm",
  sharp = false,
  style,
  "data-testid": testId
}) => {
  const Header = header ? /* @__PURE__ */ jsx602(CardHeader, {
    children: header
  }) : null;
  return /* @__PURE__ */ jsx602(BaseCard, {
    onClick,
    withBorder: true,
    footer,
    header: Header,
    Icon: Icon2,
    iconColor,
    iconBackground,
    variant: "filled",
    padding,
    radius: sharp ? "0" : "sm",
    "data-testid": testId,
    style: {
      borderColor: `var(--mantine-color-gray-2)`,
      ...style
    },
    role,
    shadow,
    children
  });
};
// src/components/card/SelectionCard.tsx
import { jsx as jsx603 } from "react/jsx-runtime";
var SelectionCard = ({
  children,
  color,
  isSelected,
  ...rest
}) => {
  if (isSelected) {
    return /* @__PURE__ */ jsx603(InnerFilledCard, {
      withBorder: true,
      withOutline: true,
      color,
      ...rest,
      children
    });
  }
  return /* @__PURE__ */ jsx603(OutlinedCard, {
    iconColor: "gray",
    ...rest,
    children
  });
};
// src/components/divider/Divider.tsx
import { Divider as BaseDivider } from "@mantine/core";

// src/components/divider/divider.module.css
injectStyle("._3Rh_tG_root{--divider-color:var(--mantine-color-gray-1)}._3Rh_tG_root:where([data-variant=middle]):where([data-orientation=horizontal]){margin:0 var(--mantine-spacing-sm)}._3Rh_tG_root:where([data-variant=middle]):where([data-orientation=vertical]){margin:var(--mantine-spacing-xxxs)0}");
var divider_module_default = { root: "_3Rh_tG_root" };

// src/components/divider/Divider.tsx
import { jsx as jsx604 } from "react/jsx-runtime";
var Divider = ({
  orientation,
  variant = "full"
}) => {
  return /* @__PURE__ */ jsx604(BaseDivider, {
    "data-variant": variant,
    classNames: divider_module_default,
    orientation
  });
};

// src/components/divider/variants/HorizontalDivider.tsx
import { jsx as jsx605 } from "react/jsx-runtime";
var HorizontalDivider = ({
  variant = "full"
}) => {
  return /* @__PURE__ */ jsx605(Divider, {
    variant,
    orientation: "horizontal"
  });
};

// src/components/divider/variants/VerticalDivider.tsx
import { jsx as jsx606 } from "react/jsx-runtime";
var VerticalDivider = ({ variant = "full" }) => {
  return /* @__PURE__ */ jsx606(Divider, {
    variant,
    orientation: "vertical"
  });
};

// src/components/typography/titles/BaseTitle.tsx
import { Title } from "@mantine/core";

// src/components/typography/shared.ts
var getColor = (color, highContrast = false) => {
  if (color === "white" || color === "currentColor") {
    return color;
  }
  return highContrast ? `var(--mantine-color-${color}-9)` : `var(--mantine-color-${color}-7)`;
};

// src/components/typography/titles/BaseTitle.tsx
import { jsx as jsx607 } from "react/jsx-runtime";
var BaseTitle = ({
  children,
  order,
  color = "gray",
  size = "2rem",
  ta,
  "data-testid": testId
}) => /* @__PURE__ */ jsx607(Title, {
  order,
  size,
  ta,
  style: {
    color: getColor(color, true)
  },
  "data-testid": testId,
  children
});

// src/components/typography/titles/Title1.tsx
import { jsx as jsx608 } from "react/jsx-runtime";
var Title1 = ({
  children,
  color = "gray",
  size = "2rem",
  ta
}) => /* @__PURE__ */ jsx608(BaseTitle, {
  order: 1,
  size,
  color,
  ta,
  children
});
// src/components/typography/headings/BaseHeading.tsx
import { Title as Title2 } from "@mantine/core";
import { jsx as jsx609 } from "react/jsx-runtime";
var BaseHeading = ({
  children,
  order,
  color = "gray",
  size = "h1",
  ta,
  "data-testid": testId
}) => /* @__PURE__ */ jsx609(Title2, {
  order,
  size,
  ta,
  style: {
    color: getColor(color, true)
  },
  "data-testid": testId,
  children
});

// src/components/typography/headings/Heading1.tsx
import { jsx as jsx610 } from "react/jsx-runtime";
var Heading1 = ({
  children,
  color = "gray",
  size = "h1",
  ta
}) => /* @__PURE__ */ jsx610(BaseHeading, {
  order: 1,
  size,
  color,
  ta,
  children
});
// src/components/typography/headings/Heading2.tsx
import { jsx as jsx611 } from "react/jsx-runtime";
var Heading2 = ({
  children,
  color = "gray",
  size = "h2",
  ta,
  "data-testid": testId
}) => /* @__PURE__ */ jsx611(BaseHeading, {
  order: 2,
  size,
  color,
  ta,
  "data-testid": testId,
  children
});
// src/components/typography/headings/Heading3.tsx
import { jsx as jsx612 } from "react/jsx-runtime";
var Heading3 = ({
  children,
  color = "gray",
  size = "h3",
  ta
}) => {
  return /* @__PURE__ */ jsx612(BaseHeading, {
    order: 3,
    size,
    color,
    ta,
    children
  });
};
// src/components/typography/headings/Heading4.tsx
import { jsx as jsx613 } from "react/jsx-runtime";
var Heading4 = ({
  children,
  color = "gray",
  size = "h4",
  ta
}) => /* @__PURE__ */ jsx613(BaseHeading, {
  order: 4,
  size,
  color,
  ta,
  children
});
// src/components/typography/headings/Heading5.tsx
import { jsx as jsx614 } from "react/jsx-runtime";
var Heading5 = ({
  children,
  color = "gray",
  size = "h5",
  ta
}) => /* @__PURE__ */ jsx614(BaseHeading, {
  order: 5,
  size,
  color,
  ta,
  children
});
// src/components/typography/headings/Heading6.tsx
import { jsx as jsx615 } from "react/jsx-runtime";
var Heading6 = ({
  children,
  color = "gray",
  size = "h6",
  ta
}) => /* @__PURE__ */ jsx615(BaseHeading, {
  order: 6,
  size,
  color,
  ta,
  children
});
// src/components/typography/Body1.tsx
import { Text as Text3 } from "@mantine/core";
import { jsx as jsx616 } from "react/jsx-runtime";
var Body1 = ({
  children,
  bold = false,
  color = "gray",
  ta,
  highContrast = false,
  inline = false,
  "data-testid": testId,
  ellipsis = false,
  noWrap = false
}) => /* @__PURE__ */ jsx616(Text3, {
  size: "md",
  component: inline ? "span" : "p",
  fw: bold ? 600 : 400,
  ta,
  style: {
    color: getColor(color, highContrast),
    ...ellipsis && {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    textWrap: noWrap ? "nowrap" : "wrap"
  },
  "data-testid": testId,
  children
});
// src/components/typography/Body2.tsx
import { Text as Text4 } from "@mantine/core";
import { jsx as jsx617 } from "react/jsx-runtime";
var Body2 = ({
  children,
  bold = false,
  color = "gray",
  ta,
  highContrast = false,
  inline = false,
  "data-testid": testId,
  noWrap = false
}) => /* @__PURE__ */ jsx617(Text4, {
  size: "sm",
  component: inline ? "span" : "p",
  fw: bold ? 600 : 400,
  ta,
  style: {
    color: getColor(color, highContrast),
    textWrap: noWrap ? "nowrap" : "wrap"
  },
  "data-testid": testId,
  children
});
// src/components/typography/ButtonLabel.tsx
import { Text as Text5 } from "@mantine/core";
import { jsx as jsx618 } from "react/jsx-runtime";
var ButtonLabel = ({
  children,
  color = "gray",
  icon = false,
  ta
}) => /* @__PURE__ */ jsx618(Text5, {
  size: "lg",
  fw: 600,
  ta,
  style: {
    color: getColor(color, true),
    blockSize: icon ? "var(--text-lh, var(--mantine-line-height-lg))" : "auto"
  },
  children
});
// src/components/typography/Subtitle1.tsx
import { Text as Text6 } from "@mantine/core";
import { jsx as jsx619 } from "react/jsx-runtime";
var Subtitle1 = ({
  children,
  color = "gray",
  icon = false,
  inline = false,
  ta,
  "data-testid": testId
}) => /* @__PURE__ */ jsx619(Text6, {
  size: "xl",
  component: inline ? "span" : "p",
  fw: 600,
  ta,
  "data-testid": testId,
  style: {
    color: getColor(color, true),
    blockSize: icon ? "var(--text-lh, var(--mantine-line-height-xl))" : "auto",
    display: inline ? "inline-block" : "block"
  },
  children
});
// src/components/typography/Subtitle2.tsx
import { Text as Text7 } from "@mantine/core";
import { jsx as jsx620 } from "react/jsx-runtime";
var Subtitle2 = ({
  children,
  color = "gray",
  icon = false,
  inline = false,
  ta,
  "data-testid": testId
}) => /* @__PURE__ */ jsx620(Text7, {
  size: "lg",
  component: inline ? "span" : "p",
  fw: 600,
  ta,
  "data-testid": testId,
  style: {
    color: getColor(color, true),
    blockSize: icon ? "var(--text-lh, var(--mantine-line-height-xl))" : "auto",
    display: inline ? "inline-block" : "block"
  },
  children
});
// src/components/typography/Subtitle3.tsx
import { Text as Text8 } from "@mantine/core";
import { jsx as jsx621 } from "react/jsx-runtime";
var Subtitle3 = ({
  children,
  color = "gray",
  icon = false,
  inline = false,
  ta
}) => /* @__PURE__ */ jsx621(Text8, {
  size: "sm",
  component: inline ? "span" : "p",
  fw: 600,
  ta,
  style: {
    color: getColor(color, true),
    blockSize: icon ? "var(--text-lh, var(--mantine-line-height-xl))" : "auto",
    display: inline ? "inline-block" : "block"
  },
  children
});
// src/components/typography/SidebarHeading.tsx
import { Text as Text9 } from "@mantine/core";
import { jsx as jsx622 } from "react/jsx-runtime";
var SidebarHeading = ({
  children
}) => /* @__PURE__ */ jsx622(Text9, {
  size: "lg",
  fw: 600,
  style: { color: `var(--mantine-color-gray-4)` },
  children
});
// src/components/typography/Caption.tsx
import { Text as Text10 } from "@mantine/core";
import { jsx as jsx623 } from "react/jsx-runtime";
var Caption = ({
  children,
  color = "gray",
  ta,
  highContrast = false
}) => /* @__PURE__ */ jsx623(Text10, {
  size: "xs",
  fw: 500,
  ta,
  style: { color: getColor(color, highContrast) },
  children
});
// src/components/accordion/accordion.module.css
injectStyle(".Q7MPtq_root{--accordion-chevron-size:1.5rem}.Q7MPtq_item{border-bottom:0}.Q7MPtq_icon,.Q7MPtq_label{color:var(--mantine-color-gray-9)}.Q7MPtq_label{padding:0}.Q7MPtq_control{padding:var(--mantine-spacing-xs)0}.Q7MPtq_content{padding:var(--mantine-spacing-xxxs)0 var(--mantine-spacing-sm)0}.Q7MPtq_chevron{align-self:flex-start}");
var accordion_module_default = { root: "Q7MPtq_root", item: "Q7MPtq_item", icon: "Q7MPtq_icon", label: "Q7MPtq_label", control: "Q7MPtq_control", content: "Q7MPtq_content", chevron: "Q7MPtq_chevron" };

// src/components/accordion/Accordion.tsx
import { jsx as jsx624, jsxs as jsxs12 } from "react/jsx-runtime";
var Accordion = ({
  border = false,
  defaultValue,
  divider = true,
  items,
  multiple = false
}) => {
  const cards = items.flatMap(({ header, key, Icon: Icon2, ...restProps }, idx, arr) => {
    const card = /* @__PURE__ */ jsxs12(MantineAccordion.Item, {
      value: key,
      children: [
        /* @__PURE__ */ jsx624(MantineAccordion.Control, {
          icon: Icon2 ? /* @__PURE__ */ jsx624(Icon2, {}) : null,
          children: /* @__PURE__ */ jsx624(Subtitle2, {
            children: header
          })
        }),
        /* @__PURE__ */ jsx624(MantineAccordion.Panel, {
          children: /* @__PURE__ */ jsx624(BaseCard, {
            ...restProps,
            radius: 0,
            padding: 0
          })
        })
      ]
    }, key);
    if (divider && arr.length - 1 !== idx) {
      return [card, /* @__PURE__ */ jsx624(HorizontalDivider, {}, `${key}-divider`)];
    }
    return card;
  });
  return /* @__PURE__ */ jsx624(MantineAccordion, {
    multiple,
    defaultValue,
    classNames: accordion_module_default,
    chevron: /* @__PURE__ */ jsx624(IconKeyboardArrowDown, {
      color: "gray"
    }),
    style: {
      border: border ? "1px solid var(--mantine-color-default-border)" : 0,
      borderRadius: "var(--accordion-radius)"
    },
    children: cards
  });
};
// src/components/address/Address.tsx
import { jsx as jsx625, jsxs as jsxs13 } from "react/jsx-runtime";
var getMapUrl = (address) => {
  const url = new URL("https://maps.google.com/");
  url.searchParams.set("q", `${address.line1}, ${address.city}, ${address.state} ${address.zipCode}`);
  return url.toString();
};
var AddressBody = ({ inline, parts }) => {
  if (inline) {
    return /* @__PURE__ */ jsx625(Body1, {
      children: parts.join(", ")
    });
  }
  return /* @__PURE__ */ jsx625(Stack, {
    gap: "xxxs",
    children: parts.map((part) => /* @__PURE__ */ jsx625(Body1, {
      children: part
    }, part))
  });
};
var Address = ({
  actionable = true,
  address,
  showIcon = true,
  inline = true
}) => {
  const parts = [
    address.line1,
    address.line2,
    `${address.city}, ${address.state} ${address.zipCode}`
  ].filter((str) => str?.length);
  const iconColor = actionable ? "primary" : "secondary";
  return /* @__PURE__ */ jsx625(Anchor, {
    target: "_blank",
    href: actionable ? getMapUrl(address) : undefined,
    textDecoration: "none",
    children: /* @__PURE__ */ jsxs13(Flex, {
      align: "center",
      gap: "xxs",
      children: [
        showIcon && /* @__PURE__ */ jsx625(IconLocationOn, {
          color: iconColor
        }),
        /* @__PURE__ */ jsx625(AddressBody, {
          inline,
          parts
        })
      ]
    })
  });
};
// src/components/alert/Alert.tsx
import { Alert as MantineAlert } from "@mantine/core";

// src/components/button/Button.tsx
import {
  Button as ButtonBase
} from "@mantine/core";

// src/components/internal/get-hc-prop.ts
var getHcProp = (color) => {
  if (color === "high-contrast") {
    return { "data-high-contrast": "true" };
  }
  if (color === "high-contrast-inverted") {
    return { "data-high-contrast": "inverted" };
  }
  return {};
};

// src/components/button/button.module.css
injectStyle(".xCYxwG_root{--button-padding-x-sm:var(--mantine-spacing-sm);--button-padding-x-md:var(--mantine-spacing-md);--button-padding-x-lg:var(--mantine-spacing-lg);--button-height-sm:calc(2.5rem*var(--mantine-scale));--button-height-md:calc(3rem*var(--mantine-scale));--button-height-lg:calc(3.5rem*var(--mantine-scale));min-width:min-content}.xCYxwG_root:where([data-with-left-section]){padding-inline-start:var(--button-padding-x)}.xCYxwG_root:where([data-with-right-section]){padding-inline-end:var(--button-padding-x)}.xCYxwG_label{font-size:medium;font-weight:500}");
var button_module_default = { root: "xCYxwG_root", label: "xCYxwG_label" };

// src/components/button/Button.tsx
import { jsx as jsx626 } from "react/jsx-runtime";
var Button = ({
  children,
  onClick,
  color = "primary",
  size = "md",
  LeftIcon,
  RightIcon,
  type,
  form: form2,
  ...mantineButtonProps
}) => {
  const hcProp = getHcProp(color);
  return /* @__PURE__ */ jsx626(ButtonBase, {
    ...mantineButtonProps,
    ...hcProp,
    type,
    form: form2,
    classNames: button_module_default,
    color,
    size,
    onClick,
    rightSection: RightIcon && /* @__PURE__ */ jsx626(RightIcon, {
      color: "currentColor"
    }),
    leftSection: LeftIcon && /* @__PURE__ */ jsx626(LeftIcon, {
      color: "currentColor"
    }),
    __vars: {
      "--button-radius": size === "sm" ? "var(--mantine-radius-xxs)" : "var(--mantine-radius-xs)"
    },
    children
  });
};

// src/components/button/TextButton.tsx
import { Button as ButtonBase2 } from "@mantine/core";

// src/components/button/textbutton.module.css
injectStyle(".IgDAOW_root{height:calc(1.5rem*var(--mantine-scale));padding:0;overflow:visible}:where([data-mantine-color-scheme=light]) .IgDAOW_root:where(:disabled,[data-disabled]){background-color:var(--button-bg)}.IgDAOW_root:hover svg{fill:var(--button-hover-color)}.IgDAOW_section:where([data-position=left]){margin-inline-end:var(--mantine-spacing-xxxs)}.IgDAOW_section:where([data-position=right]){margin-inline-start:var(--mantine-spacing-xxxs)}");
var textbutton_module_default = { root: "IgDAOW_root", section: "IgDAOW_section" };

// src/components/button/TextButton.tsx
import { jsx as jsx627 } from "react/jsx-runtime";
var TextButton = ({
  children,
  LeftIcon,
  RightIcon,
  onClick,
  color = "primary",
  justify = "center",
  disabled,
  "data-testid": testId
}) => {
  return /* @__PURE__ */ jsx627(ButtonBase2, {
    variant: "transparent",
    size: "md",
    color,
    classNames: textbutton_module_default,
    disabled,
    onClick,
    rightSection: RightIcon && /* @__PURE__ */ jsx627(RightIcon, {
      color
    }),
    leftSection: LeftIcon && /* @__PURE__ */ jsx627(LeftIcon, {
      color
    }),
    __vars: {
      "--button-hover-color": `var(--mantine-color-${color}-9)`,
      "--button-justify": justify
    },
    "data-testid": testId,
    children
  });
};

// src/components/alert/alert.module.css
injectStyle(".WmWSiq_root{--mantine-color-gray-light-color:var(--mantine-color-gray-9);--mantine-color-saving-light-color:var(--mantine-color-saving-9);--mantine-color-primary-light-color:var(--mantine-color-primary-9);--mantine-color-secondary-light-color:var(--mantine-color-secondary-9);--mantine-color-error-light-color:var(--mantine-color-error-9);--mantine-color-success-light-color:var(--mantine-color-success-9);--mantine-color-warning-light-color:var(--mantine-color-warning-9);--mantine-color-info-light-color:var(--mantine-color-info-9);--mantine-color-notice-light-color:var(--mantine-color-notice-9);padding:var(--mantine-spacing-xs)var(--mantine-spacing-sm)}[data-full-bleed][data-active=true]>.WmWSiq_root{padding-inline:0}.WmWSiq_icon{margin-inline-end:var(--mantine-spacing-xxs)}.WmWSiq_message{color:var(--alert-color)}");
var alert_module_default = { message: "WmWSiq_message", root: "WmWSiq_root", icon: "WmWSiq_icon" };

// src/components/alert/Alert.tsx
import { jsx as jsx628, jsxs as jsxs14 } from "react/jsx-runtime";
var severityIcons = {
  gray: IconInfo,
  saving: IconSavings,
  primary: IconInfo,
  secondary: IconInfo,
  error: IconError,
  success: IconCheckCircle,
  warning: IconWarning,
  info: IconInfo,
  notice: IconInfo
};
var Alert = ({
  children,
  IconOverride = null,
  severity,
  primaryButtonProps,
  secondaryButtonProps
}) => {
  const Icon2 = IconOverride ? IconOverride : severityIcons[severity];
  return /* @__PURE__ */ jsxs14(MantineAlert, {
    classNames: alert_module_default,
    variant: "light",
    color: severity,
    radius: "none",
    icon: Icon2 ? /* @__PURE__ */ jsx628(Icon2, {}) : null,
    children: [
      /* @__PURE__ */ jsx628(Body1, {
        color: "currentColor",
        children
      }),
      primaryButtonProps?.label && /* @__PURE__ */ jsxs14(Flex, {
        gap: "sm",
        justify: "flex-end",
        children: [
          /* @__PURE__ */ jsx628(TextButton, {
            onClick: primaryButtonProps.action,
            color: severity,
            children: primaryButtonProps.label
          }),
          secondaryButtonProps?.label && /* @__PURE__ */ jsx628(TextButton, {
            onClick: secondaryButtonProps.action,
            color: severity,
            children: secondaryButtonProps.label
          })
        ]
      })
    ]
  });
};
// src/components/app-shell/AppShell.tsx
import { AppShell as MantineAppShell } from "@mantine/core";
import {
  useRef as useRef8
} from "react";

// src/components/cover/CoverProviderContext.tsx
import { createContext as createContext2 } from "react";
var CoverProviderContext = createContext2({
  coverPageTarget: undefined
});

// src/components/nav-bar/NavBar.tsx
import { useMemo as useMemo3 } from "react";
import { useTranslation as useTranslation92 } from "react-i18next";
import { jsx as jsx629, jsxs as jsxs15 } from "react/jsx-runtime";
var NavBar = (props) => {
  const {
    logoUrl,
    logoStyles,
    username,
    auth,
    onAvatarClick,
    onLogoClick,
    onBackButtonClick,
    hideBackButton,
    AvatarAdornment,
    logoHeight = "48px",
    logoWidth = "128px"
  } = props;
  const showBackButton = !hideBackButton && !!onBackButtonClick;
  const showAvatar = !!onAvatarClick;
  const { t } = useTranslation92("pds");
  const initials = useMemo3(() => {
    if (!auth)
      return;
    if (username)
      return getInitials(username);
  }, [auth, username]);
  if (AvatarAdornment) {
    return /* @__PURE__ */ jsx629(AdornmentLayout, {
      initials,
      AvatarAdornment,
      ...props
    });
  }
  return /* @__PURE__ */ jsxs15(Flex, {
    justify: "space-between",
    align: "center",
    p: "xxs",
    style: { width: "100%" },
    "data-testid": "app-header-container",
    children: [
      /* @__PURE__ */ jsx629(Box3, {
        style: { visibility: showBackButton ? "visible" : "hidden" },
        children: /* @__PURE__ */ jsx629(IconButton, {
          Icon: IconChevronLeft,
          size: "sm",
          onClick: onBackButtonClick,
          color: "primary",
          disabled: false,
          alt: t("navbar.backButton")
        })
      }),
      logoUrl ? /* @__PURE__ */ jsx629("img", {
        src: logoUrl,
        style: {
          width: logoWidth,
          height: logoHeight,
          cursor: onLogoClick ? "pointer" : "initial",
          ...logoStyles ?? {}
        },
        alt: "navbar-logo",
        onClick: onLogoClick
      }) : null,
      /* @__PURE__ */ jsx629(Box3, {
        children: showAvatar ? /* @__PURE__ */ jsx629(Avatar, {
          onClick: onAvatarClick,
          size: "md",
          initials,
          AvatarIcon: initials ? undefined : IconMenu,
          color: "primary",
          "data-testid": "navigation-bar-avatar"
        }) : null
      })
    ]
  });
};
var AdornmentLayout = (props) => {
  const {
    logoUrl,
    logoStyles,
    onAvatarClick,
    onLogoClick,
    AvatarAdornment,
    initials
  } = props;
  const isMobile = useIsMobile();
  const showAvatar = !!onAvatarClick;
  return /* @__PURE__ */ jsxs15(Flex, {
    justify: "space-between",
    align: "center",
    p: "xxs",
    style: { width: "100%" },
    "data-testid": "app-header-container",
    children: [
      isMobile ? null : /* @__PURE__ */ jsx629(Box3, {}),
      logoUrl ? /* @__PURE__ */ jsx629("img", {
        src: logoUrl,
        style: {
          width: "128px",
          height: "48px",
          cursor: onLogoClick ? "pointer" : "initial",
          ...logoStyles ?? {}
        },
        alt: "navbar-logo",
        onClick: onLogoClick
      }) : null,
      /* @__PURE__ */ jsxs15(Flex, {
        align: "center",
        children: [
          /* @__PURE__ */ jsx629(AvatarAdornment, {}),
          showAvatar ? /* @__PURE__ */ jsx629(Avatar, {
            onClick: onAvatarClick,
            size: "md",
            initials,
            AvatarIcon: initials ? undefined : IconMenu,
            color: "primary",
            "data-testid": "navigation-bar-avatar"
          }) : null
        ]
      })
    ]
  });
};

// src/components/nav-bar/NavBarContext.tsx
import {
  createContext as createContext3,
  useContext as useContext2,
  useEffect as useEffect8,
  useState as useState8
} from "react";
import { jsx as jsx630 } from "react/jsx-runtime";
var NavBarContext = createContext3(undefined);
var NavBarProvider = ({ children }) => {
  const [backButtonDisabled, setBackButtonDisabled] = useState8(false);
  const [backOverrideState, setBackOverrideState] = useState8({ overrideFn: null });
  return /* @__PURE__ */ jsx630(NavBarContext.Provider, {
    value: {
      backOverrideState,
      setBackOverrideState,
      backButtonDisabled,
      setBackButtonDisabled
    },
    children
  });
};
var useNavBar = () => {
  const context = useContext2(NavBarContext);
  if (!context) {
    throw new Error("useNavBar must be used within a NavBarProvider");
  }
  return context;
};
var useConditionalBackOverride = (overrideFn, condition) => {
  const { setBackOverrideState } = useNavBar();
  useEffect8(() => {
    if (condition)
      setBackOverrideState({ overrideFn });
    return () => setBackOverrideState({ overrideFn: null });
  }, [condition]);
};
var useDisableBackButton = (disabled) => {
  const { setBackButtonDisabled } = useNavBar();
  useEffect8(() => {
    if (disabled) {
      setBackButtonDisabled(true);
    }
    return () => setBackButtonDisabled(false);
  }, [disabled]);
};

// src/components/app-shell/app-shell-main.module.css
injectStyle("._1GEdca_main{overflow-x:hidden}._1GEdca_main:has(>:first-child>[role=alert]:first-child),._1GEdca_main:has(>:first-child>[data-full-bleed]:first-child){padding-top:0!important}:is(._1GEdca_main:has(>:first-child>[role=alert]:first-child),._1GEdca_main:has(>:first-child>[data-full-bleed]:first-child))>:first-child>[role=alert]:first-child,:is(._1GEdca_main:has(>:first-child>[role=alert]:first-child),._1GEdca_main:has(>:first-child>[data-full-bleed]:first-child))>:first-child>[data-full-bleed]:first-child{margin-bottom:var(--mantine-spacing-lg)}");
var app_shell_main_module_default = { main: "_1GEdca_main" };

// src/components/app-shell/AppShell.tsx
import { jsx as jsx631, jsxs as jsxs16 } from "react/jsx-runtime";
var AppShell2 = ({
  header,
  footer,
  navBarProps,
  children,
  maxWidth = "800px",
  footerBg = "inherit",
  navbarBg = "inherit"
}) => {
  const coverPageRef = useRef8(null);
  return /* @__PURE__ */ jsxs16(MantineAppShell, {
    display: "flex",
    style: {
      flexDirection: "column"
    },
    mih: "100svh",
    withBorder: false,
    children: [
      /* @__PURE__ */ jsx631(MantineAppShell.Navbar, {
        bg: navbarBg,
        h: "auto",
        pos: "relative",
        children: /* @__PURE__ */ jsx631(Box3, {
          m: "0 auto",
          w: "100%",
          maw: maxWidth,
          children: /* @__PURE__ */ jsx631(NavBar, {
            ...navBarProps ?? {}
          })
        })
      }),
      header ? /* @__PURE__ */ jsx631(MantineAppShell.Header, {
        h: "auto",
        pos: "relative",
        w: "100%",
        maw: maxWidth,
        m: "0 auto",
        children: header
      }) : null,
      /* @__PURE__ */ jsx631(MantineAppShell.Main, {
        display: "flex",
        flex: "1",
        pb: "xl",
        pt: "lg",
        px: "sm",
        style: { flexDirection: "column" },
        mih: "unset",
        classNames: app_shell_main_module_default,
        children: /* @__PURE__ */ jsx631(Stack, {
          gap: 0,
          m: "0 auto",
          w: "100%",
          flex: "1",
          maw: maxWidth,
          pos: "relative",
          ref: coverPageRef,
          children: /* @__PURE__ */ jsx631(CoverProviderContext.Provider, {
            value: { coverPageTarget: coverPageRef },
            children
          })
        })
      }),
      footer ? /* @__PURE__ */ jsx631(MantineAppShell.Footer, {
        pos: "relative",
        p: "sm",
        bg: footerBg,
        children: /* @__PURE__ */ jsx631(Box3, {
          w: "100%",
          maw: maxWidth,
          m: "0 auto",
          children: footer
        })
      }) : null
    ]
  });
};
// src/components/badge/Badge.tsx
import {
  Badge as MantineBadge
} from "@mantine/core";

// src/components/badge/badge.module.css
injectStyle(".D4s69G_root{text-transform:none}");
var badge_module_default = { root: "D4s69G_root" };

// src/components/badge/Badge.tsx
import { jsx as jsx632 } from "react/jsx-runtime";
var Badge = ({
  children,
  color = "primary",
  radius = "xxs",
  p
}) => {
  const content = typeof children === "string" || typeof children === "number" ? /* @__PURE__ */ jsx632(Body2, {
    color,
    children
  }) : children;
  return /* @__PURE__ */ jsx632(MantineBadge, {
    p,
    classNames: badge_module_default,
    c: `var(--mantine-color-${color}-7)`,
    bg: `var(--mantine-color-${color}-0)`,
    fz: "sm",
    size: "lg",
    radius,
    variant: "filled",
    children: content
  });
};

// src/components/badge/SurfaceBadge.tsx
import { Badge as MantineBadge2 } from "@mantine/core";
import { jsx as jsx633 } from "react/jsx-runtime";
var SurfaceBadge = ({
  children,
  color = "primary"
}) => {
  return /* @__PURE__ */ jsx633(MantineBadge2, {
    c: `var(--mantine-color-${color}-7)`,
    fz: "sm",
    size: "lg",
    radius: "xxs",
    variant: "default",
    __vars: {
      "--badge-bd": "0"
    },
    children
  });
};

// src/components/badge/badge-list/BadgeList.tsx
import { jsx as jsx634 } from "react/jsx-runtime";
var BadgeList = ({ badgelist }) => {
  return /* @__PURE__ */ jsx634(Flex, {
    gap: "xs",
    children: badgelist.map(({ label, color }, idx) => /* @__PURE__ */ jsx634(Badge, {
      color,
      children: label
    }, `${label}-${idx}`))
  });
};
// src/components/breadcrumbs/Breadcrumbs.tsx
import { Breadcrumbs as MantineBreadCrumbs } from "@mantine/core";
import { Fragment as Fragment3, useMemo as useMemo4 } from "react";
import { jsx as jsx635, Fragment as Fragment4 } from "react/jsx-runtime";
var Breadcrumbs = ({ items }) => {
  const renderBreadcrumbItem = (title, href, isCurrentPage) => /* @__PURE__ */ jsx635(Fragment4, {
    children: isCurrentPage ? /* @__PURE__ */ jsx635(Subtitle2, {
      children: title
    }) : /* @__PURE__ */ jsx635(Anchor, {
      textDecoration: "none",
      href,
      children: /* @__PURE__ */ jsx635(Body1, {
        color: "primary",
        children: title
      })
    }, href)
  });
  const breadcrumbItems = useMemo4(() => {
    return items.map((item) => {
      const isCurrentPage = item.href === window.location.pathname;
      return renderBreadcrumbItem(item.title, item.href, isCurrentPage);
    });
  }, [items]);
  if (!items || items.length === 0)
    return null;
  return /* @__PURE__ */ jsx635(MantineBreadCrumbs, {
    separatorMargin: "xxxs",
    separator: /* @__PURE__ */ jsx635(IconChevronRight, {}),
    children: breadcrumbItems.map((item, index) => /* @__PURE__ */ jsx635(Fragment3, {
      children: item
    }, index))
  });
};
// src/components/carousel/Carousel.tsx
import {
  Carousel as CarouselBase
} from "@mantine/carousel";
import"@mantine/carousel/styles.css";

// src/components/carousel/carousel.module.css
injectStyle("._8SlQZq_root:not([data-include-gap-in-size]) ._8SlQZq_container[data-orientation=horizontal]>:last-child{margin-inline-end:0}._8SlQZq_root[data-include-gap-in-size] ._8SlQZq_container[data-orientation=horizontal]>:last-child{padding-inline-end:0}._8SlQZq_indicator{background-color:var(--mantine-color-gray-7);width:8px;height:8px}._8SlQZq_indicators[data-orientation=horizontal]{bottom:var(--indicator-offset,var(--mantine-spacing-md))}._8SlQZq_slide>*{height:100%}");
var carousel_module_default = { slide: "_8SlQZq_slide", container: "_8SlQZq_container", root: "_8SlQZq_root", indicator: "_8SlQZq_indicator", indicators: "_8SlQZq_indicators" };

// src/components/carousel/Carousel.tsx
import { jsx as jsx636 } from "react/jsx-runtime";
var Carousel = ({
  slides,
  withIndicators = true,
  withControls = false,
  cropped = true,
  indicatorOffset,
  onNextSlide,
  onPreviousSlide,
  onSlideChange
}) => {
  const vars = {};
  if (indicatorOffset) {
    vars["--indicator-offset"] = indicatorOffset;
  }
  return /* @__PURE__ */ jsx636(CarouselBase, {
    slideSize: cropped ? "85%" : undefined,
    slideGap: "sm",
    withIndicators,
    withControls,
    classNames: carousel_module_default,
    onNextSlide,
    onPreviousSlide,
    onSlideChange,
    __vars: vars,
    align: "start",
    role: "tablist",
    children: slides.length ? slides.map((content, idx) => /* @__PURE__ */ jsx636(CarouselBase.Slide, {
      children: content
    }, `carousel-slide-${idx}`)) : null
  });
};
// src/components/checkbox/Checkbox.tsx
import {
  Checkbox as CheckboxBase,
  CheckboxGroup
} from "@mantine/core";
import { useCallback as useCallback11 } from "react";

// src/components/checkbox/checkbox.module.css
injectStyle(".bzyOSG_root{--checkbox-size:var(--checkbox-size-md);--label-lh:1.5rem}.bzyOSG_labelWrapper{gap:var(--mantine-spacing-xxxs);display:flex}.bzyOSG_label{color:var(--mantine-color-gray-7);font-size:var(--mantine-font-size-md);--label-offset-start:var(--mantine-spacing-xxs)}.bzyOSG_input{size:var(--checkbox-size-md);stroke:calc(.125rem*var(--mantine-scale))solid transparent;border-width:2px}.bzyOSG_input:where([data-error]){border-color:var(--mantine-color-error-7)}.bzyOSG_description,.bzyOSG_error{font-size:var(--mantine-font-size-sm);margin-top:0}.bzyOSG_error{color:var(--mantine-color-error-7)}");
var checkbox_module_default = { root: "bzyOSG_root", input: "bzyOSG_input", label: "bzyOSG_label", labelWrapper: "bzyOSG_labelWrapper", description: "bzyOSG_description", error: "bzyOSG_error" };

// src/components/checkbox/Checkbox.tsx
import { jsx as jsx637 } from "react/jsx-runtime";
var Checkbox = (() => {
  const Component = ({
    label,
    error,
    indeterminate,
    description,
    disabled,
    onBlur,
    onChange,
    onFocus,
    checked,
    value
  }) => {
    const handleChange = useCallback11((e) => onChange?.(e.currentTarget.checked), [onChange]);
    return /* @__PURE__ */ jsx637(CheckboxBase, {
      label,
      radius: "xxs",
      classNames: checkbox_module_default,
      indeterminate,
      description,
      error,
      disabled,
      onBlur,
      onChange: handleChange,
      checked,
      onFocus,
      value
    });
  };
  Component.Group = CheckboxGroup;
  return Component;
})();
// src/components/chip/Chip.tsx
import {
  Box as Box4,
  Chip as ChipBase,
  ChipGroup
} from "@mantine/core";
import { forwardRef as forwardRef4 } from "react";

// src/components/chip/chip.module.css
injectStyle(".pnEUPW_root{--chip-size-xs:calc(1.5rem*var(--mantine-scale));--chip-size-sm:calc(2rem*var(--mantine-scale));--chip-size-md:calc(2.5rem*var(--mantine-scale));--chip-size-lg:calc(3rem*var(--mantine-scale));--chip-size-xl:calc(3.5rem*var(--mantine-scale))}:is(.pnEUPW_label:not([data-checked]):not([data-disabled]),.pnEUPW_label:where([data-disabled]))>span>p{color:var(--mantine-color-gray-5)!important}.pnEUPW_label:not([data-checked]){background-color:var(--mantine-color-white);border:1px solid var(--mantine-color-gray-2);padding-inline:var(--mantine-spacing-xs)}.pnEUPW_label:where([data-disabled]):where([data-checked]){background-color:var(--mantine-color-gray-0);border-width:0}.pnEUPW_iconWrapper{--chip-icon-size:1.5rem}");
var chip_module_default = { iconWrapper: "pnEUPW_iconWrapper", label: "pnEUPW_label", root: "pnEUPW_root" };

// src/components/chip/Chip.tsx
import { jsx as jsx638 } from "react/jsx-runtime";
var Chip = (() => {
  const Component = forwardRef4(({
    children,
    checked,
    onChange,
    color = "primary",
    disabled,
    value,
    onClick
  }, ref) => /* @__PURE__ */ jsx638(Box4, {
    ref,
    children: /* @__PURE__ */ jsx638(ChipBase, {
      checked,
      icon: /* @__PURE__ */ jsx638(IconCheck, {
        color
      }),
      classNames: chip_module_default,
      onChange,
      color: disabled ? undefined : color,
      variant: "light",
      disabled,
      radius: "xs",
      size: "md",
      value,
      onClick,
      children: /* @__PURE__ */ jsx638(Subtitle2, {
        color,
        children
      })
    })
  }));
  Component.displayName = "Chip";
  const ChipComponent = Component;
  ChipComponent.Group = ChipGroup;
  return ChipComponent;
})();
// src/components/collapsible-card/collapsible-card.module.css
injectStyle("div:has(>.QNprgq_collapse[data-state]){transition:margin-top .2s}div:has(>.QNprgq_collapse[data-state=closed]){margin-top:calc(var(--mantine-spacing-sm)*-1)}");
var collapsible_card_module_default = { collapse: "QNprgq_collapse" };

// src/components/collapsible-card/CollapsibleCard.tsx
import { jsx as jsx639, jsxs as jsxs17 } from "react/jsx-runtime";
var variants = {
  bare: BareCard,
  elevated: ElevatedCard,
  filled: FilledCard,
  outlined: OutlinedCard,
  highlighted: FilledCard
};
var CollapsibleCard = ({
  children,
  defaultOpen = false,
  header,
  footer,
  variant,
  ...restProps
}) => {
  const [isOpen, { toggle }] = useDisclosure(defaultOpen);
  const Card = variants[variant];
  const CardHeader2 = /* @__PURE__ */ jsxs17(Flex, {
    component: "a",
    onClick: toggle,
    justify: "space-between",
    align: "center",
    style: {
      cursor: "pointer",
      width: "100%"
    },
    "data-testid": "collapsible-card-expand",
    children: [
      /* @__PURE__ */ jsx639(Box3, {
        style: { flex: 1 },
        children: header
      }),
      /* @__PURE__ */ jsx639(Box3, {
        style: { alignSelf: "start" },
        children: /* @__PURE__ */ jsx639(IconKeyboardArrowDown, {
          style: {
            transition: "transform 200ms ease",
            transform: isOpen ? "rotate(180deg)" : ""
          }
        })
      })
    ]
  });
  return /* @__PURE__ */ jsx639(Card, {
    ...restProps,
    header: CardHeader2,
    footer,
    children: /* @__PURE__ */ jsx639(Collapse, {
      "data-state": isOpen ? "open" : "closed",
      className: collapsible_card_module_default.collapse,
      in: isOpen,
      children
    })
  });
};
// src/components/container/ContainerItem.tsx
import { jsx as jsx640 } from "react/jsx-runtime";
var ContainerItem = ({
  children,
  className
}) => {
  return /* @__PURE__ */ jsx640(Box3, {
    className,
    children
  });
};

// src/components/container/Container.tsx
import { jsx as jsx641 } from "react/jsx-runtime";
var Container = ({
  children,
  className,
  name,
  type = "size"
}) => {
  const style = { containerType: type };
  if (name) {
    style.containerName = name;
  }
  if (className) {
    return /* @__PURE__ */ jsx641(Box3, {
      style,
      children: /* @__PURE__ */ jsx641(ContainerItem, {
        className,
        children
      })
    });
  }
  return /* @__PURE__ */ jsx641(Box3, {
    style,
    children
  });
};
// src/components/cover/Cover.tsx
import { Overlay as MantineOverlay, Portal } from "@mantine/core";
import { useContext as useContext3 } from "react";

// src/components/full-bleed/full-bleed.module.css
injectStyle(".xAVSiq_root{background-color:var(--bleed-bg-color);position:relative}.xAVSiq_root[data-spacing=all],.xAVSiq_root[data-spacing=block]{padding-block:var(--mantine-spacing-lg)}.xAVSiq_root[data-active=false][data-spacing=all],.xAVSiq_root[data-active=false][data-spacing=inline]{padding-inline:var(--mantine-spacing-sm)}.xAVSiq_root[data-color=gray]{--bleed-bg-color:var(--mantine-color-gray-0)}.xAVSiq_root[data-color=saving]{--bleed-bg-color:var(--mantine-color-saving-0)}.xAVSiq_root[data-color=primary]{--bleed-bg-color:var(--mantine-color-primary-0)}.xAVSiq_root[data-color=secondary]{--bleed-bg-color:var(--mantine-color-secondary-0)}.xAVSiq_root[data-color=error]{--bleed-bg-color:var(--mantine-color-error-0)}.xAVSiq_root[data-color=success]{--bleed-bg-color:var(--mantine-color-success-0)}.xAVSiq_root[data-color=warning]{--bleed-bg-color:var(--mantine-color-warning-0)}.xAVSiq_root[data-color=info]{--bleed-bg-color:var(--mantine-color-info-0)}.xAVSiq_root[data-color=notice]{--bleed-bg-color:var(--mantine-color-notice-0)}.xAVSiq_root[data-color=body]{--bleed-bg-color:var(--mantine-color-body)}.xAVSiq_root[data-color=gradient]{--bleed-background:linear-gradient(to bottom,var(--mantine-color-gray-0),var(--mantine-color-white))}.xAVSiq_root[data-active=true]:after{content:\"\";background:var(--bleed-background,var(--bleed-bg-color));z-index:-1;pointer-events:none;width:100svw;margin-left:-50svw;margin-right:-50svw;display:block;position:absolute;inset:0 50%}");
var full_bleed_module_default = { root: "xAVSiq_root" };

// src/components/full-bleed/FullBleed.tsx
import { jsx as jsx642 } from "react/jsx-runtime";
var FullBleed = ({
  breakpoint,
  children,
  color = "gray",
  flex = false,
  spacing = "all"
}) => {
  const isMobile = useIsMobile(breakpoint);
  const boxProps = {
    className: full_bleed_module_default.root,
    "data-color": color,
    "data-active": isMobile || typeof breakpoint === "undefined" ? "true" : "false",
    "data-spacing": spacing,
    "data-full-bleed": "true",
    flex: flex ? "1" : ""
  };
  return /* @__PURE__ */ jsx642(Box3, {
    ...boxProps,
    children
  });
};

// src/components/cover/cover.module.css
injectStyle(".gzjGHq_root{background:var(--mantine-color-body)!important}body:has(.gzjGHq_root--no-overflow){overflow:hidden}");
var cover_module_default = { root: "gzjGHq_root", "root--no-overflow": "gzjGHq_root--no-overflow" };

// src/components/cover/Cover.tsx
import { jsx as jsx643 } from "react/jsx-runtime";
var Cover = ({
  fullScreen = false,
  children,
  visible = false,
  allowScroll = false
}) => {
  const { coverPageTarget } = useContext3(CoverProviderContext);
  useSafeScrollTop(visible);
  const props = fullScreen ? { center: true, fixed: true } : { display: "flex", p: "inherit" };
  const overflowClass = allowScroll ? "" : cover_module_default["root--no-overflow"];
  if (!visible) {
    return null;
  }
  return /* @__PURE__ */ jsx643(Portal, {
    target: coverPageTarget?.current ?? undefined,
    children: /* @__PURE__ */ jsx643(MantineOverlay, {
      classNames: {
        root: `${cover_module_default.root} ${overflowClass}`
      },
      ...props,
      children: /* @__PURE__ */ jsx643(FullBleed, {
        color: "body",
        flex: true,
        children
      })
    })
  });
};
// src/components/currency/Currency.tsx
var Currency = ({
  locale = "en-US",
  currency = "USD",
  amount
}) => {
  const formattedNumber = new Intl.NumberFormat(locale, {
    style: "currency",
    currency
  }).format(amount);
  return formattedNumber;
};
// src/components/date-picker/DatePickerInput.tsx
import {
  DatePickerInput as DPI
} from "@mantine/dates";
import"@mantine/dates/styles.css";

// src/components/date-picker/date-picker.module.css
injectStyle(".gdEqKq_wrapper{--input-right-section-width:auto}.gdEqKq_wrapper[data-error] :focus,.gdEqKq_wrapper[data-error] :focus-within,[data-mantine-color-scheme] .gdEqKq_wrapper[data-error]:not([data-variant=unstyled]){--input-bd:var(--mantine-color-error-7);--input-color:var(--mantine-color-error-7);--input-placeholder-color:var(--mantine-color-error-7);--input-section-color:var(--mantine-color-error-7)}.gdEqKq_wrapper svg:where([data-error]){color:var(--mantine-color-error-7)}.gdEqKq_error{color:var(--mantine-color-error-7)}.gdEqKq_root{position:relative}.gdEqKq_label{z-index:1;top:17px;left:var(--mantine-spacing-sm);color:var(--lightningcss-light,var(--mantine-color-gray-5))var(--lightningcss-dark,var(--mantine-color-dark-3));font-weight:100;transition:font-size .15s,background-color .15s,color .15s,top .15s,left .15s;position:absolute}.gdEqKq_root:not(:focus-within) .gdEqKq_label:not([data-floating=true]):has(+[data-with-left-section=true]){left:calc(3.75rem - calc(.125rem*var(--mantine-scale)))}.gdEqKq_label+.gdEqKq_wrapper>.gdEqKq_input::placeholder{color:#0000;transition:color .15s}.gdEqKq_label+.gdEqKq_wrapper>.gdEqKq_input:focus-within::placeholder{color:var(--mantine-color-placeholder)}.gdEqKq_required{opacity:0;transition:opacity .15s}.gdEqKq_label[data-floating=true],.gdEqKq_root:focus-within .gdEqKq_label{background-color:var(--mantine-color-white);font-size:var(--mantine-font-size-xs);color:var(--mantine-color-primary-7);padding:3px;font-weight:500;top:-14px}:is(.gdEqKq_label[data-floating=true],.gdEqKq_root:focus-within .gdEqKq_label):has(+[data-disabled=true]){color:var(--mantine-color-gray-5)}:is(.gdEqKq_label[data-floating=true],.gdEqKq_root:focus-within .gdEqKq_label) .gdEqKq_required{opacity:1}.gdEqKq_root[data-error=true] .gdEqKq_label{color:var(--mantine-color-error-7)}.gdEqKq_input{--input-disabled-bg:transparent}.gdEqKq_input:focus-within{border-width:2px;padding-inline-start:calc(var(--input-padding-inline-start) - 1px);padding-inline-end:calc(var(--input-padding-inline-end) - 1px)}.gdEqKq_description{margin-left:var(--mantine-spacing-xs);color:var(--mantine-color-gray-7);font-size:14px}[data-disabled=true]+.gdEqKq_description{color:var(--mantine-color-gray-5)}");
var date_picker_module_default = { error: "gdEqKq_error", description: "gdEqKq_description", label: "gdEqKq_label", required: "gdEqKq_required", input: "gdEqKq_input", wrapper: "gdEqKq_wrapper", root: "gdEqKq_root" };

// src/components/date-picker/DatePickerInput.tsx
import { jsx as jsx644, jsxs as jsxs18, Fragment as Fragment5 } from "react/jsx-runtime";
var DatePickerInput = ({
  label,
  placeholder,
  value,
  required,
  error,
  disabled,
  onChange,
  maxDate,
  minDate
}) => {
  const hasValue = !!value?.[0] && !!value?.[1];
  const modalProps = {
    size: undefined,
    padding: "md",
    styles: {
      inner: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "var(--mantine-spacing-md)"
      },
      body: {
        display: "flex",
        justifyContent: "center",
        width: "100%",
        overflowX: "auto"
      },
      content: {
        minWidth: "min-content",
        width: "100%",
        overflow: "visible"
      },
      header: {
        padding: 0
      }
    }
  };
  return /* @__PURE__ */ jsx644(DPI, {
    label: hasValue && label,
    placeholder,
    value,
    onChange,
    required,
    type: "range",
    labelProps: {
      "data-floating": hasValue
    },
    radius: "xxs",
    size: "xl",
    classNames: date_picker_module_default,
    descriptionProps: {
      className: disabled ? date_picker_module_default.descriptionDisabled : date_picker_module_default.description
    },
    inputWrapperOrder: error ? ["label", "input", "error"] : ["label", "input", "description"],
    valueFormat: "MMM D, YYYY",
    firstDayOfWeek: 0,
    getDayProps: (_) => ({ weekend: false }),
    maxDate,
    minDate,
    withCellSpacing: false,
    monthLabelFormat: renderMonthLabel,
    dropdownType: "modal",
    modalProps,
    rightSection: !hasValue ? /* @__PURE__ */ jsx644(IconCalendarToday, {
      style: { marginRight: "var(--mantine-spacing-sm)" }
    }) : undefined,
    rightSectionPointerEvents: !hasValue ? "none" : undefined,
    clearable: hasValue
  });
};
function renderMonthLabel(date) {
  return /* @__PURE__ */ jsxs18(Fragment5, {
    children: [
      formatDate(date, { month: "long", year: "numeric" }),
      /* @__PURE__ */ jsx644(IconUnfoldMore, {
        width: "xs"
      })
    ]
  });
}

// src/components/date-picker/YearPickerInput.tsx
import {
  YearPickerInput as YPI
} from "@mantine/dates";
import"@mantine/dates/styles.css";
import { jsx as jsx645 } from "react/jsx-runtime";
var YearPickerInput = ({
  label,
  placeholder,
  value,
  required,
  error,
  disabled,
  onChange,
  maxDate,
  minDate
}) => {
  const hasValue = value?.toString().trim().length !== 0;
  return /* @__PURE__ */ jsx645(YPI, {
    label,
    placeholder,
    value,
    onChange,
    required,
    labelProps: {
      "data-floating": hasValue
    },
    radius: "xxs",
    size: "xl",
    classNames: date_picker_module_default,
    descriptionProps: {
      className: disabled ? date_picker_module_default.descriptionDisabled : date_picker_module_default.description
    },
    inputWrapperOrder: error ? ["label", "input", "error"] : ["label", "input", "description"],
    rightSection: /* @__PURE__ */ jsx645(IconCalendarToday, {
      style: { marginRight: "var(--mantine-spacing-sm)" }
    }),
    rightSectionPointerEvents: "none",
    maxDate,
    minDate
  });
};
// src/components/definition-list/DefinitionList.tsx
import { jsx as jsx646, jsxs as jsxs19 } from "react/jsx-runtime";
var DefinitionList = ({
  compact = true,
  inline,
  items
}) => {
  return /* @__PURE__ */ jsx646(Stack, {
    gap: compact ? "xs" : "sm",
    children: items.map(({ title, body, key }) => {
      if (inline) {
        return /* @__PURE__ */ jsxs19(Flex, {
          gap: "xs",
          "data-testid": key,
          children: [
            /* @__PURE__ */ jsx646(Subtitle1, {
              children: title
            }),
            /* @__PURE__ */ jsx646(Box3, {
              children: body
            })
          ]
        }, key);
      }
      return /* @__PURE__ */ jsxs19(Stack, {
        gap: compact ? "xxxs" : "xxs",
        "data-testid": key,
        children: [
          title ? /* @__PURE__ */ jsx646(Subtitle1, {
            children: title
          }) : null,
          /* @__PURE__ */ jsx646(Box3, {
            children: body
          })
        ]
      }, key);
    })
  });
};
// src/components/delivery/Delivery.tsx
import { jsx as jsx647, jsxs as jsxs20 } from "react/jsx-runtime";
var Delivery = ({
  iconColor = "primary",
  showIcon = true,
  shippingTime
}) => {
  return /* @__PURE__ */ jsxs20(Flex, {
    align: "center",
    gap: "xxs",
    children: [
      showIcon && /* @__PURE__ */ jsx647(IconBox, {
        color: iconColor
      }),
      /* @__PURE__ */ jsx647(Body1, {
        children: shippingTime
      })
    ]
  });
};
// src/components/desktop-shell/DesktopShell.tsx
import { AppShell as AppShell3, Burger, Container as Container2, Flex as Flex2, Stack as Stack2 } from "@mantine/core";

// src/components/desktop-shell/desktop-shell.module.css
injectStyle(".z9crKq_header-grid{grid-template-columns:1fr 4fr 1fr;display:grid}.z9crKq_navbar-container{box-shadow:var(--mantine-shadow-sm);border-radius:var(--mantine-spacing-md)}.z9crKq_navbar{flex-grow:1}");
var desktop_shell_module_default = { "navbar-container": "z9crKq_navbar-container", navbar: "z9crKq_navbar", "header-grid": "z9crKq_header-grid" };

// src/components/desktop-shell/DesktopShell.tsx
import { jsx as jsx648, jsxs as jsxs21 } from "react/jsx-runtime";
var DesktopShell = ({
  header,
  headerMenu,
  navbar,
  footer,
  opened,
  toggleOpen,
  children
}) => {
  const isMobile = useIsMobile("md");
  return /* @__PURE__ */ jsxs21(AppShell3, {
    header: { height: 90 },
    navbar: {
      width: 300,
      breakpoint: "md",
      collapsed: { mobile: !opened }
    },
    padding: "md",
    withBorder: false,
    layout: isMobile ? "default" : "alt",
    children: [
      /* @__PURE__ */ jsx648(AppShell3.Header, {
        children: /* @__PURE__ */ jsxs21(Flex2, {
          p: "md",
          justify: "space-between",
          children: [
            /* @__PURE__ */ jsx648(Flex2, {
              children: /* @__PURE__ */ jsx648(Burger, {
                opened,
                onClick: toggleOpen,
                hiddenFrom: "md",
                size: "md"
              })
            }),
            header,
            headerMenu
          ]
        })
      }),
      /* @__PURE__ */ jsx648(AppShell3.Navbar, {
        p: 0,
        className: desktop_shell_module_default["navbar-container"],
        children: /* @__PURE__ */ jsxs21(Stack2, {
          p: "md",
          justify: "space-between",
          className: desktop_shell_module_default["navbar"],
          children: [
            navbar,
            footer
          ]
        })
      }),
      /* @__PURE__ */ jsx648(AppShell3.Main, {
        children: /* @__PURE__ */ jsx648(Container2, {
          fluid: true,
          children
        })
      })
    ]
  });
};
// src/components/distance/Distance.tsx
import { jsx as jsx649, jsxs as jsxs22 } from "react/jsx-runtime";
var Distance = ({
  distance,
  locale = "en-US",
  units,
  iconColor = "primary",
  showIcon = true
}) => {
  const formattedDistance = new Intl.NumberFormat(locale, {
    style: "decimal",
    maximumFractionDigits: 2
  }).format(distance);
  return /* @__PURE__ */ jsxs22(Flex, {
    align: "center",
    gap: "xxs",
    children: [
      showIcon ? /* @__PURE__ */ jsx649(IconRoute, {
        color: iconColor,
        style: {
          transform: "rotate(90deg)"
        }
      }) : undefined,
      /* @__PURE__ */ jsx649(Body1, {
        children: `${formattedDistance} ${units}`
      })
    ]
  });
};
// src/components/divided-text/DividedText.tsx
import { jsx as jsx650, jsxs as jsxs23 } from "react/jsx-runtime";
var DividedText = ({
  entries,
  divider = exports_constants.unicode.BULLET,
  variant = "body1"
}) => {
  const filteredList = entries.filter((x) => x);
  const TextComponent = variant === "body1" ? Body1 : Body2;
  return /* @__PURE__ */ jsx650(TextComponent, {
    children: filteredList.map((value, index) => {
      return index < filteredList.length - 1 ? /* @__PURE__ */ jsxs23("span", {
        children: [
          value,
          " ",
          divider,
          " "
        ]
      }, `${value}-${index}`) : /* @__PURE__ */ jsx650("span", {
        children: value
      }, `${value}-${index}`);
    })
  });
};
// src/components/drawer/index.ts
import { Drawer as DrawerBase2 } from "@mantine/core";
import { useDrawersStack } from "@mantine/core";

// src/components/drawer/Drawer.tsx
import {
  Drawer as DrawerBase,
  RemoveScroll
} from "@mantine/core";

// src/components/drawer/drawer.module.css
injectStyle(".G50Fna_root{--drawer-close-icon-color:var(--mantine-color-gray-background);--drawer-close-icon-hover-color:var(--mantine-color-gray-background-hover)}.G50Fna_root[data-position=right]{--drawer-close-icon-color:var(--mantine-color-primary-background);--drawer-close-icon-hover-color:var(--mantine-color-primary-background-hover)}.G50Fna_inner .G50Fna_overlay{max-width:100svw}[data-compact] .G50Fna_inner{max-width:35svw;right:0}[data-compact] .G50Fna_overlay{background:0 0}.G50Fna_title{color:var(--mantine-color-gray-9);font-size:var(--mantine-font-size-xl);font-weight:600}.G50Fna_close{--cb-size:2.5rem;--cb-icon-size:1.5rem;color:var(--drawer-close-icon-color)}.G50Fna_close:hover{background-color:var(--drawer-close-icon-hover-color)}.G50Fna_content>:only-child>.G50Fna_body{padding:0}.G50Fna_header{padding-inline:var(--mantine-spacing-sm)}");
var drawer_module_default = { overlay: "G50Fna_overlay", root: "G50Fna_root", inner: "G50Fna_inner", header: "G50Fna_header", body: "G50Fna_body", close: "G50Fna_close", content: "G50Fna_content", title: "G50Fna_title" };

// src/components/drawer/Drawer.tsx
import { jsx as jsx651, jsxs as jsxs24 } from "react/jsx-runtime";
var Drawer = ({
  header,
  onClose,
  opened,
  children,
  height,
  position = "right",
  fullWidth = false,
  size = "md",
  compact = false
}) => {
  const rootProps = {
    onClose,
    opened,
    classNames: drawer_module_default,
    position,
    size
  };
  if (fullWidth) {
    rootProps.className = RemoveScroll.classNames.fullWidth;
  }
  return /* @__PURE__ */ jsxs24(DrawerBase.Root, {
    "data-compact": compact ? "true" : undefined,
    ...rootProps,
    "data-position": position,
    children: [
      /* @__PURE__ */ jsx651(DrawerBase.Overlay, {}),
      /* @__PURE__ */ jsx651(DrawerBase.Content, {
        h: height,
        mah: position === "bottom" || position === "top" ? "calc(100svh - 4rem)" : "100svh",
        children: /* @__PURE__ */ jsxs24(Stack, {
          gap: 0,
          h: "100%",
          children: [
            /* @__PURE__ */ jsxs24(DrawerBase.Header, {
              children: [
                header,
                /* @__PURE__ */ jsx651(DrawerBase.CloseButton, {})
              ]
            }),
            /* @__PURE__ */ jsx651(DrawerBase.Body, {
              flex: 1,
              style: { overflow: "auto" },
              children
            })
          ]
        })
      })
    ]
  });
};

// src/components/drawer/index.ts
var DrawerStack = DrawerBase2.Stack;
// src/components/indicator/DotIndicator.tsx
import { Indicator as MantineIndicator } from "@mantine/core";
import { jsx as jsx652 } from "react/jsx-runtime";
var DotIndicator = ({
  children,
  color = "primary",
  offset = 0,
  position = "top-end",
  disabled = false
}) => {
  const theme2 = useMantineTheme();
  const colorProps = theme2.other.getStyleForColor(color);
  return /* @__PURE__ */ jsx652(MantineIndicator, {
    disabled,
    color: colorProps.bg,
    offset,
    position,
    children
  });
};

// src/components/indicator/Indicator.tsx
import {
  Indicator as MantineIndicator2
} from "@mantine/core";

// src/components/indicator/indicator.module.css
injectStyle(".S1hnpa_root{--indicator-size:1.25rem}.S1hnpa_indicator{line-height:var(--indicator-size)}.S1hnpa_indicator:where([data-with-label]){padding-inline:var(--mantine-spacing-xxs)}");
var indicator_module_default = { indicator: "S1hnpa_indicator", root: "S1hnpa_root" };

// src/components/indicator/Indicator.tsx
import { jsx as jsx653 } from "react/jsx-runtime";
var Indicator = ({
  children,
  label,
  color = "primary",
  offset = 0,
  position = "top-end",
  disabled = false,
  light = false
}) => {
  return /* @__PURE__ */ jsx653(MantineIndicator2, {
    disabled,
    color: light ? `var(--mantine-color-${color}-0)` : `var(--mantine-color-${color}-7)`,
    label,
    offset,
    position,
    classNames: indicator_module_default,
    __vars: {
      "--indicator-text-color": light ? `var(--mantine-color-${color}-7)` : "var(--mantine-color-white)"
    },
    children
  });
};

// src/components/filter-selection/FilterSelection.tsx
import { jsx as jsx654, jsxs as jsxs25, Fragment as Fragment6 } from "react/jsx-runtime";
var FilterSelection = ({
  onEndIconClick,
  onInputClick,
  StartIcon,
  EndIcon,
  distance,
  input,
  endIconHasNotification = false,
  inputTestId,
  endTestId
}) => {
  const CardComponent = StartIcon ? OutlinedCard : ElevatedCard;
  const inputSection = StartIcon ? /* @__PURE__ */ jsx654(TextButton, {
    LeftIcon: StartIcon,
    onClick: onInputClick,
    "data-testid": inputTestId,
    children: /* @__PURE__ */ jsx654(Subtitle2, {
      color: "primary",
      children: input
    })
  }) : /* @__PURE__ */ jsx654(Subtitle2, {
    children: input
  });
  const endSection = EndIcon ? /* @__PURE__ */ jsx654(DotIndicator, {
    color: "error",
    disabled: !endIconHasNotification,
    children: /* @__PURE__ */ jsx654(EndIcon, {
      color: "primary"
    })
  }) : distance ? /* @__PURE__ */ jsx654(Subtitle2, {
    color: "gray",
    children: distance
  }) : undefined;
  return /* @__PURE__ */ jsx654(CardComponent, {
    children: /* @__PURE__ */ jsxs25(Flex, {
      children: [
        /* @__PURE__ */ jsx654(Flex, {
          align: "center",
          flex: 1,
          style: {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
          },
          gap: "xxxs",
          mr: "xxxs",
          role: "button",
          children: inputSection
        }),
        endSection ? /* @__PURE__ */ jsxs25(Fragment6, {
          children: [
            /* @__PURE__ */ jsx654(VerticalDivider, {
              variant: "middle"
            }),
            /* @__PURE__ */ jsx654(Flex, {
              "data-testid": endTestId,
              onClick: onEndIconClick,
              px: "xxs",
              pt: "xxs",
              pb: "xxxs",
              children: endSection
            })
          ]
        }) : undefined
      ]
    })
  });
};
// src/components/highlight/Highlight.tsx
import {
  Highlight as MantineHighlight
} from "@mantine/core";
import { jsx as jsx655 } from "react/jsx-runtime";
var Highlight = ({ highlight, children }) => {
  return /* @__PURE__ */ jsx655(MantineHighlight, {
    highlightStyles: {
      fontWeight: 600,
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "var(--mantine-color-primary-7)"
    },
    highlight,
    children
  });
};
// src/components/hours-of-operation/HoursOfOperation.tsx
import { useDisclosure as useDisclosure3 } from "@mantine/hooks";
import { useTranslation as useTranslation94 } from "react-i18next";

// src/components/modal/index.ts
import { Modal as ModalBase2 } from "@mantine/core";
import { useModalsStack } from "@mantine/core";

// src/components/modal/Modal.tsx
import {
  Flex as Flex3,
  Modal as ModalBase
} from "@mantine/core";

// src/components/modal/modal.module.css
injectStyle(".Iey0BG_root{max-width:600px}.Iey0BG_inner{align-items:center}.Iey0BG_title{color:var(--mantine-color-gray-9);font-size:large;font-weight:600}.Iey0BG_header{padding:var(--mb-padding,var(--mantine-spacing-sm))}.Iey0BG_body{color:var(--mantine-color-gray-7)}.Iey0BG_close{--cb-size:2.5rem;--cb-icon-size:1.5rem;align-self:start}");
var modal_module_default = { root: "Iey0BG_root", close: "Iey0BG_close", body: "Iey0BG_body", inner: "Iey0BG_inner", title: "Iey0BG_title", header: "Iey0BG_header" };

// src/components/modal/Modal.tsx
import { jsx as jsx656, jsxs as jsxs26 } from "react/jsx-runtime";
var Modal = ({
  title,
  titleColor,
  TitleIcon,
  children,
  opened,
  onClose,
  size,
  height = "auto"
}) => {
  const theme2 = useMantineTheme();
  const isMobile = useMediaQuery(`(max-width: ${theme2.breakpoints.sm})`);
  const header = title ? /* @__PURE__ */ jsxs26(Flex3, {
    gap: "xxs",
    align: "center",
    children: [
      TitleIcon,
      /* @__PURE__ */ jsx656(Subtitle1, {
        color: titleColor,
        inline: true,
        children: title
      })
    ]
  }) : null;
  if (isMobile) {
    return /* @__PURE__ */ jsx656(Drawer, {
      fullWidth: true,
      header,
      opened,
      onClose,
      height: "auto",
      position: "bottom",
      children: /* @__PURE__ */ jsx656(Box3, {
        pt: title ? 0 : "md",
        pr: "md",
        pb: "md",
        pl: "md",
        children
      })
    });
  }
  return /* @__PURE__ */ jsx656(ModalBase, {
    size,
    title: header,
    opened,
    onClose,
    classNames: modal_module_default,
    transitionProps: { transition: "pop" },
    scrollAreaComponent: ScrollArea.Autosize,
    __vars: {
      "--modal-content-height": `${height}`
    },
    children
  });
};

// src/components/modal/index.ts
var ModalStack = ModalBase2.Stack;

// src/components/hours-of-operation/HoursByDay.tsx
import { Stack as Stack3 } from "@mantine/core";
import { useTranslation as useTranslation93 } from "react-i18next";

// src/components/hours-of-operation/days.ts
var days = [
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday"
];

// src/components/hours-of-operation/HoursByDay.tsx
import { jsx as jsx657 } from "react/jsx-runtime";
var HoursByDay = ({ hours, showIcon }) => {
  const { t } = useTranslation93("pds");
  const dayNames = {
    sunday: t("hoursOfOperation.sunday"),
    monday: t("hoursOfOperation.monday"),
    tuesday: t("hoursOfOperation.tuesday"),
    wednesday: t("hoursOfOperation.wednesday"),
    thursday: t("hoursOfOperation.thursday"),
    friday: t("hoursOfOperation.friday"),
    saturday: t("hoursOfOperation.saturday")
  };
  return /* @__PURE__ */ jsx657(Stack3, {
    children: days.map((day) => /* @__PURE__ */ jsx657(HoursOfOperation, {
      actionable: false,
      day: dayNames[day] ?? day,
      times: hours[day],
      showIcon
    }, `hours-of-operation-${day}`))
  });
};

// src/components/hours-of-operation/HoursOfOperation.tsx
import { jsx as jsx658, jsxs as jsxs27 } from "react/jsx-runtime";
var HoursOfOperation = ({
  day,
  times,
  showIcon = true,
  actionable = true,
  weeklyHours,
  inline = false
}) => {
  const { t } = useTranslation94("pds");
  const [opened, { open, close }] = useDisclosure3(false);
  const isValidTime = !!times[0] && !!times[1];
  const DayComponent = inline ? Body1 : Subtitle2;
  return /* @__PURE__ */ jsxs27(BaseCard, {
    Icon: showIcon ? IconSchedule : undefined,
    iconColor: actionable ? "primary" : "secondary",
    p: 0,
    style: { boxShadow: "none" },
    children: [
      /* @__PURE__ */ jsxs27(Flex, {
        style: { cursor: actionable ? "pointer" : undefined },
        gap: "xxxs",
        onClick: open,
        direction: inline ? "row" : "column",
        children: [
          day ? /* @__PURE__ */ jsx658(DayComponent, {
            inline,
            children: day
          }) : undefined,
          isValidTime ? /* @__PURE__ */ jsx658(Body1, {
            inline,
            children: t("hoursOfOperation.times", {
              startTime: formatTime(times[0]),
              endTime: formatTime(times[1])
            })
          }) : /* @__PURE__ */ jsx658(Body1, {
            inline,
            children: t("hoursOfOperation.closed")
          })
        ]
      }),
      weeklyHours ? /* @__PURE__ */ jsx658(Modal, {
        title: t("hoursOfOperation.weeklyHoursModal"),
        onClose: close,
        opened,
        children: /* @__PURE__ */ jsx658(HoursByDay, {
          hours: weeklyHours
        })
      }) : null
    ]
  });
};
// src/components/inputs/autocomplete/Autocomplete.tsx
import {
  Autocomplete as AutocompleteBase
} from "@mantine/core";
import { useCallback as useCallback12, useMemo as useMemo5, useRef as useRef9, useState as useState9 } from "react";

// src/components/inputs/form-field-error/FormFieldError.tsx
import { Box as Box5 } from "@mantine/core";

// src/components/inputs/form-field-error/form-field-error.module.css
injectStyle(".WZlcBW_root{justify-content:center;align-items:center;gap:var(--mantine-spacing-xxs);font-size:var(--mantine-font-size-sm);color:var(--mantine-color-error-7);margin-top:2px;display:inline-flex}");
var form_field_error_module_default = { root: "WZlcBW_root" };

// src/components/inputs/form-field-error/FormFieldError.tsx
import { jsx as jsx659, jsxs as jsxs28 } from "react/jsx-runtime";
var FormFieldError = ({ errText }) => {
  return /* @__PURE__ */ jsxs28(Box5, {
    component: "span",
    className: form_field_error_module_default.root,
    children: [
      /* @__PURE__ */ jsx659(IconError, {
        color: "error",
        height: rem("20px"),
        width: rem("20px")
      }),
      errText
    ]
  });
};

// src/components/inputs/inputs.module.css
injectStyle(".NudwIW_wrapper{--input-left-section-width:auto;--input-right-section-width:auto}.NudwIW_wrapper[data-error] :focus,.NudwIW_wrapper[data-error] :focus-within,[data-mantine-color-scheme] .NudwIW_wrapper[data-error]:not([data-variant=unstyled]){--input-bd:var(--mantine-color-error-7);--input-color:var(--mantine-color-error-7);--input-placeholder-color:var(--mantine-color-error-7);--input-section-color:var(--mantine-color-error-7)}.NudwIW_wrapper svg:where([data-error]){color:var(--mantine-color-error-7)}.NudwIW_error{color:var(--mantine-color-error-7)}.NudwIW_dropdown,.NudwIW_option{border-radius:var(--mantine-radius-xxs)}.NudwIW_dropdown{box-shadow:var(--mantine-shadow-sm);border-width:0}.NudwIW_root{position:relative}.NudwIW_label{z-index:1;top:17px;left:var(--mantine-spacing-sm);color:var(--lightningcss-light,var(--mantine-color-gray-5))var(--lightningcss-dark,var(--mantine-color-dark-3));font-weight:100;transition:font-size .15s,background-color .15s,color .15s,top .15s,left .15s;position:absolute}.NudwIW_root:not(:focus-within) .NudwIW_label:not([data-floating=true]):has(+[data-with-left-section=true]){left:calc(3.75rem - calc(.125rem*var(--mantine-scale)))}.NudwIW_label+.NudwIW_wrapper>.NudwIW_input::placeholder{color:#0000;transition:color .15s}.NudwIW_label+.NudwIW_wrapper>.NudwIW_input:focus-within::placeholder{color:var(--mantine-color-placeholder)}.NudwIW_passwordInput{width:95%}.NudwIW_required{opacity:0;transition:opacity .15s}.NudwIW_label[data-floating=true],.NudwIW_root:focus-within .NudwIW_label{background-color:var(--mantine-color-white);font-size:var(--mantine-font-size-xs);color:var(--mantine-color-primary-7);padding:3px;font-weight:500;top:-14px}:is(.NudwIW_label[data-floating=true],.NudwIW_root:focus-within .NudwIW_label):has(+[data-disabled=true]){color:var(--mantine-color-gray-5)}:is(.NudwIW_label[data-floating=true],.NudwIW_root:focus-within .NudwIW_label) .NudwIW_required{opacity:1}.NudwIW_root[data-error=true] .NudwIW_label{color:var(--mantine-color-error-7)}.NudwIW_input{--input-disabled-bg:transparent}.NudwIW_input:focus-within{border-width:2px;padding-inline-start:calc(var(--input-padding-inline-start) - 1px);padding-inline-end:calc(var(--input-padding-inline-end) - 1px)}.NudwIW_description{margin-left:var(--mantine-spacing-xs);color:var(--mantine-color-gray-7);font-size:14px}[data-disabled=true]+.NudwIW_description{color:var(--mantine-color-gray-5)}");
var inputs_module_default = { error: "NudwIW_error", root: "NudwIW_root", passwordInput: "NudwIW_passwordInput", option: "NudwIW_option", wrapper: "NudwIW_wrapper", label: "NudwIW_label", required: "NudwIW_required", description: "NudwIW_description", dropdown: "NudwIW_dropdown", input: "NudwIW_input" };

// src/components/inputs/autocomplete/Autocomplete.tsx
import { jsx as jsx660, jsxs as jsxs29 } from "react/jsx-runtime";
var Autocomplete = ({
  data,
  defaultValue,
  description,
  disabled,
  error,
  filter,
  label,
  onBlur,
  onChange,
  onFocus,
  onKeyUp,
  onOptionSubmit,
  optionIcon,
  placeholder,
  value,
  role = "searchbox"
}) => {
  const inputRef = useRef9(null);
  const [internalValue, setInternalValue] = useState9(value ?? defaultValue ?? "");
  const hasValue = (value ?? internalValue).length !== 0;
  const handleChange = useCallback12((changedValue) => {
    setInternalValue(changedValue);
    onChange?.(changedValue);
  }, [onChange]);
  const renderOption = useCallback12((input) => {
    return /* @__PURE__ */ jsxs29(Group, {
      gap: "sm",
      wrap: "nowrap",
      children: [
        input.option.value.includes("Current location") ? /* @__PURE__ */ jsx660(IconMyLocation, {
          color: "primary"
        }) : optionIcon,
        /* @__PURE__ */ jsx660(Body1, {
          children: input.option.value
        })
      ]
    }, input.option.value);
  }, [optionIcon]);
  const clear = useCallback12(() => {
    handleChange("");
    inputRef.current?.focus();
  }, [handleChange]);
  const resetButton = hasValue ? /* @__PURE__ */ jsx660(IconButton, {
    Icon: IconClose,
    size: "sm",
    onClick: clear,
    color: "gray"
  }) : null;
  const err = useMemo5(() => {
    if (error && typeof error === "boolean") {
      return true;
    }
    if (error && typeof error === "string") {
      return /* @__PURE__ */ jsx660(FormFieldError, {
        errText: error
      });
    }
    return null;
  }, [error]);
  return /* @__PURE__ */ jsx660(AutocompleteBase, {
    ref: inputRef,
    classNames: inputs_module_default,
    onBlur,
    onChange: handleChange,
    onFocus,
    onKeyUp,
    rightSection: resetButton,
    description,
    label,
    data,
    filter,
    disabled,
    placeholder,
    onOptionSubmit,
    radius: "xxs",
    size: "xl",
    renderOption,
    rightSectionWidth: "3.25rem",
    value: value ?? internalValue,
    labelProps: {
      "data-floating": hasValue,
      className: inputs_module_default.autocompletelabel
    },
    descriptionProps: {
      className: disabled ? inputs_module_default.descriptionDisabled : inputs_module_default.description
    },
    error: err,
    inputWrapperOrder: error ? ["label", "input", "error"] : ["label", "input", "description"],
    role
  });
};

// src/components/inputs/password-input/PasswordInput.tsx
import {
  Flex as Flex4,
  PasswordInput as PasswordInputBase
} from "@mantine/core";
import { useDisclosure as useDisclosure4 } from "@mantine/hooks";
import { useCallback as useCallback13, useMemo as useMemo6, useRef as useRef10 } from "react";
import { jsx as jsx661, jsxs as jsxs30, Fragment as Fragment7 } from "react/jsx-runtime";
var CustomRightSection = ({ reveal, toggle, clear, hasValue }) => /* @__PURE__ */ jsxs30(Flex4, {
  direction: "row",
  gap: "xs",
  mr: "xs",
  children: [
    hasValue ? /* @__PURE__ */ jsxs30(Fragment7, {
      children: [
        /* @__PURE__ */ jsx661(IconButton, {
          color: "gray",
          withStyles: false,
          Icon: IconClose,
          onClick: clear
        }),
        /* @__PURE__ */ jsx661(VerticalDivider, {})
      ]
    }) : null,
    /* @__PURE__ */ jsx661(IconButton, {
      color: "gray",
      withStyles: false,
      Icon: reveal ? IconVisibility : IconVisibilityOff,
      onClick: toggle
    })
  ]
});
var PasswordInput = ({
  defaultValue,
  description,
  disabled,
  error,
  label,
  leftSection,
  name,
  onBlur,
  onChange,
  onClick,
  onFocus,
  onKeyUp,
  placeholder,
  value
}) => {
  const [visible, { toggle }] = useDisclosure4(false);
  const inputRef = useRef10(null);
  const handleClear = useCallback13(() => onChange?.(""), [onChange]);
  const handleChange = useCallback13((e) => onChange?.(e.target.value), [onChange]);
  const hasValue = value?.toString().trim().length !== 0;
  const err = useMemo6(() => {
    if (error && typeof error === "boolean") {
      return true;
    }
    if (error && typeof error === "string") {
      return /* @__PURE__ */ jsx661(FormFieldError, {
        errText: error
      });
    }
    return null;
  }, [error]);
  return /* @__PURE__ */ jsx661(PasswordInputBase, {
    required: true,
    ref: inputRef,
    classNames: { ...inputs_module_default, innerInput: inputs_module_default.passwordInput },
    autoComplete: "off",
    radius: "xxs",
    onClick,
    value: value ?? defaultValue,
    description,
    name,
    label,
    disabled,
    leftSection,
    onBlur,
    onChange: handleChange,
    onFocus,
    onKeyUp,
    placeholder,
    size: "xl",
    visible,
    labelProps: { "data-floating": hasValue },
    inputSize: "sm",
    rightSection: /* @__PURE__ */ jsx661(CustomRightSection, {
      reveal: visible,
      toggle,
      clear: handleClear,
      hasValue
    }),
    descriptionProps: {
      className: disabled ? inputs_module_default.descriptionDisabled : inputs_module_default.description
    },
    error: err,
    inputWrapperOrder: error ? ["label", "input", "error"] : ["label", "input", "description"]
  });
};

// src/components/inputs/text-input/TextInput.tsx
import {
  TextInput as TextInputBase
} from "@mantine/core";
import {
  useCallback as useCallback14,
  useLayoutEffect as useLayoutEffect2,
  useMemo as useMemo7,
  useRef as useRef11
} from "react";
import { IMaskInput } from "react-imask";
import { jsx as jsx662 } from "react/jsx-runtime";
var TextInput = ({
  autoFocus = false,
  description,
  disabled,
  error,
  flex,
  inputMode,
  label,
  leftSection,
  mask,
  name,
  onBlur,
  onChange,
  onClick,
  onFocus,
  onKeyUp,
  onPaste,
  placeholder,
  required,
  rightSection,
  role = "textbox",
  type,
  value,
  size = "xl",
  readOnly
}) => {
  const ref = useRef11(null);
  const hasValue = value?.toString().trim().length !== 0;
  useLayoutEffect2(() => {
    if (autoFocus && ref.current) {
      ref.current.focus();
    }
  }, [autoFocus]);
  const innerOnBlur = useCallback14((event) => {
    if (ref.current && ref.current.type === "number" && !ref.current?.validity.valid) {
      ref.current.value = value?.toString().trim() ?? "";
    }
    onBlur?.(event);
  }, [onBlur, value]);
  const err = useMemo7(() => {
    if (error && typeof error === "boolean") {
      return true;
    }
    if (error && typeof error === "string") {
      return /* @__PURE__ */ jsx662(FormFieldError, {
        errText: error
      });
    }
    return null;
  }, [error]);
  const maskProps = mask ? {
    component: IMaskInput,
    mask
  } : {};
  return /* @__PURE__ */ jsx662(TextInputBase, {
    ref,
    readOnly,
    classNames: inputs_module_default,
    description,
    value,
    label,
    disabled,
    inputMode,
    required,
    leftSection,
    rightSection,
    placeholder,
    name,
    onBlur: innerOnBlur,
    onChange,
    onClick,
    onFocus,
    onKeyUp,
    type,
    autoComplete: "off",
    radius: "xxs",
    size,
    flex,
    labelProps: {
      "data-floating": hasValue
    },
    error: err,
    descriptionProps: {
      className: disabled ? inputs_module_default.descriptionDisabled : inputs_module_default.description
    },
    inputWrapperOrder: error ? ["label", "input", "error"] : ["label", "input", "description"],
    onPaste,
    role,
    ...maskProps
  });
};

// src/components/inputs/phone-number/PhoneNumberInput.tsx
import { jsx as jsx663 } from "react/jsx-runtime";
var phoneNumberSchema = z.string().refine((val) => /^\d{10}$/.test(val)).transform((val) => `(${val.slice(0, 3)}) ${val.slice(3, 6)}-${val.slice(6)}`);
var PHONE_PLACEHOLDER = "(000) 000-0000";
var PhoneNumberInput = ({
  placeholder,
  onBlur,
  onChange,
  onPaste,
  value,
  ...restProps
}) => {
  const handleBlur = (e) => {
    if (e.target.value !== value) {
      onChange?.(e);
    }
    onBlur?.(e);
  };
  const handlePaste = (e) => {
    const clipboardData = e.clipboardData.getData("text/plain");
    const parsedData = phoneNumberSchema.safeParse(clipboardData);
    if (parsedData.success) {
      e.clipboardData.setData("text/plain", parsedData.data);
    }
    onPaste?.(e);
  };
  return /* @__PURE__ */ jsx663(TextInput, {
    ...restProps,
    placeholder: placeholder || PHONE_PLACEHOLDER,
    mask: PHONE_PLACEHOLDER,
    onPaste: handlePaste,
    onBlur: handleBlur,
    onChange,
    value
  });
};

// src/components/inputs/search-input/SearchInput.tsx
import { Flex as Flex5 } from "@mantine/core";
import { jsx as jsx664, jsxs as jsxs31, Fragment as Fragment8 } from "react/jsx-runtime";
var SearchInput = ({
  autoFocus,
  clear,
  description,
  disabled,
  error,
  inputMode,
  label,
  name,
  onBlur,
  onChange,
  onClick,
  onFocus,
  onKeyUp,
  onPaste,
  placeholder,
  required,
  type,
  value
}) => {
  const inputProps = {
    autoFocus,
    description,
    disabled,
    error,
    inputMode,
    label,
    name,
    onBlur,
    onChange,
    onClick,
    onFocus,
    onKeyUp,
    onPaste,
    placeholder,
    required,
    type,
    value
  };
  return /* @__PURE__ */ jsx664(TextInput, {
    ...inputProps,
    role: "searchbox",
    rightSection: /* @__PURE__ */ jsxs31(Flex5, {
      direction: "row",
      gap: "xs",
      mr: "xs",
      children: [
        value ? /* @__PURE__ */ jsxs31(Fragment8, {
          children: [
            /* @__PURE__ */ jsx664(IconButton, {
              color: "gray",
              withStyles: false,
              Icon: IconClose,
              onClick: clear
            }),
            /* @__PURE__ */ jsx664(VerticalDivider, {})
          ]
        }) : null,
        /* @__PURE__ */ jsx664(Flex5, {
          align: "center",
          children: /* @__PURE__ */ jsx664(IconSearch, {})
        })
      ]
    })
  });
};

// src/components/inputs/text-area/TextArea.tsx
import {
  Textarea as MantineTextarea
} from "@mantine/core";
import { forwardRef as forwardRef5 } from "react";
import { jsx as jsx665 } from "react/jsx-runtime";
var TextArea = forwardRef5(({
  value,
  onChange,
  placeholder,
  autoFocus,
  variant,
  size = "lg",
  onFocus,
  onBlur
}, ref) => {
  return /* @__PURE__ */ jsx665(MantineTextarea, {
    radius: "xxs",
    size,
    value,
    onChange,
    placeholder,
    autoFocus,
    autosize: true,
    ref,
    variant,
    onFocus,
    onBlur
  });
});
TextArea.displayName = "TextArea";
// src/components/list/List.tsx
import {
  List as MantineList
} from "@mantine/core";
import { jsx as jsx666 } from "react/jsx-runtime";
var ListItem = MantineList.Item;
var List = ({
  children,
  compact = false,
  icon,
  listStyleType,
  type = "unordered"
}) => {
  return /* @__PURE__ */ jsx666(MantineList, {
    center: !!icon,
    icon,
    listStyleType,
    spacing: compact ? "xs" : "sm",
    type,
    children
  });
};
// src/components/loader/Loader.tsx
import { Loader as LoaderBase } from "@mantine/core";

// src/components/loader/loader.module.css
injectStyle('@keyframes _2o6kdG_loader-animation{0%{transform:rotate(0)}to{transform:rotate(360deg)}}._2o6kdG_root{--loader-size-sm:calc(2.5rem*var(--mantine-scale));--loader-size-md:calc(3rem*var(--mantine-scale));--loader-size-lg:calc(3.5rem*var(--mantine-scale))}._2o6kdG_root:before{content:"";width:var(--loader-size);height:var(--loader-size);border-width:calc(var(--loader-size)/8);border-style:solid;border-color:transparent transparent var(--loader-color)var(--loader-color);border-radius:10000px;animation:1s -.2s infinite _2o6kdG_loader-animation;display:block;position:absolute}._2o6kdG_root:after{border-color:var(--loader-color)var(--loader-color)transparent transparent;animation:1s infinite _2o6kdG_loader-animation}');
var loader_module_default = { root: "_2o6kdG_root", "loader-animation": "_2o6kdG_loader-animation" };

// src/components/loader/Loader.tsx
import { jsx as jsx667 } from "react/jsx-runtime";
var Loader = ({ size, color }) => {
  return /* @__PURE__ */ jsx667(LoaderBase, {
    color,
    size,
    type: "oval",
    classNames: loader_module_default
  });
};
// src/components/loading-placeholder/LoadingPlaceHolder.tsx
import { Stack as Stack4 } from "@mantine/core";

// src/components/skeleton/Skeleton.tsx
import { Skeleton as MantineSkeleton } from "@mantine/core";

// src/components/skeleton/skeleton.module.css
injectStyle("._54OwoG_root{--skeleton-radius:var(--mantine-spacing-xxs)}._54OwoG_root:where([data-visible]):after{background-color:var(--mantine-color-gray-2)}");
var skeleton_module_default = { root: "_54OwoG_root" };

// src/components/skeleton/Skeleton.tsx
import { jsx as jsx668 } from "react/jsx-runtime";
var Skeleton = ({
  circle = false,
  height,
  width,
  children,
  visible = true
}) => {
  return /* @__PURE__ */ jsx668(MantineSkeleton, {
    "data-testid": "skeleton",
    visible,
    circle,
    height,
    width,
    classNames: skeleton_module_default,
    children
  });
};

// src/components/skeleton/variants/CircularSkeleton.tsx
import { jsx as jsx669 } from "react/jsx-runtime";
var CircularSkeleton = ({
  height,
  visible
}) => {
  return /* @__PURE__ */ jsx669(Skeleton, {
    circle: true,
    height,
    visible
  });
};

// src/components/skeleton/variants/RoundedSkeleton.tsx
import { jsx as jsx670 } from "react/jsx-runtime";
var RoundedSkeleton = ({
  height,
  width,
  visible
}) => {
  return /* @__PURE__ */ jsx670(Skeleton, {
    width,
    height,
    visible
  });
};

// src/components/skeleton/variants/TextSkeleton.tsx
import { jsx as jsx671 } from "react/jsx-runtime";
var TextSkeleton = ({
  children,
  visible
}) => {
  return /* @__PURE__ */ jsx671(Skeleton, {
    visible,
    children
  });
};

// src/components/loading-placeholder/LoadingPlaceHolder.tsx
import { jsx as jsx672 } from "react/jsx-runtime";
var LoadingPlaceholder = ({
  rows,
  rowHeight = 18,
  rowWidth = 200,
  gap = "xs"
}) => {
  if (!rows) {
    return null;
  }
  const skeletons = Array.from({ length: rows }, (_item, index) => /* @__PURE__ */ jsx672(RoundedSkeleton, {
    height: rowHeight,
    width: rowWidth
  }, `skel-${index}`));
  return /* @__PURE__ */ jsx672(Stack4, {
    align: "stretch",
    gap,
    children: skeletons
  });
};
// src/components/nav-link/NavLink.tsx
import {
  NavLink as NavLinkBase
} from "@mantine/core";

// src/components/nav-link/navlink.module.css
injectStyle(".ZxohYW_root{border-radius:var(--mantine-radius-xs);padding:var(--mantine-spacing-xs)var(--mantine-spacing-sm);color:var(--nl-text-hover-color)}.ZxohYW_root:hover{background-color:var(--nl-hover)}.ZxohYW_root[data-sidebar=true]{border-radius:0}.ZxohYW_root[data-variant=subtle]:not([data-sidebar=true]){--nl-hover:transparent!important}.ZxohYW_root[data-variant=subtle]:not([data-outline=true]):not([data-sidebar=true]){padding:0}.ZxohYW_root[data-outline=true]{border:1px solid}.ZxohYW_root:hover{color:var(--nl-text-hover-color)}.ZxohYW_body{line-height:normal}.ZxohYW_label{font-size:var(--mantine-font-size-lg);font-weight:600}[data-sidebar=true] .ZxohYW_label{font-weight:400}.ZxohYW_section:where([data-position=left]){margin-inline-end:var(--mantine-spacing-xxs)}.ZxohYW_section:where([data-position=right]){margin-inline-start:var(--mantine-spacing-xxs)}");
var navlink_module_default = { root: "ZxohYW_root", label: "ZxohYW_label", section: "ZxohYW_section", body: "ZxohYW_body" };

// src/components/nav-link/NavLink.tsx
import { jsx as jsx673 } from "react/jsx-runtime";
var NavLink = ({
  active,
  disabled,
  label,
  Icon: Icon2,
  onClick,
  color = "primary",
  variant = "light",
  withChevron = true,
  "data-testid": testId
}) => {
  const linkVariant = variant === "outline" ? "subtle" : variant;
  return /* @__PURE__ */ jsx673(NavLinkBase, {
    active,
    disabled,
    label,
    leftSection: Icon2 && /* @__PURE__ */ jsx673(Icon2, {
      color
    }),
    rightSection: withChevron && /* @__PURE__ */ jsx673(IconChevronRight, {
      color
    }),
    onClick,
    classNames: navlink_module_default,
    variant: linkVariant,
    color,
    "data-testid": testId,
    "data-outline": variant === "outline",
    __vars: {
      "--nl-text-hover-color": `var(--mantine-color-${color}-9)`
    },
    role: "link"
  });
};

// src/components/nav-link/SideNavLink.tsx
import {
  NavLink as NavLinkBase2
} from "@mantine/core";
import { jsx as jsx674 } from "react/jsx-runtime";
var SideNavLink = ({
  active,
  disabled,
  label,
  Icon: Icon2,
  onClick,
  color = "primary",
  style
}) => {
  return /* @__PURE__ */ jsx674(NavLinkBase2, {
    active,
    disabled,
    label,
    leftSection: Icon2 && /* @__PURE__ */ jsx674(Icon2, {
      color
    }),
    onClick,
    classNames: navlink_module_default,
    variant: "subtle",
    color,
    "data-sidebar": true,
    role: "menuitem",
    __vars: {
      "--nl-color": "var(--mantine-color-text)"
    },
    style
  });
};
// src/components/notification/Notification.tsx
import {
  Notification as NotificationBase
} from "@mantine/core";
import { useTranslation as useTranslation95 } from "react-i18next";
import"@mantine/notifications/styles.css";
import { jsx as jsx675 } from "react/jsx-runtime";
var Notification = ({
  color,
  icon,
  loading,
  onClose,
  withCloseButton = true,
  children
}) => {
  const { t } = useTranslation95("pds");
  let body = children;
  if (typeof children === "string") {
    body = /* @__PURE__ */ jsx675(Body1, {
      color: "white",
      children
    });
  }
  return /* @__PURE__ */ jsx675(NotificationBase, {
    radius: "xxs",
    icon,
    loading,
    withCloseButton,
    onClose,
    closeButtonProps: {
      "aria-label": t("notification.hideNotification")
    },
    classNames: notification_module_default,
    __vars: {
      "--bkg-color": `var(--mantine-color-${color ?? "gray"}-9)`,
      "--hover-bkg-color": `var(--mantine-color-${color ?? "gray"}-7)`
    },
    children: body
  });
};
// src/components/notification/Notifications.tsx
import {
  notifications as notificationsBase
} from "@mantine/notifications";
import { jsx as jsx676 } from "react/jsx-runtime";
var originalShow = notificationsBase.show;
var revisedShow = (notification) => {
  const { color, message } = notification;
  const isMessageString = typeof message === "string";
  let childEl;
  if (isMessageString) {
    childEl = /* @__PURE__ */ jsx676(Body1, {
      color: "white",
      children: message
    });
  } else {
    childEl = notification.message;
  }
  return originalShow({
    withCloseButton: isMessageString,
    ...notification,
    message: childEl,
    __vars: {
      "--bkg-color": `var(--mantine-color-${color ?? "gray"}-9)`,
      "--hover-bkg-color": `var(--mantine-color-${color ?? "gray"}-7)`
    }
  });
};
var notifications = {
  ...notificationsBase,
  show: revisedShow
};

// src/components/notification/index.ts
import { useNotifications } from "@mantine/notifications";
// src/components/overlay/Overlay.tsx
import { Overlay as MantineOverlay2 } from "@mantine/core";

// src/components/overlay/overlay.module.css
injectStyle(".lLhaJq_root{background:var(--mantine-color-gray-7);opacity:.5}");
var overlay_module_default = { root: "lLhaJq_root" };

// src/components/overlay/Overlay.tsx
import { jsx as jsx677 } from "react/jsx-runtime";
var Overlay = ({
  fullScreen = true,
  loader = false,
  visible = false
}) => {
  if (!visible) {
    return null;
  }
  return /* @__PURE__ */ jsx677(MantineOverlay2, {
    classNames: overlay_module_default,
    center: true,
    fixed: fullScreen,
    children: loader ? /* @__PURE__ */ jsx677(Loader, {
      color: "white"
    }) : null
  });
};
// src/components/page-layout/PageLayout.tsx
import { jsx as jsx678, jsxs as jsxs32 } from "react/jsx-runtime";
var PageLayout = ({
  loadingOverlay,
  navBar,
  header,
  title,
  footer,
  children,
  maxWidth = "800px"
}) => {
  return /* @__PURE__ */ jsxs32(AppShell, {
    display: "flex",
    style: {
      flexDirection: "column",
      maxWidth
    },
    m: "0 auto",
    mih: "100svh",
    withBorder: false,
    children: [
      loadingOverlay ? /* @__PURE__ */ jsx678(Overlay, {
        visible: true,
        loader: true,
        fullScreen: true
      }) : null,
      /* @__PURE__ */ jsx678(AppShell.Navbar, {
        h: "auto",
        pos: "relative",
        children: navBar
      }),
      header ? /* @__PURE__ */ jsx678(AppShell.Header, {
        h: "auto",
        pos: "relative",
        w: "100%",
        children: header
      }) : undefined,
      /* @__PURE__ */ jsx678(AppShell.Main, {
        style: { flexGrow: 1 },
        mih: "auto",
        pt: "lg",
        px: "sm",
        children: /* @__PURE__ */ jsxs32(Stack, {
          gap: "sm",
          children: [
            /* @__PURE__ */ jsx678(Heading1, {
              children: title
            }),
            children
          ]
        })
      }),
      /* @__PURE__ */ jsx678(AppShell.Footer, {
        pos: "relative",
        p: "sm",
        children: footer
      })
    ]
  });
};
// src/components/phone-number/phone-number.formatter.ts
function getSafePhoneNumber(input) {
  return input.length === 10 ? `+1${input}` : input.length === 11 ? `+${input}` : input;
}
function sanitizePhoneNumber(input) {
  return input.replace(/\D/g, "");
}
function isValidPhoneNumber(input, sanitize = false) {
  const re = /^\+1[0-9]\d{9}$/;
  if (sanitize) {
    return re.test(getSafePhoneNumber(sanitizePhoneNumber(input)));
  }
  return re.test(input);
}
function formatPhoneNumber(input, sanitize = false) {
  const num = sanitize ? getSafePhoneNumber(sanitizePhoneNumber(input)) : getSafePhoneNumber(input);
  if (!isValidPhoneNumber(num)) {
    console.warn(`Invalid phone number format ${input}, must have +1 country code with 10-digit number`);
    return input;
  }
  return `(${num.slice(2, 5)}) ${num.slice(5, 8)}-${num.slice(8)}`;
}

// src/components/phone-number/PhoneNumber.tsx
import { jsx as jsx679, jsxs as jsxs33 } from "react/jsx-runtime";
var PhoneNumber = ({
  phone,
  showIcon = true,
  actionable = true
}) => {
  const iconColor = actionable ? "primary" : "secondary";
  if (!phone) {
    return null;
  }
  return /* @__PURE__ */ jsx679(Anchor, {
    href: actionable ? `tel:${phone}` : undefined,
    textDecoration: "none",
    children: /* @__PURE__ */ jsxs33(Flex, {
      align: "center",
      gap: "xxs",
      children: [
        showIcon && /* @__PURE__ */ jsx679(IconCall, {
          color: iconColor
        }),
        /* @__PURE__ */ jsx679(Body1, {
          children: formatPhoneNumber(phone)
        })
      ]
    })
  });
};
// src/components/progress-bar/ProgressBar.tsx
import { Progress } from "@mantine/core";
import { useMemo as useMemo8 } from "react";

// src/components/progress-bar/MinMaxLabels.tsx
import { jsx as jsx680, jsxs as jsxs34 } from "react/jsx-runtime";
var MinMaxLabels = ({
  min,
  value,
  max,
  maxFormatter,
  minFormatter,
  showComplete
}) => {
  const isComplete = value >= max;
  const useIcon = isComplete && showComplete;
  return /* @__PURE__ */ jsxs34(Flex, {
    justify: "space-between",
    children: [
      /* @__PURE__ */ jsx680(Label, {
        limit: min,
        value,
        formatter: minFormatter
      }, "min-label"),
      /* @__PURE__ */ jsx680(Label, {
        limit: max,
        value,
        formatter: maxFormatter,
        Icon: useIcon ? /* @__PURE__ */ jsx680(IconCheckCircle, {
          color: "success"
        }) : undefined
      }, "max-label")
    ]
  });
};
var Label = ({
  value,
  limit,
  formatter,
  Icon: Icon2
}) => {
  if (Icon2) {
    return Icon2;
  }
  const formatted = formatter?.(limit, value) ?? limit;
  return typeof formatted === "number" ? /* @__PURE__ */ jsx680(Subtitle2, {
    children: formatted
  }) : formatted;
};

// src/components/progress-bar/StartEndLabels.tsx
import { jsx as jsx681, jsxs as jsxs35 } from "react/jsx-runtime";
var StartEndLabels = ({
  startLabel,
  endLabel
}) => {
  if (!startLabel && !endLabel) {
    return null;
  }
  return /* @__PURE__ */ jsxs35(Flex, {
    justify: "space-between",
    align: "flex-start",
    children: [
      startLabel ? /* @__PURE__ */ jsx681(Body1, {
        children: startLabel
      }) : /* @__PURE__ */ jsx681("span", {}),
      endLabel ? /* @__PURE__ */ jsx681(Body1, {
        children: endLabel
      }) : /* @__PURE__ */ jsx681("span", {})
    ]
  });
};

// src/components/progress-bar/ProgressBar.tsx
import { jsx as jsx682, jsxs as jsxs36 } from "react/jsx-runtime";
var ProgressBar = ({
  startLabel,
  endLabel,
  min,
  value,
  max,
  showComplete = false,
  helperText,
  maxFormatter,
  minFormatter,
  color: colorOverride,
  backgroundColor: backgroundColorOverride
}) => {
  const isComplete = value >= max;
  const currentPct = Math.round((value - min) / (max - min) * 100);
  const color = useMemo8(() => {
    if (!showComplete) {
      return "info";
    }
    return isComplete ? "success" : "info";
  }, [isComplete, showComplete]);
  return /* @__PURE__ */ jsxs36(Stack, {
    align: "stretch",
    gap: 2,
    style: { flexGrow: 1 },
    children: [
      /* @__PURE__ */ jsx682(StartEndLabels, {
        startLabel,
        endLabel
      }),
      /* @__PURE__ */ jsx682(MinMaxLabels, {
        min,
        value,
        max,
        maxFormatter,
        minFormatter,
        showComplete
      }),
      /* @__PURE__ */ jsx682(Progress, {
        color: colorOverride ?? color,
        radius: "xl",
        size: "sm",
        value: currentPct,
        style: {
          backgroundColor: backgroundColorOverride ? "var(backgroundColorOverride)" : "var(--mantine-color-info-0)"
        },
        __vars: {
          "--progress-size": "var(--progress-size-md)"
        }
      }),
      /* @__PURE__ */ jsx682(Flex, {
        justify: "space-between",
        children: /* @__PURE__ */ jsx682(Caption, {
          children: helperText
        })
      })
    ]
  });
};
// src/components/quote/Quote.tsx
import {
  Notification as NotificationBase2
} from "@mantine/core";
import"@mantine/notifications/styles.css";
import { jsx as jsx683 } from "react/jsx-runtime";
var Quote = ({
  children,
  title,
  onClose,
  withCloseButton
}) => {
  let body = children;
  if (typeof children === "string") {
    body = /* @__PURE__ */ jsx683(Body1, {
      color: "gray",
      children
    });
  }
  return /* @__PURE__ */ jsx683(NotificationBase2, {
    styles: {
      title: { color: "var(--mantine-color-gray-7)" },
      description: { color: "var(--mantine-color-gray-7)" },
      closeButton: { color: "var(--mantine-color-gray-7)" },
      root: {
        boxShadow: "none",
        borderLeft: "4px solid var(--mantine-color-primary-1)",
        position: "relative",
        paddingLeft: "12px"
      }
    },
    onClose,
    withCloseButton,
    title,
    withBorder: true,
    children: body
  });
};
// src/components/radio/Radio.tsx
import {
  Radio as RadioBase
} from "@mantine/core";

// src/components/radio/radio.module.css
injectStyle(".BWTmjW_label{--label-offset-start:var(--mantine-spacing-xxs);color:var(--mantine-color-gray-7)}.BWTmjW_label:where([data-disabled]){color:var(--mantine-color-gray-5)}.BWTmjW_radio{border-color:var(--mantine-color-gray-7);border-width:calc(.125rem*var(--mantine-scale))}:where([data-mantine-color-scheme=light]) .BWTmjW_radio:disabled{background-color:var(--mantine-color-white)}.BWTmjW_inner{margin-top:2px}");
var radio_module_default = { radio: "BWTmjW_radio", inner: "BWTmjW_inner", label: "BWTmjW_label" };

// src/components/radio/Radio.tsx
import { jsx as jsx684 } from "react/jsx-runtime";
var Radio = ({
  label,
  disabled,
  checked,
  size,
  value,
  error,
  onBlur,
  onChange,
  onFocus
}) => {
  return /* @__PURE__ */ jsx684(RadioBase, {
    label: typeof label === "string" ? /* @__PURE__ */ jsx684(Body1, {
      inline: true,
      children: label
    }) : label,
    disabled,
    classNames: radio_module_default,
    variant: "outline",
    checked,
    size,
    value,
    error,
    onBlur,
    onChange,
    onFocus
  });
};

// src/components/radio/RadioGroup.tsx
import {
  RadioGroup as RadioGroupBase
} from "@mantine/core";

// src/components/radio/radiogroup.module.css
injectStyle(".Sp0Wnq_root{gap:var(--mantine-spacing-sm);flex-direction:column;display:flex}");
var radiogroup_module_default = { root: "Sp0Wnq_root" };

// src/components/radio/RadioGroup.tsx
import { jsx as jsx685 } from "react/jsx-runtime";
var RadioGroup = ({
  children,
  required,
  label,
  value,
  error,
  onBlur,
  onChange,
  onFocus
}) => {
  return /* @__PURE__ */ jsx685(RadioGroupBase, {
    classNames: radiogroup_module_default,
    label,
    withAsterisk: required,
    value,
    onChange,
    error,
    onBlur,
    onFocus,
    children
  });
};
// src/components/select/MultiSelect.tsx
import {
  MultiSelect as MultiSelectBase
} from "@mantine/core";

// src/components/select/select.module.css
injectStyle(".rPIWPG_wrapper[data-error] :focus,.rPIWPG_wrapper[data-error] :focus-within,[data-mantine-color-scheme] .rPIWPG_wrapper[data-error]:not([data-variant=unstyled]){--input-bd:var(--mantine-color-error-7);--input-color:var(--mantine-color-error-7);--input-placeholder-color:var(--mantine-color-error-7);--input-section-color:var(--mantine-color-error-7)}.rPIWPG_wrapper svg:where([data-error]){color:var(--mantine-color-error-7)}.rPIWPG_error{color:var(--mantine-color-error-7)}.rPIWPG_dropdown,.rPIWPG_option{border-radius:var(--mantine-radius-xxs)}.rPIWPG_dropdown{box-shadow:var(--mantine-shadow-sm);border-width:0}.rPIWPG_root{position:relative}.rPIWPG_label{z-index:1;top:17px;left:var(--mantine-spacing-sm);color:var(--lightningcss-light,var(--mantine-color-gray-5))var(--lightningcss-dark,var(--mantine-color-dark-3));font-weight:100;transition:transform .15s,font-size .15s,color .15s,top .15s,left .15s;position:absolute}.rPIWPG_root:not(:focus-within) .rPIWPG_label:not([data-floating=true]):has(+[data-with-left-section=true]){left:calc(3.75rem - calc(.125rem*var(--mantine-scale)))}.rPIWPG_label[data-floating=true],.rPIWPG_root:focus-within .rPIWPG_label{background-color:var(--mantine-color-white);transform:translate(calc(var(--mantine-spacing-sm)*-1),rem(-28px));font-size:var(--mantine-font-size-xs);color:var(--mantine-color-primary-7);padding:3px;font-weight:500;top:-14px}:is(.rPIWPG_label[data-floating=true],.rPIWPG_root:focus-within .rPIWPG_label):has(+[data-disabled=true]){color:var(--mantine-color-gray-5)}:is(.rPIWPG_label[data-floating=true],.rPIWPG_root:focus-within .rPIWPG_label) .rPIWPG_required{opacity:1}.rPIWPG_root[data-error=true] .rPIWPG_label{color:var(--mantine-color-error-7)}.rPIWPG_input{--input-disabled-bg:transparent}.rPIWPG_input::placeholder{transition:color .15s}.rPIWPG_input:focus-within{border-width:2px;padding-inline-start:calc(var(--input-padding-inline-start) - 1px);padding-inline-end:calc(var(--input-padding-inline-end) - 1px)}.rPIWPG_input:focus-within::placeholder{color:var(--mantine-color-placeholder)}");
var select_module_default = { root: "rPIWPG_root", required: "rPIWPG_required", option: "rPIWPG_option", input: "rPIWPG_input", error: "rPIWPG_error", label: "rPIWPG_label", wrapper: "rPIWPG_wrapper", dropdown: "rPIWPG_dropdown" };

// src/components/select/MultiSelect.tsx
import { jsx as jsx686 } from "react/jsx-runtime";
var MultiSelect = ({
  data,
  placeholder,
  label,
  error,
  clearable,
  disabled,
  onBlur,
  onChange,
  onFocus,
  value
}) => {
  const hasValue = value && value.length > 0;
  return /* @__PURE__ */ jsx686(MultiSelectBase, {
    data,
    placeholder: !hasValue ? placeholder : undefined,
    label,
    error,
    clearable,
    comboboxProps: {
      transitionProps: { transition: "pop", duration: 200 }
    },
    withCheckIcon: false,
    onChange,
    disabled,
    radius: "xxs",
    classNames: select_module_default,
    onBlur,
    onFocus,
    value,
    size: "xl",
    labelProps: {
      "data-floating": hasValue
    }
  });
};

// src/components/select/Select.tsx
import {
  Select as SelectBase
} from "@mantine/core";
import { jsx as jsx687 } from "react/jsx-runtime";
var Select = ({
  data,
  placeholder,
  label,
  error,
  clearable,
  disabled,
  onBlur,
  onChange,
  onFocus,
  value,
  renderOption
}) => {
  const hasValue = value && value?.toString().trim().length !== 0;
  return /* @__PURE__ */ jsx687(SelectBase, {
    data,
    placeholder,
    label,
    error,
    clearable,
    comboboxProps: {
      transitionProps: { transition: "pop", duration: 200 }
    },
    withCheckIcon: false,
    onChange,
    disabled,
    radius: "xxs",
    classNames: select_module_default,
    onBlur,
    onFocus,
    value,
    size: "xl",
    labelProps: {
      "data-floating": hasValue
    },
    renderOption
  });
};
// src/components/slider/DiscreteRangeSlider.tsx
import { RangeSlider as MantineRangeSlider } from "@mantine/core";
import { useMemo as useMemo9 } from "react";

// src/components/slider/slider.module.css
injectStyle("[data-mantine-color-scheme=light] .fw5o_q_root{--slider-track-bg:var(--mantine-color-primary-0);--slider-track-disabled-bg:var(--mantine-color-gray-2)}.fw5o_q_track{--track-bg:var(--slider-track-bg)}.fw5o_q_track:where([data-disabled]){--track-bg:var(--slider-track-disabled-bg)}.fw5o_q_thumb{background-color:var(--mantine-color-primary-7);width:24px;height:24px}.fw5o_q_mark:not([data-filled]){border-color:var(--mantine-color-primary-7);background-color:var(--mantine-color-primary-7)}.fw5o_q_mark:not([data-filled]):where([data-disabled]){border-color:var(--mantine-color-gray-4);background-color:var(--mantine-color-gray-4)}.fw5o_q_mark{border-color:var(--mantine-color-primary-0);background-color:var(--mantine-color-primary-0)}");
var slider_module_default = { thumb: "fw5o_q_thumb", track: "fw5o_q_track", root: "fw5o_q_root", mark: "fw5o_q_mark" };

// src/components/slider/slider.utils.ts
var getMinMaxLabel = (label, val) => {
  if (label === true) {
    return { value: val, label: val };
  }
  return { value: val, label };
};
var buildContinuousSliderMarkArray = (marks, max, maxLabel, min, minLabel) => {
  const markArr = marks.map((mark) => ({ value: mark }));
  if (maxLabel) {
    markArr.unshift(getMinMaxLabel(maxLabel, max));
  }
  if (minLabel) {
    markArr.unshift(getMinMaxLabel(minLabel, min));
  }
  return markArr;
};
var buildDiscreteSliderMarkArray = (max, maxLabel, min, minLabel, step) => {
  const stepArr = [];
  for (let mark = step;mark <= max; mark += step) {
    stepArr.push(mark);
  }
  const markArr = stepArr.map((step2) => ({ value: step2 }));
  if (maxLabel) {
    markArr.unshift(getMinMaxLabel(maxLabel, max));
  }
  if (minLabel) {
    markArr.unshift(getMinMaxLabel(minLabel, min));
  }
  return markArr;
};

// src/components/slider/DiscreteRangeSlider.tsx
import { jsx as jsx688 } from "react/jsx-runtime";
var DiscreteRangeSlider = (props) => {
  const {
    disabled = false,
    label,
    max = 100,
    maxLabel = false,
    min = 0,
    minLabel = false,
    onChange,
    showMarks = true,
    step,
    value
  } = props;
  const marks = useMemo9(() => {
    if (showMarks) {
      return buildDiscreteSliderMarkArray(max, maxLabel, min, minLabel, step);
    }
    return [];
  }, [max, maxLabel, min, minLabel, showMarks, step]);
  return /* @__PURE__ */ jsx688(MantineRangeSlider, {
    color: "primary",
    classNames: slider_module_default,
    disabled,
    label,
    marks,
    max,
    min,
    onChange,
    step,
    value
  });
};

// src/components/slider/DiscreteSlider.tsx
import { Slider as MantineSlider } from "@mantine/core";
import { useMemo as useMemo10 } from "react";
import { jsx as jsx689 } from "react/jsx-runtime";
var DiscreteSlider = (props) => {
  const {
    disabled = false,
    label,
    max = 100,
    maxLabel = false,
    min = 1,
    minLabel = false,
    onChange,
    showMarks = true,
    step,
    value
  } = props;
  const marks = useMemo10(() => {
    if (showMarks) {
      return buildDiscreteSliderMarkArray(max, maxLabel, min, minLabel, step);
    }
    return [];
  }, [max, maxLabel, min, minLabel, showMarks, step]);
  return /* @__PURE__ */ jsx689(MantineSlider, {
    classNames: slider_module_default,
    color: "primary",
    disabled,
    label,
    marks,
    max,
    min,
    onChange,
    step,
    value
  });
};

// src/components/slider/RangeSlider.tsx
import { RangeSlider as MantineRangeSlider2 } from "@mantine/core";
import { useMemo as useMemo11 } from "react";
import { jsx as jsx690 } from "react/jsx-runtime";
var RangeSlider = (props) => {
  const {
    disabled = false,
    label,
    marks = [],
    max = 100,
    maxLabel = false,
    min = 1,
    minLabel = false,
    onChange,
    value
  } = props;
  const actualMarks = useMemo11(() => buildContinuousSliderMarkArray(marks, max, maxLabel, min, minLabel), [marks, max, maxLabel, min, minLabel]);
  return /* @__PURE__ */ jsx690(MantineRangeSlider2, {
    classNames: slider_module_default,
    color: "primary",
    disabled,
    label,
    marks: actualMarks,
    max,
    min,
    onChange,
    value
  });
};

// src/components/slider/Slider.tsx
import { Slider as MantineSlider2 } from "@mantine/core";
import { useMemo as useMemo12 } from "react";
import { jsx as jsx691 } from "react/jsx-runtime";
var Slider = (props) => {
  const {
    disabled = false,
    label,
    marks = [],
    max = 100,
    maxLabel = false,
    min = 0,
    minLabel = false,
    onChange,
    value
  } = props;
  const actualMarks = useMemo12(() => buildContinuousSliderMarkArray(marks, max, maxLabel, min, minLabel), [marks, max, maxLabel, min, minLabel]);
  return /* @__PURE__ */ jsx691(MantineSlider2, {
    color: "primary",
    disabled,
    classNames: slider_module_default,
    label,
    marks: actualMarks,
    max,
    min,
    onChange,
    value
  });
};
// src/components/tabs/Tabs.tsx
import { Tabs as MantineTabs } from "@mantine/core";

// src/components/tabs/tabs.module.css
injectStyle(".YrTyua_tabSection{margin-right:0}.YrTyua_tab{padding:var(--mantine-spacing-xxs)var(--mantine-spacing-xs);gap:var(--mantine-spacing-xxs)}.YrTyua_tab:hover{background-color:#0000}.YrTyua_tabLabel{color:var(--mantine-color-gray-7);font-family:Inter;font-size:16px;font-weight:400}[data-active=true] .YrTyua_tabLabel,[data-active=true] .YrTyua_tabSection{color:var(--mantine-color-primary-7);font-weight:600}.YrTyua_list{background-color:var(--mantine-color-body)}[data-full-bleed-tabbar=true] .YrTyua_list:before{background-color:var(--mantine-color-body);pointer-events:none;width:100svw;margin-left:-50svw;margin-right:-50svw;inset:0 50%}[data-sticky-tabbar=true] .YrTyua_list{z-index:1;position:sticky;top:0}");
var tabs_module_default = { tabLabel: "YrTyua_tabLabel", tabSection: "YrTyua_tabSection", list: "YrTyua_list", tab: "YrTyua_tab" };

// src/components/tabs/Tabs.tsx
import { jsx as jsx692, jsxs as jsxs37 } from "react/jsx-runtime";
var Tabs = ({
  tabs,
  grow = false,
  defaultValue,
  onChange,
  value,
  keepMounted = true,
  tabBarProps
}) => {
  const fullBleedTabBar = !!tabBarProps?.fullBleed;
  const stickyTabBar = !!tabBarProps?.sticky;
  const tabItems = tabs?.map((item) => /* @__PURE__ */ jsx692(MantineTabs.Tab, {
    value: item.value,
    disabled: item.disabled,
    leftSection: item.LeftIcon && /* @__PURE__ */ jsx692(item.LeftIcon, {}),
    children: item.label
  }, item.value));
  const panelItems = tabs?.map((item, idx) => /* @__PURE__ */ jsx692(MantineTabs.Panel, {
    value: item.value,
    children: item.panel
  }, `${item.value}-${idx}`));
  return /* @__PURE__ */ jsxs37(MantineTabs, {
    classNames: tabs_module_default,
    defaultValue,
    keepMounted,
    onChange,
    value,
    "data-full-bleed-tabbar": fullBleedTabBar,
    "data-sticky-tabbar": stickyTabBar,
    children: [
      /* @__PURE__ */ jsx692(MantineTabs.List, {
        grow,
        children: tabItems
      }),
      panelItems
    ]
  });
};
// src/components/timeline/Timeline.tsx
import { Timeline as BaseTimeline, Flex as Flex6 } from "@mantine/core";

// src/components/timeline/timeline.module.css
injectStyle("._3AElIW_item{color:var(--mantine-color-gray-7);margin-top:var(--mantine-spacing-xxs)}._3AElIW_item:first-child{margin-top:0}._3AElIW_item:before{top:6px;bottom:calc(var(--mantine-spacing-xl)*-.5);transition:border-color .4s;transition-timing-function:cubic-bezier();border-color:var(--timeline-color)}._3AElIW_itemBullet{transition-property:background-color border-color;transition-timing-function:cubic-bezier();border-color:var(--timeline-color);transition-duration:.5s;transition-delay:.3s;top:6px}._3AElIW_itemBullet:where([data-active]){background-color:var(--timeline-color);top:6px}._3AElIW_itemTitle{color:var(--mantine-color-gray-9);margin-bottom:var(--mantine-spacing-xxxs)}");
var timeline_module_default = { item: "_3AElIW_item", itemBullet: "_3AElIW_itemBullet", itemTitle: "_3AElIW_itemTitle" };

// src/components/timeline/Timeline.tsx
import { jsx as jsx693, jsxs as jsxs38 } from "react/jsx-runtime";
var Timeline = ({
  activeStep,
  steps,
  color = "secondary"
}) => {
  const items = steps.map((step, ix) => /* @__PURE__ */ jsx693(BaseTimeline.Item, {
    title: /* @__PURE__ */ jsxs38(Flex6, {
      justify: "space-between",
      children: [
        /* @__PURE__ */ jsx693(Subtitle2, {
          children: step.title
        }),
        step.description ? /* @__PURE__ */ jsx693(Body1, {
          children: step.description
        }) : null
      ]
    }),
    children: step.subtitle
  }, `item-${ix}`));
  return /* @__PURE__ */ jsx693(BaseTimeline, {
    active: activeStep,
    bulletSize: 12,
    lineWidth: 2,
    classNames: timeline_module_default,
    style: { "--timeline-color": `var(--mantine-color-${color}-7)` },
    children: items
  });
};
// src/components/toggle-button/ToggleButton.tsx
import { ActionIcon as ActionIcon2 } from "@mantine/core";
import { useCallback as useCallback15, useMemo as useMemo13 } from "react";

// src/components/toggle-button/toggle-button.module.css
injectStyle(".m6dJSq_root{cursor:var(--toggle-button-cursor,pointer)}:where([data-mantine-color-scheme=light]) .m6dJSq_root:where(:disabled:not([data-loading]),[data-disabled]:not([data-loading])){background-color:var(--ai-bg)}");
var toggle_button_module_default = { root: "m6dJSq_root" };

// src/components/toggle-button/ToggleButton.tsx
import { jsx as jsx694 } from "react/jsx-runtime";
var ToggleButton = ({
  Icon: Icon2,
  CheckedIcon,
  checked,
  color = "primary",
  disabled = false,
  toggle,
  iconProps = {}
}) => {
  const hasAction = !!toggle;
  const DisplayIcon = useMemo13(() => {
    if (checked) {
      return CheckedIcon;
    }
    return Icon2;
  }, [checked, CheckedIcon, Icon2]);
  const bgColor = disabled ? "var(--mantine-color-gray-0)" : `var(--mantine-color-${color}-0)`;
  const iconColor = `var(--mantine-color-${color}-7)`;
  const handleClick = useCallback15((event) => {
    event.preventDefault();
    event.stopPropagation();
    toggle?.();
  }, [toggle]);
  return /* @__PURE__ */ jsx694(ActionIcon2, {
    type: "button",
    variant: "subtle",
    disabled,
    radius: "50%",
    size: rem(40),
    onClick: handleClick,
    __vars: {
      "--ai-bg": bgColor,
      "--ai-color": iconColor,
      "--ai-hover": hasAction ? `var(--mantine-color-${color}-0)` : bgColor,
      "--ai-hover-color": hasAction ? `var(--mantine-color-${color}-9)` : iconColor,
      "--toggle-button-cursor": hasAction ? "pointer" : "default"
    },
    classNames: toggle_button_module_default,
    children: /* @__PURE__ */ jsx694(DisplayIcon, {
      ...iconProps,
      color
    })
  });
};
// src/components/website/Website.tsx
import { jsx as jsx695, jsxs as jsxs39 } from "react/jsx-runtime";
var Website = ({
  iconColor = "primary",
  showIcon = true,
  url
}) => {
  return /* @__PURE__ */ jsxs39(Flex, {
    align: "center",
    gap: "xxs",
    children: [
      showIcon && /* @__PURE__ */ jsx695(IconLink, {
        color: iconColor
      }),
      /* @__PURE__ */ jsx695(Anchor, {
        href: url,
        target: "_blank",
        children: url
      })
    ]
  });
};
export {
  useNotifications,
  useNavBar,
  useModalsStack,
  useDrawersStack,
  useDisableBackButton,
  useConditionalBackOverride,
  sanitizePhoneNumber,
  notifications,
  modals,
  isValidPhoneNumber,
  getSafePhoneNumber,
  formatPhoneNumber,
  days,
  YearPickerInput,
  Website,
  VerticalDivider,
  Transition,
  Tooltip,
  ToggleButton,
  Title1,
  Timeline,
  TextSkeleton,
  TextInput,
  TextButton,
  TextArea,
  Text2 as Text,
  Tabs,
  Table,
  Switch,
  SurfaceBadge,
  Subtitle3,
  Subtitle2,
  Subtitle1,
  Stack,
  Spoiler,
  Space,
  Slider,
  SidebarHeading,
  SideNavLink,
  SelectionCard,
  Select,
  SearchInput,
  ScrollArea,
  RoundedSkeleton,
  RangeSlider,
  RadioGroup,
  Radio,
  Quote,
  ProgressBar,
  Popover,
  PhoneNumberInput,
  PhoneNumber,
  PasswordInput,
  PageLayout,
  PDF_MIME_TYPE,
  Overlay,
  OutlinedCard,
  Notification,
  NavLink,
  NavBarProvider,
  NavBarContext,
  NavBar,
  MultiSelect,
  ModalStack,
  Modal,
  AppShell as MantineAppShell,
  LoadingPlaceholder,
  Loader,
  ListItem,
  List,
  Indicator,
  Image,
  IconWarning,
  IconVisibilityOff,
  IconVisibility,
  IconUpload,
  IconUpdate,
  IconUnfoldMore,
  IconUnarchive,
  IconTune,
  IconTranslate,
  IconSupportAgent,
  IconStethoscope,
  IconSms,
  IconShoppingBag,
  IconSettings,
  IconSend,
  IconSearch,
  IconSchedule,
  IconSavings,
  IconRoute,
  IconReply,
  IconPrivacyTip,
  IconPrescription,
  IconPerson,
  IconPermContactCalendar,
  IconPayments,
  IconPaid,
  IconPDF,
  IconOpenInNew,
  IconNumbers,
  IconNoteAlt,
  IconNestClockFarsightAnalog,
  IconMyLocation,
  IconMoreVert,
  IconMoreHoriz,
  IconMenuOpen,
  IconMenu,
  IconMedication,
  IconMailOrder,
  IconLogout,
  IconLogoDev,
  IconLock,
  IconLocationOn,
  IconLocalShipping,
  IconLocalPharmacy,
  IconLink,
  IconKeyboardArrowDown,
  IconKeep,
  IconIosShare,
  IconInfo,
  IconImage,
  IconHome,
  IconHelpCenter,
  IconHealthAndSafety,
  IconHeadphones,
  IconGroup,
  IconGenericPharmacy,
  IconGenericHome,
  IconForwardToInbox,
  IconFlag,
  IconFilterList,
  IconFilter,
  IconFileOpen,
  IconFavorite,
  IconEventBusy,
  IconEvent,
  IconError,
  IconEdit,
  IconDownload,
  IconDescription,
  IconDeliverBox,
  IconDelete,
  IconControlledSubstance,
  IconClose,
  IconChevronRight,
  IconChevronLeft,
  IconCheckCircle,
  IconCheck,
  IconCancel,
  IconCall,
  IconCalendarToday,
  IconCached,
  IconButton,
  IconBox,
  IconBolt,
  IconBadge,
  IconAssignment,
  IconArchive,
  IconApprovalDelegation,
  IconAdminMeds,
  IconAdd,
  HoursOfOperation,
  HoursByDay,
  HorizontalDivider,
  HighlightedCard,
  Highlight,
  Heading6,
  Heading5,
  Heading4,
  Heading3,
  Heading2,
  Heading1,
  Group,
  GridCol,
  Grid,
  FullBleed,
  FormFieldError,
  Flex,
  FilterSelection,
  FilledCard,
  ElevatedCard,
  Dropzone3 as Dropzone,
  DrawerStack,
  Drawer,
  DotIndicator,
  DividedText,
  Distance,
  DiscreteSlider,
  DiscreteRangeSlider,
  DesktopShell,
  Delivery,
  DefinitionList,
  DatePickerInput,
  Currency,
  Cover,
  ContainerItem,
  Container,
  CollapsibleCard,
  Collapse,
  CloseButton,
  CircularSkeleton,
  Chip,
  Checkbox,
  Center,
  Carousel,
  Caption,
  ButtonLabel,
  Button,
  Breadcrumbs,
  Box3 as Box,
  Body2,
  Body1,
  Blockquote,
  BaseCard,
  BareCard,
  BadgeList,
  Badge,
  AvatarGroup,
  Avatar,
  Autocomplete,
  AppShell2 as AppShell,
  Anchor,
  Alert,
  Affix,
  Address,
  Accordion
};

//# debugId=16718933144E443464756E2164756E21
